var j_ = Object.defineProperty;
var V_ = (e, t, n) => t in e ? j_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ie = (e, t, n) => V_(e, typeof t != "symbol" ? t + "" : t, n);
import * as q_ from "react";
import xn, { createElement as Z_, createContext as Ec, useRef as dd, useState as Nr, useEffect as tr, Suspense as J_, lazy as X_, useContext as co, forwardRef as Q_, Fragment as ey, useMemo as ip } from "react";
import sp, { createPortal as ty } from "react-dom";
var uf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function op(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zu = { exports: {} }, Gl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var df;
function ny() {
  if (df) return Gl;
  df = 1;
  var e = xn, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, l = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(p, _, E) {
    var T, S = {}, w = null, O = null;
    E !== void 0 && (w = "" + E), _.key !== void 0 && (w = "" + _.key), _.ref !== void 0 && (O = _.ref);
    for (T in _) r.call(_, T) && !d.hasOwnProperty(T) && (S[T] = _[T]);
    if (p && p.defaultProps) for (T in _ = p.defaultProps, _) S[T] === void 0 && (S[T] = _[T]);
    return { $$typeof: t, type: p, key: w, ref: O, props: S, _owner: l.current };
  }
  return Gl.Fragment = n, Gl.jsx = f, Gl.jsxs = f, Gl;
}
var Yl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ff;
function ry() {
  return ff || (ff = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xn, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), p = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), T = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function I(pe) {
      if (pe === null || typeof pe != "object")
        return null;
      var Ze = m && pe[m] || pe[v];
      return typeof Ze == "function" ? Ze : null;
    }
    var G = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(pe) {
      {
        for (var Ze = arguments.length, ot = new Array(Ze > 1 ? Ze - 1 : 0), St = 1; St < Ze; St++)
          ot[St - 1] = arguments[St];
        P("error", pe, ot);
      }
    }
    function P(pe, Ze, ot) {
      {
        var St = G.ReactDebugCurrentFrame, Ut = St.getStackAddendum();
        Ut !== "" && (Ze += "%s", ot = ot.concat([Ut]));
        var Ft = ot.map(function(kt) {
          return String(kt);
        });
        Ft.unshift("Warning: " + Ze), Function.prototype.apply.call(console[pe], console, Ft);
      }
    }
    var H = !1, j = !1, re = !1, te = !1, ce = !1, V;
    V = Symbol.for("react.module.reference");
    function z(pe) {
      return !!(typeof pe == "string" || typeof pe == "function" || pe === r || pe === d || ce || pe === l || pe === E || pe === T || te || pe === O || H || j || re || typeof pe == "object" && pe !== null && (pe.$$typeof === w || pe.$$typeof === S || pe.$$typeof === f || pe.$$typeof === p || pe.$$typeof === _ || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      pe.$$typeof === V || pe.getModuleId !== void 0));
    }
    function q(pe, Ze, ot) {
      var St = pe.displayName;
      if (St)
        return St;
      var Ut = Ze.displayName || Ze.name || "";
      return Ut !== "" ? ot + "(" + Ut + ")" : ot;
    }
    function Te(pe) {
      return pe.displayName || "Context";
    }
    function Se(pe) {
      if (pe == null)
        return null;
      if (typeof pe.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof pe == "function")
        return pe.displayName || pe.name || null;
      if (typeof pe == "string")
        return pe;
      switch (pe) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case d:
          return "Profiler";
        case l:
          return "StrictMode";
        case E:
          return "Suspense";
        case T:
          return "SuspenseList";
      }
      if (typeof pe == "object")
        switch (pe.$$typeof) {
          case p:
            var Ze = pe;
            return Te(Ze) + ".Consumer";
          case f:
            var ot = pe;
            return Te(ot._context) + ".Provider";
          case _:
            return q(pe, pe.render, "ForwardRef");
          case S:
            var St = pe.displayName || null;
            return St !== null ? St : Se(pe.type) || "Memo";
          case w: {
            var Ut = pe, Ft = Ut._payload, kt = Ut._init;
            try {
              return Se(kt(Ft));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ee = Object.assign, de = 0, K, D, Z, oe, Y, W, J;
    function R() {
    }
    R.__reactDisabledLog = !0;
    function U() {
      {
        if (de === 0) {
          K = console.log, D = console.info, Z = console.warn, oe = console.error, Y = console.group, W = console.groupCollapsed, J = console.groupEnd;
          var pe = {
            configurable: !0,
            enumerable: !0,
            value: R,
            writable: !0
          };
          Object.defineProperties(console, {
            info: pe,
            log: pe,
            warn: pe,
            error: pe,
            group: pe,
            groupCollapsed: pe,
            groupEnd: pe
          });
        }
        de++;
      }
    }
    function X() {
      {
        if (de--, de === 0) {
          var pe = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ee({}, pe, {
              value: K
            }),
            info: Ee({}, pe, {
              value: D
            }),
            warn: Ee({}, pe, {
              value: Z
            }),
            error: Ee({}, pe, {
              value: oe
            }),
            group: Ee({}, pe, {
              value: Y
            }),
            groupCollapsed: Ee({}, pe, {
              value: W
            }),
            groupEnd: Ee({}, pe, {
              value: J
            })
          });
        }
        de < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var fe = G.ReactCurrentDispatcher, _e;
    function B(pe, Ze, ot) {
      {
        if (_e === void 0)
          try {
            throw Error();
          } catch (Ut) {
            var St = Ut.stack.trim().match(/\n( *(at )?)/);
            _e = St && St[1] || "";
          }
        return `
` + _e + pe;
      }
    }
    var M = !1, F;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      F = new se();
    }
    function ye(pe, Ze) {
      if (!pe || M)
        return "";
      {
        var ot = F.get(pe);
        if (ot !== void 0)
          return ot;
      }
      var St;
      M = !0;
      var Ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ft;
      Ft = fe.current, fe.current = null, U();
      try {
        if (Ze) {
          var kt = function() {
            throw Error();
          };
          if (Object.defineProperty(kt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(kt, []);
            } catch (un) {
              St = un;
            }
            Reflect.construct(pe, [], kt);
          } else {
            try {
              kt.call();
            } catch (un) {
              St = un;
            }
            pe.call(kt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (un) {
            St = un;
          }
          pe();
        }
      } catch (un) {
        if (un && St && typeof un.stack == "string") {
          for (var It = un.stack.split(`
`), Bt = St.stack.split(`
`), sn = It.length - 1, ln = Bt.length - 1; sn >= 1 && ln >= 0 && It[sn] !== Bt[ln]; )
            ln--;
          for (; sn >= 1 && ln >= 0; sn--, ln--)
            if (It[sn] !== Bt[ln]) {
              if (sn !== 1 || ln !== 1)
                do
                  if (sn--, ln--, ln < 0 || It[sn] !== Bt[ln]) {
                    var bn = `
` + It[sn].replace(" at new ", " at ");
                    return pe.displayName && bn.includes("<anonymous>") && (bn = bn.replace("<anonymous>", pe.displayName)), typeof pe == "function" && F.set(pe, bn), bn;
                  }
                while (sn >= 1 && ln >= 0);
              break;
            }
        }
      } finally {
        M = !1, fe.current = Ft, X(), Error.prepareStackTrace = Ut;
      }
      var Cr = pe ? pe.displayName || pe.name : "", Zn = Cr ? B(Cr) : "";
      return typeof pe == "function" && F.set(pe, Zn), Zn;
    }
    function De(pe, Ze, ot) {
      return ye(pe, !1);
    }
    function ee(pe) {
      var Ze = pe.prototype;
      return !!(Ze && Ze.isReactComponent);
    }
    function ne(pe, Ze, ot) {
      if (pe == null)
        return "";
      if (typeof pe == "function")
        return ye(pe, ee(pe));
      if (typeof pe == "string")
        return B(pe);
      switch (pe) {
        case E:
          return B("Suspense");
        case T:
          return B("SuspenseList");
      }
      if (typeof pe == "object")
        switch (pe.$$typeof) {
          case _:
            return De(pe.render);
          case S:
            return ne(pe.type, Ze, ot);
          case w: {
            var St = pe, Ut = St._payload, Ft = St._init;
            try {
              return ne(Ft(Ut), Ze, ot);
            } catch {
            }
          }
        }
      return "";
    }
    var ue = Object.prototype.hasOwnProperty, be = {}, Ne = G.ReactDebugCurrentFrame;
    function Re(pe) {
      if (pe) {
        var Ze = pe._owner, ot = ne(pe.type, pe._source, Ze ? Ze.type : null);
        Ne.setExtraStackFrame(ot);
      } else
        Ne.setExtraStackFrame(null);
    }
    function ke(pe, Ze, ot, St, Ut) {
      {
        var Ft = Function.call.bind(ue);
        for (var kt in pe)
          if (Ft(pe, kt)) {
            var It = void 0;
            try {
              if (typeof pe[kt] != "function") {
                var Bt = Error((St || "React class") + ": " + ot + " type `" + kt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof pe[kt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Bt.name = "Invariant Violation", Bt;
              }
              It = pe[kt](Ze, kt, St, ot, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (sn) {
              It = sn;
            }
            It && !(It instanceof Error) && (Re(Ut), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", St || "React class", ot, kt, typeof It), Re(null)), It instanceof Error && !(It.message in be) && (be[It.message] = !0, Re(Ut), k("Failed %s type: %s", ot, It.message), Re(null));
          }
      }
    }
    var Fe = Array.isArray;
    function qe(pe) {
      return Fe(pe);
    }
    function Be(pe) {
      {
        var Ze = typeof Symbol == "function" && Symbol.toStringTag, ot = Ze && pe[Symbol.toStringTag] || pe.constructor.name || "Object";
        return ot;
      }
    }
    function ct(pe) {
      try {
        return Dt(pe), !1;
      } catch {
        return !0;
      }
    }
    function Dt(pe) {
      return "" + pe;
    }
    function zt(pe) {
      if (ct(pe))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Be(pe)), Dt(pe);
    }
    var en = G.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ie, le;
    function ve(pe) {
      if (ue.call(pe, "ref")) {
        var Ze = Object.getOwnPropertyDescriptor(pe, "ref").get;
        if (Ze && Ze.isReactWarning)
          return !1;
      }
      return pe.ref !== void 0;
    }
    function Le(pe) {
      if (ue.call(pe, "key")) {
        var Ze = Object.getOwnPropertyDescriptor(pe, "key").get;
        if (Ze && Ze.isReactWarning)
          return !1;
      }
      return pe.key !== void 0;
    }
    function Me(pe, Ze) {
      typeof pe.ref == "string" && en.current;
    }
    function je(pe, Ze) {
      {
        var ot = function() {
          ie || (ie = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ze));
        };
        ot.isReactWarning = !0, Object.defineProperty(pe, "key", {
          get: ot,
          configurable: !0
        });
      }
    }
    function rt(pe, Ze) {
      {
        var ot = function() {
          le || (le = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ze));
        };
        ot.isReactWarning = !0, Object.defineProperty(pe, "ref", {
          get: ot,
          configurable: !0
        });
      }
    }
    var it = function(pe, Ze, ot, St, Ut, Ft, kt) {
      var It = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: pe,
        key: Ze,
        ref: ot,
        props: kt,
        // Record the component responsible for creating this element.
        _owner: Ft
      };
      return It._store = {}, Object.defineProperty(It._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(It, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: St
      }), Object.defineProperty(It, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ut
      }), Object.freeze && (Object.freeze(It.props), Object.freeze(It)), It;
    };
    function st(pe, Ze, ot, St, Ut) {
      {
        var Ft, kt = {}, It = null, Bt = null;
        ot !== void 0 && (zt(ot), It = "" + ot), Le(Ze) && (zt(Ze.key), It = "" + Ze.key), ve(Ze) && (Bt = Ze.ref, Me(Ze, Ut));
        for (Ft in Ze)
          ue.call(Ze, Ft) && !Oe.hasOwnProperty(Ft) && (kt[Ft] = Ze[Ft]);
        if (pe && pe.defaultProps) {
          var sn = pe.defaultProps;
          for (Ft in sn)
            kt[Ft] === void 0 && (kt[Ft] = sn[Ft]);
        }
        if (It || Bt) {
          var ln = typeof pe == "function" ? pe.displayName || pe.name || "Unknown" : pe;
          It && je(kt, ln), Bt && rt(kt, ln);
        }
        return it(pe, It, Bt, Ut, St, en.current, kt);
      }
    }
    var vt = G.ReactCurrentOwner, Ge = G.ReactDebugCurrentFrame;
    function ze(pe) {
      if (pe) {
        var Ze = pe._owner, ot = ne(pe.type, pe._source, Ze ? Ze.type : null);
        Ge.setExtraStackFrame(ot);
      } else
        Ge.setExtraStackFrame(null);
    }
    var tt;
    tt = !1;
    function _t(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === t;
    }
    function yt() {
      {
        if (vt.current) {
          var pe = Se(vt.current.type);
          if (pe)
            return `

Check the render method of \`` + pe + "`.";
        }
        return "";
      }
    }
    function Ct(pe) {
      return "";
    }
    var ht = {};
    function Tt(pe) {
      {
        var Ze = yt();
        if (!Ze) {
          var ot = typeof pe == "string" ? pe : pe.displayName || pe.name;
          ot && (Ze = `

Check the top-level render call using <` + ot + ">.");
        }
        return Ze;
      }
    }
    function pt(pe, Ze) {
      {
        if (!pe._store || pe._store.validated || pe.key != null)
          return;
        pe._store.validated = !0;
        var ot = Tt(Ze);
        if (ht[ot])
          return;
        ht[ot] = !0;
        var St = "";
        pe && pe._owner && pe._owner !== vt.current && (St = " It was passed a child from " + Se(pe._owner.type) + "."), ze(pe), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ot, St), ze(null);
      }
    }
    function Pt(pe, Ze) {
      {
        if (typeof pe != "object")
          return;
        if (qe(pe))
          for (var ot = 0; ot < pe.length; ot++) {
            var St = pe[ot];
            _t(St) && pt(St, Ze);
          }
        else if (_t(pe))
          pe._store && (pe._store.validated = !0);
        else if (pe) {
          var Ut = I(pe);
          if (typeof Ut == "function" && Ut !== pe.entries)
            for (var Ft = Ut.call(pe), kt; !(kt = Ft.next()).done; )
              _t(kt.value) && pt(kt.value, Ze);
        }
      }
    }
    function Wt(pe) {
      {
        var Ze = pe.type;
        if (Ze == null || typeof Ze == "string")
          return;
        var ot;
        if (typeof Ze == "function")
          ot = Ze.propTypes;
        else if (typeof Ze == "object" && (Ze.$$typeof === _ || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ze.$$typeof === S))
          ot = Ze.propTypes;
        else
          return;
        if (ot) {
          var St = Se(Ze);
          ke(ot, pe.props, "prop", St, pe);
        } else if (Ze.PropTypes !== void 0 && !tt) {
          tt = !0;
          var Ut = Se(Ze);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ut || "Unknown");
        }
        typeof Ze.getDefaultProps == "function" && !Ze.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function tn(pe) {
      {
        for (var Ze = Object.keys(pe.props), ot = 0; ot < Ze.length; ot++) {
          var St = Ze[ot];
          if (St !== "children" && St !== "key") {
            ze(pe), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", St), ze(null);
            break;
          }
        }
        pe.ref !== null && (ze(pe), k("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var Lt = {};
    function jt(pe, Ze, ot, St, Ut, Ft) {
      {
        var kt = z(pe);
        if (!kt) {
          var It = "";
          (pe === void 0 || typeof pe == "object" && pe !== null && Object.keys(pe).length === 0) && (It += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Bt = Ct();
          Bt ? It += Bt : It += yt();
          var sn;
          pe === null ? sn = "null" : qe(pe) ? sn = "array" : pe !== void 0 && pe.$$typeof === t ? (sn = "<" + (Se(pe.type) || "Unknown") + " />", It = " Did you accidentally export a JSX literal instead of a component?") : sn = typeof pe, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", sn, It);
        }
        var ln = st(pe, Ze, ot, Ut, Ft);
        if (ln == null)
          return ln;
        if (kt) {
          var bn = Ze.children;
          if (bn !== void 0)
            if (St)
              if (qe(bn)) {
                for (var Cr = 0; Cr < bn.length; Cr++)
                  Pt(bn[Cr], pe);
                Object.freeze && Object.freeze(bn);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pt(bn, pe);
        }
        if (ue.call(Ze, "key")) {
          var Zn = Se(pe), un = Object.keys(Ze).filter(function(Ri) {
            return Ri !== "key";
          }), or = un.length > 0 ? "{key: someKey, " + un.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Lt[Zn + or]) {
            var lr = un.length > 0 ? "{" + un.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, or, Zn, lr, Zn), Lt[Zn + or] = !0;
          }
        }
        return pe === r ? tn(ln) : Wt(ln), ln;
      }
    }
    function Rt(pe, Ze, ot) {
      return jt(pe, Ze, ot, !0);
    }
    function nn(pe, Ze, ot) {
      return jt(pe, Ze, ot, !1);
    }
    var Ar = nn, Ni = Rt;
    Yl.Fragment = r, Yl.jsx = Ar, Yl.jsxs = Ni;
  }()), Yl;
}
process.env.NODE_ENV === "production" ? zu.exports = ny() : zu.exports = ry();
var nt = zu.exports;
function iy(e) {
  switch (e) {
    case "AD":
    case "AM":
    case "AT":
    case "AX":
    case "AZ":
    case "BA":
    case "BY":
    case "CY":
    case "CZ":
    case "DK":
    case "DZ":
    case "EC":
    case "EH":
    case "ET":
    case "FI":
    case "FR":
    case "GE":
    case "GF":
    case "GI":
    case "GP":
    case "GW":
    case "HT":
    case "KE":
    case "KV":
    case "KW":
    case "LA":
    case "LU":
    case "MC":
    case "MD":
    case "ME":
    case "MG":
    case "MK":
    case "MQ":
    case "MZ":
    case "NC":
    case "NL":
    case "NO":
    case "PL":
    case "PT":
    case "PY":
    case "RE":
    case "RS":
    case "SA":
    case "SE":
    case "SJ":
    case "SM":
    case "SN":
    case "TC":
    case "TJ":
    case "TM":
    case "TN":
    case "TZ":
    case "UY":
    case "VG":
    case "ZM":
      return [["line1"], ["line2"], ["postalCode", "city"], ["countryCode"]];
    case "AF":
    case "IR":
      return [
        ["line1"],
        ["line2"],
        ["city"],
        ["region"],
        ["postalCode"],
        ["countryCode"]
      ];
    case "AG":
    case "AO":
    case "AW":
    case "BJ":
    case "BO":
    case "BS":
    case "BZ":
    case "CI":
    case "CW":
    case "DJ":
    case "FJ":
    case "GA":
    case "GH":
    case "GM":
    case "GY":
    case "JM":
    case "KI":
    case "LY":
    case "MW":
    case "NA":
    case "NR":
    case "PS":
    case "QA":
    case "RW":
    case "SC":
    case "SR":
    case "SX":
    case "TG":
    case "TT":
    case "UG":
    case "VU":
      return [["line1"], ["line2"], ["city"], ["countryCode"]];
    case "AL":
    case "EE":
    case "IS":
      return [["line1"], ["line2"], ["postalCode", "city"]];
    case "AR":
      return [
        ["line1"],
        ["line2"],
        ["postalCode", "city", ",", "region"],
        ["countryCode"]
      ];
    case "AS":
    case "BB":
    case "BD":
    case "BM":
    case "BN":
    case "BT":
    case "CR":
    case "DO":
    case "FK":
    case "FM":
    case "GR":
    case "GU":
    case "JO":
    case "KZ":
    case "LB":
    case "LK":
    case "LS":
    case "MA":
    case "MH":
    case "MM":
    case "MR":
    case "MT":
    case "MV":
    case "NG":
    case "PG":
    case "PK":
    case "PR":
    case "RO":
    case "SG":
    case "VC":
    case "WS":
      return [["line1"], ["line2"], ["city", "postalCode"], ["countryCode"]];
    case "AU":
    case "CA":
    case "SZ":
    case "US":
    case "VI":
      return [
        ["line1"],
        ["line2"],
        ["city", ",", "region", "postalCode"],
        ["countryCode"]
      ];
    case "BE":
    case "PE":
      return [
        ["line1"],
        ["line2"],
        ["postalCode", "sublocality", "city"],
        ["countryCode"]
      ];
    case "BF":
    case "BI":
    case "BQ":
    case "BW":
    case "CF":
    case "CG":
    case "CM":
    case "DM":
    case "ER":
    case "GQ":
    case "KM":
    case "ML":
    case "SY":
    case "TD":
    case "ZW":
      return [["line1"], ["line2"], ["city"], ["region"], ["countryCode"]];
    case "BG":
      return [["line1"], ["postalCode", "region"], ["countryCode"]];
    case "BH":
      return [["line1"], ["line2"], ["sublocality", "city"], ["countryCode"]];
    case "BR":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["city", "region"],
        ["postalCode"],
        ["countryCode"]
      ];
    case "CH":
    case "DE":
    case "GT":
    case "IT":
    case "LI":
    case "MY":
    case "NI":
    case "OM":
    case "SK":
    case "VA":
      return [
        ["line1"],
        ["line2"],
        ["postalCode", "city", "region"],
        ["countryCode"]
      ];
    case "CL":
    case "PF":
      return [
        ["line1"],
        ["line2"],
        ["city", "postalCode", "region"],
        ["countryCode"]
      ];
    case "CN":
      return [
        ["region", "city", "sublocality"],
        ["line1"],
        ["line2"],
        ["countryCode"]
      ];
    case "CO":
    case "ID":
    case "IQ":
    case "KH":
    case "MP":
    case "NP":
    case "PW":
    case "UA":
      return [
        ["line1"],
        ["line2"],
        ["city", "region", "postalCode"],
        ["countryCode"]
      ];
    case "EG":
      return [
        ["line1"],
        ["line2"],
        ["sublocality", "city", "region", "postalCode"],
        ["countryCode"]
      ];
    case "ES":
    case "IL":
      return [
        ["line1"],
        ["line2"],
        ["city", "postalCode"],
        ["region"],
        ["countryCode"]
      ];
    case "GB":
    case "MN":
    case "ZA":
      return [
        ["line1"],
        ["line2"],
        ["sublocality", "city", "postalCode"],
        ["countryCode"]
      ];
    case "GG":
    case "IM":
    case "JE":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["city"],
        ["postalCode"],
        ["countryCode"]
      ];
    case "GN":
      return [["line1", "line2", "city"], ["countryCode"]];
    case "HK":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["city"],
        ["region"],
        ["countryCode"]
      ];
    case "HR":
      return [["line1"], ["postalCode", "city", "region"], ["countryCode"]];
    case "HU":
    case "SI":
      return [["postalCode", "city"], ["line1"], ["line2"], ["countryCode"]];
    case "IE":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["city", "region", "postalCode"],
        ["countryCode"]
      ];
    case "IN":
    case "VE":
      return [
        ["line1"],
        ["line2"],
        ["city", "postalCode"],
        ["region"],
        ["countryCode"]
      ];
    case "JP":
      return [
        ["line2"],
        ["line1", "sublocality"],
        ["city", "region"],
        ["postalCode"],
        ["countryCode"]
      ];
    case "KR":
      return [
        ["countryCode"],
        ["region", "city", "sublocality", "line1"],
        ["line2"],
        ["postalCode"]
      ];
    case "KY":
      return [["line1"], ["line2"], ["postalCode"], ["countryCode"]];
    case "LT":
      return [
        ["line1"],
        ["postalCode", "city", "sublocality", "region"],
        ["countryCode"]
      ];
    case "LV":
      return [["line1"], ["city", ",", "postalCode"], ["countryCode"]];
    case "MO":
      return [["line1"], ["line2"], ["sublocality"], ["city"], ["countryCode"]];
    case "MU":
      return [
        ["line1"],
        ["line2"],
        ["city"],
        ["region", "postalCode"],
        ["countryCode"]
      ];
    case "MX":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["postalCode", "city", ",", "region"],
        ["countryCode"]
      ];
    case "NE":
    case "SD":
      return [
        ["line1"],
        ["line2"],
        ["postalCode"],
        ["city"],
        ["region"],
        ["countryCode"]
      ];
    case "NZ":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["city"],
        ["postalCode"],
        ["countryCode"]
      ];
    case "PH":
    case "TW":
    case "VN":
      return [
        ["line1"],
        ["line2"],
        ["sublocality", "city"],
        ["region", "postalCode"],
        ["countryCode"]
      ];
    case "RU":
      return [["line1"], ["line2"], ["city"], ["postalCode"], ["countryCode"]];
    case "SB":
    case "SL":
    case "ST":
    case "TL":
    case "TO":
    case "TV":
      return [["line1"], ["line2"], ["city", ",", "region"], ["countryCode"]];
    case "TH":
    case "TR":
      return [
        ["line1"],
        ["line2"],
        ["sublocality"],
        ["postalCode", "city"],
        ["countryCode"]
      ];
    case "UZ":
      return [["line1"], ["line2"], ["region", "postalCode"], ["countryCode"]];
  }
  return [
    ["line1", "line2"],
    ["city", "region", "postalCode"],
    ["countryCode"]
  ];
}
const sy = {
  GOOGLEMYBUSINESS: "GOOGLEMYBUSINESS"
}, hf = {
  GOOGLE: "google",
  APPLE: "apple",
  BING: "bing"
}, oy = (e, t) => {
  const r = {
    region: "localizedRegionName",
    countryCode: "localizedCountryName"
  }[e];
  return r && t[r];
}, ZS = (e, t = [], n, r = {
  route: !1
}, l) => {
  const d = "Failed to construct query for maps service.";
  let f = e && _f([
    e.line1,
    e.line2,
    e.city,
    e.region,
    e.postalCode,
    e.countryCode
  ]);
  switch (r.provider) {
    case hf.APPLE: {
      if (l != null && l.latitude && (l != null && l.longitude))
        return gf(
          `${l.latitude},${l.longitude}`,
          r.route
        );
      if (!f) {
        console.warn(
          `${d} Check that you've provided a valid Yext Address.`
        );
        break;
      }
      return gf(f, r.route);
    }
    case hf.BING: {
      if (l != null && l.latitude && (l != null && l.longitude))
        return pf(
          `${l.latitude},${l.longitude}`,
          r.route
        );
      if (f = e && _f([
        e.line1,
        e.city,
        e.region,
        e.postalCode
      ]), !f) {
        console.warn(
          `${d} Check that you've provided a valid Yext Address.`
        );
        break;
      }
      return pf(f, r.route);
    }
    default: {
      if (l != null && l.latitude && (l != null && l.longitude))
        return mf(
          `${l.latitude},${l.longitude}`,
          r.route
        );
      const p = t.find(
        (_) => {
          var E;
          return ((E = _ == null ? void 0 : _.publisher) == null ? void 0 : E.toUpperCase()) === sy.GOOGLEMYBUSINESS;
        }
      );
      if (p != null && p.listingUrl)
        return p.listingUrl;
      if (n)
        return ly(n, f, r.route);
      if (!f) {
        console.warn(
          `${d} Check that you've provided a valid Yext Address, Yext ListingType, or Google Place ID.`
        );
        break;
      }
      return mf(f, r.route);
    }
  }
}, gf = (e, t) => t ? `https://maps.apple.com/?daddr=${e}` : `https://maps.apple.com/?address=${e}`, pf = (e, t) => t ? `https://bing.com/maps/default.aspx?rtp=adr.${e}` : `https://bing.com/maps/default.aspx?where1=${e}`, ly = (e, t, n) => {
  const r = t ? `&query=${t}` : "";
  return n ? `https://maps.google.com/maps/dir/?api=1${r}&destination_place_id=${e}&destination=direct` : r ? `https://maps.google.com/maps/search/?api=1${r}&query_place_id=${e}` : `https://maps.google.com/maps/dir/?api=1&destination_place_id=${e}&destination=direct`;
}, mf = (e, t) => t ? `https://maps.google.com/maps/dir/?api=1&destination=${e}` : `https://maps.google.com/maps/search/?api=1&query=${e}`, _f = (e = []) => {
  if (!e.length) return "";
  const t = e.filter(Boolean).join(", ");
  return encodeURI(t);
}, JS = ({
  address: e,
  lines: t,
  separator: n = ",",
  ...r
}) => {
  const l = (t || iy(e.countryCode)).map(
    (d) => /* @__PURE__ */ nt.jsx(
      ay,
      {
        address: e,
        line: d,
        separator: n
      },
      d.toString()
    )
  );
  return /* @__PURE__ */ Z_("div", { ...r, key: e.toString() }, l);
}, ay = ({
  address: e,
  line: t,
  separator: n
}) => {
  const r = [];
  let l = 0;
  for (const d of t) {
    if (d === ",") {
      r.push(
        /* @__PURE__ */ nt.jsx("span", { children: n }, `separator-${l++}`)
      );
      continue;
    }
    const f = e[d];
    if (!f)
      continue;
    const p = oy(d, e);
    if (p) {
      r.push(
        /* @__PURE__ */ nt.jsxs(q_.Fragment, { children: [
          " ",
          /* @__PURE__ */ nt.jsx("abbr", { title: p, children: f })
        ] }, d)
      );
      continue;
    }
    r.push(/* @__PURE__ */ nt.jsx("span", { children: " " + f }, d));
  }
  return /* @__PURE__ */ nt.jsx("div", { className: "address-line", children: r });
};
var nl = {};
Object.defineProperty(nl, "__esModule", {
  value: !0
});
var cy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, uy = typeof window < "u" && typeof window.document < "u", dy = typeof process < "u" && process.versions != null && process.versions.node != null, fy = (typeof self > "u" ? "undefined" : cy(self)) === "object" && self.constructor && self.constructor.name === "DedicatedWorkerGlobalScope", hy = typeof window < "u" && window.name === "nodejs" || typeof navigator < "u" && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), gy = typeof Deno < "u" && typeof Deno.version < "u" && typeof Deno.version.deno < "u", yf = nl.isBrowser = uy;
nl.isWebWorker = fy;
var py = nl.isNode = dy;
nl.isJsDom = hy;
var my = nl.isDeno = gy;
class _y {
  constructor() {
    Ie(this, "name");
    /**
     * Whether or not the current runtime is being executed server-side or client-side. If the runtime
     * is node or deno then isServerSide will be true. When the runtime is browser isServerSide is
     * false.
     */
    Ie(this, "isServerSide");
    Ie(this, "version");
    var t;
    my ? (this.name = "deno", this.version = "", yf && (this.version = ((t = window.Deno) == null ? void 0 : t.version.deno) || ""), this.isServerSide = !0) : py ? (this.name = "node", this.version = process.versions.node, this.isServerSide = !0) : yf ? (this.name = "browser", this.version = navigator.userAgent, this.isServerSide = !1) : (this.name = "unknown", this.version = "", this.isServerSide = !1);
  }
  getNodeMajorVersion() {
    if (this.name !== "node")
      throw new Error("Not running in Node.");
    return +this.version.split(".")[0];
  }
}
const la = () => new _y(), yy = (...e) => {
  var t;
  if (typeof window < "u") {
    if (window.IS_PRODUCTION)
      return !0;
    const n = (t = window.location) == null ? void 0 : t.hostname;
    return e == null ? void 0 : e.some((r) => r == null ? void 0 : r.includes(n));
  }
  return !1;
};
function qc(e) {
  if (!fd(e))
    throw new Error("Parameter was not an error");
}
function fd(e) {
  return !!e && typeof e == "object" && Ny(e) === "[object Error]" || e instanceof Error;
}
function Ny(e) {
  return Object.prototype.toString.call(e);
}
const Cy = "Layerr";
let Ey = Cy;
function Ty() {
  return Ey;
}
function xy(e) {
  let t, n = "";
  if (e.length === 0)
    t = {};
  else if (fd(e[0]))
    t = {
      cause: e[0]
    }, n = e.slice(1).join(" ") || "";
  else if (e[0] && typeof e[0] == "object")
    t = Object.assign({}, e[0]), n = e.slice(1).join(" ") || "";
  else if (typeof e[0] == "string")
    t = {}, n = n = e.join(" ") || "";
  else
    throw new Error("Invalid arguments passed to Layerr");
  return {
    options: t,
    shortMessage: n
  };
}
class Mi extends Error {
  constructor(t, n) {
    const r = [...arguments], { options: l, shortMessage: d } = xy(r);
    let f = d;
    if (l.cause && (f = `${f}: ${l.cause.message}`), super(f), this.message = f, l.name && typeof l.name == "string" ? this.name = l.name : this.name = Ty(), l.cause && Object.defineProperty(this, "_cause", { value: l.cause }), Object.defineProperty(this, "_info", { value: {} }), l.info && typeof l.info == "object" && Object.assign(this._info, l.info), Error.captureStackTrace) {
      const p = l.constructorOpt || this.constructor;
      Error.captureStackTrace(this, p);
    }
  }
  static cause(t) {
    return qc(t), t._cause && fd(t._cause) ? t._cause : null;
  }
  static fullStack(t) {
    qc(t);
    const n = Mi.cause(t);
    return n ? `${t.stack}
caused by: ${Mi.fullStack(n)}` : t.stack ?? "";
  }
  static info(t) {
    qc(t);
    const n = {}, r = Mi.cause(t);
    return r && Object.assign(n, Mi.info(r)), t._info && Object.assign(n, t._info), n;
  }
  toString() {
    let t = this.name || this.constructor.name || this.constructor.prototype.name;
    return this.message && (t = `${t}: ${this.message}`), t;
  }
}
const lp = "0123456789ABCDEFGHJKMNPQRSTVWXYZ", ia = 32, Nf = 281474976710655, vy = 10, Sy = 16, ea = Object.freeze({
  source: "ulid"
});
function wy(e) {
  const t = Oy(), n = t && (t.crypto || t.msCrypto) || null;
  if (typeof (n == null ? void 0 : n.getRandomValues) == "function")
    return () => {
      const r = new Uint8Array(1);
      return n.getRandomValues(r), r[0] / 255;
    };
  if (typeof (n == null ? void 0 : n.randomBytes) == "function")
    return () => n.randomBytes(1).readUInt8() / 255;
  throw new Mi({
    info: {
      code: "PRNG_DETECT",
      ...ea
    }
  }, "Failed to find a reliable PRNG");
}
function Oy() {
  return My() ? self : typeof window < "u" ? window : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : null;
}
function Dy(e, t) {
  let n = "";
  for (; e > 0; e--)
    n = Ry(t) + n;
  return n;
}
function Ay(e, t) {
  if (isNaN(e))
    throw new Mi({
      info: {
        code: "ENC_TIME_NAN",
        ...ea
      }
    }, `Time must be a number: ${e}`);
  if (e > Nf)
    throw new Mi({
      info: {
        code: "ENC_TIME_SIZE_EXCEED",
        ...ea
      }
    }, `Cannot encode a time larger than ${Nf}: ${e}`);
  if (e < 0)
    throw new Mi({
      info: {
        code: "ENC_TIME_NEG",
        ...ea
      }
    }, `Time must be positive: ${e}`);
  if (Number.isInteger(e) === !1)
    throw new Mi({
      info: {
        code: "ENC_TIME_TYPE",
        ...ea
      }
    }, `Time must be an integer: ${e}`);
  let n, r = "";
  for (let l = t; l > 0; l--)
    n = e % ia, r = lp.charAt(n) + r, e = (e - n) / ia;
  return r;
}
function My() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function Ry(e) {
  let t = Math.floor(e() * ia);
  return t === ia && (t = ia - 1), lp.charAt(t);
}
function by(e, t) {
  const n = wy(), r = isNaN(e) ? Date.now() : e;
  return Ay(r, vy) + Dy(Sy, n);
}
var Cf = "yext_analytics_session_id";
function Ly() {
  if (typeof window > "u")
    return null;
  try {
    var e = window.sessionStorage.getItem(Cf);
    return e || (e = by(), window.sessionStorage.setItem(Cf, e)), e;
  } catch (t) {
    return console.warn(`Unable to use browser sessionStorage for sessionId.
`, t), null;
  }
}
const Iy = "1.0.0", Ef = {
  version: Iy
};
function ky(e, t, n) {
  return n.debug ? (ap(!0, t, n), !0) : navigator.sendBeacon(e, JSON.stringify(t));
}
function Py(e, t, n) {
  return n.debug ? (ap(!1, t, n), Promise.resolve(new Response())) : fetch(e, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(t),
    keepalive: !0
  });
}
function $y(e, t) {
  return !t && !!navigator.userAgent && navigator.userAgent.toLowerCase().includes("firefox");
}
function ap(e, t, n) {
  var r = e ? "Beacon" : "fetch()";
  console.log("[DEBUG] AnalyticsConfig object at time of call to report():", n), console.log("[DEBUG] The following EventPayload would be sent to the Yext Events API using ".concat(r, ":"), t);
}
var Uu = function() {
  return Uu = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, Uu.apply(this, arguments);
}, Gu = function(e, t) {
  if (!t || Object.keys(t).length === 0)
    return e;
  if (!e || Object.keys(e).length === 0)
    return t;
  var n = JSON.parse(JSON.stringify(e));
  for (var r in t)
    if (t.hasOwnProperty(r)) {
      var l = t[r];
      l == null ? delete n[r] : typeof l != "object" ? n[r] = l : n[r] = Gu(n[r], l);
    }
  return Uu({}, n);
}, Fy = "yextevents.com/accounts/me/events";
function By(e, t) {
  var n = e === "SANDBOX", r = t == null ? void 0 : t.toLowerCase();
  if (n && r === "eu")
    throw new Error("Sandbox environment is not available in the EU region.");
  return "https://" + (n ? "sbx." : "") + (r ?? "us") + "." + Fy;
}
var Hy = function(e, t, n, r) {
  function l(d) {
    return d instanceof n ? d : new n(function(f) {
      f(d);
    });
  }
  return new (n || (n = Promise))(function(d, f) {
    function p(T) {
      try {
        E(r.next(T));
      } catch (S) {
        f(S);
      }
    }
    function _(T) {
      try {
        E(r.throw(T));
      } catch (S) {
        f(S);
      }
    }
    function E(T) {
      T.done ? d(T.value) : l(T.value).then(p, _);
    }
    E((r = r.apply(e, t || [])).next());
  });
}, Wy = function(e, t) {
  var n = { label: 0, sent: function() {
    if (d[0] & 1) throw d[1];
    return d[1];
  }, trys: [], ops: [] }, r, l, d, f;
  return f = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
    return this;
  }), f;
  function p(E) {
    return function(T) {
      return _([E, T]);
    };
  }
  function _(E) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; f && (f = 0, E[0] && (n = 0)), n; ) try {
      if (r = 1, l && (d = E[0] & 2 ? l.return : E[0] ? l.throw || ((d = l.return) && d.call(l), 0) : l.next) && !(d = d.call(l, E[1])).done) return d;
      switch (l = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
        case 0:
        case 1:
          d = E;
          break;
        case 4:
          return n.label++, { value: E[1], done: !1 };
        case 5:
          n.label++, l = E[1], E = [0];
          continue;
        case 7:
          E = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (d = n.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
            n = 0;
            continue;
          }
          if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
            n.label = E[1];
            break;
          }
          if (E[0] === 6 && n.label < d[1]) {
            n.label = d[1], d = E;
            break;
          }
          if (d && n.label < d[2]) {
            n.label = d[2], n.ops.push(E);
            break;
          }
          d[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      E = t.call(e, n);
    } catch (T) {
      E = [6, T], l = 0;
    } finally {
      r = d = 0;
    }
    if (E[0] & 5) throw E[1];
    return { value: E[0] ? E[1] : void 0, done: !0 };
  }
}, Ky = (
  /** @class */
  function() {
    function e(t, n) {
      if (t.authorizationType !== "apiKey" && t.authorizationType !== "bearer")
        throw new Error("Authorization type must be either apiKey or bearer.");
      if (!t.authorization)
        throw new Error("Authorization must be provided.");
      this.config = t, this.payload = n;
    }
    return e.prototype.with = function(t) {
      var n = this.payload === void 0 ? t : Gu(this.payload, t);
      return new e(this.config, n);
    }, e.prototype.report = function(t) {
      var n;
      return Hy(this, void 0, void 0, function() {
        var r, l, d, f, p = this;
        return Wy(this, function(_) {
          return r = Gu((n = this.payload) !== null && n !== void 0 ? n : {}, t ?? {}), this.config.sessionTrackingEnabled ? r.sessionId || (r.sessionId = Ly()) : r.sessionId = void 0, r.clientSdk ? r.clientSdk.ANALYTICS = Ef.version : r.clientSdk = (f = {}, f.ANALYTICS = Ef.version, f), r.authorization = this.config.authorizationType === "apiKey" ? "KEY " + this.config.authorization : "Bearer " + this.config.authorization, l = $y(r, this.config.forceFetch), d = By(this.config.env, this.config.region), l ? [2, new Promise(function(E, T) {
            ky(d, r, p.config) ? E("") : T("Failed Beacon Call");
          })] : [2, Py(d, r, this.config).then(function(E) {
            return E;
          }).catch(function(E) {
            return E;
          })];
        });
      });
    }, e;
  }()
);
function zy(e) {
  return new Ky(e);
}
function Yu(e) {
  return e ? e.toLowerCase().trim().replace(/\s/g, "") : "";
}
function cp(e, t) {
  return [e, t].filter((n) => !!n).map((n) => Yu(n)).join("_");
}
const Uy = (e) => {
  switch (Math.floor(e / 1e8 % 10)) {
    case 0:
      return "US";
    case 1:
      return "EU";
    default:
      return "";
  }
}, up = Ec(null), Gy = X_(() => import("./debugger-BwrGCC7Q.js"));
function XS(e) {
  const {
    children: t,
    apiKey: n,
    currency: r,
    templateData: l,
    requireOptIn: d,
    disableSessionTracking: f,
    enableDebugging: p,
    productionDomains: _
  } = e;
  if (!n)
    throw new Error("API Key is required for AnalyticsProvider");
  const E = dd(null), [T, S] = Nr(!1);
  tr(() => {
    S(!0);
  }, []), E.current === null && (E.current = new Yy(
    n,
    r,
    l,
    d,
    f,
    _,
    p ?? ju()
  ));
  const w = E.current;
  return tr(() => (window.enableYextAnalytics = () => {
    w.optIn();
  }, () => {
    delete window.enableYextAnalytics;
  }), [w]), /* @__PURE__ */ nt.jsxs(nt.Fragment, { children: [
    /* @__PURE__ */ nt.jsx(up.Provider, { value: w, children: t }),
    T && (p || ju()) && la().name === "browser" ? /* @__PURE__ */ nt.jsx(J_, { fallback: /* @__PURE__ */ nt.jsx(nt.Fragment, {}), children: /* @__PURE__ */ nt.jsx(Gy, {}) }) : null
  ] });
}
function ju() {
  return la().name !== "browser" || typeof window === void 0 ? !1 : !!new URL(window.location.href).searchParams.get("xYextDebug");
}
class Yy {
  /**
   * Creates an Analytics instance, will fire a pageview event if requireOptin
   * is false
   *
   * @param apiKey - the Yext API key for authorizing analytics events
   * @param defaultCurrency - the ISO 4217 currency code to use for valued events
   * @param templateData - template data object from the pages system
   * @param requireOptIn - boolean, set to true if you require user opt in before tracking analytics
   * @param disableSessionTracking - turns off session tracking
   * @param productionDomains - the domains to fire Yext analytics on. Only necessary if this code is being run in the context of a Yext module.
   * @param enableDebugging - turns debug mode on meaning requests are logged instead
   */
  constructor(t, n, r, l, d, f, p = !1) {
    Ie(this, "_optedIn");
    Ie(this, "_sessionTrackingEnabled");
    Ie(this, "_analyticsEventService");
    Ie(this, "_pageViewFired", !1);
    this.apiKey = t, this.defaultCurrency = n, this.templateData = r, this.productionDomains = f, this.enableDebugging = p, this._optedIn = !l, this._sessionTrackingEnabled = !d, this.makeReporter(), this.pageView();
  }
  makeReporter() {
    if (la().name !== "browser" || !this._optedIn)
      return;
    if (!yy(...this.productionDomains ?? []) && !this.getDebugEnabled()) {
      console.warn("Yext Analytics disabled for non-production domains");
      return;
    }
    const t = Uy(
      this.templateData.document.businessId
    ), n = {
      authorizationType: "apiKey",
      authorization: this.apiKey,
      env: "PRODUCTION",
      region: t || "US",
      sessionTrackingEnabled: this._sessionTrackingEnabled,
      debug: this.getDebugEnabled()
    }, r = {
      pages: {
        siteUid: this.templateData.document.siteId,
        template: this.templateData.document.__.name
      },
      entity: this.templateData.document.uid || void 0,
      pageUrl: document.URL,
      referrerUrl: document.referrer !== "" ? document.referrer : void 0
    };
    this._analyticsEventService = zy(n).with(r);
  }
  canTrack() {
    return la().name === "browser" && this._optedIn && !!this._analyticsEventService;
  }
  /** {@inheritDoc AnalyticsMethods.identify} */
  identify(t) {
    this.canTrack() && this._analyticsEventService && (this._analyticsEventService = this._analyticsEventService.with({
      visitor: t
    }));
  }
  /** {@inheritDoc AnalyticsMethods.async} */
  async optIn() {
    this._optedIn = !0, this.makeReporter(), this._pageViewFired || await this.pageView();
  }
  /** {@inheritDoc AnalyticsMethods.async} */
  async pageView() {
    var t;
    if (!this.canTrack())
      return Promise.resolve(void 0);
    await ((t = this._analyticsEventService) == null ? void 0 : t.report({
      action: "PAGE_VIEW"
    })), this._pageViewFired = !0;
  }
  /** {@inheritDoc AnalyticsMethods.track} */
  async track(t) {
    var S;
    if (!this.canTrack())
      return Promise.resolve();
    const {
      action: n,
      scope: r,
      eventName: l,
      currency: d,
      amount: f,
      destinationUrl: p,
      customTags: _,
      customValues: E
    } = t;
    let T;
    f && (T = {
      amount: f,
      currency: d || this.defaultCurrency
    }), await ((S = this._analyticsEventService) == null ? void 0 : S.report({
      action: n,
      pages: {
        scope: Yu(r) || void 0,
        originalEventName: cp(r || "", Yu(l) || "")
      },
      value: T,
      destinationUrl: p,
      customTags: _,
      customValues: E
    }));
  }
  /** {@inheritDoc AnalyticsMethods.getDebugEnabled} */
  getDebugEnabled() {
    return this.enableDebugging || ju();
  }
}
const Vu = Ec({ name: "" }), dp = () => co(Vu).name;
function QS(e) {
  var f;
  const t = dp(), [n] = Nr({
    name: cp(t, e.name)
  }), r = (f = ua()) == null ? void 0 : f.getDebugEnabled(), [l, d] = Nr(!1);
  return tr(() => {
    d(!0);
  }, []), r && l ? /* @__PURE__ */ nt.jsx("section", { "data-ya-scope": n.name, children: /* @__PURE__ */ nt.jsx(Vu.Provider, { value: n, children: e.children }) }) : /* @__PURE__ */ nt.jsx(Vu.Provider, { value: n, children: e.children });
}
function ua() {
  const e = co(up);
  if (!e)
    return e;
  la().name === "browser" && !window.setAnalyticsOptIn && (window.setAnalyticsOptIn = async () => {
    await e.optIn();
  });
  const t = dp();
  return {
    getDebugEnabled() {
      return e.getDebugEnabled();
    },
    identify(n) {
      return e.identify(n);
    },
    optIn() {
      return e.optIn();
    },
    pageView() {
      return e.pageView();
    },
    track(n) {
      return e.track({
        ...n,
        scope: n.scope ?? t
        // prefer specific scope over hook
      });
    }
  };
}
const ew = () => {
  var e;
  return (e = ua()) == null ? void 0 : e.track;
}, tw = () => {
  var e;
  return (e = ua()) == null ? void 0 : e.pageView;
}, nw = () => {
  var e;
  return (e = ua()) == null ? void 0 : e.identify;
}, io = {
  /**
   * The the default layout if one is not specified. An image will be scaled down to fit the
   * container but not exceed the absolute size of the image.
   */
  INTRINSIC: "intrinsic",
  /**
   * Shows the image in a fixed size. `width` or `height` must be passed in. If both `width` and
   * `height` are passed in, but the aspect ratio does not match the aspect ratio of the image,
   * the image will be centered. This behavior can be adjusted using the `objectFit` and
   * `objectPosition` props of the `style` rpop.
   */
  FIXED: "fixed",
  /** Shows the image in a fixed aspect ratio. The `aspectRatio` prop must be provided. */
  ASPECT: "aspect",
  /** Always fills the image to 100% of the container's width. */
  FILL: "fill"
}, jy = (e) => {
  const t = e.protocol.slice(0, -1);
  if (t !== "http" && t !== "https") {
    console.error(`Invalid scheme: ${e}`);
    return;
  }
  const n = e.hostname;
  let r;
  if (n === "a.mktgcdn.com")
    r = "us";
  else {
    if (n.replace("a.", "").replace(".mktgcdn.com", "") !== "eu") {
      console.error(`Invalid host: ${e}`);
      return;
    }
    r = "eu";
  }
  if (!e.pathname.startsWith("/f")) {
    console.error(`Invalid path: ${e}`);
    return;
  }
  const l = e.pathname.replace(/^\//, "").split("/");
  if (l.length < 2 || l.length > 3) {
    console.error(`Invalid path: ${e}`);
    return;
  }
  let d;
  if (l[0] === "f")
    d = "prod";
  else
    switch (l[0].replace("f-", "")) {
      case "sandbox": {
        d = "sbx";
        break;
      }
      case "qa": {
        d = "qa";
        break;
      }
      case "dev": {
        d = "dev";
        break;
      }
      default: {
        console.error(`Invalid path: ${e}`);
        return;
      }
    }
  if (r === "eu" && (d === "dev" || d === "sbx")) {
    console.error(`Invalid path: ${e}`);
    return;
  }
  let f;
  if (l.length === 3 && (f = parseInt(l[1]), Number.isNaN(f))) {
    console.error(`Invalid account id: ${e}`);
    return;
  }
  const p = l[l.length - 1].split("."), _ = p.length === 2 ? `.${p[1]}` : "", E = p[0];
  return {
    scheme: t,
    partition: r,
    env: d,
    accountId: f,
    contentHash: E,
    extension: _
  };
}, Vy = (e, t, n) => {
  const r = `https://dyn${e.partition === "us" ? "" : `.${e.partition}`}.mktgcdn.com`;
  let l = "f";
  switch (e.env) {
    case "prod":
      break;
    case "sbx": {
      l += "-sandbox";
      break;
    }
    default:
      l += `-${e.env.toString()}`;
  }
  const d = e.accountId !== void 0 ? `${e.accountId}/` : "";
  return `${r}/${l}/${d}${e.contentHash}${e.extension}/width=${Math.round(t)},height=${Math.round(n)}`;
}, qy = (e) => {
  const t = e.protocol.slice(0, -1);
  if (t !== "http" && t !== "https") {
    console.error(`Invalid scheme: ${e}`);
    return;
  }
  if (e.hostname !== "a.mktgcdn.com") {
    console.error(`Invalid host: ${e}`);
    return;
  }
  if (!e.pathname.startsWith("/p")) {
    console.error(`Invalid path: ${e}`);
    return;
  }
  const n = e.pathname.replace(/^\//, "").split("/");
  if (n.length < 3 || n.length > 4) {
    console.error(`Invalid path: ${e}`);
    return;
  }
  let r;
  if (n[0] === "p")
    r = "prod";
  else
    switch (n[0].replace("p-", "")) {
      case "sandbox": {
        r = "sbx";
        break;
      }
      case "qa": {
        r = "qa";
        break;
      }
      case "dev": {
        r = "dev";
        break;
      }
      default: {
        console.error(`Invalid path: ${e}`);
        return;
      }
    }
  const l = n[1];
  let d;
  if (n.length === 4) {
    if (!n[2].includes(".")) {
      console.error(`Invalid aspect ratio: ${e}`);
      return;
    }
    if (d = parseFloat(n[2]), Number.isNaN(d) || n[2].split(".")[1].length !== 4) {
      console.error(`Invalid aspect ratio: ${e}`);
      return;
    }
  }
  const f = n[n.length - 1].split("."), p = f.length === 2 ? `.${f[1]}` : "", _ = f[0];
  return {
    scheme: t,
    env: r,
    contentHash: l,
    aspectRatio: d,
    name: _,
    extension: p
  };
}, Zy = (e, t, n) => {
  const r = "https://dyn.mktgcdn.com";
  let l = "p";
  switch (e.env) {
    case "prod":
      break;
    case "sbx": {
      l += "-sandbox";
      break;
    }
    default:
      l += `-${e.env.toString()}`;
  }
  return `${r}/${l}/${e.contentHash}/width=${Math.round(
    t
  )},height=${Math.round(n)}`;
}, qu = (e, t, n) => {
  if (!fp(e)) {
    console.error(`Invalid image url: ${e}.`);
    return;
  }
  const r = new URL(e);
  if (r.pathname.startsWith("/p")) {
    const l = qy(r);
    if (l)
      return Zy(l, t, n);
  } else if (r.pathname.startsWith("/f")) {
    const l = jy(r);
    if (l)
      return Vy(l, t, n);
  }
  return e;
}, fp = (e) => {
  let t;
  try {
    t = new URL(e);
  } catch {
    return !1;
  }
  return t.protocol === "http:" || t.protocol === "https:";
}, rw = ({
  image: e,
  className: t,
  width: n,
  height: r,
  aspectRatio: l,
  layout: d = io.INTRINSIC,
  placeholder: f,
  imgOverrides: p,
  style: _ = {},
  loading: E = "lazy"
}) => {
  const T = dd(null), [S, w] = Nr(!1), O = "image" in e ? e.image : e;
  tr(() => {
    var ce;
    (ce = T.current) != null && ce.complete && w(!0);
  }, []), Jy(
    d,
    O.width,
    O.height,
    n,
    r,
    l
  );
  const m = Math.abs(O.width);
  m || console.warn("Invalid image width.");
  const v = Math.abs(O.height);
  if (v || console.warn("Invalid image height."), !fp(O.url))
    return console.error(`Invalid image url: ${O.url}`), /* @__PURE__ */ nt.jsx(nt.Fragment, { children: f != null && f });
  const I = n && n > 0 ? n : void 0, G = r && r > 0 ? r : void 0, { src: k, imgStyle: P, widths: H } = Xy(
    d,
    m,
    v,
    _,
    O.url,
    I,
    G,
    l
  ), j = H.map(
    (ce) => `${qu(O.url, ce, v / m * ce)} ${ce}w`
  ).join(", "), re = [640, 768, 1024, 1280, 1536], te = H.map(
    (ce, V) => V === H.length - 1 ? `${ce}px` : `(max-width: ${re[V]}px) ${ce}px`
  ).join(", ");
  return /* @__PURE__ */ nt.jsxs(nt.Fragment, { children: [
    !S && f != null && f,
    /* @__PURE__ */ nt.jsx(
      "img",
      {
        ref: T,
        style: P,
        src: k,
        className: t,
        width: I,
        height: G,
        srcSet: j,
        sizes: te,
        loading: E,
        alt: O.alternateText || "",
        ...p
      }
    )
  ] });
}, Jy = (e, t, n, r, l, d) => {
  if (t < 0 && console.warn(`Invalid image width: ${t}.`), n < 0 && console.warn(`Invalid image height: ${n}.`), e === io.FIXED) {
    if (!r && !l) {
      console.warn(
        "Using fixed layout but neither width nor height is passed as props."
      );
      return;
    }
    r && r < 0 && console.warn(`Using fixed layout but width is invalid: ${r}.`), l && l < 0 && console.warn(`Using fixed layout but height is invalid: ${l}.`);
    return;
  }
  (r || l) && console.warn(
    "Width or height is passed in but layout is not fixed. These will have no impact. If you want to have a fixed height or width then set layout to fixed."
  ), e === io.ASPECT && !d && console.warn(
    "Using aspect layout but aspectRatio is not passed as a prop."
  );
}, Xy = (e, t, n, r, l, d, f, p) => {
  let _ = [100, 320, 640, 960, 1280, 1920], E = qu(l, 500, 500);
  const T = { ...r };
  switch (T.objectFit = T.objectFit || "cover", T.objectPosition = T.objectPosition || "center", e) {
    case io.INTRINSIC:
      T.maxWidth = t, T.width = "100%", T.aspectRatio = p ? `${p}` : `${t} / ${n}`;
      break;
    case io.FIXED: {
      const { fixedWidth: S, fixedHeight: w, fixedWidths: O } = Qy(
        t,
        n,
        _,
        d,
        f
      );
      T.width = S, T.height = w, _ = O, E = qu(l, S, w);
      break;
    }
    case io.ASPECT:
      T.aspectRatio = p ? `${p}` : `${t} / ${n}`;
      break;
    case io.FILL:
      T.width = "100%", T.aspectRatio = p ? `${p}` : `${t} / ${n}`;
      break;
    default:
      console.warn(`Unrecognized layout: ${e}.`);
      break;
  }
  return { src: E, imgStyle: T, widths: _ };
}, Qy = (e, t, n, r, l) => r && l ? {
  fixedWidth: r,
  fixedHeight: l,
  fixedWidths: [r]
} : r ? {
  fixedWidth: r,
  fixedHeight: r * t / e,
  fixedWidths: [r]
} : l ? {
  fixedWidth: l / t * e,
  fixedHeight: l,
  fixedWidths: [l / t * e]
} : {
  fixedWidth: e,
  fixedHeight: t,
  fixedWidths: n
};
var hp = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var d = "", f = 0; f < arguments.length; f++) {
        var p = arguments[f];
        p && (d = l(d, r(p)));
      }
      return d;
    }
    function r(d) {
      if (typeof d == "string" || typeof d == "number")
        return d;
      if (typeof d != "object")
        return "";
      if (Array.isArray(d))
        return n.apply(null, d);
      if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]"))
        return d.toString();
      var f = "";
      for (var p in d)
        t.call(d, p) && d[p] && (f = l(f, p));
      return f;
    }
    function l(d, f) {
      return f ? d ? d + " " + f : d + f : d;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(hp);
var eN = hp.exports;
const el = /* @__PURE__ */ op(eN), tN = "phonecall", nN = "drivingdirection", Tf = "calltoactionclick", rN = "clicktowebsite", iN = "other", xf = "link", sN = "cta", oN = (e) => {
  const t = e.cta ?? { link: e.href };
  if (!t.link)
    throw e.cta ? new Error("CTA's link is undefined") : new Error("Link's href is undefined");
  return t.linkType || (t.linkType = cN(t.link)), t.link = uN(t), t;
}, lN = (e, t) => {
  switch (e.linkType) {
    case "EMAIL":
      return "CTA_CLICK";
    case "PHONE":
      return "TAP_TO_CALL";
    case "CLICK_TO_WEBSITE":
      return "WEBSITE";
    case "DRIVING_DIRECTIONS":
      return "DRIVING_DIRECTIONS";
    case "OTHER":
      return "CTA_CLICK";
    case "URL":
      return "LINK";
    default:
      return t ? "CTA_CLICK" : "LINK";
  }
}, aN = (e, t, n) => {
  if (e)
    return e;
  if (t)
    switch (t) {
      case "PHONE":
        return tN;
      case "EMAIL":
        return Tf;
      case "URL":
        return xf;
      case "DRIVING_DIRECTIONS":
        return nN;
      case "CLICK_TO_WEBSITE":
        return rN;
      case "OTHER":
        return iN;
      default:
        return n ? Tf : xf;
    }
  return sN;
}, cN = (e) => dN(e) ? "EMAIL" : e.startsWith("tel:") ? "PHONE" : "URL", uN = (e) => e.linkType === "EMAIL" ? e.link.startsWith("mailto:") ? e.link : `mailto:${e.link}` : e.linkType === "PHONE" ? e.link.startsWith("tel:") ? e.link : `tel:${e.link}` : e.link, dN = (e) => e.startsWith("mailto:") ? !0 : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e), fN = Q_(
  function(t, n) {
    const {
      children: r,
      onClick: l,
      className: d,
      eventName: f,
      scope: p,
      currency: _,
      amount: E,
      cta: T,
      obfuscate: S,
      customTags: w,
      customValues: O,
      ...m
    } = t, v = oN(t), I = lN(v, !!T), G = aN(
      f,
      v.linkType,
      !!T
    ), k = ua(), P = S || S !== !1 && v.linkType === "EMAIL", H = async (te) => {
      const ce = te.currentTarget;
      let V = "";
      if (P) {
        te.preventDefault();
        const z = ce.href.split("/").at(-1);
        z && (V = atob(z));
      }
      if (k !== null)
        try {
          await k.track({
            action: I,
            scope: p,
            eventName: G,
            currency: _,
            amount: E,
            destinationUrl: V || ce.href,
            customTags: w,
            customValues: O
          });
        } catch {
          console.error("Failed to report click Analytics Event");
        }
      l && l(te), V && (window.location.href = V);
    }, j = P ? "Obfuscated, set a label or child" : v.link, re = {
      className: el("Link", d),
      href: P ? btoa(v.link) : v.link,
      onClick: H,
      rel: t.target && !t.rel ? "noopener" : void 0,
      ref: n
    };
    return k != null && k.getDebugEnabled() && (re["data-ya-action"] = I, re["data-ya-scopeoverride"] = p, re["data-ya-eventname"] = G), /* @__PURE__ */ nt.jsx("a", { ...m, ...re, suppressHydrationWarning: !0, children: r || v.label || j });
  }
);
var yn = /* @__PURE__ */ ((e) => (e.DEGREE = "deg", e.KILOMETER = "km", e.MILE = "mi", e.RADIAN = "r", e))(yn || {}), jr = /* @__PURE__ */ ((e) => (e.MERCATOR = "mercator", e.SPHERICAL = "spherical", e))(jr || {});
const Zc = 3959, Jc = 6371, hN = ["latitude", "lat"], gN = ["longitude", "lon", "lng", "long"];
function vf(e, t) {
  for (const n of t)
    if (e[n] || e[n] === 0)
      return e[n];
}
function Sf(e) {
  switch (typeof e) {
    case "string":
    case "number":
      const t = Number.parseFloat(e);
      if (Number.isNaN(t))
        throw new Error(`'${e}' must be convertible to a Number'`);
      return t;
    default:
      throw new Error(
        `typeof '${e}' must be a number or a string that can be converted to a number, is '${typeof e}'`
      );
  }
}
function so(e) {
  return e * Math.PI / 180;
}
function Xi(e) {
  return e / Math.PI * 180;
}
function pN(e, t) {
  const n = so(e.latitude), r = so(t.latitude), l = r - n, d = so(t.longitude - e.longitude), f = Math.pow(Math.sin(l / 2), 2) + Math.cos(n) * Math.cos(r) * Math.pow(Math.sin(d / 2), 2);
  return 2 * Math.atan2(Math.sqrt(f), Math.sqrt(1 - f));
}
function mN(e, t) {
  const n = Math.tan(Math.PI / 360 * (e + 90)), r = Math.tan(Math.PI / 360 * (t + 90));
  return Math.log(r / n);
}
function _N(e, t) {
  const r = Math.tan(Math.PI / 360 * (e + 90)) * Math.pow(Math.E, t);
  return Math.atan(r) * 360 / Math.PI - 90;
}
class fn {
  /**
   * Constructor takes either 1 or 2 arguments.
   * 2 arguments: latitude and longitude.
   * 1 argument: an object with at least one {@link LATITUDE_ALIASES | latitude alias}
   * and one one {@link LONGITUDE_ALIASES | longitude alias}.
   * @param longitude - Optional only if the first argument is a {@link Coordinate}-like object
   */
  constructor(t, n) {
    Ie(this, "_lat");
    Ie(this, "_lon");
    let r = t, l = n;
    this._lat = 0, this._lon = 0, typeof t == "object" ? (r = vf(t, hN) ?? 0, l = vf(t, gN) ?? 0, this.latitude = typeof r == "function" ? r() : r, this.longitude = typeof l == "function" ? l() : l) : typeof r == "number" && typeof l == "number" && (this.latitude = r, this.longitude = l);
  }
  /**
   * Degrees latitude in the range [-90, 90].
   * If setting a value outside this range, it will be set to -90 or 90, whichever is closer.
   */
  get latitude() {
    return this._lat;
  }
  set latitude(t) {
    this._lat = Math.max(-90, Math.min(Sf(t), 90));
  }
  /**
   * Degrees longitude in the range [-Infinity, Infinity].
   */
  get longitude() {
    return this._lon;
  }
  set longitude(t) {
    this._lon = Sf(t);
  }
  /**
   * Degrees longitude in the range [-180, 180).
   * If the coordinate's longitude is outside this range, the equivalent value within it is used.
   * Examples: 123 =\> 123, 270 =\> -90, -541 =\> 179
   */
  get normalLon() {
    return ((this._lon + 180) % 360 + 360) % 360 - 180;
  }
  /**
   * Add distance to the coordinate to change its position.
   * @param latDist - latitude distance
   * @param lonDist - longitude distance
   * @param unit - The unit of latDist and lonDist
   * @param projection - The projection of Earth (not relevant when using a physical distance unit, e.g. Mile)
   */
  add(t, n, r = yn.DEGREE, l = jr.SPHERICAL) {
    if (l === jr.MERCATOR && (r === yn.DEGREE || r === yn.RADIAN)) {
      const d = r === yn.DEGREE ? so(t) : t, f = r === yn.DEGREE ? n : Xi(n);
      this.latitude = _N(this.latitude, d), this.longitude += f;
    } else
      switch (r) {
        case yn.DEGREE:
          this.latitude += t, this.longitude += n;
          break;
        case yn.KILOMETER:
          this.latitude += Xi(t) * Jc, this.longitude += Xi(n) * Jc * Math.cos(so(this.latitude));
          break;
        case yn.MILE:
          this.latitude += Xi(t) * Zc, this.longitude += Xi(n) * Zc * Math.cos(so(this.latitude));
          break;
        case yn.RADIAN:
          this.latitude += Xi(t), this.longitude += Xi(n);
          break;
        default:
          throw new Error(`unit unhandled: ${String(r)}`);
      }
  }
  /**
   * Calculate the distance from this coordinate to another coordinate.
   * @param unit - The unit of distance
   * @param projection - The projection of Earth (not relevant when using a physical distance unit, e.g. Mile)
   * @returns Distance in the requested unit
   */
  distanceTo(t, n = yn.MILE, r = jr.SPHERICAL) {
    if (r === jr.MERCATOR && (n === yn.DEGREE || n === yn.RADIAN)) {
      const l = mN(
        this.latitude,
        t.latitude
      ), d = Math.abs(t.normalLon - this.normalLon), f = so(
        Math.min(d, 360 - d)
      ), p = Math.sqrt(Math.pow(l, 2) + Math.pow(f, 2));
      switch (n) {
        case yn.DEGREE:
          return Xi(p);
        case yn.RADIAN:
          return p;
        default:
          throw new Error(`unit unhandled: ${String(n)}`);
      }
    } else {
      const l = pN(this, t);
      switch (n) {
        case yn.DEGREE:
          return Xi(l);
        case yn.KILOMETER:
          return l * Jc;
        case yn.MILE:
          return l * Zc;
        case yn.RADIAN:
          return l;
        default:
          throw new Error(`unit unhandled: ${String(n)}`);
      }
    }
  }
  /**
   * Test if this coordinate has the same latitude and longitude as another.
   */
  equals(t) {
    return t && t.latitude === this.latitude && t.longitude === this.longitude;
  }
  /**
   * Get the coordinate as a string that can be used in a search query.
   * Example: \{latitude: -45, longitude: 123\} =\> '-45,123'
   */
  searchQueryString() {
    return `${this.latitude},${this.longitude}`;
  }
}
function gp(e, t = () => null) {
  const n = document.createElement("script");
  n.async = !0, n.onload = t, n.src = e, document.head.appendChild(n);
}
var Or = /* @__PURE__ */ ((e) => (e.UNDEFINED = "undefined", e.NULL = "object", e.BOOLEAN = "boolean", e.NUMBER = "number", e.BIGINT = "bigint", e.STRING = "string", e.SYMBOL = "symbol", e.FUNCTION = "function", e.OBJECT = "object", e))(Or || {});
function $r(e, t) {
  if (typeof t != "string")
    throw new Error("Assertion error: 'type' must be a string");
  if (typeof e !== t)
    throw new Error(
      `Expected an object of type '${t}' but received '${typeof e}'`
    );
}
function Dr(e, t) {
  let n;
  try {
    n = e instanceof t;
  } catch {
    throw new Error(
      "Assertion error: 'instanceClass' is not a valid constructor"
    );
  }
  if (!n)
    throw new Error(
      `Expected an instance of '${t.name}' but received '${e.constructor.name}'`
    );
}
class pp {
  constructor(t, n) {
    /**
     * @param wrapper - The wrapper element that the map will be inserted into
     */
    Ie(this, "providerMapClass");
    Ie(this, "wrapper");
    Ie(this, "controlEnabled");
    Ie(this, "panHandler");
    Ie(this, "panStartHandler");
    Ie(this, "providerOptions");
    Dr(t, fo), n && Dr(n, HTMLElement), this.providerMapClass = t.getMapClass(), this.wrapper = n, this.controlEnabled = !0, this.panHandler = () => null, this.panStartHandler = () => null, this.providerOptions = {};
  }
  /**
   * @param controlEnabled - Whether the user can interact with the map
   */
  withControlEnabled(t) {
    return this.controlEnabled = t, this;
  }
  /**
   * @param panHandler - Function called after the map bounds change
   */
  withPanHandler(t) {
    return $r(t, Or.FUNCTION), this.panHandler = t, this;
  }
  /**
   * @param panStartHandler - Function called before the map bounds change
   */
  withPanStartHandler(t) {
    return $r(t, Or.FUNCTION), this.panStartHandler = t, this;
  }
  /**
   * @param providerOptions - A free-form object used to set any additional provider-specific
   *   options, usually by passing the object to the map's constructor
   */
  withProviderOptions(t) {
    return this.providerOptions = t, this;
  }
  /**
   * @returns An instance of a subclass of {@link ProviderMap}
   *   for the given {@link MapProvider}
   */
  build() {
    const t = this.providerMapClass;
    return new t(this);
  }
}
class rl {
  constructor(t) {
    /**
     * The constructor creates a map instance using the provider's API and initializes it with all the
     * given options. See {@link ProviderMapOptions}
     * for the supported options.
     */
    Ie(this, "_panHandler");
    Ie(this, "_panStartHandler");
    Dr(t, pp), this._panHandler = t.panHandler, this._panStartHandler = t.panStartHandler;
  }
  /**
   * The current center of the map
   */
  getCenter() {
    throw new Error("not implemented");
  }
  /**
   * Zoom level complies with the specifications in {@link Map#getZoom}
   * @returns The current zoom level of the map
   */
  getZoom() {
    throw new Error("not implemented");
  }
  /**
   * @param coordinate - The new center for the map
   * @param animated - Whether to transition smoothly to the new center
   */
  setCenter(t, n) {
    throw new Error("not implemented");
  }
  /**
   * Zoom level complies with the specifications in {@link Map#getZoom}
   * @param zoom - The new zoom level for the map
   * @param animated - Whether to transition smoothly to the new zoom
   */
  setZoom(t, n) {
    throw new Error("not implemented");
  }
  /**
   * @param center - Must be convertible to {@link Coordinate}
   * @param animated - Whether to transition smoothly to the new bounds
   * @see ProviderMap#setZoom
   * @see ProviderMap#setCenter
   */
  setZoomCenter(t, n, r) {
    this.setZoom(t, r), this.setCenter(n, r);
  }
}
class mp {
  constructor(t) {
    Ie(this, "providerPinClass");
    Ie(this, "clickHandler");
    Ie(this, "focusHandler");
    Ie(this, "hoverHandler");
    Ie(this, "icons");
    Ie(this, "hasPinUrl");
    Dr(t, fo), this.providerPinClass = t.getPinClass(), this.clickHandler = () => null, this.focusHandler = (n) => null, this.hoverHandler = (n) => null, this.icons = {}, this.hasPinUrl = !1;
  }
  /**
   * @param clickHandler - Function called when the pin is clicked
   */
  withClickHandler(t) {
    return $r(t, Or.FUNCTION), this.clickHandler = t, this;
  }
  /**
   * @param focusHandler - Function called when the pin becomes (un)focused
   */
  withFocusHandler(t) {
    return $r(t, Or.FUNCTION), this.focusHandler = t, this;
  }
  /**
   * @param hoverHandler - Function called when the pin becomes (un)hovered
   */
  withHoverHandler(t) {
    return $r(t, Or.FUNCTION), this.hoverHandler = t, this;
  }
  /**
   * Similar to {@link MapPinOptions#withIcon},
   * but all icons are given as a map of key =\> icon. If a provider pin instance needs an icon to be
   * a specialized class rather than a simple URL, the icons in this object can be converted in this
   * function and assigned back to the icons object instead of being recreated from the URL every
   * time the pin's icon changes.
   * @param icons - Map of a string key to the URL or data URI of an image
   */
  withIcons(t) {
    return this.icons = t, this;
  }
  /**
   * @param hasPinUrl - Pass through from MapPin class
   * @returns
   */
  withHasPinUrl(t) {
    return this.hasPinUrl = t, this;
  }
  /**
   * @returns An instance of a subclass of {@link ProviderPin}
   *   for the given {@link MapProvider}
   */
  build() {
    const t = this.providerPinClass;
    return new t(this);
  }
}
class hd {
  /**
   * The constructor creates a pin instance using the provider's API and initializes it with all the
   * given options. See {@link ProviderPinOptions}
   * for the supported options.
   */
  constructor(t) {
    Ie(this, "_clickHandler");
    Ie(this, "_focusHandler");
    Ie(this, "_hoverHandler");
    Ie(this, "_icons");
    Dr(t, mp), this._clickHandler = t.clickHandler, this._focusHandler = t.focusHandler, this._hoverHandler = t.hoverHandler, this._icons = t.icons;
  }
  /**
   * @param coordinate - The position of the pin
   */
  setCoordinate(t) {
    throw new Error("not implemented");
  }
  /**
   * Remove the pin from its current map and, if newMap is not null, add it to the new map.
   * @param newMap - The new map -- if null, the pin will not be
   *   shown on any map
   * @param currentMap - The current map -- if null, the pin is
   *   not shown on any map
   */
  setMap(t, n) {
    throw new Error("not implemented");
  }
  /**
   * Apply the given properties to modify the appearance of the pin.
   * @see PinProperties
   */
  setProperties(t) {
    throw new Error("not implemented");
  }
}
const yN = Object.freeze({
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  left: "0",
  outline: "none",
  pointerEvents: "auto",
  position: "absolute",
  top: "0"
});
class il extends hd {
  /**
   * After instatiating a {@link ProviderPin}, this creates
   * a wrapper element and a default pin element.
   */
  constructor(n) {
    super(n);
    Ie(this, "_pinEl");
    Ie(this, "_pinAlt");
    Ie(this, "_wrapper");
    this._pinEl = n.hasPinUrl ? document.createElement("div") : document.createElement("button"), Object.assign(this._pinEl.style, il.baseStyle), this._pinAlt = document.createElement("span"), this._pinAlt.classList.add("sr-only"), this._pinEl.appendChild(this._pinAlt), this._wrapper = document.createElement("div"), this._wrapper.style.pointerEvents = "none", this._wrapper.appendChild(this._pinEl), this.addListeners();
  }
  /**
   * This is the base style applied to pin elements. It is a map from CSS property to value, such
   * as 'position': 'absolute'
   */
  static get baseStyle() {
    return yN;
  }
  /**
   * Adds click, hover, and focus event listeners to the wrapper element
   */
  addListeners() {
    this._wrapper && (this._wrapper.addEventListener("click", () => this._clickHandler()), this._wrapper.addEventListener("focusin", () => this._focusHandler(!0)), this._wrapper.addEventListener(
      "focusout",
      () => this._focusHandler(!1)
    ), this._wrapper.addEventListener(
      "mouseover",
      () => this._hoverHandler(!0)
    ), this._wrapper.addEventListener(
      "mouseout",
      () => this._hoverHandler(!1)
    ));
  }
  /**
   * @returns HTML button element for pin element
   */
  getPinElement() {
    return this._pinEl;
  }
  /**
   * @returns HTML button element for wrapper element
   */
  getWrapperElement() {
    return this._wrapper;
  }
  /**
   * @see ProviderPin#setProperties
   */
  setProperties(n) {
    this.setElementProperties(n);
    const r = n.getClass(), l = n.getElement() || this._pinEl, d = n.getZIndex();
    l.style.pointerEvents = "auto", this._wrapper && (this._wrapper.style.zIndex = d.toString(), this._wrapper.setAttribute("class", r), l !== this._wrapper.children[0] && (this._wrapper.children[0].style.pointerEvents = "", this._wrapper.removeChild(this._wrapper.children[0]), this._wrapper.appendChild(l)));
  }
  /**
   * Sets properties used specifically by the pin element
   */
  setElementProperties(n) {
    const r = n.getAnchorX(), l = n.getAnchorY(), d = n.getHeight(), f = this._icons[n.getIcon()], p = n.getSRText(), _ = n.getWidth();
    Object.assign(this._pinEl.style, {
      backgroundImage: f ? `url("${f}")` : "",
      height: d + "px",
      transform: `translate(${-100 * r}%, ${-100 * l}%)`,
      width: _ + "px"
    }), this._pinAlt.innerText = p;
  }
}
class uo {
  constructor() {
    Ie(this, "loadFunction");
    Ie(this, "mapClass");
    Ie(this, "pinClass");
    Ie(this, "providerName");
    this.loadFunction = (t, n, r, l) => t(), this.mapClass = rl, this.pinClass = hd, this.providerName = "";
  }
  withLoadFunction(t) {
    return $r(t, Or.FUNCTION), this.loadFunction = t, this;
  }
  /**
   * @param mapClass - Subclass of {@link ProviderMap}
   *   for the provider
   */
  withMapClass(t) {
    return this.mapClass = t, this;
  }
  /**
   * @param pinClass - Subclass of {@link ProviderPin} for the provider
   */
  withPinClass(t) {
    return this.pinClass = t, this;
  }
  /**
   * @param providerName - Name of the map provider
   */
  withProviderName(t) {
    return this.providerName = t, this;
  }
  build() {
    return new fo(this);
  }
}
class fo {
  constructor(t) {
    Ie(this, "_loadFunction");
    Ie(this, "_mapClass");
    Ie(this, "_pinClass");
    Ie(this, "_providerName");
    Ie(this, "_loadPromise");
    Ie(this, "_resolveLoad");
    Ie(this, "_rejectLoad");
    Ie(this, "_apiKey");
    Ie(this, "_loadInvoked");
    Ie(this, "_loaded");
    Ie(this, "_options");
    Dr(t, uo), this._loadFunction = t.loadFunction, this._mapClass = t.mapClass, this._pinClass = t.pinClass, this._providerName = t.providerName, this._loadPromise = new Promise((n, r) => {
      this._resolveLoad = n, this._rejectLoad = r;
    }), this._apiKey = "", this._loadInvoked = !1, this._loaded = !1, this._options = {};
  }
  /**
   * Returns true if the map provider has been successfully loaded
   */
  get loaded() {
    return this._loaded;
  }
  /**
   * @see ~MapProviderOptions#withMapClass
   */
  getMapClass() {
    return this._mapClass;
  }
  /**
   * @see MapProviderOptions#withPinClass
   */
  getPinClass() {
    return this._pinClass;
  }
  /**
   * @see MapProviderOptions#withProviderName
   */
  getProviderName() {
    return this._providerName;
  }
  /**
   * Call {@link loadFunction}
   * and resolve or reject when loading succeeds or fails
   * @param apiKey - Provider API key -- uses value from {@link MapProvider#setLoadOptions}
   *   if not passed
   * @param options - Additional provider-specific options -- uses value from {@link MapProvider#setLoadOptions}
   *   if not passed
   */
  async load(t = this._apiKey, n = this._options) {
    !this._loadInvoked && this._resolveLoad && this._rejectLoad && (this._loadInvoked = !0, this._loadFunction(this._resolveLoad, this._rejectLoad, t, n)), await this.ready(), this._loaded = !0;
  }
  /**
   * Resolves or rejects when the map provider has loaded successfully or unsuccessfully
   */
  async ready() {
    await this._loadPromise;
  }
  /**
   * Set the API key and provider options used on load. Does nothing if load was already called.
   * @param apiKey - Provider API key
   * @param options - Additional provider-specific options
   */
  setLoadOptions(t, n = null) {
    this._loadInvoked || (this._apiKey = t, this._options = n || this._options);
  }
}
class NN extends rl {
  constructor(n) {
    super(n);
    Ie(this, "map");
    Ie(this, "_moving");
    n.wrapper && (this.map = new google.maps.Map(n.wrapper, {
      disableDefaultUI: !n.controlEnabled,
      fullscreenControl: !1,
      gestureHandling: n.controlEnabled ? "auto" : "none",
      mapTypeControl: !1,
      rotateControl: !1,
      scaleControl: !1,
      streetViewControl: !1,
      zoomControl: n.controlEnabled,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      ...n.providerOptions
    }), this._moving = !1, google.maps.event.addListener(this.map, "bounds_changed", () => {
      this._moving || (this._moving = !0, this._panStartHandler());
    }), google.maps.event.addListener(this.map, "idle", () => {
      this._moving = !1, this._panHandler();
    }));
  }
  /**
   * {@inheritDoc ProviderMap.getCenter}
   */
  getCenter() {
    var n;
    return new fn(((n = this.map) == null ? void 0 : n.getCenter()) ?? { lat: 0, lng: 0 });
  }
  /**
   * {@inheritDoc ProviderMap.getZoom}
   */
  getZoom() {
    var n;
    return ((n = this.map) == null ? void 0 : n.getZoom()) ?? 0;
  }
  /**
   * {@inheritDoc ProviderMap.setCenter}
   */
  setCenter(n, r) {
    var d, f;
    const l = new google.maps.LatLng(
      n.latitude,
      n.longitude
    );
    r ? (d = this.map) == null || d.panTo(l) : (f = this.map) == null || f.setCenter(l);
  }
  /**
   * {@inheritDoc ProviderMap.setZoom}
   */
  setZoom(n, r) {
    var l;
    (l = this.map) == null || l.setZoom(Math.floor(n));
  }
  /**
   * {@inheritDoc ProviderMap.setZoomCenter}
   */
  setZoomCenter(n, r, l) {
    this.setCenter(r, l), this.setZoom(n, l);
  }
}
class CN extends il {
  constructor(n) {
    super(n);
    Ie(this, "_latLng");
    Ie(this, "pin");
    this._wrapper && (this._wrapper.style.position = "absolute", google.maps.OverlayView.preventMapHitsAndGesturesFrom(this._wrapper));
    class r extends google.maps.OverlayView {
      constructor(f) {
        super();
        Ie(this, "pin");
        this.pin = f;
      }
      draw() {
        var p;
        const f = (p = this.getProjection()) == null ? void 0 : p.fromLatLngToDivPixel(
          this.pin._latLng ?? null
        );
        f && this.pin._wrapper && (this.pin._wrapper.style.left = f.x + "px", this.pin._wrapper.style.top = f.y + "px");
      }
      onAdd() {
        var f;
        this.pin._wrapper && ((f = this.getPanes()) == null || f.floatPane.appendChild(this.pin._wrapper));
      }
      onRemove() {
        var f, p;
        (p = (f = this.pin._wrapper) == null ? void 0 : f.parentNode) == null || p.removeChild(this.pin._wrapper);
      }
    }
    this.pin = new r(this);
  }
  /**
   * {@inheritDoc HTMLProviderPin.setCoordinate}
   */
  setCoordinate(n) {
    this._latLng = new google.maps.LatLng(
      n.latitude,
      n.longitude
    ), this.pin.draw();
  }
  /**
   * {@inheritDoc HTMLProviderPin.setMap}
   */
  setMap(n, r) {
    var d;
    const l = (d = n == null ? void 0 : n.getProviderMap()) == null ? void 0 : d.map;
    this.pin.setMap(l ?? null);
  }
}
const wf = "GoogleMapsCallback_b7d77ff2", EN = "https://maps.googleapis.com/maps/api/js";
function TN(e, t, n, {
  autocomplete: r = !1,
  channel: l = window.location.hostname,
  client: d,
  language: f,
  region: p,
  libraries: _ = [],
  loading: E = "async",
  params: T = {}
} = {}) {
  window[wf] = e, r && _.push(
    "geocoder",
    "places"
    /* PLACES */
  );
  const S = {
    callback: wf,
    channel: l,
    libraries: _.join(","),
    ...T
  };
  n && (S.key = n), d && (S.client = d), f && (S.language = f), p && (S.region = p), E && (S.loading = E), gp(
    EN + "?" + Object.entries(S).map(([w, O]) => w + "=" + O).join("&")
  );
}
const xN = new uo().withLoadFunction(TN).withMapClass(NN).withPinClass(CN).withProviderName("Google").build();
class no {
  /**
   * @param sw - Southwest coordinate
   * @param ne - Northeast coordinate
   */
  constructor(t, n) {
    Ie(this, "_ne");
    Ie(this, "_sw");
    this._ne = new fn(n), this._sw = new fn(t);
  }
  /**
   * Create a new {@link GeoBounds} with minimal area that
   * contains all the given coordinates
   */
  static fit(t) {
    const n = t.map((E) => E.latitude), r = Math.max(...n), l = Math.min(...n), d = t.map((E) => E.normalLon).sort((E, T) => E - T), f = d.map((E, T) => ({ distance: (T < d.length - 1 ? d[T + 1] : d[0] + 360) - E, index: T })).reduce(
      (E, T) => T.distance > E.distance ? T : E
    ).index, p = d[f], _ = d[(f + 1) % d.length];
    return new this(new fn(l, _), new fn(r, p));
  }
  /**
   * Northeast coordinate
   */
  get ne() {
    return this._ne;
  }
  set ne(t) {
    this._ne = new fn(t);
  }
  /**
   * Southwest coordinate
   */
  get sw() {
    return this._sw;
  }
  set sw(t) {
    this._sw = new fn(t);
  }
  /**
   * Whether the coordinate lies within the region defined by the bounds.
   * {@link Normalized | longitudes} are used for the
   * bounds and the coordinate.
   */
  contains(t) {
    const n = this._sw.latitude <= t.latitude && t.latitude <= this._ne.latitude, r = this._ne.longitude - this._sw.longitude >= 360, l = this._sw.normalLon <= this._ne.normalLon ? this._sw.normalLon <= t.normalLon && t.normalLon <= this._ne.normalLon : this._sw.normalLon <= t.normalLon || t.normalLon <= this._ne.normalLon;
    return n && (r || l);
  }
  /**
   * Extend the bounds if necessary so that the coordinate is contained by them.
   */
  extend(t) {
    if (this._ne.latitude = Math.max(this._ne.latitude, t.latitude), this._sw.latitude = Math.min(this._sw.latitude, t.latitude), !this.contains(t)) {
      const n = ((t.longitude - this._ne.longitude) % 360 + 360) % 360, r = ((this._sw.longitude - t.longitude) % 360 + 360) % 360;
      n < r ? this._ne.longitude += n : this._sw.longitude -= r;
    }
  }
  /**
   * Calculate the center of the bounds using the given projection.
   * To find the visual center on a Mercator map, use Projection.MERCATOR.
   * To find the center for geolocation or geosearch purposes, use Projection.SPHERICAL.
   */
  getCenter(t = jr.SPHERICAL) {
    const n = new fn(this._ne.latitude, this._sw.longitude), r = this._sw.distanceTo(n, yn.DEGREE, t), l = (n.longitude + this._ne.longitude) / 2 + (this._ne.longitude < n.longitude ? 180 : 0);
    return n.add(-r / 2, 0, yn.DEGREE, t), n.longitude = l, n;
  }
}
class vN {
  constructor() {
    Ie(this, "_anchorX");
    Ie(this, "_anchorY");
    Ie(this, "_height");
    Ie(this, "_icon");
    Ie(this, "_srText");
    Ie(this, "_width");
    Ie(this, "_zIndex");
    Ie(this, "_class");
    Ie(this, "_element");
    this._anchorX = 0.5, this._anchorY = 1, this._height = 39, this._icon = "default", this._srText = "map pin", this._width = 33, this._zIndex = 0, this._class = "", this._element = null;
  }
  /**
   * @returns The point in the pin that should be positioned over the coordinate, from 0
   *   (left edge) to 1 (right edge)
   */
  getAnchorX() {
    return this._anchorX;
  }
  /**
   * @returns The point in the pin that should be positioned over the coordinate, from 0
   *   (top edge) to 1 (bottom edge)
   */
  getAnchorY() {
    return this._anchorY;
  }
  /**
   * {@link HTMLProviderPins} only
   * @returns The class of the wrapper element for an HTML pin
   */
  getClass() {
    return this._class;
  }
  /**
   * {@link HTMLProviderPins} only
   * @returns The HTML pin element
   */
  getElement() {
    return this._element;
  }
  /**
   * @returns The pixel height of the pin
   */
  getHeight() {
    return this._height;
  }
  /**
   * This returns a string key that can be used with {@link MapPin#getIcon}
   * to get the icon image for a pin.
   * @returns The unique name of the icon
   */
  getIcon() {
    return this._icon;
  }
  /**
   * @returns The text that a screen reader reads when focused on the pin
   */
  getSRText() {
    return this._srText;
  }
  /**
   * @returns The pixel width of the pin
   */
  getWidth() {
    return this._width;
  }
  /**
   * @returns The z-index of the pin
   */
  getZIndex() {
    return this._zIndex;
  }
  /**
   * @see PinProperties#getAnchorX
   */
  setAnchorX(t) {
    return this._anchorX = t, this;
  }
  /**
   * @see PinProperties#getAnchorY
   */
  setAnchorY(t) {
    return this._anchorY = t, this;
  }
  /**
   * @see PinProperties#getClass
   */
  setClass(t) {
    return this._class = t, this;
  }
  /**
   * @see PinProperties#getElement
   */
  setElement(t) {
    return this._element = t, this;
  }
  /**
   * @see PinProperties#getHeight
   */
  setHeight(t) {
    return this._height = t, this;
  }
  /**
   * @see PinProperties#getIcon
   */
  setIcon(t) {
    return this._icon = t, this;
  }
  /**
   * @see PinProperties#getSRText
   */
  setSRText(t) {
    return this._srText = t, this;
  }
  /**
   * @see PinProperties#getWidth
   */
  setWidth(t) {
    return this._width = t, this;
  }
  /**
   * @see PinProperties#getZIndex
   */
  setZIndex(t) {
    return this._zIndex = t, this;
  }
}
class gd {
  constructor() {
    /**
     * Initialize with default options
     */
    Ie(this, "coordinate");
    Ie(this, "hideOffscreen");
    Ie(this, "icons");
    Ie(this, "propertiesForStatus");
    Ie(this, "provider");
    Ie(this, "type");
    Ie(this, "hasPinUrl");
    this.coordinate = new fn(0, 0), this.hideOffscreen = !1, this.icons = {}, this.propertiesForStatus = (t) => new vN(), this.provider = null, this.type = "", this.hasPinUrl = !1;
  }
  /**
   * @param coordinate - Must be convertible to {@link Coordinate}
   */
  withCoordinate(t) {
    return this.coordinate = new fn(t), this;
  }
  /**
   * @param hideOffscreen - If true, the pin will only be rendered if it's in the visible
   *   portion of the map to improve performance
   */
  withHideOffscreen(t) {
    return this.hideOffscreen = t, this;
  }
  /**
   * @param key - The unique name for the icon, used in {@link PinProperties#getIcon}
   *   and {@link PinProperties#setIcon}
   * @param icon - The URL or data URI of the icon image
   */
  withIcon(t, n) {
    return this.icons[t] = n, this;
  }
  withPropertiesForStatus(t) {
    return $r(t, Or.FUNCTION), this.propertiesForStatus = t, this;
  }
  withProvider(t) {
    return t && (Dr(t, fo), this.provider = t), this;
  }
  /**
   * @param hasPinUrl - If true, the pin's HTML element will be a div instead of a button since there is a nested anchor tag within the pin. This will fix current accessibility issues.
   */
  withHasPinUrl(t) {
    return this.hasPinUrl = t, this;
  }
  /**
   * @param type - A string describing the type of the pin
   */
  withType(t) {
    return this.type = t, this;
  }
  build() {
    return new SN(this);
  }
}
class SN {
  constructor(t) {
    Ie(this, "_coordinate");
    Ie(this, "_hideOffscreen");
    Ie(this, "_icons");
    Ie(this, "_propertiesForStatus");
    Ie(this, "_type");
    Ie(this, "_clickHandler");
    Ie(this, "_focusHandler");
    Ie(this, "_hoverHandler");
    Ie(this, "_hidden");
    Ie(this, "_cancelHiddenUpdater");
    Ie(this, "_map");
    Ie(this, "_pin");
    Ie(this, "_status");
    var n, r;
    if (Dr(t, gd), t.provider && Dr(t.provider, fo), !((n = t.provider) != null && n.loaded))
      throw new Error(
        `MapProvider '${(r = t.provider) == null ? void 0 : r.getProviderName()}' is not loaded. The MapProvider must be loaded before calling MapPin constructor.`
      );
    this._coordinate = t.coordinate, this._hideOffscreen = t.hideOffscreen, this._icons = { ...t.icons }, this._propertiesForStatus = t.propertiesForStatus, this._type = t.type, this._clickHandler = () => null, this._focusHandler = (l) => this._hoverHandler(l), this._hoverHandler = (l) => null, this._hidden = !1, this._cancelHiddenUpdater = () => null, this._map = null, this._pin = new mp(t.provider).withIcons({ ...this._icons }).withClickHandler(() => this._clickHandler()).withFocusHandler((l) => this._focusHandler(l)).withHoverHandler((l) => this._hoverHandler(l)).withHasPinUrl(t.hasPinUrl).build(), this._pin.setCoordinate(t.coordinate), this._status = {}, this.setStatus(this._status);
  }
  /**
   * @returns The coordinate of the pin
   */
  getCoordinate() {
    return this._coordinate;
  }
  /**
   * Get the icon for a string key, such as 'default', 'hovered', or 'selected'
   * @param key - The unique name of the icon
   * @returns The URL or data URI of the icon image
   * @see MapPinOptions#withIcon
   */
  getIcon(t) {
    return this._icons[t];
  }
  /**
   * @returns The map that the pin is currently on, or null if
   * not on a map
   */
  getMap() {
    return this._map;
  }
  /**
   * Intended for internal use only
   * @returns The pin's {@link ProviderPin}
   *   instance
   */
  getProviderPin() {
    return this._pin;
  }
  /**
   * @returns The string describing the type of pin
   */
  getType() {
    return this._type;
  }
  /**
   * Remove this pin from its current map, if on one.
   */
  remove() {
    this.setMap(null);
  }
  /**
   * Set a handler function for when the pin is clicked, replacing any previously set click handler.
   */
  setClickHandler(t) {
    $r(t, Or.FUNCTION), this._clickHandler = t;
  }
  /**
   * @param coordinate - Must be convertible to {@link Coordinate}
   */
  setCoordinate(t) {
    this._coordinate = new fn(t), this._pin.setCoordinate(this._coordinate), this._hideOffscreen && this._hideIfOffscreen();
  }
  /**
   * Set a handler function for when the pin is (un)focused, replacing any previously set focus handler.
   */
  setFocusHandler(t) {
    $r(t, Or.FUNCTION), this._focusHandler = t;
  }
  /**
   * Set a handler function for when the pin is (un)hovered, replacing any previously set hover handler.
   */
  setHoverHandler(t) {
    $r(t, Or.FUNCTION), this._hoverHandler = t;
  }
  /**
   * Add the pin to a map, removing it from its current map if on one.
   */
  setMap(t) {
    if (t !== this._map && (t !== null && Dr(t, yp), this._pin.setMap(t, this._hidden ? null : this._map), this._map = t, this._hidden = !1, this._cancelHiddenUpdater(), t && this._hideOffscreen)) {
      let n = !1;
      const r = new Promise((l) => {
        this._cancelHiddenUpdater = () => {
          n = !0, l();
        };
      });
      (async () => {
        for (; !n; )
          this._hideIfOffscreen(), await Promise.race([r, t.moving()]), await Promise.race([r, t.idle()]);
      })();
    }
  }
  /**
   * Assign all properties in an object to the pin's status.
   * Example: if the pin's status is \{ a: true, b: true \}, passing in \{ a: false, c: true \} will
   * change the pin's status to \{ a: false, b: true, c: true \}
   */
  setStatus(t) {
    Object.assign(this._status, t), this._pin.setProperties(this._propertiesForStatus(this._status));
  }
  /**
   * Add or remove the pin from the map based on whether its coordinate is within the current bounds
   */
  _hideIfOffscreen() {
    if (this._map) {
      const t = this._map.getBounds().contains(this._coordinate);
      this._hidden && t ? this._pin.setMap(this._map, null) : !this._hidden && !t && this._pin.setMap(null, this._map), this._hidden = !t;
    }
  }
}
const ys = 0.98;
function Ja(e, t) {
  return Math.max(e instanceof Function ? e() : e || 0, 0) / t;
}
class _p {
  /**
   * Initialize with default options
   */
  constructor() {
    Ie(this, "controlEnabled");
    Ie(this, "defaultCenter");
    Ie(this, "defaultZoom");
    Ie(this, "legendPins");
    Ie(this, "padding");
    Ie(this, "panHandler");
    Ie(this, "panStartHandler");
    Ie(this, "provider");
    Ie(this, "providerOptions");
    Ie(this, "singlePinZoom");
    Ie(this, "wrapper");
    this.controlEnabled = !0, this.defaultCenter = new fn(39.83, -98.58), this.defaultZoom = 4, this.legendPins = [], this.padding = {
      bottom: () => 50,
      left: () => 50,
      right: () => 50,
      top: () => 50
    }, this.panHandler = (t, n) => null, this.panStartHandler = (t) => null, this.provider = null, this.providerOptions = {}, this.singlePinZoom = 14, this.wrapper = null;
  }
  /**
   * @param controlEnabled - Whether the user can move and zoom the map
   */
  withControlEnabled(t) {
    return this.controlEnabled = t, this;
  }
  /**
   * @param defaultCenter - The center on initial load and
   *   when calling {@link Map#fitCoordinates} with an empty array
   */
  withDefaultCenter(t) {
    return this.defaultCenter = new fn(t), this;
  }
  /**
   * @param defaultZoom - The zoom on initial load and when calling {@link Map#fitCoordinates}
   *   with an empty array
   */
  withDefaultZoom(t) {
    return this.defaultZoom = t, this;
  }
  /**
   * GENERATOR TODO Map legend not yet implemented
   * @param legendPins - Pins used to construct the map legend
   */
  withLegendPins(t) {
    return this.legendPins = Array.from(t), this;
  }
  /**
   * Padding is used by {@link Map#fitCoordinates}.
   * Padding can either be constant values or funtions that return a padding value.
   * See {@link Map#setPadding} for more information.
   * @see {@link Map#setPadding}
   */
  withPadding(t) {
    return this.padding = t, this;
  }
  withPanHandler(t) {
    return $r(t, Or.FUNCTION), this.panHandler = t, this;
  }
  withPanStartHandler(t) {
    return $r(t, Or.FUNCTION), this.panStartHandler = t, this;
  }
  /**
   * The {@link MapProvider} must be loaded before
   * constructing the {@link Map}.
   */
  withProvider(t) {
    return Dr(t, fo), this.provider = t, this;
  }
  /**
   * @param providerOptions - A free-form object used to set any additional provider-specific
   *   options in the {@link ProviderMap}
   */
  withProviderOptions(t) {
    return this.providerOptions = t, this;
  }
  /**
   * @param singlePinZoom - The zoom when calling {@link Map#fitCoordinates}
   *   with an array containing one coordinate
   */
  withSinglePinZoom(t) {
    return this.singlePinZoom = t, this;
  }
  /**
   * @param wrapper - The wrapper element that the map will be inserted into. The
   *   existing contents of the element will be removed.
   */
  withWrapper(t) {
    return t ? (Dr(t, HTMLElement), this.wrapper = t, this) : this;
  }
  build() {
    return new yp(this);
  }
}
let yp = class {
  constructor(t) {
    /**
     * The {@link MapProvider} for the map must be loaded
     * before calling this constructor.
     */
    Ie(this, "_defaultCenter");
    Ie(this, "_defaultZoom");
    Ie(this, "_legendPins");
    Ie(this, "_padding");
    Ie(this, "_provider");
    Ie(this, "_singlePinZoom");
    Ie(this, "_wrapper");
    Ie(this, "_cachedBounds");
    Ie(this, "_resolveIdle");
    Ie(this, "_resolveMoving");
    Ie(this, "_idlePromise");
    Ie(this, "_panHandlerRunning");
    Ie(this, "_panStartHandlerRunning");
    Ie(this, "_currentBounds");
    Ie(this, "_movingPromise");
    Ie(this, "_panHandler");
    Ie(this, "_panStartHandler");
    Ie(this, "_map");
    var n, r, l;
    if (Dr(t, _p), t.provider && Dr(t.provider, fo), t.wrapper && Dr(t.wrapper, HTMLElement), !((n = t.provider) != null && n.loaded))
      throw new Error(
        `MapProvider '${(r = t.provider) == null ? void 0 : r.getProviderName()}' is not loaded. The MapProvider must be loaded before calling Map constructor.`
      );
    for (this._defaultCenter = t.defaultCenter, this._defaultZoom = t.defaultZoom, this._legendPins = t.legendPins, this._provider = t.provider, this._singlePinZoom = t.singlePinZoom, this._wrapper = t.wrapper, this._padding = {}, this.setPadding(t.padding), this._cachedBounds = null, this._resolveIdle = () => null, this._resolveMoving = () => null, this._idlePromise = Promise.resolve(), this._setIdle(), this.setPanHandler(t.panHandler), this.setPanStartHandler(t.panStartHandler); (l = this._wrapper) != null && l.lastChild; )
      this._wrapper.removeChild(this._wrapper.lastChild);
    this._panHandlerRunning = !1, this._panStartHandlerRunning = !1, this._map = new pp(t.provider, this._wrapper).withControlEnabled(t.controlEnabled).withPanHandler(() => this.panHandler()).withPanStartHandler(() => this.panStartHandler()).withProviderOptions(t.providerOptions).build(), this.setZoomCenter(this._defaultZoom, this._defaultCenter), this._currentBounds = this.getBounds();
  }
  /**
   * Set the map bounds so that all the given coordinates are within the {@link padded}
   * view.
   * @param animated - Whether to transition smoothly to the new bounds
   * @param maxZoom - The max zoom level after fitting. Uses {@link singlePinZoom}
   *   by default.
   */
  fitCoordinates(t, n = !1, r = this._singlePinZoom) {
    t.length ? this.setBounds(
      no.fit(t),
      n,
      this._padding,
      r
    ) : this.setZoomCenter(this._defaultZoom, this._defaultCenter, n);
  }
  /**
   * Get the current visible region of the map. If the map is zoomed out to show multiple copies of
   * the world, the longitude bounds will be outside [-180, 180) but the center will always be
   * within [-180, 180).
   */
  getBounds() {
    var t, n;
    if (!this._cachedBounds) {
      const r = ((t = this._wrapper) == null ? void 0 : t.offsetHeight) ?? 0, l = ((n = this._wrapper) == null ? void 0 : n.offsetWidth) ?? 0, d = this.getZoom(), f = this.getCenter(), p = 360 / Math.pow(2, d + 8), _ = l * p, E = r * p;
      this._cachedBounds = new no(f, f), this._cachedBounds.ne.add(
        E / 2,
        _ / 2,
        yn.DEGREE,
        jr.MERCATOR
      ), this._cachedBounds.sw.add(
        -E / 2,
        -_ / 2,
        yn.DEGREE,
        jr.MERCATOR
      ), this.moving().then(() => this._cachedBounds = null);
    }
    return new no(this._cachedBounds.sw, this._cachedBounds.ne);
  }
  /**
   * @returns The center of the current visible region of
   *   the map
   */
  getCenter() {
    return this._map.getCenter();
  }
  /**
   * Intended for internal use only
   * @returns The map's {@link ProviderMap}
   *   instance
   */
  getProviderMap() {
    return this._map;
  }
  /**
   * To standardize zoom for all providers, zoom level is calculated with this formula:
   * zoom = log2(pixel width of equator) - 8.
   * At zoom = 0, the entire world is 256 pixels wide.
   * At zoom = 1, the entire world is 512 pixels wide.
   * Zoom 2 → 1024 pixels, zoom 3 → 2056 pixels, etc.
   * Negative and non-integer zoom levels are valid and follow the formula.
   * @returns The current zoom level of the map
   */
  getZoom() {
    return this._map.getZoom();
  }
  /**
   * Returns when the map is not moving.
   * Use map.idle().then(callback) to run callback immediately if the map is currently idle or once
   * the map becomes idle if it's not.
   */
  async idle() {
    await this._idlePromise;
  }
  /**
   * Returns when the map is moving.
   * Use map.moving().then(callback) to run callback immediately if the map is currently moving or
   * once the map starts moving if it's not.
   */
  async moving() {
    await this._movingPromise;
  }
  /**
   * @returns A {@link MapPinOptions}
   *   instance with the same provider as this map
   */
  newPinOptions() {
    return new gd().withProvider(this._provider);
  }
  /**
   * Called when the map has finished moving, at most once per animation frame.
   * Passes the current and previous bounds to the custom pan handler given by {@link MapOptions#withPanHandler}
   */
  panHandler() {
    this._panHandlerRunning || (this._panHandlerRunning = !0, requestAnimationFrame(() => {
      const t = this._currentBounds;
      this._currentBounds = this.getBounds(), this._panHandler && this._panHandler(
        t,
        new no(
          new fn(this._currentBounds.sw),
          new fn(this._currentBounds.ne)
        )
      ), this._panHandlerRunning = !1;
    }), this._setIdle());
  }
  /**
   * Called when the map has started moving, at most once per animation frame.
   * Passes the current bounds to the custom pan handler given by {@link MapOptions#withPanStartHandler}
   */
  panStartHandler() {
    this._panStartHandlerRunning || (this._panStartHandlerRunning = !0, requestAnimationFrame(() => {
      this._panStartHandler && this._panStartHandler(
        new no(
          new fn(this._currentBounds.sw),
          new fn(this._currentBounds.ne)
        )
      ), this._panStartHandlerRunning = !1;
    }), this._setMoving());
  }
  /**
   * @param bounds - bounds.ne: The northeast corner of the bounds -- must be convertible to {@link Coordinate}
   * bounds.se: The southwest corner of the bounds -- must be convertible to {@link Coordinate}
   * @param animated - Whether to transition smoothly to the new bounds
   * @param padding - padding.bottom: Minimum number of pixels between the map's bottom edge and a pin
   * padding.left: Minimum number of pixels between the map's left edge and a pin
   * padding.right: Minimum number of pixels between the map's right edge and a pin
   * padding.top: Minimum number of pixels between the map's top edge and a pin
   */
  setBounds({ ne: t, sw: n }, r = !1, l = {}, d = 1 / 0) {
    var z, q;
    const f = (z = this._wrapper) == null ? void 0 : z.offsetHeight, p = (q = this._wrapper) == null ? void 0 : q.offsetWidth;
    if (!f || !p)
      return;
    let _ = Ja(l.bottom, f), E = Ja(l.left, p), T = Ja(l.right, p), S = Ja(l.top, f), w = E + T, O = _ + S;
    w > ys && (E *= ys / w, T *= ys / w, w = ys), O > ys && (_ *= ys / O, S *= ys / O, O = ys);
    const m = f * (1 - O), v = p * (1 - w), I = new no(n, t), G = new fn(I.ne.latitude, I.sw.longitude), k = I.sw.distanceTo(G, yn.DEGREE, jr.MERCATOR), P = (I.ne.longitude - G.longitude + 360) % 360;
    let H = Math.max(k, P * m / v) / (1 - O), j = Math.max(P, k * v / m) / (1 - w), re = Math.log2(p * 360 / j) - 8;
    re > d && (re = d, j = p * 360 / 2 ** (re + 8), H = j * f / p);
    const te = I.getCenter(jr.MERCATOR), ce = (S - _) / 2 * H, V = (T - E) / 2 * j;
    te.add(ce, V, yn.DEGREE, jr.MERCATOR), this.setZoomCenter(re, te, r);
  }
  /**
   * @param coordinate - Must be convertible to {@link Coordinate}
   * @param animated - Whether to transition smoothly to the new center
   */
  setCenter(t, n = !1) {
    this._map.setCenter(new fn(t), n);
  }
  /**
   * Padding is used by {@link Map#fitCoordinates}.
   * Padding can either be constant values or funtions that return a padding value.
   * Constant values are good if the map should always have the same padding on every breakpoint.
   * Functions are useful if the map should have different padding at different breakpoints/layouts.
   * The function can check window.innerWidth or any other condition before returning a number.
   * @param padding - padding.bottom: Minimum number of pixels between the map's bottom edge and a pin
   * padding.left: Minimum number of pixels between the map's left edge and a pin
   * padding.right: Minimum number of pixels between the map's right edge and a pin
   * padding.top: Minimum number of pixels between the map's top edge and a pin
   */
  setPadding({
    bottom: t = this._padding.bottom,
    left: n = this._padding.left,
    right: r = this._padding.right,
    top: l = this._padding.top
  }) {
    return this._padding = { bottom: t, left: n, right: r, top: l }, this;
  }
  setPanHandler(t) {
    $r(t, Or.FUNCTION), this._panHandler = t;
  }
  setPanStartHandler(t) {
    $r(t, Or.FUNCTION), this._panStartHandler = t;
  }
  /**
   * @param animated - Whether to transition smoothly to the new zoom
   * @see Map#getZoom
   */
  setZoom(t, n = !1) {
    this._map.setZoom(t, n);
  }
  /**
   * @param center - Must be convertible to {@link Coordinate}
   * @param animated - Whether to transition smoothly to the new bounds
   * @see Map#setZoom
   * @see Map#setCenter
   */
  setZoomCenter(t, n, r = !1) {
    this._map.setZoomCenter(t, n, r);
  }
  /**
   * Set the map state to idle
   */
  _setIdle() {
    this._resolveMoving(), this._movingPromise = new Promise(
      (t) => this._resolveMoving = t
    ), this._resolveIdle();
  }
  /**
   * Set the map state to moving
   */
  _setMoving() {
    this._resolveIdle(), this._idlePromise = new Promise((t) => this._resolveIdle = t), this._resolveMoving();
  }
};
const Tc = Ec(null);
function sw() {
  const e = co(Tc);
  if (!e || e.map === void 0)
    throw new Error("Attempted to call useMapContext() outside of <Map>.");
  return e.map;
}
const wN = ({
  apiKey: e,
  bounds: t,
  children: n,
  className: r,
  clientKey: l,
  controls: d = !0,
  defaultCenter: f = { latitude: 39.83, longitude: -98.58 },
  defaultZoom: p = 4,
  mapRef: _,
  padding: E = { bottom: 50, left: 50, right: 50, top: 50 },
  panHandler: T = () => null,
  panStartHandler: S = () => null,
  provider: w = xN,
  providerOptions: O = {},
  singleZoom: m = 14
}) => {
  const v = dd(null), [I, G] = Nr(new fn(f)), [k, P] = Nr(!1), [H, j] = Nr(), [re, te] = Nr(p), ce = (V, z) => {
    T(V, z), z && G(z.getCenter());
  };
  return tr(() => {
    !k || !H || te(H.getZoom());
  }, [I]), tr(() => {
    if (!t || !k || !H)
      return;
    const V = t.map((z) => new fn(z));
    H.fitCoordinates(V);
  }, [JSON.stringify(t), H]), tr(() => {
    if (!k || H)
      return;
    const V = new _p().withControlEnabled(d).withDefaultCenter(I).withDefaultZoom(re).withPadding(E).withPanHandler(ce).withPanStartHandler(S).withProvider(w).withProviderOptions(O).withSinglePinZoom(m).withWrapper(v.current).build();
    j(V), _ && (_.current = V);
  }, [k]), tr(() => {
    k || H || !v.current || w.load(e, {
      ...O,
      ...l && { client: l }
    }).then(() => P(!0));
  }, []), /* @__PURE__ */ nt.jsx(
    "div",
    {
      className: el(
        {
          "is-loaded": k
        },
        r
      ),
      id: "map",
      ref: v,
      "data-testid": "map",
      children: H && /* @__PURE__ */ nt.jsx(Tc.Provider, { value: { map: H, provider: w }, children: n })
    }
  );
}, ON = ({ count: e }) => /* @__PURE__ */ nt.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    children: /* @__PURE__ */ nt.jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ nt.jsx(
        "circle",
        {
          fill: "red",
          fillRule: "nonzero",
          stroke: "white",
          cx: "11",
          cy: "11",
          r: "11"
        }
      ),
      /* @__PURE__ */ nt.jsx(
        "text",
        {
          fill: "white",
          fontFamily: "Arial-BoldMT,Arial",
          fontSize: "12",
          fontWeight: "bold",
          children: /* @__PURE__ */ nt.jsx("tspan", { x: "50%", y: "15", textAnchor: "middle", children: e })
        }
      )
    ] })
  }
), pd = Ec(
  null
);
function ow() {
  const e = co(pd);
  if (!e)
    throw new Error(
      "Attempted to call useClustererContext() outside of <Clusterer>."
    );
  return e;
}
const lw = ({
  clusterRadius: e = 50,
  children: t,
  ClusterTemplate: n = ON
}) => {
  const { map: r } = co(Tc), [l, d] = Nr([]), [f, p] = Nr(), [_, E] = Nr([]), [T, S] = Nr([]);
  return tr(() => {
    p(DN(l, r.getZoom(), e));
  }, [l, r.getZoom()]), tr(() => {
    S(() => []), E(() => []), (f == null ? void 0 : f.length) !== 0 && (f == null || f.forEach((w) => {
      if (w.length === 1) {
        w[0].pin.setMap(r);
        return;
      }
      if (w.length > 1) {
        const O = no.fit(
          w.map((v) => v.pin.getCoordinate())
        ).getCenter(jr.MERCATOR), m = `cluster-{${O._lat},${O._lon}}`;
        w.forEach((v) => v.pin.setMap(null)), E((v) => [...v, m]), S((v) => [
          ...v,
          /* @__PURE__ */ nt.jsx(
            Np,
            {
              coordinate: O,
              id: m,
              onClick: () => r.fitCoordinates(
                w.map((I) => I.pin.getCoordinate()),
                !0,
                1 / 0
              ),
              children: /* @__PURE__ */ nt.jsx(n, { count: w.length })
            },
            m
          )
        ]);
      }
    }));
  }, [f]), /* @__PURE__ */ nt.jsx(
    pd.Provider,
    {
      value: {
        clusters: f ?? [],
        clusterIds: _,
        setPinStore: d
      },
      children: /* @__PURE__ */ nt.jsxs(nt.Fragment, { children: [
        T.map((w, O) => /* @__PURE__ */ nt.jsx(ey, { children: w }, O)),
        t
      ] })
    }
  );
}, DN = (e, t, n) => {
  const r = n * Math.PI / 2 ** (t + 7), l = e.map((p, _) => [_]), d = [];
  e.forEach((p, _) => {
    for (let E = _; E < e.length; E++)
      E !== _ && new fn(p.pin.getCoordinate()).distanceTo(
        new fn(e[E].pin.getCoordinate()),
        yn.RADIAN,
        jr.MERCATOR
      ) <= r && (l[_].push(E), l[E].push(_));
  });
  let f = 1;
  for (; f; ) {
    f = 0;
    let p;
    if (l.forEach((T, S) => {
      T.length > f && (f = T.length, p = S);
    }), !f)
      break;
    const _ = l[p ?? 0], E = [];
    l[p ?? 0] = [];
    for (const T of _) {
      const S = l[T];
      E.push(e[T]), l[T] = [], S.forEach(
        (w) => l[w].splice(
          l[w].indexOf(T),
          1
        )
      );
    }
    d.push(E);
  }
  return d;
}, AN = /* @__PURE__ */ nt.jsx(
  "svg",
  {
    width: "30",
    height: "38",
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ nt.jsx(
      "path",
      {
        d: "M30 15.0882C30 23.4212 23.3333 30.7353 15 38C7.22222 31.2941 0 23.4212 0 15.0882C0 6.75523 6.71573 0 15 0C23.2843 0 30 6.75523 30 15.0882Z",
        fill: "red"
      }
    )
  }
), Np = ({
  children: e,
  coordinate: t,
  hideOffscreen: n = !1,
  id: r,
  icon: l = AN,
  onClick: d = () => null,
  onFocus: f = () => null,
  onHover: p = () => null,
  zIndex: _,
  hasPinUrl: E = !1
}) => {
  const { map: T, provider: S } = co(Tc), w = co(pd), O = ip(() => new gd().withCoordinate(t).withHideOffscreen(n).withProvider(S).withHasPinUrl(E).build(), []);
  tr(() => {
    if (_ !== 0 && !_)
      return;
    const v = O.getProviderPin().getWrapperElement();
    v && (v.style.zIndex = _.toString());
  }, [_]), tr(() => {
    O.setMap(T), O.setClickHandler(() => d(r)), O.setFocusHandler((I) => f(I, r)), O.setHoverHandler((I) => p(I, r));
    const v = w == null ? void 0 : w.clusterIds.includes(r);
    return w && !v && w.setPinStore((I) => [
      ...I,
      {
        pin: O,
        id: r
      }
    ]), () => {
      O.setMap(null), w && w.setPinStore(
        (I) => I.filter((G) => G.id !== r)
      );
    };
  }, []);
  const m = e || l;
  if (m) {
    const v = O.getProviderPin().getPinElement();
    return Object.assign(v.style, {
      height: "auto",
      width: "auto"
    }), ty(m, v);
  }
  return null;
}, aw = ({
  children: e,
  coordinate: t,
  linkSameTab: n,
  pinUrl: r,
  onClick: l = () => null,
  onHover: d = () => null,
  onFocus: f = () => null,
  ...p
}) => {
  var _;
  return /* @__PURE__ */ nt.jsx(wN, { bounds: [t], ...p, children: /* @__PURE__ */ nt.jsx(
    Np,
    {
      coordinate: t,
      id: "location-map-marker",
      onClick: l,
      onHover: d,
      onFocus: f,
      hasPinUrl: ((_ = r || "") == null ? void 0 : _.length) > 0,
      children: r ? /* @__PURE__ */ nt.jsx(
        fN,
        {
          href: r,
          target: n ? "_self" : "_blank",
          "aria-label": "map-marker",
          children: e
        }
      ) : e || void 0
    }
  ) });
};
var Xc = {}, jl = {}, Of;
function MN() {
  if (Of) return jl;
  Of = 1;
  var e = xn;
  const t = /* @__PURE__ */ e.createContext(null);
  function n(l, d) {
    let f = null;
    l != null && (f = l[1]);
    function p() {
      return d ?? (f != null ? f.getTheme() : null);
    }
    return {
      getTheme: p
    };
  }
  function r() {
    const l = e.useContext(t);
    if (l == null)
      throw Error("LexicalComposerContext.useLexicalComposerContext: cannot find a LexicalComposerContext");
    return l;
  }
  return jl.LexicalComposerContext = t, jl.createLexicalComposerContext = n, jl.useLexicalComposerContext = r, jl;
}
var Vl = {}, Df;
function RN() {
  if (Df) return Vl;
  Df = 1;
  var e = xn;
  function t(r) {
    let l = new URLSearchParams();
    l.append("code", r);
    for (let d = 1; d < arguments.length; d++) l.append("v", arguments[d]);
    throw Error(`Minified Lexical error #${r}; visit https://lexical.dev/docs/error?${l} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  let n = e.createContext(null);
  return Vl.LexicalComposerContext = n, Vl.createLexicalComposerContext = function(r, l) {
    let d = null;
    return r != null && (d = r[1]), { getTheme: function() {
      return l ?? (d != null ? d.getTheme() : null);
    } };
  }, Vl.useLexicalComposerContext = function() {
    let r = e.useContext(n);
    return r == null && t(8), r;
  }, Vl;
}
var Qc, Af;
function qn() {
  return Af || (Af = 1, Qc = process.env.NODE_ENV === "development" ? MN() : RN()), Qc;
}
var He = {}, Mf;
function bN() {
  if (Mf) return He;
  Mf = 1;
  function e(u) {
    return {
      type: u
    };
  }
  const t = e("SELECTION_CHANGE_COMMAND"), n = e("SELECTION_INSERT_CLIPBOARD_NODES_COMMAND"), r = e("CLICK_COMMAND"), l = e("DELETE_CHARACTER_COMMAND"), d = e("INSERT_LINE_BREAK_COMMAND"), f = e("INSERT_PARAGRAPH_COMMAND"), p = e("CONTROLLED_TEXT_INSERTION_COMMAND"), _ = e("PASTE_COMMAND"), E = e("REMOVE_TEXT_COMMAND"), T = e("DELETE_WORD_COMMAND"), S = e("DELETE_LINE_COMMAND"), w = e("FORMAT_TEXT_COMMAND"), O = e("UNDO_COMMAND"), m = e("REDO_COMMAND"), v = e("KEYDOWN_COMMAND"), I = e("KEY_ARROW_RIGHT_COMMAND"), G = e("MOVE_TO_END"), k = e("KEY_ARROW_LEFT_COMMAND"), P = e("MOVE_TO_START"), H = e("KEY_ARROW_UP_COMMAND"), j = e("KEY_ARROW_DOWN_COMMAND"), re = e("KEY_ENTER_COMMAND"), te = e("KEY_SPACE_COMMAND"), ce = e("KEY_BACKSPACE_COMMAND"), V = e("KEY_ESCAPE_COMMAND"), z = e("KEY_DELETE_COMMAND"), q = e("KEY_TAB_COMMAND"), Te = e("INSERT_TAB_COMMAND"), Se = e("INDENT_CONTENT_COMMAND"), Ee = e("OUTDENT_CONTENT_COMMAND"), de = e("DROP_COMMAND"), K = e("FORMAT_ELEMENT_COMMAND"), D = e("DRAGSTART_COMMAND"), Z = e("DRAGOVER_COMMAND"), oe = e("DRAGEND_COMMAND"), Y = e("COPY_COMMAND"), W = e("CUT_COMMAND"), J = e("SELECT_ALL_COMMAND"), R = e("CLEAR_EDITOR_COMMAND"), U = e("CLEAR_HISTORY_COMMAND"), X = e("CAN_REDO_COMMAND"), fe = e("CAN_UNDO_COMMAND"), _e = e("FOCUS_COMMAND"), B = e("BLUR_COMMAND"), M = e("KEY_MODIFIER_COMMAND"), F = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", se = F && "documentMode" in document ? document.documentMode : null, ye = F && /Mac|iPod|iPhone|iPad/.test(navigator.platform), De = F && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), ee = F && "InputEvent" in window && !se ? "getTargetRanges" in new window.InputEvent("input") : !1, ne = F && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), ue = F && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, be = F && /Android/.test(navigator.userAgent), Ne = F && /^(?=.*Chrome).*/i.test(navigator.userAgent), Re = F && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !Ne, ke = 1, Fe = 3, qe = 0, Be = 1, ct = 2, Dt = 0, zt = 1, en = 2, Oe = 1, ie = 2, le = 4, ve = 8, Le = 16, Me = 32, je = 64, rt = 128, it = Oe | ie | le | ve | Le | Me | je | rt, st = 1, vt = 2, Ge = 1, ze = 2, tt = 3, _t = 4, yt = 5, Ct = 6, ht = " ", pt = ne || ue || Re ? ht : "​", Pt = `

`, Wt = De ? ht : pt, tn = "֑-߿יִ-﷽ﹰ-ﻼ", Lt = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", jt = new RegExp("^[^" + Lt + "]*[" + tn + "]"), Rt = new RegExp("^[^" + tn + "]*[" + Lt + "]"), nn = {
    bold: Oe,
    code: Le,
    highlight: rt,
    italic: ie,
    strikethrough: le,
    subscript: Me,
    superscript: je,
    underline: ve
  }, Ar = {
    directionless: st,
    unmergeable: vt
  }, Ni = {
    center: ze,
    end: Ct,
    justify: _t,
    left: Ge,
    right: tt,
    start: yt
  }, pe = {
    [ze]: "center",
    [Ct]: "end",
    [_t]: "justify",
    [Ge]: "left",
    [tt]: "right",
    [yt]: "start"
  }, Ze = {
    normal: Dt,
    segmented: en,
    token: zt
  }, ot = {
    [Dt]: "normal",
    [en]: "segmented",
    [zt]: "token"
  }, St = 100;
  let Ut = !1, Ft = 0;
  function kt() {
    return Ut;
  }
  function It(u) {
    Ft = u.timeStamp;
  }
  function Bt(u) {
    Ft === 0 && To(u).addEventListener("textInput", It, !0);
  }
  function sn(u, s, c) {
    return (
      // @ts-expect-error: internal field
      s.__lexicalLineBreak === u || // @ts-ignore We intentionally add this to the Node.
      u[`__lexicalKey_${c._key}`] !== void 0
    );
  }
  function ln(u) {
    return u.getEditorState().read(() => {
      const s = mn();
      return s !== null ? s.clone() : null;
    });
  }
  function bn(u, s, c) {
    const h = cr(c._window);
    let y = null, N = null;
    h !== null && h.anchorNode === u && (y = h.anchorOffset, N = h.focusOffset);
    const b = u.nodeValue;
    b !== null && Br(s, b, y, N, !1);
  }
  function Cr(u, s, c) {
    if (Et(u)) {
      const h = u.anchor.getNode();
      if (h.is(c) && u.format !== h.getFormat())
        return !1;
    }
    return s.nodeType === Fe && c.isAttached();
  }
  function Zn(u, s, c) {
    Ut = !0;
    const h = performance.now() - Ft > St;
    try {
      Gr(u, () => {
        const y = mn() || ln(u), N = /* @__PURE__ */ new Map(), b = u.getRootElement(), $ = u._editorState, ae = u._blockCursorElement;
        let he = !1, me = "";
        for (let we = 0; we < s.length; we++) {
          const Ce = s[we], Ve = Ce.type, Ue = Ce.target;
          let $e = oi(Ue, $);
          if (!($e === null && Ue !== b || An($e))) {
            if (Ve === "characterData")
              h && mt($e) && Cr(y, Ue, $e) && bn(
                // nodeType === DOM_TEXT_TYPE is a Text DOM node
                Ue,
                $e,
                u
              );
            else if (Ve === "childList") {
              he = !0;
              const Mt = Ce.addedNodes;
              for (let qt = 0; qt < Mt.length; qt++) {
                const Ht = Mt[qt], Ot = mo(Ht), an = Ht.parentNode;
                if (an != null && Ht !== ae && Ot === null && (Ht.nodeName !== "BR" || !sn(Ht, an, u))) {
                  if (De) {
                    const sr = Ht.innerText || Ht.nodeValue;
                    sr && (me += sr);
                  }
                  an.removeChild(Ht);
                }
              }
              const Qe = Ce.removedNodes, ft = Qe.length;
              if (ft > 0) {
                let qt = 0;
                for (let Ht = 0; Ht < ft; Ht++) {
                  const Ot = Qe[Ht];
                  (Ot.nodeName === "BR" && sn(Ot, Ue, u) || ae === Ot) && (Ue.appendChild(Ot), qt++);
                }
                ft !== qt && (Ue === b && ($e = pl($)), N.set(Ue, $e));
              }
            }
          }
        }
        if (N.size > 0)
          for (const [we, Ce] of N)
            if (et(Ce)) {
              const Ve = Ce.getChildrenKeys();
              let Ue = we.firstChild;
              for (let $e = 0; $e < Ve.length; $e++) {
                const Mt = Ve[$e], Qe = u.getElementByKey(Mt);
                Qe !== null && (Ue == null ? (we.appendChild(Qe), Ue = Qe) : Ue !== Qe && we.replaceChild(Qe, Ue), Ue = Ue.nextSibling);
              }
            } else mt(Ce) && Ce.markDirty();
        const xe = c.takeRecords();
        if (xe.length > 0) {
          for (let we = 0; we < xe.length; we++) {
            const Ce = xe[we], Ve = Ce.addedNodes, Ue = Ce.target;
            for (let $e = 0; $e < Ve.length; $e++) {
              const Mt = Ve[$e], Qe = Mt.parentNode;
              Qe != null && Mt.nodeName === "BR" && !sn(Mt, Ue, u) && Qe.removeChild(Mt);
            }
          }
          c.takeRecords();
        }
        y !== null && (he && (y.dirty = !0, Tr(y)), De && wl(u) && y.insertRawText(me));
      });
    } finally {
      Ut = !1;
    }
  }
  function un(u) {
    const s = u._observer;
    if (s !== null) {
      const c = s.takeRecords();
      Zn(u, c, s);
    }
  }
  function or(u) {
    Bt(u), u._observer = new MutationObserver((s, c) => {
      Zn(u, s, c);
    });
  }
  function lr(u, s) {
    const c = u.__mode, h = u.__format, y = u.__style, N = s.__mode, b = s.__format, $ = s.__style;
    return (c === null || c === N) && (h === null || h === b) && (y === null || y === $);
  }
  function Ri(u, s) {
    const c = u.mergeWithSibling(s), h = Tn()._normalizedNodes;
    return h.add(u.__key), h.add(s.__key), c;
  }
  function Er(u) {
    let s = u;
    if (s.__text === "" && s.isSimpleText() && !s.isUnmergeable()) {
      s.remove();
      return;
    }
    let c;
    for (; (c = s.getPreviousSibling()) !== null && mt(c) && c.isSimpleText() && !c.isUnmergeable(); )
      if (c.__text === "")
        c.remove();
      else if (lr(c, s)) {
        s = Ri(c, s);
        break;
      } else
        break;
    let h;
    for (; (h = s.getNextSibling()) !== null && mt(h) && h.isSimpleText() && !h.isUnmergeable(); )
      if (h.__text === "")
        h.remove();
      else if (lr(s, h)) {
        s = Ri(s, h);
        break;
      } else
        break;
  }
  function Os(u) {
    return go(u.anchor), go(u.focus), u;
  }
  function go(u) {
    for (; u.type === "element"; ) {
      const s = u.getNode(), c = u.offset;
      let h, y;
      if (c === s.getChildrenSize() ? (h = s.getChildAtIndex(c - 1), y = !0) : (h = s.getChildAtIndex(c), y = !1), mt(h)) {
        u.set(h.__key, y ? h.getTextContentSize() : 0, "text");
        break;
      } else if (!et(h))
        break;
      u.set(h.__key, y ? h.getChildrenSize() : 0, "element");
    }
  }
  let ul = 1;
  function qr() {
    return "" + ul++;
  }
  function ya(u, s) {
    const c = u._nodes.get(s);
    if (c === void 0)
      throw Error(`registeredNode: Type ${s} not found`);
    return c;
  }
  const po = typeof queueMicrotask == "function" ? queueMicrotask : (u) => {
    Promise.resolve().then(u);
  };
  function ss(u) {
    return An(oi(u));
  }
  function Ds(u) {
    const s = document.activeElement;
    if (s === null)
      return !1;
    const c = s.nodeName;
    return An(oi(u)) && (c === "INPUT" || c === "TEXTAREA" || s.contentEditable === "true" && // @ts-ignore iternal field
    s.__lexicalEditor == null);
  }
  function os(u, s, c) {
    const h = u.getRootElement();
    try {
      return h !== null && h.contains(s) && h.contains(c) && // Ignore if selection is within nested editor
      s !== null && !Ds(s) && dl(s) === u;
    } catch {
      return !1;
    }
  }
  function dl(u) {
    let s = u;
    for (; s != null; ) {
      const c = s.__lexicalEditor;
      if (c != null)
        return c;
      s = Eo(s);
    }
    return null;
  }
  function Ln(u) {
    return jt.test(u) ? "rtl" : Rt.test(u) ? "ltr" : null;
  }
  function zn(u) {
    return u.isToken() || u.isSegmented();
  }
  function si(u) {
    return u.nodeType === Fe;
  }
  function Fr(u) {
    let s = u;
    for (; s != null; ) {
      if (si(s))
        return s;
      s = s.firstChild;
    }
    return null;
  }
  function Bn(u, s, c) {
    const h = nn[s];
    if (c !== null && (u & h) === (c & h))
      return u;
    let y = u ^ h;
    return s === "subscript" ? y &= -65 : s === "superscript" && (y &= -33), y;
  }
  function As(u) {
    return mt(u) || ui(u) || An(u);
  }
  function fl(u, s) {
    if (s != null) {
      u.__key = s;
      return;
    }
    hr(), qd();
    const c = Tn(), h = Si(), y = qr();
    h._nodeMap.set(y, u), et(u) ? c._dirtyElements.set(y, !0) : c._dirtyLeaves.add(y), c._cloneNotNeeded.add(y), c._dirtyType = Be, u.__key = y;
  }
  function hl(u, s, c) {
    let h = u;
    for (; h !== null; ) {
      if (c.has(h))
        return;
      const y = s.get(h);
      if (y === void 0)
        break;
      c.set(h, !1), h = y.__parent;
    }
  }
  function Zr(u) {
    const s = u.getParent();
    if (s !== null) {
      const c = u.getWritable(), h = s.getWritable(), y = u.getPreviousSibling(), N = u.getNextSibling();
      if (y === null)
        if (N !== null) {
          const b = N.getWritable();
          h.__first = N.__key, b.__prev = null;
        } else
          h.__first = null;
      else {
        const b = y.getWritable();
        if (N !== null) {
          const $ = N.getWritable();
          $.__prev = b.__key, b.__next = $.__key;
        } else
          b.__next = null;
        c.__prev = null;
      }
      if (N === null)
        if (y !== null) {
          const b = y.getWritable();
          h.__last = y.__key, b.__next = null;
        } else
          h.__last = null;
      else {
        const b = N.getWritable();
        if (y !== null) {
          const $ = y.getWritable();
          $.__next = b.__key, b.__prev = $.__key;
        } else
          b.__prev = null;
        c.__next = null;
      }
      h.__size--, c.__parent = null;
    }
  }
  function bi(u) {
    qd();
    const s = u.getLatest(), c = s.__parent, h = Si(), y = Tn(), N = h._nodeMap, b = y._dirtyElements;
    c !== null && hl(c, N, b);
    const $ = s.__key;
    y._dirtyType = Be, et(u) ? b.set($, !0) : y._dirtyLeaves.add($);
  }
  function gl(u) {
    const s = u.getPreviousSibling(), c = u.getNextSibling();
    s !== null && bi(s), c !== null && bi(c);
  }
  function vn(u) {
    hr();
    const s = Tn(), c = s._compositionKey;
    if (u !== c) {
      if (s._compositionKey = u, c !== null) {
        const h = Nn(c);
        h !== null && h.getWritable();
      }
      if (u !== null) {
        const h = Nn(u);
        h !== null && h.getWritable();
      }
    }
  }
  function ar() {
    return Wo() ? null : Tn()._compositionKey;
  }
  function Nn(u, s) {
    const h = (s || Si())._nodeMap.get(u);
    return h === void 0 ? null : h;
  }
  function mo(u, s) {
    const c = Tn(), h = u[`__lexicalKey_${c._key}`];
    return h !== void 0 ? Nn(h, s) : null;
  }
  function oi(u, s) {
    let c = u;
    for (; c != null; ) {
      const h = mo(c, s);
      if (h !== null)
        return h;
      c = Eo(c);
    }
    return null;
  }
  function Ms(u) {
    const s = u._decorators, c = Object.assign({}, s);
    return u._pendingDecorators = c, c;
  }
  function _o(u) {
    return u.read(() => nr().getTextContent());
  }
  function Li(u, s) {
    Gr(u, () => {
      const c = Si();
      if (c.isEmpty())
        return;
      if (s === "root") {
        nr().markDirty();
        return;
      }
      const h = c._nodeMap;
      for (const [, y] of h)
        y.markDirty();
    }, u._pendingEditorState === null ? {
      tag: "history-merge"
    } : void 0);
  }
  function nr() {
    return pl(Si());
  }
  function pl(u) {
    return u._nodeMap.get("root");
  }
  function Tr(u) {
    hr();
    const s = Si();
    if (u !== null) {
      if (Object.isFrozen(u))
        throw Error("$setSelection called on frozen selection object. Ensure selection is cloned before passing in.");
      u.dirty = !0, u.setCachedNodes(null);
    }
    s._selection = u;
  }
  function ml() {
    hr();
    const u = Tn();
    un(u);
  }
  function Ii(u) {
    const s = Tn(), c = Na(u, s);
    if (c === null) {
      const h = s.getRootElement();
      return u === h ? Nn("root") : null;
    }
    return Nn(c);
  }
  function _l(u, s) {
    return s ? u.getTextContentSize() : 0;
  }
  function Na(u, s) {
    let c = u;
    for (; c != null; ) {
      const h = c[`__lexicalKey_${s._key}`];
      if (h !== void 0)
        return h;
      c = Eo(c);
    }
    return null;
  }
  function Rs(u) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(u);
  }
  function ki(u) {
    const s = [];
    let c = u;
    for (; c !== null; )
      s.push(c), c = c._parentEditor;
    return s;
  }
  function yl() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
  }
  function yo(u) {
    return u.nodeType === Fe ? u.nodeValue : null;
  }
  function bs(u, s, c) {
    const h = cr(s._window);
    if (h === null)
      return;
    const y = h.anchorNode;
    let {
      anchorOffset: N,
      focusOffset: b
    } = h;
    if (y !== null) {
      let $ = yo(y);
      const ae = oi(y);
      if ($ !== null && mt(ae)) {
        if ($ === pt && c) {
          const he = c.length;
          $ = c, N = he, b = he;
        }
        $ !== null && Br(ae, $, N, b, u);
      }
    }
  }
  function Br(u, s, c, h, y) {
    let N = u;
    if (N.isAttached() && (y || !N.isDirty())) {
      const b = N.isComposing();
      let $ = s;
      (b || y) && s[s.length - 1] === pt && ($ = s.slice(0, -1));
      const ae = N.getTextContent();
      if (y || $ !== ae) {
        if ($ === "") {
          if (vn(null), !ne && !ue && !Re) {
            const Ue = Tn();
            setTimeout(() => {
              Ue.update(() => {
                N.isAttached() && N.remove();
              });
            }, 20);
          } else
            N.remove();
          return;
        }
        const he = N.getParent(), me = Ho(), xe = N.getTextContentSize(), we = ar(), Ce = N.getKey();
        if (N.isToken() || we !== null && Ce === we && !b || // Check if character was added at the start or boundaries when not insertable, and we need
        // to clear this input from occurring as that action wasn't permitted.
        Et(me) && (he !== null && !he.canInsertTextBefore() && me.anchor.offset === 0 || me.anchor.key === u.__key && me.anchor.offset === 0 && !N.canInsertTextBefore() && !b || me.focus.key === u.__key && me.focus.offset === xe && !N.canInsertTextAfter() && !b)) {
          N.markDirty();
          return;
        }
        const Ve = mn();
        if (!Et(Ve) || c === null || h === null) {
          N.setTextContent($);
          return;
        }
        if (Ve.setTextNodeRange(N, c, N, h), N.isSegmented()) {
          const Ue = N.getTextContent(), $e = Dn(Ue);
          N.replace($e), N = $e;
        }
        N.setTextContent($);
      }
    }
  }
  function Nl(u) {
    const s = u.getPreviousSibling();
    return (mt(s) || et(s) && s.isInline()) && !s.canInsertTextAfter();
  }
  function Ls(u, s) {
    if (s.isSegmented())
      return !0;
    if (!u.isCollapsed())
      return !1;
    const c = u.anchor.offset, h = s.getParentOrThrow(), y = s.isToken();
    return c === 0 ? !s.canInsertTextBefore() || !h.canInsertTextBefore() || y || Nl(s) : c === s.getTextContentSize() ? !s.canInsertTextAfter() || !h.canInsertTextAfter() || y : !1;
  }
  function Ca(u, s, c, h) {
    return u === 9 && !s && !c && !h;
  }
  function Ea(u, s, c, h) {
    return u === 66 && !s && Jr(c, h);
  }
  function ls(u, s, c, h) {
    return u === 73 && !s && Jr(c, h);
  }
  function Is(u, s, c, h) {
    return u === 85 && !s && Jr(c, h);
  }
  function Cl(u, s) {
    return Ra(u) && !s;
  }
  function El(u, s) {
    return Ra(u) && s;
  }
  function ks(u, s) {
    return ye && s && u === 79;
  }
  function Ps(u, s, c) {
    return Xr(u) && (ye ? s : c);
  }
  function Ta(u, s, c) {
    return $i(u) && (ye ? s : c);
  }
  function xa(u, s) {
    return ye && s && Xr(u);
  }
  function va(u, s) {
    return ye && s && $i(u);
  }
  function Sa(u, s, c, h) {
    return ye ? s || c ? !1 : Xr(u) || u === 72 && h : h || s || c ? !1 : Xr(u);
  }
  function Rc(u, s, c, h, y) {
    return ye ? c || h || y ? !1 : $i(u) || u === 68 && s : s || h || y ? !1 : $i(u);
  }
  function bc(u, s, c, h) {
    return u === 90 && !s && Jr(c, h);
  }
  function wa(u, s, c, h) {
    return ye ? u === 90 && c && s : u === 89 && h || u === 90 && h && s;
  }
  function Lc(u, s, c, h) {
    return s ? !1 : u === 67 ? ye ? c : h : !1;
  }
  function Ic(u, s, c, h) {
    return s ? !1 : u === 88 ? ye ? c : h : !1;
  }
  function Oa(u) {
    return u === 37;
  }
  function Da(u) {
    return u === 39;
  }
  function Tl(u) {
    return u === 38;
  }
  function kc(u) {
    return u === 40;
  }
  function Pc(u, s, c, h) {
    return Oa(u) && !s && !h && !c;
  }
  function Aa(u, s, c, h, y) {
    return Oa(u) && !h && !c && (s || y);
  }
  function as(u, s, c, h) {
    return Da(u) && !s && !h && !c;
  }
  function Ma(u, s, c, h, y) {
    return Da(u) && !h && !c && (s || y);
  }
  function $c(u, s, c) {
    return Tl(u) && !s && !c;
  }
  function xl(u, s, c) {
    return kc(u) && !s && !c;
  }
  function $s(u, s, c, h) {
    return u || s || c || h;
  }
  function Fc(u) {
    return u === 32;
  }
  function Jr(u, s) {
    return ye ? u : s;
  }
  function Ra(u) {
    return u === 13;
  }
  function Xr(u) {
    return u === 8;
  }
  function Pi(u) {
    return u === 27;
  }
  function $i(u) {
    return u === 46;
  }
  function No(u, s, c) {
    return u === 65 && Jr(s, c);
  }
  function vl() {
    const u = nr(), s = u.select(0, u.getChildrenSize());
    Tr(Os(s));
  }
  function Fi(u, s) {
    u.__lexicalClassNameCache === void 0 && (u.__lexicalClassNameCache = {});
    const c = u.__lexicalClassNameCache, h = c[s];
    if (h !== void 0)
      return h;
    const y = u[s];
    if (typeof y == "string") {
      const N = y.split(" ");
      return c[s] = N, N;
    }
    return y;
  }
  function cs(u, s, c, h, y) {
    if (c.size === 0)
      return;
    const N = h.__type, b = h.__key, $ = s.get(N);
    if ($ === void 0)
      throw Error(`Type ${N} not in registeredNodes`);
    const ae = $.klass;
    let he = u.get(ae);
    he === void 0 && (he = /* @__PURE__ */ new Map(), u.set(ae, he));
    const me = he.get(b), xe = me === "destroyed" && y === "created";
    (me === void 0 || xe) && he.set(b, xe ? "updated" : y);
  }
  function Bi(u) {
    const s = Si(), c = s._readOnly, h = u.getType(), y = s._nodeMap, N = [];
    for (const [, b] of y)
      b instanceof u && b.__type === h && (c || b.isAttached()) && N.push(b);
    return N;
  }
  function ba(u, s, c) {
    const h = u.getParent();
    let y = c, N = u;
    return h !== null && (s && c === 0 ? (y = N.getIndexWithinParent(), N = h) : !s && c === N.getChildrenSize() && (y = N.getIndexWithinParent() + 1, N = h)), N.getChildAtIndex(s ? y - 1 : y);
  }
  function Sl(u, s) {
    const c = u.offset;
    if (u.type === "element") {
      const h = u.getNode();
      return ba(h, s, c);
    } else {
      const h = u.getNode();
      if (s && c === 0 || !s && c === h.getTextContentSize()) {
        const y = s ? h.getPreviousSibling() : h.getNextSibling();
        return y === null ? ba(h.getParentOrThrow(), s, h.getIndexWithinParent() + (s ? 0 : 1)) : y;
      }
    }
    return null;
  }
  function wl(u) {
    const s = To(u).event, c = s && s.inputType;
    return c === "insertFromPaste" || c === "insertFromPasteAsQuotation";
  }
  function ut(u, s, c) {
    return ef(u, s, c);
  }
  function Co(u) {
    return !Yr(u) && !u.isLastChild() && !u.isInline();
  }
  function Fs(u, s) {
    const c = u._keyToDOMMap.get(s);
    if (c === void 0)
      throw Error(`Reconciliation: could not find DOM element for node key ${s}`);
    return c;
  }
  function Eo(u) {
    const s = u.assignedSlot || u.parentElement;
    return s !== null && s.nodeType === 11 ? s.host : s;
  }
  function Ci(u, s, c) {
    const h = c.ownerDocument, y = h.defaultView;
    if (y === null)
      return;
    let {
      top: N,
      bottom: b
    } = s, $ = 0, ae = 0, he = c;
    for (; he !== null; ) {
      const me = he === h.body;
      if (me)
        $ = 0, ae = To(u).innerHeight;
      else {
        const we = he.getBoundingClientRect();
        $ = we.top, ae = we.bottom;
      }
      let xe = 0;
      if (N < $ ? xe = -($ - N) : b > ae && (xe = b - ae), xe !== 0)
        if (me)
          y.scrollBy(0, xe);
        else {
          const we = he.scrollTop;
          he.scrollTop += xe;
          const Ce = he.scrollTop - we;
          N -= Ce, b -= Ce;
        }
      if (me)
        break;
      he = Eo(he);
    }
  }
  function Un(u) {
    return Tn()._updateTags.has(u);
  }
  function Nt(u) {
    hr(), Tn()._updateTags.add(u);
  }
  function us(u) {
    const s = mn();
    if (!Et(s) || !et(u))
      return s;
    const {
      anchor: c,
      focus: h
    } = s, y = c.getNode(), N = h.getNode();
    return Hi(y, u) && c.set(u.__key, 0, "element"), Hi(N, u) && h.set(u.__key, 0, "element"), s;
  }
  function Hi(u, s) {
    let c = u.getParent();
    for (; c !== null; ) {
      if (c.is(s))
        return !0;
      c = c.getParent();
    }
    return !1;
  }
  function La(u) {
    const s = u.ownerDocument;
    return s && s.defaultView || null;
  }
  function To(u) {
    const s = u._window;
    if (s === null)
      throw Error("window object not found");
    return s;
  }
  function Hr(u) {
    return et(u) && u.isInline() || An(u) && u.isInline();
  }
  function xo(u) {
    let s = u.getParentOrThrow();
    for (; s !== null; ) {
      if (li(s))
        return s;
      s = s.getParentOrThrow();
    }
    return s;
  }
  function li(u) {
    return Yr(u) || et(u) && u.isShadowRoot();
  }
  function Ol(u) {
    const s = u.constructor.clone(u);
    return fl(s, null), s;
  }
  function Mr(u) {
    const s = Tn(), c = u.constructor.getType(), h = s._nodes.get(c);
    if (h === void 0)
      throw Error('$initializeNode failed. Ensure node has been registered to the editor. You can do this by passing the node class via the "nodes" array in the editor config.');
    const y = h.replace;
    if (y !== null) {
      const N = y(u);
      if (!(N instanceof u.constructor))
        throw Error("$initializeNode failed. Ensure replacement node is a subclass of the original node.");
      return N;
    }
    return u;
  }
  function Bs(u, s) {
    const c = u.getParent();
    if (Yr(c) && !et(s) && !An(s))
      throw Error("Only element or decorator nodes can be inserted in to the root node");
  }
  function vo(u) {
    const s = u.theme, c = document.createElement("div");
    c.contentEditable = "false", c.setAttribute("data-lexical-cursor", "true");
    let h = s.blockCursor;
    if (h !== void 0) {
      if (typeof h == "string") {
        const y = h.split(" ");
        h = s.blockCursor = y;
      }
      h !== void 0 && c.classList.add(...h);
    }
    return c;
  }
  function At(u) {
    return (An(u) || et(u) && !u.canBeEmpty()) && !u.isInline();
  }
  function Hs(u, s, c) {
    c.style.removeProperty("caret-color"), s._blockCursorElement = null;
    const h = u.parentElement;
    h !== null && h.removeChild(u);
  }
  function Ei(u, s, c) {
    let h = u._blockCursorElement;
    if (Et(c) && c.isCollapsed() && c.anchor.type === "element" && s.contains(document.activeElement)) {
      const y = c.anchor, N = y.getNode(), b = y.offset, $ = N.getChildrenSize();
      let ae = !1, he = null;
      if (b === $) {
        const me = N.getChildAtIndex(b - 1);
        At(me) && (ae = !0);
      } else {
        const me = N.getChildAtIndex(b);
        if (At(me)) {
          const xe = me.getPreviousSibling();
          (xe === null || At(xe)) && (ae = !0, he = u.getElementByKey(me.__key));
        }
      }
      if (ae) {
        const me = u.getElementByKey(N.__key);
        h === null && (u._blockCursorElement = h = vo(u._config)), s.style.caretColor = "transparent", he === null ? me.appendChild(h) : me.insertBefore(h, he);
        return;
      }
    }
    h !== null && Hs(h, u, s);
  }
  function cr(u) {
    return F ? (u || window).getSelection() : null;
  }
  function Ia(u, s) {
    let c = u.getChildAtIndex(s);
    if (c == null && (c = u), li(u))
      throw Error("Can not call $splitNode() on root element");
    const h = (b) => {
      const $ = b.getParentOrThrow(), ae = li($), he = b === c && !ae ? b : Ol(b);
      if (ae) {
        if (!(et(b) && et(he)))
          throw Error("Children of a root must be ElementNode");
        return b.insertAfter(he), [b, he, he];
      } else {
        const [me, xe, we] = h($), Ce = b.getNextSiblings();
        return we.append(he, ...Ce), [me, xe, he];
      }
    }, [y, N] = h(c);
    return [y, N];
  }
  function So(u, s) {
    let c = u;
    for (; c !== nr() && c != null; ) {
      if (s(c))
        return c;
      c = c.getParent();
    }
    return null;
  }
  function ka(u) {
    return Ws(u) && u.tagName === "A";
  }
  function Ws(u) {
    return u.nodeType === 1;
  }
  function Wi(u) {
    if (An(u) && !u.isInline())
      return !0;
    if (!et(u) || li(u))
      return !1;
    const s = u.getFirstChild(), c = s === null || ui(s) || mt(s) || s.isInline();
    return !u.isInline() && u.canBeEmpty() !== !1 && c;
  }
  function wo(u, s) {
    let c = u;
    for (; c !== null && c.getParent() !== null && !s(c); )
      c = c.getParentOrThrow();
    return s(c) ? c : null;
  }
  function Pa(u, s) {
    const c = u._decorators;
    let y = u._pendingDecorators || c;
    const N = s._nodeMap;
    let b;
    for (b in y)
      N.has(b) || (y === c && (y = Ms(u)), delete y[b]);
  }
  function Dl(u, s, c, h, y, N) {
    let b = u.getFirstChild();
    for (; b !== null; ) {
      const $ = b.__key;
      b.__parent === s && (et(b) && Dl(b, $, c, h, y, N), c.has($) || N.delete($), y.push($)), b = b.getNextSibling();
    }
  }
  function Al(u, s, c, h) {
    const y = u._nodeMap, N = s._nodeMap, b = [];
    for (const [$] of h) {
      const ae = N.get($);
      ae !== void 0 && (ae.isAttached() || (et(ae) && Dl(ae, $, y, N, b, h), y.has($) || h.delete($), b.push($)));
    }
    for (const $ of b)
      N.delete($);
    for (const $ of c) {
      const ae = N.get($);
      ae !== void 0 && !ae.isAttached() && (y.has($) || c.delete($), N.delete($));
    }
  }
  let In = "", Gn = "", Vt = "", xr, Hn, ds, $a = !1, fs = !1, Ks, zs = null, Us, Ml, Ki, hn, On, Wn;
  function hs(u, s) {
    const c = Ki.get(u);
    if (s !== null) {
      const h = Ao(u);
      h.parentNode === s && s.removeChild(h);
    }
    if (hn.has(u) || Hn._keyToDOMMap.delete(u), et(c)) {
      const h = xi(c, Ki);
      zi(h, 0, h.length - 1, null);
    }
    c !== void 0 && cs(Wn, ds, Ks, c, "destroyed");
  }
  function zi(u, s, c, h) {
    let y = s;
    for (; y <= c; ++y) {
      const N = u[y];
      N !== void 0 && hs(N, h);
    }
  }
  function Ti(u, s) {
    u.setProperty("text-align", s);
  }
  const gs = "40px";
  function Jn(u, s) {
    const c = xr.theme.indent;
    if (typeof c == "string") {
      const y = u.classList.contains(c);
      s > 0 && !y ? u.classList.add(c) : s < 1 && y && u.classList.remove(c);
    }
    const h = getComputedStyle(u).getPropertyValue("--lexical-indent-base-value") || gs;
    u.style.setProperty("padding-inline-start", s === 0 ? "" : `calc(${s} * ${h})`);
  }
  function Wr(u, s) {
    const c = u.style;
    s === 0 ? Ti(c, "") : s === Ge ? Ti(c, "left") : s === ze ? Ti(c, "center") : s === tt ? Ti(c, "right") : s === _t ? Ti(c, "justify") : s === yt ? Ti(c, "start") : s === Ct && Ti(c, "end");
  }
  function dn(u, s, c) {
    const h = hn.get(u);
    if (h === void 0)
      throw Error("createNode: node does not exist in nodeMap");
    const y = h.createDOM(xr, Hn);
    if (Je(u, y, Hn), mt(h) ? y.setAttribute("data-lexical-text", "true") : An(h) && y.setAttribute("data-lexical-decorator", "true"), et(h)) {
      const N = h.__indent, b = h.__size;
      if (N !== 0 && Jn(y, N), b !== 0) {
        const ae = b - 1, he = xi(h, hn);
        Fa(he, ae, h, y);
      }
      const $ = h.__format;
      $ !== 0 && Wr(y, $), h.isInline() || Oo(null, h, y), Co(h) && (In += Pt, Vt += Pt);
    } else {
      const N = h.getTextContent();
      if (An(h)) {
        const b = h.decorate(Hn, xr);
        b !== null && Ll(u, b), y.contentEditable = "false";
      } else mt(h) && (h.isDirectionless() || (Gn += N));
      In += N, Vt += N;
    }
    if (s !== null)
      if (c != null)
        s.insertBefore(y, c);
      else {
        const N = s.__lexicalLineBreak;
        N != null ? s.insertBefore(y, N) : s.appendChild(y);
      }
    return Object.freeze(h), cs(Wn, ds, Ks, h, "created"), y;
  }
  function Fa(u, s, c, h) {
    const y = Gn;
    Gn = "", Rl(u, c, 0, s, h, null), bl(c, h), Gn = y;
  }
  function Rl(u, s, c, h, y, N) {
    const b = In;
    In = "";
    let $ = c;
    for (; $ <= h; ++$)
      dn(u[$], y, N);
    Co(s) && (In += Pt), y.__lexicalTextContent = In, In = b + In;
  }
  function Ba(u, s) {
    const c = s.get(u);
    return ui(c) || An(c) && c.isInline();
  }
  function Oo(u, s, c) {
    const h = u !== null && (u.__size === 0 || Ba(u.__last, Ki)), y = s.__size === 0 || Ba(s.__last, hn);
    if (h) {
      if (!y) {
        const N = c.__lexicalLineBreak;
        N != null && c.removeChild(N), c.__lexicalLineBreak = null;
      }
    } else if (y) {
      const N = document.createElement("br");
      c.__lexicalLineBreak = N, c.appendChild(N);
    }
  }
  function bl(u, s) {
    const c = (
      // @ts-expect-error: internal field
      s.__lexicalDirTextContent
    ), h = s.__lexicalDir;
    if (c !== Gn || h !== zs) {
      const y = Gn === "", N = y ? zs : Ln(Gn);
      if (N !== h) {
        const b = s.classList, $ = xr.theme;
        let ae = h !== null ? $[h] : void 0, he = N !== null ? $[N] : void 0;
        if (ae !== void 0) {
          if (typeof ae == "string") {
            const me = ae.split(" ");
            ae = $[h] = me;
          }
          b.remove(...ae);
        }
        if (N === null || y && N === "ltr")
          s.removeAttribute("dir");
        else {
          if (he !== void 0) {
            if (typeof he == "string") {
              const me = he.split(" ");
              he = $[N] = me;
            }
            he !== void 0 && b.add(...he);
          }
          s.dir = N;
        }
        if (!fs) {
          const me = u.getWritable();
          me.__dir = N;
        }
      }
      zs = N, s.__lexicalDirTextContent = Gn, s.__lexicalDir = N;
    }
  }
  function Ui(u, s, c) {
    const h = Gn;
    Gn = "", at(u, s, c), bl(s, c), Gn = h;
  }
  function xi(u, s) {
    const c = [];
    let h = u.__first;
    for (; h !== null; ) {
      const y = s.get(h);
      if (y === void 0)
        throw Error("createChildrenArray: node does not exist in nodeMap");
      c.push(h), h = y.__next;
    }
    return c;
  }
  function at(u, s, c) {
    const h = In, y = u.__size, N = s.__size;
    if (In = "", y === 1 && N === 1) {
      const b = u.__first, $ = s.__first;
      if (b === $)
        ps(b, c);
      else {
        const ae = Ao(b), he = dn($, null, null);
        c.replaceChild(he, ae), hs(b, null);
      }
    } else {
      const b = xi(u, Ki), $ = xi(s, hn);
      if (y === 0)
        N !== 0 && Rl($, s, 0, N - 1, c, null);
      else if (N === 0) {
        if (y !== 0) {
          const he = c.__lexicalLineBreak == null;
          zi(b, 0, y - 1, he ? null : c), he && (c.textContent = "");
        }
      } else
        Cn(s, b, $, y, N, c);
    }
    Co(s) && (In += Pt), c.__lexicalTextContent = In, In = h + In;
  }
  function ps(u, s) {
    const c = Ki.get(u);
    let h = hn.get(u);
    if (c === void 0 || h === void 0)
      throw Error("reconcileNode: prevNode or nextNode does not exist in nodeMap");
    const y = $a || Ml.has(u) || Us.has(u), N = Fs(Hn, u);
    if (c === h && !y) {
      if (et(c)) {
        const b = N.__lexicalTextContent;
        b !== void 0 && (In += b, Vt += b);
        const $ = N.__lexicalDirTextContent;
        $ !== void 0 && (Gn += $);
      } else {
        const b = c.getTextContent();
        mt(c) && !c.isDirectionless() && (Gn += b), Vt += b, In += b;
      }
      return N;
    }
    if (c !== h && y && cs(Wn, ds, Ks, h, "updated"), h.updateDOM(c, N, xr)) {
      const b = dn(u, null, null);
      if (s === null)
        throw Error("reconcileNode: parentDOM is null");
      return s.replaceChild(b, N), hs(u, null), b;
    }
    if (et(c) && et(h)) {
      const b = h.__indent;
      b !== c.__indent && Jn(N, b);
      const $ = h.__format;
      $ !== c.__format && Wr(N, $), y && (Ui(c, h, N), !Yr(h) && !h.isInline() && Oo(c, h, N)), Co(h) && (In += Pt, Vt += Pt);
    } else {
      const b = h.getTextContent();
      if (An(h)) {
        const $ = h.decorate(Hn, xr);
        $ !== null && Ll(u, $);
      } else mt(h) && !h.isDirectionless() && (Gn += b);
      In += b, Vt += b;
    }
    if (!fs && Yr(h) && h.__cachedText !== Vt) {
      const b = h.getWritable();
      b.__cachedText = Vt, h = b;
    }
    return Object.freeze(h), N;
  }
  function Ll(u, s) {
    let c = Hn._pendingDecorators;
    const h = Hn._decorators;
    if (c === null) {
      if (h[u] === s)
        return;
      c = Ms(Hn);
    }
    c[u] = s;
  }
  function vr(u) {
    return u.firstChild;
  }
  function Do(u) {
    let s = u.nextSibling;
    return s !== null && s === Hn._blockCursorElement && (s = s.nextSibling), s;
  }
  function Cn(u, s, c, h, y, N) {
    const b = h - 1, $ = y - 1;
    let ae, he, me = vr(N), xe = 0, we = 0;
    for (; xe <= b && we <= $; ) {
      const Ue = s[xe], $e = c[we];
      if (Ue === $e)
        me = Do(ps($e, N)), xe++, we++;
      else {
        ae === void 0 && (ae = new Set(s)), he === void 0 && (he = new Set(c));
        const Mt = he.has(Ue), Qe = ae.has($e);
        if (!Mt)
          me = Do(Ao(Ue)), hs(Ue, N), xe++;
        else if (!Qe)
          dn($e, N, me), we++;
        else {
          const ft = Fs(Hn, $e);
          ft === me ? me = Do(ps($e, N)) : (me != null ? N.insertBefore(ft, me) : N.appendChild(ft), ps($e, N)), xe++, we++;
        }
      }
    }
    const Ce = xe > b, Ve = we > $;
    if (Ce && !Ve) {
      const Ue = c[$ + 1], $e = Ue === void 0 ? null : Hn.getElementByKey(Ue);
      Rl(c, u, we, $, N, $e);
    } else Ve && !Ce && zi(s, xe, b, N);
  }
  function Gi(u, s, c, h, y, N) {
    In = "", Vt = "", Gn = "", $a = h === ct, zs = null, Hn = c, xr = c._config, ds = c._nodes, Ks = Hn._listeners.mutation, Us = y, Ml = N, Ki = u._nodeMap, hn = s._nodeMap, fs = s._readOnly, On = new Map(c._keyToDOMMap);
    const b = /* @__PURE__ */ new Map();
    return Wn = b, ps("root", null), Hn = void 0, ds = void 0, Us = void 0, Ml = void 0, Ki = void 0, hn = void 0, xr = void 0, On = void 0, Wn = void 0, b;
  }
  function Je(u, s, c) {
    const h = c._keyToDOMMap;
    s["__lexicalKey_" + c._key] = u, h.set(u, s);
  }
  function Ao(u) {
    const s = On.get(u);
    if (s === void 0)
      throw Error(`Reconciliation: could not find DOM element for node key ${u}`);
    return s;
  }
  const ur = Object.freeze({}), rr = 30, Il = [["keydown", ge], ["pointerdown", Fl], ["compositionstart", x], ["compositionend", Q], ["input", C], ["click", Ha], ["cut", ur], ["copy", ur], ["dragstart", ur], ["dragover", ur], ["dragend", ur], ["paste", ur], ["focus", ur], ["blur", ur], ["drop", ur]];
  ee && Il.push(["beforeinput", (u, s) => g(u, s)]);
  let Yi = 0, kl = 0, Gs = 0, Kr = null, Ys = 0, zr = !1, Mo = !1, js = !1, Vs = !1, Ro = [0, "", 0, "root", 0];
  function ji(u, s, c, h, y) {
    const N = u.anchor, b = u.focus, $ = N.getNode(), ae = Tn(), he = cr(ae._window), me = he !== null ? he.anchorNode : null, xe = N.key, we = ae.getElementByKey(xe), Ce = c.length;
    return xe !== b.key || // If we're working with a non-text node.
    !mt($) || // If we are replacing a range with a single character or grapheme, and not composing.
    (!y && (!ee || // We check to see if there has been
    // a recent beforeinput event for "textInput". If there has been one in the last
    // 50ms then we proceed as normal. However, if there is not, then this is likely
    // a dangling `input` event caused by execCommand('insertText').
    Gs < h + 50) || $.isDirty() && Ce < 2 || Rs(c)) && N.offset !== b.offset && !$.isComposing() || // Any non standard text node.
    zn($) || // If the text length is more than a single character and we're either
    // dealing with this in "beforeinput" or where the node has already recently
    // been changed (thus is dirty).
    $.isDirty() && Ce > 1 || // If the DOM selection element is not the same as the backing node during beforeinput.
    (y || !ee) && we !== null && !$.isComposing() && me !== Fr(we) || // If TargetRange is not the same as the DOM selection; browser trying to edit random parts
    // of the editor.
    he !== null && s !== null && (!s.collapsed || s.startContainer !== he.anchorNode || s.startOffset !== he.anchorOffset) || // Check if we're changing from bold to italics, or some other format.
    $.getFormat() !== u.format || $.getStyle() !== u.style || // One last set of heuristics to check against.
    Ls(u, $);
  }
  function Pl(u, s) {
    return u !== null && u.nodeValue !== null && u.nodeType === Fe && s !== 0 && s !== u.nodeValue.length;
  }
  function $l(u, s, c) {
    const {
      anchorNode: h,
      anchorOffset: y,
      focusNode: N,
      focusOffset: b
    } = u;
    zr && (zr = !1, Pl(h, y) && Pl(N, b)) || Gr(s, () => {
      if (!c) {
        Tr(null);
        return;
      }
      if (!os(s, h, N))
        return;
      const $ = mn();
      if (Et($)) {
        const ae = $.anchor, he = ae.getNode();
        if ($.isCollapsed()) {
          u.type === "Range" && u.anchorNode === u.focusNode && ($.dirty = !0);
          const me = To(s).event, xe = me ? me.timeStamp : performance.now(), [we, Ce, Ve, Ue, $e] = Ro, Mt = nr(), Qe = s.isComposing() === !1 && Mt.getTextContent() === "";
          if (xe < $e + 200 && ae.offset === Ve && ae.key === Ue)
            $.format = we, $.style = Ce;
          else if (ae.type === "text") {
            if (!mt(he))
              throw Error("Point.getNode() must return TextNode when type is text");
            $.format = he.getFormat(), $.style = he.getStyle();
          } else ae.type === "element" && !Qe && ($.format = 0, $.style = "");
        } else {
          let me = it, xe = !1;
          const we = $.getNodes(), Ce = we.length;
          for (let Ve = 0; Ve < Ce; Ve++) {
            const Ue = we[Ve];
            if (mt(Ue) && (xe = !0, me &= Ue.getFormat(), me === 0))
              break;
          }
          $.format = xe ? me : 0;
        }
      }
      ut(s, t, void 0);
    });
  }
  function Ha(u, s) {
    Gr(s, () => {
      const c = mn(), h = cr(s._window), y = Ho();
      if (h) {
        if (Et(c)) {
          const N = c.anchor, b = N.getNode();
          if (N.type === "element" && N.offset === 0 && c.isCollapsed() && !Yr(b) && nr().getChildrenSize() === 1 && b.getTopLevelElementOrThrow().isEmpty() && y !== null && c.is(y))
            h.removeAllRanges(), c.dirty = !0;
          else if (u.detail === 3 && !c.isCollapsed()) {
            const ae = c.focus.getNode();
            b !== ae && (et(b) ? b.select(0) : b.getParentOrThrow().select(0));
          }
        } else if (u.pointerType === "touch") {
          const N = h.anchorNode;
          if (N !== null) {
            const b = N.nodeType;
            if (b === ke || b === Fe) {
              const $ = Wc(y, h, s, u);
              Tr($);
            }
          }
        }
      }
      ut(s, r, u);
    });
  }
  function Fl(u, s) {
    const c = u.target, h = u.pointerType;
    c instanceof Node && h !== "touch" && Gr(s, () => {
      ss(c) || (Mo = !0);
    });
  }
  function o(u) {
    if (!u.getTargetRanges)
      return null;
    const s = u.getTargetRanges();
    return s.length === 0 ? null : s[0];
  }
  function i(u, s) {
    return u !== s || et(u) || et(s) || !u.isToken() || !s.isToken();
  }
  function a(u) {
    return kl === 229 && u < Yi + rr;
  }
  function g(u, s) {
    const c = u.inputType, h = o(u);
    c === "deleteCompositionText" || // If we're pasting in FF, we shouldn't get this event
    // as the `paste` event should have triggered, unless the
    // user has dom.event.clipboardevents.enabled disabled in
    // about:config. In that case, we need to process the
    // pasted content in the DOM mutation phase.
    De && wl(s) || c !== "insertCompositionText" && Gr(s, () => {
      const y = mn();
      if (c === "deleteContentBackward") {
        if (y === null) {
          const me = Ho();
          if (!Et(me))
            return;
          Tr(me.clone());
        }
        if (Et(y)) {
          if (be && vn(y.anchor.key), a(u.timeStamp) && s.isComposing() && y.anchor.key === y.focus.key) {
            if (vn(null), Yi = 0, setTimeout(() => {
              Gr(s, () => {
                vn(null);
              });
            }, rr), Et(y)) {
              const xe = y.anchor.getNode();
              if (xe.markDirty(), y.format = xe.getFormat(), !mt(xe))
                throw Error("Anchor node must be a TextNode");
              y.style = xe.getStyle();
            }
            y.anchor.getNode().getTextContent().length <= 1 && (u.preventDefault(), ut(s, l, !0));
          } else
            vn(null), u.preventDefault(), ut(s, l, !0);
          return;
        }
      }
      if (!Et(y))
        return;
      const N = u.data;
      Kr !== null && bs(!1, s, Kr), (!y.dirty || Kr !== null) && y.isCollapsed() && !Yr(y.anchor.getNode()) && h !== null && y.applyDOMRange(h), Kr = null;
      const b = y.anchor, $ = y.focus, ae = b.getNode(), he = $.getNode();
      if (c === "insertText" || c === "insertTranspose") {
        if (N === `
`)
          u.preventDefault(), ut(s, d, !1);
        else if (N === Pt)
          u.preventDefault(), ut(s, f, void 0);
        else if (N == null && u.dataTransfer) {
          const me = u.dataTransfer.getData("text/plain");
          u.preventDefault(), y.insertRawText(me);
        } else N != null && ji(y, h, N, u.timeStamp, !0) ? (u.preventDefault(), ut(s, p, N)) : Kr = N;
        Gs = u.timeStamp;
        return;
      }
      switch (u.preventDefault(), c) {
        case "insertFromYank":
        case "insertFromDrop":
        case "insertReplacementText": {
          ut(s, p, u);
          break;
        }
        case "insertFromComposition": {
          vn(null), ut(s, p, u);
          break;
        }
        case "insertLineBreak": {
          vn(null), ut(s, d, !1);
          break;
        }
        case "insertParagraph": {
          vn(null), js && !ue ? (js = !1, ut(s, d, !1)) : ut(s, f, void 0);
          break;
        }
        case "insertFromPaste":
        case "insertFromPasteAsQuotation": {
          ut(s, _, u);
          break;
        }
        case "deleteByComposition": {
          i(ae, he) && ut(s, E, u);
          break;
        }
        case "deleteByDrag":
        case "deleteByCut": {
          ut(s, E, u);
          break;
        }
        case "deleteContent": {
          ut(s, l, !1);
          break;
        }
        case "deleteWordBackward": {
          ut(s, T, !0);
          break;
        }
        case "deleteWordForward": {
          ut(s, T, !1);
          break;
        }
        case "deleteHardLineBackward":
        case "deleteSoftLineBackward": {
          ut(s, S, !0);
          break;
        }
        case "deleteContentForward":
        case "deleteHardLineForward":
        case "deleteSoftLineForward": {
          ut(s, S, !1);
          break;
        }
        case "formatStrikeThrough": {
          ut(s, w, "strikethrough");
          break;
        }
        case "formatBold": {
          ut(s, w, "bold");
          break;
        }
        case "formatItalic": {
          ut(s, w, "italic");
          break;
        }
        case "formatUnderline": {
          ut(s, w, "underline");
          break;
        }
        case "historyUndo": {
          ut(s, O, void 0);
          break;
        }
        case "historyRedo": {
          ut(s, m, void 0);
          break;
        }
      }
    });
  }
  function C(u, s) {
    u.stopPropagation(), Gr(s, () => {
      const c = mn(), h = u.data, y = o(u);
      if (h != null && Et(c) && ji(c, y, h, u.timeStamp, !1)) {
        Vs && (A(s, h), Vs = !1);
        const N = c.anchor, b = N.getNode(), $ = cr(s._window);
        if ($ === null)
          return;
        const ae = N.offset;
        (!ee || c.isCollapsed() || !mt(b) || $.anchorNode === null || b.getTextContent().slice(0, ae) + h + b.getTextContent().slice(ae + c.focus.offset) !== yo($.anchorNode)) && ut(s, p, h);
        const he = h.length;
        De && he > 1 && u.inputType === "insertCompositionText" && !s.isComposing() && (c.anchor.offset -= he), !ne && !ue && !Re && s.isComposing() && (Yi = 0, vn(null));
      } else
        bs(!1, s, h !== null ? h : void 0), Vs && (A(s, h || void 0), Vs = !1);
      ml();
    }), Kr = null;
  }
  function x(u, s) {
    Gr(s, () => {
      const c = mn();
      if (Et(c) && !s.isComposing()) {
        const h = c.anchor, y = c.anchor.getNode();
        vn(h.key), // If it has been 30ms since the last keydown, then we should
        // apply the empty space heuristic. We can't do this for Safari,
        // as the keydown fires after composition start.
        (u.timeStamp < Yi + rr || // FF has issues around composing multibyte characters, so we also
        // need to invoke the empty space heuristic below.
        h.type === "element" || !c.isCollapsed() || y.getFormat() !== c.format || mt(y) && y.getStyle() !== c.style) && ut(s, p, Wt);
      }
    });
  }
  function A(u, s) {
    const c = u._compositionKey;
    if (vn(null), c !== null && s != null) {
      if (s === "") {
        const h = Nn(c), y = Fr(u.getElementByKey(c));
        y !== null && y.nodeValue !== null && mt(h) && Br(h, y.nodeValue, null, null, !0);
        return;
      }
      if (s[s.length - 1] === `
`) {
        const h = mn();
        if (Et(h)) {
          const y = h.focus;
          h.anchor.set(y.key, y.offset, y.type), ut(u, re, null);
          return;
        }
      }
    }
    bs(!0, u, s);
  }
  function Q(u, s) {
    De ? Vs = !0 : Gr(s, () => {
      A(s, u.data);
    });
  }
  function ge(u, s) {
    if (Yi = u.timeStamp, kl = u.keyCode, s.isComposing())
      return;
    const {
      keyCode: c,
      shiftKey: h,
      ctrlKey: y,
      metaKey: N,
      altKey: b
    } = u;
    if (!ut(s, v, u)) {
      if (as(c, y, b, N))
        ut(s, I, u);
      else if (Ma(c, y, h, b, N))
        ut(s, G, u);
      else if (Pc(c, y, b, N))
        ut(s, k, u);
      else if (Aa(c, y, h, b, N))
        ut(s, P, u);
      else if ($c(c, y, N))
        ut(s, H, u);
      else if (xl(c, y, N))
        ut(s, j, u);
      else if (El(c, h))
        js = !0, ut(s, re, u);
      else if (Fc(c))
        ut(s, te, u);
      else if (ks(c, y))
        u.preventDefault(), js = !0, ut(s, d, !0);
      else if (Cl(c, h))
        js = !1, ut(s, re, u);
      else if (Sa(c, b, N, y))
        Xr(c) ? ut(s, ce, u) : (u.preventDefault(), ut(s, l, !0));
      else if (Pi(c))
        ut(s, V, u);
      else if (Rc(c, y, h, b, N))
        $i(c) ? ut(s, z, u) : (u.preventDefault(), ut(s, l, !1));
      else if (Ps(c, b, y))
        u.preventDefault(), ut(s, T, !0);
      else if (Ta(c, b, y))
        u.preventDefault(), ut(s, T, !1);
      else if (xa(c, N))
        u.preventDefault(), ut(s, S, !0);
      else if (va(c, N))
        u.preventDefault(), ut(s, S, !1);
      else if (Ea(c, b, N, y))
        u.preventDefault(), ut(s, w, "bold");
      else if (Is(c, b, N, y))
        u.preventDefault(), ut(s, w, "underline");
      else if (ls(c, b, N, y))
        u.preventDefault(), ut(s, w, "italic");
      else if (Ca(c, b, y, N))
        ut(s, q, u);
      else if (bc(c, h, N, y))
        u.preventDefault(), ut(s, O, void 0);
      else if (wa(c, h, N, y))
        u.preventDefault(), ut(s, m, void 0);
      else {
        const $ = s._editorState._selection;
        Ur($) ? Lc(c, h, N, y) ? (u.preventDefault(), ut(s, Y, u)) : Ic(c, h, N, y) ? (u.preventDefault(), ut(s, W, u)) : No(c, N, y) && (u.preventDefault(), ut(s, J, u)) : !De && No(c, N, y) && (u.preventDefault(), ut(s, J, u));
      }
      $s(y, h, b, N) && ut(s, M, u);
    }
  }
  function Ae(u) {
    let s = u.__lexicalEventHandles;
    return s === void 0 && (s = [], u.__lexicalEventHandles = s), s;
  }
  const Ye = /* @__PURE__ */ new Map();
  function Xe(u) {
    const s = u.target, c = s == null ? null : s.nodeType === 9 ? s.defaultView : s.ownerDocument.defaultView, h = cr(c);
    if (h === null)
      return;
    const y = dl(h.anchorNode);
    if (y === null)
      return;
    Mo && (Mo = !1, Gr(y, () => {
      const me = Ho(), xe = h.anchorNode;
      if (xe === null)
        return;
      const we = xe.nodeType;
      if (we !== ke && we !== Fe)
        return;
      const Ce = Wc(me, h, y, u);
      Tr(Ce);
    }));
    const N = ki(y), b = N[N.length - 1], $ = b._key, ae = Ye.get($), he = ae || b;
    he !== y && $l(h, he, !1), $l(h, y, !0), y !== b ? Ye.set($, y) : ae && Ye.delete($);
  }
  function Ke(u) {
    u._lexicalHandled = !0;
  }
  function Pe(u) {
    return u._lexicalHandled === !0;
  }
  function gt(u, s) {
    Ys === 0 && u.ownerDocument.addEventListener("selectionchange", Xe), Ys++, u.__lexicalEditor = s;
    const c = Ae(u);
    for (let h = 0; h < Il.length; h++) {
      const [y, N] = Il[h], b = typeof N == "function" ? ($) => {
        Pe($) || (Ke($), s.isEditable() && N($, s));
      } : ($) => {
        if (!Pe($) && (Ke($), s.isEditable()))
          switch (y) {
            case "cut":
              return ut(s, W, $);
            case "copy":
              return ut(s, Y, $);
            case "paste":
              return ut(s, _, $);
            case "dragstart":
              return ut(s, D, $);
            case "dragover":
              return ut(s, Z, $);
            case "dragend":
              return ut(s, oe, $);
            case "focus":
              return ut(s, _e, $);
            case "blur":
              return ut(s, B, $);
            case "drop":
              return ut(s, de, $);
          }
      };
      u.addEventListener(y, b), c.push(() => {
        u.removeEventListener(y, b);
      });
    }
  }
  function wt(u) {
    Ys !== 0 && (Ys--, Ys === 0 && u.ownerDocument.removeEventListener("selectionchange", Xe));
    const s = u.__lexicalEditor;
    s != null && ($t(s), u.__lexicalEditor = null);
    const c = Ae(u);
    for (let h = 0; h < c.length; h++)
      c[h]();
    u.__lexicalEventHandles = [];
  }
  function $t(u) {
    if (u._parentEditor !== null) {
      const s = ki(u), h = s[s.length - 1]._key;
      Ye.get(h) === u && Ye.delete(h);
    } else
      Ye.delete(u._key);
  }
  function Kt() {
    zr = !0;
  }
  function Yn(u, s, c, h, y) {
    Ro = [u, s, c, h, y];
  }
  function Rr(u, s, c) {
    hr();
    const h = u.__key, y = u.getParent();
    if (y === null)
      return;
    const N = us(u);
    let b = !1;
    if (Et(N) && s) {
      const $ = N.anchor, ae = N.focus;
      $.key === h && (Va($, u, y, u.getPreviousSibling(), u.getNextSibling()), b = !0), ae.key === h && (Va(ae, u, y, u.getPreviousSibling(), u.getNextSibling()), b = !0);
    } else Ur(N) && s && u.isSelected() && u.selectPrevious();
    if (Et(N) && s && !b) {
      const $ = u.getIndexWithinParent();
      Zr(u), ja(N, y, $, -1);
    } else
      Zr(u);
    !c && !li(y) && !y.canBeEmpty() && y.isEmpty() && Rr(y, s), s && Yr(y) && y.isEmpty() && y.selectEnd();
  }
  class ai {
    // Allow us to look up the type including static props
    /** @internal */
    /** @internal */
    //@ts-ignore We set the key in the constructor.
    /** @internal */
    /** @internal */
    /** @internal */
    // Flow doesn't support abstract classes unfortunately, so we can't _force_
    // subclasses of Node to implement statics. All subclasses of Node should have
    // a static getType and clone method though. We define getType and clone here so we can call it
    // on any  Node, and we throw this error by default since the subclass should provide
    // their own implementation.
    /**
     * Returns the string type of this node. Every node must
     * implement this and it MUST BE UNIQUE amongst nodes registered
     * on the editor.
     *
     */
    static getType() {
      throw Error(`LexicalNode: Node ${this.name} does not implement .getType().`);
    }
    /**
     * Clones this node, creating a new node with a different key
     * and adding it to the EditorState (but not attaching it anywhere!). All nodes must
     * implement this method.
     *
     */
    static clone(s) {
      throw Error(`LexicalNode: Node ${this.name} does not implement .clone().`);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(s) {
      this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, fl(this, s), this.__type !== "root" && (hr(), ci(this.__type, this.constructor));
    }
    // Getters and Traversers
    /**
     * Returns the string type of this node.
     */
    getType() {
      return this.__type;
    }
    isInline() {
      throw Error(`LexicalNode: Node ${this.constructor.name} does not implement .isInline().`);
    }
    /**
     * Returns true if there is a path between this node and the RootNode, false otherwise.
     * This is a way of determining if the node is "attached" EditorState. Unattached nodes
     * won't be reconciled and will ultimatelt be cleaned up by the Lexical GC.
     */
    isAttached() {
      let s = this.__key;
      for (; s !== null; ) {
        if (s === "root")
          return !0;
        const c = Nn(s);
        if (c === null)
          break;
        s = c.__parent;
      }
      return !1;
    }
    /**
     * Returns true if this node is contained within the provided Selection., false otherwise.
     * Relies on the algorithms implemented in {@link BaseSelection.getNodes} to determine
     * what's included.
     *
     * @param selection - The selection that we want to determine if the node is in.
     */
    isSelected(s) {
      const c = s || mn();
      if (c == null)
        return !1;
      const h = c.getNodes().some((y) => y.__key === this.__key);
      return mt(this) ? h : Et(c) && c.anchor.type === "element" && c.focus.type === "element" && c.anchor.key === c.focus.key && c.anchor.offset === c.focus.offset ? !1 : h;
    }
    /**
     * Returns this nodes key.
     */
    getKey() {
      return this.__key;
    }
    /**
     * Returns the zero-based index of this node within the parent.
     */
    getIndexWithinParent() {
      const s = this.getParent();
      if (s === null)
        return -1;
      let c = s.getFirstChild(), h = 0;
      for (; c !== null; ) {
        if (this.is(c))
          return h;
        h++, c = c.getNextSibling();
      }
      return -1;
    }
    /**
     * Returns the parent of this node, or null if none is found.
     */
    getParent() {
      const s = this.getLatest().__parent;
      return s === null ? null : Nn(s);
    }
    /**
     * Returns the parent of this node, or throws if none is found.
     */
    getParentOrThrow() {
      const s = this.getParent();
      if (s === null)
        throw Error(`Expected node ${this.__key} to have a parent.`);
      return s;
    }
    /**
     * Returns the highest (in the EditorState tree)
     * non-root ancestor of this node, or null if none is found. See {@link lexical!$isRootOrShadowRoot}
     * for more information on which Elements comprise "roots".
     */
    getTopLevelElement() {
      let s = this;
      for (; s !== null; ) {
        const c = s.getParent();
        if (li(c)) {
          if (!et(s))
            throw Error("Children of root nodes must be elements");
          return s;
        }
        s = c;
      }
      return null;
    }
    /**
     * Returns the highest (in the EditorState tree)
     * non-root ancestor of this node, or throws if none is found. See {@link lexical!$isRootOrShadowRoot}
     * for more information on which Elements comprise "roots".
     */
    getTopLevelElementOrThrow() {
      const s = this.getTopLevelElement();
      if (s === null)
        throw Error(`Expected node ${this.__key} to have a top parent element.`);
      return s;
    }
    /**
     * Returns a list of the every ancestor of this node,
     * all the way up to the RootNode.
     *
     */
    getParents() {
      const s = [];
      let c = this.getParent();
      for (; c !== null; )
        s.push(c), c = c.getParent();
      return s;
    }
    /**
     * Returns a list of the keys of every ancestor of this node,
     * all the way up to the RootNode.
     *
     */
    getParentKeys() {
      const s = [];
      let c = this.getParent();
      for (; c !== null; )
        s.push(c.__key), c = c.getParent();
      return s;
    }
    /**
     * Returns the "previous" siblings - that is, the node that comes
     * before this one in the same parent.
     *
     */
    getPreviousSibling() {
      const c = this.getLatest().__prev;
      return c === null ? null : Nn(c);
    }
    /**
     * Returns the "previous" siblings - that is, the nodes that come between
     * this one and the first child of it's parent, inclusive.
     *
     */
    getPreviousSiblings() {
      const s = [], c = this.getParent();
      if (c === null)
        return s;
      let h = c.getFirstChild();
      for (; h !== null && !h.is(this); )
        s.push(h), h = h.getNextSibling();
      return s;
    }
    /**
     * Returns the "next" siblings - that is, the node that comes
     * after this one in the same parent
     *
     */
    getNextSibling() {
      const c = this.getLatest().__next;
      return c === null ? null : Nn(c);
    }
    /**
     * Returns all "next" siblings - that is, the nodes that come between this
     * one and the last child of it's parent, inclusive.
     *
     */
    getNextSiblings() {
      const s = [];
      let c = this.getNextSibling();
      for (; c !== null; )
        s.push(c), c = c.getNextSibling();
      return s;
    }
    /**
     * Returns the closest common ancestor of this node and the provided one or null
     * if one cannot be found.
     *
     * @param node - the other node to find the common ancestor of.
     */
    getCommonAncestor(s) {
      const c = this.getParents(), h = s.getParents();
      et(this) && c.unshift(this), et(s) && h.unshift(s);
      const y = c.length, N = h.length;
      if (y === 0 || N === 0 || c[y - 1] !== h[N - 1])
        return null;
      const b = new Set(h);
      for (let $ = 0; $ < y; $++) {
        const ae = c[$];
        if (b.has(ae))
          return ae;
      }
      return null;
    }
    /**
     * Returns true if the provided node is the exact same one as this node, from Lexical's perspective.
     * Always use this instead of referential equality.
     *
     * @param object - the node to perform the equality comparison on.
     */
    is(s) {
      return s == null ? !1 : this.__key === s.__key;
    }
    /**
     * Returns true if this node logical precedes the target node in the editor state.
     *
     * @param targetNode - the node we're testing to see if it's after this one.
     */
    isBefore(s) {
      if (this === s)
        return !1;
      if (s.isParentOf(this))
        return !0;
      if (this.isParentOf(s))
        return !1;
      const c = this.getCommonAncestor(s);
      let h = 0, y = 0, N = this;
      for (; ; ) {
        const b = N.getParentOrThrow();
        if (b === c) {
          h = N.getIndexWithinParent();
          break;
        }
        N = b;
      }
      for (N = s; ; ) {
        const b = N.getParentOrThrow();
        if (b === c) {
          y = N.getIndexWithinParent();
          break;
        }
        N = b;
      }
      return h < y;
    }
    /**
     * Returns true if this node is the parent of the target node, false otherwise.
     *
     * @param targetNode - the would-be child node.
     */
    isParentOf(s) {
      const c = this.__key;
      if (c === s.__key)
        return !1;
      let h = s;
      for (; h !== null; ) {
        if (h.__key === c)
          return !0;
        h = h.getParent();
      }
      return !1;
    }
    // TO-DO: this function can be simplified a lot
    /**
     * Returns a list of nodes that are between this node and
     * the target node in the EditorState.
     *
     * @param targetNode - the node that marks the other end of the range of nodes to be returned.
     */
    getNodesBetween(s) {
      const c = this.isBefore(s), h = [], y = /* @__PURE__ */ new Set();
      let N = this;
      for (; ; ) {
        const b = N.__key;
        if (y.has(b) || (y.add(b), h.push(N)), N === s)
          break;
        const $ = et(N) ? c ? N.getFirstChild() : N.getLastChild() : null;
        if ($ !== null) {
          N = $;
          continue;
        }
        const ae = c ? N.getNextSibling() : N.getPreviousSibling();
        if (ae !== null) {
          N = ae;
          continue;
        }
        const he = N.getParentOrThrow();
        if (y.has(he.__key) || h.push(he), he === s)
          break;
        let me = null, xe = he;
        do {
          if (xe === null)
            throw Error("getNodesBetween: ancestor is null");
          me = c ? xe.getNextSibling() : xe.getPreviousSibling(), xe = xe.getParent(), xe !== null && me === null && !y.has(xe.__key) && h.push(xe);
        } while (me === null);
        N = me;
      }
      return c || h.reverse(), h;
    }
    /**
     * Returns true if this node has been marked dirty during this update cycle.
     *
     */
    isDirty() {
      const c = Tn()._dirtyLeaves;
      return c !== null && c.has(this.__key);
    }
    /**
     * Returns the latest version of the node from the active EditorState.
     * This is used to avoid getting values from stale node references.
     *
     */
    getLatest() {
      const s = Nn(this.__key);
      if (s === null)
        throw Error("Lexical node does not exist in active editor state. Avoid using the same node references between nested closures from editorState.read/editor.update.");
      return s;
    }
    /**
     * Returns a mutable version of the node. Will throw an error if
     * called outside of a Lexical Editor {@link LexicalEditor.update} callback.
     *
     */
    getWritable() {
      hr();
      const s = Si(), c = Tn(), h = s._nodeMap, y = this.__key, N = this.getLatest(), b = N.__parent, $ = c._cloneNotNeeded, ae = mn();
      if (dr(ae) && ae.setCachedNodes(null), $.has(y))
        return bi(N), N;
      const me = N.constructor.clone(N);
      return me.__parent = b, me.__next = N.__next, me.__prev = N.__prev, et(N) && et(me) ? (me.__first = N.__first, me.__last = N.__last, me.__size = N.__size, me.__indent = N.__indent, me.__format = N.__format, me.__dir = N.__dir) : mt(N) && mt(me) && (me.__format = N.__format, me.__style = N.__style, me.__mode = N.__mode, me.__detail = N.__detail), $.add(y), me.__key = y, bi(me), h.set(y, me), me;
    }
    /**
     * Returns the text content of the node. Override this for
     * custom nodes that should have a representation in plain text
     * format (for copy + paste, for example)
     *
     */
    getTextContent() {
      return "";
    }
    /**
     * Returns the length of the string produced by calling getTextContent on this node.
     *
     */
    getTextContentSize() {
      return this.getTextContent().length;
    }
    // View
    /**
     * Called during the reconciliation process to determine which nodes
     * to insert into the DOM for this Lexical Node.
     *
     * This method must return exactly one HTMLElement. Nested elements are not supported.
     *
     * Do not attempt to update the Lexical EditorState during this phase of the update lifecyle.
     *
     * @param _config - allows access to things like the EditorTheme (to apply classes) during reconciliation.
     * @param _editor - allows access to the editor for context during reconciliation.
     *
     * */
    createDOM(s, c) {
      throw Error("createDOM: base method not extended");
    }
    /**
     * Called when a node changes and should update the DOM
     * in whatever way is necessary to make it align with any changes that might
     * have happened during the update.
     *
     * Returning "true" here will cause lexical to unmount and recreate the DOM node
     * (by calling createDOM). You would need to do this if the element tag changes,
     * for instance.
     *
     * */
    updateDOM(s, c, h) {
      throw Error("updateDOM: base method not extended");
    }
    /**
     * Controls how the this node is serialized to HTML. This is important for
     * copy and paste between Lexical and non-Lexical editors, or Lexical editors with different namespaces,
     * in which case the primary transfer format is HTML. It's also important if you're serializing
     * to HTML for any other reason via {@link @lexical/html!$generateHtmlFromNodes}. You could
     * also use this method to build your own HTML renderer.
     *
     * */
    exportDOM(s) {
      return {
        element: this.createDOM(s._config, s)
      };
    }
    /**
     * Controls how the this node is serialized to JSON. This is important for
     * copy and paste between Lexical editors sharing the same namespace. It's also important
     * if you're serializing to JSON for persistent storage somewhere.
     * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
     *
     * */
    exportJSON() {
      throw Error("exportJSON: base method not extended");
    }
    /**
     * Controls how the this node is deserialized from JSON. This is usually boilerplate,
     * but provides an abstraction between the node implementation and serialized interface that can
     * be important if you ever make breaking changes to a node schema (by adding or removing properties).
     * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
     *
     * */
    static importJSON(s) {
      throw Error(`LexicalNode: Node ${this.name} does not implement .importJSON().`);
    }
    /**
     * @experimental
     *
     * Registers the returned function as a transform on the node during
     * Editor initialization. Most such use cases should be addressed via
     * the {@link LexicalEditor.registerNodeTransform} API.
     *
     * Experimental - use at your own risk.
     */
    static transform() {
      return null;
    }
    // Setters and mutators
    /**
     * Removes this LexicalNode from the EditorState. If the node isn't re-inserted
     * somewhere, the Lexical garbage collector will eventually clean it up.
     *
     * @param preserveEmptyParent - If falsy, the node's parent will be removed if
     * it's empty after the removal operation. This is the default behavior, subject to
     * other node heuristics such as {@link ElementNode#canBeEmpty}
     * */
    remove(s) {
      Rr(this, !0, s);
    }
    /**
     * Replaces this LexicalNode with the provided node, optionally transferring the children
     * of the replaced node to the replacing node.
     *
     * @param replaceWith - The node to replace this one with.
     * @param includeChildren - Whether or not to transfer the children of this node to the replacing node.
     * */
    replace(s, c) {
      hr();
      let h = mn();
      h !== null && (h = h.clone()), Bs(this, s);
      const y = this.getLatest(), N = this.__key, b = s.__key, $ = s.getWritable(), ae = this.getParentOrThrow().getWritable(), he = ae.__size;
      Zr($);
      const me = y.getPreviousSibling(), xe = y.getNextSibling(), we = y.__prev, Ce = y.__next, Ve = y.__parent;
      if (Rr(y, !1, !0), me === null)
        ae.__first = b;
      else {
        const Ue = me.getWritable();
        Ue.__next = b;
      }
      if ($.__prev = we, xe === null)
        ae.__last = b;
      else {
        const Ue = xe.getWritable();
        Ue.__prev = b;
      }
      if ($.__next = Ce, $.__parent = Ve, ae.__size = he, c) {
        if (!(et(this) && et($)))
          throw Error("includeChildren should only be true for ElementNodes");
        this.getChildren().forEach((Ue) => {
          $.append(Ue);
        });
      }
      if (Et(h)) {
        Tr(h);
        const Ue = h.anchor, $e = h.focus;
        Ue.key === N && pn(Ue, $), $e.key === N && pn($e, $);
      }
      return ar() === N && vn(b), $;
    }
    /**
     * Inserts a node after this LexicalNode (as the next sibling).
     *
     * @param nodeToInsert - The node to insert after this one.
     * @param restoreSelection - Whether or not to attempt to resolve the
     * selection to the appropriate place after the operation is complete.
     * */
    insertAfter(s, c = !0) {
      hr(), Bs(this, s);
      const h = this.getWritable(), y = s.getWritable(), N = y.getParent(), b = mn();
      let $ = !1, ae = !1;
      if (N !== null) {
        const Ce = s.getIndexWithinParent();
        if (Zr(y), Et(b)) {
          const Ve = N.__key, Ue = b.anchor, $e = b.focus;
          $ = Ue.type === "element" && Ue.key === Ve && Ue.offset === Ce + 1, ae = $e.type === "element" && $e.key === Ve && $e.offset === Ce + 1;
        }
      }
      const he = this.getNextSibling(), me = this.getParentOrThrow().getWritable(), xe = y.__key, we = h.__next;
      if (he === null)
        me.__last = xe;
      else {
        const Ce = he.getWritable();
        Ce.__prev = xe;
      }
      if (me.__size++, h.__next = xe, y.__next = we, y.__prev = h.__key, y.__parent = h.__parent, c && Et(b)) {
        const Ce = this.getIndexWithinParent();
        ja(b, me, Ce + 1);
        const Ve = me.__key;
        $ && b.anchor.set(Ve, Ce + 2, "element"), ae && b.focus.set(Ve, Ce + 2, "element");
      }
      return s;
    }
    /**
     * Inserts a node before this LexicalNode (as the previous sibling).
     *
     * @param nodeToInsert - The node to insert before this one.
     * @param restoreSelection - Whether or not to attempt to resolve the
     * selection to the appropriate place after the operation is complete.
     * */
    insertBefore(s, c = !0) {
      hr(), Bs(this, s);
      const h = this.getWritable(), y = s.getWritable(), N = y.__key;
      Zr(y);
      const b = this.getPreviousSibling(), $ = this.getParentOrThrow().getWritable(), ae = h.__prev, he = this.getIndexWithinParent();
      if (b === null)
        $.__first = N;
      else {
        const xe = b.getWritable();
        xe.__next = N;
      }
      $.__size++, h.__prev = N, y.__prev = ae, y.__next = h.__key, y.__parent = h.__parent;
      const me = mn();
      if (c && Et(me)) {
        const xe = this.getParentOrThrow();
        ja(me, xe, he);
      }
      return s;
    }
    /**
     * Whether or not this node has a required parent. Used during copy + paste operations
     * to normalize nodes that would otherwise be orphaned. For example, ListItemNodes without
     * a ListNode parent or TextNodes with a ParagraphNode parent.
     *
     * */
    isParentRequired() {
      return !1;
    }
    /**
     * The creation logic for any required parent. Should be implemented if {@link isParentRequired} returns true.
     *
     * */
    createParentElementNode() {
      return Zi();
    }
    selectStart() {
      return this.selectPrevious();
    }
    selectEnd() {
      return this.selectNext(0, 0);
    }
    /**
     * Moves selection to the previous sibling of this node, at the specified offsets.
     *
     * @param anchorOffset - The anchor offset for selection.
     * @param focusOffset -  The focus offset for selection
     * */
    selectPrevious(s, c) {
      hr();
      const h = this.getPreviousSibling(), y = this.getParentOrThrow();
      if (h === null)
        return y.select(0, 0);
      if (et(h))
        return h.select();
      if (!mt(h)) {
        const N = h.getIndexWithinParent() + 1;
        return y.select(N, N);
      }
      return h.select(s, c);
    }
    /**
     * Moves selection to the next sibling of this node, at the specified offsets.
     *
     * @param anchorOffset - The anchor offset for selection.
     * @param focusOffset -  The focus offset for selection
     * */
    selectNext(s, c) {
      hr();
      const h = this.getNextSibling(), y = this.getParentOrThrow();
      if (h === null)
        return y.select();
      if (et(h))
        return h.select(0, 0);
      if (!mt(h)) {
        const N = h.getIndexWithinParent();
        return y.select(N, N);
      }
      return h.select(s, c);
    }
    /**
     * Marks a node dirty, triggering transforms and
     * forcing it to be reconciled during the update cycle.
     *
     * */
    markDirty() {
      this.getWritable();
    }
  }
  function ci(u, s) {
    const c = Tn()._nodes.get(u);
    if (c === void 0)
      throw Error(`Create node: Attempted to create node ${s.name} that was not configured to be used on the editor.`);
    const h = c.klass;
    if (h !== s)
      throw Error(`Create node: Type ${u} in node ${s.name} does not match registered node ${h.name} with the same type`);
  }
  function Bl(u, s, c) {
    const h = s.getParentOrThrow().getLastChild();
    let y = s;
    const N = [s];
    for (; y !== h; ) {
      if (!y.getNextSibling())
        throw Error("insertRangeAfter: lastToInsert must be a later sibling of firstToInsert");
      y = y.getNextSibling(), N.push(y);
    }
    let b = u;
    for (const $ of N)
      b = b.insertAfter($);
  }
  class Vi extends ai {
    static getType() {
      return "linebreak";
    }
    static clone(s) {
      return new Vi(s.__key);
    }
    constructor(s) {
      super(s);
    }
    getTextContent() {
      return `
`;
    }
    createDOM() {
      return document.createElement("br");
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return {
        br: (s) => {
          const c = s.parentElement;
          let h, y;
          return c !== null && ((h = c.firstChild) === s || h.nextSibling === s && h.nodeType === Fe && (h.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) && ((y = c.lastChild) === s || y.previousSibling === s && y.nodeType === Fe && (y.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) ? null : {
            conversion: bo,
            priority: 0
          };
        }
      };
    }
    static importJSON(s) {
      return ms();
    }
    exportJSON() {
      return {
        type: "linebreak",
        version: 1
      };
    }
  }
  function bo(u) {
    return {
      node: ms()
    };
  }
  function ms() {
    return Mr(new Vi());
  }
  function ui(u) {
    return u instanceof Vi;
  }
  function br(u, s) {
    return s & Le ? "code" : s & rt ? "mark" : s & Me ? "sub" : s & je ? "sup" : null;
  }
  function qi(u, s) {
    return s & Oe ? "strong" : s & ie ? "em" : "span";
  }
  function Lo(u, s, c, h, y) {
    const N = h.classList;
    let b = Fi(y, "base");
    b !== void 0 && N.add(...b), b = Fi(y, "underlineStrikethrough");
    let $ = !1;
    const ae = s & ve && s & le, he = c & ve && c & le;
    b !== void 0 && (he ? ($ = !0, ae || N.add(...b)) : ae && N.remove(...b));
    for (const me in nn) {
      const we = nn[me];
      if (b = Fi(y, me), b !== void 0)
        if (c & we) {
          if ($ && (me === "underline" || me === "strikethrough")) {
            s & we && N.remove(...b);
            continue;
          }
          (!(s & we) || ae && me === "underline" || me === "strikethrough") && N.add(...b);
        } else s & we && N.remove(...b);
    }
  }
  function Wa(u, s) {
    const c = u.length, h = s.length;
    let y = 0, N = 0;
    for (; y < c && y < h && u[y] === s[y]; )
      y++;
    for (; N + y < c && N + y < h && u[c - N - 1] === s[h - N - 1]; )
      N++;
    return [y, c - y - N, s.slice(y, h - N)];
  }
  function Ka(u, s, c) {
    const h = s.firstChild, y = c.isComposing(), b = u + (y ? pt : "");
    if (h == null)
      s.textContent = b;
    else {
      const $ = h.nodeValue;
      if ($ !== b)
        if (y || De) {
          const [ae, he, me] = Wa($, b);
          he !== 0 && h.deleteData(ae, he), h.insertData(ae, me);
        } else
          h.nodeValue = b;
    }
  }
  function Hl(u, s, c, h, y, N) {
    Ka(y, u, s);
    const $ = N.theme.text;
    $ !== void 0 && Lo(c, 0, h, u, $);
  }
  function qs(u, s) {
    const c = document.createElement(s);
    return c.appendChild(u), c;
  }
  class Qr extends ai {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "text";
    }
    static clone(s) {
      return new Qr(s.__text, s.__key);
    }
    constructor(s, c) {
      super(c), this.__text = s, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
    }
    /**
     * Returns a 32-bit integer that represents the TextFormatTypes currently applied to the
     * TextNode. You probably don't want to use this method directly - consider using TextNode.hasFormat instead.
     *
     * @returns a number representing the format of the text node.
     */
    getFormat() {
      return this.getLatest().__format;
    }
    /**
     * Returns a 32-bit integer that represents the TextDetailTypes currently applied to the
     * TextNode. You probably don't want to use this method directly - consider using TextNode.isDirectionless
     * or TextNode.isUnmergeable instead.
     *
     * @returns a number representing the detail of the text node.
     */
    getDetail() {
      return this.getLatest().__detail;
    }
    /**
     * Returns the mode (TextModeType) of the TextNode, which may be "normal", "token", or "segmented"
     *
     * @returns TextModeType.
     */
    getMode() {
      const s = this.getLatest();
      return ot[s.__mode];
    }
    /**
     * Returns the styles currently applied to the node. This is analogous to CSSText in the DOM.
     *
     * @returns CSSText-like string of styles applied to the underlying DOM node.
     */
    getStyle() {
      return this.getLatest().__style;
    }
    /**
     * Returns whether or not the node is in "token" mode. TextNodes in token mode can be navigated through character-by-character
     * with a RangeSelection, but are deleted as a single entity (not invdividually by character).
     *
     * @returns true if the node is in token mode, false otherwise.
     */
    isToken() {
      return this.getLatest().__mode === zt;
    }
    /**
     *
     * @returns true if Lexical detects that an IME or other 3rd-party script is attempting to
     * mutate the TextNode, false otherwise.
     */
    isComposing() {
      return this.__key === ar();
    }
    /**
     * Returns whether or not the node is in "segemented" mode. TextNodes in segemented mode can be navigated through character-by-character
     * with a RangeSelection, but are deleted in space-delimited "segments".
     *
     * @returns true if the node is in segmented mode, false otherwise.
     */
    isSegmented() {
      return this.getLatest().__mode === en;
    }
    /**
     * Returns whether or not the node is "directionless". Directionless nodes don't respect changes between RTL and LTR modes.
     *
     * @returns true if the node is directionless, false otherwise.
     */
    isDirectionless() {
      return (this.getLatest().__detail & st) !== 0;
    }
    /**
     * Returns whether or not the node is unmergeable. In some scenarios, Lexical tries to merge
     * adjacent TextNodes into a single TextNode. If a TextNode is unmergeable, this won't happen.
     *
     * @returns true if the node is unmergeable, false otherwise.
     */
    isUnmergeable() {
      return (this.getLatest().__detail & vt) !== 0;
    }
    /**
     * Returns whether or not the node has the provided format applied. Use this with the human-readable TextFormatType
     * string values to get the format of a TextNode.
     *
     * @param type - the TextFormatType to check for.
     *
     * @returns true if the node has the provided format, false otherwise.
     */
    hasFormat(s) {
      const c = nn[s];
      return (this.getFormat() & c) !== 0;
    }
    /**
     * Returns whether or not the node is simple text. Simple text is defined as a TextNode that has the string type "text"
     * (i.e., not a subclass) and has no mode applied to it (i.e., not segmented or token).
     *
     * @returns true if the node is simple text, false otherwise.
     */
    isSimpleText() {
      return this.__type === "text" && this.__mode === 0;
    }
    /**
     * Returns the text content of the node as a string.
     *
     * @returns a string representing the text content of the node.
     */
    getTextContent() {
      return this.getLatest().__text;
    }
    /**
     * Returns the format flags applied to the node as a 32-bit integer.
     *
     * @returns a number representing the TextFormatTypes applied to the node.
     */
    getFormatFlags(s, c) {
      const y = this.getLatest().__format;
      return Bn(y, s, c);
    }
    // View
    createDOM(s, c) {
      const h = this.__format, y = br(this, h), N = qi(this, h), b = y === null ? N : y, $ = document.createElement(b);
      let ae = $;
      this.hasFormat("code") && $.setAttribute("spellcheck", "false"), y !== null && (ae = document.createElement(N), $.appendChild(ae));
      const he = this.__text;
      Hl(ae, this, N, h, he, s);
      const me = this.__style;
      return me !== "" && ($.style.cssText = me), $;
    }
    updateDOM(s, c, h) {
      const y = this.__text, N = s.__format, b = this.__format, $ = br(this, N), ae = br(this, b), he = qi(this, N), me = qi(this, b);
      if (($ === null ? he : $) !== (ae === null ? me : ae))
        return !0;
      if ($ === ae && he !== me) {
        const Qe = c.firstChild;
        if (Qe == null)
          throw Error("updateDOM: prevInnerDOM is null or undefined");
        const ft = document.createElement(me);
        return Hl(ft, this, me, b, y, h), c.replaceChild(ft, Qe), !1;
      }
      let Ce = c;
      if (ae !== null && $ !== null && (Ce = c.firstChild, Ce == null))
        throw Error("updateDOM: innerDOM is null or undefined");
      Ka(y, Ce, this);
      const Ue = h.theme.text;
      Ue !== void 0 && N !== b && Lo(me, N, b, Ce, Ue);
      const $e = s.__style, Mt = this.__style;
      return $e !== Mt && (c.style.cssText = Mt), !1;
    }
    static importDOM() {
      return {
        "#text": () => ({
          conversion: ko,
          priority: 0
        }),
        b: () => ({
          conversion: Wl,
          priority: 0
        }),
        code: () => ({
          conversion: ei,
          priority: 0
        }),
        em: () => ({
          conversion: ei,
          priority: 0
        }),
        i: () => ({
          conversion: ei,
          priority: 0
        }),
        s: () => ({
          conversion: ei,
          priority: 0
        }),
        span: () => ({
          conversion: za,
          priority: 0
        }),
        strong: () => ({
          conversion: ei,
          priority: 0
        }),
        sub: () => ({
          conversion: ei,
          priority: 0
        }),
        sup: () => ({
          conversion: ei,
          priority: 0
        }),
        u: () => ({
          conversion: ei,
          priority: 0
        })
      };
    }
    static importJSON(s) {
      const c = Dn(s.text);
      return c.setFormat(s.format), c.setDetail(s.detail), c.setMode(s.mode), c.setStyle(s.style), c;
    }
    // This improves Lexical's basic text output in copy+paste plus
    // for headless mode where people might use Lexical to generate
    // HTML content and not have the ability to use CSS classes.
    exportDOM(s) {
      let {
        element: c
      } = super.exportDOM(s);
      if (!(c !== null && Ws(c)))
        throw Error("Expected TextNode createDOM to always return a HTMLElement");
      return c.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (c = qs(c, "b")), this.hasFormat("italic") && (c = qs(c, "i")), this.hasFormat("strikethrough") && (c = qs(c, "s")), this.hasFormat("underline") && (c = qs(c, "u")), {
        element: c
      };
    }
    exportJSON() {
      return {
        detail: this.getDetail(),
        format: this.getFormat(),
        mode: this.getMode(),
        style: this.getStyle(),
        text: this.getTextContent(),
        type: "text",
        version: 1
      };
    }
    // Mutators
    selectionTransform(s, c) {
    }
    /**
     * Sets the node format to the provided TextFormatType or 32-bit integer. Note that the TextFormatType
     * version of the argument can only specify one format and doing so will remove all other formats that
     * may be applied to the node. For toggling behavior, consider using {@link TextNode.toggleFormat}
     *
     * @param format - TextFormatType or 32-bit integer representing the node format.
     *
     * @returns this TextNode.
     * // TODO 0.12 This should just be a `string`.
     */
    setFormat(s) {
      const c = this.getWritable();
      return c.__format = typeof s == "string" ? nn[s] : s, c;
    }
    /**
     * Sets the node detail to the provided TextDetailType or 32-bit integer. Note that the TextDetailType
     * version of the argument can only specify one detail value and doing so will remove all other detail values that
     * may be applied to the node. For toggling behavior, consider using {@link TextNode.toggleDirectionless}
     * or {@link TextNode.togglerUnmergeable}
     *
     * @param detail - TextDetailType or 32-bit integer representing the node detail.
     *
     * @returns this TextNode.
     * // TODO 0.12 This should just be a `string`.
     */
    setDetail(s) {
      const c = this.getWritable();
      return c.__detail = typeof s == "string" ? Ar[s] : s, c;
    }
    /**
     * Sets the node style to the provided CSSText-like string. Set this property as you
     * would an HTMLElement style attribute to apply inline styles to the underlying DOM Element.
     *
     * @param style - CSSText to be applied to the underlying HTMLElement.
     *
     * @returns this TextNode.
     */
    setStyle(s) {
      const c = this.getWritable();
      return c.__style = s, c;
    }
    /**
     * Applies the provided format to this TextNode if it's not present. Removes it if it's present.
     * The subscript and superscript formats are mutually exclusive.
     * Prefer using this method to turn specific formats on and off.
     *
     * @param type - TextFormatType to toggle.
     *
     * @returns this TextNode.
     */
    toggleFormat(s) {
      const c = this.getFormat(), h = Bn(c, s, null);
      return this.setFormat(h);
    }
    /**
     * Toggles the directionless detail value of the node. Prefer using this method over setDetail.
     *
     * @returns this TextNode.
     */
    toggleDirectionless() {
      const s = this.getWritable();
      return s.__detail ^= st, s;
    }
    /**
     * Toggles the unmergeable detail value of the node. Prefer using this method over setDetail.
     *
     * @returns this TextNode.
     */
    toggleUnmergeable() {
      const s = this.getWritable();
      return s.__detail ^= vt, s;
    }
    /**
     * Sets the mode of the node.
     *
     * @returns this TextNode.
     */
    setMode(s) {
      const c = Ze[s];
      if (this.__mode === c)
        return this;
      const h = this.getWritable();
      return h.__mode = c, h;
    }
    /**
     * Sets the text content of the node.
     *
     * @param text - the string to set as the text value of the node.
     *
     * @returns this TextNode.
     */
    setTextContent(s) {
      if (this.__text === s)
        return this;
      const c = this.getWritable();
      return c.__text = s, c;
    }
    /**
     * Sets the current Lexical selection to be a RangeSelection with anchor and focus on this TextNode at the provided offsets.
     *
     * @param _anchorOffset - the offset at which the Selection anchor will be placed.
     * @param _focusOffset - the offset at which the Selection focus will be placed.
     *
     * @returns the new RangeSelection.
     */
    select(s, c) {
      hr();
      let h = s, y = c;
      const N = mn(), b = this.getTextContent(), $ = this.__key;
      if (typeof b == "string") {
        const ae = b.length;
        h === void 0 && (h = ae), y === void 0 && (y = ae);
      } else
        h = 0, y = 0;
      if (Et(N)) {
        const ae = ar();
        (ae === N.anchor.key || ae === N.focus.key) && vn($), N.setTextNodeRange(this, h, this, y);
      } else
        return Ud($, h, $, y, "text", "text");
      return N;
    }
    selectStart() {
      return this.select(0, 0);
    }
    selectEnd() {
      const s = this.getTextContentSize();
      return this.select(s, s);
    }
    /**
     * Inserts the provided text into this TextNode at the provided offset, deleting the number of characters
     * specified. Can optionally calculate a new selection after the operation is complete.
     *
     * @param offset - the offset at which the splice operation should begin.
     * @param delCount - the number of characters to delete, starting from the offset.
     * @param newText - the text to insert into the TextNode at the offset.
     * @param moveSelection - optional, whether or not to move selection to the end of the inserted substring.
     *
     * @returns this TextNode.
     */
    spliceText(s, c, h, y) {
      const N = this.getWritable(), b = N.__text, $ = h.length;
      let ae = s;
      ae < 0 && (ae = $ + ae, ae < 0 && (ae = 0));
      const he = mn();
      if (y && Et(he)) {
        const xe = s + $;
        he.setTextNodeRange(N, xe, N, xe);
      }
      const me = b.slice(0, ae) + h + b.slice(ae + c);
      return N.__text = me, N;
    }
    /**
     * This method is meant to be overriden by TextNode subclasses to control the behavior of those nodes
     * when a user event would cause text to be inserted before them in the editor. If true, Lexical will attempt
     * to insert text into this node. If false, it will insert the text in a new sibling node.
     *
     * @returns true if text can be inserted before the node, false otherwise.
     */
    canInsertTextBefore() {
      return !0;
    }
    /**
     * This method is meant to be overriden by TextNode subclasses to control the behavior of those nodes
     * when a user event would cause text to be inserted after them in the editor. If true, Lexical will attempt
     * to insert text into this node. If false, it will insert the text in a new sibling node.
     *
     * @returns true if text can be inserted after the node, false otherwise.
     */
    canInsertTextAfter() {
      return !0;
    }
    /**
     * Splits this TextNode at the provided character offsets, forming new TextNodes from the substrings
     * formed by the split, and inserting those new TextNodes into the editor, replacing the one that was split.
     *
     * @param splitOffsets - rest param of the text content character offsets at which this node should be split.
     *
     * @returns an Array containing the newly-created TextNodes.
     */
    splitText(...s) {
      hr();
      const c = this.getLatest(), h = c.getTextContent(), y = c.__key, N = ar(), b = new Set(s), $ = [], ae = h.length;
      let he = "";
      for (let an = 0; an < ae; an++)
        he !== "" && b.has(an) && ($.push(he), he = ""), he += h[an];
      he !== "" && $.push(he);
      const me = $.length;
      if (me === 0)
        return [];
      if ($[0] === h)
        return [c];
      const xe = $[0], we = c.getParentOrThrow();
      let Ce;
      const Ve = c.getFormat(), Ue = c.getStyle(), $e = c.__detail;
      let Mt = !1;
      c.isSegmented() ? (Ce = Dn(xe), Ce.__format = Ve, Ce.__style = Ue, Ce.__detail = $e, Mt = !0) : (Ce = c.getWritable(), Ce.__text = xe);
      const Qe = mn(), ft = [Ce];
      let qt = xe.length;
      for (let an = 1; an < me; an++) {
        const sr = $[an], _s = sr.length, gr = Dn(sr).getWritable();
        gr.__format = Ve, gr.__style = Ue, gr.__detail = $e;
        const rn = gr.__key, kn = qt + _s;
        if (Et(Qe)) {
          const fi = Qe.anchor, Ji = Qe.focus;
          fi.key === y && fi.type === "text" && fi.offset > qt && fi.offset <= kn && (fi.key = rn, fi.offset -= qt, Qe.dirty = !0), Ji.key === y && Ji.type === "text" && Ji.offset > qt && Ji.offset <= kn && (Ji.key = rn, Ji.offset -= qt, Qe.dirty = !0);
        }
        N === y && vn(rn), qt = kn, ft.push(gr);
      }
      gl(this);
      const Ht = we.getWritable(), Ot = this.getIndexWithinParent();
      return Mt ? (Ht.splice(Ot, 0, ft), this.remove()) : Ht.splice(Ot, 1, ft), Et(Qe) && ja(Qe, we, Ot, me - 1), ft;
    }
    /**
     * Merges the target TextNode into this TextNode, removing the target node.
     *
     * @param target - the TextNode to merge into this one.
     *
     * @returns this TextNode.
     */
    mergeWithSibling(s) {
      const c = s === this.getPreviousSibling();
      if (!c && s !== this.getNextSibling())
        throw Error("mergeWithSibling: sibling must be a previous or next sibling");
      const h = this.__key, y = s.__key, N = this.__text, b = N.length;
      ar() === y && vn(h);
      const ae = mn();
      if (Et(ae)) {
        const we = ae.anchor, Ce = ae.focus;
        we !== null && we.key === y && (Yd(we, c, h, s, b), ae.dirty = !0), Ce !== null && Ce.key === y && (Yd(Ce, c, h, s, b), ae.dirty = !0);
      }
      const he = s.__text, me = c ? he + N : N + he;
      this.setTextContent(me);
      const xe = this.getWritable();
      return s.remove(), xe;
    }
    /**
     * This method is meant to be overriden by TextNode subclasses to control the behavior of those nodes
     * when used with the registerLexicalTextEntity function. If you're using registerLexicalTextEntity, the
     * node class that you create and replace matched text with should return true from this method.
     *
     * @returns true if the node is to be treated as a "text entity", false otherwise.
     */
    isTextEntity() {
      return !1;
    }
  }
  function za(u) {
    const s = u, c = s.style.fontWeight === "700", h = s.style.textDecoration === "line-through", y = s.style.fontStyle === "italic", N = s.style.textDecoration === "underline", b = s.style.verticalAlign;
    return {
      forChild: ($) => (mt($) && (c && $.toggleFormat("bold"), h && $.toggleFormat("strikethrough"), y && $.toggleFormat("italic"), N && $.toggleFormat("underline"), b === "sub" && $.toggleFormat("subscript"), b === "super" && $.toggleFormat("superscript")), $),
      node: null
    };
  }
  function Wl(u) {
    const c = u.style.fontWeight === "normal";
    return {
      forChild: (h) => (mt(h) && !c && h.toggleFormat("bold"), h),
      node: null
    };
  }
  const Io = /* @__PURE__ */ new WeakMap();
  function Ua(u) {
    return u.nodeName === "PRE" || u.nodeType === ke && u.style !== void 0 && u.style.whiteSpace !== void 0 && u.style.whiteSpace.startsWith("pre");
  }
  function Zs(u) {
    let s, c = u.parentNode;
    const h = [u];
    for (; c !== null && (s = Io.get(c)) === void 0 && !Ua(c); )
      h.push(c), c = c.parentNode;
    const y = s === void 0 ? c : s;
    for (let N = 0; N < h.length; N++)
      Io.set(h[N], y);
    return y;
  }
  function ko(u) {
    const s = u;
    if (u.parentElement === null)
      throw Error("Expected parentElement of Text not to be null");
    let h = s.textContent || "";
    if (Zs(s) !== null) {
      const y = h.split(/(\r?\n|\t)/), N = [], b = y.length;
      for (let $ = 0; $ < b; $++) {
        const ae = y[$];
        ae === `
` || ae === `\r
` ? N.push(ms()) : ae === "	" ? N.push(Po()) : ae !== "" && N.push(Dn(ae));
      }
      return {
        node: N
      };
    }
    if (h = h.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), h === "")
      return {
        node: null
      };
    if (h[0] === " ") {
      let y = s, N = !0;
      for (; y !== null && (y = Ga(y, !1)) !== null; ) {
        const b = y.textContent || "";
        if (b.length > 0) {
          /[ \t\n]$/.test(b) && (h = h.slice(1)), N = !1;
          break;
        }
      }
      N && (h = h.slice(1));
    }
    if (h[h.length - 1] === " ") {
      let y = s, N = !0;
      for (; y !== null && (y = Ga(y, !0)) !== null; )
        if ((y.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
          N = !1;
          break;
        }
      N && (h = h.slice(0, h.length - 1));
    }
    return h === "" ? {
      node: null
    } : {
      node: Dn(h)
    };
  }
  const Kl = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/, "i");
  function Ga(u, s) {
    let c = u;
    for (; ; ) {
      let h;
      for (; (h = s ? c.nextSibling : c.previousSibling) === null; ) {
        const N = c.parentElement;
        if (N === null)
          return null;
        c = N;
      }
      if (c = h, c.nodeType === ke) {
        const N = c.style.display;
        if (N === "" && c.nodeName.match(Kl) === null || N !== "" && !N.startsWith("inline"))
          return null;
      }
      let y = c;
      for (; (y = s ? c.firstChild : c.lastChild) !== null; )
        c = y;
      if (c.nodeType === Fe)
        return c;
      if (c.nodeName === "BR")
        return null;
    }
  }
  const zl = {
    code: "code",
    em: "italic",
    i: "italic",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
  };
  function ei(u) {
    const s = zl[u.nodeName.toLowerCase()];
    return s === void 0 ? {
      node: null
    } : {
      forChild: (c) => (mt(c) && !c.hasFormat(s) && c.toggleFormat(s), c),
      node: null
    };
  }
  function Dn(u = "") {
    return Mr(new Qr(u));
  }
  function mt(u) {
    return u instanceof Qr;
  }
  class Sr extends Qr {
    static getType() {
      return "tab";
    }
    static clone(s) {
      const c = new Sr(s.__key);
      return c.__text = s.__text, c.__format = s.__format, c.__style = s.__style, c;
    }
    constructor(s) {
      super("	", s), this.__detail = vt;
    }
    static importDOM() {
      return null;
    }
    static importJSON(s) {
      const c = Po();
      return c.setFormat(s.format), c.setStyle(s.style), c;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "tab",
        version: 1
      };
    }
    setTextContent(s) {
      throw Error("TabNode does not support setTextContent");
    }
    setDetail(s) {
      throw Error("TabNode does not support setDetail");
    }
    setMode(s) {
      throw Error("TabNode does not support setMode");
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
  }
  function Po() {
    return Mr(new Sr());
  }
  function $o(u) {
    return u instanceof Sr;
  }
  class Bc {
    constructor(s, c, h) {
      this._selection = null, this.key = s, this.offset = c, this.type = h;
    }
    is(s) {
      return this.key === s.key && this.offset === s.offset && this.type === s.type;
    }
    isBefore(s) {
      let c = this.getNode(), h = s.getNode();
      const y = this.offset, N = s.offset;
      if (et(c)) {
        const b = c.getDescendantByIndex(y);
        c = b ?? c;
      }
      if (et(h)) {
        const b = h.getDescendantByIndex(N);
        h = b ?? h;
      }
      return c === h ? y < N : c.isBefore(h);
    }
    getNode() {
      const s = this.key, c = Nn(s);
      if (c === null)
        throw Error("Point.getNode: node not found");
      return c;
    }
    set(s, c, h) {
      const y = this._selection, N = this.key;
      this.key = s, this.offset = c, this.type = h, Wo() || (ar() === N && vn(s), y !== null && (y.setCachedNodes(null), y.dirty = !0));
    }
  }
  function Lr(u, s, c) {
    return new Bc(u, s, c);
  }
  function Fo(u, s) {
    let c = s.__key, h = u.offset, y = "element";
    if (mt(s)) {
      y = "text";
      const N = s.getTextContentSize();
      h > N && (h = N);
    } else if (!et(s)) {
      const N = s.getNextSibling();
      if (mt(N))
        c = N.__key, h = 0, y = "text";
      else {
        const b = s.getParent();
        b && (c = b.__key, h = s.getIndexWithinParent() + 1);
      }
    }
    u.set(c, h, y);
  }
  function pn(u, s) {
    if (et(s)) {
      const c = s.getLastDescendant();
      et(c) || mt(c) ? Fo(u, c) : Fo(u, s);
    } else
      Fo(u, s);
  }
  function Xn(u, s, c, h) {
    const y = u.getNode(), N = y.getChildAtIndex(u.offset), b = Dn(), $ = Yr(y) ? Zi().append(b) : b;
    b.setFormat(c), b.setStyle(h), N === null ? y.append($) : N.insertBefore($), u.is(s) && s.set(b.__key, 0, "text"), u.set(b.__key, 0, "text");
  }
  function En(u, s, c, h) {
    u.key = s, u.offset = c, u.type = h;
  }
  class Ir {
    constructor(s, c) {
      this.anchor = s, this.focus = c, s._selection = this, c._selection = this, this._cachedNodes = null, this.dirty = !1;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(s) {
      this._cachedNodes = s;
    }
    is(s) {
      return dr(s) ? this.anchor.is(s.anchor) && this.focus.is(s.focus) : !1;
    }
    isCollapsed() {
      return !1;
    }
    extract() {
      return this.getNodes();
    }
    /**
     * Returns whether the Selection is "backwards", meaning the focus
     * logically precedes the anchor in the EditorState.
     * @returns true if the Selection is backwards, false otherwise.
     */
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    /**
     * Returns the character-based offsets of the Selection, accounting for non-text Points
     * by using the children size or text content.
     *
     * @returns the character offsets for the Selection
     */
    getCharacterOffsets() {
      return di(this);
    }
  }
  class vi {
    constructor(s) {
      this.dirty = !1, this._nodes = s, this._cachedNodes = null;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(s) {
      this._cachedNodes = s;
    }
    is(s) {
      if (!Ur(s))
        return !1;
      const c = this._nodes, h = s._nodes;
      return c.size === h.size && Array.from(c).every((y) => h.has(y));
    }
    add(s) {
      this.dirty = !0, this._nodes.add(s), this._cachedNodes = null;
    }
    delete(s) {
      this.dirty = !0, this._nodes.delete(s), this._cachedNodes = null;
    }
    clear() {
      this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(s) {
      return this._nodes.has(s);
    }
    clone() {
      return new vi(new Set(this._nodes));
    }
    extract() {
      return this.getNodes();
    }
    insertRawText(s) {
    }
    insertText() {
    }
    insertNodes(s) {
      const c = this.getNodes(), h = c.length, y = c[h - 1];
      let N;
      if (mt(y))
        N = y.select();
      else {
        const b = y.getIndexWithinParent() + 1;
        N = y.getParentOrThrow().select(b, b);
      }
      N.insertNodes(s);
      for (let b = 0; b < h; b++)
        c[b].remove();
    }
    getNodes() {
      const s = this._cachedNodes;
      if (s !== null)
        return s;
      const c = this._nodes, h = [];
      for (const y of c) {
        const N = Nn(y);
        N !== null && h.push(N);
      }
      return Wo() || (this._cachedNodes = h), h;
    }
    getTextContent() {
      const s = this.getNodes();
      let c = "";
      for (let h = 0; h < s.length; h++)
        c += s[h].getTextContent();
      return c;
    }
  }
  function Et(u) {
    return u instanceof ir;
  }
  function dr(u) {
    return u instanceof Ir;
  }
  function kr(u) {
    const [s, , c] = jd(u), h = c.getChildren(), y = h.length, N = h[0].getChildren().length, b = new Array(y);
    for (let $ = 0; $ < y; $++)
      b[$] = new Array(N);
    for (let $ = 0; $ < y; $++) {
      const he = h[$].getChildren();
      let me = 0;
      for (let xe = 0; xe < he.length; xe++) {
        for (; b[$][me]; )
          me++;
        const we = he[xe], Ce = we.__rowSpan || 1, Ve = we.__colSpan || 1;
        for (let Ue = 0; Ue < Ce; Ue++)
          for (let $e = 0; $e < Ve; $e++)
            b[$ + Ue][me + $e] = we;
        if (s === we)
          return {
            colSpan: Ve,
            columnIndex: me,
            rowIndex: $,
            rowSpan: Ce
          };
        me += Ve;
      }
    }
    return null;
  }
  class ir extends Ir {
    constructor(s, c, h, y) {
      super(s, c), this.format = h, this.style = y;
    }
    /**
     * Used to check if the provided selections is equal to this one by value,
     * inluding anchor, focus, format, and style properties.
     * @param selection - the Selection to compare this one to.
     * @returns true if the Selections are equal, false otherwise.
     */
    is(s) {
      return Et(s) ? this.anchor.is(s.anchor) && this.focus.is(s.focus) && this.format === s.format && this.style === s.style : !1;
    }
    /**
     * Returns whether the Selection is "collapsed", meaning the anchor and focus are
     * the same node and have the same offset.
     *
     * @returns true if the Selection is collapsed, false otherwise.
     */
    isCollapsed() {
      return this.anchor.is(this.focus);
    }
    /**
     * Gets all the nodes in the Selection. Uses caching to make it generally suitable
     * for use in hot paths.
     *
     * @returns an Array containing all the nodes in the Selection
     */
    getNodes() {
      const s = this._cachedNodes;
      if (s !== null)
        return s;
      const c = this.anchor, h = this.focus, y = c.isBefore(h), N = y ? c : h, b = y ? h : c;
      let $ = N.getNode(), ae = b.getNode();
      const he = N.offset, me = b.offset;
      if (et($)) {
        const we = $.getDescendantByIndex(he);
        $ = we ?? $;
      }
      if (et(ae)) {
        let we = ae.getDescendantByIndex(me);
        we !== null && we !== $ && ae.getChildAtIndex(me) === we && (we = we.getPreviousSibling()), ae = we ?? ae;
      }
      let xe;
      return $.is(ae) ? et($) && $.getChildrenSize() > 0 ? xe = [] : xe = [$] : xe = $.getNodesBetween(ae), Wo() || (this._cachedNodes = xe), xe;
    }
    /**
     * Sets this Selection to be of type "text" at the provided anchor and focus values.
     *
     * @param anchorNode - the anchor node to set on the Selection
     * @param anchorOffset - the offset to set on the Selection
     * @param focusNode - the focus node to set on the Selection
     * @param focusOffset - the focus offset to set on the Selection
     */
    setTextNodeRange(s, c, h, y) {
      En(this.anchor, s.__key, c, "text"), En(this.focus, h.__key, y, "text"), this._cachedNodes = null, this.dirty = !0;
    }
    /**
     * Gets the (plain) text content of all the nodes in the selection.
     *
     * @returns a string representing the text content of all the nodes in the Selection
     */
    getTextContent() {
      const s = this.getNodes();
      if (s.length === 0)
        return "";
      const c = s[0], h = s[s.length - 1], y = this.anchor, N = this.focus, b = y.isBefore(N), [$, ae] = di(this);
      let he = "", me = !0;
      for (let xe = 0; xe < s.length; xe++) {
        const we = s[xe];
        if (et(we) && !we.isInline())
          me || (he += `
`), we.isEmpty() ? me = !1 : me = !0;
        else if (me = !1, mt(we)) {
          let Ce = we.getTextContent();
          we === c ? we === h ? (y.type !== "element" || N.type !== "element" || N.offset === y.offset) && (Ce = $ < ae ? Ce.slice($, ae) : Ce.slice(ae, $)) : Ce = b ? Ce.slice($) : Ce.slice(ae) : we === h && (Ce = b ? Ce.slice(0, ae) : Ce.slice(0, $)), he += Ce;
        } else (An(we) || ui(we)) && (we !== h || !this.isCollapsed()) && (he += we.getTextContent());
      }
      return he;
    }
    /**
     * Attempts to map a DOM selection range onto this Lexical Selection,
     * setting the anchor, focus, and type accordingly
     *
     * @param range a DOM Selection range conforming to the StaticRange interface.
     */
    applyDOMRange(s) {
      const c = Tn(), y = c.getEditorState()._selection, N = zd(s.startContainer, s.startOffset, s.endContainer, s.endOffset, c, y);
      if (N === null)
        return;
      const [b, $] = N;
      En(this.anchor, b.key, b.offset, b.type), En(this.focus, $.key, $.offset, $.type), this._cachedNodes = null;
    }
    /**
     * Creates a new RangeSelection, copying over all the property values from this one.
     *
     * @returns a new RangeSelection with the same property values as this one.
     */
    clone() {
      const s = this.anchor, c = this.focus;
      return new ir(Lr(s.key, s.offset, s.type), Lr(c.key, c.offset, c.type), this.format, this.style);
    }
    /**
     * Toggles the provided format on all the TextNodes in the Selection.
     *
     * @param format a string TextFormatType to toggle on the TextNodes in the selection
     */
    toggleFormat(s) {
      this.format = Bn(this.format, s, null), this.dirty = !0;
    }
    /**
     * Sets the value of the style property on the Selection
     *
     * @param style - the style to set at the value of the style property.
     */
    setStyle(s) {
      this.style = s, this.dirty = !0;
    }
    /**
     * Returns whether the provided TextFormatType is present on the Selection. This will be true if any node in the Selection
     * has the specified format.
     *
     * @param type the TextFormatType to check for.
     * @returns true if the provided format is currently toggled on on the Selection, false otherwise.
     */
    hasFormat(s) {
      const c = nn[s];
      return (this.format & c) !== 0;
    }
    /**
     * Attempts to insert the provided text into the EditorState at the current Selection.
     * converts tabs, newlines, and carriage returns into LexicalNodes.
     *
     * @param text the text to insert into the Selection
     */
    insertRawText(s) {
      const c = s.split(/(\r?\n|\t)/), h = [], y = c.length;
      for (let N = 0; N < y; N++) {
        const b = c[N];
        b === `
` || b === `\r
` ? h.push(ms()) : b === "	" ? h.push(Po()) : h.push(Dn(b));
      }
      this.insertNodes(h);
    }
    /**
     * Attempts to insert the provided text into the EditorState at the current Selection as a new
     * Lexical TextNode, according to a series of insertion heuristics based on the selection type and position.
     *
     * @param text the text to insert into the Selection
     */
    insertText(s) {
      const c = this.anchor, h = this.focus, y = this.isCollapsed() || c.isBefore(h), N = this.format, b = this.style;
      y && c.type === "element" ? Xn(c, h, N, b) : !y && h.type === "element" && Xn(h, c, N, b);
      const $ = this.getNodes(), ae = $.length, he = y ? c : h, me = y ? h : c, xe = he.offset, we = me.offset;
      let Ce = $[0];
      if (!mt(Ce))
        throw Error("insertText: first node is not a text node");
      const Ue = Ce.getTextContent().length, $e = Ce.getParentOrThrow(), Mt = ae - 1;
      let Qe = $[Mt];
      if (this.isCollapsed() && xe === Ue && (Ce.isSegmented() || Ce.isToken() || !Ce.canInsertTextAfter() || !$e.canInsertTextAfter() && Ce.getNextSibling() === null)) {
        let ft = Ce.getNextSibling();
        if ((!mt(ft) || !ft.canInsertTextBefore() || zn(ft)) && (ft = Dn(), ft.setFormat(N), $e.canInsertTextAfter() ? Ce.insertAfter(ft) : $e.insertAfter(ft)), ft.select(0, 0), Ce = ft, s !== "") {
          this.insertText(s);
          return;
        }
      } else if (this.isCollapsed() && xe === 0 && (Ce.isSegmented() || Ce.isToken() || !Ce.canInsertTextBefore() || !$e.canInsertTextBefore() && Ce.getPreviousSibling() === null)) {
        let ft = Ce.getPreviousSibling();
        if ((!mt(ft) || zn(ft)) && (ft = Dn(), ft.setFormat(N), $e.canInsertTextBefore() ? Ce.insertBefore(ft) : $e.insertBefore(ft)), ft.select(), Ce = ft, s !== "") {
          this.insertText(s);
          return;
        }
      } else if (Ce.isSegmented() && xe !== Ue) {
        const ft = Dn(Ce.getTextContent());
        ft.setFormat(N), Ce.replace(ft), Ce = ft;
      } else if (!this.isCollapsed() && s !== "") {
        const ft = Qe.getParent();
        if (!$e.canInsertTextBefore() || !$e.canInsertTextAfter() || et(ft) && (!ft.canInsertTextBefore() || !ft.canInsertTextAfter())) {
          this.insertText(""), Kd(this.anchor, this.focus, null), this.insertText(s);
          return;
        }
      }
      if (ae === 1) {
        if (Ce.isToken()) {
          const Ot = Dn(s);
          Ot.select(), Ce.replace(Ot);
          return;
        }
        const ft = Ce.getFormat(), qt = Ce.getStyle();
        if (xe === we && (ft !== N || qt !== b))
          if (Ce.getTextContent() === "")
            Ce.setFormat(N), Ce.setStyle(b);
          else {
            const Ot = Dn(s);
            if (Ot.setFormat(N), Ot.setStyle(b), Ot.select(), xe === 0)
              Ce.insertBefore(Ot, !1);
            else {
              const [an] = Ce.splitText(xe);
              an.insertAfter(Ot, !1);
            }
            Ot.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= s.length);
            return;
          }
        else if ($o(Ce)) {
          const Ot = Dn(s);
          Ot.setFormat(N), Ot.setStyle(b), Ot.select(), Ce.replace(Ot);
          return;
        }
        const Ht = we - xe;
        Ce = Ce.spliceText(xe, Ht, s, !0), Ce.getTextContent() === "" ? Ce.remove() : this.anchor.type === "text" && (Ce.isComposing() ? this.anchor.offset -= s.length : (this.format = ft, this.style = qt));
      } else {
        const ft = /* @__PURE__ */ new Set([...Ce.getParentKeys(), ...Qe.getParentKeys()]), qt = et(Ce) ? Ce : Ce.getParentOrThrow();
        let Ht = et(Qe) ? Qe : Qe.getParentOrThrow(), Ot = Qe;
        if (!qt.is(Ht) && Ht.isInline())
          do
            Ot = Ht, Ht = Ht.getParentOrThrow();
          while (Ht.isInline());
        if (me.type === "text" && (we !== 0 || Qe.getTextContent() === "") || me.type === "element" && Qe.getIndexWithinParent() < we)
          if (mt(Qe) && !Qe.isToken() && we !== Qe.getTextContentSize()) {
            if (Qe.isSegmented()) {
              const rn = Dn(Qe.getTextContent());
              Qe.replace(rn), Qe = rn;
            }
            !Yr(me.getNode()) && me.type === "text" && (Qe = Qe.spliceText(0, we, "")), ft.add(Qe.__key);
          } else {
            const rn = Qe.getParentOrThrow();
            !rn.canBeEmpty() && rn.getChildrenSize() === 1 ? rn.remove() : Qe.remove();
          }
        else
          ft.add(Qe.__key);
        const an = Ht.getChildren(), sr = new Set($), _s = qt.is(Ht), gr = qt.isInline() && Ce.getNextSibling() === null ? qt : Ce;
        for (let rn = an.length - 1; rn >= 0; rn--) {
          const kn = an[rn];
          if (kn.is(Ce) || et(kn) && kn.isParentOf(Ce))
            break;
          kn.isAttached() && (!sr.has(kn) || kn.is(Ot) ? _s || gr.insertAfter(kn, !1) : kn.remove());
        }
        if (!_s) {
          let rn = Ht, kn = null;
          for (; rn !== null; ) {
            const fi = rn.getChildren(), Ji = fi.length;
            (Ji === 0 || fi[Ji - 1].is(kn)) && (ft.delete(rn.__key), kn = rn), rn = rn.getParent();
          }
        }
        if (!Ce.isToken())
          Ce = Ce.spliceText(xe, Ue - xe, s, !0), Ce.getTextContent() === "" ? Ce.remove() : Ce.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= s.length);
        else if (xe === Ue)
          Ce.select();
        else {
          const rn = Dn(s);
          rn.select(), Ce.replace(rn);
        }
        for (let rn = 1; rn < ae; rn++) {
          const kn = $[rn], fi = kn.__key;
          ft.has(fi) || kn.remove();
        }
      }
    }
    /**
     * Removes the text in the Selection, adjusting the EditorState accordingly.
     */
    removeText() {
      this.insertText("");
    }
    /**
     * Applies the provided format to the TextNodes in the Selection, splitting or
     * merging nodes as necessary.
     *
     * @param formatType the format type to apply to the nodes in the Selection.
     */
    formatText(s) {
      if (this.isCollapsed()) {
        this.toggleFormat(s), vn(null);
        return;
      }
      const c = this.getNodes(), h = [];
      for (const Qe of c)
        mt(Qe) && h.push(Qe);
      const y = h.length;
      if (y === 0) {
        this.toggleFormat(s), vn(null);
        return;
      }
      const N = this.anchor, b = this.focus, $ = this.isBackward(), ae = $ ? b : N, he = $ ? N : b;
      let me = 0, xe = h[0], we = ae.type === "element" ? 0 : ae.offset;
      if (ae.type === "text" && we === xe.getTextContentSize() && (me = 1, xe = h[1], we = 0), xe == null)
        return;
      const Ce = xe.getFormatFlags(s, null), Ve = y - 1;
      let Ue = h[Ve];
      const $e = he.type === "text" ? he.offset : Ue.getTextContentSize();
      if (xe.is(Ue)) {
        if (we === $e)
          return;
        if (we === 0 && $e === xe.getTextContentSize())
          xe.setFormat(Ce);
        else {
          const Qe = xe.splitText(we, $e), ft = we === 0 ? Qe[0] : Qe[1];
          ft.setFormat(Ce), ae.type === "text" && ae.set(ft.__key, 0, "text"), he.type === "text" && he.set(ft.__key, $e - we, "text");
        }
        this.format = Ce;
        return;
      }
      we !== 0 && ([, xe] = xe.splitText(we), we = 0), xe.setFormat(Ce);
      const Mt = Ue.getFormatFlags(s, Ce);
      $e > 0 && ($e !== Ue.getTextContentSize() && ([Ue] = Ue.splitText($e)), Ue.setFormat(Mt));
      for (let Qe = me + 1; Qe < Ve; Qe++) {
        const ft = h[Qe];
        if (!ft.isToken()) {
          const qt = ft.getFormatFlags(s, Mt);
          ft.setFormat(qt);
        }
      }
      ae.type === "text" && ae.set(xe.__key, we, "text"), he.type === "text" && he.set(Ue.__key, $e, "text"), this.format = Ce | Mt;
    }
    /**
     * Attempts to "intelligently" insert an arbitrary list of Lexical nodes into the EditorState at the
     * current Selection according to a set of heuristics that determine how surrounding nodes
     * should be changed, replaced, or moved to accomodate the incoming ones.
     *
     * @param nodes - the nodes to insert
     */
    insertNodes(s) {
      if (s.length === 0)
        return;
      if (this.anchor.key === "root") {
        this.insertParagraph();
        const $e = mn();
        if (!Et($e))
          throw Error("Expected RangeSelection after insertParagraph");
        return $e.insertNodes(s);
      }
      const c = wo(this.anchor.getNode(), Wi), h = s[s.length - 1];
      if ("__language" in c && et(c)) {
        if ("__language" in s[0])
          this.insertText(s[0].getTextContent());
        else {
          const $e = Kc(this);
          c.splice($e, 0, s), h.selectEnd();
        }
        return;
      }
      const y = ($e) => (et($e) || An($e)) && !$e.isInline();
      if (!s.some(y)) {
        if (!et(c))
          throw Error("Expected 'firstBlock' to be an ElementNode");
        const $e = Kc(this);
        c.splice($e, 0, s), h.selectEnd();
        return;
      }
      const N = v_(s), b = N.getLastDescendant(), $ = N.getChildren(), ae = ($e) => "__value" in $e && "__checked" in $e, he = ($e) => et($e) && Wi($e) && !$e.isEmpty() && et(c) && (!c.isEmpty() || ae(c)), xe = !et(c) || !c.isEmpty() ? this.insertParagraph() : null, we = $[$.length - 1];
      let Ce = $[0];
      if (he(Ce)) {
        if (!et(c))
          throw Error("Expected 'firstBlock' to be an ElementNode");
        c.append(...Ce.getChildren()), Ce = $[1];
      }
      Ce && Bl(c, Ce);
      const Ve = wo(b, Wi);
      xe && et(Ve) && (ae(xe) || Wi(we)) && (Ve.append(...xe.getChildren()), xe.remove()), et(c) && c.isEmpty() && c.remove(), b.selectEnd();
      const Ue = et(c) ? c.getLastChild() : null;
      ui(Ue) && Ve !== c && Ue.remove();
    }
    /**
     * Inserts a new ParagraphNode into the EditorState at the current Selection
     *
     * @returns the newly inserted node.
     */
    insertParagraph() {
      if (this.anchor.key === "root") {
        const b = Zi();
        return nr().splice(this.anchor.offset, 0, [b]), b.select(), b;
      }
      const s = Kc(this), c = wo(this.anchor.getNode(), Wi);
      if (!et(c))
        throw Error("Expected ancestor to be an ElementNode");
      const h = c.getChildAtIndex(s), y = h ? [h, ...h.getNextSiblings()] : [], N = c.insertNewAfter(this, !1);
      return N ? (N.append(...y), N.selectStart(), N) : null;
    }
    /**
     * Inserts a logical linebreak, which may be a new LineBreakNode or a new ParagraphNode, into the EditorState at the
     * current Selection.
     */
    insertLineBreak(s) {
      const c = ms();
      if (this.insertNodes([c]), s) {
        const h = c.getParentOrThrow(), y = c.getIndexWithinParent();
        h.select(y, y);
      }
    }
    /**
     * Extracts the nodes in the Selection, splitting nodes where necessary
     * to get offset-level precision.
     *
     * @returns The nodes in the Selection
     */
    extract() {
      const s = this.getNodes(), c = s.length, h = c - 1, y = this.anchor, N = this.focus;
      let b = s[0], $ = s[h];
      const [ae, he] = di(this);
      if (c === 0)
        return [];
      if (c === 1) {
        if (mt(b) && !this.isCollapsed()) {
          const xe = ae > he ? he : ae, we = ae > he ? ae : he, Ce = b.splitText(xe, we), Ve = xe === 0 ? Ce[0] : Ce[1];
          return Ve != null ? [Ve] : [];
        }
        return [b];
      }
      const me = y.isBefore(N);
      if (mt(b)) {
        const xe = me ? ae : he;
        xe === b.getTextContentSize() ? s.shift() : xe !== 0 && ([, b] = b.splitText(xe), s[0] = b);
      }
      if (mt($)) {
        const we = $.getTextContent().length, Ce = me ? he : ae;
        Ce === 0 ? s.pop() : Ce !== we && ([$] = $.splitText(Ce), s[h] = $);
      }
      return s;
    }
    /**
     * Modifies the Selection according to the parameters and a set of heuristics that account for
     * various node types. Can be used to safely move or extend selection by one logical "unit" without
     * dealing explicitly with all the possible node types.
     *
     * @param alter the type of modification to perform
     * @param isBackward whether or not selection is backwards
     * @param granularity the granularity at which to apply the modification
     */
    modify(s, c, h) {
      const y = this.focus, N = this.anchor, b = s === "move", $ = Sl(y, c);
      if (An($) && !$.isIsolated()) {
        if (b && $.isKeyboardSelectable()) {
          const Ce = Hc();
          Ce.add($.__key), Tr(Ce);
          return;
        }
        const we = c ? $.getPreviousSibling() : $.getNextSibling();
        if (mt(we)) {
          const Ce = we.__key, Ve = c ? we.getTextContent().length : 0;
          y.set(Ce, Ve, "text"), b && N.set(Ce, Ve, "text");
          return;
        } else {
          const Ce = $.getParentOrThrow();
          let Ve, Ue;
          et(we) ? (Ue = we.__key, Ve = c ? we.getChildrenSize() : 0) : (Ve = $.getIndexWithinParent(), Ue = Ce.__key, c || Ve++), y.set(Ue, Ve, "element"), b && N.set(Ue, Ve, "element");
          return;
        }
      }
      const ae = Tn(), he = cr(ae._window);
      if (!he)
        return;
      const me = ae._blockCursorElement, xe = ae._rootElement;
      if (xe !== null && me !== null && et($) && !$.isInline() && !$.canBeEmpty() && Hs(me, ae, xe), Ya(he, s, c ? "backward" : "forward", h), he.rangeCount > 0) {
        const we = he.getRangeAt(0), Ce = this.anchor.getNode(), Ve = Yr(Ce) ? Ce : xo(Ce);
        if (this.applyDOMRange(we), this.dirty = !0, !b) {
          const Ue = this.getNodes(), $e = [];
          let Mt = !1;
          for (let Qe = 0; Qe < Ue.length; Qe++) {
            const ft = Ue[Qe];
            Hi(ft, Ve) ? $e.push(ft) : Mt = !0;
          }
          if (Mt && $e.length > 0)
            if (c) {
              const Qe = $e[0];
              et(Qe) ? Qe.selectStart() : Qe.getParentOrThrow().selectStart();
            } else {
              const Qe = $e[$e.length - 1];
              et(Qe) ? Qe.selectEnd() : Qe.getParentOrThrow().selectEnd();
            }
          (he.anchorNode !== we.startContainer || he.anchorOffset !== we.startOffset) && Bo(this);
        }
      }
    }
    /**
     * Performs one logical character deletion operation on the EditorState based on the current Selection.
     * Handles different node types.
     *
     * @param isBackward whether or not the selection is backwards.
     */
    deleteCharacter(s) {
      const c = this.isCollapsed();
      if (this.isCollapsed()) {
        const h = this.anchor, y = this.focus;
        let N = h.getNode();
        if (!s && // Delete forward handle case
        (h.type === "element" && et(N) && h.offset === N.getChildrenSize() || h.type === "text" && h.offset === N.getTextContentSize())) {
          const $ = N.getParent(), ae = N.getNextSibling() || ($ === null ? null : $.getNextSibling());
          if (et(ae) && ae.isShadowRoot())
            return;
        }
        const b = Sl(y, s);
        if (An(b) && !b.isIsolated()) {
          if (b.isKeyboardSelectable() && et(N) && N.getChildrenSize() === 0) {
            N.remove();
            const $ = Hc();
            $.add(b.__key), Tr($);
          } else
            b.remove(), Tn().dispatchCommand(t, void 0);
          return;
        } else if (!s && et(b) && et(N) && N.isEmpty()) {
          N.remove(), b.selectStart();
          return;
        }
        if (this.modify("extend", s, "character"), this.isCollapsed()) {
          if (s && h.offset === 0 && (h.type === "element" ? h.getNode() : h.getNode().getParentOrThrow()).collapseAtStart(this))
            return;
        } else {
          const $ = y.type === "text" ? y.getNode() : null;
          if (N = h.type === "text" ? h.getNode() : null, $ !== null && $.isSegmented()) {
            const ae = y.offset, he = $.getTextContentSize();
            if ($.is(N) || s && ae !== he || !s && ae !== 0) {
              Bd($, s, ae);
              return;
            }
          } else if (N !== null && N.isSegmented()) {
            const ae = h.offset, he = N.getTextContentSize();
            if (N.is($) || s && ae !== 0 || !s && ae !== he) {
              Bd(N, s, ae);
              return;
            }
          }
          h_(this, s);
        }
      }
      if (this.removeText(), s && !c && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0) {
        const h = this.anchor.getNode();
        h.isEmpty() && Yr(h.getParent()) && h.getIndexWithinParent() === 0 && h.collapseAtStart(this);
      }
    }
    /**
     * Performs one logical line deletion operation on the EditorState based on the current Selection.
     * Handles different node types.
     *
     * @param isBackward whether or not the selection is backwards.
     */
    deleteLine(s) {
      this.isCollapsed() && (this.anchor.type === "text" && this.modify("extend", s, "lineboundary"), (s ? this.focus : this.anchor).offset === 0 && this.modify("extend", s, "character")), this.removeText();
    }
    /**
     * Performs one logical word deletion operation on the EditorState based on the current Selection.
     * Handles different node types.
     *
     * @param isBackward whether or not the selection is backwards.
     */
    deleteWord(s) {
      this.isCollapsed() && this.modify("extend", s, "word"), this.removeText();
    }
  }
  function Ur(u) {
    return u instanceof vi;
  }
  function fr(u) {
    const s = u.offset;
    if (u.type === "text")
      return s;
    const c = u.getNode();
    return s === c.getChildrenSize() ? c.getTextContent().length : 0;
  }
  function di(u) {
    const s = u.anchor, c = u.focus;
    return s.type === "element" && c.type === "element" && s.key === c.key && s.offset === c.offset ? [0, 0] : [fr(s), fr(c)];
  }
  function Bo(u) {
    const s = u.focus, c = u.anchor, h = c.key, y = c.offset, N = c.type;
    En(c, s.key, s.offset, s.type), En(s, h, y, N), u._cachedNodes = null;
  }
  function Ya(u, s, c, h) {
    u.modify(s, c, h);
  }
  function h_(u, s) {
    const c = u.anchor, h = u.focus, y = c.getNode(), N = h.getNode();
    if (y === N && c.type === "text" && h.type === "text") {
      const b = c.offset, $ = h.offset, ae = b < $, he = ae ? b : $, me = ae ? $ : b, xe = me - 1;
      if (he !== xe) {
        const we = y.getTextContent().slice(he, me);
        Rs(we) || (s ? h.offset = xe : c.offset = xe);
      }
    }
  }
  function Bd(u, s, c) {
    const h = u, N = h.getTextContent().split(/(?=\s)/g), b = N.length;
    let $ = 0, ae = 0;
    for (let me = 0; me < b; me++) {
      const xe = N[me], we = me === b - 1;
      if (ae = $, $ += xe.length, s && $ === c || $ > c || we) {
        N.splice(me, 1), we && (ae = void 0);
        break;
      }
    }
    const he = N.join("").trim();
    he === "" ? h.remove() : (h.setTextContent(he), h.select(ae, ae));
  }
  function g_(u, s, c) {
    const h = u.getParent();
    return c === null || h === null || !h.canBeEmpty() || h !== c.getNode();
  }
  function Hd(u, s, c, h) {
    let y = s, N;
    if (u.nodeType === ke) {
      let b = !1;
      const $ = u.childNodes, ae = $.length;
      y === ae && (b = !0, y = ae - 1);
      let he = $[y], me = !1;
      if (he === h._blockCursorElement ? (he = $[y + 1], me = !0) : h._blockCursorElement !== null && y--, N = Ii(he), mt(N))
        y = _l(N, b);
      else {
        let xe = Ii(u);
        if (xe === null)
          return null;
        if (et(xe)) {
          let we = xe.getChildAtIndex(y);
          if (et(we) && g_(we, y, c)) {
            const Ce = b ? we.getLastDescendant() : we.getFirstDescendant();
            Ce === null ? (xe = we, y = 0) : (we = Ce, xe = et(we) ? we : we.getParentOrThrow());
          }
          mt(we) ? (N = we, xe = null, y = _l(we, b)) : we !== xe && b && !me && y++;
        } else {
          const we = xe.getIndexWithinParent();
          s === 0 && An(xe) && Ii(u) === xe ? y = we : y = we + 1, xe = xe.getParentOrThrow();
        }
        if (et(xe))
          return Lr(xe.__key, y, "element");
      }
    } else
      N = Ii(u);
    return mt(N) ? Lr(N.__key, y, "text") : null;
  }
  function Wd(u, s, c) {
    const h = u.offset, y = u.getNode();
    if (h === 0) {
      const N = y.getPreviousSibling(), b = y.getParent();
      if (!s)
        et(N) && !c && N.isInline() ? (u.key = N.__key, u.offset = N.getChildrenSize(), u.type = "element") : mt(N) && (u.key = N.__key, u.offset = N.getTextContent().length);
      else if ((c || !s) && N === null && et(b) && b.isInline()) {
        const $ = b.getPreviousSibling();
        mt($) && (u.key = $.__key, u.offset = $.getTextContent().length);
      }
    } else if (h === y.getTextContent().length) {
      const N = y.getNextSibling(), b = y.getParent();
      if (s && et(N) && N.isInline())
        u.key = N.__key, u.offset = 0, u.type = "element";
      else if ((c || s) && N === null && et(b) && b.isInline() && !b.canInsertTextAfter()) {
        const $ = b.getNextSibling();
        mt($) && (u.key = $.__key, u.offset = 0);
      }
    }
  }
  function Kd(u, s, c) {
    if (u.type === "text" && s.type === "text") {
      const h = u.isBefore(s), y = u.is(s);
      Wd(u, h, y), Wd(s, !h, y), y && (s.key = u.key, s.offset = u.offset, s.type = u.type);
      const N = Tn();
      if (N.isComposing() && N._compositionKey !== u.key && Et(c)) {
        const b = c.anchor, $ = c.focus;
        En(u, b.key, b.offset, b.type), En(s, $.key, $.offset, $.type);
      }
    }
  }
  function zd(u, s, c, h, y, N) {
    if (u === null || c === null || !os(y, u, c))
      return null;
    const b = Hd(u, s, Et(N) ? N.anchor : null, y);
    if (b === null)
      return null;
    const $ = Hd(c, h, Et(N) ? N.focus : null, y);
    if ($ === null)
      return null;
    if (b.type === "element" && $.type === "element") {
      const ae = Ii(u), he = Ii(c);
      if (An(ae) && An(he))
        return null;
    }
    return Kd(b, $, N), [b, $];
  }
  function p_(u) {
    return et(u) && !u.isInline();
  }
  function Ud(u, s, c, h, y, N) {
    const b = Si(), $ = new ir(Lr(u, s, y), Lr(c, h, N), 0, "");
    return $.dirty = !0, b._selection = $, $;
  }
  function m_() {
    const u = Lr("root", 0, "element"), s = Lr("root", 0, "element");
    return new ir(u, s, 0, "");
  }
  function Hc() {
    return new vi(/* @__PURE__ */ new Set());
  }
  function __(u) {
    const c = u.getEditorState()._selection, h = cr(u._window);
    return Et(c) || c == null ? Wc(c, h, u, null) : c.clone();
  }
  function Wc(u, s, c, h) {
    const y = c._window;
    if (y === null)
      return null;
    const N = h || y.event, b = N ? N.type : void 0, $ = b === "selectionchange", ae = !kt() && ($ || b === "beforeinput" || b === "compositionstart" || b === "compositionend" || b === "click" && N && N.detail === 3 || b === "drop" || b === void 0);
    let he, me, xe, we;
    if (!Et(u) || ae) {
      if (s === null)
        return null;
      if (he = s.anchorNode, me = s.focusNode, xe = s.anchorOffset, we = s.focusOffset, $ && Et(u) && !os(c, he, me))
        return u.clone();
    } else
      return u.clone();
    const Ce = zd(he, xe, me, we, c, u);
    if (Ce === null)
      return null;
    const [Ve, Ue] = Ce;
    return new ir(Ve, Ue, Et(u) ? u.format : 0, Et(u) ? u.style : "");
  }
  function mn() {
    return Si()._selection;
  }
  function Ho() {
    return Tn()._editorState._selection;
  }
  function ja(u, s, c, h = 1) {
    const y = u.anchor, N = u.focus, b = y.getNode(), $ = N.getNode();
    if (!s.is(b) && !s.is($))
      return;
    const ae = s.__key;
    if (u.isCollapsed()) {
      const he = y.offset;
      if (c <= he && h > 0 || c < he && h < 0) {
        const me = Math.max(0, he + h);
        y.set(ae, me, "element"), N.set(ae, me, "element"), Gd(u);
      }
    } else {
      const he = u.isBackward(), me = he ? N : y, xe = me.getNode(), we = he ? y : N, Ce = we.getNode();
      if (s.is(xe)) {
        const Ve = me.offset;
        (c <= Ve && h > 0 || c < Ve && h < 0) && me.set(ae, Math.max(0, Ve + h), "element");
      }
      if (s.is(Ce)) {
        const Ve = we.offset;
        (c <= Ve && h > 0 || c < Ve && h < 0) && we.set(ae, Math.max(0, Ve + h), "element");
      }
    }
    Gd(u);
  }
  function Gd(u) {
    const s = u.anchor, c = s.offset, h = u.focus, y = h.offset, N = s.getNode(), b = h.getNode();
    if (u.isCollapsed()) {
      if (!et(N))
        return;
      const $ = N.getChildrenSize(), ae = c >= $, he = ae ? N.getChildAtIndex($ - 1) : N.getChildAtIndex(c);
      if (mt(he)) {
        let me = 0;
        ae && (me = he.getTextContentSize()), s.set(he.__key, me, "text"), h.set(he.__key, me, "text");
      }
      return;
    }
    if (et(N)) {
      const $ = N.getChildrenSize(), ae = c >= $, he = ae ? N.getChildAtIndex($ - 1) : N.getChildAtIndex(c);
      if (mt(he)) {
        let me = 0;
        ae && (me = he.getTextContentSize()), s.set(he.__key, me, "text");
      }
    }
    if (et(b)) {
      const $ = b.getChildrenSize(), ae = y >= $, he = ae ? b.getChildAtIndex($ - 1) : b.getChildAtIndex(y);
      if (mt(he)) {
        let me = 0;
        ae && (me = he.getTextContentSize()), h.set(he.__key, me, "text");
      }
    }
  }
  function y_(u, s) {
    const h = s.getEditorState()._selection, y = u._selection;
    if (Et(y)) {
      const N = y.anchor, b = y.focus;
      let $;
      if (N.type === "text" && ($ = N.getNode(), $.selectionTransform(h, y)), b.type === "text") {
        const ae = b.getNode();
        $ !== ae && ae.selectionTransform(h, y);
      }
    }
  }
  function Va(u, s, c, h, y) {
    let N = null, b = 0, $ = null;
    h !== null ? (N = h.__key, mt(h) ? (b = h.getTextContentSize(), $ = "text") : et(h) && (b = h.getChildrenSize(), $ = "element")) : y !== null && (N = y.__key, mt(y) ? $ = "text" : et(y) && ($ = "element")), N !== null && $ !== null ? u.set(N, b, $) : (b = s.getIndexWithinParent(), b === -1 && (b = c.getChildrenSize()), u.set(c.__key, b, "element"));
  }
  function Yd(u, s, c, h, y) {
    u.type === "text" ? (u.key = c, s || (u.offset += y)) : u.offset > h.getIndexWithinParent() && (u.offset -= 1);
  }
  function N_(u, s, c, h, y, N, b) {
    const $ = h.anchorNode, ae = h.focusNode, he = h.anchorOffset, me = h.focusOffset, xe = document.activeElement;
    if (y.has("collaboration") && xe !== N || xe !== null && Ds(xe))
      return;
    if (!Et(s)) {
      u !== null && os(c, $, ae) && h.removeAllRanges();
      return;
    }
    const we = s.anchor, Ce = s.focus, Ve = we.key, Ue = Ce.key, $e = Fs(c, Ve), Mt = Fs(c, Ue), Qe = we.offset, ft = Ce.offset, qt = s.format, Ht = s.style, Ot = s.isCollapsed();
    let an = $e, sr = Mt, _s = !1;
    if (we.type === "text") {
      an = Fr($e);
      const gr = we.getNode();
      _s = gr.getFormat() !== qt || gr.getStyle() !== Ht;
    } else Et(u) && u.anchor.type === "text" && (_s = !0);
    if (Ce.type === "text" && (sr = Fr(Mt)), !(an === null || sr === null) && (Ot && (u === null || _s || Et(u) && (u.format !== qt || u.style !== Ht)) && Yn(qt, Ht, Qe, Ve, performance.now()), !(he === Qe && me === ft && $ === an && ae === sr && // Badly interpreted range selection when collapsed - #1482
    !(h.type === "Range" && Ot) && ((xe === null || !N.contains(xe)) && N.focus({
      preventScroll: !0
    }), we.type !== "element")))) {
      try {
        h.setBaseAndExtent(an, Qe, sr, ft);
      } catch {
      }
      if (!y.has("skip-scroll-into-view") && s.isCollapsed() && N !== null && N === document.activeElement) {
        const gr = s instanceof ir && s.anchor.type === "element" ? an.childNodes[Qe] || null : h.rangeCount > 0 ? h.getRangeAt(0) : null;
        if (gr !== null) {
          let rn;
          if (gr instanceof Text) {
            const kn = document.createRange();
            kn.selectNode(gr), rn = kn.getBoundingClientRect();
          } else
            rn = gr.getBoundingClientRect();
          Ci(c, rn, N);
        }
      }
      Kt();
    }
  }
  function C_(u) {
    let s = mn() || Ho();
    s === null && (s = nr().selectEnd()), s.insertNodes(u);
  }
  function E_() {
    const u = mn();
    return u === null ? "" : u.getTextContent();
  }
  function T_(u, s, c) {
    const h = [];
    let y = null, N = null;
    function b(he, me, xe) {
      const we = {
        cell: xe,
        startColumn: me,
        startRow: he
      }, Ce = xe.__rowSpan, Ve = xe.__colSpan;
      for (let Ue = 0; Ue < Ce; Ue++) {
        h[he + Ue] === void 0 && (h[he + Ue] = []);
        for (let $e = 0; $e < Ve; $e++)
          h[he + Ue][me + $e] = we;
      }
      s.is(xe) && (y = we), c.is(xe) && (N = we);
    }
    function $(he, me) {
      return h[he] === void 0 || h[he][me] === void 0;
    }
    const ae = u.getChildren();
    for (let he = 0; he < ae.length; he++) {
      const me = ae[he];
      if (!Vc(me))
        throw Error("Expected GridNode children to be GridRowNode");
      const xe = me.getChildren();
      let we = 0;
      for (const Ce of xe) {
        if (!Uo(Ce))
          throw Error("Expected GridRowNode children to be GridCellNode");
        for (; !$(he, we); )
          we++;
        b(he, we, Ce), we += Ce.__colSpan;
      }
    }
    if (y === null)
      throw Error("Anchor not found in Grid");
    if (N === null)
      throw Error("Focus not found in Grid");
    return [h, y, N];
  }
  function jd(u) {
    let s;
    if (u instanceof jc)
      s = u;
    else if (u instanceof ai) {
      const y = So(u, Uo);
      if (!Uo(y))
        throw Error("Expected to find a parent GridCellNode");
      s = y;
    } else {
      const y = So(u.getNode(), Uo);
      if (!Uo(y))
        throw Error("Expected to find a parent GridCellNode");
      s = y;
    }
    const c = s.getParent();
    if (!Vc(c))
      throw Error("Expected GridCellNode to have a parent GridRowNode");
    const h = c.getParent();
    if (!af(h))
      throw Error("Expected GridRowNode to have a parent GridNode");
    return [s, c, h];
  }
  function Kc(u) {
    u.isCollapsed() || u.removeText();
    const s = u.anchor;
    let c = s.getNode(), h = s.offset;
    for (; !Wi(c); )
      [c, h] = x_(c, h);
    return h;
  }
  function x_(u, s) {
    const c = u.getParent();
    if (!c) {
      const y = Zi();
      return nr().append(y), y.select(), [nr(), 0];
    }
    if (mt(u)) {
      const y = u.splitText(s);
      if (y.length === 0)
        return [c, u.getIndexWithinParent()];
      const N = s === 0 ? 0 : 1, b = y[0].getIndexWithinParent() + N;
      return [c, b];
    }
    if (!et(u) || s === 0)
      return [c, u.getIndexWithinParent()];
    const h = u.getChildAtIndex(s);
    if (h) {
      const y = new ir(Lr(u.__key, s, "element"), Lr(u.__key, s, "element"), 0, ""), N = u.insertNewAfter(y);
      N && N.append(h, ...h.getNextSiblings());
    }
    return [c, u.getIndexWithinParent() + 1];
  }
  function v_(u) {
    const s = Zi();
    let c = null;
    for (let h = 0; h < u.length; h++) {
      const y = u[h], N = ui(y);
      if (N || An(y) && y.isInline() || et(y) && y.isInline() || mt(y) || y.isParentRequired()) {
        if (c === null && (c = y.createParentElementNode(), s.append(c), N))
          continue;
        c !== null && c.append(y);
      } else
        s.append(y), c = null;
    }
    return s;
  }
  let Qn = null, er = null, Pr = !1, zc = !1, qa = 0;
  const Vd = {
    characterData: !0,
    childList: !0,
    subtree: !0
  };
  function Wo() {
    return Pr || Qn !== null && Qn._readOnly;
  }
  function hr() {
    if (Pr)
      throw Error("Cannot use method in read-only mode.");
  }
  function qd() {
    if (qa > 99)
      throw Error("One or more transforms are endlessly triggering additional transforms. May have encountered infinite recursion caused by transforms that have their preconditions too lose and/or conflict with each other.");
  }
  function Si() {
    if (Qn === null)
      throw Error("Unable to find an active editor state. State helpers or node methods can only be used synchronously during the callback of editor.update() or editorState.read().");
    return Qn;
  }
  function Tn() {
    if (er === null)
      throw Error("Unable to find an active editor. This method can only be used synchronously during the callback of editor.update().");
    return er;
  }
  function S_() {
    return er;
  }
  function Zd(u, s, c) {
    const h = s.__type, y = ya(u, h);
    let N = c.get(h);
    N === void 0 && (N = Array.from(y.transforms), c.set(h, N));
    const b = N.length;
    for (let $ = 0; $ < b && (N[$](s), !!s.isAttached()); $++)
      ;
  }
  function Jd(u, s) {
    return u !== void 0 && // We don't want to transform nodes being composed
    u.__key !== s && u.isAttached();
  }
  function w_(u, s) {
    const c = s._dirtyLeaves, h = u._nodeMap;
    for (const y of c) {
      const N = h.get(y);
      mt(N) && N.isAttached() && N.isSimpleText() && !N.isUnmergeable() && Er(N);
    }
  }
  function O_(u, s) {
    const c = s._dirtyLeaves, h = s._dirtyElements, y = u._nodeMap, N = ar(), b = /* @__PURE__ */ new Map();
    let $ = c, ae = $.size, he = h, me = he.size;
    for (; ae > 0 || me > 0; ) {
      if (ae > 0) {
        s._dirtyLeaves = /* @__PURE__ */ new Set();
        for (const xe of $) {
          const we = y.get(xe);
          mt(we) && we.isAttached() && we.isSimpleText() && !we.isUnmergeable() && Er(we), we !== void 0 && Jd(we, N) && Zd(s, we, b), c.add(xe);
        }
        if ($ = s._dirtyLeaves, ae = $.size, ae > 0) {
          qa++;
          continue;
        }
      }
      s._dirtyLeaves = /* @__PURE__ */ new Set(), s._dirtyElements = /* @__PURE__ */ new Map();
      for (const xe of he) {
        const we = xe[0], Ce = xe[1];
        if (we !== "root" && !Ce)
          continue;
        const Ve = y.get(we);
        Ve !== void 0 && Jd(Ve, N) && Zd(s, Ve, b), h.set(we, Ce);
      }
      $ = s._dirtyLeaves, ae = $.size, he = s._dirtyElements, me = he.size, qa++;
    }
    s._dirtyLeaves = c, s._dirtyElements = h;
  }
  function D_(u) {
    return Uc(u, Tn()._nodes);
  }
  function Uc(u, s) {
    const c = u.type, h = s.get(c);
    if (h === void 0)
      throw Error(`parseEditorState: type "${c}" + not found`);
    const y = h.klass;
    if (u.type !== y.getType())
      throw Error(`LexicalNode: Node ${y.name} does not implement .importJSON().`);
    const N = y.importJSON(u), b = u.children;
    if (et(N) && Array.isArray(b))
      for (let $ = 0; $ < b.length; $++) {
        const ae = b[$], he = Uc(ae, s);
        N.append(he);
      }
    return N;
  }
  function A_(u, s, c) {
    const h = Yc(), y = Qn, N = Pr, b = er, $ = s._dirtyElements, ae = s._dirtyLeaves, he = s._cloneNotNeeded, me = s._dirtyType;
    s._dirtyElements = /* @__PURE__ */ new Map(), s._dirtyLeaves = /* @__PURE__ */ new Set(), s._cloneNotNeeded = /* @__PURE__ */ new Set(), s._dirtyType = 0, Qn = h, Pr = !1, er = s;
    try {
      const xe = s._nodes, we = u.root;
      Uc(we, xe), c && c(), h._readOnly = !0, Qd(h);
    } catch (xe) {
      xe instanceof Error && s._onError(xe);
    } finally {
      s._dirtyElements = $, s._dirtyLeaves = ae, s._cloneNotNeeded = he, s._dirtyType = me, Qn = y, Pr = N, er = b;
    }
    return h;
  }
  function Xd(u, s) {
    const c = Qn, h = Pr, y = er;
    Qn = u, Pr = !0, er = null;
    try {
      return s();
    } finally {
      Qn = c, Pr = h, er = y;
    }
  }
  function Qd(u) {
    const s = u._nodeMap;
    s.set = () => {
      throw new Error("Cannot call set() on a frozen Lexical node map");
    }, s.clear = () => {
      throw new Error("Cannot call clear() on a frozen Lexical node map");
    }, s.delete = () => {
      throw new Error("Cannot call delete() on a frozen Lexical node map");
    };
  }
  function Js(u, s) {
    const c = u._pendingEditorState, h = u._rootElement, y = u._headless || h === null;
    if (c === null)
      return;
    const N = u._editorState, b = N._selection, $ = c._selection, ae = u._dirtyType !== qe, he = Qn, me = Pr, xe = er, we = u._updating, Ce = u._observer;
    let Ve = null;
    if (u._pendingEditorState = null, u._editorState = c, !y && ae && Ce !== null) {
      er = u, Qn = c, Pr = !1, u._updating = !0;
      try {
        const Ot = u._dirtyType, an = u._dirtyElements, sr = u._dirtyLeaves;
        Ce.disconnect(), Ve = Gi(N, c, u, Ot, an, sr);
      } catch (Ot) {
        if (Ot instanceof Error && u._onError(Ot), !zc)
          of(u, null, h, c), or(u), u._dirtyType = ct, zc = !0, Js(u, N), zc = !1;
        else
          throw Ot;
        return;
      } finally {
        Ce.observe(h, Vd), u._updating = we, Qn = he, Pr = me, er = xe;
      }
    }
    c._readOnly || (c._readOnly = !0, Qd(c), Et($) && (Object.freeze($.anchor), Object.freeze($.focus)), Object.freeze($));
    const Ue = u._dirtyLeaves, $e = u._dirtyElements, Mt = u._normalizedNodes, Qe = u._updateTags, ft = u._deferred;
    ae && (u._dirtyType = qe, u._cloneNotNeeded.clear(), u._dirtyLeaves = /* @__PURE__ */ new Set(), u._dirtyElements = /* @__PURE__ */ new Map(), u._normalizedNodes = /* @__PURE__ */ new Set(), u._updateTags = /* @__PURE__ */ new Set()), Pa(u, c);
    const qt = y ? null : cr(u._window);
    if (u._editable && // domSelection will be null in headless
    qt !== null && (ae || $ === null || $.dirty)) {
      er = u, Qn = c;
      try {
        if (Ce !== null && Ce.disconnect(), ae || $ === null || $.dirty) {
          const Ot = u._blockCursorElement;
          Ot !== null && Hs(Ot, u, h), N_(b, $, u, qt, Qe, h);
        }
        Ei(u, h, $), Ce !== null && Ce.observe(h, Vd);
      } finally {
        er = xe, Qn = he;
      }
    }
    Ve !== null && R_(u, Ve, Qe, Ue, N), !Et($) && $ !== null && (b === null || !b.is($)) && u.dispatchCommand(t, void 0);
    const Ht = u._pendingDecorators;
    Ht !== null && (u._decorators = Ht, u._pendingDecorators = null, Ul("decorator", u, !0, Ht)), M_(u, s || N, c), Ul("update", u, !0, {
      dirtyElements: $e,
      dirtyLeaves: Ue,
      editorState: c,
      normalizedNodes: Mt,
      prevEditorState: s || N,
      tags: Qe
    }), L_(u, ft), b_(u);
  }
  function M_(u, s, c) {
    const h = _o(s), y = _o(c);
    h !== y && Ul("textcontent", u, !0, y);
  }
  function R_(u, s, c, h, y) {
    const N = Array.from(u._listeners.mutation), b = N.length;
    for (let $ = 0; $ < b; $++) {
      const [ae, he] = N[$], me = s.get(he);
      me !== void 0 && ae(me, {
        dirtyLeaves: h,
        prevEditorState: y,
        updateTags: c
      });
    }
  }
  function Ul(u, s, c, ...h) {
    const y = s._updating;
    s._updating = c;
    try {
      const N = Array.from(s._listeners[u]);
      for (let b = 0; b < N.length; b++)
        N[b].apply(null, h);
    } finally {
      s._updating = y;
    }
  }
  function ef(u, s, c) {
    if (u._updating === !1 || er !== u) {
      let y = !1;
      return u.update(() => {
        y = ef(u, s, c);
      }), y;
    }
    const h = ki(u);
    for (let y = 4; y >= 0; y--)
      for (let N = 0; N < h.length; N++) {
        const ae = h[N]._commands.get(s);
        if (ae !== void 0) {
          const he = ae[y];
          if (he !== void 0) {
            const me = Array.from(he), xe = me.length;
            for (let we = 0; we < xe; we++)
              if (me[we](c, u) === !0)
                return !0;
          }
        }
      }
    return !1;
  }
  function b_(u) {
    const s = u._updates;
    if (s.length !== 0) {
      const c = s.shift();
      if (c) {
        const [h, y] = c;
        nf(u, h, y);
      }
    }
  }
  function L_(u, s) {
    if (u._deferred = [], s.length !== 0) {
      const c = u._updating;
      u._updating = !0;
      try {
        for (let h = 0; h < s.length; h++)
          s[h]();
      } finally {
        u._updating = c;
      }
    }
  }
  function tf(u, s) {
    const c = u._updates;
    let h = s || !1;
    for (; c.length !== 0; ) {
      const y = c.shift();
      if (y) {
        const [N, b] = y;
        let $, ae;
        b !== void 0 && ($ = b.onUpdate, ae = b.tag, b.skipTransforms && (h = !0), $ && u._deferred.push($), ae && u._updateTags.add(ae)), N();
      }
    }
    return h;
  }
  function nf(u, s, c) {
    const h = u._updateTags;
    let y, N, b = !1, $ = !1;
    c !== void 0 && (y = c.onUpdate, N = c.tag, N != null && h.add(N), b = c.skipTransforms || !1, $ = c.discrete || !1), y && u._deferred.push(y);
    const ae = u._editorState;
    let he = u._pendingEditorState, me = !1;
    (he === null || he._readOnly) && (he = u._pendingEditorState = P_(he || ae), me = !0), he._flushSync = $;
    const xe = Qn, we = Pr, Ce = er, Ve = u._updating;
    Qn = he, Pr = !1, u._updating = !0, er = u;
    try {
      me && (u._headless ? ae._selection != null && (he._selection = ae._selection.clone()) : he._selection = __(u));
      const $e = u._compositionKey;
      s(), b = tf(u, b), y_(he, u), u._dirtyType !== qe && (b ? w_(he, u) : O_(he, u), tf(u), Al(ae, he, u._dirtyLeaves, u._dirtyElements));
      const Mt = u._compositionKey;
      $e !== Mt && (he._flushSync = !0);
      const Qe = he._selection;
      if (Et(Qe)) {
        const ft = he._nodeMap, qt = Qe.anchor.key, Ht = Qe.focus.key;
        if (ft.get(qt) === void 0 || ft.get(Ht) === void 0)
          throw Error("updateEditor: selection has been lost because the previously selected nodes have been removed and selection wasn't moved to another node. Ensure selection changes after removing/replacing a selected node.");
      } else Ur(Qe) && Qe._nodes.size === 0 && (he._selection = null);
    } catch ($e) {
      $e instanceof Error && u._onError($e), u._pendingEditorState = ae, u._dirtyType = ct, u._cloneNotNeeded.clear(), u._dirtyLeaves = /* @__PURE__ */ new Set(), u._dirtyElements.clear(), Js(u);
      return;
    } finally {
      Qn = xe, Pr = we, er = Ce, u._updating = Ve, qa = 0;
    }
    u._dirtyType !== qe || k_(he, u) ? he._flushSync ? (he._flushSync = !1, Js(u)) : me && po(() => {
      Js(u);
    }) : (he._flushSync = !1, me && (h.clear(), u._deferred = [], u._pendingEditorState = null));
  }
  function Gr(u, s, c) {
    u._updating ? u._updates.push([s, c]) : nf(u, s, c);
  }
  class Gc extends ai {
    constructor(s) {
      super(s);
    }
    /**
     * The returned value is added to the LexicalEditor._decorators
     */
    decorate(s, c) {
      throw Error("decorate: base method not extended");
    }
    isIsolated() {
      return !1;
    }
    isInline() {
      return !0;
    }
    isKeyboardSelectable() {
      return !0;
    }
  }
  function An(u) {
    return u instanceof Gc;
  }
  class Xs extends ai {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    constructor(s) {
      super(s), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__indent = 0, this.__dir = null;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getFormatType() {
      const s = this.getFormat();
      return pe[s] || "";
    }
    getIndent() {
      return this.getLatest().__indent;
    }
    getChildren() {
      const s = [];
      let c = this.getFirstChild();
      for (; c !== null; )
        s.push(c), c = c.getNextSibling();
      return s;
    }
    getChildrenKeys() {
      const s = [];
      let c = this.getFirstChild();
      for (; c !== null; )
        s.push(c.__key), c = c.getNextSibling();
      return s;
    }
    getChildrenSize() {
      return this.getLatest().__size;
    }
    isEmpty() {
      return this.getChildrenSize() === 0;
    }
    isDirty() {
      const c = Tn()._dirtyElements;
      return c !== null && c.has(this.__key);
    }
    isLastChild() {
      const s = this.getLatest(), c = this.getParentOrThrow().getLastChild();
      return c !== null && c.is(s);
    }
    getAllTextNodes() {
      const s = [];
      let c = this.getFirstChild();
      for (; c !== null; ) {
        if (mt(c) && s.push(c), et(c)) {
          const h = c.getAllTextNodes();
          s.push(...h);
        }
        c = c.getNextSibling();
      }
      return s;
    }
    getFirstDescendant() {
      let s = this.getFirstChild();
      for (; s !== null; ) {
        if (et(s)) {
          const c = s.getFirstChild();
          if (c !== null) {
            s = c;
            continue;
          }
        }
        break;
      }
      return s;
    }
    getLastDescendant() {
      let s = this.getLastChild();
      for (; s !== null; ) {
        if (et(s)) {
          const c = s.getLastChild();
          if (c !== null) {
            s = c;
            continue;
          }
        }
        break;
      }
      return s;
    }
    getDescendantByIndex(s) {
      const c = this.getChildren(), h = c.length;
      if (s >= h) {
        const N = c[h - 1];
        return et(N) && N.getLastDescendant() || N || null;
      }
      const y = c[s];
      return et(y) && y.getFirstDescendant() || y || null;
    }
    getFirstChild() {
      const c = this.getLatest().__first;
      return c === null ? null : Nn(c);
    }
    getFirstChildOrThrow() {
      const s = this.getFirstChild();
      if (s === null)
        throw Error(`Expected node ${this.__key} to have a first child.`);
      return s;
    }
    getLastChild() {
      const c = this.getLatest().__last;
      return c === null ? null : Nn(c);
    }
    getLastChildOrThrow() {
      const s = this.getLastChild();
      if (s === null)
        throw Error(`Expected node ${this.__key} to have a last child.`);
      return s;
    }
    getChildAtIndex(s) {
      const c = this.getChildrenSize();
      let h, y;
      if (s < c / 2) {
        for (h = this.getFirstChild(), y = 0; h !== null && y <= s; ) {
          if (y === s)
            return h;
          h = h.getNextSibling(), y++;
        }
        return null;
      }
      for (h = this.getLastChild(), y = c - 1; h !== null && y >= s; ) {
        if (y === s)
          return h;
        h = h.getPreviousSibling(), y--;
      }
      return null;
    }
    getTextContent() {
      let s = "";
      const c = this.getChildren(), h = c.length;
      for (let y = 0; y < h; y++) {
        const N = c[y];
        s += N.getTextContent(), et(N) && y !== h - 1 && !N.isInline() && (s += Pt);
      }
      return s;
    }
    getTextContentSize() {
      let s = 0;
      const c = this.getChildren(), h = c.length;
      for (let y = 0; y < h; y++) {
        const N = c[y];
        s += N.getTextContentSize(), et(N) && y !== h - 1 && !N.isInline() && (s += Pt.length);
      }
      return s;
    }
    getDirection() {
      return this.getLatest().__dir;
    }
    hasFormat(s) {
      if (s !== "") {
        const c = Ni[s];
        return (this.getFormat() & c) !== 0;
      }
      return !1;
    }
    // Mutators
    select(s, c) {
      hr();
      const h = mn();
      let y = s, N = c;
      const b = this.getChildrenSize();
      if (!this.canBeEmpty()) {
        if (s === 0 && c === 0) {
          const ae = this.getFirstChild();
          if (mt(ae) || et(ae))
            return ae.select(0, 0);
        } else if ((s === void 0 || s === b) && (c === void 0 || c === b)) {
          const ae = this.getLastChild();
          if (mt(ae) || et(ae))
            return ae.select();
        }
      }
      y === void 0 && (y = b), N === void 0 && (N = b);
      const $ = this.__key;
      if (Et(h))
        h.anchor.set($, y, "element"), h.focus.set($, N, "element"), h.dirty = !0;
      else
        return Ud($, y, $, N, "element", "element");
      return h;
    }
    selectStart() {
      const s = this.getFirstDescendant();
      return s ? s.selectStart() : this.select();
    }
    selectEnd() {
      const s = this.getLastDescendant();
      return s ? s.selectEnd() : this.select();
    }
    clear() {
      const s = this.getWritable();
      return this.getChildren().forEach((h) => h.remove()), s;
    }
    append(...s) {
      return this.splice(this.getChildrenSize(), 0, s);
    }
    setDirection(s) {
      const c = this.getWritable();
      return c.__dir = s, c;
    }
    setFormat(s) {
      const c = this.getWritable();
      return c.__format = s !== "" ? Ni[s] : 0, this;
    }
    setIndent(s) {
      const c = this.getWritable();
      return c.__indent = s, this;
    }
    splice(s, c, h) {
      const y = h.length, N = this.getChildrenSize(), b = this.getWritable(), $ = b.__key, ae = [], he = [], me = this.getChildAtIndex(s + c);
      let xe = null, we = N - c + y;
      if (s !== 0)
        if (s === N)
          xe = this.getLastChild();
        else {
          const Ve = this.getChildAtIndex(s);
          Ve !== null && (xe = Ve.getPreviousSibling());
        }
      if (c > 0) {
        let Ve = xe === null ? this.getFirstChild() : xe.getNextSibling();
        for (let Ue = 0; Ue < c; Ue++) {
          if (Ve === null)
            throw Error("splice: sibling not found");
          const $e = Ve.getNextSibling(), Mt = Ve.__key, Qe = Ve.getWritable();
          Zr(Qe), he.push(Mt), Ve = $e;
        }
      }
      let Ce = xe;
      for (let Ve = 0; Ve < y; Ve++) {
        const Ue = h[Ve];
        Ce !== null && Ue.is(Ce) && (xe = Ce = Ce.getPreviousSibling());
        const $e = Ue.getWritable();
        $e.__parent === $ && we--, Zr($e);
        const Mt = Ue.__key;
        if (Ce === null)
          b.__first = Mt, $e.__prev = null;
        else {
          const Qe = Ce.getWritable();
          Qe.__next = Mt, $e.__prev = Qe.__key;
        }
        if (Ue.__key === $)
          throw Error("append: attempting to append self");
        $e.__parent = $, ae.push(Mt), Ce = Ue;
      }
      if (s + c === N) {
        if (Ce !== null) {
          const Ve = Ce.getWritable();
          Ve.__next = null, b.__last = Ce.__key;
        }
      } else if (me !== null) {
        const Ve = me.getWritable();
        if (Ce !== null) {
          const Ue = Ce.getWritable();
          Ve.__prev = Ce.__key, Ue.__next = me.__key;
        } else
          Ve.__prev = null;
      }
      if (b.__size = we, he.length) {
        const Ve = mn();
        if (Et(Ve)) {
          const Ue = new Set(he), $e = new Set(ae), {
            anchor: Mt,
            focus: Qe
          } = Ve;
          rf(Mt, Ue, $e) && Va(Mt, Mt.getNode(), this, xe, me), rf(Qe, Ue, $e) && Va(Qe, Qe.getNode(), this, xe, me), we === 0 && !this.canBeEmpty() && !li(this) && this.remove();
        }
      }
      return b;
    }
    // JSON serialization
    exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "element",
        version: 1
      };
    }
    // These are intended to be extends for specific element heuristics.
    insertNewAfter(s, c) {
      return null;
    }
    canIndent() {
      return !0;
    }
    /*
     * This method controls the behavior of a the node during backwards
     * deletion (i.e., backspace) when selection is at the beginning of
     * the node (offset 0)
     */
    collapseAtStart(s) {
      return !1;
    }
    excludeFromCopy(s) {
      return !1;
    }
    // TODO 0.10 deprecate
    canExtractContents() {
      return !0;
    }
    canReplaceWith(s) {
      return !0;
    }
    canInsertAfter(s) {
      return !0;
    }
    canBeEmpty() {
      return !0;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    isInline() {
      return !1;
    }
    // A shadow root is a Node that behaves like RootNode. The shadow root (and RootNode) mark the
    // end of the hiercharchy, most implementations should treat it as there's nothing (upwards)
    // beyond this point. For example, node.getTopLevelElement(), when performed inside a TableCellNode
    // will return the immediate first child underneath TableCellNode instead of RootNode.
    isShadowRoot() {
      return !1;
    }
    canMergeWith(s) {
      return !1;
    }
    extractWithChild(s, c, h) {
      return !1;
    }
  }
  function et(u) {
    return u instanceof Xs;
  }
  function rf(u, s, c) {
    let h = u.getNode();
    for (; h; ) {
      const y = h.__key;
      if (s.has(y) && !c.has(y))
        return !0;
      h = h.getParent();
    }
    return !1;
  }
  class Ko extends Xs {
    /** @internal */
    static getType() {
      return "root";
    }
    static clone() {
      return new Ko();
    }
    constructor() {
      super("root"), this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
      throw Error("getTopLevelElementOrThrow: root nodes are not top level elements");
    }
    getTextContent() {
      const s = this.__cachedText;
      return (Wo() || Tn()._dirtyType === qe) && s !== null ? s : super.getTextContent();
    }
    remove() {
      throw Error("remove: cannot be called on root nodes");
    }
    replace(s) {
      throw Error("replace: cannot be called on root nodes");
    }
    insertBefore(s) {
      throw Error("insertBefore: cannot be called on root nodes");
    }
    insertAfter(s) {
      throw Error("insertAfter: cannot be called on root nodes");
    }
    // View
    updateDOM(s, c) {
      return !1;
    }
    // Mutate
    append(...s) {
      for (let c = 0; c < s.length; c++) {
        const h = s[c];
        if (!et(h) && !An(h))
          throw Error("rootNode.append: Only element or decorator nodes can be appended to the root node");
      }
      return super.append(...s);
    }
    static importJSON(s) {
      const c = nr();
      return c.setFormat(s.format), c.setIndent(s.indent), c.setDirection(s.direction), c;
    }
    exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "root",
        version: 1
      };
    }
    collapseAtStart() {
      return !0;
    }
  }
  function I_() {
    return new Ko();
  }
  function Yr(u) {
    return u instanceof Ko;
  }
  function k_(u, s) {
    const c = s.getEditorState()._selection, h = u._selection;
    if (h !== null) {
      if (h.dirty || !h.is(c))
        return !0;
    } else if (c !== null)
      return !0;
    return !1;
  }
  function P_(u) {
    return new Za(new Map(u._nodeMap));
  }
  function Yc() {
    return new Za(/* @__PURE__ */ new Map([["root", I_()]]));
  }
  function sf(u) {
    const s = u.exportJSON(), c = u.constructor;
    if (s.type !== c.getType())
      throw Error(`LexicalNode: Node ${c.name} does not match the serialized type. Check if .exportJSON() is implemented and it is returning the correct type.`);
    if (et(u)) {
      const h = s.children;
      if (!Array.isArray(h))
        throw Error(`LexicalNode: Node ${c.name} is an element but .exportJSON() does not have a children array.`);
      const y = u.getChildren();
      for (let N = 0; N < y.length; N++) {
        const b = y[N], $ = sf(b);
        h.push($);
      }
    }
    return s;
  }
  class Za {
    constructor(s, c) {
      this._nodeMap = s, this._selection = c || null, this._flushSync = !1, this._readOnly = !1;
    }
    isEmpty() {
      return this._nodeMap.size === 1 && this._selection === null;
    }
    read(s) {
      return Xd(this, s);
    }
    clone(s) {
      const c = new Za(this._nodeMap, s === void 0 ? this._selection : s);
      return c._readOnly = !0, c;
    }
    toJSON() {
      return Xd(this, () => ({
        root: sf(nr())
      }));
    }
  }
  class zo extends Xs {
    static getType() {
      return "paragraph";
    }
    static clone(s) {
      return new zo(s.__key);
    }
    // View
    createDOM(s) {
      const c = document.createElement("p"), h = Fi(s.theme, "paragraph");
      return h !== void 0 && c.classList.add(...h), c;
    }
    updateDOM(s, c, h) {
      return !1;
    }
    static importDOM() {
      return {
        p: (s) => ({
          conversion: $_,
          priority: 0
        })
      };
    }
    exportDOM(s) {
      const {
        element: c
      } = super.exportDOM(s);
      if (c && Ws(c)) {
        this.isEmpty() && c.append(document.createElement("br"));
        const h = this.getFormatType();
        c.style.textAlign = h;
        const y = this.getDirection();
        y && (c.dir = y);
        const N = this.getIndent();
        N > 0 && (c.style.textIndent = `${N * 20}px`);
      }
      return {
        element: c
      };
    }
    static importJSON(s) {
      const c = Zi();
      return c.setFormat(s.format), c.setIndent(s.indent), c.setDirection(s.direction), c;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "paragraph",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(s, c) {
      const h = Zi(), y = this.getDirection();
      return h.setDirection(y), this.insertAfter(h, c), h;
    }
    collapseAtStart() {
      const s = this.getChildren();
      if (s.length === 0 || mt(s[0]) && s[0].getTextContent().trim() === "") {
        if (this.getNextSibling() !== null)
          return this.selectNext(), this.remove(), !0;
        if (this.getPreviousSibling() !== null)
          return this.selectPrevious(), this.remove(), !0;
      }
      return !1;
    }
  }
  function $_(u) {
    const s = Zi();
    if (u.style) {
      s.setFormat(u.style.textAlign);
      const c = parseInt(u.style.textIndent, 10) / 20;
      c > 0 && s.setIndent(c);
    }
    return {
      node: s
    };
  }
  function Zi() {
    return Mr(new zo());
  }
  function F_(u) {
    return u instanceof zo;
  }
  const B_ = 0, H_ = 1, W_ = 2, K_ = 3, z_ = 4;
  function of(u, s, c, h) {
    const y = u._keyToDOMMap;
    y.clear(), u._editorState = Yc(), u._pendingEditorState = h, u._compositionKey = null, u._dirtyType = qe, u._cloneNotNeeded.clear(), u._dirtyLeaves = /* @__PURE__ */ new Set(), u._dirtyElements.clear(), u._normalizedNodes = /* @__PURE__ */ new Set(), u._updateTags = /* @__PURE__ */ new Set(), u._updates = [], u._blockCursorElement = null;
    const N = u._observer;
    N !== null && (N.disconnect(), u._observer = null), s !== null && (s.textContent = ""), c !== null && (c.textContent = "", y.set("root", c));
  }
  function U_(u, s) {
    const c = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Set(), y = (N) => {
      Object.keys(N).forEach((b) => {
        let $ = c.get(b);
        $ === void 0 && ($ = [], c.set(b, $)), $.push(N[b]);
      });
    };
    return u.forEach((N) => {
      const b = N.klass.importDOM != null ? N.klass.importDOM.bind(N.klass) : null;
      if (b == null || h.has(b))
        return;
      h.add(b);
      const $ = b();
      $ !== null && y($);
    }), s && y(s), c;
  }
  function G_(u) {
    const s = u || {}, c = S_(), h = s.theme || {}, y = u === void 0 ? c : s.parentEditor || null, N = s.disableEvents || !1, b = Yc(), $ = s.namespace || (y !== null ? y._config.namespace : yl()), ae = s.editorState, he = [Ko, Qr, Vi, Sr, zo, ...s.nodes || []], {
      onError: me,
      html: xe
    } = s, we = s.editable !== void 0 ? s.editable : !0;
    let Ce;
    if (u === void 0 && c !== null)
      Ce = c._nodes;
    else {
      Ce = /* @__PURE__ */ new Map();
      for (let Ue = 0; Ue < he.length; Ue++) {
        let $e = he[Ue], Mt = null, Qe = null;
        if (typeof $e != "function") {
          const Ot = $e;
          $e = Ot.replace, Mt = Ot.with, Qe = Ot.withKlass || null;
        }
        {
          const Ot = $e.name;
          if (Ot !== "RootNode") {
            const an = $e.prototype;
            ["getType", "clone"].forEach((sr) => {
              $e.hasOwnProperty(sr) || console.warn(`${Ot} must implement static "${sr}" method`);
            }), // eslint-disable-next-line no-prototype-builtins
            !$e.hasOwnProperty("importDOM") && // eslint-disable-next-line no-prototype-builtins
            $e.hasOwnProperty("exportDOM") && console.warn(`${Ot} should implement "importDOM" if using a custom "exportDOM" method to ensure HTML serialization (important for copy & paste) works as expected`), an instanceof Gc && (an.hasOwnProperty("decorate") || console.warn(`${an.constructor.name} must implement "decorate" method`)), $e.hasOwnProperty("importJSON") || console.warn(`${Ot} should implement "importJSON" method to ensure JSON and default HTML serialization works as expected`), an.hasOwnProperty("exportJSON") || console.warn(`${Ot} should implement "exportJSON" method to ensure JSON and default HTML serialization works as expected`);
          }
        }
        const ft = $e.getType(), qt = $e.transform(), Ht = /* @__PURE__ */ new Set();
        qt !== null && Ht.add(qt), Ce.set(ft, {
          exportDOM: xe && xe.export ? xe.export.get($e) : void 0,
          klass: $e,
          replace: Mt,
          replaceWithKlass: Qe,
          transforms: Ht
        });
      }
    }
    const Ve = new Y_(b, y, Ce, {
      disableEvents: N,
      namespace: $,
      theme: h
    }, me || console.error, U_(Ce, xe ? xe.import : void 0), we);
    return ae !== void 0 && (Ve._pendingEditorState = ae, Ve._dirtyType = ct), Ve;
  }
  class Y_ {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    constructor(s, c, h, y, N, b, $) {
      this._parentEditor = c, this._rootElement = null, this._editorState = s, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = {
        decorator: /* @__PURE__ */ new Set(),
        editable: /* @__PURE__ */ new Set(),
        mutation: /* @__PURE__ */ new Map(),
        root: /* @__PURE__ */ new Set(),
        textcontent: /* @__PURE__ */ new Set(),
        update: /* @__PURE__ */ new Set()
      }, this._commands = /* @__PURE__ */ new Map(), this._config = y, this._nodes = h, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = qe, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = yl(), this._onError = N, this._htmlConversions = b, this._editable = $, this._headless = c !== null && c._headless, this._window = null, this._blockCursorElement = null;
    }
    /**
     *
     * @returns true if the editor is currently in "composition" mode due to receiving input
     * through an IME, or 3P extension, for example. Returns false otherwise.
     */
    isComposing() {
      return this._compositionKey != null;
    }
    /**
     * Registers a listener for Editor update event. Will trigger the provided callback
     * each time the editor goes through an update (via {@link LexicalEditor.update}) until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerUpdateListener(s) {
      const c = this._listeners.update;
      return c.add(s), () => {
        c.delete(s);
      };
    }
    /**
     * Registers a listener for for when the editor changes between editable and non-editable states.
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerEditableListener(s) {
      const c = this._listeners.editable;
      return c.add(s), () => {
        c.delete(s);
      };
    }
    /**
     * Registers a listener for when the editor's decorator object changes. The decorator object contains
     * all DecoratorNode keys -> their decorated value. This is primarily used with external UI frameworks.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerDecoratorListener(s) {
      const c = this._listeners.decorator;
      return c.add(s), () => {
        c.delete(s);
      };
    }
    /**
     * Registers a listener for when Lexical commits an update to the DOM and the text content of
     * the editor changes from the previous state of the editor. If the text content is the
     * same between updates, no notifications to the listeners will happen.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerTextContentListener(s) {
      const c = this._listeners.textcontent;
      return c.add(s), () => {
        c.delete(s);
      };
    }
    /**
     * Registers a listener for when the editor's root DOM element (the content editable
     * Lexical attaches to) changes. This is primarily used to attach event listeners to the root
     *  element. The root listener function is executed directly upon registration and then on
     * any subsequent update.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerRootListener(s) {
      const c = this._listeners.root;
      return s(this._rootElement, null), c.add(s), () => {
        s(null, this._rootElement), c.delete(s);
      };
    }
    /**
     * Registers a listener that will trigger anytime the provided command
     * is dispatched, subject to priority. Listeners that run at a higher priority can "intercept"
     * commands and prevent them from propagating to other handlers by returning true.
     *
     * Listeners registered at the same priority level will run deterministically in the order of registration.
     *
     * @param command - the command that will trigger the callback.
     * @param listener - the function that will execute when the command is dispatched.
     * @param priority - the relative priority of the listener. 0 | 1 | 2 | 3 | 4
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerCommand(s, c, h) {
      if (h === void 0)
        throw Error('Listener for type "command" requires a "priority".');
      const y = this._commands;
      y.has(s) || y.set(s, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
      const N = y.get(s);
      if (N === void 0)
        throw Error(`registerCommand: Command ${String(s)} not found in command map`);
      const b = N[h];
      return b.add(c), () => {
        b.delete(c), N.every(($) => $.size === 0) && y.delete(s);
      };
    }
    /**
     * Registers a listener that will run when a Lexical node of the provided class is
     * mutated. The listener will receive a list of nodes along with the type of mutation
     * that was performed on each: created, destroyed, or updated.
     *
     * One common use case for this is to attach DOM event listeners to the underlying DOM nodes as Lexical nodes are created.
     * {@link LexicalEditor.getElementByKey} can be used for this.
     *
     * @param klass - The class of the node that you want to listen to mutations on.
     * @param listener - The logic you want to run when the node is mutated.
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerMutationListener(s, c) {
      if (this._nodes.get(s.getType()) === void 0)
        throw Error(`Node ${s.name} has not been registered. Ensure node has been passed to createEditor.`);
      const y = this._listeners.mutation;
      return y.set(c, s), () => {
        y.delete(c);
      };
    }
    /** @internal */
    registerNodeTransformToKlass(s, c) {
      const h = s.getType(), y = this._nodes.get(h);
      if (y === void 0)
        throw Error(`Node ${s.name} has not been registered. Ensure node has been passed to createEditor.`);
      return y.transforms.add(c), y;
    }
    /**
     * Registers a listener that will run when a Lexical node of the provided class is
     * marked dirty during an update. The listener will continue to run as long as the node
     * is marked dirty. There are no guarantees around the order of transform execution!
     *
     * Watch out for infinite loops. See [Node Transforms](https://lexical.dev/docs/concepts/transforms)
     * @param klass - The class of the node that you want to run transforms on.
     * @param listener - The logic you want to run when the node is updated.
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerNodeTransform(s, c) {
      const h = this.registerNodeTransformToKlass(s, c), y = [h], N = h.replaceWithKlass;
      if (N != null) {
        const b = this.registerNodeTransformToKlass(N, c);
        y.push(b);
      }
      return Li(this, s.getType()), () => {
        y.forEach((b) => b.transforms.delete(c));
      };
    }
    /**
     * Used to assert that a certain node is registered, usually by plugins to ensure nodes that they
     * depend on have been registered.
     * @returns True if the editor has registered the provided node type, false otherwise.
     */
    hasNode(s) {
      return this._nodes.has(s.getType());
    }
    /**
     * Used to assert that certain nodes are registered, usually by plugins to ensure nodes that they
     * depend on have been registered.
     * @returns True if the editor has registered all of the provided node types, false otherwise.
     */
    hasNodes(s) {
      return s.every(this.hasNode.bind(this));
    }
    /**
     * Dispatches a command of the specified type with the specified payload.
     * This triggers all command listeners (set by {@link LexicalEditor.registerCommand})
     * for this type, passing them the provided payload.
     * @param type - the type of command listeners to trigger.
     * @param payload - the data to pass as an argument to the command listeners.
     */
    dispatchCommand(s, c) {
      return ut(this, s, c);
    }
    /**
     * Gets a map of all decorators in the editor.
     * @returns A mapping of call decorator keys to their decorated content
     */
    getDecorators() {
      return this._decorators;
    }
    /**
     *
     * @returns the current root element of the editor. If you want to register
     * an event listener, do it via {@link LexicalEditor.registerRootListener}, since
     * this reference may not be stable.
     */
    getRootElement() {
      return this._rootElement;
    }
    /**
     * Gets the key of the editor
     * @returns The editor key
     */
    getKey() {
      return this._key;
    }
    /**
     * Imperatively set the root contenteditable element that Lexical listens
     * for events on.
     */
    setRootElement(s) {
      const c = this._rootElement;
      if (s !== c) {
        const h = Fi(this._config.theme, "root"), y = this._pendingEditorState || this._editorState;
        if (this._rootElement = s, of(this, c, s, y), c !== null && (this._config.disableEvents || wt(c), h != null && c.classList.remove(...h)), s !== null) {
          const N = La(s), b = s.style;
          b.userSelect = "text", b.whiteSpace = "pre-wrap", b.wordBreak = "break-word", s.setAttribute("data-lexical-editor", "true"), this._window = N, this._dirtyType = ct, or(this), this._updateTags.add("history-merge"), Js(this), this._config.disableEvents || gt(s, this), h != null && s.classList.add(...h);
        } else
          this._editorState = y, this._pendingEditorState = null, this._window = null;
        Ul("root", this, !1, s, c);
      }
    }
    /**
     * Gets the underlying HTMLElement associated with the LexicalNode for the given key.
     * @returns the HTMLElement rendered by the LexicalNode associated with the key.
     * @param key - the key of the LexicalNode.
     */
    getElementByKey(s) {
      return this._keyToDOMMap.get(s) || null;
    }
    /**
     * Gets the active editor state.
     * @returns The editor state
     */
    getEditorState() {
      return this._editorState;
    }
    /**
     * Imperatively set the EditorState. Triggers reconciliation like an update.
     * @param editorState - the state to set the editor
     * @param options - options for the update.
     */
    setEditorState(s, c) {
      if (s.isEmpty())
        throw Error("setEditorState: the editor state is empty. Ensure the editor state's root node never becomes empty.");
      un(this);
      const h = this._pendingEditorState, y = this._updateTags, N = c !== void 0 ? c.tag : null;
      h !== null && !h.isEmpty() && (N != null && y.add(N), Js(this)), this._pendingEditorState = s, this._dirtyType = ct, this._dirtyElements.set("root", !1), this._compositionKey = null, N != null && y.add(N), Js(this);
    }
    /**
     * Parses a SerializedEditorState (usually produced by {@link EditorState.toJSON}) and returns
     * and EditorState object that can be, for example, passed to {@link LexicalEditor.setEditorState}. Typically,
     * deserliazation from JSON stored in a database uses this method.
     * @param maybeStringifiedEditorState
     * @param updateFn
     * @returns
     */
    parseEditorState(s, c) {
      const h = typeof s == "string" ? JSON.parse(s) : s;
      return A_(h, this, c);
    }
    /**
     * Executes an update to the editor state. The updateFn callback is the ONLY place
     * where Lexical editor state can be safely mutated.
     * @param updateFn - A function that has access to writable editor state.
     * @param options - A bag of options to control the behavior of the update.
     * @param options.onUpdate - A function to run once the update is complete.
     * Useful for synchronizing updates in some cases.
     * @param options.skipTransforms - Setting this to true will suppress all node
     * transforms for this update cycle.
     * @param options.tag - A tag to identify this update, in an update listener, for instance.
     * Some tags are reserved by the core and control update behavior in different ways.
     * @param options.discrete - If true, prevents this update from being batched, forcing it to
     * run synchronously.
     */
    update(s, c) {
      Gr(this, s, c);
    }
    /**
     * Focuses the editor
     * @param callbackFn - A function to run after the editor is focused.
     * @param options - A bag of options
     * @param options.defaultSelection - Where to move selection when the editor is
     * focused. Can be rootStart, rootEnd, or undefined. Defaults to rootEnd.
     */
    focus(s, c = {}) {
      const h = this._rootElement;
      h !== null && (h.setAttribute("autocapitalize", "off"), Gr(this, () => {
        const y = mn(), N = nr();
        y !== null ? y.dirty = !0 : N.getChildrenSize() !== 0 && (c.defaultSelection === "rootStart" ? N.selectStart() : N.selectEnd());
      }, {
        onUpdate: () => {
          h.removeAttribute("autocapitalize"), s && s();
        },
        tag: "focus"
      }), this._pendingEditorState === null && h.removeAttribute("autocapitalize"));
    }
    /**
     * Removes focus from the editor.
     */
    blur() {
      const s = this._rootElement;
      s !== null && s.blur();
      const c = cr(this._window);
      c !== null && c.removeAllRanges();
    }
    /**
     * Returns true if the editor is editable, false otherwise.
     * @returns True if the editor is editable, false otherwise.
     */
    isEditable() {
      return this._editable;
    }
    /**
     * Sets the editable property of the editor. When false, the
     * editor will not listen for user events on the underling contenteditable.
     * @param editable - the value to set the editable mode to.
     */
    setEditable(s) {
      this._editable !== s && (this._editable = s, Ul("editable", this, !0, s));
    }
    /**
     * Returns a JSON-serializable javascript object NOT a JSON string.
     * You still must call JSON.stringify (or something else) to turn the
     * state into a string you can transfer over the wire and store in a database.
     *
     * See {@link LexicalNode.exportJSON}
     *
     * @returns A JSON-serializable javascript object
     */
    toJSON() {
      return {
        editorState: this._editorState.toJSON()
      };
    }
  }
  class jc extends Xs {
    /** @internal */
    constructor(s, c) {
      super(c), this.__colSpan = s, this.__rowSpan = 1;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        colSpan: this.__colSpan,
        rowSpan: this.__rowSpan
      };
    }
    getColSpan() {
      return this.__colSpan;
    }
    setColSpan(s) {
      return this.getWritable().__colSpan = s, this;
    }
    getRowSpan() {
      return this.__rowSpan;
    }
    setRowSpan(s) {
      return this.getWritable().__rowSpan = s, this;
    }
  }
  function Uo(u) {
    return u instanceof jc;
  }
  class lf extends Xs {
  }
  function af(u) {
    return u instanceof lf;
  }
  class cf extends Xs {
  }
  function Vc(u) {
    return u instanceof cf;
  }
  return He.$INTERNAL_isPointSelection = dr, He.$addUpdateTag = Nt, He.$applyNodeReplacement = Mr, He.$copyNode = Ol, He.$createLineBreakNode = ms, He.$createNodeSelection = Hc, He.$createParagraphNode = Zi, He.$createPoint = Lr, He.$createRangeSelection = m_, He.$createTabNode = Po, He.$createTextNode = Dn, He.$getAdjacentNode = Sl, He.$getNearestNodeFromDOMNode = oi, He.$getNearestRootOrShadowRoot = xo, He.$getNodeByKey = Nn, He.$getPreviousSelection = Ho, He.$getRoot = nr, He.$getSelection = mn, He.$getTextContent = E_, He.$hasAncestor = Hi, He.$hasUpdateTag = Un, He.$insertNodes = C_, He.$isBlockElementNode = p_, He.$isDecoratorNode = An, He.$isElementNode = et, He.$isInlineElementOrDecoratorNode = Hr, He.$isLeafNode = As, He.$isLineBreakNode = ui, He.$isNodeSelection = Ur, He.$isParagraphNode = F_, He.$isRangeSelection = Et, He.$isRootNode = Yr, He.$isRootOrShadowRoot = li, He.$isTabNode = $o, He.$isTextNode = mt, He.$nodesOfType = Bi, He.$normalizeSelection__EXPERIMENTAL = Os, He.$parseSerializedNode = D_, He.$selectAll = vl, He.$setCompositionKey = vn, He.$setSelection = Tr, He.$splitNode = Ia, He.BLUR_COMMAND = B, He.CAN_REDO_COMMAND = X, He.CAN_UNDO_COMMAND = fe, He.CLEAR_EDITOR_COMMAND = R, He.CLEAR_HISTORY_COMMAND = U, He.CLICK_COMMAND = r, He.COMMAND_PRIORITY_CRITICAL = z_, He.COMMAND_PRIORITY_EDITOR = B_, He.COMMAND_PRIORITY_HIGH = K_, He.COMMAND_PRIORITY_LOW = H_, He.COMMAND_PRIORITY_NORMAL = W_, He.CONTROLLED_TEXT_INSERTION_COMMAND = p, He.COPY_COMMAND = Y, He.CUT_COMMAND = W, He.DELETE_CHARACTER_COMMAND = l, He.DELETE_LINE_COMMAND = S, He.DELETE_WORD_COMMAND = T, He.DEPRECATED_$computeGridMap = T_, He.DEPRECATED_$getGridCellNodeRect = kr, He.DEPRECATED_$getNodeTriplet = jd, He.DEPRECATED_$isGridCellNode = Uo, He.DEPRECATED_$isGridNode = af, He.DEPRECATED_$isGridRowNode = Vc, He.DEPRECATED_GridCellNode = jc, He.DEPRECATED_GridNode = lf, He.DEPRECATED_GridRowNode = cf, He.DRAGEND_COMMAND = oe, He.DRAGOVER_COMMAND = Z, He.DRAGSTART_COMMAND = D, He.DROP_COMMAND = de, He.DecoratorNode = Gc, He.ElementNode = Xs, He.FOCUS_COMMAND = _e, He.FORMAT_ELEMENT_COMMAND = K, He.FORMAT_TEXT_COMMAND = w, He.INDENT_CONTENT_COMMAND = Se, He.INSERT_LINE_BREAK_COMMAND = d, He.INSERT_PARAGRAPH_COMMAND = f, He.INSERT_TAB_COMMAND = Te, He.INTERNAL_PointSelection = Ir, He.KEY_ARROW_DOWN_COMMAND = j, He.KEY_ARROW_LEFT_COMMAND = k, He.KEY_ARROW_RIGHT_COMMAND = I, He.KEY_ARROW_UP_COMMAND = H, He.KEY_BACKSPACE_COMMAND = ce, He.KEY_DELETE_COMMAND = z, He.KEY_DOWN_COMMAND = v, He.KEY_ENTER_COMMAND = re, He.KEY_ESCAPE_COMMAND = V, He.KEY_MODIFIER_COMMAND = M, He.KEY_SPACE_COMMAND = te, He.KEY_TAB_COMMAND = q, He.LineBreakNode = Vi, He.MOVE_TO_END = G, He.MOVE_TO_START = P, He.OUTDENT_CONTENT_COMMAND = Ee, He.PASTE_COMMAND = _, He.ParagraphNode = zo, He.REDO_COMMAND = m, He.REMOVE_TEXT_COMMAND = E, He.RootNode = Ko, He.SELECTION_CHANGE_COMMAND = t, He.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND = n, He.SELECT_ALL_COMMAND = J, He.TabNode = Sr, He.TextNode = Qr, He.UNDO_COMMAND = O, He.createCommand = e, He.createEditor = G_, He.getNearestEditorFromDOMNode = dl, He.isCurrentlyReadOnlyMode = Wo, He.isHTMLAnchorElement = ka, He.isHTMLElement = Ws, He.isSelectionCapturedInDecoratorInput = Ds, He.isSelectionWithinEditor = os, He;
}
var We = {}, Rf;
function LN() {
  if (Rf) return We;
  Rf = 1;
  let e = {}, t = {}, n = {}, r = {}, l = {}, d = {}, f = {}, p = {}, _ = {}, E = {}, T = {}, S = {}, w = {}, O = {}, m = {}, v = {}, I = {}, G = {}, k = {}, P = {}, H = {}, j = {}, re = {}, te = {}, ce = {}, V = {}, z = {}, q = {}, Te = {}, Se = {}, Ee = {}, de = {}, K = {}, D = {}, Z = {}, oe = {};
  function Y(o) {
    let i = new URLSearchParams();
    i.append("code", o);
    for (let a = 1; a < arguments.length; a++) i.append("v", arguments[a]);
    throw Error(`Minified Lexical error #${o}; visit https://lexical.dev/docs/error?${i} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  let W = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", J = W && "documentMode" in document ? document.documentMode : null, R = W && /Mac|iPod|iPhone|iPad/.test(navigator.platform), U = W && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), X = W && "InputEvent" in window && !J ? "getTargetRanges" in new window.InputEvent("input") : !1, fe = W && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), _e = W && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, B = W && /Android/.test(navigator.userAgent), M = W && /^(?=.*Chrome).*/i.test(navigator.userAgent), F = W && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !M, se = fe || _e || F ? " " : "​", ye = U ? " " : se, De = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, ee = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, ne = { bold: 1, code: 16, highlight: 128, italic: 2, strikethrough: 4, subscript: 32, superscript: 64, underline: 8 }, ue = { directionless: 1, unmergeable: 2 }, be = { center: 2, end: 6, justify: 4, left: 1, right: 3, start: 5 }, Ne = { 2: "center", 6: "end", 4: "justify", 1: "left", 3: "right", 5: "start" }, Re = { normal: 0, segmented: 2, token: 1 }, ke = { 0: "normal", 2: "segmented", 1: "token" }, Fe = !1, qe = 0;
  function Be(o) {
    qe = o.timeStamp;
  }
  function ct(o, i, a) {
    return i.__lexicalLineBreak === o || o[`__lexicalKey_${a._key}`] !== void 0;
  }
  function Dt(o) {
    return o.getEditorState().read(() => {
      let i = Vt();
      return i !== null ? i.clone() : null;
    });
  }
  function zt(o, i, a) {
    Fe = !0;
    let g = 100 < performance.now() - qe;
    try {
      vr(o, () => {
        let C = Vt() || Dt(o);
        var x = /* @__PURE__ */ new Map(), A = o.getRootElement(), Q = o._editorState, ge = o._blockCursorElement;
        let Ae = !1, Ye = "";
        for (var Xe = 0; Xe < i.length; Xe++) {
          var Ke = i[Xe], Pe = Ke.type, gt = Ke.target, wt = Wt(gt, Q);
          if (!(wt === null && gt !== A || Cn(wt))) {
            if (Pe === "characterData") {
              if (Ke = g && Nt(wt)) e: {
                Ke = C, Pe = gt;
                var $t = wt;
                if (At(Ke)) {
                  var Kt = Ke.anchor.getNode();
                  if (Kt.is($t) && Ke.format !== Kt.getFormat()) {
                    Ke = !1;
                    break e;
                  }
                }
                Ke = Pe.nodeType === 3 && $t.isAttached();
              }
              Ke && ($t = qr(o._window), Pe = Ke = null, $t !== null && $t.anchorNode === gt && (Ke = $t.anchorOffset, Pe = $t.focusOffset), gt = gt.nodeValue, gt !== null && St(wt, gt, Ke, Pe, !1));
            } else if (Pe === "childList") {
              for (Ae = !0, Pe = Ke.addedNodes, $t = 0; $t < Pe.length; $t++) {
                Kt = Pe[$t];
                var Yn = Pt(Kt), Rr = Kt.parentNode;
                Rr == null || Kt === ge || Yn !== null || Kt.nodeName === "BR" && ct(Kt, Rr, o) || (U && (Yn = Kt.innerText || Kt.nodeValue) && (Ye += Yn), Rr.removeChild(Kt));
              }
              if (Ke = Ke.removedNodes, Pe = Ke.length, 0 < Pe) {
                for ($t = 0, Kt = 0; Kt < Pe; Kt++) Rr = Ke[Kt], (Rr.nodeName === "BR" && ct(Rr, gt, o) || ge === Rr) && (gt.appendChild(Rr), $t++);
                Pe !== $t && (gt === A && (wt = Q._nodeMap.get("root")), x.set(gt, wt));
              }
            }
          }
        }
        if (0 < x.size) for (let [
          ai,
          ci
        ] of x) if (Je(ci)) for (x = ci.getChildrenKeys(), A = ai.firstChild, Q = 0; Q < x.length; Q++) ge = o.getElementByKey(x[Q]), ge !== null && (A == null ? (ai.appendChild(ge), A = ge) : A !== ge && ai.replaceChild(ge, A), A = A.nextSibling);
        else Nt(ci) && ci.markDirty();
        if (x = a.takeRecords(), 0 < x.length) {
          for (A = 0; A < x.length; A++) for (ge = x[A], Q = ge.addedNodes, ge = ge.target, Xe = 0; Xe < Q.length; Xe++) wt = Q[Xe], gt = wt.parentNode, gt == null || wt.nodeName !== "BR" || ct(wt, ge, o) || gt.removeChild(wt);
          a.takeRecords();
        }
        C !== null && (Ae && (C.dirty = !0, nn(C)), U && sn(o) && C.insertRawText(Ye));
      });
    } finally {
      Fe = !1;
    }
  }
  function en(o) {
    let i = o._observer;
    if (i !== null) {
      let a = i.takeRecords();
      zt(o, a, i);
    }
  }
  function Oe(o) {
    qe === 0 && un(o).addEventListener("textInput", Be, !0), o._observer = new MutationObserver((i, a) => {
      zt(o, i, a);
    });
  }
  function ie(o, i) {
    let a = o.__mode, g = o.__format;
    o = o.__style;
    let C = i.__mode, x = i.__format;
    return i = i.__style, (a === null || a === C) && (g === null || g === x) && (o === null || o === i);
  }
  function le(o, i) {
    let a = o.mergeWithSibling(i), g = dn()._normalizedNodes;
    return g.add(o.__key), g.add(i.__key), a;
  }
  function ve(o) {
    if (o.__text === "" && o.isSimpleText() && !o.isUnmergeable()) o.remove();
    else {
      for (var i; (i = o.getPreviousSibling()) !== null && Nt(i) && i.isSimpleText() && !i.isUnmergeable(); ) if (i.__text === "") i.remove();
      else {
        ie(i, o) && (o = le(i, o));
        break;
      }
      for (var a; (a = o.getNextSibling()) !== null && Nt(a) && a.isSimpleText() && !a.isUnmergeable(); ) if (a.__text === "") a.remove();
      else {
        ie(o, a) && le(o, a);
        break;
      }
    }
  }
  function Le(o) {
    return Me(o.anchor), Me(o.focus), o;
  }
  function Me(o) {
    for (; o.type === "element"; ) {
      var i = o.getNode(), a = o.offset;
      if (a === i.getChildrenSize() ? (i = i.getChildAtIndex(a - 1), a = !0) : (i = i.getChildAtIndex(a), a = !1), Nt(i)) {
        o.set(i.__key, a ? i.getTextContentSize() : 0, "text");
        break;
      } else if (!Je(i)) break;
      o.set(i.__key, a ? i.getChildrenSize() : 0, "element");
    }
  }
  let je = 1, rt = typeof queueMicrotask == "function" ? queueMicrotask : (o) => {
    Promise.resolve().then(o);
  };
  function it(o) {
    let i = document.activeElement;
    if (i === null) return !1;
    let a = i.nodeName;
    return Cn(Wt(o)) && (a === "INPUT" || a === "TEXTAREA" || i.contentEditable === "true" && i.__lexicalEditor == null);
  }
  function st(o, i, a) {
    let g = o.getRootElement();
    try {
      return g !== null && g.contains(i) && g.contains(a) && i !== null && !it(i) && vt(i) === o;
    } catch {
      return !1;
    }
  }
  function vt(o) {
    for (; o != null; ) {
      let i = o.__lexicalEditor;
      if (i != null) return i;
      o = Cr(o);
    }
    return null;
  }
  function Ge(o) {
    return o.isToken() || o.isSegmented();
  }
  function ze(o) {
    for (; o != null; ) {
      if (o.nodeType === 3) return o;
      o = o.firstChild;
    }
    return null;
  }
  function tt(o, i, a) {
    let g = ne[i];
    return a !== null && (o & g) === (a & g) || (o ^= g, i === "subscript" ? o &= -65 : i === "superscript" && (o &= -33)), o;
  }
  function _t(o, i) {
    if (i != null) o.__key = i;
    else {
      Jn(), 99 < zi && Y(14), i = dn();
      var a = Wr(), g = "" + je++;
      a._nodeMap.set(g, o), Je(o) ? i._dirtyElements.set(g, !0) : i._dirtyLeaves.add(g), i._cloneNotNeeded.add(g), i._dirtyType = 1, o.__key = g;
    }
  }
  function yt(o) {
    var i = o.getParent();
    if (i !== null) {
      let C = o.getWritable();
      i = i.getWritable();
      var a = o.getPreviousSibling();
      if (o = o.getNextSibling(), a === null) if (o !== null) {
        var g = o.getWritable();
        i.__first = o.__key, g.__prev = null;
      } else i.__first = null;
      else {
        if (g = a.getWritable(), o !== null) {
          let x = o.getWritable();
          x.__prev = g.__key, g.__next = x.__key;
        } else g.__next = null;
        C.__prev = null;
      }
      o === null ? a !== null ? (o = a.getWritable(), i.__last = a.__key, o.__next = null) : i.__last = null : (o = o.getWritable(), a !== null ? (a = a.getWritable(), a.__next = o.__key, o.__prev = a.__key) : o.__prev = null, C.__next = null), i.__size--, C.__parent = null;
    }
  }
  function Ct(o) {
    99 < zi && Y(14);
    var i = o.getLatest(), a = i.__parent, g = Wr();
    let C = dn(), x = g._nodeMap;
    if (g = C._dirtyElements, a !== null) e: for (; a !== null; ) {
      if (g.has(a)) break e;
      let A = x.get(a);
      if (A === void 0) break;
      g.set(a, !1), a = A.__parent;
    }
    i = i.__key, C._dirtyType = 1, Je(o) ? g.set(i, !0) : C._dirtyLeaves.add(i);
  }
  function ht(o) {
    Jn();
    var i = dn();
    let a = i._compositionKey;
    o !== a && (i._compositionKey = o, a !== null && (i = pt(a), i !== null && i.getWritable()), o !== null && (o = pt(o), o !== null && o.getWritable()));
  }
  function Tt() {
    return gs() ? null : dn()._compositionKey;
  }
  function pt(o, i) {
    return o = (i || Wr())._nodeMap.get(o), o === void 0 ? null : o;
  }
  function Pt(o, i) {
    let a = dn();
    return o = o[`__lexicalKey_${a._key}`], o !== void 0 ? pt(o, i) : null;
  }
  function Wt(o, i) {
    for (; o != null; ) {
      let a = Pt(o, i);
      if (a !== null) return a;
      o = Cr(o);
    }
    return null;
  }
  function tn(o) {
    let i = Object.assign({}, o._decorators);
    return o._pendingDecorators = i;
  }
  function Lt(o) {
    return o.read(() => Rt().getTextContent());
  }
  function jt(o, i) {
    vr(o, () => {
      var a = Wr();
      if (!a.isEmpty()) if (i === "root") Rt().markDirty();
      else {
        a = a._nodeMap;
        for (let [, g] of a) g.markDirty();
      }
    }, o._pendingEditorState === null ? { tag: "history-merge" } : void 0);
  }
  function Rt() {
    return Wr()._nodeMap.get("root");
  }
  function nn(o) {
    Jn();
    let i = Wr();
    o !== null && (o.dirty = !0, o.setCachedNodes(null)), i._selection = o;
  }
  function Ar(o) {
    var i = dn(), a;
    e: {
      for (a = o; a != null; ) {
        let g = a[`__lexicalKey_${i._key}`];
        if (g !== void 0) {
          a = g;
          break e;
        }
        a = Cr(a);
      }
      a = null;
    }
    return a === null ? (i = i.getRootElement(), o === i ? pt("root") : null) : pt(a);
  }
  function Ni(o) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(o);
  }
  function pe(o) {
    let i = [];
    for (; o !== null; ) i.push(o), o = o._parentEditor;
    return i;
  }
  function Ze() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
  }
  function ot(o, i, a) {
    if (i = qr(i._window), i !== null) {
      var g = i.anchorNode, { anchorOffset: C, focusOffset: x } = i;
      if (g !== null && (i = g.nodeType === 3 ? g.nodeValue : null, g = Wt(g), i !== null && Nt(g))) {
        if (i === se && a) {
          let A = a.length;
          i = a, x = C = A;
        }
        i !== null && St(g, i, C, x, o);
      }
    }
  }
  function St(o, i, a, g, C) {
    let x = o;
    if (x.isAttached() && (C || !x.isDirty())) {
      let Ae = x.isComposing(), Ye = i;
      if ((Ae || C) && i[i.length - 1] === se && (Ye = i.slice(0, -1)), i = x.getTextContent(), C || Ye !== i) if (Ye === "") if (ht(null), fe || _e || F) x.remove();
      else {
        let Xe = dn();
        setTimeout(() => {
          Xe.update(() => {
            x.isAttached() && x.remove();
          });
        }, 20);
      }
      else {
        C = x.getParent(), i = xr();
        var A = x.getTextContentSize(), Q = Tt(), ge = x.getKey();
        x.isToken() || Q !== null && ge === Q && !Ae || At(i) && (C !== null && !C.canInsertTextBefore() && i.anchor.offset === 0 || i.anchor.key === o.__key && i.anchor.offset === 0 && !x.canInsertTextBefore() && !Ae || i.focus.key === o.__key && i.focus.offset === A && !x.canInsertTextAfter() && !Ae) ? x.markDirty() : (o = Vt(), At(o) && a !== null && g !== null && (o.setTextNodeRange(x, a, x, g), x.isSegmented() && (a = x.getTextContent(), a = Un(a), x.replace(a), x = a)), x.setTextContent(Ye));
      }
    }
  }
  function Ut(o, i) {
    if (i.isSegmented()) return !0;
    if (!o.isCollapsed()) return !1;
    o = o.anchor.offset;
    let a = i.getParentOrThrow(), g = i.isToken();
    return o === 0 ? ((o = !i.canInsertTextBefore() || !a.canInsertTextBefore() || g) || (i = i.getPreviousSibling(), o = (Nt(i) || Je(i) && i.isInline()) && !i.canInsertTextAfter()), o) : o === i.getTextContentSize() ? !i.canInsertTextAfter() || !a.canInsertTextAfter() || g : !1;
  }
  function Ft(o, i) {
    o.__lexicalClassNameCache === void 0 && (o.__lexicalClassNameCache = {});
    let a = o.__lexicalClassNameCache, g = a[i];
    return g !== void 0 ? g : (o = o[i], typeof o == "string" ? (o = o.split(" "), a[i] = o) : o);
  }
  function kt(o, i, a, g, C) {
    a.size !== 0 && (a = g.__type, g = g.__key, i = i.get(a), i === void 0 && Y(33, a), a = i.klass, i = o.get(a), i === void 0 && (i = /* @__PURE__ */ new Map(), o.set(a, i)), o = i.get(g), a = o === "destroyed" && C === "created", (o === void 0 || a) && i.set(g, a ? "updated" : C));
  }
  function It(o, i, a) {
    let g = o.getParent(), C = a;
    return g !== null && (i && a === 0 ? (C = o.getIndexWithinParent(), o = g) : i || a !== o.getChildrenSize() || (C = o.getIndexWithinParent() + 1, o = g)), o.getChildAtIndex(i ? C - 1 : C);
  }
  function Bt(o, i) {
    var a = o.offset;
    return o.type === "element" ? (o = o.getNode(), It(o, i, a)) : (o = o.getNode(), i && a === 0 || !i && a === o.getTextContentSize() ? (a = i ? o.getPreviousSibling() : o.getNextSibling(), a === null ? It(o.getParentOrThrow(), i, o.getIndexWithinParent() + (i ? 0 : 1)) : a) : null);
  }
  function sn(o) {
    return o = (o = un(o).event) && o.inputType, o === "insertFromPaste" || o === "insertFromPasteAsQuotation";
  }
  function ln(o) {
    return !rr(o) && !o.isLastChild() && !o.isInline();
  }
  function bn(o, i) {
    return o = o._keyToDOMMap.get(i), o === void 0 && Y(75, i), o;
  }
  function Cr(o) {
    return o = o.assignedSlot || o.parentElement, o !== null && o.nodeType === 11 ? o.host : o;
  }
  function Zn(o, i) {
    for (o = o.getParent(); o !== null; ) {
      if (o.is(i)) return !0;
      o = o.getParent();
    }
    return !1;
  }
  function un(o) {
    return o = o._window, o === null && Y(78), o;
  }
  function or(o) {
    for (o = o.getParentOrThrow(); o !== null && !lr(o); ) o = o.getParentOrThrow();
    return o;
  }
  function lr(o) {
    return rr(o) || Je(o) && o.isShadowRoot();
  }
  function Ri(o) {
    return o = o.constructor.clone(o), _t(o, null), o;
  }
  function Er(o) {
    var i = dn();
    let a = o.constructor.getType();
    return i = i._nodes.get(a), i === void 0 && Y(97), i = i.replace, i !== null ? (i = i(o), i instanceof o.constructor || Y(98), i) : o;
  }
  function Os(o, i) {
    o = o.getParent(), !rr(o) || Je(i) || Cn(i) || Y(99);
  }
  function go(o) {
    return (Cn(o) || Je(o) && !o.canBeEmpty()) && !o.isInline();
  }
  function ul(o, i, a) {
    a.style.removeProperty("caret-color"), i._blockCursorElement = null, i = o.parentElement, i !== null && i.removeChild(o);
  }
  function qr(o) {
    return W ? (o || window).getSelection() : null;
  }
  function ya(o, i) {
    for (; o !== Rt() && o != null; ) {
      if (i(o)) return o;
      o = o.getParent();
    }
    return null;
  }
  function po(o) {
    return o.nodeType === 1;
  }
  function ss(o) {
    if (Cn(o) && !o.isInline()) return !0;
    if (!Je(o) || lr(o)) return !1;
    var i = o.getFirstChild();
    return i = i === null || Pi(i) || Nt(i) || i.isInline(), !o.isInline() && o.canBeEmpty() !== !1 && i;
  }
  function Ds(o, i) {
    for (; o !== null && o.getParent() !== null && !i(o); ) o = o.getParentOrThrow();
    return i(o) ? o : null;
  }
  function os(o, i, a, g, C, x) {
    for (o = o.getFirstChild(); o !== null; ) {
      let A = o.__key;
      o.__parent === i && (Je(o) && os(o, A, a, g, C, x), a.has(A) || x.delete(A), C.push(A)), o = o.getNextSibling();
    }
  }
  function dl(o, i, a, g) {
    o = o._nodeMap, i = i._nodeMap;
    let C = [];
    for (let [x] of g) {
      let A = i.get(x);
      A === void 0 || A.isAttached() || (Je(A) && os(A, x, o, i, C, g), o.has(x) || g.delete(x), C.push(x));
    }
    for (let x of C) i.delete(x);
    for (let x of a) g = i.get(x), g === void 0 || g.isAttached() || (o.has(x) || a.delete(x), i.delete(x));
  }
  let Ln = "", zn = "", si = "", Fr, Bn, As, fl = !1, hl = !1, Zr, bi = null, gl, vn, ar, Nn, mo, oi;
  function Ms(o, i) {
    let a = ar.get(o);
    if (i !== null) {
      let g = bs(o);
      g.parentNode === i && i.removeChild(g);
    }
    Nn.has(o) || Bn._keyToDOMMap.delete(o), Je(a) && (o = Rs(a, ar), _o(o, 0, o.length - 1, null)), a !== void 0 && kt(oi, As, Zr, a, "destroyed");
  }
  function _o(o, i, a, g) {
    for (; i <= a; ++i) {
      let C = o[i];
      C !== void 0 && Ms(C, g);
    }
  }
  function Li(o, i) {
    o.setProperty("text-align", i);
  }
  function nr(o, i) {
    var a = Fr.theme.indent;
    if (typeof a == "string") {
      let g = o.classList.contains(a);
      0 < i && !g ? o.classList.add(a) : 1 > i && g && o.classList.remove(a);
    }
    a = getComputedStyle(o).getPropertyValue("--lexical-indent-base-value") || "40px", o.style.setProperty("padding-inline-start", i === 0 ? "" : `calc(${i} * ${a})`);
  }
  function pl(o, i) {
    o = o.style, i === 0 ? Li(o, "") : i === 1 ? Li(o, "left") : i === 2 ? Li(o, "center") : i === 3 ? Li(o, "right") : i === 4 ? Li(o, "justify") : i === 5 ? Li(o, "start") : i === 6 && Li(o, "end");
  }
  function Tr(o, i, a) {
    let g = Nn.get(o);
    g === void 0 && Y(60);
    let C = g.createDOM(Fr, Bn);
    var x = Bn._keyToDOMMap;
    if (C["__lexicalKey_" + Bn._key] = o, x.set(o, C), Nt(g) ? C.setAttribute("data-lexical-text", "true") : Cn(g) && C.setAttribute("data-lexical-decorator", "true"), Je(g)) {
      if (o = g.__indent, x = g.__size, o !== 0 && nr(C, o), x !== 0) {
        --x, o = Rs(g, Nn);
        var A = zn;
        zn = "", ml(o, g, 0, x, C, null), Na(g, C), zn = A;
      }
      o = g.__format, o !== 0 && pl(C, o), g.isInline() || _l(null, g, C), ln(g) && (Ln += `

`, si += `

`);
    } else x = g.getTextContent(), Cn(g) ? (A = g.decorate(Bn, Fr), A !== null && yl(o, A), C.contentEditable = "false") : Nt(g) && (g.isDirectionless() || (zn += x)), Ln += x, si += x;
    return i !== null && (a != null ? i.insertBefore(C, a) : (a = i.__lexicalLineBreak, a != null ? i.insertBefore(C, a) : i.appendChild(C))), kt(oi, As, Zr, g, "created"), C;
  }
  function ml(o, i, a, g, C, x) {
    let A = Ln;
    for (Ln = ""; a <= g; ++a) Tr(o[a], C, x);
    ln(i) && (Ln += `

`), C.__lexicalTextContent = Ln, Ln = A + Ln;
  }
  function Ii(o, i) {
    return o = i.get(o), Pi(o) || Cn(o) && o.isInline();
  }
  function _l(o, i, a) {
    o = o !== null && (o.__size === 0 || Ii(o.__last, ar)), i = i.__size === 0 || Ii(i.__last, Nn), o ? i || (i = a.__lexicalLineBreak, i != null && a.removeChild(i), a.__lexicalLineBreak = null) : i && (i = document.createElement("br"), a.__lexicalLineBreak = i, a.appendChild(i));
  }
  function Na(o, i) {
    var a = i.__lexicalDir;
    if (i.__lexicalDirTextContent !== zn || a !== bi) {
      let x = zn === "";
      if (x) var g = bi;
      else g = zn, g = De.test(g) ? "rtl" : ee.test(g) ? "ltr" : null;
      if (g !== a) {
        let A = i.classList, Q = Fr.theme;
        var C = a !== null ? Q[a] : void 0;
        let ge = g !== null ? Q[g] : void 0;
        C !== void 0 && (typeof C == "string" && (C = C.split(" "), C = Q[a] = C), A.remove(...C)), g === null || x && g === "ltr" ? i.removeAttribute("dir") : (ge !== void 0 && (typeof ge == "string" && (a = ge.split(" "), ge = Q[g] = a), ge !== void 0 && A.add(...ge)), i.dir = g), hl || (o.getWritable().__dir = g);
      }
      bi = g, i.__lexicalDirTextContent = zn, i.__lexicalDir = g;
    }
  }
  function Rs(o, i) {
    let a = [];
    for (o = o.__first; o !== null; ) {
      let g = i.get(o);
      g === void 0 && Y(101), a.push(o), o = g.__next;
    }
    return a;
  }
  function ki(o, i) {
    var a = ar.get(o), g = Nn.get(o);
    a !== void 0 && g !== void 0 || Y(61);
    var C = fl || vn.has(o) || gl.has(o);
    let x = bn(Bn, o);
    if (a === g && !C) return Je(a) ? (g = x.__lexicalTextContent, g !== void 0 && (Ln += g, si += g), g = x.__lexicalDirTextContent, g !== void 0 && (zn += g)) : (g = a.getTextContent(), Nt(a) && !a.isDirectionless() && (zn += g), si += g, Ln += g), x;
    if (a !== g && C && kt(oi, As, Zr, g, "updated"), g.updateDOM(a, x, Fr)) return g = Tr(o, null, null), i === null && Y(62), i.replaceChild(g, x), Ms(o, null), g;
    if (Je(a) && Je(g)) {
      if (o = g.__indent, o !== a.__indent && nr(x, o), o = g.__format, o !== a.__format && pl(x, o), C) {
        o = zn, zn = "", C = Ln;
        var A = a.__size, Q = g.__size;
        if (Ln = "", A === 1 && Q === 1) {
          var ge = a.__first;
          if (i = g.__first, ge === i) ki(ge, x);
          else {
            var Ae = bs(ge);
            i = Tr(i, null, null), x.replaceChild(i, Ae), Ms(ge, null);
          }
        } else {
          i = Rs(a, ar);
          var Ye = Rs(g, Nn);
          if (A === 0) Q !== 0 && ml(Ye, g, 0, Q - 1, x, null);
          else if (Q === 0) A !== 0 && (ge = x.__lexicalLineBreak == null, _o(i, 0, A - 1, ge ? null : x), ge && (x.textContent = ""));
          else {
            var Xe = i;
            i = Ye, Ye = A - 1, A = Q - 1;
            let Pe = x.firstChild, gt = 0;
            for (Q = 0; gt <= Ye && Q <= A; ) {
              var Ke = Xe[gt];
              let wt = i[Q];
              if (Ke === wt) Pe = yo(ki(wt, x)), gt++, Q++;
              else {
                ge === void 0 && (ge = new Set(Xe)), Ae === void 0 && (Ae = new Set(i));
                let $t = Ae.has(Ke), Kt = ge.has(wt);
                $t ? (Kt ? (Ke = bn(Bn, wt), Ke === Pe ? Pe = yo(ki(wt, x)) : (Pe != null ? x.insertBefore(Ke, Pe) : x.appendChild(Ke), ki(wt, x)), gt++) : Tr(wt, x, Pe), Q++) : (Pe = yo(bs(Ke)), Ms(Ke, x), gt++);
              }
            }
            ge = gt > Ye, Ae = Q > A, ge && !Ae ? (ge = i[A + 1], ge = ge === void 0 ? null : Bn.getElementByKey(ge), ml(i, g, Q, A, x, ge)) : Ae && !ge && _o(Xe, gt, Ye, x);
          }
        }
        ln(g) && (Ln += `

`), x.__lexicalTextContent = Ln, Ln = C + Ln, Na(g, x), zn = o, rr(g) || g.isInline() || _l(a, g, x);
      }
      ln(g) && (Ln += `

`, si += `

`);
    } else a = g.getTextContent(), Cn(g) ? (C = g.decorate(Bn, Fr), C !== null && yl(o, C)) : Nt(g) && !g.isDirectionless() && (zn += a), Ln += a, si += a;
    return !hl && rr(g) && g.__cachedText !== si && (g.getWritable().__cachedText = si), x;
  }
  function yl(o, i) {
    let a = Bn._pendingDecorators, g = Bn._decorators;
    if (a === null) {
      if (g[o] === i) return;
      a = tn(Bn);
    }
    a[o] = i;
  }
  function yo(o) {
    return o = o.nextSibling, o !== null && o === Bn._blockCursorElement && (o = o.nextSibling), o;
  }
  function bs(o) {
    let i = mo.get(o);
    return i === void 0 && Y(75, o), i;
  }
  let Br = Object.freeze({}), Nl = [["keydown", Pc], ["pointerdown", bc], ["compositionstart", Da], ["compositionend", kc], ["input", Oa], ["click", Rc], ["cut", Br], ["copy", Br], ["dragstart", Br], ["dragover", Br], ["dragend", Br], ["paste", Br], ["focus", Br], ["blur", Br], ["drop", Br]];
  X && Nl.push(["beforeinput", (o, i) => Ic(o, i)]);
  let Ls = 0, Ca = 0, Ea = 0, ls = null, Is = 0, Cl = !1, El = !1, ks = !1, Ps = !1, Ta = [0, "", 0, "root", 0];
  function xa(o, i, a, g, C) {
    let x = o.anchor, A = o.focus, Q = x.getNode();
    var ge = dn();
    let Ae = qr(ge._window), Ye = Ae !== null ? Ae.anchorNode : null, Xe = x.key;
    ge = ge.getElementByKey(Xe);
    let Ke = a.length;
    return Xe !== A.key || !Nt(Q) || (!C && (!X || Ea < g + 50) || Q.isDirty() && 2 > Ke || Ni(a)) && x.offset !== A.offset && !Q.isComposing() || Ge(Q) || Q.isDirty() && 1 < Ke || (C || !X) && ge !== null && !Q.isComposing() && Ye !== ze(ge) || Ae !== null && i !== null && (!i.collapsed || i.startContainer !== Ae.anchorNode || i.startOffset !== Ae.anchorOffset) || Q.getFormat() !== o.format || Q.getStyle() !== o.style || Ut(o, Q);
  }
  function va(o, i) {
    return o !== null && o.nodeValue !== null && o.nodeType === 3 && i !== 0 && i !== o.nodeValue.length;
  }
  function Sa(o, i, a) {
    let { anchorNode: g, anchorOffset: C, focusNode: x, focusOffset: A } = o;
    Cl && (Cl = !1, va(g, C) && va(x, A)) || vr(i, () => {
      if (!a) nn(null);
      else if (st(i, g, x)) {
        var Q = Vt();
        if (At(Q)) {
          var ge = Q.anchor, Ae = ge.getNode();
          if (Q.isCollapsed()) {
            o.type === "Range" && o.anchorNode === o.focusNode && (Q.dirty = !0);
            var Ye = un(i).event;
            Ye = Ye ? Ye.timeStamp : performance.now();
            let [Ke, Pe, gt, wt, $t] = Ta;
            var Xe = Rt();
            if (Xe = i.isComposing() === !1 && Xe.getTextContent() === "", Ye < $t + 200 && ge.offset === gt && ge.key === wt) Q.format = Ke, Q.style = Pe;
            else if (ge.type === "text") {
              if (!Nt(Ae)) throw Error("Point.getNode() must return TextNode when type is text");
              Q.format = Ae.getFormat(), Q.style = Ae.getStyle();
            } else ge.type !== "element" || Xe || (Q.format = 0, Q.style = "");
          } else {
            ge = 255, Ae = !1, Ye = Q.getNodes(), Xe = Ye.length;
            for (let Ke = 0; Ke < Xe; Ke++) {
              let Pe = Ye[Ke];
              if (Nt(Pe) && (Ae = !0, ge &= Pe.getFormat(), ge === 0)) break;
            }
            Q.format = Ae ? ge : 0;
          }
        }
        at(i, e, void 0);
      }
    });
  }
  function Rc(o, i) {
    vr(i, () => {
      let a = Vt();
      var g = qr(i._window);
      let C = xr();
      if (g) if (At(a)) {
        let A = a.anchor;
        var x = A.getNode();
        A.type === "element" && A.offset === 0 && a.isCollapsed() && !rr(x) && Rt().getChildrenSize() === 1 && x.getTopLevelElementOrThrow().isEmpty() && C !== null && a.is(C) ? (g.removeAllRanges(), a.dirty = !0) : o.detail !== 3 || a.isCollapsed() || (g = a.focus.getNode(), x !== g && (Je(x) ? x.select(0) : x.getParentOrThrow().select(0)));
      } else o.pointerType === "touch" && (x = g.anchorNode, x !== null && (x = x.nodeType, x === 1 || x === 3)) && (g = Gn(C, g, i, o), nn(g));
      at(i, t, o);
    });
  }
  function bc(o, i) {
    let a = o.target;
    o = o.pointerType, a instanceof Node && o !== "touch" && vr(i, () => {
      Cn(Wt(a)) || (El = !0);
    });
  }
  function wa(o) {
    return o.getTargetRanges ? (o = o.getTargetRanges(), o.length === 0 ? null : o[0]) : null;
  }
  function Lc(o, i) {
    return o !== i || Je(o) || Je(i) || !o.isToken() || !i.isToken();
  }
  function Ic(o, i) {
    let a = o.inputType, g = wa(o);
    a === "deleteCompositionText" || U && sn(i) || a !== "insertCompositionText" && vr(i, () => {
      let C = Vt();
      if (a === "deleteContentBackward") {
        if (C === null) {
          var x = xr();
          if (!At(x)) return;
          nn(x.clone());
        }
        if (At(C)) {
          if (B && ht(C.anchor.key), Ca === 229 && o.timeStamp < Ls + 30 && i.isComposing() && C.anchor.key === C.focus.key) {
            if (ht(null), Ls = 0, setTimeout(() => {
              vr(i, () => {
                ht(null);
              });
            }, 30), At(C)) {
              if (x = C.anchor.getNode(), x.markDirty(), C.format = x.getFormat(), !Nt(x)) throw Error("Anchor node must be a TextNode");
              C.style = x.getStyle();
            }
            1 >= C.anchor.getNode().getTextContent().length && (o.preventDefault(), at(i, n, !0));
          } else ht(null), o.preventDefault(), at(i, n, !0);
          return;
        }
      }
      if (At(C)) {
        x = o.data, ls !== null && ot(!1, i, ls), C.dirty && ls === null || !C.isCollapsed() || rr(C.anchor.getNode()) || g === null || C.applyDOMRange(g), ls = null;
        var A = C.focus, Q = C.anchor.getNode();
        if (A = A.getNode(), a === "insertText" || a === "insertTranspose") x === `
` ? (o.preventDefault(), at(i, r, !1)) : x === `

` ? (o.preventDefault(), at(i, l, void 0)) : x == null && o.dataTransfer ? (x = o.dataTransfer.getData("text/plain"), o.preventDefault(), C.insertRawText(x)) : x != null && xa(C, g, x, o.timeStamp, !0) ? (o.preventDefault(), at(i, d, x)) : ls = x, Ea = o.timeStamp;
        else switch (o.preventDefault(), a) {
          case "insertFromYank":
          case "insertFromDrop":
          case "insertReplacementText":
            at(i, d, o);
            break;
          case "insertFromComposition":
            ht(null), at(i, d, o);
            break;
          case "insertLineBreak":
            ht(null), at(i, r, !1);
            break;
          case "insertParagraph":
            ht(null), ks && !_e ? (ks = !1, at(i, r, !1)) : at(i, l, void 0);
            break;
          case "insertFromPaste":
          case "insertFromPasteAsQuotation":
            at(i, f, o);
            break;
          case "deleteByComposition":
            Lc(
              Q,
              A
            ) && at(i, p, o);
            break;
          case "deleteByDrag":
          case "deleteByCut":
            at(i, p, o);
            break;
          case "deleteContent":
            at(i, n, !1);
            break;
          case "deleteWordBackward":
            at(i, _, !0);
            break;
          case "deleteWordForward":
            at(i, _, !1);
            break;
          case "deleteHardLineBackward":
          case "deleteSoftLineBackward":
            at(i, E, !0);
            break;
          case "deleteContentForward":
          case "deleteHardLineForward":
          case "deleteSoftLineForward":
            at(i, E, !1);
            break;
          case "formatStrikeThrough":
            at(i, T, "strikethrough");
            break;
          case "formatBold":
            at(i, T, "bold");
            break;
          case "formatItalic":
            at(
              i,
              T,
              "italic"
            );
            break;
          case "formatUnderline":
            at(i, T, "underline");
            break;
          case "historyUndo":
            at(i, S, void 0);
            break;
          case "historyRedo":
            at(i, w, void 0);
        }
      }
    });
  }
  function Oa(o, i) {
    o.stopPropagation(), vr(i, () => {
      var a = Vt(), g = o.data, C = wa(o);
      if (g != null && At(a) && xa(a, C, g, o.timeStamp, !1)) {
        Ps && (Tl(i, g), Ps = !1);
        var x = a.anchor, A = x.getNode();
        if (C = qr(i._window), C === null) return;
        let Q = x.offset;
        (x = X && !a.isCollapsed() && Nt(A) && C.anchorNode !== null) && (A = A.getTextContent().slice(0, Q) + g + A.getTextContent().slice(Q + a.focus.offset), C = C.anchorNode, x = A === (C.nodeType === 3 ? C.nodeValue : null)), x || at(i, d, g), g = g.length, U && 1 < g && o.inputType === "insertCompositionText" && !i.isComposing() && (a.anchor.offset -= g), fe || _e || F || !i.isComposing() || (Ls = 0, ht(null));
      } else ot(!1, i, g !== null ? g : void 0), Ps && (Tl(i, g || void 0), Ps = !1);
      Jn(), a = dn(), en(a);
    }), ls = null;
  }
  function Da(o, i) {
    vr(i, () => {
      let a = Vt();
      if (At(a) && !i.isComposing()) {
        let g = a.anchor, C = a.anchor.getNode();
        ht(g.key), (o.timeStamp < Ls + 30 || g.type === "element" || !a.isCollapsed() || C.getFormat() !== a.format || Nt(C) && C.getStyle() !== a.style) && at(i, d, ye);
      }
    });
  }
  function Tl(o, i) {
    var a = o._compositionKey;
    if (ht(null), a !== null && i != null) {
      if (i === "") {
        i = pt(a), o = ze(o.getElementByKey(a)), o !== null && o.nodeValue !== null && Nt(i) && St(i, o.nodeValue, null, null, !0);
        return;
      }
      if (i[i.length - 1] === `
` && (a = Vt(), At(a))) {
        i = a.focus, a.anchor.set(i.key, i.offset, i.type), at(o, H, null);
        return;
      }
    }
    ot(!0, o, i);
  }
  function kc(o, i) {
    U ? Ps = !0 : vr(i, () => {
      Tl(i, o.data);
    });
  }
  function Pc(o, i) {
    if (Ls = o.timeStamp, Ca = o.keyCode, !i.isComposing()) {
      var { keyCode: a, shiftKey: g, ctrlKey: C, metaKey: x, altKey: A } = o;
      if (!at(i, O, o)) {
        if (a !== 39 || C || x || A) if (a !== 39 || A || g || !C && !x) if (a !== 37 || C || x || A) if (a !== 37 || A || g || !C && !x) if (a !== 38 || C || x) if (a !== 40 || C || x) if (a === 13 && g) ks = !0, at(i, H, o);
        else if (a === 32) at(i, j, o);
        else if (R && C && a === 79) o.preventDefault(), ks = !0, at(i, r, !0);
        else if (a !== 13 || g) {
          var Q = R ? A || x ? !1 : a === 8 || a === 72 && C : C || A || x ? !1 : a === 8;
          Q ? a === 8 ? at(i, re, o) : (o.preventDefault(), at(i, n, !0)) : a === 27 ? at(
            i,
            te,
            o
          ) : (Q = R ? g || A || x ? !1 : a === 46 || a === 68 && C : C || A || x ? !1 : a === 46, Q ? a === 46 ? at(i, ce, o) : (o.preventDefault(), at(i, n, !1)) : a === 8 && (R ? A : C) ? (o.preventDefault(), at(i, _, !0)) : a === 46 && (R ? A : C) ? (o.preventDefault(), at(i, _, !1)) : R && x && a === 8 ? (o.preventDefault(), at(i, E, !0)) : R && x && a === 46 ? (o.preventDefault(), at(i, E, !1)) : a === 66 && !A && (R ? x : C) ? (o.preventDefault(), at(i, T, "bold")) : a === 85 && !A && (R ? x : C) ? (o.preventDefault(), at(i, T, "underline")) : a === 73 && !A && (R ? x : C) ? (o.preventDefault(), at(i, T, "italic")) : a !== 9 || A || C || x ? a === 90 && !g && (R ? x : C) ? (o.preventDefault(), at(i, S, void 0)) : (Q = R ? a === 90 && x && g : a === 89 && C || a === 90 && C && g, Q ? (o.preventDefault(), at(i, w, void 0)) : cr(i._editorState._selection) ? (Q = g ? !1 : a === 67 ? R ? x : C : !1, Q ? (o.preventDefault(), at(i, Ee, o)) : (Q = g ? !1 : a === 88 ? R ? x : C : !1, Q ? (o.preventDefault(), at(i, de, o)) : a === 65 && (R ? x : C) && (o.preventDefault(), at(i, K, o)))) : !U && a === 65 && (R ? x : C) && (o.preventDefault(), at(i, K, o))) : at(i, V, o));
        } else ks = !1, at(i, H, o);
        else at(i, P, o);
        else at(i, k, o);
        else at(i, G, o);
        else at(i, I, o);
        else at(i, v, o);
        else at(i, m, o);
        (C || g || A || x) && at(i, oe, o);
      }
    }
  }
  function Aa(o) {
    let i = o.__lexicalEventHandles;
    return i === void 0 && (i = [], o.__lexicalEventHandles = i), i;
  }
  let as = /* @__PURE__ */ new Map();
  function Ma(o) {
    var i = o.target;
    let a = qr(i == null ? null : i.nodeType === 9 ? i.defaultView : i.ownerDocument.defaultView);
    if (a !== null) {
      var g = vt(a.anchorNode);
      if (g !== null) {
        El && (El = !1, vr(g, () => {
          var Q = xr(), ge = a.anchorNode;
          ge !== null && (ge = ge.nodeType, ge === 1 || ge === 3) && (Q = Gn(Q, a, g, o), nn(Q));
        })), i = pe(g), i = i[i.length - 1];
        var C = i._key, x = as.get(C), A = x || i;
        A !== g && Sa(a, A, !1), Sa(a, g, !0), g !== i ? as.set(C, g) : x && as.delete(C);
      }
    }
  }
  function $c(o, i) {
    Is === 0 && o.ownerDocument.addEventListener("selectionchange", Ma), Is++, o.__lexicalEditor = i;
    let a = Aa(o);
    for (let g = 0; g < Nl.length; g++) {
      let [C, x] = Nl[g], A = typeof x == "function" ? (Q) => {
        Q._lexicalHandled !== !0 && (Q._lexicalHandled = !0, i.isEditable() && x(Q, i));
      } : (Q) => {
        if (Q._lexicalHandled !== !0 && (Q._lexicalHandled = !0, i.isEditable())) switch (C) {
          case "cut":
            return at(i, de, Q);
          case "copy":
            return at(i, Ee, Q);
          case "paste":
            return at(i, f, Q);
          case "dragstart":
            return at(i, q, Q);
          case "dragover":
            return at(i, Te, Q);
          case "dragend":
            return at(
              i,
              Se,
              Q
            );
          case "focus":
            return at(i, D, Q);
          case "blur":
            return at(i, Z, Q);
          case "drop":
            return at(i, z, Q);
        }
      };
      o.addEventListener(C, A), a.push(() => {
        o.removeEventListener(C, A);
      });
    }
  }
  function xl(o, i, a) {
    Jn();
    var g = o.__key;
    let C = o.getParent();
    if (C !== null) {
      var x = Vt();
      if (At(x) && Je(o)) {
        var { anchor: A, focus: Q } = x, ge = A.getNode(), Ae = Q.getNode();
        Zn(ge, o) && A.set(o.__key, 0, "element"), Zn(Ae, o) && Q.set(o.__key, 0, "element");
      }
      if (ge = x, Ae = !1, At(ge) && i) {
        x = ge.anchor;
        let Ye = ge.focus;
        x.key === g && (fs(x, o, C, o.getPreviousSibling(), o.getNextSibling()), Ae = !0), Ye.key === g && (fs(Ye, o, C, o.getPreviousSibling(), o.getNextSibling()), Ae = !0);
      } else cr(ge) && i && o.isSelected() && o.selectPrevious();
      At(ge) && i && !Ae ? (g = o.getIndexWithinParent(), yt(o), Hn(ge, C, g, -1)) : yt(o), a || lr(C) || C.canBeEmpty() || !C.isEmpty() || xl(C, i), i && rr(C) && C.isEmpty() && C.selectEnd();
    }
  }
  class $s {
    static getType() {
      Y(64, this.name);
    }
    static clone() {
      Y(65, this.name);
    }
    constructor(i) {
      this.__type = this.constructor.getType(), this.__next = this.__prev = this.__parent = null, _t(this, i);
    }
    getType() {
      return this.__type;
    }
    isInline() {
      throw Error(`LexicalNode: Node ${this.constructor.name} does not implement .isInline().`);
    }
    isAttached() {
      for (var i = this.__key; i !== null; ) {
        if (i === "root") return !0;
        if (i = pt(i), i === null) break;
        i = i.__parent;
      }
      return !1;
    }
    isSelected(i) {
      if (i = i || Vt(), i == null) return !1;
      let a = i.getNodes().some((g) => g.__key === this.__key);
      return Nt(this) ? a : At(i) && i.anchor.type === "element" && i.focus.type === "element" && i.anchor.key === i.focus.key && i.anchor.offset === i.focus.offset ? !1 : a;
    }
    getKey() {
      return this.__key;
    }
    getIndexWithinParent() {
      var i = this.getParent();
      if (i === null) return -1;
      i = i.getFirstChild();
      let a = 0;
      for (; i !== null; ) {
        if (this.is(i)) return a;
        a++, i = i.getNextSibling();
      }
      return -1;
    }
    getParent() {
      let i = this.getLatest().__parent;
      return i === null ? null : pt(i);
    }
    getParentOrThrow() {
      let i = this.getParent();
      return i === null && Y(66, this.__key), i;
    }
    getTopLevelElement() {
      let i = this;
      for (; i !== null; ) {
        let a = i.getParent();
        if (lr(a)) {
          if (!Je(i)) throw Error("Children of root nodes must be elements");
          return i;
        }
        i = a;
      }
      return null;
    }
    getTopLevelElementOrThrow() {
      let i = this.getTopLevelElement();
      return i === null && Y(67, this.__key), i;
    }
    getParents() {
      let i = [], a = this.getParent();
      for (; a !== null; ) i.push(a), a = a.getParent();
      return i;
    }
    getParentKeys() {
      let i = [], a = this.getParent();
      for (; a !== null; ) i.push(a.__key), a = a.getParent();
      return i;
    }
    getPreviousSibling() {
      let i = this.getLatest().__prev;
      return i === null ? null : pt(i);
    }
    getPreviousSiblings() {
      let i = [];
      var a = this.getParent();
      if (a === null) return i;
      for (a = a.getFirstChild(); a !== null && !a.is(this); ) i.push(a), a = a.getNextSibling();
      return i;
    }
    getNextSibling() {
      let i = this.getLatest().__next;
      return i === null ? null : pt(i);
    }
    getNextSiblings() {
      let i = [], a = this.getNextSibling();
      for (; a !== null; ) i.push(a), a = a.getNextSibling();
      return i;
    }
    getCommonAncestor(i) {
      let a = this.getParents();
      var g = i.getParents();
      Je(this) && a.unshift(this), Je(i) && g.unshift(i), i = a.length;
      var C = g.length;
      if (i === 0 || C === 0 || a[i - 1] !== g[C - 1]) return null;
      for (g = new Set(g), C = 0; C < i; C++) {
        let x = a[C];
        if (g.has(x)) return x;
      }
      return null;
    }
    is(i) {
      return i == null ? !1 : this.__key === i.__key;
    }
    isBefore(i) {
      if (this === i) return !1;
      if (i.isParentOf(this)) return !0;
      if (this.isParentOf(i)) return !1;
      var a = this.getCommonAncestor(i);
      let g = this;
      for (; ; ) {
        var C = g.getParentOrThrow();
        if (C === a) {
          C = g.getIndexWithinParent();
          break;
        }
        g = C;
      }
      for (g = i; ; ) {
        if (i = g.getParentOrThrow(), i === a) {
          a = g.getIndexWithinParent();
          break;
        }
        g = i;
      }
      return C < a;
    }
    isParentOf(i) {
      let a = this.__key;
      if (a === i.__key) return !1;
      for (; i !== null; ) {
        if (i.__key === a) return !0;
        i = i.getParent();
      }
      return !1;
    }
    getNodesBetween(i) {
      let a = this.isBefore(i), g = [], C = /* @__PURE__ */ new Set();
      for (var x = this; ; ) {
        var A = x.__key;
        if (C.has(A) || (C.add(A), g.push(x)), x === i) break;
        if (A = Je(x) ? a ? x.getFirstChild() : x.getLastChild() : null, A !== null) x = A;
        else if (A = a ? x.getNextSibling() : x.getPreviousSibling(), A !== null) x = A;
        else {
          if (x = x.getParentOrThrow(), C.has(x.__key) || g.push(x), x === i) break;
          A = x;
          do
            A === null && Y(68), x = a ? A.getNextSibling() : A.getPreviousSibling(), A = A.getParent(), A !== null && (x !== null || C.has(A.__key) || g.push(A));
          while (x === null);
        }
      }
      return a || g.reverse(), g;
    }
    isDirty() {
      let i = dn()._dirtyLeaves;
      return i !== null && i.has(this.__key);
    }
    getLatest() {
      let i = pt(this.__key);
      return i === null && Y(113), i;
    }
    getWritable() {
      Jn();
      var i = Wr(), a = dn();
      i = i._nodeMap;
      let g = this.__key, C = this.getLatest(), x = C.__parent;
      a = a._cloneNotNeeded;
      var A = Vt();
      return Hs(A) && A.setCachedNodes(null), a.has(g) ? (Ct(C), C) : (A = C.constructor.clone(C), A.__parent = x, A.__next = C.__next, A.__prev = C.__prev, Je(C) && Je(A) ? (A.__first = C.__first, A.__last = C.__last, A.__size = C.__size, A.__indent = C.__indent, A.__format = C.__format, A.__dir = C.__dir) : Nt(C) && Nt(A) && (A.__format = C.__format, A.__style = C.__style, A.__mode = C.__mode, A.__detail = C.__detail), a.add(g), A.__key = g, Ct(A), i.set(g, A), A);
    }
    getTextContent() {
      return "";
    }
    getTextContentSize() {
      return this.getTextContent().length;
    }
    createDOM() {
      Y(70);
    }
    updateDOM() {
      Y(71);
    }
    exportDOM(i) {
      return { element: this.createDOM(i._config, i) };
    }
    exportJSON() {
      Y(72);
    }
    static importJSON() {
      Y(18, this.name);
    }
    static transform() {
      return null;
    }
    remove(i) {
      xl(this, !0, i);
    }
    replace(i, a) {
      Jn();
      var g = Vt();
      g !== null && (g = g.clone()), Os(this, i);
      let C = this.getLatest(), x = this.__key, A = i.__key, Q = i.getWritable();
      i = this.getParentOrThrow().getWritable();
      let ge = i.__size;
      yt(Q);
      let Ae = C.getPreviousSibling(), Ye = C.getNextSibling(), Xe = C.__prev, Ke = C.__next, Pe = C.__parent;
      if (xl(C, !1, !0), Ae === null ? i.__first = A : Ae.getWritable().__next = A, Q.__prev = Xe, Ye === null ? i.__last = A : Ye.getWritable().__prev = A, Q.__next = Ke, Q.__parent = Pe, i.__size = ge, a) {
        if (!Je(this) || !Je(Q)) throw Error("includeChildren should only be true for ElementNodes");
        this.getChildren().forEach((gt) => {
          Q.append(gt);
        });
      }
      return At(g) && (nn(g), a = g.anchor, g = g.focus, a.key === x && li(a, Q), g.key === x && li(g, Q)), Tt() === x && ht(A), Q;
    }
    insertAfter(i, a = !0) {
      Jn(), Os(this, i);
      var g = this.getWritable();
      let C = i.getWritable();
      var x = C.getParent();
      let A = Vt();
      var Q = !1, ge = !1;
      if (x !== null) {
        var Ae = i.getIndexWithinParent();
        yt(C), At(A) && (ge = x.__key, Q = A.anchor, x = A.focus, Q = Q.type === "element" && Q.key === ge && Q.offset === Ae + 1, ge = x.type === "element" && x.key === ge && x.offset === Ae + 1);
      }
      x = this.getNextSibling(), Ae = this.getParentOrThrow().getWritable();
      let Ye = C.__key, Xe = g.__next;
      return x === null ? Ae.__last = Ye : x.getWritable().__prev = Ye, Ae.__size++, g.__next = Ye, C.__next = Xe, C.__prev = g.__key, C.__parent = g.__parent, a && At(A) && (a = this.getIndexWithinParent(), Hn(A, Ae, a + 1), g = Ae.__key, Q && A.anchor.set(g, a + 2, "element"), ge && A.focus.set(g, a + 2, "element")), i;
    }
    insertBefore(i, a = !0) {
      Jn(), Os(this, i);
      var g = this.getWritable();
      let C = i.getWritable(), x = C.__key;
      yt(C);
      let A = this.getPreviousSibling(), Q = this.getParentOrThrow().getWritable(), ge = g.__prev, Ae = this.getIndexWithinParent();
      return A === null ? Q.__first = x : A.getWritable().__next = x, Q.__size++, g.__prev = x, C.__prev = ge, C.__next = g.__key, C.__parent = g.__parent, g = Vt(), a && At(g) && (a = this.getParentOrThrow(), Hn(g, a, Ae)), i;
    }
    isParentRequired() {
      return !1;
    }
    createParentElementNode() {
      return zr();
    }
    selectStart() {
      return this.selectPrevious();
    }
    selectEnd() {
      return this.selectNext(0, 0);
    }
    selectPrevious(i, a) {
      Jn();
      let g = this.getPreviousSibling(), C = this.getParentOrThrow();
      return g === null ? C.select(0, 0) : Je(g) ? g.select() : Nt(g) ? g.select(i, a) : (i = g.getIndexWithinParent() + 1, C.select(i, i));
    }
    selectNext(i, a) {
      Jn();
      let g = this.getNextSibling(), C = this.getParentOrThrow();
      return g === null ? C.select() : Je(g) ? g.select(0, 0) : Nt(g) ? g.select(i, a) : (i = g.getIndexWithinParent(), C.select(i, i));
    }
    markDirty() {
      this.getWritable();
    }
  }
  function Fc(o, i, a) {
    a = a || i.getParentOrThrow().getLastChild();
    let g = i;
    for (i = [i]; g !== a; ) {
      if (!g.getNextSibling()) throw Error("insertRangeAfter: lastToInsert must be a later sibling of firstToInsert");
      g = g.getNextSibling(), i.push(g);
    }
    for (let C of i) o = o.insertAfter(C);
  }
  class Jr extends $s {
    static getType() {
      return "linebreak";
    }
    static clone(i) {
      return new Jr(i.__key);
    }
    constructor(i) {
      super(i);
    }
    getTextContent() {
      return `
`;
    }
    createDOM() {
      return document.createElement("br");
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { br: (i) => {
        let a = i.parentElement, g, C;
        return a !== null && ((g = a.firstChild) === i || g.nextSibling === i && g.nodeType === 3 && (g.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) && ((C = a.lastChild) === i || C.previousSibling === i && C.nodeType === 3 && (C.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) ? null : { conversion: Ra, priority: 0 };
      } };
    }
    static importJSON() {
      return Xr();
    }
    exportJSON() {
      return { type: "linebreak", version: 1 };
    }
  }
  function Ra() {
    return { node: Xr() };
  }
  function Xr() {
    return Er(new Jr());
  }
  function Pi(o) {
    return o instanceof Jr;
  }
  function $i(o, i) {
    return i & 16 ? "code" : i & 128 ? "mark" : i & 32 ? "sub" : i & 64 ? "sup" : null;
  }
  function No(o, i) {
    return i & 1 ? "strong" : i & 2 ? "em" : "span";
  }
  function vl(o, i, a, g, C) {
    o = g.classList, g = Ft(C, "base"), g !== void 0 && o.add(...g), g = Ft(C, "underlineStrikethrough");
    let x = !1, A = i & 8 && i & 4;
    var Q = a & 8 && a & 4;
    g !== void 0 && (Q ? (x = !0, A || o.add(...g)) : A && o.remove(...g));
    for (let ge in ne) Q = ne[ge], g = Ft(C, ge), g !== void 0 && (a & Q ? !x || ge !== "underline" && ge !== "strikethrough" ? (!(i & Q) || A && ge === "underline" || ge === "strikethrough") && o.add(...g) : i & Q && o.remove(...g) : i & Q && o.remove(...g));
  }
  function Fi(o, i, a) {
    let g = i.firstChild;
    if (a = a.isComposing(), o += a ? se : "", g == null) i.textContent = o;
    else if (i = g.nodeValue, i !== o) if (a || U) {
      a = i.length;
      let C = o.length, x = 0, A = 0;
      for (; x < a && x < C && i[x] === o[x]; ) x++;
      for (; A + x < a && A + x < C && i[a - A - 1] === o[C - A - 1]; ) A++;
      o = [x, a - x - A, o.slice(x, C - A)];
      let [Q, ge, Ae] = o;
      ge !== 0 && g.deleteData(Q, ge), g.insertData(Q, Ae);
    } else g.nodeValue = o;
  }
  function cs(o, i) {
    return i = document.createElement(i), i.appendChild(o), i;
  }
  class Bi extends $s {
    static getType() {
      return "text";
    }
    static clone(i) {
      return new Bi(i.__text, i.__key);
    }
    constructor(i, a) {
      super(a), this.__text = i, this.__format = 0, this.__style = "", this.__detail = this.__mode = 0;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getDetail() {
      return this.getLatest().__detail;
    }
    getMode() {
      let i = this.getLatest();
      return ke[i.__mode];
    }
    getStyle() {
      return this.getLatest().__style;
    }
    isToken() {
      return this.getLatest().__mode === 1;
    }
    isComposing() {
      return this.__key === Tt();
    }
    isSegmented() {
      return this.getLatest().__mode === 2;
    }
    isDirectionless() {
      return (this.getLatest().__detail & 1) !== 0;
    }
    isUnmergeable() {
      return (this.getLatest().__detail & 2) !== 0;
    }
    hasFormat(i) {
      return i = ne[i], (this.getFormat() & i) !== 0;
    }
    isSimpleText() {
      return this.__type === "text" && this.__mode === 0;
    }
    getTextContent() {
      return this.getLatest().__text;
    }
    getFormatFlags(i, a) {
      let g = this.getLatest().__format;
      return tt(g, i, a);
    }
    createDOM(i) {
      var a = this.__format, g = $i(this, a);
      let C = No(this, a), x = document.createElement(g === null ? C : g), A = x;
      return this.hasFormat("code") && x.setAttribute("spellcheck", "false"), g !== null && (A = document.createElement(C), x.appendChild(A)), g = A, Fi(this.__text, g, this), i = i.theme.text, i !== void 0 && vl(C, 0, a, g, i), a = this.__style, a !== "" && (x.style.cssText = a), x;
    }
    updateDOM(i, a, g) {
      let C = this.__text;
      var x = i.__format, A = this.__format, Q = $i(this, x);
      let ge = $i(this, A);
      var Ae = No(this, x);
      let Ye = No(this, A);
      return (Q === null ? Ae : Q) !== (ge === null ? Ye : ge) ? !0 : Q === ge && Ae !== Ye ? (x = a.firstChild, x == null && Y(48), i = Q = document.createElement(Ye), Fi(C, i, this), g = g.theme.text, g !== void 0 && vl(Ye, 0, A, i, g), a.replaceChild(Q, x), !1) : (Ae = a, ge !== null && Q !== null && (Ae = a.firstChild, Ae == null && Y(49)), Fi(C, Ae, this), g = g.theme.text, g !== void 0 && x !== A && vl(Ye, x, A, Ae, g), A = this.__style, i.__style !== A && (a.style.cssText = A), !1);
    }
    static importDOM() {
      return {
        "#text": () => ({ conversion: ut, priority: 0 }),
        b: () => ({ conversion: Sl, priority: 0 }),
        code: () => ({ conversion: Ci, priority: 0 }),
        em: () => ({ conversion: Ci, priority: 0 }),
        i: () => ({ conversion: Ci, priority: 0 }),
        s: () => ({ conversion: Ci, priority: 0 }),
        span: () => ({ conversion: ba, priority: 0 }),
        strong: () => ({ conversion: Ci, priority: 0 }),
        sub: () => ({ conversion: Ci, priority: 0 }),
        sup: () => ({ conversion: Ci, priority: 0 }),
        u: () => ({ conversion: Ci, priority: 0 })
      };
    }
    static importJSON(i) {
      let a = Un(i.text);
      return a.setFormat(i.format), a.setDetail(i.detail), a.setMode(i.mode), a.setStyle(i.style), a;
    }
    exportDOM(i) {
      return { element: i } = super.exportDOM(i), i !== null && po(i) || Y(132), i.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (i = cs(i, "b")), this.hasFormat("italic") && (i = cs(i, "i")), this.hasFormat("strikethrough") && (i = cs(i, "s")), this.hasFormat("underline") && (i = cs(i, "u")), { element: i };
    }
    exportJSON() {
      return {
        detail: this.getDetail(),
        format: this.getFormat(),
        mode: this.getMode(),
        style: this.getStyle(),
        text: this.getTextContent(),
        type: "text",
        version: 1
      };
    }
    selectionTransform() {
    }
    setFormat(i) {
      let a = this.getWritable();
      return a.__format = typeof i == "string" ? ne[i] : i, a;
    }
    setDetail(i) {
      let a = this.getWritable();
      return a.__detail = typeof i == "string" ? ue[i] : i, a;
    }
    setStyle(i) {
      let a = this.getWritable();
      return a.__style = i, a;
    }
    toggleFormat(i) {
      let a = this.getFormat();
      return i = tt(a, i, null), this.setFormat(i);
    }
    toggleDirectionless() {
      let i = this.getWritable();
      return i.__detail ^= 1, i;
    }
    toggleUnmergeable() {
      let i = this.getWritable();
      return i.__detail ^= 2, i;
    }
    setMode(i) {
      if (i = Re[i], this.__mode === i) return this;
      let a = this.getWritable();
      return a.__mode = i, a;
    }
    setTextContent(i) {
      if (this.__text === i) return this;
      let a = this.getWritable();
      return a.__text = i, a;
    }
    select(i, a) {
      Jn();
      let g = Vt();
      var C = this.getTextContent();
      let x = this.__key;
      if (typeof C == "string" ? (C = C.length, i === void 0 && (i = C), a === void 0 && (a = C)) : a = i = 0, At(g)) C = Tt(), C !== g.anchor.key && C !== g.focus.key || ht(x), g.setTextNodeRange(this, i, this, a);
      else return Dl(x, i, x, a, "text", "text");
      return g;
    }
    selectStart() {
      return this.select(0, 0);
    }
    selectEnd() {
      let i = this.getTextContentSize();
      return this.select(i, i);
    }
    spliceText(i, a, g, C) {
      let x = this.getWritable(), A = x.__text, Q = g.length, ge = i;
      0 > ge && (ge = Q + ge, 0 > ge && (ge = 0));
      let Ae = Vt();
      return C && At(Ae) && (i += Q, Ae.setTextNodeRange(x, i, x, i)), a = A.slice(0, ge) + g + A.slice(ge + a), x.__text = a, x;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    splitText(...i) {
      Jn();
      var a = this.getLatest(), g = a.getTextContent(), C = a.__key, x = Tt(), A = new Set(i);
      i = [];
      for (var Q = g.length, ge = "", Ae = 0; Ae < Q; Ae++) ge !== "" && A.has(Ae) && (i.push(ge), ge = ""), ge += g[Ae];
      if (ge !== "" && i.push(ge), A = i.length, A === 0) return [];
      if (i[0] === g) return [a];
      var Ye = i[0];
      g = a.getParentOrThrow(), Ae = a.getFormat();
      let Xe = a.getStyle(), Ke = a.__detail;
      Q = !1, a.isSegmented() ? (ge = Un(Ye), ge.__format = Ae, ge.__style = Xe, ge.__detail = Ke, Q = !0) : (ge = a.getWritable(), ge.__text = Ye), a = Vt(), ge = [ge], Ye = Ye.length;
      for (let wt = 1; wt < A; wt++) {
        var Pe = i[wt], gt = Pe.length;
        Pe = Un(Pe).getWritable(), Pe.__format = Ae, Pe.__style = Xe, Pe.__detail = Ke;
        let $t = Pe.__key;
        if (gt = Ye + gt, At(a)) {
          let Kt = a.anchor, Yn = a.focus;
          Kt.key === C && Kt.type === "text" && Kt.offset > Ye && Kt.offset <= gt && (Kt.key = $t, Kt.offset -= Ye, a.dirty = !0), Yn.key === C && Yn.type === "text" && Yn.offset > Ye && Yn.offset <= gt && (Yn.key = $t, Yn.offset -= Ye, a.dirty = !0);
        }
        x === C && ht($t), Ye = gt, ge.push(Pe);
      }
      return C = this.getPreviousSibling(), x = this.getNextSibling(), C !== null && Ct(C), x !== null && Ct(x), C = g.getWritable(), x = this.getIndexWithinParent(), Q ? (C.splice(x, 0, ge), this.remove()) : C.splice(x, 1, ge), At(a) && Hn(a, g, x, A - 1), ge;
    }
    mergeWithSibling(i) {
      var a = i === this.getPreviousSibling();
      a || i === this.getNextSibling() || Y(50);
      var g = this.__key;
      let C = i.__key, x = this.__text, A = x.length;
      Tt() === C && ht(g);
      let Q = Vt();
      if (At(Q)) {
        let ge = Q.anchor, Ae = Q.focus;
        ge !== null && ge.key === C && (Ks(ge, a, g, i, A), Q.dirty = !0), Ae !== null && Ae.key === C && (Ks(Ae, a, g, i, A), Q.dirty = !0);
      }
      return g = i.__text, this.setTextContent(a ? g + x : x + g), a = this.getWritable(), i.remove(), a;
    }
    isTextEntity() {
      return !1;
    }
  }
  function ba(o) {
    let i = o.style.fontWeight === "700", a = o.style.textDecoration === "line-through", g = o.style.fontStyle === "italic", C = o.style.textDecoration === "underline", x = o.style.verticalAlign;
    return { forChild: (A) => (Nt(A) && (i && A.toggleFormat("bold"), a && A.toggleFormat("strikethrough"), g && A.toggleFormat("italic"), C && A.toggleFormat("underline"), x === "sub" && A.toggleFormat("subscript"), x === "super" && A.toggleFormat("superscript")), A), node: null };
  }
  function Sl(o) {
    let i = o.style.fontWeight === "normal";
    return { forChild: (a) => (Nt(a) && !i && a.toggleFormat("bold"), a), node: null };
  }
  let wl = /* @__PURE__ */ new WeakMap();
  function ut(o) {
    o.parentElement === null && Y(129);
    for (var i = o.textContent || "", a, g = o.parentNode, C = [o]; g !== null && (a = wl.get(g)) === void 0 && !(g.nodeName === "PRE" || g.nodeType === 1 && g.style !== void 0 && g.style.whiteSpace !== void 0 && g.style.whiteSpace.startsWith("pre")); ) C.push(g), g = g.parentNode;
    for (a = a === void 0 ? g : a, g = 0; g < C.length; g++) wl.set(C[g], a);
    if (a !== null) {
      for (i = i.split(/(\r?\n|\t)/), o = [], C = i.length, a = 0; a < C; a++) g = i[a], g === `
` || g === `\r
` ? o.push(Xr()) : g === "	" ? o.push(Hi()) : g !== "" && o.push(Un(g));
      return { node: o };
    }
    if (i = i.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), i === "") return { node: null };
    if (i[0] === " ") {
      for (C = o, a = !0; C !== null && (C = Fs(C, !1)) !== null; ) if (g = C.textContent || "", 0 < g.length) {
        /[ \t\n]$/.test(g) && (i = i.slice(1)), a = !1;
        break;
      }
      a && (i = i.slice(1));
    }
    if (i[i.length - 1] === " ") {
      for (C = !0; o !== null && (o = Fs(o, !0)) !== null; ) if (0 < (o.textContent || "").replace(/^( |\t|\r?\n)+/, "").length) {
        C = !1;
        break;
      }
      C && (i = i.slice(0, i.length - 1));
    }
    return i === "" ? { node: null } : { node: Un(i) };
  }
  let Co = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/, "i");
  function Fs(o, i) {
    for (; ; ) {
      for (var a = void 0; (a = i ? o.nextSibling : o.previousSibling) === null; ) if (o = o.parentElement, o === null) return null;
      if (o = a, o.nodeType === 1 && (a = o.style.display, a === "" && o.nodeName.match(Co) === null || a !== "" && !a.startsWith("inline"))) return null;
      for (; (a = i ? o.firstChild : o.lastChild) !== null; ) o = a;
      if (o.nodeType === 3) return o;
      if (o.nodeName === "BR") return null;
    }
  }
  let Eo = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
  function Ci(o) {
    let i = Eo[o.nodeName.toLowerCase()];
    return i === void 0 ? { node: null } : { forChild: (a) => (Nt(a) && !a.hasFormat(i) && a.toggleFormat(i), a), node: null };
  }
  function Un(o = "") {
    return Er(new Bi(o));
  }
  function Nt(o) {
    return o instanceof Bi;
  }
  class us extends Bi {
    static getType() {
      return "tab";
    }
    static clone(i) {
      let a = new us(i.__key);
      return a.__text = i.__text, a.__format = i.__format, a.__style = i.__style, a;
    }
    constructor(i) {
      super("	", i), this.__detail = 2;
    }
    static importDOM() {
      return null;
    }
    static importJSON(i) {
      let a = Hi();
      return a.setFormat(i.format), a.setStyle(i.style), a;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "tab", version: 1 };
    }
    setTextContent() {
      Y(126);
    }
    setDetail() {
      Y(127);
    }
    setMode() {
      Y(128);
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
  }
  function Hi() {
    return Er(new us());
  }
  function La(o) {
    return o instanceof us;
  }
  class To {
    constructor(i, a, g) {
      this._selection = null, this.key = i, this.offset = a, this.type = g;
    }
    is(i) {
      return this.key === i.key && this.offset === i.offset && this.type === i.type;
    }
    isBefore(i) {
      let a = this.getNode(), g = i.getNode(), C = this.offset;
      if (i = i.offset, Je(a)) {
        var x = a.getDescendantByIndex(C);
        a = x ?? a;
      }
      return Je(g) && (x = g.getDescendantByIndex(i), g = x ?? g), a === g ? C < i : a.isBefore(g);
    }
    getNode() {
      let i = pt(this.key);
      return i === null && Y(20), i;
    }
    set(i, a, g) {
      let C = this._selection, x = this.key;
      this.key = i, this.offset = a, this.type = g, gs() || (Tt() === x && ht(i), C !== null && (C.setCachedNodes(null), C.dirty = !0));
    }
  }
  function Hr(o, i, a) {
    return new To(o, i, a);
  }
  function xo(o, i) {
    let a = i.__key, g = o.offset, C = "element";
    if (Nt(i)) C = "text", i = i.getTextContentSize(), g > i && (g = i);
    else if (!Je(i)) {
      var x = i.getNextSibling();
      Nt(x) ? (a = x.__key, g = 0, C = "text") : (x = i.getParent()) && (a = x.__key, g = i.getIndexWithinParent() + 1);
    }
    o.set(a, g, C);
  }
  function li(o, i) {
    if (Je(i)) {
      let a = i.getLastDescendant();
      Je(a) || Nt(a) ? xo(o, a) : xo(o, i);
    } else xo(o, i);
  }
  function Ol(o, i, a, g) {
    let C = o.getNode(), x = C.getChildAtIndex(o.offset), A = Un(), Q = rr(C) ? zr().append(A) : A;
    A.setFormat(a), A.setStyle(g), x === null ? C.append(Q) : x.insertBefore(Q), o.is(i) && i.set(A.__key, 0, "text"), o.set(A.__key, 0, "text");
  }
  function Mr(o, i, a, g) {
    o.key = i, o.offset = a, o.type = g;
  }
  class Bs {
    constructor(i, a) {
      this.anchor = i, this.focus = a, i._selection = this, a._selection = this, this._cachedNodes = null, this.dirty = !1;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(i) {
      this._cachedNodes = i;
    }
    is(i) {
      return Hs(i) ? this.anchor.is(i.anchor) && this.focus.is(i.focus) : !1;
    }
    isCollapsed() {
      return !1;
    }
    extract() {
      return this.getNodes();
    }
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    getCharacterOffsets() {
      return So(this);
    }
  }
  class vo {
    constructor(i) {
      this.dirty = !1, this._nodes = i, this._cachedNodes = null;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(i) {
      this._cachedNodes = i;
    }
    is(i) {
      if (!cr(i)) return !1;
      let a = this._nodes, g = i._nodes;
      return a.size === g.size && Array.from(a).every((C) => g.has(C));
    }
    add(i) {
      this.dirty = !0, this._nodes.add(i), this._cachedNodes = null;
    }
    delete(i) {
      this.dirty = !0, this._nodes.delete(i), this._cachedNodes = null;
    }
    clear() {
      this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(i) {
      return this._nodes.has(i);
    }
    clone() {
      return new vo(new Set(this._nodes));
    }
    extract() {
      return this.getNodes();
    }
    insertRawText() {
    }
    insertText() {
    }
    insertNodes(i) {
      let a = this.getNodes(), g = a.length;
      var C = a[g - 1];
      if (Nt(C)) C = C.select();
      else {
        let x = C.getIndexWithinParent() + 1;
        C = C.getParentOrThrow().select(x, x);
      }
      for (C.insertNodes(i), i = 0; i < g; i++) a[i].remove();
    }
    getNodes() {
      var i = this._cachedNodes;
      if (i !== null) return i;
      var a = this._nodes;
      i = [];
      for (let g of a) a = pt(g), a !== null && i.push(a);
      return gs() || (this._cachedNodes = i), i;
    }
    getTextContent() {
      let i = this.getNodes(), a = "";
      for (let g = 0; g < i.length; g++) a += i[g].getTextContent();
      return a;
    }
  }
  function At(o) {
    return o instanceof Ei;
  }
  function Hs(o) {
    return o instanceof Bs;
  }
  class Ei extends Bs {
    constructor(i, a, g, C) {
      super(i, a), this.format = g, this.style = C;
    }
    is(i) {
      return At(i) ? this.anchor.is(i.anchor) && this.focus.is(i.focus) && this.format === i.format && this.style === i.style : !1;
    }
    isCollapsed() {
      return this.anchor.is(this.focus);
    }
    getNodes() {
      var i = this._cachedNodes;
      if (i !== null) return i;
      i = this.anchor;
      var a = this.focus, g = i.isBefore(a), C = g ? i : a;
      g = g ? a : i, i = C.getNode(), a = g.getNode();
      let x = C.offset;
      return C = g.offset, Je(i) && (g = i.getDescendantByIndex(x), i = g ?? i), Je(a) && (g = a.getDescendantByIndex(C), g !== null && g !== i && a.getChildAtIndex(C) === g && (g = g.getPreviousSibling()), a = g ?? a), i = i.is(a) ? Je(i) && 0 < i.getChildrenSize() ? [] : [i] : i.getNodesBetween(a), gs() || (this._cachedNodes = i), i;
    }
    setTextNodeRange(i, a, g, C) {
      Mr(this.anchor, i.__key, a, "text"), Mr(this.focus, g.__key, C, "text"), this._cachedNodes = null, this.dirty = !0;
    }
    getTextContent() {
      let i = this.getNodes();
      if (i.length === 0) return "";
      let a = i[0], g = i[i.length - 1], C = this.anchor, x = this.focus, A = C.isBefore(x), [Q, ge] = So(this), Ae = "", Ye = !0;
      for (let Xe = 0; Xe < i.length; Xe++) {
        let Ke = i[Xe];
        if (Je(Ke) && !Ke.isInline()) Ye || (Ae += `
`), Ye = !Ke.isEmpty();
        else if (Ye = !1, Nt(Ke)) {
          let Pe = Ke.getTextContent();
          Ke === a ? Ke === g ? (C.type !== "element" || x.type !== "element" || x.offset === C.offset) && (Pe = Q < ge ? Pe.slice(Q, ge) : Pe.slice(ge, Q)) : Pe = A ? Pe.slice(Q) : Pe.slice(ge) : Ke === g && (Pe = A ? Pe.slice(0, ge) : Pe.slice(0, Q)), Ae += Pe;
        } else !Cn(Ke) && !Pi(Ke) || Ke === g && this.isCollapsed() || (Ae += Ke.getTextContent());
      }
      return Ae;
    }
    applyDOMRange(i) {
      let a = dn(), g = a.getEditorState()._selection;
      if (i = Pa(
        i.startContainer,
        i.startOffset,
        i.endContainer,
        i.endOffset,
        a,
        g
      ), i !== null) {
        var [C, x] = i;
        Mr(this.anchor, C.key, C.offset, C.type), Mr(this.focus, x.key, x.offset, x.type), this._cachedNodes = null;
      }
    }
    clone() {
      let i = this.anchor, a = this.focus;
      return new Ei(Hr(i.key, i.offset, i.type), Hr(a.key, a.offset, a.type), this.format, this.style);
    }
    toggleFormat(i) {
      this.format = tt(this.format, i, null), this.dirty = !0;
    }
    setStyle(i) {
      this.style = i, this.dirty = !0;
    }
    hasFormat(i) {
      return (this.format & ne[i]) !== 0;
    }
    insertRawText(i) {
      i = i.split(/(\r?\n|\t)/);
      let a = [], g = i.length;
      for (let C = 0; C < g; C++) {
        let x = i[C];
        x === `
` || x === `\r
` ? a.push(Xr()) : x === "	" ? a.push(Hi()) : a.push(Un(x));
      }
      this.insertNodes(a);
    }
    insertText(i) {
      var a = this.anchor, g = this.focus, C = this.isCollapsed() || a.isBefore(g), x = this.format, A = this.style;
      C && a.type === "element" ? Ol(a, g, x, A) : C || g.type !== "element" || Ol(g, a, x, A);
      var Q = this.getNodes(), ge = Q.length, Ae = C ? g : a;
      g = (C ? a : g).offset;
      var Ye = Ae.offset;
      a = Q[0], Nt(a) || Y(26), C = a.getTextContent().length;
      var Xe = a.getParentOrThrow(), Ke = Q[ge - 1];
      if (this.isCollapsed() && g === C && (a.isSegmented() || a.isToken() || !a.canInsertTextAfter() || !Xe.canInsertTextAfter() && a.getNextSibling() === null)) {
        var Pe = a.getNextSibling();
        if (Nt(Pe) && Pe.canInsertTextBefore() && !Ge(Pe) || (Pe = Un(), Pe.setFormat(x), Xe.canInsertTextAfter() ? a.insertAfter(Pe) : Xe.insertAfter(Pe)), Pe.select(0, 0), a = Pe, i !== "") {
          this.insertText(i);
          return;
        }
      } else if (this.isCollapsed() && g === 0 && (a.isSegmented() || a.isToken() || !a.canInsertTextBefore() || !Xe.canInsertTextBefore() && a.getPreviousSibling() === null)) {
        if (Pe = a.getPreviousSibling(), (!Nt(Pe) || Ge(Pe)) && (Pe = Un(), Pe.setFormat(x), Xe.canInsertTextBefore() ? a.insertBefore(Pe) : Xe.insertBefore(Pe)), Pe.select(), a = Pe, i !== "") {
          this.insertText(i);
          return;
        }
      } else if (a.isSegmented() && g !== C) Xe = Un(a.getTextContent()), Xe.setFormat(x), a.replace(Xe), a = Xe;
      else if (!(this.isCollapsed() || i === "" || (Pe = Ke.getParent(), Xe.canInsertTextBefore() && Xe.canInsertTextAfter() && (!Je(Pe) || Pe.canInsertTextBefore() && Pe.canInsertTextAfter())))) {
        this.insertText(""), wo(this.anchor, this.focus, null), this.insertText(i);
        return;
      }
      if (ge === 1) if (a.isToken()) i = Un(i), i.select(), a.replace(i);
      else {
        if (Q = a.getFormat(), ge = a.getStyle(), g === Ye && (Q !== x || ge !== A)) if (a.getTextContent() === "") a.setFormat(x), a.setStyle(A);
        else {
          Q = Un(i), Q.setFormat(x), Q.setStyle(A), Q.select(), g === 0 ? a.insertBefore(Q, !1) : ([ge] = a.splitText(g), ge.insertAfter(Q, !1)), Q.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= i.length);
          return;
        }
        else if (La(a)) {
          i = Un(i), i.setFormat(x), i.setStyle(A), i.select(), a.replace(i);
          return;
        }
        a = a.spliceText(g, Ye - g, i, !0), a.getTextContent() === "" ? a.remove() : this.anchor.type === "text" && (a.isComposing() ? this.anchor.offset -= i.length : (this.format = Q, this.style = ge));
      }
      else {
        if (x = /* @__PURE__ */ new Set([...a.getParentKeys(), ...Ke.getParentKeys()]), Pe = Je(a) ? a : a.getParentOrThrow(), A = Je(Ke) ? Ke : Ke.getParentOrThrow(), Xe = Ke, !Pe.is(A) && A.isInline())
          do
            Xe = A, A = A.getParentOrThrow();
          while (A.isInline());
        if (Ae.type === "text" && (Ye !== 0 || Ke.getTextContent() === "") || Ae.type === "element" && Ke.getIndexWithinParent() < Ye) if (Nt(Ke) && !Ke.isToken() && Ye !== Ke.getTextContentSize()) {
          if (Ke.isSegmented()) {
            var gt = Un(Ke.getTextContent());
            Ke.replace(gt), Ke = gt;
          }
          rr(Ae.getNode()) || Ae.type !== "text" || (Ke = Ke.spliceText(0, Ye, "")), x.add(Ke.__key);
        } else Ae = Ke.getParentOrThrow(), Ae.canBeEmpty() || Ae.getChildrenSize() !== 1 ? Ke.remove() : Ae.remove();
        else x.add(Ke.__key);
        for (Ae = A.getChildren(), Ye = new Set(Q), Ke = Pe.is(A), Pe = Pe.isInline() && a.getNextSibling() === null ? Pe : a, gt = Ae.length - 1; 0 <= gt; gt--) {
          let wt = Ae[gt];
          if (wt.is(a) || Je(wt) && wt.isParentOf(a)) break;
          wt.isAttached() && (!Ye.has(wt) || wt.is(Xe) ? Ke || Pe.insertAfter(wt, !1) : wt.remove());
        }
        if (!Ke) for (Ae = A, A = null; Ae !== null; )
          Ye = Ae.getChildren(), Ke = Ye.length, (Ke === 0 || Ye[Ke - 1].is(A)) && (x.delete(Ae.__key), A = Ae), Ae = Ae.getParent();
        for (a.isToken() ? g === C ? a.select() : (i = Un(i), i.select(), a.replace(i)) : (a = a.spliceText(g, C - g, i, !0), a.getTextContent() === "" ? a.remove() : a.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= i.length)), i = 1; i < ge; i++) a = Q[i], x.has(a.__key) || a.remove();
      }
    }
    removeText() {
      this.insertText("");
    }
    formatText(i) {
      if (this.isCollapsed()) this.toggleFormat(i), ht(null);
      else {
        var a = this.getNodes(), g = [];
        for (var C of a) Nt(C) && g.push(C);
        var x = g.length;
        if (x === 0) this.toggleFormat(i), ht(null);
        else {
          C = this.anchor;
          var A = this.focus, Q = this.isBackward();
          a = Q ? A : C, C = Q ? C : A;
          var ge = 0, Ae = g[0];
          if (A = a.type === "element" ? 0 : a.offset, a.type === "text" && A === Ae.getTextContentSize() && (ge = 1, Ae = g[1], A = 0), Ae != null) {
            Q = Ae.getFormatFlags(i, null);
            var Ye = x - 1, Xe = g[Ye];
            if (x = C.type === "text" ? C.offset : Xe.getTextContentSize(), Ae.is(Xe)) A !== x && (A === 0 && x === Ae.getTextContentSize() ? Ae.setFormat(Q) : (i = Ae.splitText(A, x), i = A === 0 ? i[0] : i[1], i.setFormat(Q), a.type === "text" && a.set(i.__key, 0, "text"), C.type === "text" && C.set(i.__key, x - A, "text")), this.format = Q);
            else {
              A !== 0 && ([, Ae] = Ae.splitText(A), A = 0), Ae.setFormat(Q);
              var Ke = Xe.getFormatFlags(i, Q);
              for (0 < x && (x !== Xe.getTextContentSize() && ([Xe] = Xe.splitText(x)), Xe.setFormat(Ke)), ge += 1; ge < Ye; ge++) {
                let Pe = g[ge];
                if (!Pe.isToken()) {
                  let gt = Pe.getFormatFlags(i, Ke);
                  Pe.setFormat(gt);
                }
              }
              a.type === "text" && a.set(Ae.__key, A, "text"), C.type === "text" && C.set(Xe.__key, x, "text"), this.format = Q | Ke;
            }
          }
        }
      }
    }
    insertNodes(i) {
      if (i.length !== 0) {
        if (this.anchor.key === "root") {
          this.insertParagraph();
          var a = Vt();
          if (!At(a)) throw Error("Expected RangeSelection after insertParagraph");
          return a.insertNodes(i);
        }
        var g = Ds(this.anchor.getNode(), ss);
        if (a = i[i.length - 1], "__language" in g && Je(g)) if ("__language" in i[0]) this.insertText(i[0].getTextContent());
        else {
          var C = Us(this);
          g.splice(C, 0, i), a.selectEnd();
        }
        else if (i.some((Q) => (Je(Q) || Cn(Q)) && !Q.isInline())) {
          a = Ki(i), i = a.getLastDescendant();
          var x = a.getChildren();
          a = Je(g) && g.isEmpty() ? null : this.insertParagraph(), C = x[x.length - 1];
          var A = x[0];
          if (((Q) => Je(Q) && ss(Q) && !Q.isEmpty() && Je(g) && (!g.isEmpty() || "__value" in g && "__checked" in g))(A)) {
            if (!Je(g)) throw Error("Expected 'firstBlock' to be an ElementNode");
            g.append(...A.getChildren()), A = x[1];
          }
          A && Fc(g, A), x = Ds(i, ss), a && Je(x) && ("__value" in a && "__checked" in a || ss(C)) && (x.append(...a.getChildren()), a.remove()), Je(g) && g.isEmpty() && g.remove(), i.selectEnd(), i = Je(g) ? g.getLastChild() : null, Pi(i) && x !== g && i.remove();
        } else {
          if (!Je(g)) throw Error("Expected 'firstBlock' to be an ElementNode");
          C = Us(this), g.splice(C, 0, i), a.selectEnd();
        }
      }
    }
    insertParagraph() {
      if (this.anchor.key === "root") {
        var i = zr();
        return Rt().splice(this.anchor.offset, 0, [i]), i.select(), i;
      }
      var a = Us(this);
      if (i = Ds(this.anchor.getNode(), ss), !Je(i)) throw Error("Expected ancestor to be an ElementNode");
      return a = (a = i.getChildAtIndex(a)) ? [a, ...a.getNextSiblings()] : [], (i = i.insertNewAfter(this, !1)) ? (i.append(...a), i.selectStart(), i) : null;
    }
    insertLineBreak(i) {
      var a = Xr();
      this.insertNodes([a]), i && (i = a.getParentOrThrow(), a = a.getIndexWithinParent(), i.select(a, a));
    }
    extract() {
      var i = this.getNodes(), a = i.length, g = a - 1, C = this.anchor;
      let x = this.focus;
      var A = i[0];
      let Q = i[g], [ge, Ae] = So(this);
      return a === 0 ? [] : a === 1 ? Nt(A) && !this.isCollapsed() ? (i = ge > Ae ? Ae : ge, g = A.splitText(i, ge > Ae ? ge : Ae), i = i === 0 ? g[0] : g[1], i != null ? [i] : []) : [A] : (a = C.isBefore(x), Nt(A) && (C = a ? ge : Ae, C === A.getTextContentSize() ? i.shift() : C !== 0 && ([, A] = A.splitText(C), i[0] = A)), Nt(Q) && (A = Q.getTextContent().length, a = a ? Ae : ge, a === 0 ? i.pop() : a !== A && ([Q] = Q.splitText(a), i[g] = Q)), i);
    }
    modify(i, a, g) {
      var C = this.focus, x = this.anchor, A = i === "move", Q = Bt(C, a);
      if (Cn(Q) && !Q.isIsolated()) A && Q.isKeyboardSelectable() ? (a = Al(), a.add(Q.__key), nn(a)) : (i = a ? Q.getPreviousSibling() : Q.getNextSibling(), Nt(i) ? (Q = i.__key, a = a ? i.getTextContent().length : 0, C.set(Q, a, "text"), A && x.set(Q, a, "text")) : (g = Q.getParentOrThrow(), Je(i) ? (g = i.__key, Q = a ? i.getChildrenSize() : 0) : (Q = Q.getIndexWithinParent(), g = g.__key, a || Q++), C.set(g, Q, "element"), A && x.set(g, Q, "element")));
      else if (x = dn(), C = qr(x._window)) {
        var ge = x._blockCursorElement, Ae = x._rootElement;
        if (Ae === null || ge === null || !Je(Q) || Q.isInline() || Q.canBeEmpty() || ul(ge, x, Ae), C.modify(i, a ? "backward" : "forward", g), 0 < C.rangeCount && (Q = C.getRangeAt(0), x = this.anchor.getNode(), x = rr(x) ? x : or(x), this.applyDOMRange(Q), this.dirty = !0, !A)) {
          for (A = this.getNodes(), i = [], g = !1, ge = 0; ge < A.length; ge++) Ae = A[ge], Zn(Ae, x) ? i.push(Ae) : g = !0;
          g && 0 < i.length && (a ? (a = i[0], Je(a) ? a.selectStart() : a.getParentOrThrow().selectStart()) : (a = i[i.length - 1], Je(a) ? a.selectEnd() : a.getParentOrThrow().selectEnd())), (C.anchorNode !== Q.startContainer || C.anchorOffset !== Q.startOffset) && (a = this.focus, A = this.anchor, C = A.key, Q = A.offset, x = A.type, Mr(A, a.key, a.offset, a.type), Mr(a, C, Q, x), this._cachedNodes = null);
        }
      }
    }
    deleteCharacter(i) {
      let a = this.isCollapsed();
      if (this.isCollapsed()) {
        var g = this.anchor, C = this.focus, x = g.getNode();
        if (!i && (g.type === "element" && Je(x) && g.offset === x.getChildrenSize() || g.type === "text" && g.offset === x.getTextContentSize())) {
          var A = x.getParent();
          if (A = x.getNextSibling() || (A === null ? null : A.getNextSibling()), Je(A) && A.isShadowRoot()) return;
        }
        if (A = Bt(C, i), Cn(A) && !A.isIsolated()) {
          A.isKeyboardSelectable() && Je(x) && x.getChildrenSize() === 0 ? (x.remove(), i = Al(), i.add(A.__key), nn(i)) : (A.remove(), dn().dispatchCommand(e, void 0));
          return;
        }
        if (!i && Je(A) && Je(x) && x.isEmpty()) {
          x.remove(), A.selectStart();
          return;
        }
        if (this.modify("extend", i, "character"), this.isCollapsed()) {
          if (i && g.offset === 0 && (g.type === "element" ? g.getNode() : g.getNode().getParentOrThrow()).collapseAtStart(this)) return;
        } else {
          if (A = C.type === "text" ? C.getNode() : null, x = g.type === "text" ? g.getNode() : null, A !== null && A.isSegmented()) {
            if (g = C.offset, C = A.getTextContentSize(), A.is(x) || i && g !== C || !i && g !== 0) {
              ka(A, i, g);
              return;
            }
          } else if (x !== null && x.isSegmented() && (g = g.offset, C = x.getTextContentSize(), x.is(A) || i && g !== 0 || !i && g !== C)) {
            ka(x, i, g);
            return;
          }
          if (x = this.anchor, A = this.focus, g = x.getNode(), C = A.getNode(), g === C && x.type === "text" && A.type === "text") {
            var Q = x.offset, ge = A.offset;
            let Ae = Q < ge;
            C = Ae ? Q : ge, ge = Ae ? ge : Q, Q = ge - 1, C !== Q && (g = g.getTextContent().slice(C, ge), Ni(g) || (i ? A.offset = Q : x.offset = Q));
          }
        }
      }
      this.removeText(), i && !a && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0 && (i = this.anchor.getNode(), i.isEmpty() && rr(i.getParent()) && i.getIndexWithinParent() === 0 && i.collapseAtStart(this));
    }
    deleteLine(i) {
      this.isCollapsed() && (this.anchor.type === "text" && this.modify("extend", i, "lineboundary"), (i ? this.focus : this.anchor).offset === 0 && this.modify(
        "extend",
        i,
        "character"
      )), this.removeText();
    }
    deleteWord(i) {
      this.isCollapsed() && this.modify("extend", i, "word"), this.removeText();
    }
  }
  function cr(o) {
    return o instanceof vo;
  }
  function Ia(o) {
    let i = o.offset;
    return o.type === "text" ? i : (o = o.getNode(), i === o.getChildrenSize() ? o.getTextContent().length : 0);
  }
  function So(o) {
    let i = o.anchor;
    return o = o.focus, i.type === "element" && o.type === "element" && i.key === o.key && i.offset === o.offset ? [0, 0] : [Ia(i), Ia(o)];
  }
  function ka(o, i, a) {
    let g = o.getTextContent().split(/(?=\s)/g), C = g.length, x = 0, A = 0;
    for (let Q = 0; Q < C; Q++) {
      let ge = g[Q], Ae = Q === C - 1;
      if (A = x, x += ge.length, i && x === a || x > a || Ae) {
        g.splice(Q, 1), Ae && (A = void 0);
        break;
      }
    }
    i = g.join("").trim(), i === "" ? o.remove() : (o.setTextContent(i), o.select(A, A));
  }
  function Ws(o, i, a, g) {
    var C = i;
    if (o.nodeType === 1) {
      let Q = !1;
      var x = o.childNodes, A = x.length;
      C === A && (Q = !0, C = A - 1);
      let ge = x[C];
      if (A = !1, ge === g._blockCursorElement ? (ge = x[C + 1], A = !0) : g._blockCursorElement !== null && C--, g = Ar(ge), Nt(g)) C = Q ? g.getTextContentSize() : 0;
      else {
        if (x = Ar(o), x === null) return null;
        if (Je(x) ? (o = x.getChildAtIndex(C), (i = Je(o)) && (i = o.getParent(), i = a === null || i === null || !i.canBeEmpty() || i !== a.getNode()), i && (a = Q ? o.getLastDescendant() : o.getFirstDescendant(), a === null ? (x = o, C = 0) : (o = a, x = Je(o) ? o : o.getParentOrThrow())), Nt(o) ? (g = o, x = null, C = Q ? o.getTextContentSize() : 0) : o !== x && Q && !A && C++) : (C = x.getIndexWithinParent(), C = i === 0 && Cn(x) && Ar(o) === x ? C : C + 1, x = x.getParentOrThrow()), Je(x)) return Hr(x.__key, C, "element");
      }
    } else g = Ar(o);
    return Nt(g) ? Hr(g.__key, C, "text") : null;
  }
  function Wi(o, i, a) {
    var g = o.offset, C = o.getNode();
    g === 0 ? (g = C.getPreviousSibling(), C = C.getParent(), i ? (a || !i) && g === null && Je(C) && C.isInline() && (i = C.getPreviousSibling(), Nt(i) && (o.key = i.__key, o.offset = i.getTextContent().length)) : Je(g) && !a && g.isInline() ? (o.key = g.__key, o.offset = g.getChildrenSize(), o.type = "element") : Nt(g) && (o.key = g.__key, o.offset = g.getTextContent().length)) : g === C.getTextContent().length && (g = C.getNextSibling(), C = C.getParent(), i && Je(g) && g.isInline() ? (o.key = g.__key, o.offset = 0, o.type = "element") : (a || i) && g === null && Je(C) && C.isInline() && !C.canInsertTextAfter() && (i = C.getNextSibling(), Nt(i) && (o.key = i.__key, o.offset = 0)));
  }
  function wo(o, i, a) {
    if (o.type === "text" && i.type === "text") {
      var g = o.isBefore(i);
      let C = o.is(i);
      Wi(o, g, C), Wi(i, !g, C), C && (i.key = o.key, i.offset = o.offset, i.type = o.type), g = dn(), g.isComposing() && g._compositionKey !== o.key && At(a) && (g = a.anchor, a = a.focus, Mr(o, g.key, g.offset, g.type), Mr(i, a.key, a.offset, a.type));
    }
  }
  function Pa(o, i, a, g, C, x) {
    return o === null || a === null || !st(C, o, a) || (i = Ws(o, i, At(x) ? x.anchor : null, C), i === null) || (g = Ws(a, g, At(x) ? x.focus : null, C), g === null || i.type === "element" && g.type === "element" && (o = Ar(o), a = Ar(a), Cn(o) && Cn(a))) ? null : (wo(i, g, x), [i, g]);
  }
  function Dl(o, i, a, g, C, x) {
    let A = Wr();
    return o = new Ei(Hr(o, i, C), Hr(a, g, x), 0, ""), o.dirty = !0, A._selection = o;
  }
  function Al() {
    return new vo(/* @__PURE__ */ new Set());
  }
  function In(o) {
    let i = o.getEditorState()._selection, a = qr(o._window);
    return At(i) || i == null ? Gn(i, a, o, null) : i.clone();
  }
  function Gn(o, i, a, g) {
    var C = a._window;
    if (C === null) return null;
    var x = (C = g || C.event) ? C.type : void 0;
    g = x === "selectionchange", C = !Fe && (g || x === "beforeinput" || x === "compositionstart" || x === "compositionend" || x === "click" && C && C.detail === 3 || x === "drop" || x === void 0);
    let A;
    if (!At(o) || C) {
      if (i === null) return null;
      if (C = i.anchorNode, x = i.focusNode, A = i.anchorOffset, i = i.focusOffset, g && At(o) && !st(a, C, x)) return o.clone();
    } else return o.clone();
    if (a = Pa(C, A, x, i, a, o), a === null) return null;
    let [Q, ge] = a;
    return new Ei(Q, ge, At(o) ? o.format : 0, At(o) ? o.style : "");
  }
  function Vt() {
    return Wr()._selection;
  }
  function xr() {
    return dn()._editorState._selection;
  }
  function Hn(o, i, a, g = 1) {
    var C = o.anchor, x = o.focus, A = C.getNode(), Q = x.getNode();
    if (i.is(A) || i.is(Q)) {
      if (A = i.__key, o.isCollapsed())
        i = C.offset, (a <= i && 0 < g || a < i && 0 > g) && (a = Math.max(0, i + g), C.set(A, a, "element"), x.set(A, a, "element"), ds(o));
      else {
        let Ae = o.isBackward();
        Q = Ae ? x : C;
        var ge = Q.getNode();
        C = Ae ? C : x, x = C.getNode(), i.is(ge) && (ge = Q.offset, (a <= ge && 0 < g || a < ge && 0 > g) && Q.set(A, Math.max(0, ge + g), "element")), i.is(x) && (i = C.offset, (a <= i && 0 < g || a < i && 0 > g) && C.set(A, Math.max(0, i + g), "element"));
      }
      ds(o);
    }
  }
  function ds(o) {
    var i = o.anchor, a = i.offset;
    let g = o.focus;
    var C = g.offset, x = i.getNode(), A = g.getNode();
    if (o.isCollapsed()) Je(x) && (A = x.getChildrenSize(), A = (C = a >= A) ? x.getChildAtIndex(A - 1) : x.getChildAtIndex(a), Nt(A) && (a = 0, C && (a = A.getTextContentSize()), i.set(A.__key, a, "text"), g.set(A.__key, a, "text")));
    else {
      if (Je(x)) {
        let Q = x.getChildrenSize();
        a = (o = a >= Q) ? x.getChildAtIndex(Q - 1) : x.getChildAtIndex(a), Nt(a) && (x = 0, o && (x = a.getTextContentSize()), i.set(a.__key, x, "text"));
      }
      Je(A) && (a = A.getChildrenSize(), C = (i = C >= a) ? A.getChildAtIndex(a - 1) : A.getChildAtIndex(C), Nt(C) && (A = 0, i && (A = C.getTextContentSize()), g.set(C.__key, A, "text")));
    }
  }
  function $a(o, i) {
    if (i = i.getEditorState()._selection, o = o._selection, At(o)) {
      var a = o.anchor;
      let g = o.focus, C;
      a.type === "text" && (C = a.getNode(), C.selectionTransform(i, o)), g.type === "text" && (a = g.getNode(), C !== a && a.selectionTransform(i, o));
    }
  }
  function fs(o, i, a, g, C) {
    let x = null, A = 0, Q = null;
    g !== null ? (x = g.__key, Nt(g) ? (A = g.getTextContentSize(), Q = "text") : Je(g) && (A = g.getChildrenSize(), Q = "element")) : C !== null && (x = C.__key, Nt(C) ? Q = "text" : Je(C) && (Q = "element")), x !== null && Q !== null ? o.set(x, A, Q) : (A = i.getIndexWithinParent(), A === -1 && (A = a.getChildrenSize()), o.set(a.__key, A, "element"));
  }
  function Ks(o, i, a, g, C) {
    o.type === "text" ? (o.key = a, i || (o.offset += C)) : o.offset > g.getIndexWithinParent() && --o.offset;
  }
  function zs(o) {
    o instanceof Ro || (o instanceof $s ? (o = ya(o, ji), ji(o) || Y(114)) : (o = ya(o.getNode(), ji), ji(o) || Y(114)));
    let i = o.getParent();
    Fl(i) || Y(115);
    let a = i.getParent();
    return $l(a) || Y(116), [o, i, a];
  }
  function Us(o) {
    o.isCollapsed() || o.removeText();
    var i = o.anchor;
    for (o = i.getNode(), i = i.offset; !ss(o); ) [o, i] = Ml(o, i);
    return i;
  }
  function Ml(o, i) {
    var a = o.getParent();
    if (!a) return a = zr(), Rt().append(a), a.select(), [Rt(), 0];
    if (Nt(o)) {
      var g = o.splitText(i);
      return g.length === 0 ? [a, o.getIndexWithinParent()] : (o = i === 0 ? 0 : 1, o = g[0].getIndexWithinParent() + o, [a, o]);
    }
    return !Je(o) || i === 0 ? [a, o.getIndexWithinParent()] : ((g = o.getChildAtIndex(i)) && (i = new Ei(Hr(o.__key, i, "element"), Hr(o.__key, i, "element"), 0, ""), (i = o.insertNewAfter(i)) && i.append(g, ...g.getNextSiblings())), [a, o.getIndexWithinParent() + 1]);
  }
  function Ki(o) {
    let i = zr(), a = null;
    for (let g = 0; g < o.length; g++) {
      let C = o[g], x = Pi(C);
      if (x || Cn(C) && C.isInline() || Je(C) && C.isInline() || Nt(C) || C.isParentRequired()) {
        if (a === null && (a = C.createParentElementNode(), i.append(a), x)) continue;
        a !== null && a.append(C);
      } else i.append(C), a = null;
    }
    return i;
  }
  let hn = null, On = null, Wn = !1, hs = !1, zi = 0, Ti = { characterData: !0, childList: !0, subtree: !0 };
  function gs() {
    return Wn || hn !== null && hn._readOnly;
  }
  function Jn() {
    Wn && Y(13);
  }
  function Wr() {
    return hn === null && Y(15), hn;
  }
  function dn() {
    return On === null && Y(16), On;
  }
  function Fa(o, i, a) {
    var g = i.__type;
    let C = o._nodes.get(g);
    for (C === void 0 && Y(30, g), o = a.get(g), o === void 0 && (o = Array.from(C.transforms), a.set(g, o)), a = o.length, g = 0; g < a && (o[g](i), i.isAttached()); g++) ;
  }
  function Rl(o, i) {
    i = i._dirtyLeaves, o = o._nodeMap;
    for (let a of i) i = o.get(a), Nt(i) && i.isAttached() && i.isSimpleText() && !i.isUnmergeable() && ve(i);
  }
  function Ba(o, i) {
    let a = i._dirtyLeaves, g = i._dirtyElements;
    o = o._nodeMap;
    let C = Tt(), x = /* @__PURE__ */ new Map();
    var A = a;
    let Q = A.size;
    for (var ge = g, Ae = ge.size; 0 < Q || 0 < Ae; ) {
      if (0 < Q) {
        i._dirtyLeaves = /* @__PURE__ */ new Set();
        for (let Ye of A) A = o.get(Ye), Nt(A) && A.isAttached() && A.isSimpleText() && !A.isUnmergeable() && ve(A), A !== void 0 && A !== void 0 && A.__key !== C && A.isAttached() && Fa(i, A, x), a.add(Ye);
        if (A = i._dirtyLeaves, Q = A.size, 0 < Q) {
          zi++;
          continue;
        }
      }
      i._dirtyLeaves = /* @__PURE__ */ new Set(), i._dirtyElements = /* @__PURE__ */ new Map();
      for (let Ye of ge) ge = Ye[0], Ae = Ye[1], (ge === "root" || Ae) && (A = o.get(ge), A !== void 0 && A !== void 0 && A.__key !== C && A.isAttached() && Fa(i, A, x), g.set(ge, Ae));
      A = i._dirtyLeaves, Q = A.size, ge = i._dirtyElements, Ae = ge.size, zi++;
    }
    i._dirtyLeaves = a, i._dirtyElements = g;
  }
  function Oo(o, i) {
    var a = o.type, g = i.get(a);
    if (g === void 0 && Y(17, a), a = g.klass, o.type !== a.getType() && Y(18, a.name), a = a.importJSON(o), o = o.children, Je(a) && Array.isArray(o)) for (g = 0; g < o.length; g++) {
      let C = Oo(o[g], i);
      a.append(C);
    }
    return a;
  }
  function bl(o, i) {
    let a = hn, g = Wn, C = On;
    hn = o, Wn = !0, On = null;
    try {
      return i();
    } finally {
      hn = a, Wn = g, On = C;
    }
  }
  function Ui(o, i) {
    let a = o._pendingEditorState, g = o._rootElement, C = o._headless || g === null;
    if (a !== null) {
      var x = o._editorState, A = x._selection, Q = a._selection, ge = o._dirtyType !== 0, Ae = hn, Ye = Wn, Xe = On, Ke = o._updating, Pe = o._observer, gt = null;
      if (o._pendingEditorState = null, o._editorState = a, !C && ge && Pe !== null) {
        On = o, hn = a, Wn = !1, o._updating = !0;
        try {
          let pn = o._dirtyType, Xn = o._dirtyElements, En = o._dirtyLeaves;
          Pe.disconnect();
          var wt = pn, $t = Xn, Kt = En;
          zn = si = Ln = "", fl = wt === 2, bi = null, Bn = o, Fr = o._config, As = o._nodes, Zr = Bn._listeners.mutation, gl = $t, vn = Kt, ar = x._nodeMap, Nn = a._nodeMap, hl = a._readOnly, mo = new Map(o._keyToDOMMap);
          let Ir = /* @__PURE__ */ new Map();
          oi = Ir, ki("root", null), oi = mo = Fr = Nn = ar = vn = gl = As = Bn = void 0, gt = Ir;
        } catch (pn) {
          if (pn instanceof Error && o._onError(pn), hs) throw pn;
          Mo(o, null, g, a), Oe(o), o._dirtyType = 2, hs = !0, Ui(o, x), hs = !1;
          return;
        } finally {
          Pe.observe(g, Ti), o._updating = Ke, hn = Ae, Wn = Ye, On = Xe;
        }
      }
      a._readOnly || (a._readOnly = !0);
      var Yn = o._dirtyLeaves, Rr = o._dirtyElements, ai = o._normalizedNodes, ci = o._updateTags, Bl = o._deferred;
      ge && (o._dirtyType = 0, o._cloneNotNeeded.clear(), o._dirtyLeaves = /* @__PURE__ */ new Set(), o._dirtyElements = /* @__PURE__ */ new Map(), o._normalizedNodes = /* @__PURE__ */ new Set(), o._updateTags = /* @__PURE__ */ new Set());
      var Vi = o._decorators, bo = o._pendingDecorators || Vi, ms = a._nodeMap, ui;
      for (ui in bo) ms.has(ui) || (bo === Vi && (bo = tn(o)), delete bo[ui]);
      var br = C ? null : qr(o._window);
      if (o._editable && br !== null && (ge || Q === null || Q.dirty)) {
        On = o, hn = a;
        try {
          if (Pe !== null && Pe.disconnect(), ge || Q === null || Q.dirty) {
            let pn = o._blockCursorElement;
            pn !== null && ul(pn, o, g);
            e: {
              let Xn = br.anchorNode, En = br.focusNode, Ir = br.anchorOffset, vi = br.focusOffset, Et = document.activeElement;
              if (!(ci.has("collaboration") && Et !== g || Et !== null && it(Et))) if (At(Q)) {
                var qi = Q.anchor, Lo = Q.focus, Wa = qi.key, Ka = Lo.key, Hl = bn(o, Wa), qs = bn(o, Ka), Qr = qi.offset, za = Lo.offset, Wl = Q.format, Io = Q.style, Ua = Q.isCollapsed(), Zs = Hl, ko = qs, Kl = !1;
                if (qi.type === "text") {
                  Zs = ze(Hl);
                  let dr = qi.getNode();
                  Kl = dr.getFormat() !== Wl || dr.getStyle() !== Io;
                } else At(A) && A.anchor.type === "text" && (Kl = !0);
                if (Lo.type === "text" && (ko = ze(qs)), Zs !== null && ko !== null) {
                  if (Ua && (A === null || Kl || At(A) && (A.format !== Wl || A.style !== Io))) {
                    var Ga = performance.now();
                    Ta = [Wl, Io, Qr, Wa, Ga];
                  }
                  if (Ir === Qr && vi === za && Xn === Zs && En === ko && (br.type !== "Range" || !Ua) && (Et !== null && g.contains(Et) || g.focus({ preventScroll: !0 }), qi.type !== "element")) break e;
                  try {
                    br.setBaseAndExtent(Zs, Qr, ko, za);
                  } catch {
                  }
                  if (!ci.has("skip-scroll-into-view") && Q.isCollapsed() && g !== null && g === document.activeElement) {
                    let dr = Q instanceof Ei && Q.anchor.type === "element" ? Zs.childNodes[Qr] || null : 0 < br.rangeCount ? br.getRangeAt(0) : null;
                    if (dr !== null) {
                      let kr;
                      if (dr instanceof Text) {
                        let fr = document.createRange();
                        fr.selectNode(dr), kr = fr.getBoundingClientRect();
                      } else kr = dr.getBoundingClientRect();
                      let ir = g.ownerDocument, Ur = ir.defaultView;
                      if (Ur !== null) for (var { top: zl, bottom: ei } = kr, Dn, mt, Sr = g; Sr !== null; ) {
                        let fr = Sr === ir.body;
                        if (fr) Dn = 0, mt = un(o).innerHeight;
                        else {
                          let Bo = Sr.getBoundingClientRect();
                          Dn = Bo.top, mt = Bo.bottom;
                        }
                        let di = 0;
                        if (zl < Dn ? di = -(Dn - zl) : ei > mt && (di = ei - mt), di !== 0) if (fr) Ur.scrollBy(0, di);
                        else {
                          let Bo = Sr.scrollTop;
                          Sr.scrollTop += di;
                          let Ya = Sr.scrollTop - Bo;
                          zl -= Ya, ei -= Ya;
                        }
                        if (fr) break;
                        Sr = Cr(Sr);
                      }
                    }
                  }
                  Cl = !0;
                }
              } else A !== null && st(o, Xn, En) && br.removeAllRanges();
            }
          }
          e: {
            let pn = o._blockCursorElement;
            if (At(Q) && Q.isCollapsed() && Q.anchor.type === "element" && g.contains(document.activeElement)) {
              let Xn = Q.anchor, En = Xn.getNode(), Ir = Xn.offset, vi = En.getChildrenSize(), Et = !1, dr = null;
              if (Ir === vi) {
                let kr = En.getChildAtIndex(Ir - 1);
                go(kr) && (Et = !0);
              } else {
                let kr = En.getChildAtIndex(Ir);
                if (go(kr)) {
                  let ir = kr.getPreviousSibling();
                  (ir === null || go(ir)) && (Et = !0, dr = o.getElementByKey(kr.__key));
                }
              }
              if (Et) {
                let kr = o.getElementByKey(En.__key);
                if (pn === null) {
                  let ir = o._config.theme, Ur = document.createElement("div");
                  Ur.contentEditable = "false", Ur.setAttribute("data-lexical-cursor", "true");
                  let fr = ir.blockCursor;
                  if (fr !== void 0) {
                    if (typeof fr == "string") {
                      let di = fr.split(" ");
                      fr = ir.blockCursor = di;
                    }
                    fr !== void 0 && Ur.classList.add(...fr);
                  }
                  o._blockCursorElement = pn = Ur;
                }
                g.style.caretColor = "transparent", dr === null ? kr.appendChild(pn) : kr.insertBefore(pn, dr);
                break e;
              }
            }
            pn !== null && ul(pn, o, g);
          }
          Pe !== null && Pe.observe(g, Ti);
        } finally {
          On = Xe, hn = Ae;
        }
      }
      if (gt !== null) {
        var Po = gt;
        let pn = Array.from(o._listeners.mutation), Xn = pn.length;
        for (let En = 0; En < Xn; En++) {
          let [Ir, vi] = pn[En], Et = Po.get(vi);
          Et !== void 0 && Ir(Et, { dirtyLeaves: Yn, prevEditorState: x, updateTags: ci });
        }
      }
      At(Q) || Q === null || A !== null && A.is(Q) || o.dispatchCommand(e, void 0);
      var $o = o._pendingDecorators;
      $o !== null && (o._decorators = $o, o._pendingDecorators = null, xi("decorator", o, !0, $o));
      var Bc = Lt(i || x), Lr = Lt(a);
      if (Bc !== Lr && xi("textcontent", o, !0, Lr), xi("update", o, !0, { dirtyElements: Rr, dirtyLeaves: Yn, editorState: a, normalizedNodes: ai, prevEditorState: i || x, tags: ci }), o._deferred = [], Bl.length !== 0) {
        let pn = o._updating;
        o._updating = !0;
        try {
          for (let Xn = 0; Xn < Bl.length; Xn++) Bl[Xn]();
        } finally {
          o._updating = pn;
        }
      }
      var Fo = o._updates;
      if (Fo.length !== 0) {
        let pn = Fo.shift();
        if (pn) {
          let [Xn, En] = pn;
          Ll(o, Xn, En);
        }
      }
    }
  }
  function xi(o, i, a, ...g) {
    let C = i._updating;
    i._updating = a;
    try {
      let x = Array.from(i._listeners[o]);
      for (o = 0; o < x.length; o++) x[o].apply(null, g);
    } finally {
      i._updating = C;
    }
  }
  function at(o, i, a) {
    if (o._updating === !1 || On !== o) {
      let x = !1;
      return o.update(() => {
        x = at(o, i, a);
      }), x;
    }
    let g = pe(o);
    for (let x = 4; 0 <= x; x--) for (let A = 0; A < g.length; A++) {
      var C = g[A]._commands.get(i);
      if (C !== void 0 && (C = C[x], C !== void 0)) {
        C = Array.from(C);
        let Q = C.length;
        for (let ge = 0; ge < Q; ge++) if (C[ge](a, o) === !0) return !0;
      }
    }
    return !1;
  }
  function ps(o, i) {
    let a = o._updates;
    for (i = i || !1; a.length !== 0; ) {
      var g = a.shift();
      if (g) {
        let [C, x] = g, A;
        x !== void 0 && (g = x.onUpdate, A = x.tag, x.skipTransforms && (i = !0), g && o._deferred.push(g), A && o._updateTags.add(A)), C();
      }
    }
    return i;
  }
  function Ll(o, i, a) {
    let g = o._updateTags;
    var C, x = C = !1;
    if (a !== void 0) {
      var A = a.onUpdate;
      C = a.tag, C != null && g.add(C), C = a.skipTransforms || !1, x = a.discrete || !1;
    }
    A && o._deferred.push(A), a = o._editorState, A = o._pendingEditorState;
    let Q = !1;
    (A === null || A._readOnly) && (A = o._pendingEditorState = new Gs(new Map((A || a)._nodeMap)), Q = !0), A._flushSync = x, x = hn;
    let ge = Wn, Ae = On, Ye = o._updating;
    hn = A, Wn = !1, o._updating = !0, On = o;
    try {
      Q && (o._headless ? a._selection != null && (A._selection = a._selection.clone()) : A._selection = In(o));
      let Xe = o._compositionKey;
      i(), C = ps(o, C), $a(A, o), o._dirtyType !== 0 && (C ? Rl(A, o) : Ba(A, o), ps(o), dl(a, A, o._dirtyLeaves, o._dirtyElements)), Xe !== o._compositionKey && (A._flushSync = !0);
      let Ke = A._selection;
      if (At(Ke)) {
        let Pe = A._nodeMap, gt = Ke.focus.key;
        Pe.get(Ke.anchor.key) !== void 0 && Pe.get(gt) !== void 0 || Y(19);
      } else cr(Ke) && Ke._nodes.size === 0 && (A._selection = null);
    } catch (Xe) {
      Xe instanceof Error && o._onError(Xe), o._pendingEditorState = a, o._dirtyType = 2, o._cloneNotNeeded.clear(), o._dirtyLeaves = /* @__PURE__ */ new Set(), o._dirtyElements.clear(), Ui(o);
      return;
    } finally {
      hn = x, Wn = ge, On = Ae, o._updating = Ye, zi = 0;
    }
    o._dirtyType !== 0 || Il(A, o) ? A._flushSync ? (A._flushSync = !1, Ui(o)) : Q && rt(() => {
      Ui(o);
    }) : (A._flushSync = !1, Q && (g.clear(), o._deferred = [], o._pendingEditorState = null));
  }
  function vr(o, i, a) {
    o._updating ? o._updates.push([i, a]) : Ll(o, i, a);
  }
  class Do extends $s {
    constructor(i) {
      super(i);
    }
    decorate() {
      Y(47);
    }
    isIsolated() {
      return !1;
    }
    isInline() {
      return !0;
    }
    isKeyboardSelectable() {
      return !0;
    }
  }
  function Cn(o) {
    return o instanceof Do;
  }
  class Gi extends $s {
    constructor(i) {
      super(i), this.__last = this.__first = null, this.__indent = this.__format = this.__size = 0, this.__dir = null;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getFormatType() {
      let i = this.getFormat();
      return Ne[i] || "";
    }
    getIndent() {
      return this.getLatest().__indent;
    }
    getChildren() {
      let i = [], a = this.getFirstChild();
      for (; a !== null; ) i.push(a), a = a.getNextSibling();
      return i;
    }
    getChildrenKeys() {
      let i = [], a = this.getFirstChild();
      for (; a !== null; ) i.push(a.__key), a = a.getNextSibling();
      return i;
    }
    getChildrenSize() {
      return this.getLatest().__size;
    }
    isEmpty() {
      return this.getChildrenSize() === 0;
    }
    isDirty() {
      let i = dn()._dirtyElements;
      return i !== null && i.has(this.__key);
    }
    isLastChild() {
      let i = this.getLatest(), a = this.getParentOrThrow().getLastChild();
      return a !== null && a.is(i);
    }
    getAllTextNodes() {
      let i = [], a = this.getFirstChild();
      for (; a !== null; ) {
        if (Nt(a) && i.push(a), Je(a)) {
          let g = a.getAllTextNodes();
          i.push(...g);
        }
        a = a.getNextSibling();
      }
      return i;
    }
    getFirstDescendant() {
      let i = this.getFirstChild();
      for (; i !== null; ) {
        if (Je(i)) {
          let a = i.getFirstChild();
          if (a !== null) {
            i = a;
            continue;
          }
        }
        break;
      }
      return i;
    }
    getLastDescendant() {
      let i = this.getLastChild();
      for (; i !== null; ) {
        if (Je(i)) {
          let a = i.getLastChild();
          if (a !== null) {
            i = a;
            continue;
          }
        }
        break;
      }
      return i;
    }
    getDescendantByIndex(i) {
      let a = this.getChildren(), g = a.length;
      return i >= g ? (i = a[g - 1], Je(i) && i.getLastDescendant() || i || null) : (i = a[i], Je(i) && i.getFirstDescendant() || i || null);
    }
    getFirstChild() {
      let i = this.getLatest().__first;
      return i === null ? null : pt(i);
    }
    getFirstChildOrThrow() {
      let i = this.getFirstChild();
      return i === null && Y(45, this.__key), i;
    }
    getLastChild() {
      let i = this.getLatest().__last;
      return i === null ? null : pt(i);
    }
    getLastChildOrThrow() {
      let i = this.getLastChild();
      return i === null && Y(96, this.__key), i;
    }
    getChildAtIndex(i) {
      var a = this.getChildrenSize();
      let g;
      if (i < a / 2) {
        for (g = this.getFirstChild(), a = 0; g !== null && a <= i; ) {
          if (a === i) return g;
          g = g.getNextSibling(), a++;
        }
        return null;
      }
      for (g = this.getLastChild(), --a; g !== null && a >= i; ) {
        if (a === i) return g;
        g = g.getPreviousSibling(), a--;
      }
      return null;
    }
    getTextContent() {
      let i = "", a = this.getChildren(), g = a.length;
      for (let C = 0; C < g; C++) {
        let x = a[C];
        i += x.getTextContent(), Je(x) && C !== g - 1 && !x.isInline() && (i += `

`);
      }
      return i;
    }
    getTextContentSize() {
      let i = 0, a = this.getChildren(), g = a.length;
      for (let C = 0; C < g; C++) {
        let x = a[C];
        i += x.getTextContentSize(), Je(x) && C !== g - 1 && !x.isInline() && (i += 2);
      }
      return i;
    }
    getDirection() {
      return this.getLatest().__dir;
    }
    hasFormat(i) {
      return i !== "" ? (i = be[i], (this.getFormat() & i) !== 0) : !1;
    }
    select(i, a) {
      Jn();
      let g = Vt(), C = i, x = a;
      var A = this.getChildrenSize();
      if (!this.canBeEmpty()) {
        if (i === 0 && a === 0) {
          if (i = this.getFirstChild(), Nt(i) || Je(i)) return i.select(0, 0);
        } else if (!(i !== void 0 && i !== A || a !== void 0 && a !== A) && (i = this.getLastChild(), Nt(i) || Je(i))) return i.select();
      }
      if (C === void 0 && (C = A), x === void 0 && (x = A), A = this.__key, At(g)) g.anchor.set(A, C, "element"), g.focus.set(A, x, "element"), g.dirty = !0;
      else return Dl(A, C, A, x, "element", "element");
      return g;
    }
    selectStart() {
      let i = this.getFirstDescendant();
      return i ? i.selectStart() : this.select();
    }
    selectEnd() {
      let i = this.getLastDescendant();
      return i ? i.selectEnd() : this.select();
    }
    clear() {
      let i = this.getWritable();
      return this.getChildren().forEach((a) => a.remove()), i;
    }
    append(...i) {
      return this.splice(
        this.getChildrenSize(),
        0,
        i
      );
    }
    setDirection(i) {
      let a = this.getWritable();
      return a.__dir = i, a;
    }
    setFormat(i) {
      return this.getWritable().__format = i !== "" ? be[i] : 0, this;
    }
    setIndent(i) {
      return this.getWritable().__indent = i, this;
    }
    splice(i, a, g) {
      let C = g.length, x = this.getChildrenSize(), A = this.getWritable(), Q = A.__key;
      var ge = [], Ae = [];
      let Ye = this.getChildAtIndex(i + a), Xe = null, Ke = x - a + C;
      if (i !== 0) if (i === x) Xe = this.getLastChild();
      else {
        var Pe = this.getChildAtIndex(i);
        Pe !== null && (Xe = Pe.getPreviousSibling());
      }
      if (0 < a) {
        var gt = Xe === null ? this.getFirstChild() : Xe.getNextSibling();
        for (Pe = 0; Pe < a; Pe++) {
          gt === null && Y(100);
          var wt = gt.getNextSibling(), $t = gt.__key;
          gt = gt.getWritable(), yt(gt), Ae.push($t), gt = wt;
        }
      }
      for (Pe = Xe, wt = 0; wt < C; wt++) {
        $t = g[wt], Pe !== null && $t.is(Pe) && (Xe = Pe = Pe.getPreviousSibling()), gt = $t.getWritable(), gt.__parent === Q && Ke--, yt(gt);
        let Kt = $t.__key;
        Pe === null ? (A.__first = Kt, gt.__prev = null) : (Pe = Pe.getWritable(), Pe.__next = Kt, gt.__prev = Pe.__key), $t.__key === Q && Y(76), gt.__parent = Q, ge.push(Kt), Pe = $t;
      }
      if (i + a === x ? Pe !== null && (Pe.getWritable().__next = null, A.__last = Pe.__key) : Ye !== null && (i = Ye.getWritable(), Pe !== null ? (a = Pe.getWritable(), i.__prev = Pe.__key, a.__next = Ye.__key) : i.__prev = null), A.__size = Ke, Ae.length && (i = Vt(), At(i))) {
        Ae = new Set(Ae), ge = new Set(ge);
        let { anchor: Kt, focus: Yn } = i;
        Ao(Kt, Ae, ge) && fs(Kt, Kt.getNode(), this, Xe, Ye), Ao(Yn, Ae, ge) && fs(Yn, Yn.getNode(), this, Xe, Ye), Ke !== 0 || this.canBeEmpty() || lr(this) || this.remove();
      }
      return A;
    }
    exportJSON() {
      return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
    }
    insertNewAfter() {
      return null;
    }
    canIndent() {
      return !0;
    }
    collapseAtStart() {
      return !1;
    }
    excludeFromCopy() {
      return !1;
    }
    canExtractContents() {
      return !0;
    }
    canReplaceWith() {
      return !0;
    }
    canInsertAfter() {
      return !0;
    }
    canBeEmpty() {
      return !0;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    isInline() {
      return !1;
    }
    isShadowRoot() {
      return !1;
    }
    canMergeWith() {
      return !1;
    }
    extractWithChild() {
      return !1;
    }
  }
  function Je(o) {
    return o instanceof Gi;
  }
  function Ao(o, i, a) {
    for (o = o.getNode(); o; ) {
      let g = o.__key;
      if (i.has(g) && !a.has(g)) return !0;
      o = o.getParent();
    }
    return !1;
  }
  class ur extends Gi {
    static getType() {
      return "root";
    }
    static clone() {
      return new ur();
    }
    constructor() {
      super("root"), this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
      Y(51);
    }
    getTextContent() {
      let i = this.__cachedText;
      return !gs() && dn()._dirtyType !== 0 || i === null ? super.getTextContent() : i;
    }
    remove() {
      Y(52);
    }
    replace() {
      Y(53);
    }
    insertBefore() {
      Y(54);
    }
    insertAfter() {
      Y(55);
    }
    updateDOM() {
      return !1;
    }
    append(...i) {
      for (let a = 0; a < i.length; a++) {
        let g = i[a];
        Je(g) || Cn(g) || Y(56);
      }
      return super.append(...i);
    }
    static importJSON(i) {
      let a = Rt();
      return a.setFormat(i.format), a.setIndent(i.indent), a.setDirection(i.direction), a;
    }
    exportJSON() {
      return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
    }
    collapseAtStart() {
      return !0;
    }
  }
  function rr(o) {
    return o instanceof ur;
  }
  function Il(o, i) {
    if (i = i.getEditorState()._selection, o = o._selection, o !== null) {
      if (o.dirty || !o.is(i)) return !0;
    } else if (i !== null) return !0;
    return !1;
  }
  function Yi() {
    return new Gs(/* @__PURE__ */ new Map([["root", new ur()]]));
  }
  function kl(o) {
    let i = o.exportJSON();
    var a = o.constructor;
    if (i.type !== a.getType() && Y(130, a.name), Je(o)) {
      let g = i.children;
      for (Array.isArray(g) || Y(59, a.name), o = o.getChildren(), a = 0; a < o.length; a++) {
        let C = kl(o[a]);
        g.push(C);
      }
    }
    return i;
  }
  class Gs {
    constructor(i, a) {
      this._nodeMap = i, this._selection = a || null, this._readOnly = this._flushSync = !1;
    }
    isEmpty() {
      return this._nodeMap.size === 1 && this._selection === null;
    }
    read(i) {
      return bl(this, i);
    }
    clone(i) {
      return i = new Gs(this._nodeMap, i === void 0 ? this._selection : i), i._readOnly = !0, i;
    }
    toJSON() {
      return bl(this, () => ({ root: kl(Rt()) }));
    }
  }
  class Kr extends Gi {
    static getType() {
      return "paragraph";
    }
    static clone(i) {
      return new Kr(i.__key);
    }
    createDOM(i) {
      let a = document.createElement("p");
      return i = Ft(i.theme, "paragraph"), i !== void 0 && a.classList.add(...i), a;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { p: () => ({ conversion: Ys, priority: 0 }) };
    }
    exportDOM(i) {
      if ({ element: i } = super.exportDOM(i), i && po(i)) {
        this.isEmpty() && i.append(document.createElement("br"));
        var a = this.getFormatType();
        i.style.textAlign = a, (a = this.getDirection()) && (i.dir = a), a = this.getIndent(), 0 < a && (i.style.textIndent = `${20 * a}px`);
      }
      return { element: i };
    }
    static importJSON(i) {
      let a = zr();
      return a.setFormat(i.format), a.setIndent(i.indent), a.setDirection(i.direction), a;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "paragraph", version: 1 };
    }
    insertNewAfter(i, a) {
      i = zr();
      let g = this.getDirection();
      return i.setDirection(g), this.insertAfter(i, a), i;
    }
    collapseAtStart() {
      let i = this.getChildren();
      if (i.length === 0 || Nt(i[0]) && i[0].getTextContent().trim() === "") {
        if (this.getNextSibling() !== null) return this.selectNext(), this.remove(), !0;
        if (this.getPreviousSibling() !== null) return this.selectPrevious(), this.remove(), !0;
      }
      return !1;
    }
  }
  function Ys(o) {
    let i = zr();
    return o.style && (i.setFormat(o.style.textAlign), o = parseInt(o.style.textIndent, 10) / 20, 0 < o && i.setIndent(o)), { node: i };
  }
  function zr() {
    return Er(new Kr());
  }
  function Mo(o, i, a, g) {
    let C = o._keyToDOMMap;
    C.clear(), o._editorState = Yi(), o._pendingEditorState = g, o._compositionKey = null, o._dirtyType = 0, o._cloneNotNeeded.clear(), o._dirtyLeaves = /* @__PURE__ */ new Set(), o._dirtyElements.clear(), o._normalizedNodes = /* @__PURE__ */ new Set(), o._updateTags = /* @__PURE__ */ new Set(), o._updates = [], o._blockCursorElement = null, g = o._observer, g !== null && (g.disconnect(), o._observer = null), i !== null && (i.textContent = ""), a !== null && (a.textContent = "", C.set("root", a));
  }
  function js(o, i) {
    let a = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set(), C = (x) => {
      Object.keys(x).forEach((A) => {
        let Q = a.get(A);
        Q === void 0 && (Q = [], a.set(A, Q)), Q.push(x[A]);
      });
    };
    return o.forEach((x) => {
      x = x.klass.importDOM != null ? x.klass.importDOM.bind(x.klass) : null, x == null || g.has(x) || (g.add(x), x = x(), x !== null && C(x));
    }), i && C(i), a;
  }
  class Vs {
    constructor(i, a, g, C, x, A, Q) {
      this._parentEditor = a, this._rootElement = null, this._editorState = i, this._compositionKey = this._pendingEditorState = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = C, this._nodes = g, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = Ze(), this._onError = x, this._htmlConversions = A, this._editable = Q, this._headless = a !== null && a._headless, this._blockCursorElement = this._window = null;
    }
    isComposing() {
      return this._compositionKey != null;
    }
    registerUpdateListener(i) {
      let a = this._listeners.update;
      return a.add(i), () => {
        a.delete(i);
      };
    }
    registerEditableListener(i) {
      let a = this._listeners.editable;
      return a.add(i), () => {
        a.delete(i);
      };
    }
    registerDecoratorListener(i) {
      let a = this._listeners.decorator;
      return a.add(i), () => {
        a.delete(i);
      };
    }
    registerTextContentListener(i) {
      let a = this._listeners.textcontent;
      return a.add(i), () => {
        a.delete(i);
      };
    }
    registerRootListener(i) {
      let a = this._listeners.root;
      return i(this._rootElement, null), a.add(i), () => {
        i(null, this._rootElement), a.delete(i);
      };
    }
    registerCommand(i, a, g) {
      g === void 0 && Y(35);
      let C = this._commands;
      C.has(i) || C.set(i, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
      let x = C.get(i);
      x === void 0 && Y(36, String(i));
      let A = x[g];
      return A.add(a), () => {
        A.delete(a), x.every((Q) => Q.size === 0) && C.delete(i);
      };
    }
    registerMutationListener(i, a) {
      this._nodes.get(i.getType()) === void 0 && Y(37, i.name);
      let g = this._listeners.mutation;
      return g.set(a, i), () => {
        g.delete(a);
      };
    }
    registerNodeTransformToKlass(i, a) {
      var g = i.getType();
      return g = this._nodes.get(g), g === void 0 && Y(37, i.name), g.transforms.add(a), g;
    }
    registerNodeTransform(i, a) {
      var g = this.registerNodeTransformToKlass(i, a);
      let C = [g];
      return g = g.replaceWithKlass, g != null && (g = this.registerNodeTransformToKlass(g, a), C.push(g)), jt(this, i.getType()), () => {
        C.forEach((x) => x.transforms.delete(a));
      };
    }
    hasNode(i) {
      return this._nodes.has(i.getType());
    }
    hasNodes(i) {
      return i.every(this.hasNode.bind(this));
    }
    dispatchCommand(i, a) {
      return at(this, i, a);
    }
    getDecorators() {
      return this._decorators;
    }
    getRootElement() {
      return this._rootElement;
    }
    getKey() {
      return this._key;
    }
    setRootElement(i) {
      let a = this._rootElement;
      if (i !== a) {
        let A = Ft(this._config.theme, "root");
        var g = this._pendingEditorState || this._editorState;
        if (this._rootElement = i, Mo(this, a, i, g), a !== null) {
          if (!this._config.disableEvents) {
            Is !== 0 && (Is--, Is === 0 && a.ownerDocument.removeEventListener("selectionchange", Ma));
            var C = a.__lexicalEditor;
            if (C != null) {
              if (C._parentEditor !== null) {
                var x = pe(C);
                x = x[x.length - 1]._key, as.get(x) === C && as.delete(x);
              } else as.delete(C._key);
              a.__lexicalEditor = null;
            }
            for (C = Aa(a), x = 0; x < C.length; x++) C[x]();
            a.__lexicalEventHandles = [];
          }
          A != null && a.classList.remove(...A);
        }
        i !== null ? (g = (g = i.ownerDocument) && g.defaultView || null, C = i.style, C.userSelect = "text", C.whiteSpace = "pre-wrap", C.wordBreak = "break-word", i.setAttribute(
          "data-lexical-editor",
          "true"
        ), this._window = g, this._dirtyType = 2, Oe(this), this._updateTags.add("history-merge"), Ui(this), this._config.disableEvents || $c(i, this), A != null && i.classList.add(...A)) : (this._editorState = g, this._window = this._pendingEditorState = null), xi("root", this, !1, i, a);
      }
    }
    getElementByKey(i) {
      return this._keyToDOMMap.get(i) || null;
    }
    getEditorState() {
      return this._editorState;
    }
    setEditorState(i, a) {
      i.isEmpty() && Y(38), en(this);
      let g = this._pendingEditorState, C = this._updateTags;
      a = a !== void 0 ? a.tag : null, g === null || g.isEmpty() || (a != null && C.add(a), Ui(this)), this._pendingEditorState = i, this._dirtyType = 2, this._dirtyElements.set("root", !1), this._compositionKey = null, a != null && C.add(a), Ui(this);
    }
    parseEditorState(i, a) {
      i = typeof i == "string" ? JSON.parse(i) : i;
      let g = Yi(), C = hn, x = Wn, A = On, Q = this._dirtyElements, ge = this._dirtyLeaves, Ae = this._cloneNotNeeded, Ye = this._dirtyType;
      this._dirtyElements = /* @__PURE__ */ new Map(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyType = 0, hn = g, Wn = !1, On = this;
      try {
        Oo(i.root, this._nodes), a && a(), g._readOnly = !0;
      } catch (Xe) {
        Xe instanceof Error && this._onError(Xe);
      } finally {
        this._dirtyElements = Q, this._dirtyLeaves = ge, this._cloneNotNeeded = Ae, this._dirtyType = Ye, hn = C, Wn = x, On = A;
      }
      return g;
    }
    update(i, a) {
      vr(this, i, a);
    }
    focus(i, a = {}) {
      let g = this._rootElement;
      g !== null && (g.setAttribute("autocapitalize", "off"), vr(this, () => {
        let C = Vt(), x = Rt();
        C !== null ? C.dirty = !0 : x.getChildrenSize() !== 0 && (a.defaultSelection === "rootStart" ? x.selectStart() : x.selectEnd());
      }, { onUpdate: () => {
        g.removeAttribute("autocapitalize"), i && i();
      }, tag: "focus" }), this._pendingEditorState === null && g.removeAttribute("autocapitalize"));
    }
    blur() {
      var i = this._rootElement;
      i !== null && i.blur(), i = qr(this._window), i !== null && i.removeAllRanges();
    }
    isEditable() {
      return this._editable;
    }
    setEditable(i) {
      this._editable !== i && (this._editable = i, xi("editable", this, !0, i));
    }
    toJSON() {
      return { editorState: this._editorState.toJSON() };
    }
  }
  class Ro extends Gi {
    constructor(i, a) {
      super(a), this.__colSpan = i, this.__rowSpan = 1;
    }
    exportJSON() {
      return { ...super.exportJSON(), colSpan: this.__colSpan, rowSpan: this.__rowSpan };
    }
    getColSpan() {
      return this.__colSpan;
    }
    setColSpan(i) {
      return this.getWritable().__colSpan = i, this;
    }
    getRowSpan() {
      return this.__rowSpan;
    }
    setRowSpan(i) {
      return this.getWritable().__rowSpan = i, this;
    }
  }
  function ji(o) {
    return o instanceof Ro;
  }
  class Pl extends Gi {
  }
  function $l(o) {
    return o instanceof Pl;
  }
  class Ha extends Gi {
  }
  function Fl(o) {
    return o instanceof Ha;
  }
  return We.$INTERNAL_isPointSelection = Hs, We.$addUpdateTag = function(o) {
    Jn(), dn()._updateTags.add(o);
  }, We.$applyNodeReplacement = Er, We.$copyNode = Ri, We.$createLineBreakNode = Xr, We.$createNodeSelection = Al, We.$createParagraphNode = zr, We.$createPoint = Hr, We.$createRangeSelection = function() {
    let o = Hr("root", 0, "element"), i = Hr("root", 0, "element");
    return new Ei(o, i, 0, "");
  }, We.$createTabNode = Hi, We.$createTextNode = Un, We.$getAdjacentNode = Bt, We.$getNearestNodeFromDOMNode = Wt, We.$getNearestRootOrShadowRoot = or, We.$getNodeByKey = pt, We.$getPreviousSelection = xr, We.$getRoot = Rt, We.$getSelection = Vt, We.$getTextContent = function() {
    let o = Vt();
    return o === null ? "" : o.getTextContent();
  }, We.$hasAncestor = Zn, We.$hasUpdateTag = function(o) {
    return dn()._updateTags.has(o);
  }, We.$insertNodes = function(o) {
    let i = Vt() || xr();
    i === null && (i = Rt().selectEnd()), i.insertNodes(o);
  }, We.$isBlockElementNode = function(o) {
    return Je(o) && !o.isInline();
  }, We.$isDecoratorNode = Cn, We.$isElementNode = Je, We.$isInlineElementOrDecoratorNode = function(o) {
    return Je(o) && o.isInline() || Cn(o) && o.isInline();
  }, We.$isLeafNode = function(o) {
    return Nt(o) || Pi(o) || Cn(o);
  }, We.$isLineBreakNode = Pi, We.$isNodeSelection = cr, We.$isParagraphNode = function(o) {
    return o instanceof Kr;
  }, We.$isRangeSelection = At, We.$isRootNode = rr, We.$isRootOrShadowRoot = lr, We.$isTabNode = La, We.$isTextNode = Nt, We.$nodesOfType = function(o) {
    var i = Wr();
    let a = i._readOnly, g = o.getType();
    i = i._nodeMap;
    let C = [];
    for (let [, x] of i) x instanceof o && x.__type === g && (a || x.isAttached()) && C.push(x);
    return C;
  }, We.$normalizeSelection__EXPERIMENTAL = Le, We.$parseSerializedNode = function(o) {
    return Oo(o, dn()._nodes);
  }, We.$selectAll = function() {
    var o = Rt();
    o = o.select(0, o.getChildrenSize()), nn(Le(o));
  }, We.$setCompositionKey = ht, We.$setSelection = nn, We.$splitNode = function(o, i) {
    let a = o.getChildAtIndex(i);
    a == null && (a = o), lr(o) && Y(102);
    let g = (A) => {
      const Q = A.getParentOrThrow(), ge = lr(Q), Ae = A !== a || ge ? Ri(A) : A;
      if (ge) {
        if (!Je(A) || !Je(Ae)) throw Error("Children of a root must be ElementNode");
        return A.insertAfter(Ae), [A, Ae, Ae];
      }
      const [Ye, Xe, Ke] = g(Q);
      return A = A.getNextSiblings(), Ke.append(Ae, ...A), [Ye, Xe, Ae];
    }, [C, x] = g(a);
    return [C, x];
  }, We.BLUR_COMMAND = Z, We.CAN_REDO_COMMAND = {}, We.CAN_UNDO_COMMAND = {}, We.CLEAR_EDITOR_COMMAND = {}, We.CLEAR_HISTORY_COMMAND = {}, We.CLICK_COMMAND = t, We.COMMAND_PRIORITY_CRITICAL = 4, We.COMMAND_PRIORITY_EDITOR = 0, We.COMMAND_PRIORITY_HIGH = 3, We.COMMAND_PRIORITY_LOW = 1, We.COMMAND_PRIORITY_NORMAL = 2, We.CONTROLLED_TEXT_INSERTION_COMMAND = d, We.COPY_COMMAND = Ee, We.CUT_COMMAND = de, We.DELETE_CHARACTER_COMMAND = n, We.DELETE_LINE_COMMAND = E, We.DELETE_WORD_COMMAND = _, We.DEPRECATED_$computeGridMap = function(o, i, a) {
    let g = [], C = null, x = null;
    o = o.getChildren();
    for (let Ye = 0; Ye < o.length; Ye++) {
      var A = o[Ye];
      Fl(A) || Y(108);
      var Q = A.getChildren();
      A = 0;
      for (let Xe of Q) {
        for (ji(Xe) || Y(109); g[Ye] !== void 0 && g[Ye][A] !== void 0; ) A++;
        Q = Ye;
        var ge = A, Ae = Xe;
        let Ke = { cell: Ae, startColumn: ge, startRow: Q }, Pe = Ae.__rowSpan, gt = Ae.__colSpan;
        for (let wt = 0; wt < Pe; wt++) {
          g[Q + wt] === void 0 && (g[Q + wt] = []);
          for (let $t = 0; $t < gt; $t++) g[Q + wt][ge + $t] = Ke;
        }
        i.is(Ae) && (C = Ke), a.is(Ae) && (x = Ke), A += Xe.__colSpan;
      }
    }
    return C === null && Y(110), x === null && Y(111), [
      g,
      C,
      x
    ];
  }, We.DEPRECATED_$getGridCellNodeRect = function(o) {
    let [i, , a] = zs(o);
    o = a.getChildren();
    let g = o.length;
    var C = o[0].getChildren().length;
    let x = Array(g);
    for (var A = 0; A < g; A++) x[A] = Array(C);
    for (C = 0; C < g; C++) {
      A = o[C].getChildren();
      let Q = 0;
      for (let ge = 0; ge < A.length; ge++) {
        for (; x[C][Q]; ) Q++;
        let Ae = A[ge], Ye = Ae.__rowSpan || 1, Xe = Ae.__colSpan || 1;
        for (let Ke = 0; Ke < Ye; Ke++) for (let Pe = 0; Pe < Xe; Pe++) x[C + Ke][Q + Pe] = Ae;
        if (i === Ae) return { colSpan: Xe, columnIndex: Q, rowIndex: C, rowSpan: Ye };
        Q += Xe;
      }
    }
    return null;
  }, We.DEPRECATED_$getNodeTriplet = zs, We.DEPRECATED_$isGridCellNode = ji, We.DEPRECATED_$isGridNode = $l, We.DEPRECATED_$isGridRowNode = Fl, We.DEPRECATED_GridCellNode = Ro, We.DEPRECATED_GridNode = Pl, We.DEPRECATED_GridRowNode = Ha, We.DRAGEND_COMMAND = Se, We.DRAGOVER_COMMAND = Te, We.DRAGSTART_COMMAND = q, We.DROP_COMMAND = z, We.DecoratorNode = Do, We.ElementNode = Gi, We.FOCUS_COMMAND = D, We.FORMAT_ELEMENT_COMMAND = {}, We.FORMAT_TEXT_COMMAND = T, We.INDENT_CONTENT_COMMAND = {}, We.INSERT_LINE_BREAK_COMMAND = r, We.INSERT_PARAGRAPH_COMMAND = l, We.INSERT_TAB_COMMAND = {}, We.INTERNAL_PointSelection = Bs, We.KEY_ARROW_DOWN_COMMAND = P, We.KEY_ARROW_LEFT_COMMAND = I, We.KEY_ARROW_RIGHT_COMMAND = m, We.KEY_ARROW_UP_COMMAND = k, We.KEY_BACKSPACE_COMMAND = re, We.KEY_DELETE_COMMAND = ce, We.KEY_DOWN_COMMAND = O, We.KEY_ENTER_COMMAND = H, We.KEY_ESCAPE_COMMAND = te, We.KEY_MODIFIER_COMMAND = oe, We.KEY_SPACE_COMMAND = j, We.KEY_TAB_COMMAND = V, We.LineBreakNode = Jr, We.MOVE_TO_END = v, We.MOVE_TO_START = G, We.OUTDENT_CONTENT_COMMAND = {}, We.PASTE_COMMAND = f, We.ParagraphNode = Kr, We.REDO_COMMAND = w, We.REMOVE_TEXT_COMMAND = p, We.RootNode = ur, We.SELECTION_CHANGE_COMMAND = e, We.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND = {}, We.SELECT_ALL_COMMAND = K, We.TabNode = us, We.TextNode = Bi, We.UNDO_COMMAND = S, We.createCommand = function() {
    return {};
  }, We.createEditor = function(o) {
    var i = o || {}, a = On, g = i.theme || {};
    let C = o === void 0 ? a : i.parentEditor || null, x = i.disableEvents || !1, A = Yi(), Q = i.namespace || (C !== null ? C._config.namespace : Ze()), ge = i.editorState, Ae = [ur, Bi, Jr, us, Kr, ...i.nodes || []], { onError: Ye, html: Xe } = i;
    if (i = i.editable !== void 0 ? i.editable : !0, o === void 0 && a !== null) o = a._nodes;
    else for (o = /* @__PURE__ */ new Map(), a = 0; a < Ae.length; a++) {
      let Pe = Ae[a], gt = null;
      var Ke = null;
      typeof Pe != "function" && (Ke = Pe, Pe = Ke.replace, gt = Ke.with, Ke = Ke.withKlass || null);
      let wt = Pe.getType(), $t = Pe.transform(), Kt = /* @__PURE__ */ new Set();
      $t !== null && Kt.add($t), o.set(wt, { exportDOM: Xe && Xe.export ? Xe.export.get(Pe) : void 0, klass: Pe, replace: gt, replaceWithKlass: Ke, transforms: Kt });
    }
    return g = new Vs(A, C, o, { disableEvents: x, namespace: Q, theme: g }, Ye || console.error, js(o, Xe ? Xe.import : void 0), i), ge !== void 0 && (g._pendingEditorState = ge, g._dirtyType = 2), g;
  }, We.getNearestEditorFromDOMNode = vt, We.isCurrentlyReadOnlyMode = gs, We.isHTMLAnchorElement = function(o) {
    return po(o) && o.tagName === "A";
  }, We.isHTMLElement = po, We.isSelectionCapturedInDecoratorInput = it, We.isSelectionWithinEditor = st, We;
}
var eu, bf;
function Yt() {
  return bf || (bf = 1, eu = process.env.NODE_ENV === "development" ? bN() : LN()), eu;
}
var Lf;
function IN() {
  if (Lf) return Xc;
  Lf = 1;
  var e = qn(), t = Yt(), n = xn;
  const r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  var d = r ? n.useLayoutEffect : n.useEffect;
  const f = {
    tag: "history-merge"
  };
  function p({
    initialConfig: E,
    children: T
  }) {
    const S = n.useMemo(
      () => {
        const {
          theme: w,
          namespace: O,
          editor__DEPRECATED: m,
          nodes: v,
          onError: I,
          editorState: G,
          html: k
        } = E, P = e.createLexicalComposerContext(null, w);
        let H = m || null;
        if (H === null) {
          const j = t.createEditor({
            editable: E.editable,
            html: k,
            namespace: O,
            nodes: v,
            onError: (re) => I(re, j),
            theme: w
          });
          _(j, G), H = j;
        }
        return [H, P];
      },
      // We only do this for init
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );
    return d(() => {
      const w = E.editable, [O] = S;
      O.setEditable(w !== void 0 ? w : !0);
    }, []), /* @__PURE__ */ n.createElement(e.LexicalComposerContext.Provider, {
      value: S
    }, T);
  }
  function _(E, T) {
    if (T !== null) {
      if (T === void 0)
        E.update(() => {
          const S = t.$getRoot();
          if (S.isEmpty()) {
            const w = t.$createParagraphNode();
            S.append(w);
            const O = r ? document.activeElement : null;
            (t.$getSelection() !== null || O !== null && O === E.getRootElement()) && w.select();
          }
        }, f);
      else if (T !== null)
        switch (typeof T) {
          case "string": {
            const S = E.parseEditorState(T);
            E.setEditorState(S, f);
            break;
          }
          case "object": {
            E.setEditorState(T, f);
            break;
          }
          case "function": {
            E.update(() => {
              t.$getRoot().isEmpty() && T(E);
            }, f);
            break;
          }
        }
    }
  }
  return Xc.LexicalComposer = p, Xc;
}
var tu = {}, If;
function kN() {
  if (If) return tu;
  If = 1;
  var e = qn(), t = Yt(), n = xn;
  let r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  var l = r ? n.useLayoutEffect : n.useEffect;
  let d = { tag: "history-merge" };
  function f(p, _) {
    if (_ !== null) {
      if (_ === void 0) p.update(() => {
        var E = t.$getRoot();
        if (E.isEmpty()) {
          let T = t.$createParagraphNode();
          E.append(T), E = r ? document.activeElement : null, (t.$getSelection() !== null || E !== null && E === p.getRootElement()) && T.select();
        }
      }, d);
      else if (_ !== null) switch (typeof _) {
        case "string":
          let E = p.parseEditorState(_);
          p.setEditorState(E, d);
          break;
        case "object":
          p.setEditorState(_, d);
          break;
        case "function":
          p.update(() => {
            t.$getRoot().isEmpty() && _(p);
          }, d);
      }
    }
  }
  return tu.LexicalComposer = function({ initialConfig: p, children: _ }) {
    let E = n.useMemo(() => {
      const { theme: T, namespace: S, editor__DEPRECATED: w, nodes: O, onError: m, editorState: v, html: I } = p, G = e.createLexicalComposerContext(null, T);
      let k = w || null;
      if (k === null) {
        const P = t.createEditor({ editable: p.editable, html: I, namespace: S, nodes: O, onError: (H) => m(H, P), theme: T });
        f(P, v), k = P;
      }
      return [k, G];
    }, []);
    return l(() => {
      let T = p.editable, [S] = E;
      S.setEditable(T !== void 0 ? T : !0);
    }, []), n.createElement(
      e.LexicalComposerContext.Provider,
      { value: E },
      _
    );
  }, tu;
}
const PN = process.env.NODE_ENV === "development" ? IN() : kN();
var $N = PN, nu = {}, ru, kf;
function FN() {
  if (kf) return ru;
  kf = 1;
  var e = qn(), t = xn, l = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function d(_) {
    const [E] = e.useLexicalComposerContext(), T = t.useMemo(() => _(E), [E, _]), S = t.useRef(T.initialValueFn()), [w, O] = t.useState(S.current);
    return l(() => {
      const {
        initialValueFn: m,
        subscribe: v
      } = T, I = m();
      return S.current !== I && (S.current = I, O(I)), v((G) => {
        S.current = G, O(G);
      });
    }, [T, _]), w;
  }
  function f(_) {
    return {
      initialValueFn: () => _.isEditable(),
      subscribe: (E) => _.registerEditableListener(E)
    };
  }
  function p() {
    return d(f);
  }
  return ru = p, ru;
}
var iu, Pf;
function BN() {
  if (Pf) return iu;
  Pf = 1;
  var e = qn(), t = xn, n = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function r(d) {
    let [f] = e.useLexicalComposerContext(), p = t.useMemo(() => d(f), [f, d]), _ = t.useRef(p.initialValueFn()), [E, T] = t.useState(_.current);
    return n(() => {
      let { initialValueFn: S, subscribe: w } = p, O = S();
      return _.current !== O && (_.current = O, T(O)), w((m) => {
        _.current = m, T(m);
      });
    }, [p, d]), E;
  }
  function l(d) {
    return { initialValueFn: () => d.isEditable(), subscribe: (f) => d.registerEditableListener(f) };
  }
  return iu = function() {
    return r(l);
  }, iu;
}
var su, $f;
function Cp() {
  return $f || ($f = 1, su = process.env.NODE_ENV === "development" ? FN() : BN()), su;
}
var Qi = {}, Ff;
function HN() {
  if (Ff) return Qi;
  Ff = 1;
  var e = Yt();
  function t(_, E) {
    let T = _.getFirstChild(), S = 0;
    e: for (; T !== null; ) {
      if (e.$isElementNode(T)) {
        const m = T.getFirstChild();
        if (m !== null) {
          T = m;
          continue;
        }
      } else if (e.$isTextNode(T)) {
        const m = T.getTextContentSize();
        if (S + m > E)
          return {
            node: T,
            offset: E - S
          };
        S += m;
      }
      const w = T.getNextSibling();
      if (w !== null) {
        T = w;
        continue;
      }
      let O = T.getParent();
      for (; O !== null; ) {
        const m = O.getNextSibling();
        if (m !== null) {
          T = m;
          continue e;
        }
        O = O.getParent();
      }
      break;
    }
    return null;
  }
  function n(_, E = !0) {
    if (_)
      return !1;
    let T = l();
    return E && (T = T.trim()), T === "";
  }
  function r(_, E) {
    return () => n(_, E);
  }
  function l() {
    return e.$getRoot().getTextContent();
  }
  function d(_) {
    if (!n(_, !1))
      return !1;
    const T = e.$getRoot().getChildren(), S = T.length;
    if (S > 1)
      return !1;
    for (let w = 0; w < S; w++) {
      const O = T[w];
      if (e.$isDecoratorNode(O))
        return !1;
      if (e.$isElementNode(O)) {
        if (!e.$isParagraphNode(O) || O.__indent !== 0)
          return !1;
        const m = O.getChildren(), v = m.length;
        for (let I = 0; I < v; I++) {
          const G = m[w];
          if (!e.$isTextNode(G))
            return !1;
        }
      }
    }
    return !0;
  }
  function f(_) {
    return () => d(_);
  }
  function p(_, E, T, S) {
    const w = (P) => P instanceof T, O = (P) => {
      const H = e.$createTextNode(P.getTextContent());
      H.setFormat(P.getFormat()), P.replace(H);
    }, m = (P) => P.getLatest().__mode, v = (P) => {
      if (!P.isSimpleText())
        return;
      const H = P.getPreviousSibling();
      let j = P.getTextContent(), re = P, te;
      if (e.$isTextNode(H)) {
        const ce = H.getTextContent(), V = ce + j, z = E(V);
        if (w(H))
          if (z === null || m(H) !== 0) {
            O(H);
            return;
          } else {
            const q = z.end - ce.length;
            if (q > 0) {
              const Te = j.slice(0, q), Se = ce + Te;
              if (H.select(), H.setTextContent(Se), q === j.length)
                P.remove();
              else {
                const Ee = j.slice(q);
                P.setTextContent(Ee);
              }
              return;
            }
          }
        else if (z === null || z.start < ce.length)
          return;
      }
      for (; ; ) {
        te = E(j);
        let ce = te === null ? "" : j.slice(te.end);
        if (j = ce, ce === "") {
          const q = re.getNextSibling();
          if (e.$isTextNode(q)) {
            ce = re.getTextContent() + q.getTextContent();
            const Te = E(ce);
            if (Te === null) {
              w(q) ? O(q) : q.markDirty();
              return;
            } else if (Te.start !== 0)
              return;
          }
        } else {
          const q = E(ce);
          if (q !== null && q.start === 0)
            return;
        }
        if (te === null)
          return;
        if (te.start === 0 && e.$isTextNode(H) && H.isTextEntity())
          continue;
        let V;
        te.start === 0 ? [V, re] = re.splitText(te.end) : [, V, re] = re.splitText(te.start, te.end);
        const z = S(V);
        if (z.setFormat(V.getFormat()), V.replace(z), re == null)
          return;
      }
    }, I = (P) => {
      const H = P.getTextContent(), j = E(H);
      if (j === null || j.start !== 0) {
        O(P);
        return;
      }
      if (H.length > j.end) {
        P.splitText(j.end);
        return;
      }
      const re = P.getPreviousSibling();
      e.$isTextNode(re) && re.isTextEntity() && (O(re), O(P));
      const te = P.getNextSibling();
      e.$isTextNode(te) && te.isTextEntity() && (O(te), w(P) && O(P));
    }, G = _.registerNodeTransform(e.TextNode, v), k = _.registerNodeTransform(T, I);
    return [G, k];
  }
  return Qi.$canShowPlaceholder = d, Qi.$canShowPlaceholderCurry = f, Qi.$findTextIntersectionFromCharacters = t, Qi.$isRootTextContentEmpty = n, Qi.$isRootTextContentEmptyCurry = r, Qi.$rootTextContent = l, Qi.registerLexicalTextEntity = p, Qi;
}
var es = {}, Bf;
function WN() {
  if (Bf) return es;
  Bf = 1;
  var e = Yt();
  function t(l, d = !0) {
    return l ? !1 : (l = n(), d && (l = l.trim()), l === "");
  }
  function n() {
    return e.$getRoot().getTextContent();
  }
  function r(l) {
    if (!t(l, !1)) return !1;
    l = e.$getRoot().getChildren();
    let d = l.length;
    if (1 < d) return !1;
    for (let p = 0; p < d; p++) {
      var f = l[p];
      if (e.$isDecoratorNode(f)) return !1;
      if (e.$isElementNode(f)) {
        if (!e.$isParagraphNode(f) || f.__indent !== 0) return !1;
        f = f.getChildren();
        let _ = f.length;
        for (let E = 0; E < _; E++) if (!e.$isTextNode(f[p])) return !1;
      }
    }
    return !0;
  }
  return es.$canShowPlaceholder = r, es.$canShowPlaceholderCurry = function(l) {
    return () => r(l);
  }, es.$findTextIntersectionFromCharacters = function(l, d) {
    var f = l.getFirstChild();
    l = 0;
    e: for (; f !== null; ) {
      if (e.$isElementNode(f)) {
        var p = f.getFirstChild();
        if (p !== null) {
          f = p;
          continue;
        }
      } else if (e.$isTextNode(f)) {
        if (p = f.getTextContentSize(), l + p > d) return { node: f, offset: d - l };
        l += p;
      }
      if (p = f.getNextSibling(), p !== null) f = p;
      else {
        for (f = f.getParent(); f !== null; ) {
          if (p = f.getNextSibling(), p !== null) {
            f = p;
            continue e;
          }
          f = f.getParent();
        }
        break;
      }
    }
    return null;
  }, es.$isRootTextContentEmpty = t, es.$isRootTextContentEmptyCurry = function(l, d) {
    return () => t(l, d);
  }, es.$rootTextContent = n, es.registerLexicalTextEntity = function(l, d, f, p) {
    let _ = (T) => {
      const S = e.$createTextNode(T.getTextContent());
      S.setFormat(T.getFormat()), T.replace(S);
    }, E = l.registerNodeTransform(e.TextNode, (T) => {
      if (T.isSimpleText()) {
        var S = T.getPreviousSibling(), w = T.getTextContent(), O = T;
        if (e.$isTextNode(S)) {
          var m = S.getTextContent(), v = d(m + w);
          if (S instanceof f) {
            if (v === null || S.getLatest().__mode !== 0) {
              _(S);
              return;
            }
            if (v = v.end - m.length, 0 < v) {
              O = w.slice(0, v), O = m + O, S.select(), S.setTextContent(O), v === w.length ? T.remove() : (S = w.slice(v), T.setTextContent(S));
              return;
            }
          } else if (v === null || v.start < m.length) return;
        }
        for (; ; ) {
          if (T = d(w), w = v = T === null ? "" : w.slice(T.end), v === "") {
            if (m = O.getNextSibling(), e.$isTextNode(m)) {
              if (v = O.getTextContent() + m.getTextContent(), v = d(v), v === null) {
                m instanceof f ? _(m) : m.markDirty();
                break;
              } else if (v.start !== 0) break;
            }
          } else if (m = d(v), m !== null && m.start === 0) break;
          if (T === null) break;
          if (T.start === 0 && e.$isTextNode(S) && S.isTextEntity()) continue;
          let I;
          if (T.start === 0 ? [I, O] = O.splitText(T.end) : [, I, O] = O.splitText(T.start, T.end), T = p(I), T.setFormat(I.getFormat()), I.replace(T), O == null) break;
        }
      }
    });
    return l = l.registerNodeTransform(f, (T) => {
      var S = T.getTextContent();
      const w = d(S);
      w === null || w.start !== 0 ? _(T) : S.length > w.end ? T.splitText(w.end) : (S = T.getPreviousSibling(), e.$isTextNode(S) && S.isTextEntity() && (_(S), _(T)), S = T.getNextSibling(), e.$isTextNode(S) && S.isTextEntity() && (_(S), T instanceof f && _(T)));
    }), [E, l];
  }, es;
}
var ou, Hf;
function Ep() {
  return Hf || (Hf = 1, ou = process.env.NODE_ENV === "development" ? HN() : WN()), ou;
}
var Sn = {}, jn = {}, Wf;
function KN() {
  if (Wf) return jn;
  Wf = 1;
  var e = Yt();
  const t = /* @__PURE__ */ new Map();
  function n(K) {
    let D = K;
    for (; D != null; ) {
      if (D.nodeType === Node.TEXT_NODE)
        return D;
      D = D.firstChild;
    }
    return null;
  }
  function r(K) {
    const D = K.parentNode;
    if (D == null)
      throw new Error("Should never happen");
    return [D, Array.from(D.childNodes).indexOf(K)];
  }
  function l(K, D, Z, oe, Y) {
    const W = D.getKey(), J = oe.getKey(), R = document.createRange();
    let U = K.getElementByKey(W), X = K.getElementByKey(J), fe = Z, _e = Y;
    if (e.$isTextNode(D) && (U = n(U)), e.$isTextNode(oe) && (X = n(X)), D === void 0 || oe === void 0 || U === null || X === null)
      return null;
    U.nodeName === "BR" && ([U, fe] = r(U)), X.nodeName === "BR" && ([X, _e] = r(X));
    const B = U.firstChild;
    U === X && B != null && B.nodeName === "BR" && fe === 0 && _e === 0 && (_e = 1);
    try {
      R.setStart(U, fe), R.setEnd(X, _e);
    } catch {
      return null;
    }
    return R.collapsed && (fe !== _e || W !== J) && (R.setStart(X, _e), R.setEnd(U, fe)), R;
  }
  function d(K, D) {
    const Z = K.getRootElement();
    if (Z === null)
      return [];
    const oe = Z.getBoundingClientRect(), Y = getComputedStyle(Z), W = parseFloat(Y.paddingLeft) + parseFloat(Y.paddingRight), J = Array.from(D.getClientRects());
    let R = J.length;
    J.sort((X, fe) => {
      const _e = X.top - fe.top;
      return Math.abs(_e) <= 3 ? X.left - fe.left : _e;
    });
    let U;
    for (let X = 0; X < R; X++) {
      const fe = J[X], _e = U && U.top <= fe.top && U.top + U.height > fe.top && U.left + U.width > fe.left, B = fe.width + W === oe.width;
      if (_e || B) {
        J.splice(X--, 1), R--;
        continue;
      }
      U = fe;
    }
    return J;
  }
  function f(K) {
    const D = {}, Z = K.split(";");
    for (const oe of Z)
      if (oe !== "") {
        const [Y, W] = oe.split(/:([^]+)/);
        Y && W && (D[Y.trim()] = W.trim());
      }
    return D;
  }
  function p(K) {
    let D = t.get(K);
    return D === void 0 && (D = f(K), t.set(K, D)), Object.freeze(D), D;
  }
  function _(K) {
    let D = "";
    for (const Z in K)
      Z && (D += `${Z}: ${K[Z]};`);
    return D;
  }
  function E(K, D) {
    return K.__first = D.__first, K.__last = D.__last, K.__size = D.__size, K.__format = D.__format, K.__indent = D.__indent, K.__dir = D.__dir, K;
  }
  function T(K, D) {
    return K.__format = D.__format, K.__style = D.__style, K.__mode = D.__mode, K.__detail = D.__detail, K;
  }
  function S(K) {
    const Z = K.constructor.clone(K);
    return Z.__parent = K.__parent, Z.__next = K.__next, Z.__prev = K.__prev, e.$isElementNode(K) && e.$isElementNode(Z) ? E(Z, K) : e.$isTextNode(K) && e.$isTextNode(Z) ? T(Z, K) : Z;
  }
  function w(K, D) {
    if (D.isSelected(K) && !D.isSegmented() && !D.isToken() && e.$INTERNAL_isPointSelection(K)) {
      const Z = K.anchor.getNode(), oe = K.focus.getNode(), Y = D.is(Z), W = D.is(oe);
      if (Y || W) {
        const J = K.isBackward(), [R, U] = K.getCharacterOffsets(), X = Z.is(oe), fe = D.is(J ? oe : Z), _e = D.is(J ? Z : oe);
        let B = 0, M;
        if (X)
          B = R > U ? U : R, M = R > U ? R : U;
        else if (fe)
          B = J ? U : R, M = void 0;
        else if (_e) {
          const F = J ? R : U;
          B = 0, M = F;
        }
        return D.__text = D.__text.slice(B, M), D;
      }
    }
    return D;
  }
  function O(K) {
    if (K.type === "text")
      return K.offset === K.getNode().getTextContentSize();
    const D = K.getNode();
    if (!e.$isElementNode(D))
      throw Error("isAtNodeEnd: node must be a TextNode or ElementNode");
    return K.offset === D.getChildrenSize();
  }
  function m(K, D, Z) {
    let oe = D.getNode(), Y = Z;
    if (e.$isElementNode(oe)) {
      const W = oe.getDescendantByIndex(D.offset);
      W !== null && (oe = W);
    }
    for (; Y > 0 && oe !== null; ) {
      if (e.$isElementNode(oe)) {
        const X = oe.getLastDescendant();
        X !== null && (oe = X);
      }
      let W = oe.getPreviousSibling(), J = 0;
      if (W === null) {
        let X = oe.getParentOrThrow(), fe = X.getPreviousSibling();
        for (; fe === null; ) {
          if (X = X.getParent(), X === null) {
            W = null;
            break;
          }
          fe = X.getPreviousSibling();
        }
        X !== null && (J = X.isInline() ? 0 : 2, W = fe);
      }
      let R = oe.getTextContent();
      R === "" && e.$isElementNode(oe) && !oe.isInline() && (R = `

`);
      const U = R.length;
      if (!e.$isTextNode(oe) || Y >= U) {
        const X = oe.getParent();
        oe.remove(), X != null && X.getChildrenSize() === 0 && !e.$isRootNode(X) && X.remove(), Y -= U + J, oe = W;
      } else {
        const X = oe.getKey(), fe = K.getEditorState().read(() => {
          const M = e.$getNodeByKey(X);
          return e.$isTextNode(M) && M.isSimpleText() ? M.getTextContent() : null;
        }), _e = U - Y, B = R.slice(0, _e);
        if (fe !== null && fe !== R) {
          const M = e.$getPreviousSelection();
          let F = oe;
          if (oe.isSimpleText())
            oe.setTextContent(fe);
          else {
            const se = e.$createTextNode(fe);
            oe.replace(se), F = se;
          }
          if (e.$isRangeSelection(M) && M.isCollapsed()) {
            const se = M.anchor.offset;
            F.select(se, se);
          }
        } else if (oe.isSimpleText()) {
          const M = D.key === X;
          let F = D.offset;
          F < Y && (F = U);
          const se = M ? F - Y : 0, ye = M ? F : _e;
          if (M && se === 0) {
            const [De] = oe.splitText(se, ye);
            De.remove();
          } else {
            const [, De] = oe.splitText(se, ye);
            De.remove();
          }
        } else {
          const M = e.$createTextNode(B);
          oe.replace(M);
        }
        Y = 0;
      }
    }
  }
  function v(K) {
    const D = K.getStyle(), Z = f(D);
    t.set(D, Z);
  }
  function I(K, D) {
    const Z = p("getStyle" in K ? K.getStyle() : K.style), oe = Object.entries(D).reduce((W, [J, R]) => (R === null ? delete W[J] : W[J] = R, W), {
      ...Z
    }), Y = _(oe);
    K.setStyle(Y), t.set(Y, oe);
  }
  function G(K, D) {
    const Z = K.getNodes(), oe = Z.length;
    if (!e.$isRangeSelection(K)) {
      const ne = e.$createRangeSelection(), ue = ne.anchor, be = ne.focus;
      for (let Ne = 0; Ne < oe; Ne++) {
        const Re = Z[Ne];
        e.DEPRECATED_$isGridCellNode(Re) && (ue.set(Re.getKey(), 0, "element"), be.set(Re.getKey(), Re.getChildrenSize(), "element"), G(e.$normalizeSelection__EXPERIMENTAL(ne), D));
      }
      e.$setSelection(K);
      return;
    }
    const Y = oe - 1;
    let W = Z[0], J = Z[Y];
    if (K.isCollapsed() && e.$isRangeSelection(K)) {
      I(K, D);
      return;
    }
    const R = K.anchor, U = K.focus, fe = W.getTextContent().length, _e = U.offset;
    let B = R.offset;
    const M = R.isBefore(U);
    let F = M ? B : _e, se = M ? _e : B;
    const ye = M ? R.type : U.type, De = M ? U.type : R.type, ee = M ? U.key : R.key;
    if (e.$isTextNode(W) && F === fe) {
      const ne = W.getNextSibling();
      e.$isTextNode(ne) && (B = 0, F = 0, W = ne);
    }
    if (Z.length === 1) {
      if (e.$isTextNode(W)) {
        if (F = ye === "element" ? 0 : B > _e ? _e : B, se = De === "element" ? fe : B > _e ? B : _e, F === se)
          return;
        if (F === 0 && se === fe)
          I(W, D), W.select(F, se);
        else {
          const ne = W.splitText(F, se), ue = F === 0 ? ne[0] : ne[1];
          I(ue, D), ue.select(0, se - F);
        }
      }
    } else {
      if (e.$isTextNode(W) && F < W.getTextContentSize() && (F !== 0 && (W = W.splitText(F)[1], F = 0, R.set(W.getKey(), F, "text")), I(W, D)), e.$isTextNode(J)) {
        const ue = J.getTextContent().length;
        J.__key !== ee && se !== 0 && (se = ue), se !== ue && ([J] = J.splitText(se)), se !== 0 && I(J, D);
      }
      for (let ne = 1; ne < Y; ne++) {
        const ue = Z[ne], be = ue.getKey();
        e.$isTextNode(ue) && be !== W.getKey() && be !== J.getKey() && !ue.isToken() && I(ue, D);
      }
    }
  }
  function k(K, D) {
    if (K.anchor.key === "root") {
      const Y = D(), W = e.$getRoot(), J = W.getFirstChild();
      J ? J.replace(Y, !0) : W.append(Y);
      return;
    }
    const Z = K.getNodes(), oe = de(K.anchor.getNode(), Ee);
    oe && Z.indexOf(oe) === -1 && Z.push(oe);
    for (let Y = 0; Y < Z.length; Y++) {
      const W = Z[Y];
      if (!Ee(W))
        continue;
      if (!e.$isElementNode(W))
        throw Error("Expected block node to be an ElementNode");
      const J = D();
      J.setFormat(W.getFormatType()), J.setIndent(W.getIndent()), W.replace(J, !0);
    }
  }
  function P(K) {
    return K.getNode().isAttached();
  }
  function H(K) {
    let D = K;
    for (; D !== null && !e.$isRootOrShadowRoot(D); ) {
      const Z = D.getLatest(), oe = D.getParent();
      Z.getChildrenSize() === 0 && D.remove(!0), D = oe;
    }
  }
  function j(K, D, Z = null) {
    const oe = K.getNodes(), Y = oe.length, W = K.anchor;
    if (Y === 0 || Y === 1 && W.type === "element" && W.getNode().getChildrenSize() === 0) {
      const U = W.type === "text" ? W.getNode().getParentOrThrow() : W.getNode(), X = U.getChildren();
      let fe = D();
      fe.setFormat(U.getFormatType()), fe.setIndent(U.getIndent()), X.forEach((_e) => fe.append(_e)), Z && (fe = Z.append(fe)), U.replace(fe);
      return;
    }
    let J = null, R = [];
    for (let U = 0; U < Y; U++) {
      const X = oe[U];
      e.$isRootOrShadowRoot(X) ? (re(K, R, R.length, D, Z), R = [], J = X) : J === null || J !== null && e.$hasAncestor(X, J) ? R.push(X) : (re(K, R, R.length, D, Z), R = [X]);
    }
    re(K, R, R.length, D, Z);
  }
  function re(K, D, Z, oe, Y = null) {
    if (D.length === 0)
      return;
    const W = D[0], J = /* @__PURE__ */ new Map(), R = [];
    let U = e.$isElementNode(W) ? W : W.getParentOrThrow();
    U.isInline() && (U = U.getParentOrThrow());
    let X = !1;
    for (; U !== null; ) {
      const F = U.getPreviousSibling();
      if (F !== null) {
        U = F, X = !0;
        break;
      }
      if (U = U.getParentOrThrow(), e.$isRootOrShadowRoot(U))
        break;
    }
    const fe = /* @__PURE__ */ new Set();
    for (let F = 0; F < Z; F++) {
      const se = D[F];
      e.$isElementNode(se) && se.getChildrenSize() === 0 && fe.add(se.getKey());
    }
    const _e = /* @__PURE__ */ new Set();
    for (let F = 0; F < Z; F++) {
      const se = D[F];
      let ye = se.getParent();
      if (ye !== null && ye.isInline() && (ye = ye.getParent()), ye !== null && e.$isLeafNode(se) && !_e.has(se.getKey())) {
        const De = ye.getKey();
        if (J.get(De) === void 0) {
          const ee = oe();
          ee.setFormat(ye.getFormatType()), ee.setIndent(ye.getIndent()), R.push(ee), J.set(De, ee), ye.getChildren().forEach((ne) => {
            ee.append(ne), _e.add(ne.getKey()), e.$isElementNode(ne) && ne.getChildrenKeys().forEach((ue) => _e.add(ue));
          }), H(ye);
        }
      } else if (fe.has(se.getKey())) {
        if (!e.$isElementNode(se))
          throw Error("Expected node in emptyElements to be an ElementNode");
        const De = oe();
        De.setFormat(se.getFormatType()), De.setIndent(se.getIndent()), R.push(De), se.remove(!0);
      }
    }
    if (Y !== null)
      for (let F = 0; F < R.length; F++) {
        const se = R[F];
        Y.append(se);
      }
    let B = null;
    if (e.$isRootOrShadowRoot(U))
      if (X)
        if (Y !== null)
          U.insertAfter(Y);
        else
          for (let F = R.length - 1; F >= 0; F--) {
            const se = R[F];
            U.insertAfter(se);
          }
      else {
        const F = U.getFirstChild();
        if (e.$isElementNode(F) && (U = F), F === null)
          if (Y)
            U.append(Y);
          else
            for (let se = 0; se < R.length; se++) {
              const ye = R[se];
              U.append(ye), B = ye;
            }
        else if (Y !== null)
          F.insertBefore(Y);
        else
          for (let se = 0; se < R.length; se++) {
            const ye = R[se];
            F.insertBefore(ye), B = ye;
          }
      }
    else if (Y)
      U.insertAfter(Y);
    else
      for (let F = R.length - 1; F >= 0; F--) {
        const se = R[F];
        U.insertAfter(se), B = se;
      }
    const M = e.$getPreviousSelection();
    e.$isRangeSelection(M) && P(M.anchor) && P(M.focus) ? e.$setSelection(M.clone()) : B !== null ? B.selectEnd() : K.dirty = !0;
  }
  function te(K, D) {
    const Z = e.$getAdjacentNode(K.focus, D);
    return e.$isDecoratorNode(Z) && !Z.isIsolated() || e.$isElementNode(Z) && !Z.isInline() && !Z.canBeEmpty();
  }
  function ce(K, D, Z, oe) {
    K.modify(D ? "extend" : "move", Z, oe);
  }
  function V(K) {
    const D = K.anchor.getNode();
    return (e.$isRootNode(D) ? D : D.getParentOrThrow()).getDirection() === "rtl";
  }
  function z(K, D, Z) {
    const oe = V(K);
    ce(K, D, Z ? !oe : oe, "character");
  }
  function q(K) {
    const D = K.anchor, Z = K.focus, W = D.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let J = W.getFirstDescendant(), R = W.getLastDescendant(), U = "element", X = "element", fe = 0;
    e.$isTextNode(J) ? U = "text" : !e.$isElementNode(J) && J !== null && (J = J.getParentOrThrow()), e.$isTextNode(R) ? (X = "text", fe = R.getTextContentSize()) : !e.$isElementNode(R) && R !== null && (R = R.getParentOrThrow()), J && R && (D.set(J.getKey(), 0, U), Z.set(R.getKey(), fe, X));
  }
  function Te(K, D, Z) {
    const oe = K.getStyle(), Y = p(oe);
    return Y !== null && Y[D] || Z;
  }
  function Se(K, D, Z = "") {
    let oe = null;
    const Y = K.getNodes(), W = K.anchor, J = K.focus, R = K.isBackward(), U = R ? J.offset : W.offset, X = R ? J.getNode() : W.getNode();
    if (K.isCollapsed() && K.style !== "") {
      const fe = K.style, _e = p(fe);
      if (_e !== null && D in _e)
        return _e[D];
    }
    for (let fe = 0; fe < Y.length; fe++) {
      const _e = Y[fe];
      if (!(fe !== 0 && U === 0 && _e.is(X)) && e.$isTextNode(_e)) {
        const B = Te(_e, D, Z);
        if (oe === null)
          oe = B;
        else if (oe !== B) {
          oe = "";
          break;
        }
      }
    }
    return oe === null ? Z : oe;
  }
  function Ee(K) {
    if (e.$isDecoratorNode(K) && !K.isInline())
      return !0;
    if (!e.$isElementNode(K) || e.$isRootOrShadowRoot(K))
      return !1;
    const D = K.getFirstChild(), Z = D === null || e.$isLineBreakNode(D) || e.$isTextNode(D) || D.isInline();
    return !K.isInline() && K.canBeEmpty() !== !1 && Z;
  }
  function de(K, D) {
    let Z = K;
    for (; Z !== null && Z.getParent() !== null && !D(Z); )
      Z = Z.getParentOrThrow();
    return D(Z) ? Z : null;
  }
  return jn.$addNodeStyle = v, jn.$cloneWithProperties = S, jn.$getSelectionStyleValueForProperty = Se, jn.$isAtNodeEnd = O, jn.$isParentElementRTL = V, jn.$moveCaretSelection = ce, jn.$moveCharacter = z, jn.$patchStyleText = G, jn.$selectAll = q, jn.$setBlocksType = k, jn.$shouldOverrideDefaultCharacterSelection = te, jn.$sliceSelectedTextNodeContent = w, jn.$wrapNodes = j, jn.createDOMRange = l, jn.createRectsFromDOMRange = d, jn.getStyleObjectFromCSS = p, jn.trimTextContentFromAnchor = m, jn;
}
var Vn = {}, Kf;
function zN() {
  if (Kf) return Vn;
  Kf = 1;
  var e = Yt();
  let t = /* @__PURE__ */ new Map();
  function n(m) {
    for (; m != null; ) {
      if (m.nodeType === Node.TEXT_NODE) return m;
      m = m.firstChild;
    }
    return null;
  }
  function r(m) {
    let v = m.parentNode;
    if (v == null) throw Error("Should never happen");
    return [v, Array.from(v.childNodes).indexOf(m)];
  }
  function l(m) {
    let v = {};
    m = m.split(";");
    for (let I of m) if (I !== "") {
      let [G, k] = I.split(/:([^]+)/);
      G && k && (v[G.trim()] = k.trim());
    }
    return v;
  }
  function d(m) {
    let v = t.get(m);
    return v === void 0 && (v = l(m), t.set(m, v)), v;
  }
  function f(m) {
    let v = "";
    for (let I in m) I && (v += `${I}: ${m[I]};`);
    return v;
  }
  function p(m, v) {
    var I = d("getStyle" in m ? m.getStyle() : m.style);
    v = Object.entries(v).reduce((G, [k, P]) => (P === null ? delete G[k] : G[k] = P, G), { ...I }), I = f(v), m.setStyle(I), t.set(I, v);
  }
  function _(m, v) {
    var I = m.getNodes(), G = I.length;
    if (e.$isRangeSelection(m)) {
      --G;
      var k = I[0], P = I[G];
      if (m.isCollapsed() && e.$isRangeSelection(m)) p(m, v);
      else {
        var H = m.anchor, j = m.focus, re = k.getTextContent().length, te = j.offset, ce = H.offset, V = H.isBefore(j), z = V ? ce : te;
        m = V ? te : ce;
        var q = V ? H.type : j.type, Te = V ? j.type : H.type;
        if (j = V ? j.key : H.key, e.$isTextNode(k) && z === re && (V = k.getNextSibling(), e.$isTextNode(V) && (z = ce = 0, k = V)), I.length === 1) e.$isTextNode(k) && (z = q === "element" ? 0 : ce > te ? te : ce, m = Te === "element" ? re : ce > te ? ce : te, z !== m && (z === 0 && m === re ? (p(
          k,
          v
        ), k.select(z, m)) : (I = k.splitText(z, m), I = z === 0 ? I[0] : I[1], p(I, v), I.select(0, m - z))));
        else for (e.$isTextNode(k) && z < k.getTextContentSize() && (z !== 0 && (k = k.splitText(z)[1], z = 0, H.set(k.getKey(), z, "text")), p(k, v)), e.$isTextNode(P) && (z = P.getTextContent().length, P.__key !== j && m !== 0 && (m = z), m !== z && ([P] = P.splitText(m)), m !== 0 && p(P, v)), m = 1; m < G; m++) z = I[m], H = z.getKey(), e.$isTextNode(z) && H !== k.getKey() && H !== P.getKey() && !z.isToken() && p(z, v);
      }
    } else {
      for (k = e.$createRangeSelection(), P = k.anchor, z = k.focus, H = 0; H < G; H++) re = I[H], e.DEPRECATED_$isGridCellNode(re) && (P.set(re.getKey(), 0, "element"), z.set(re.getKey(), re.getChildrenSize(), "element"), _(e.$normalizeSelection__EXPERIMENTAL(k), v));
      e.$setSelection(m);
    }
  }
  function E(m) {
    for (; m !== null && !e.$isRootOrShadowRoot(m); ) {
      let v = m.getLatest(), I = m.getParent();
      v.getChildrenSize() === 0 && m.remove(!0), m = I;
    }
  }
  function T(m, v, I, G, k = null) {
    if (v.length !== 0) {
      var P = v[0], H = /* @__PURE__ */ new Map(), j = [];
      P = e.$isElementNode(P) ? P : P.getParentOrThrow(), P.isInline() && (P = P.getParentOrThrow());
      for (var re = !1; P !== null; ) {
        var te = P.getPreviousSibling();
        if (te !== null) {
          P = te, re = !0;
          break;
        }
        if (P = P.getParentOrThrow(), e.$isRootOrShadowRoot(P)) break;
      }
      te = /* @__PURE__ */ new Set();
      for (var ce = 0; ce < I; ce++) {
        var V = v[ce];
        e.$isElementNode(V) && V.getChildrenSize() === 0 && te.add(V.getKey());
      }
      var z = /* @__PURE__ */ new Set();
      for (ce = 0; ce < I; ce++) {
        V = v[ce];
        var q = V.getParent();
        if (q !== null && q.isInline() && (q = q.getParent()), q !== null && e.$isLeafNode(V) && !z.has(V.getKey())) {
          if (V = q.getKey(), H.get(V) === void 0) {
            let Te = G();
            Te.setFormat(q.getFormatType()), Te.setIndent(q.getIndent()), j.push(Te), H.set(V, Te), q.getChildren().forEach((Se) => {
              Te.append(Se), z.add(Se.getKey()), e.$isElementNode(Se) && Se.getChildrenKeys().forEach((Ee) => z.add(Ee));
            }), E(q);
          }
        } else if (te.has(V.getKey())) {
          if (!e.$isElementNode(V)) throw Error("Expected node in emptyElements to be an ElementNode");
          q = G(), q.setFormat(V.getFormatType()), q.setIndent(V.getIndent()), j.push(q), V.remove(!0);
        }
      }
      if (k !== null) for (v = 0; v < j.length; v++) k.append(j[v]);
      if (v = null, e.$isRootOrShadowRoot(P)) if (re) if (k !== null) P.insertAfter(k);
      else for (k = j.length - 1; 0 <= k; k--) P.insertAfter(j[k]);
      else if (re = P.getFirstChild(), e.$isElementNode(re) && (P = re), re === null) if (k) P.append(k);
      else for (k = 0; k < j.length; k++) re = j[k], P.append(re), v = re;
      else if (k !== null) re.insertBefore(k);
      else for (P = 0; P < j.length; P++) k = j[P], re.insertBefore(k), v = k;
      else if (k) P.insertAfter(k);
      else for (k = j.length - 1; 0 <= k; k--) re = j[k], P.insertAfter(re), v = re;
      j = e.$getPreviousSelection(), e.$isRangeSelection(j) && j.anchor.getNode().isAttached() && j.focus.getNode().isAttached() ? e.$setSelection(j.clone()) : v !== null ? v.selectEnd() : m.dirty = !0;
    }
  }
  function S(m, v, I, G) {
    m.modify(v ? "extend" : "move", I, G);
  }
  function w(m) {
    return m = m.anchor.getNode(), (e.$isRootNode(m) ? m : m.getParentOrThrow()).getDirection() === "rtl";
  }
  function O(m) {
    if (e.$isDecoratorNode(m) && !m.isInline()) return !0;
    if (!e.$isElementNode(m) || e.$isRootOrShadowRoot(m)) return !1;
    var v = m.getFirstChild();
    return v = v === null || e.$isLineBreakNode(v) || e.$isTextNode(v) || v.isInline(), !m.isInline() && m.canBeEmpty() !== !1 && v;
  }
  return Vn.$addNodeStyle = function(m) {
    m = m.getStyle();
    let v = l(m);
    t.set(m, v);
  }, Vn.$cloneWithProperties = function(m) {
    let v = m.constructor.clone(m);
    return v.__parent = m.__parent, v.__next = m.__next, v.__prev = m.__prev, e.$isElementNode(m) && e.$isElementNode(v) ? (v.__first = m.__first, v.__last = m.__last, v.__size = m.__size, v.__format = m.__format, v.__indent = m.__indent, v.__dir = m.__dir, v) : (e.$isTextNode(m) && e.$isTextNode(v) && (v.__format = m.__format, v.__style = m.__style, v.__mode = m.__mode, v.__detail = m.__detail), v);
  }, Vn.$getSelectionStyleValueForProperty = function(m, v, I = "") {
    let G = null, k = m.getNodes();
    var P = m.anchor, H = m.focus, j = m.isBackward();
    let re = j ? H.offset : P.offset;
    if (P = j ? H.getNode() : P.getNode(), m.isCollapsed() && m.style !== "" && (m = d(m.style), m !== null && v in m)) return m[v];
    for (m = 0; m < k.length; m++) {
      var te = k[m];
      if ((m === 0 || re !== 0 || !te.is(P)) && e.$isTextNode(te)) {
        if (H = v, j = I, te = te.getStyle(), te = d(te), H = te !== null && te[H] || j, G === null) G = H;
        else if (G !== H) {
          G = "";
          break;
        }
      }
    }
    return G === null ? I : G;
  }, Vn.$isAtNodeEnd = function(m) {
    if (m.type === "text") return m.offset === m.getNode().getTextContentSize();
    let v = m.getNode();
    if (!e.$isElementNode(v)) throw Error("isAtNodeEnd: node must be a TextNode or ElementNode");
    return m.offset === v.getChildrenSize();
  }, Vn.$isParentElementRTL = w, Vn.$moveCaretSelection = S, Vn.$moveCharacter = function(m, v, I) {
    let G = w(m);
    S(m, v, I ? !G : G, "character");
  }, Vn.$patchStyleText = _, Vn.$selectAll = function(m) {
    let v = m.anchor;
    m = m.focus;
    var I = v.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let G = I.getFirstDescendant();
    I = I.getLastDescendant();
    let k = "element", P = "element", H = 0;
    e.$isTextNode(G) ? k = "text" : e.$isElementNode(G) || G === null || (G = G.getParentOrThrow()), e.$isTextNode(I) ? (P = "text", H = I.getTextContentSize()) : e.$isElementNode(I) || I === null || (I = I.getParentOrThrow()), G && I && (v.set(G.getKey(), 0, k), m.set(I.getKey(), H, P));
  }, Vn.$setBlocksType = function(m, v) {
    if (m.anchor.key === "root") {
      v = v();
      var I = e.$getRoot();
      (m = I.getFirstChild()) ? m.replace(v, !0) : I.append(v);
    } else {
      for (I = m.getNodes(), m = m.anchor.getNode(); m !== null && m.getParent() !== null && !O(m); ) m = m.getParentOrThrow();
      for ((m = O(m) ? m : null) && I.indexOf(m) === -1 && I.push(m), m = 0; m < I.length; m++) {
        let G = I[m];
        if (!O(G)) continue;
        if (!e.$isElementNode(G)) throw Error("Expected block node to be an ElementNode");
        let k = v();
        k.setFormat(G.getFormatType()), k.setIndent(G.getIndent()), G.replace(
          k,
          !0
        );
      }
    }
  }, Vn.$shouldOverrideDefaultCharacterSelection = function(m, v) {
    return m = e.$getAdjacentNode(m.focus, v), e.$isDecoratorNode(m) && !m.isIsolated() || e.$isElementNode(m) && !m.isInline() && !m.canBeEmpty();
  }, Vn.$sliceSelectedTextNodeContent = function(m, v) {
    if (v.isSelected(m) && !v.isSegmented() && !v.isToken() && e.$INTERNAL_isPointSelection(m)) {
      var I = m.anchor.getNode(), G = m.focus.getNode(), k = v.is(I), P = v.is(G);
      if (k || P) {
        k = m.isBackward();
        let [H, j] = m.getCharacterOffsets();
        m = I.is(G), P = v.is(k ? G : I), G = v.is(k ? I : G), I = 0;
        let re;
        m ? (I = H > j ? j : H, re = H > j ? H : j) : P ? (I = k ? j : H, re = void 0) : G && (k = k ? H : j, I = 0, re = k), v.__text = v.__text.slice(I, re);
      }
    }
    return v;
  }, Vn.$wrapNodes = function(m, v, I = null) {
    var G = m.getNodes();
    let k = G.length;
    var P = m.anchor;
    if (k === 0 || k === 1 && P.type === "element" && P.getNode().getChildrenSize() === 0) {
      m = P.type === "text" ? P.getNode().getParentOrThrow() : P.getNode(), G = m.getChildren();
      let j = v();
      j.setFormat(m.getFormatType()), j.setIndent(m.getIndent()), G.forEach((re) => j.append(re)), I && (j = I.append(j)), m.replace(j);
    } else {
      P = null;
      var H = [];
      for (let j = 0; j < k; j++) {
        let re = G[j];
        e.$isRootOrShadowRoot(re) ? (T(m, H, H.length, v, I), H = [], P = re) : P === null || P !== null && e.$hasAncestor(
          re,
          P
        ) ? H.push(re) : (T(m, H, H.length, v, I), H = [re]);
      }
      T(m, H, H.length, v, I);
    }
  }, Vn.createDOMRange = function(m, v, I, G, k) {
    let P = v.getKey(), H = G.getKey(), j = document.createRange(), re = m.getElementByKey(P);
    if (m = m.getElementByKey(H), e.$isTextNode(v) && (re = n(re)), e.$isTextNode(G) && (m = n(m)), v === void 0 || G === void 0 || re === null || m === null) return null;
    re.nodeName === "BR" && ([re, I] = r(re)), m.nodeName === "BR" && ([m, k] = r(m)), v = re.firstChild, re === m && v != null && v.nodeName === "BR" && I === 0 && k === 0 && (k = 1);
    try {
      j.setStart(re, I), j.setEnd(m, k);
    } catch {
      return null;
    }
    return !j.collapsed || I === k && P === H || (j.setStart(m, k), j.setEnd(
      re,
      I
    )), j;
  }, Vn.createRectsFromDOMRange = function(m, v) {
    var I = m.getRootElement();
    if (I === null) return [];
    m = I.getBoundingClientRect(), I = getComputedStyle(I), I = parseFloat(I.paddingLeft) + parseFloat(I.paddingRight), v = Array.from(v.getClientRects());
    let G = v.length;
    v.sort((P, H) => {
      let j = P.top - H.top;
      return 3 >= Math.abs(j) ? P.left - H.left : j;
    });
    let k;
    for (let P = 0; P < G; P++) {
      let H = v[P], j = H.width + I === m.width;
      k && k.top <= H.top && k.top + k.height > H.top && k.left + k.width > H.left || j ? (v.splice(P--, 1), G--) : k = H;
    }
    return v;
  }, Vn.getStyleObjectFromCSS = d, Vn.trimTextContentFromAnchor = function(m, v, I) {
    let G = v.getNode();
    if (e.$isElementNode(G)) {
      var k = G.getDescendantByIndex(v.offset);
      k !== null && (G = k);
    }
    for (; 0 < I && G !== null; ) {
      e.$isElementNode(G) && (k = G.getLastDescendant(), k !== null && (G = k));
      var P = G.getPreviousSibling(), H = 0;
      if (P === null) {
        k = G.getParentOrThrow();
        for (var j = k.getPreviousSibling(); j === null; ) {
          if (k = k.getParent(), k === null) {
            P = null;
            break;
          }
          j = k.getPreviousSibling();
        }
        k !== null && (H = k.isInline() ? 0 : 2, P = j);
      }
      if (j = G.getTextContent(), j === "" && e.$isElementNode(G) && !G.isInline() && (j = `

`), k = j.length, !e.$isTextNode(G) || I >= k) j = G.getParent(), G.remove(), j == null || j.getChildrenSize() !== 0 || e.$isRootNode(j) || j.remove(), I -= k + H, G = P;
      else {
        let re = G.getKey();
        H = m.getEditorState().read(() => {
          const ce = e.$getNodeByKey(re);
          return e.$isTextNode(ce) && ce.isSimpleText() ? ce.getTextContent() : null;
        }), P = k - I;
        let te = j.slice(0, P);
        H !== null && H !== j ? (I = e.$getPreviousSelection(), k = G, G.isSimpleText() ? G.setTextContent(H) : (k = e.$createTextNode(H), G.replace(k)), e.$isRangeSelection(I) && I.isCollapsed() && (I = I.anchor.offset, k.select(I, I))) : G.isSimpleText() ? (H = v.key === re, j = v.offset, j < I && (j = k), I = H ? j - I : 0, k = H ? j : P, H && I === 0 ? ([I] = G.splitText(I, k), I.remove()) : ([, I] = G.splitText(I, k), I.remove())) : (I = e.$createTextNode(te), G.replace(I)), I = 0;
      }
    }
  }, Vn;
}
var lu, zf;
function vs() {
  return zf || (zf = 1, lu = process.env.NODE_ENV === "development" ? KN() : zN()), lu;
}
var Uf;
function UN() {
  if (Uf) return Sn;
  Uf = 1;
  var e = vs(), t = Yt();
  function n(...te) {
    return () => {
      te.forEach((ce) => ce());
    };
  }
  function r(te) {
    return `${te}px`;
  }
  const l = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
  };
  function d(te, ce, V) {
    let z = null, q = null, Te = null, Se = [];
    const Ee = document.createElement("div");
    function de() {
      if (z === null)
        throw Error("Unexpected null rootDOMNode");
      if (q === null)
        throw Error("Unexpected null parentDOMNode");
      const {
        left: oe,
        top: Y
      } = z.getBoundingClientRect(), W = q, J = e.createRectsFromDOMRange(te, ce);
      Ee.isConnected || W.append(Ee);
      let R = !1;
      for (let U = 0; U < J.length; U++) {
        const X = J[U], fe = Se[U] || document.createElement("div"), _e = fe.style;
        _e.position !== "absolute" && (_e.position = "absolute", R = !0);
        const B = r(X.left - oe);
        _e.left !== B && (_e.left = B, R = !0);
        const M = r(X.top - Y);
        _e.top !== M && (fe.style.top = M, R = !0);
        const F = r(X.width);
        _e.width !== F && (fe.style.width = F, R = !0);
        const se = r(X.height);
        _e.height !== se && (fe.style.height = se, R = !0), fe.parentNode !== Ee && (Ee.append(fe), R = !0), Se[U] = fe;
      }
      for (; Se.length > J.length; )
        Se.pop();
      R && V(Se);
    }
    function K() {
      q = null, z = null, Te !== null && Te.disconnect(), Te = null, Ee.remove();
      for (const oe of Se)
        oe.remove();
      Se = [];
    }
    function D() {
      const oe = te.getRootElement();
      if (oe === null)
        return K();
      const Y = oe.parentElement;
      if (!(Y instanceof HTMLElement))
        return K();
      K(), z = oe, q = Y, Te = new MutationObserver((W) => {
        const J = te.getRootElement(), R = J && J.parentElement;
        if (J !== z || R !== q)
          return D();
        for (const U of W)
          if (!Ee.contains(U.target))
            return de();
      }), Te.observe(Y, l), de();
    }
    const Z = te.registerRootListener(D);
    return () => {
      Z(), K();
    };
  }
  function f(te, ce) {
    let V = null, z = null, q = null, Te = null, Se = () => {
    };
    function Ee(de) {
      de.read(() => {
        const K = t.$getSelection();
        if (!t.$isRangeSelection(K)) {
          V = null, z = null, q = null, Te = null, Se(), Se = () => {
          };
          return;
        }
        const {
          anchor: D,
          focus: Z
        } = K, oe = D.getNode(), Y = oe.getKey(), W = D.offset, J = Z.getNode(), R = J.getKey(), U = Z.offset, X = te.getElementByKey(Y), fe = te.getElementByKey(R), _e = V === null || X === null || W !== z || Y !== V.getKey() || oe !== V && (!(V instanceof t.TextNode) || oe.updateDOM(V, X, te._config)), B = q === null || fe === null || U !== Te || R !== q.getKey() || J !== q && (!(q instanceof t.TextNode) || J.updateDOM(q, fe, te._config));
        if (_e || B) {
          const M = te.getElementByKey(D.getNode().getKey()), F = te.getElementByKey(Z.getNode().getKey());
          if (M !== null && F !== null && M.tagName === "SPAN" && F.tagName === "SPAN") {
            const se = document.createRange();
            let ye, De, ee, ne;
            Z.isBefore(D) ? (ye = F, De = Z.offset, ee = M, ne = D.offset) : (ye = M, De = D.offset, ee = F, ne = Z.offset);
            const ue = ye.firstChild;
            if (ue === null)
              throw Error("Expected text node to be first child of span");
            const be = ee.firstChild;
            if (be === null)
              throw Error("Expected text node to be first child of span");
            se.setStart(ue, De), se.setEnd(be, ne), Se(), Se = d(te, se, (Ne) => {
              for (const Re of Ne) {
                const ke = Re.style;
                ke.background !== "Highlight" && (ke.background = "Highlight"), ke.color !== "HighlightText" && (ke.color = "HighlightText"), ke.zIndex !== "-1" && (ke.zIndex = "-1"), ke.pointerEvents !== "none" && (ke.pointerEvents = "none"), ke.marginTop !== r(-1.5) && (ke.marginTop = r(-1.5)), ke.paddingTop !== r(4) && (ke.paddingTop = r(4)), ke.paddingBottom !== r(0) && (ke.paddingBottom = r(0));
              }
              ce !== void 0 && ce(Ne);
            });
          }
        }
        V = oe, z = W, q = J, Te = U;
      });
    }
    return Ee(te.getEditorState()), n(te.registerUpdateListener(({
      editorState: de
    }) => Ee(de)), Se, () => {
      Se();
    });
  }
  function p(te, ...ce) {
    ce.forEach((V) => {
      if (typeof V == "string") {
        const z = V.split(" ").filter((q) => q !== "");
        te.classList.add(...z);
      }
    });
  }
  function _(te, ...ce) {
    ce.forEach((V) => {
      typeof V == "string" && te.classList.remove(...V.split(" "));
    });
  }
  function E(te, ce) {
    for (const V of ce)
      if (te.type.startsWith(V))
        return !0;
    return !1;
  }
  function T(te, ce) {
    const V = te[Symbol.iterator]();
    return new Promise((z, q) => {
      const Te = [], Se = () => {
        const {
          done: Ee,
          value: de
        } = V.next();
        if (Ee)
          return z(Te);
        const K = new FileReader();
        K.addEventListener("error", q), K.addEventListener("load", () => {
          const D = K.result;
          typeof D == "string" && Te.push({
            file: de,
            result: D
          }), Se();
        }), E(de, ce) ? K.readAsDataURL(de) : Se();
      };
      Se();
    });
  }
  function S(te, ce) {
    const V = [], z = (te || t.$getRoot()).getLatest(), q = ce || (t.$isElementNode(z) ? z.getLastDescendant() : z);
    let Te = z, Se = w(Te);
    for (; Te !== null && !Te.is(q); )
      if (V.push({
        depth: Se,
        node: Te
      }), t.$isElementNode(Te) && Te.getChildrenSize() > 0)
        Te = Te.getFirstChild(), Se++;
      else {
        let Ee = null;
        for (; Ee === null && Te !== null; )
          Ee = Te.getNextSibling(), Ee === null ? (Te = Te.getParent(), Se--) : Te = Ee;
      }
    return Te !== null && Te.is(q) && V.push({
      depth: Se,
      node: Te
    }), V;
  }
  function w(te) {
    let ce = te, V = 0;
    for (; (ce = ce.getParent()) !== null; )
      V++;
    return V;
  }
  function O(te, ce) {
    let V = te;
    for (; V != null; ) {
      if (V instanceof ce)
        return V;
      V = V.getParent();
    }
    return null;
  }
  function m(te) {
    const ce = v(te, (V) => t.$isElementNode(V) && !V.isInline());
    if (!t.$isElementNode(ce))
      throw Error(`Expected node ${te.__key} to have closest block element node.`);
    return ce;
  }
  const v = (te, ce) => {
    let V = te;
    for (; V !== t.$getRoot() && V != null; ) {
      if (ce(V))
        return V;
      V = V.getParent();
    }
    return null;
  };
  function I(te, ce, V, z) {
    const q = (Ee) => Ee instanceof ce, Te = (Ee) => {
      const de = Ee.getChildren();
      for (let Z = 0; Z < de.length; Z++) {
        const oe = de[Z];
        if (q(oe))
          return null;
      }
      let K = Ee, D = Ee;
      for (; K !== null; )
        if (D = K, K = K.getParent(), q(K))
          return {
            child: D,
            parent: K
          };
      return null;
    }, Se = (Ee) => {
      const de = Te(Ee);
      if (de !== null) {
        const {
          child: K,
          parent: D
        } = de;
        if (K.is(Ee)) {
          z(D, Ee);
          const Z = K.getNextSiblings(), oe = Z.length;
          if (D.insertAfter(K), oe !== 0) {
            const Y = V(D);
            K.insertAfter(Y);
            for (let W = 0; W < oe; W++)
              Y.append(Z[W]);
          }
          !D.canBeEmpty() && D.getChildrenSize() === 0 && D.remove();
        }
      }
    };
    return te.registerNodeTransform(ce, Se);
  }
  function G(te, ce) {
    const z = /* @__PURE__ */ new Map(), q = te._pendingEditorState;
    for (const [Se, Ee] of ce._nodeMap) {
      const de = e.$cloneWithProperties(Ee);
      if (t.$isTextNode(de)) {
        if (!t.$isTextNode(Ee))
          throw Error("Expected node be a TextNode");
        de.__text = Ee.__text;
      }
      z.set(Se, de);
    }
    q && (q._nodeMap = z), te._dirtyType = 2;
    const Te = ce._selection;
    t.$setSelection(Te === null ? null : Te.clone());
  }
  function k(te) {
    const ce = t.$getSelection() || t.$getPreviousSelection();
    if (t.$isRangeSelection(ce)) {
      const {
        focus: V
      } = ce, z = V.getNode(), q = V.offset;
      if (t.$isRootOrShadowRoot(z)) {
        const Te = z.getChildAtIndex(q);
        Te == null ? z.append(te) : Te.insertBefore(te), te.selectNext();
      } else {
        let Te, Se;
        t.$isTextNode(z) ? (Te = z.getParentOrThrow(), Se = z.getIndexWithinParent(), q > 0 && (Se += 1, z.splitText(q))) : (Te = z, Se = q);
        const [, Ee] = t.$splitNode(Te, Se);
        Ee.insertBefore(te), Ee.selectStart();
      }
    } else {
      if (ce != null) {
        const z = ce.getNodes();
        z[z.length - 1].getTopLevelElementOrThrow().insertAfter(te);
      } else
        t.$getRoot().append(te);
      const V = t.$createParagraphNode();
      te.insertAfter(V), V.select();
    }
    return te.getLatest();
  }
  function P(te, ce) {
    const V = ce();
    return te.replace(V), V.append(te), V;
  }
  function H(te, ce) {
    return te !== null ? Object.getPrototypeOf(te).constructor.name === ce.name : !1;
  }
  function j(te, ce) {
    const V = [];
    for (let z = 0; z < te.length; z++) {
      const q = ce(te[z]);
      q !== null && V.push(q);
    }
    return V;
  }
  function re(te, ce) {
    const V = te.getFirstChild();
    V !== null ? V.insertBefore(ce) : te.append(ce);
  }
  return Sn.$splitNode = t.$splitNode, Sn.isHTMLAnchorElement = t.isHTMLAnchorElement, Sn.isHTMLElement = t.isHTMLElement, Sn.$dfs = S, Sn.$filter = j, Sn.$findMatchingParent = v, Sn.$getNearestBlockElementAncestorOrThrow = m, Sn.$getNearestNodeOfType = O, Sn.$insertFirst = re, Sn.$insertNodeToNearestRoot = k, Sn.$restoreEditorState = G, Sn.$wrapNodeInElement = P, Sn.addClassNamesToElement = p, Sn.isMimeType = E, Sn.markSelection = f, Sn.mediaFileReader = T, Sn.mergeRegister = n, Sn.objectKlassEquals = H, Sn.positionNodeOnRange = d, Sn.registerNestedElementResolver = I, Sn.removeClassNamesFromElement = _, Sn;
}
var wn = {}, Gf;
function GN() {
  if (Gf) return wn;
  Gf = 1;
  var e = vs(), t = Yt();
  function n(_) {
    let E = new URLSearchParams();
    E.append("code", _);
    for (let T = 1; T < arguments.length; T++) E.append("v", arguments[T]);
    throw Error(`Minified Lexical error #${_}; visit https://lexical.dev/docs/error?${E} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  function r(..._) {
    return () => {
      _.forEach((E) => E());
    };
  }
  let l = { attributes: !0, characterData: !0, childList: !0, subtree: !0 };
  function d(_, E, T) {
    function S() {
      if (m === null) throw Error("Unexpected null rootDOMNode");
      if (v === null) throw Error("Unexpected null parentDOMNode");
      let { left: H, top: j } = m.getBoundingClientRect();
      var re = v;
      let te = e.createRectsFromDOMRange(_, E);
      k.isConnected || re.append(k), re = !1;
      for (let z = 0; z < te.length; z++) {
        var ce = te[z];
        let q = G[z] || document.createElement("div"), Te = q.style;
        Te.position !== "absolute" && (Te.position = "absolute", re = !0);
        var V = `${ce.left - H}px`;
        Te.left !== V && (Te.left = V, re = !0), V = `${ce.top - j}px`, Te.top !== V && (q.style.top = V, re = !0), V = `${ce.width}px`, Te.width !== V && (q.style.width = V, re = !0), ce = `${ce.height}px`, Te.height !== ce && (q.style.height = ce, re = !0), q.parentNode !== k && (k.append(q), re = !0), G[z] = q;
      }
      for (; G.length > te.length; ) G.pop();
      re && T(G);
    }
    function w() {
      m = v = null, I !== null && I.disconnect(), I = null, k.remove();
      for (let H of G) H.remove();
      G = [];
    }
    function O() {
      let H = _.getRootElement();
      if (H === null) return w();
      let j = H.parentElement;
      if (!(j instanceof HTMLElement)) return w();
      w(), m = H, v = j, I = new MutationObserver((re) => {
        let te = _.getRootElement(), ce = te && te.parentElement;
        if (te !== m || ce !== v) return O();
        for (let V of re) if (!k.contains(V.target)) return S();
      }), I.observe(j, l), S();
    }
    let m = null, v = null, I = null, G = [], k = document.createElement("div"), P = _.registerRootListener(O);
    return () => {
      P(), w();
    };
  }
  function f(_, E) {
    for (let T of E) if (_.type.startsWith(T)) return !0;
    return !1;
  }
  let p = (_, E) => {
    for (; _ !== t.$getRoot() && _ != null; ) {
      if (E(_)) return _;
      _ = _.getParent();
    }
    return null;
  };
  return wn.$splitNode = t.$splitNode, wn.isHTMLAnchorElement = t.isHTMLAnchorElement, wn.isHTMLElement = t.isHTMLElement, wn.$dfs = function(_, E) {
    let T = [];
    _ = (_ || t.$getRoot()).getLatest(), E = E || (t.$isElementNode(_) ? _.getLastDescendant() : _);
    for (var S = _, w = 0; (S = S.getParent()) !== null; ) w++;
    for (S = w; _ !== null && !_.is(E); ) if (T.push({ depth: S, node: _ }), t.$isElementNode(_) && 0 < _.getChildrenSize()) _ = _.getFirstChild(), S++;
    else for (w = null; w === null && _ !== null; ) w = _.getNextSibling(), w === null ? (_ = _.getParent(), S--) : _ = w;
    return _ !== null && _.is(E) && T.push({ depth: S, node: _ }), T;
  }, wn.$filter = function(_, E) {
    let T = [];
    for (let S = 0; S < _.length; S++) {
      let w = E(_[S]);
      w !== null && T.push(w);
    }
    return T;
  }, wn.$findMatchingParent = p, wn.$getNearestBlockElementAncestorOrThrow = function(_) {
    let E = p(_, (T) => t.$isElementNode(T) && !T.isInline());
    return t.$isElementNode(E) || n(4, _.__key), E;
  }, wn.$getNearestNodeOfType = function(_, E) {
    for (; _ != null; ) {
      if (_ instanceof E) return _;
      _ = _.getParent();
    }
    return null;
  }, wn.$insertFirst = function(_, E) {
    let T = _.getFirstChild();
    T !== null ? T.insertBefore(E) : _.append(E);
  }, wn.$insertNodeToNearestRoot = function(_) {
    var E = t.$getSelection() || t.$getPreviousSelection();
    if (t.$isRangeSelection(E)) {
      var { focus: T } = E;
      if (E = T.getNode(), T = T.offset, t.$isRootOrShadowRoot(E)) T = E.getChildAtIndex(T), T == null ? E.append(_) : T.insertBefore(_), _.selectNext();
      else {
        let S, w;
        t.$isTextNode(E) ? (S = E.getParentOrThrow(), w = E.getIndexWithinParent(), 0 < T && (w += 1, E.splitText(T))) : (S = E, w = T), [, E] = t.$splitNode(S, w), E.insertBefore(_), E.selectStart();
      }
    } else E != null ? (E = E.getNodes(), E[E.length - 1].getTopLevelElementOrThrow().insertAfter(_)) : t.$getRoot().append(_), E = t.$createParagraphNode(), _.insertAfter(E), E.select();
    return _.getLatest();
  }, wn.$restoreEditorState = function(_, E) {
    let T = /* @__PURE__ */ new Map(), S = _._pendingEditorState;
    for (let [w, O] of E._nodeMap) {
      let m = e.$cloneWithProperties(O);
      if (t.$isTextNode(m)) {
        if (!t.$isTextNode(O)) throw Error("Expected node be a TextNode");
        m.__text = O.__text;
      }
      T.set(w, m);
    }
    S && (S._nodeMap = T), _._dirtyType = 2, _ = E._selection, t.$setSelection(_ === null ? null : _.clone());
  }, wn.$wrapNodeInElement = function(_, E) {
    return E = E(), _.replace(E), E.append(_), E;
  }, wn.addClassNamesToElement = function(_, ...E) {
    E.forEach((T) => {
      typeof T == "string" && (T = T.split(" ").filter((S) => S !== ""), _.classList.add(...T));
    });
  }, wn.isMimeType = f, wn.markSelection = function(_, E) {
    function T(I) {
      I.read(() => {
        var G = t.$getSelection();
        if (t.$isRangeSelection(G)) {
          var { anchor: k, focus: P } = G;
          G = k.getNode();
          var H = G.getKey(), j = k.offset, re = P.getNode(), te = re.getKey(), ce = P.offset, V = _.getElementByKey(H), z = _.getElementByKey(te);
          if (H = S === null || V === null || j !== w || H !== S.getKey() || G !== S && (!(S instanceof t.TextNode) || G.updateDOM(S, V, _._config)), te = O === null || z === null || ce !== m || te !== O.getKey() || re !== O && (!(O instanceof t.TextNode) || re.updateDOM(O, z, _._config)), H || te) {
            V = _.getElementByKey(k.getNode().getKey());
            var q = _.getElementByKey(P.getNode().getKey());
            if (V !== null && q !== null && V.tagName === "SPAN" && q.tagName === "SPAN") {
              if (te = document.createRange(), P.isBefore(k) ? (H = q, z = P.offset, q = V, V = k.offset) : (H = V, z = k.offset, V = P.offset), H = H.firstChild, H === null || (q = q.firstChild, q === null)) throw Error("Expected text node to be first child of span");
              te.setStart(H, z), te.setEnd(q, V), v(), v = d(_, te, (Te) => {
                for (let Se of Te) {
                  let Ee = Se.style;
                  Ee.background !== "Highlight" && (Ee.background = "Highlight"), Ee.color !== "HighlightText" && (Ee.color = "HighlightText"), Ee.zIndex !== "-1" && (Ee.zIndex = "-1"), Ee.pointerEvents !== "none" && (Ee.pointerEvents = "none"), Ee.marginTop !== "-1.5px" && (Ee.marginTop = "-1.5px"), Ee.paddingTop !== "4px" && (Ee.paddingTop = "4px"), Ee.paddingBottom !== "0px" && (Ee.paddingBottom = "0px");
                }
                E !== void 0 && E(Te);
              });
            }
          }
          S = G, w = j, O = re, m = ce;
        } else m = O = w = S = null, v(), v = () => {
        };
      });
    }
    let S = null, w = null, O = null, m = null, v = () => {
    };
    return T(_.getEditorState()), r(_.registerUpdateListener(({ editorState: I }) => T(I)), v, () => {
      v();
    });
  }, wn.mediaFileReader = function(_, E) {
    let T = _[Symbol.iterator]();
    return new Promise((S, w) => {
      let O = [], m = () => {
        const { done: v, value: I } = T.next();
        if (v) return S(O);
        const G = new FileReader();
        G.addEventListener("error", w), G.addEventListener("load", () => {
          const k = G.result;
          typeof k == "string" && O.push({ file: I, result: k }), m();
        }), f(I, E) ? G.readAsDataURL(I) : m();
      };
      m();
    });
  }, wn.mergeRegister = r, wn.objectKlassEquals = function(_, E) {
    return _ !== null ? Object.getPrototypeOf(_).constructor.name === E.name : !1;
  }, wn.positionNodeOnRange = d, wn.registerNestedElementResolver = function(_, E, T, S) {
    return _.registerNodeTransform(E, (w) => {
      e: {
        for (var O = w.getChildren(), m = 0; m < O.length; m++) if (O[m] instanceof E) {
          O = null;
          break e;
        }
        for (O = w; O !== null; ) if (m = O, O = O.getParent(), O instanceof E) {
          O = { child: m, parent: O };
          break e;
        }
        O = null;
      }
      if (O !== null) {
        const { child: v, parent: I } = O;
        if (v.is(w)) {
          if (S(I, w), w = v.getNextSiblings(), O = w.length, I.insertAfter(v), O !== 0) {
            m = T(I), v.insertAfter(m);
            for (let G = 0; G < O; G++) m.append(w[G]);
          }
          I.canBeEmpty() || I.getChildrenSize() !== 0 || I.remove();
        }
      }
    });
  }, wn.removeClassNamesFromElement = function(_, ...E) {
    E.forEach((T) => {
      typeof T == "string" && _.classList.remove(...T.split(" "));
    });
  }, wn;
}
var au, Yf;
function gn() {
  return Yf || (Yf = 1, au = process.env.NODE_ENV === "development" ? UN() : GN()), au;
}
var cu = {}, jf;
function YN() {
  if (jf) return cu;
  jf = 1;
  var e = Yt();
  function t(n) {
    const r = window.location.origin, l = (d) => {
      if (d.origin !== r)
        return;
      const f = n.getRootElement();
      if (document.activeElement !== f)
        return;
      const p = d.data;
      if (typeof p == "string") {
        let _;
        try {
          _ = JSON.parse(p);
        } catch {
          return;
        }
        if (_ && _.protocol === "nuanria_messaging" && _.type === "request") {
          const E = _.payload;
          if (E && E.functionId === "makeChanges") {
            const T = E.args;
            if (T) {
              const [S, w, O, m, v, I] = T;
              n.update(() => {
                const G = e.$getSelection();
                if (e.$isRangeSelection(G)) {
                  const k = G.anchor;
                  let P = k.getNode(), H = 0, j = 0;
                  if (e.$isTextNode(P) && S >= 0 && w >= 0 && (H = S, j = S + w, G.setTextNodeRange(P, H, P, j)), (H !== j || O !== "") && (G.insertRawText(O), P = k.getNode()), e.$isTextNode(P)) {
                    H = m, j = m + v;
                    const re = P.getTextContentSize();
                    H = H > re ? re : H, j = j > re ? re : j, G.setTextNodeRange(P, H, P, j);
                  }
                  d.stopImmediatePropagation();
                }
              });
            }
          }
        }
      }
    };
    return window.addEventListener("message", l, !0), () => {
      window.removeEventListener("message", l, !0);
    };
  }
  return cu.registerDragonSupport = t, cu;
}
var uu = {}, Vf;
function jN() {
  if (Vf) return uu;
  Vf = 1;
  var e = Yt();
  return uu.registerDragonSupport = function(t) {
    let n = window.location.origin, r = (l) => {
      if (l.origin === n) {
        var d = t.getRootElement();
        if (document.activeElement === d && (d = l.data, typeof d == "string")) {
          try {
            var f = JSON.parse(d);
          } catch {
            return;
          }
          if (f && f.protocol === "nuanria_messaging" && f.type === "request" && (f = f.payload) && f.functionId === "makeChanges" && (f = f.args)) {
            const [p, _, E, T, S] = f;
            t.update(() => {
              const w = e.$getSelection();
              if (e.$isRangeSelection(w)) {
                var O = w.anchor;
                let m = O.getNode(), v = 0, I = 0;
                e.$isTextNode(m) && 0 <= p && 0 <= _ && (v = p, I = p + _, w.setTextNodeRange(m, v, m, I)), (v !== I || E !== "") && (w.insertRawText(E), m = O.getNode()), e.$isTextNode(m) && (v = T, I = T + S, O = m.getTextContentSize(), v = v > O ? O : v, I = I > O ? O : I, w.setTextNodeRange(m, v, m, I)), l.stopImmediatePropagation();
              }
            });
          }
        }
      }
    };
    return window.addEventListener("message", r, !0), () => {
      window.removeEventListener("message", r, !0);
    };
  }, uu;
}
var du, qf;
function Tp() {
  return qf || (qf = 1, du = process.env.NODE_ENV === "development" ? YN() : jN()), du;
}
var hi = {}, wi = {}, Xa = {}, Zf;
function VN() {
  if (Zf) return Xa;
  Zf = 1;
  var e = vs(), t = gn(), n = Yt();
  function r(E, T) {
    const S = T.body ? T.body.childNodes : [];
    let w = [];
    for (let O = 0; O < S.length; O++) {
      const m = S[O];
      if (!p.has(m.nodeName)) {
        const v = _(m, E);
        v !== null && (w = w.concat(v));
      }
    }
    return w;
  }
  function l(E, T) {
    if (typeof document > "u" || typeof window > "u")
      throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    const S = document.createElement("div"), O = n.$getRoot().getChildren();
    for (let m = 0; m < O.length; m++) {
      const v = O[m];
      d(E, v, S, T);
    }
    return S.innerHTML;
  }
  function d(E, T, S, w = null) {
    let O = w != null ? T.isSelected(w) : !0;
    const m = n.$isElementNode(T) && T.excludeFromCopy("html");
    let v = T;
    if (w !== null) {
      let re = e.$cloneWithProperties(T);
      re = n.$isTextNode(re) && w != null ? e.$sliceSelectedTextNodeContent(w, re) : re, v = re;
    }
    const I = n.$isElementNode(v) ? v.getChildren() : [], G = E._nodes.get(v.getType());
    let k;
    G && G.exportDOM !== void 0 ? k = G.exportDOM(E, v) : k = v.exportDOM(E);
    const {
      element: P,
      after: H
    } = k;
    if (!P)
      return !1;
    const j = document.createDocumentFragment();
    for (let re = 0; re < I.length; re++) {
      const te = I[re], ce = d(E, te, j, w);
      !O && n.$isElementNode(T) && ce && T.extractWithChild(te, w, "html") && (O = !0);
    }
    if (O && !m) {
      if (t.isHTMLElement(P) && P.append(j), S.append(P), H) {
        const re = H.call(v, P);
        re && P.replaceWith(re);
      }
    } else
      S.append(j);
    return O;
  }
  function f(E, T) {
    const {
      nodeName: S
    } = E, w = T._htmlConversions.get(S.toLowerCase());
    let O = null;
    if (w !== void 0)
      for (const m of w) {
        const v = m(E);
        v !== null && (O === null || (O.priority || 0) < (v.priority || 0)) && (O = v);
      }
    return O !== null ? O.conversion : null;
  }
  const p = /* @__PURE__ */ new Set(["STYLE", "SCRIPT"]);
  function _(E, T, S = /* @__PURE__ */ new Map(), w) {
    let O = [];
    if (p.has(E.nodeName))
      return O;
    let m = null;
    const v = f(E, T), I = v ? v(E) : null;
    let G = null;
    if (I !== null) {
      G = I.after;
      const H = I.node;
      if (m = Array.isArray(H) ? H[H.length - 1] : H, m !== null) {
        for (const [, j] of S)
          if (m = j(m, w), !m)
            break;
        m && O.push(...Array.isArray(H) ? H : [m]);
      }
      I.forChild != null && S.set(E.nodeName, I.forChild);
    }
    const k = E.childNodes;
    let P = [];
    for (let H = 0; H < k.length; H++)
      P.push(..._(k[H], T, new Map(S), m));
    return G != null && (P = G(P)), m == null ? O = O.concat(P) : n.$isElementNode(m) && m.append(...P), O;
  }
  return Xa.$generateHtmlFromNodes = l, Xa.$generateNodesFromDOM = r, Xa;
}
var Qa = {}, Jf;
function qN() {
  if (Jf) return Qa;
  Jf = 1;
  var e = vs(), t = gn(), n = Yt();
  function r(f, p, _, E = null) {
    let T = E != null ? p.isSelected(E) : !0, S = n.$isElementNode(p) && p.excludeFromCopy("html");
    var w = p;
    E !== null && (w = e.$cloneWithProperties(p), w = n.$isTextNode(w) && E != null ? e.$sliceSelectedTextNodeContent(E, w) : w);
    let O = n.$isElementNode(w) ? w.getChildren() : [];
    var m = f._nodes.get(w.getType());
    m = m && m.exportDOM !== void 0 ? m.exportDOM(f, w) : w.exportDOM(f);
    let { element: v, after: I } = m;
    if (!v) return !1;
    m = document.createDocumentFragment();
    for (let G = 0; G < O.length; G++) {
      let k = O[G], P = r(f, k, m, E);
      !T && n.$isElementNode(p) && P && p.extractWithChild(k, E, "html") && (T = !0);
    }
    return T && !S ? (t.isHTMLElement(v) && v.append(m), _.append(v), I && (f = I.call(w, v)) && v.replaceWith(f)) : _.append(m), T;
  }
  let l = /* @__PURE__ */ new Set(["STYLE", "SCRIPT"]);
  function d(f, p, _ = /* @__PURE__ */ new Map(), E) {
    let T = [];
    if (l.has(f.nodeName)) return T;
    let S = null;
    var w, { nodeName: O } = f, m = p._htmlConversions.get(O.toLowerCase());
    if (O = null, m !== void 0) for (w of m) m = w(f), m !== null && (O === null || (O.priority || 0) < (m.priority || 0)) && (O = m);
    if (O = (w = O !== null ? O.conversion : null) ? w(f) : null, w = null, O !== null) {
      if (w = O.after, m = O.node, S = Array.isArray(m) ? m[m.length - 1] : m, S !== null) {
        for (var [, v] of _) if (S = v(S, E), !S) break;
        S && T.push(...Array.isArray(m) ? m : [S]);
      }
      O.forChild != null && _.set(f.nodeName, O.forChild);
    }
    for (f = f.childNodes, E = [], v = 0; v < f.length; v++) E.push(...d(f[v], p, new Map(_), S));
    return w != null && (E = w(E)), S == null ? T = T.concat(E) : n.$isElementNode(S) && S.append(...E), T;
  }
  return Qa.$generateHtmlFromNodes = function(f, p) {
    if (typeof document > "u" || typeof window > "u") throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    let _ = document.createElement("div"), E = n.$getRoot().getChildren();
    for (let T = 0; T < E.length; T++) r(f, E[T], _, p);
    return _.innerHTML;
  }, Qa.$generateNodesFromDOM = function(f, p) {
    p = p.body ? p.body.childNodes : [];
    let _ = [];
    for (let T = 0; T < p.length; T++) {
      var E = p[T];
      l.has(E.nodeName) || (E = d(E, f), E !== null && (_ = _.concat(E)));
    }
    return _;
  }, Qa;
}
var fu, Xf;
function xp() {
  return Xf || (Xf = 1, fu = process.env.NODE_ENV === "development" ? VN() : qN()), fu;
}
var Qf;
function ZN() {
  if (Qf) return wi;
  Qf = 1;
  var e = xp(), t = vs(), n = gn(), r = Yt();
  const l = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", d = (P) => l ? (P || window).getSelection() : null;
  function f(P) {
    const H = r.$getSelection();
    if (H == null)
      throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(H) && H.isCollapsed() || H.getNodes().length === 0 ? "" : e.$generateHtmlFromNodes(P, H);
  }
  function p(P) {
    const H = r.$getSelection();
    if (H == null)
      throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(H) && H.isCollapsed() || H.getNodes().length === 0 ? null : JSON.stringify(O(P, H));
  }
  function _(P, H) {
    const j = P.getData("text/plain") || P.getData("text/uri-list");
    j != null && H.insertRawText(j);
  }
  function E(P, H, j) {
    const re = P.getData("application/x-lexical-editor");
    if (re)
      try {
        const V = JSON.parse(re);
        if (V.namespace === j._config.namespace && Array.isArray(V.nodes)) {
          const z = m(V.nodes);
          return T(j, z, H);
        }
      } catch {
      }
    const te = P.getData("text/html");
    if (te)
      try {
        const z = new DOMParser().parseFromString(te, "text/html"), q = e.$generateNodesFromDOM(j, z);
        return T(j, q, H);
      } catch {
      }
    const ce = P.getData("text/plain") || P.getData("text/uri-list");
    if (ce != null)
      if (r.$isRangeSelection(H)) {
        const V = ce.split(/(\r?\n|\t)/);
        V[V.length - 1] === "" && V.pop();
        for (let z = 0; z < V.length; z++) {
          const q = V[z];
          q === `
` || q === `\r
` ? H.insertParagraph() : q === "	" ? H.insertNodes([r.$createTabNode()]) : H.insertText(q);
        }
      } else
        H.insertRawText(ce);
  }
  function T(P, H, j) {
    P.dispatchCommand(r.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, {
      nodes: H,
      selection: j
    }) || j.insertNodes(H);
  }
  function S(P) {
    const H = P.exportJSON(), j = P.constructor;
    if (H.type !== j.getType())
      throw Error(`LexicalNode: Node ${j.name} does not implement .exportJSON().`);
    if (r.$isElementNode(P)) {
      const re = H.children;
      if (!Array.isArray(re))
        throw Error(`LexicalNode: Node ${j.name} is an element but .exportJSON() does not have a children array.`);
    }
    return H;
  }
  function w(P, H, j, re = []) {
    let te = H != null ? j.isSelected(H) : !0;
    const ce = r.$isElementNode(j) && j.excludeFromCopy("html");
    let V = j;
    if (H !== null) {
      let Te = t.$cloneWithProperties(j);
      Te = r.$isTextNode(Te) && H != null ? t.$sliceSelectedTextNodeContent(H, Te) : Te, V = Te;
    }
    const z = r.$isElementNode(V) ? V.getChildren() : [], q = S(V);
    if (r.$isTextNode(V)) {
      const Te = V.__text;
      Te.length > 0 ? q.text = Te : te = !1;
    }
    for (let Te = 0; Te < z.length; Te++) {
      const Se = z[Te], Ee = w(P, H, Se, q.children);
      !te && r.$isElementNode(j) && Ee && j.extractWithChild(Se, H, "clone") && (te = !0);
    }
    if (te && !ce)
      re.push(q);
    else if (Array.isArray(q.children))
      for (let Te = 0; Te < q.children.length; Te++) {
        const Se = q.children[Te];
        re.push(Se);
      }
    return te;
  }
  function O(P, H) {
    const j = [], te = r.$getRoot().getChildren();
    for (let ce = 0; ce < te.length; ce++) {
      const V = te[ce];
      w(P, H, V, j);
    }
    return {
      namespace: P._config.namespace,
      nodes: j
    };
  }
  function m(P) {
    const H = [];
    for (let j = 0; j < P.length; j++) {
      const re = P[j], te = r.$parseSerializedNode(re);
      r.$isTextNode(te) && t.$addNodeStyle(te), H.push(te);
    }
    return H;
  }
  const v = 50;
  let I = null;
  async function G(P, H) {
    if (I !== null)
      return !1;
    if (H !== null)
      return new Promise((z, q) => {
        P.update(() => {
          z(k(P, H));
        });
      });
    const j = P.getRootElement(), re = P._window == null ? window.document : P._window.document, te = d(P._window);
    if (j === null || te === null)
      return !1;
    const ce = re.createElement("span");
    ce.style.cssText = "position: fixed; top: -1000px;", ce.append(re.createTextNode("#")), j.append(ce);
    const V = new Range();
    return V.setStart(ce, 0), V.setEnd(ce, 1), te.removeAllRanges(), te.addRange(V), new Promise((z, q) => {
      const Te = P.registerCommand(r.COPY_COMMAND, (Se) => (n.objectKlassEquals(Se, ClipboardEvent) && (Te(), I !== null && (window.clearTimeout(I), I = null), z(k(P, Se))), !0), r.COMMAND_PRIORITY_CRITICAL);
      I = window.setTimeout(() => {
        Te(), I = null, z(!1);
      }, v), re.execCommand("copy"), ce.remove();
    });
  }
  function k(P, H) {
    const j = d(P._window);
    if (!j)
      return !1;
    const re = j.anchorNode, te = j.focusNode;
    if (re !== null && te !== null && !r.isSelectionWithinEditor(P, re, te))
      return !1;
    H.preventDefault();
    const ce = H.clipboardData, V = r.$getSelection();
    if (ce === null || V === null)
      return !1;
    const z = f(P), q = p(P);
    let Te = "";
    return V !== null && (Te = V.getTextContent()), z !== null && ce.setData("text/html", z), q !== null && ce.setData("application/x-lexical-editor", q), ce.setData("text/plain", Te), !0;
  }
  return wi.$generateJSONFromSelectedNodes = O, wi.$generateNodesFromSerializedNodes = m, wi.$getHtmlContent = f, wi.$getLexicalContent = p, wi.$insertDataTransferForPlainText = _, wi.$insertDataTransferForRichText = E, wi.$insertGeneratedNodes = T, wi.copyToClipboard = G, wi;
}
var Oi = {}, eh;
function JN() {
  if (eh) return Oi;
  eh = 1;
  var e = xp(), t = vs(), n = gn(), r = Yt();
  function l(m) {
    let v = new URLSearchParams();
    v.append("code", m);
    for (let I = 1; I < arguments.length; I++) v.append("v", arguments[I]);
    throw Error(`Minified Lexical error #${m}; visit https://lexical.dev/docs/error?${v} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  let d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  function f(m) {
    let v = r.$getSelection();
    if (v == null) throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(v) && v.isCollapsed() || v.getNodes().length === 0 ? "" : e.$generateHtmlFromNodes(m, v);
  }
  function p(m) {
    let v = r.$getSelection();
    if (v == null) throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(v) && v.isCollapsed() || v.getNodes().length === 0 ? null : JSON.stringify(T(m, v));
  }
  function _(m, v, I) {
    m.dispatchCommand(r.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, { nodes: v, selection: I }) || I.insertNodes(v);
  }
  function E(m, v, I, G = []) {
    let k = v != null ? I.isSelected(v) : !0, P = r.$isElementNode(I) && I.excludeFromCopy("html");
    var H = I;
    if (v !== null) {
      var j = t.$cloneWithProperties(I);
      H = j = r.$isTextNode(j) && v != null ? t.$sliceSelectedTextNodeContent(v, j) : j;
    }
    let re = r.$isElementNode(H) ? H.getChildren() : [];
    var te = H;
    j = te.exportJSON();
    var ce = te.constructor;
    for (j.type !== ce.getType() && l(58, ce.name), r.$isElementNode(te) && (Array.isArray(j.children) || l(59, ce.name)), r.$isTextNode(H) && (H = H.__text, 0 < H.length ? j.text = H : k = !1), H = 0; H < re.length; H++) te = re[H], ce = E(m, v, te, j.children), !k && r.$isElementNode(I) && ce && I.extractWithChild(te, v, "clone") && (k = !0);
    if (k && !P) G.push(j);
    else if (Array.isArray(j.children)) for (m = 0; m < j.children.length; m++) G.push(j.children[m]);
    return k;
  }
  function T(m, v) {
    let I = [], G = r.$getRoot().getChildren();
    for (let k = 0; k < G.length; k++) E(m, v, G[k], I);
    return { namespace: m._config.namespace, nodes: I };
  }
  function S(m) {
    let v = [];
    for (let I = 0; I < m.length; I++) {
      let G = r.$parseSerializedNode(m[I]);
      r.$isTextNode(G) && t.$addNodeStyle(G), v.push(G);
    }
    return v;
  }
  let w = null;
  function O(m, v) {
    var I = d ? (m._window || window).getSelection() : null;
    if (!I) return !1;
    var G = I.anchorNode;
    if (I = I.focusNode, G !== null && I !== null && !r.isSelectionWithinEditor(m, G, I) || (v.preventDefault(), v = v.clipboardData, G = r.$getSelection(), v === null || G === null)) return !1;
    I = f(m), m = p(m);
    let k = "";
    return G !== null && (k = G.getTextContent()), I !== null && v.setData("text/html", I), m !== null && v.setData("application/x-lexical-editor", m), v.setData("text/plain", k), !0;
  }
  return Oi.$generateJSONFromSelectedNodes = T, Oi.$generateNodesFromSerializedNodes = S, Oi.$getHtmlContent = f, Oi.$getLexicalContent = p, Oi.$insertDataTransferForPlainText = function(m, v) {
    m = m.getData("text/plain") || m.getData("text/uri-list"), m != null && v.insertRawText(m);
  }, Oi.$insertDataTransferForRichText = function(m, v, I) {
    var G = m.getData("application/x-lexical-editor");
    if (G) try {
      let P = JSON.parse(G);
      if (P.namespace === I._config.namespace && Array.isArray(P.nodes)) {
        let H = S(P.nodes);
        return _(I, H, v);
      }
    } catch {
    }
    if (G = m.getData("text/html")) try {
      var k = new DOMParser().parseFromString(G, "text/html");
      let P = e.$generateNodesFromDOM(I, k);
      return _(I, P, v);
    } catch {
    }
    if (m = m.getData("text/plain") || m.getData("text/uri-list"), m != null) if (r.$isRangeSelection(v)) for (m = m.split(/(\r?\n|\t)/), m[m.length - 1] === "" && m.pop(), I = 0; I < m.length; I++) k = m[I], k === `
` || k === `\r
` ? v.insertParagraph() : k === "	" ? v.insertNodes([r.$createTabNode()]) : v.insertText(k);
    else v.insertRawText(m);
  }, Oi.$insertGeneratedNodes = _, Oi.copyToClipboard = async function(m, v) {
    if (w !== null) return !1;
    if (v !== null) return new Promise((H) => {
      m.update(() => {
        H(O(m, v));
      });
    });
    var I = m.getRootElement();
    let G = m._window == null ? window.document : m._window.document, k = d ? (m._window || window).getSelection() : null;
    if (I === null || k === null) return !1;
    let P = G.createElement("span");
    return P.style.cssText = "position: fixed; top: -1000px;", P.append(G.createTextNode("#")), I.append(P), I = new Range(), I.setStart(P, 0), I.setEnd(P, 1), k.removeAllRanges(), k.addRange(I), new Promise((H) => {
      let j = m.registerCommand(r.COPY_COMMAND, (re) => (n.objectKlassEquals(re, ClipboardEvent) && (j(), w !== null && (window.clearTimeout(w), w = null), H(O(m, re))), !0), r.COMMAND_PRIORITY_CRITICAL);
      w = window.setTimeout(() => {
        j(), w = null, H(!1);
      }, 50), G.execCommand("copy"), P.remove();
    });
  }, Oi;
}
var hu, th;
function vp() {
  return th || (th = 1, hu = process.env.NODE_ENV === "development" ? ZN() : JN()), hu;
}
var nh;
function XN() {
  if (nh) return hi;
  nh = 1;
  var e = vp(), t = vs(), n = gn(), r = Yt();
  function l(Se, Ee) {
    if (typeof document.caretRangeFromPoint < "u") {
      const de = document.caretRangeFromPoint(Se, Ee);
      return de === null ? null : {
        node: de.startContainer,
        offset: de.startOffset
      };
    } else if (document.caretPositionFromPoint !== "undefined") {
      const de = document.caretPositionFromPoint(Se, Ee);
      return de === null ? null : {
        node: de.offsetNode,
        offset: de.offset
      };
    } else
      return null;
  }
  const d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", f = d && "documentMode" in document ? document.documentMode : null, p = d && "InputEvent" in window && !f ? "getTargetRanges" in new window.InputEvent("input") : !1, _ = d && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), E = d && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, T = d && /^(?=.*Chrome).*/i.test(navigator.userAgent), S = d && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !T, w = r.createCommand("DRAG_DROP_PASTE_FILE");
  class O extends r.ElementNode {
    static getType() {
      return "quote";
    }
    static clone(Ee) {
      return new O(Ee.__key);
    }
    constructor(Ee) {
      super(Ee);
    }
    // View
    createDOM(Ee) {
      const de = document.createElement("blockquote");
      return n.addClassNamesToElement(de, Ee.theme.quote), de;
    }
    updateDOM(Ee, de) {
      return !1;
    }
    static importDOM() {
      return {
        blockquote: (Ee) => ({
          conversion: P,
          priority: 0
        })
      };
    }
    exportDOM(Ee) {
      const {
        element: de
      } = super.exportDOM(Ee);
      if (de && n.isHTMLElement(de)) {
        this.isEmpty() && de.append(document.createElement("br"));
        const K = this.getFormatType();
        de.style.textAlign = K;
        const D = this.getDirection();
        D && (de.dir = D);
      }
      return {
        element: de
      };
    }
    static importJSON(Ee) {
      const de = m();
      return de.setFormat(Ee.format), de.setIndent(Ee.indent), de.setDirection(Ee.direction), de;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "quote"
      };
    }
    // Mutation
    insertNewAfter(Ee, de) {
      const K = r.$createParagraphNode(), D = this.getDirection();
      return K.setDirection(D), this.insertAfter(K, de), K;
    }
    collapseAtStart() {
      const Ee = r.$createParagraphNode();
      return this.getChildren().forEach((K) => Ee.append(K)), this.replace(Ee), !0;
    }
  }
  function m() {
    return r.$applyNodeReplacement(new O());
  }
  function v(Se) {
    return Se instanceof O;
  }
  class I extends r.ElementNode {
    /** @internal */
    static getType() {
      return "heading";
    }
    static clone(Ee) {
      return new I(Ee.__tag, Ee.__key);
    }
    constructor(Ee, de) {
      super(de), this.__tag = Ee;
    }
    getTag() {
      return this.__tag;
    }
    // View
    createDOM(Ee) {
      const de = this.__tag, K = document.createElement(de), Z = Ee.theme.heading;
      if (Z !== void 0) {
        const oe = Z[de];
        n.addClassNamesToElement(K, oe);
      }
      return K;
    }
    updateDOM(Ee, de) {
      return !1;
    }
    static importDOM() {
      return {
        h1: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        h2: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        h3: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        h4: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        h5: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        h6: (Ee) => ({
          conversion: k,
          priority: 0
        }),
        p: (Ee) => {
          const K = Ee.firstChild;
          return K !== null && G(K) ? {
            conversion: () => ({
              node: null
            }),
            priority: 3
          } : null;
        },
        span: (Ee) => G(Ee) ? {
          conversion: (de) => ({
            node: H("h1")
          }),
          priority: 3
        } : null
      };
    }
    exportDOM(Ee) {
      const {
        element: de
      } = super.exportDOM(Ee);
      if (de && n.isHTMLElement(de)) {
        this.isEmpty() && de.append(document.createElement("br"));
        const K = this.getFormatType();
        de.style.textAlign = K;
        const D = this.getDirection();
        D && (de.dir = D);
      }
      return {
        element: de
      };
    }
    static importJSON(Ee) {
      const de = H(Ee.tag);
      return de.setFormat(Ee.format), de.setIndent(Ee.indent), de.setDirection(Ee.direction), de;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        tag: this.getTag(),
        type: "heading",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(Ee, de = !0) {
      const K = Ee ? Ee.anchor.offset : 0, D = K === this.getTextContentSize() || !Ee ? r.$createParagraphNode() : H(this.getTag()), Z = this.getDirection();
      if (D.setDirection(Z), this.insertAfter(D, de), K === 0 && !this.isEmpty() && Ee) {
        const oe = r.$createParagraphNode();
        oe.select(), this.replace(oe, !0);
      }
      return D;
    }
    collapseAtStart() {
      const Ee = this.isEmpty() ? r.$createParagraphNode() : H(this.getTag());
      return this.getChildren().forEach((K) => Ee.append(K)), this.replace(Ee), !0;
    }
    extractWithChild() {
      return !0;
    }
  }
  function G(Se) {
    return Se.nodeName.toLowerCase() === "span" ? Se.style.fontSize === "26pt" : !1;
  }
  function k(Se) {
    const Ee = Se.nodeName.toLowerCase();
    let de = null;
    return (Ee === "h1" || Ee === "h2" || Ee === "h3" || Ee === "h4" || Ee === "h5" || Ee === "h6") && (de = H(Ee), Se.style !== null && de.setFormat(Se.style.textAlign)), {
      node: de
    };
  }
  function P(Se) {
    const Ee = m();
    return Se.style !== null && Ee.setFormat(Se.style.textAlign), {
      node: Ee
    };
  }
  function H(Se) {
    return r.$applyNodeReplacement(new I(Se));
  }
  function j(Se) {
    return Se instanceof I;
  }
  function re(Se, Ee) {
    Se.preventDefault(), Ee.update(() => {
      const de = r.$getSelection(), K = Se instanceof InputEvent || Se instanceof KeyboardEvent ? null : Se.clipboardData;
      K != null && r.$INTERNAL_isPointSelection(de) && e.$insertDataTransferForRichText(K, de, Ee);
    }, {
      tag: "paste"
    });
  }
  async function te(Se, Ee) {
    await e.copyToClipboard(Ee, n.objectKlassEquals(Se, ClipboardEvent) ? Se : null), Ee.update(() => {
      const de = r.$getSelection();
      r.$isRangeSelection(de) ? de.removeText() : r.$isNodeSelection(de) && de.getNodes().forEach((K) => K.remove());
    });
  }
  function ce(Se) {
    let Ee = null;
    if (Se instanceof DragEvent ? Ee = Se.dataTransfer : Se instanceof ClipboardEvent && (Ee = Se.clipboardData), Ee === null)
      return [!1, [], !1];
    const de = Ee.types, K = de.includes("Files"), D = de.includes("text/html") || de.includes("text/plain");
    return [K, Array.from(Ee.files), D];
  }
  function V(Se) {
    const Ee = r.$getSelection();
    if (!r.$isRangeSelection(Ee))
      return !1;
    const de = /* @__PURE__ */ new Set(), K = Ee.getNodes();
    for (let D = 0; D < K.length; D++) {
      const Z = K[D], oe = Z.getKey();
      if (de.has(oe))
        continue;
      const Y = n.$getNearestBlockElementAncestorOrThrow(Z), W = Y.getKey();
      Y.canIndent() && !de.has(W) && (de.add(W), Se(Y));
    }
    return de.size > 0;
  }
  function z(Se) {
    const Ee = r.$getNearestNodeFromDOMNode(Se);
    return r.$isDecoratorNode(Ee);
  }
  function q(Se) {
    const Ee = Se.focus;
    return Ee.key === "root" && Ee.offset === r.$getRoot().getChildrenSize();
  }
  function Te(Se) {
    return n.mergeRegister(Se.registerCommand(r.CLICK_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isNodeSelection(K) ? (K.clear(), !0) : !1;
    }, 0), Se.registerCommand(r.DELETE_CHARACTER_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (K.deleteCharacter(de), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.DELETE_WORD_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (K.deleteWord(de), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.DELETE_LINE_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (K.deleteLine(de), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.CONTROLLED_TEXT_INSERTION_COMMAND, (de) => {
      const K = r.$getSelection();
      if (typeof de == "string")
        r.$INTERNAL_isPointSelection(K) && K.insertText(de);
      else {
        if (!r.$INTERNAL_isPointSelection(K))
          return !1;
        const D = de.dataTransfer;
        if (D != null)
          e.$insertDataTransferForRichText(D, K, Se);
        else if (r.$isRangeSelection(K)) {
          const Z = de.data;
          return Z && K.insertText(Z), !0;
        }
      }
      return !0;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.REMOVE_TEXT_COMMAND, () => {
      const de = r.$getSelection();
      return r.$isRangeSelection(de) ? (de.removeText(), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.FORMAT_TEXT_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (K.formatText(de), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.FORMAT_ELEMENT_COMMAND, (de) => {
      const K = r.$getSelection();
      if (!r.$isRangeSelection(K) && !r.$isNodeSelection(K))
        return !1;
      const D = K.getNodes();
      for (const Z of D) {
        const oe = n.$findMatchingParent(Z, (Y) => r.$isElementNode(Y) && !Y.isInline());
        oe !== null && oe.setFormat(de);
      }
      return !0;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.INSERT_LINE_BREAK_COMMAND, (de) => {
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (K.insertLineBreak(de), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.INSERT_PARAGRAPH_COMMAND, () => {
      const de = r.$getSelection();
      return r.$isRangeSelection(de) ? (de.insertParagraph(), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.INSERT_TAB_COMMAND, () => (r.$insertNodes([r.$createTabNode()]), !0), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.INDENT_CONTENT_COMMAND, () => V((de) => {
      const K = de.getIndent();
      de.setIndent(K + 1);
    }), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.OUTDENT_CONTENT_COMMAND, () => V((de) => {
      const K = de.getIndent();
      K > 0 && de.setIndent(K - 1);
    }), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ARROW_UP_COMMAND, (de) => {
      const K = r.$getSelection();
      if (r.$isNodeSelection(K) && !z(de.target)) {
        const D = K.getNodes();
        if (D.length > 0)
          return D[0].selectPrevious(), !0;
      } else if (r.$isRangeSelection(K)) {
        const D = r.$getAdjacentNode(K.focus, !0);
        if (!de.shiftKey && r.$isDecoratorNode(D) && !D.isIsolated() && !D.isInline())
          return D.selectPrevious(), de.preventDefault(), !0;
      }
      return !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ARROW_DOWN_COMMAND, (de) => {
      const K = r.$getSelection();
      if (r.$isNodeSelection(K)) {
        const D = K.getNodes();
        if (D.length > 0)
          return D[0].selectNext(0, 0), !0;
      } else if (r.$isRangeSelection(K)) {
        if (q(K))
          return de.preventDefault(), !0;
        const D = r.$getAdjacentNode(K.focus, !1);
        if (!de.shiftKey && r.$isDecoratorNode(D) && !D.isIsolated() && !D.isInline())
          return D.selectNext(), de.preventDefault(), !0;
      }
      return !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ARROW_LEFT_COMMAND, (de) => {
      const K = r.$getSelection();
      if (r.$isNodeSelection(K)) {
        const D = K.getNodes();
        if (D.length > 0)
          return de.preventDefault(), D[0].selectPrevious(), !0;
      }
      if (!r.$isRangeSelection(K))
        return !1;
      if (t.$shouldOverrideDefaultCharacterSelection(K, !0)) {
        const D = de.shiftKey;
        return de.preventDefault(), t.$moveCharacter(K, D, !0), !0;
      }
      return !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ARROW_RIGHT_COMMAND, (de) => {
      const K = r.$getSelection();
      if (r.$isNodeSelection(K) && !z(de.target)) {
        const Z = K.getNodes();
        if (Z.length > 0)
          return de.preventDefault(), Z[0].selectNext(0, 0), !0;
      }
      if (!r.$isRangeSelection(K))
        return !1;
      const D = de.shiftKey;
      return t.$shouldOverrideDefaultCharacterSelection(K, !1) ? (de.preventDefault(), t.$moveCharacter(K, D, !1), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_BACKSPACE_COMMAND, (de) => {
      if (z(de.target))
        return !1;
      const K = r.$getSelection();
      if (!r.$isRangeSelection(K))
        return !1;
      de.preventDefault();
      const {
        anchor: D
      } = K, Z = D.getNode();
      return K.isCollapsed() && D.offset === 0 && !r.$isRootNode(Z) && n.$getNearestBlockElementAncestorOrThrow(Z).getIndent() > 0 ? Se.dispatchCommand(r.OUTDENT_CONTENT_COMMAND, void 0) : Se.dispatchCommand(r.DELETE_CHARACTER_COMMAND, !0);
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_DELETE_COMMAND, (de) => {
      if (z(de.target))
        return !1;
      const K = r.$getSelection();
      return r.$isRangeSelection(K) ? (de.preventDefault(), Se.dispatchCommand(r.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ENTER_COMMAND, (de) => {
      const K = r.$getSelection();
      if (!r.$isRangeSelection(K))
        return !1;
      if (de !== null) {
        if ((E || _ || S) && p)
          return !1;
        if (de.preventDefault(), de.shiftKey)
          return Se.dispatchCommand(r.INSERT_LINE_BREAK_COMMAND, !1);
      }
      return Se.dispatchCommand(r.INSERT_PARAGRAPH_COMMAND, void 0);
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.KEY_ESCAPE_COMMAND, () => {
      const de = r.$getSelection();
      return r.$isRangeSelection(de) ? (Se.blur(), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.DROP_COMMAND, (de) => {
      const [, K] = ce(de);
      if (K.length > 0) {
        const Z = de.clientX, oe = de.clientY, Y = l(Z, oe);
        if (Y !== null) {
          const {
            offset: W,
            node: J
          } = Y, R = r.$getNearestNodeFromDOMNode(J);
          if (R !== null) {
            const U = r.$createRangeSelection();
            if (r.$isTextNode(R))
              U.anchor.set(R.getKey(), W, "text"), U.focus.set(R.getKey(), W, "text");
            else {
              const fe = R.getParentOrThrow().getKey(), _e = R.getIndexWithinParent() + 1;
              U.anchor.set(fe, _e, "element"), U.focus.set(fe, _e, "element");
            }
            const X = r.$normalizeSelection__EXPERIMENTAL(U);
            r.$setSelection(X);
          }
          Se.dispatchCommand(w, K);
        }
        return de.preventDefault(), !0;
      }
      const D = r.$getSelection();
      return !!r.$isRangeSelection(D);
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.DRAGSTART_COMMAND, (de) => {
      const [K] = ce(de), D = r.$getSelection();
      return !(K && !r.$isRangeSelection(D));
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.DRAGOVER_COMMAND, (de) => {
      const [K] = ce(de), D = r.$getSelection();
      if (K && !r.$isRangeSelection(D))
        return !1;
      const Z = de.clientX, oe = de.clientY, Y = l(Z, oe);
      if (Y !== null) {
        const W = r.$getNearestNodeFromDOMNode(Y.node);
        r.$isDecoratorNode(W) && de.preventDefault();
      }
      return !0;
    }, r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.SELECT_ALL_COMMAND, () => (r.$selectAll(), !0), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.COPY_COMMAND, (de) => (e.copyToClipboard(Se, n.objectKlassEquals(de, ClipboardEvent) ? de : null), !0), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.CUT_COMMAND, (de) => (te(de, Se), !0), r.COMMAND_PRIORITY_EDITOR), Se.registerCommand(r.PASTE_COMMAND, (de) => {
      const [, K, D] = ce(de);
      if (K.length > 0 && !D)
        return Se.dispatchCommand(w, K), !0;
      if (r.isSelectionCapturedInDecoratorInput(de.target))
        return !1;
      const Z = r.$getSelection();
      return r.$INTERNAL_isPointSelection(Z) ? (re(de, Se), !0) : !1;
    }, r.COMMAND_PRIORITY_EDITOR));
  }
  return hi.$createHeadingNode = H, hi.$createQuoteNode = m, hi.$isHeadingNode = j, hi.$isQuoteNode = v, hi.DRAG_DROP_PASTE = w, hi.HeadingNode = I, hi.QuoteNode = O, hi.eventFiles = ce, hi.registerRichText = Te, hi;
}
var gi = {}, rh;
function QN() {
  if (rh) return gi;
  rh = 1;
  var e = vp(), t = vs(), n = gn(), r = Yt();
  function l(V, z) {
    return typeof document.caretRangeFromPoint < "u" ? (V = document.caretRangeFromPoint(V, z), V === null ? null : { node: V.startContainer, offset: V.startOffset }) : document.caretPositionFromPoint !== "undefined" ? (V = document.caretPositionFromPoint(V, z), V === null ? null : { node: V.offsetNode, offset: V.offset }) : null;
  }
  let d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", f = d && "documentMode" in document ? document.documentMode : null, p = d && "InputEvent" in window && !f ? "getTargetRanges" in new window.InputEvent("input") : !1, _ = d && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), E = d && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, T = d && /^(?=.*Chrome).*/i.test(navigator.userAgent), S = d && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !T, w = r.createCommand("DRAG_DROP_PASTE_FILE");
  class O extends r.ElementNode {
    static getType() {
      return "quote";
    }
    static clone(z) {
      return new O(z.__key);
    }
    constructor(z) {
      super(z);
    }
    createDOM(z) {
      let q = document.createElement("blockquote");
      return n.addClassNamesToElement(q, z.theme.quote), q;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { blockquote: () => ({ conversion: k, priority: 0 }) };
    }
    exportDOM(z) {
      if ({ element: z } = super.exportDOM(z), z && n.isHTMLElement(z)) {
        this.isEmpty() && z.append(document.createElement("br"));
        var q = this.getFormatType();
        z.style.textAlign = q, (q = this.getDirection()) && (z.dir = q);
      }
      return { element: z };
    }
    static importJSON(z) {
      let q = m();
      return q.setFormat(z.format), q.setIndent(z.indent), q.setDirection(z.direction), q;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "quote" };
    }
    insertNewAfter(z, q) {
      z = r.$createParagraphNode();
      let Te = this.getDirection();
      return z.setDirection(Te), this.insertAfter(z, q), z;
    }
    collapseAtStart() {
      let z = r.$createParagraphNode();
      return this.getChildren().forEach((q) => z.append(q)), this.replace(z), !0;
    }
  }
  function m() {
    return r.$applyNodeReplacement(new O());
  }
  class v extends r.ElementNode {
    static getType() {
      return "heading";
    }
    static clone(z) {
      return new v(z.__tag, z.__key);
    }
    constructor(z, q) {
      super(q), this.__tag = z;
    }
    getTag() {
      return this.__tag;
    }
    createDOM(z) {
      let q = this.__tag, Te = document.createElement(q);
      return z = z.theme.heading, z !== void 0 && n.addClassNamesToElement(Te, z[q]), Te;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { h1: () => ({ conversion: G, priority: 0 }), h2: () => ({ conversion: G, priority: 0 }), h3: () => ({ conversion: G, priority: 0 }), h4: () => ({ conversion: G, priority: 0 }), h5: () => ({
        conversion: G,
        priority: 0
      }), h6: () => ({ conversion: G, priority: 0 }), p: (z) => (z = z.firstChild, z !== null && I(z) ? { conversion: () => ({ node: null }), priority: 3 } : null), span: (z) => I(z) ? { conversion: () => ({ node: P("h1") }), priority: 3 } : null };
    }
    exportDOM(z) {
      if ({ element: z } = super.exportDOM(z), z && n.isHTMLElement(z)) {
        this.isEmpty() && z.append(document.createElement("br"));
        var q = this.getFormatType();
        z.style.textAlign = q, (q = this.getDirection()) && (z.dir = q);
      }
      return { element: z };
    }
    static importJSON(z) {
      let q = P(z.tag);
      return q.setFormat(z.format), q.setIndent(z.indent), q.setDirection(z.direction), q;
    }
    exportJSON() {
      return { ...super.exportJSON(), tag: this.getTag(), type: "heading", version: 1 };
    }
    insertNewAfter(z, q = !0) {
      let Te = z ? z.anchor.offset : 0, Se = Te !== this.getTextContentSize() && z ? P(this.getTag()) : r.$createParagraphNode(), Ee = this.getDirection();
      return Se.setDirection(Ee), this.insertAfter(Se, q), Te === 0 && !this.isEmpty() && z && (z = r.$createParagraphNode(), z.select(), this.replace(z, !0)), Se;
    }
    collapseAtStart() {
      let z = this.isEmpty() ? r.$createParagraphNode() : P(this.getTag());
      return this.getChildren().forEach((q) => z.append(q)), this.replace(z), !0;
    }
    extractWithChild() {
      return !0;
    }
  }
  function I(V) {
    return V.nodeName.toLowerCase() === "span" ? V.style.fontSize === "26pt" : !1;
  }
  function G(V) {
    let z = V.nodeName.toLowerCase(), q = null;
    return (z === "h1" || z === "h2" || z === "h3" || z === "h4" || z === "h5" || z === "h6") && (q = P(z), V.style !== null && q.setFormat(V.style.textAlign)), { node: q };
  }
  function k(V) {
    let z = m();
    return V.style !== null && z.setFormat(V.style.textAlign), { node: z };
  }
  function P(V) {
    return r.$applyNodeReplacement(new v(V));
  }
  function H(V, z) {
    V.preventDefault(), z.update(() => {
      let q = r.$getSelection(), Te = V instanceof InputEvent || V instanceof KeyboardEvent ? null : V.clipboardData;
      Te != null && r.$INTERNAL_isPointSelection(q) && e.$insertDataTransferForRichText(Te, q, z);
    }, { tag: "paste" });
  }
  async function j(V, z) {
    await e.copyToClipboard(z, n.objectKlassEquals(V, ClipboardEvent) ? V : null), z.update(() => {
      let q = r.$getSelection();
      r.$isRangeSelection(q) ? q.removeText() : r.$isNodeSelection(q) && q.getNodes().forEach((Te) => Te.remove());
    });
  }
  function re(V) {
    let z = null;
    if (V instanceof DragEvent ? z = V.dataTransfer : V instanceof ClipboardEvent && (z = V.clipboardData), z === null) return [!1, [], !1];
    var q = z.types;
    return V = q.includes("Files"), q = q.includes("text/html") || q.includes("text/plain"), [V, Array.from(z.files), q];
  }
  function te(V) {
    var z = r.$getSelection();
    if (!r.$isRangeSelection(z)) return !1;
    let q = /* @__PURE__ */ new Set();
    z = z.getNodes();
    for (let Ee = 0; Ee < z.length; Ee++) {
      var Te = z[Ee], Se = Te.getKey();
      q.has(Se) || (Te = n.$getNearestBlockElementAncestorOrThrow(Te), Se = Te.getKey(), Te.canIndent() && !q.has(Se) && (q.add(Se), V(Te)));
    }
    return 0 < q.size;
  }
  function ce(V) {
    return V = r.$getNearestNodeFromDOMNode(V), r.$isDecoratorNode(V);
  }
  return gi.$createHeadingNode = P, gi.$createQuoteNode = m, gi.$isHeadingNode = function(V) {
    return V instanceof v;
  }, gi.$isQuoteNode = function(V) {
    return V instanceof O;
  }, gi.DRAG_DROP_PASTE = w, gi.HeadingNode = v, gi.QuoteNode = O, gi.eventFiles = re, gi.registerRichText = function(V) {
    return n.mergeRegister(
      V.registerCommand(r.CLICK_COMMAND, () => {
        const z = r.$getSelection();
        return r.$isNodeSelection(z) ? (z.clear(), !0) : !1;
      }, 0),
      V.registerCommand(r.DELETE_CHARACTER_COMMAND, (z) => {
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (q.deleteCharacter(z), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.DELETE_WORD_COMMAND, (z) => {
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (q.deleteWord(z), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.DELETE_LINE_COMMAND, (z) => {
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (q.deleteLine(z), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.CONTROLLED_TEXT_INSERTION_COMMAND, (z) => {
        const q = r.$getSelection();
        if (typeof z == "string") r.$INTERNAL_isPointSelection(q) && q.insertText(z);
        else {
          if (!r.$INTERNAL_isPointSelection(q)) return !1;
          const Te = z.dataTransfer;
          Te != null ? e.$insertDataTransferForRichText(Te, q, V) : r.$isRangeSelection(q) && (z = z.data) && q.insertText(z);
        }
        return !0;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.REMOVE_TEXT_COMMAND, () => {
        const z = r.$getSelection();
        return r.$isRangeSelection(z) ? (z.removeText(), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.FORMAT_TEXT_COMMAND, (z) => {
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (q.formatText(z), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.FORMAT_ELEMENT_COMMAND, (z) => {
        var q = r.$getSelection();
        if (!r.$isRangeSelection(q) && !r.$isNodeSelection(q)) return !1;
        q = q.getNodes();
        for (const Te of q) q = n.$findMatchingParent(
          Te,
          (Se) => r.$isElementNode(Se) && !Se.isInline()
        ), q !== null && q.setFormat(z);
        return !0;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.INSERT_LINE_BREAK_COMMAND, (z) => {
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (q.insertLineBreak(z), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.INSERT_PARAGRAPH_COMMAND, () => {
        const z = r.$getSelection();
        return r.$isRangeSelection(z) ? (z.insertParagraph(), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.INSERT_TAB_COMMAND, () => (r.$insertNodes([r.$createTabNode()]), !0), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.INDENT_CONTENT_COMMAND, () => te((z) => {
        const q = z.getIndent();
        z.setIndent(q + 1);
      }), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.OUTDENT_CONTENT_COMMAND, () => te((z) => {
        const q = z.getIndent();
        0 < q && z.setIndent(q - 1);
      }), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.KEY_ARROW_UP_COMMAND, (z) => {
        var q = r.$getSelection();
        if (r.$isNodeSelection(q) && !ce(z.target)) {
          if (z = q.getNodes(), 0 < z.length) return z[0].selectPrevious(), !0;
        } else if (r.$isRangeSelection(q) && (q = r.$getAdjacentNode(
          q.focus,
          !0
        ), !z.shiftKey && r.$isDecoratorNode(q) && !q.isIsolated() && !q.isInline())) return q.selectPrevious(), z.preventDefault(), !0;
        return !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.KEY_ARROW_DOWN_COMMAND, (z) => {
        var q = r.$getSelection();
        if (r.$isNodeSelection(q)) {
          if (z = q.getNodes(), 0 < z.length) return z[0].selectNext(0, 0), !0;
        } else if (r.$isRangeSelection(q)) {
          let Te = q.focus;
          if (Te.key === "root" && Te.offset === r.$getRoot().getChildrenSize()) return z.preventDefault(), !0;
          if (q = r.$getAdjacentNode(q.focus, !1), !z.shiftKey && r.$isDecoratorNode(q) && !q.isIsolated() && !q.isInline()) return q.selectNext(), z.preventDefault(), !0;
        }
        return !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.KEY_ARROW_LEFT_COMMAND, (z) => {
        const q = r.$getSelection();
        if (r.$isNodeSelection(q)) {
          var Te = q.getNodes();
          if (0 < Te.length) return z.preventDefault(), Te[0].selectPrevious(), !0;
        }
        return r.$isRangeSelection(q) && t.$shouldOverrideDefaultCharacterSelection(q, !0) ? (Te = z.shiftKey, z.preventDefault(), t.$moveCharacter(q, Te, !0), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(
        r.KEY_ARROW_RIGHT_COMMAND,
        (z) => {
          const q = r.$getSelection();
          if (r.$isNodeSelection(q) && !ce(z.target)) {
            var Te = q.getNodes();
            if (0 < Te.length) return z.preventDefault(), Te[0].selectNext(0, 0), !0;
          }
          return r.$isRangeSelection(q) ? (Te = z.shiftKey, t.$shouldOverrideDefaultCharacterSelection(q, !1) ? (z.preventDefault(), t.$moveCharacter(q, Te, !1), !0) : !1) : !1;
        },
        r.COMMAND_PRIORITY_EDITOR
      ),
      V.registerCommand(r.KEY_BACKSPACE_COMMAND, (z) => {
        if (ce(z.target)) return !1;
        const q = r.$getSelection();
        if (!r.$isRangeSelection(q)) return !1;
        z.preventDefault(), { anchor: z } = q;
        const Te = z.getNode();
        return q.isCollapsed() && z.offset === 0 && !r.$isRootNode(Te) && 0 < n.$getNearestBlockElementAncestorOrThrow(Te).getIndent() ? V.dispatchCommand(r.OUTDENT_CONTENT_COMMAND, void 0) : V.dispatchCommand(r.DELETE_CHARACTER_COMMAND, !0);
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.KEY_DELETE_COMMAND, (z) => {
        if (ce(z.target)) return !1;
        const q = r.$getSelection();
        return r.$isRangeSelection(q) ? (z.preventDefault(), V.dispatchCommand(r.DELETE_CHARACTER_COMMAND, !1)) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(
        r.KEY_ENTER_COMMAND,
        (z) => {
          const q = r.$getSelection();
          if (!r.$isRangeSelection(q)) return !1;
          if (z !== null) {
            if ((E || _ || S) && p) return !1;
            if (z.preventDefault(), z.shiftKey) return V.dispatchCommand(r.INSERT_LINE_BREAK_COMMAND, !1);
          }
          return V.dispatchCommand(r.INSERT_PARAGRAPH_COMMAND, void 0);
        },
        r.COMMAND_PRIORITY_EDITOR
      ),
      V.registerCommand(r.KEY_ESCAPE_COMMAND, () => {
        const z = r.$getSelection();
        return r.$isRangeSelection(z) ? (V.blur(), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.DROP_COMMAND, (z) => {
        const [, q] = re(z);
        if (0 < q.length) {
          var Te = l(z.clientX, z.clientY);
          if (Te !== null) {
            const { offset: Ee, node: de } = Te;
            var Se = r.$getNearestNodeFromDOMNode(de);
            if (Se !== null) {
              if (Te = r.$createRangeSelection(), r.$isTextNode(Se)) Te.anchor.set(Se.getKey(), Ee, "text"), Te.focus.set(Se.getKey(), Ee, "text");
              else {
                const K = Se.getParentOrThrow().getKey();
                Se = Se.getIndexWithinParent() + 1, Te.anchor.set(K, Se, "element"), Te.focus.set(K, Se, "element");
              }
              Te = r.$normalizeSelection__EXPERIMENTAL(Te), r.$setSelection(Te);
            }
            V.dispatchCommand(w, q);
          }
          return z.preventDefault(), !0;
        }
        return z = r.$getSelection(), !!r.$isRangeSelection(z);
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.DRAGSTART_COMMAND, (z) => {
        [z] = re(z);
        const q = r.$getSelection();
        return !(z && !r.$isRangeSelection(q));
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.DRAGOVER_COMMAND, (z) => {
        var [q] = re(z);
        const Te = r.$getSelection();
        return q && !r.$isRangeSelection(Te) ? !1 : (q = l(z.clientX, z.clientY), q !== null && (q = r.$getNearestNodeFromDOMNode(q.node), r.$isDecoratorNode(q) && z.preventDefault()), !0);
      }, r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.SELECT_ALL_COMMAND, () => (r.$selectAll(), !0), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.COPY_COMMAND, (z) => (e.copyToClipboard(V, n.objectKlassEquals(z, ClipboardEvent) ? z : null), !0), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.CUT_COMMAND, (z) => (j(z, V), !0), r.COMMAND_PRIORITY_EDITOR),
      V.registerCommand(r.PASTE_COMMAND, (z) => {
        const [, q, Te] = re(z);
        if (0 < q.length && !Te) return V.dispatchCommand(w, q), !0;
        if (r.isSelectionCapturedInDecoratorInput(z.target)) return !1;
        const Se = r.$getSelection();
        return r.$INTERNAL_isPointSelection(Se) ? (H(z, V), !0) : !1;
      }, r.COMMAND_PRIORITY_EDITOR)
    );
  }, gi;
}
var gu, ih;
function md() {
  return ih || (ih = 1, gu = process.env.NODE_ENV === "development" ? XN() : QN()), gu;
}
var sh;
function eC() {
  if (sh) return nu;
  sh = 1;
  var e = qn(), t = Cp(), n = xn, r = Ep(), l = gn(), d = sp, f = Tp(), p = md(), T = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? n.useLayoutEffect : n.useEffect;
  function S(G) {
    return G.getEditorState().read(r.$canShowPlaceholderCurry(G.isComposing()));
  }
  function w(G) {
    const [k, P] = n.useState(() => S(G));
    return T(() => {
      function H() {
        const j = S(G);
        P(j);
      }
      return H(), l.mergeRegister(G.registerUpdateListener(() => {
        H();
      }), G.registerEditableListener(() => {
        H();
      }));
    }, [G]), k;
  }
  function O(G, k) {
    const [P, H] = n.useState(() => G.getDecorators());
    return T(() => G.registerDecoratorListener((j) => {
      d.flushSync(() => {
        H(j);
      });
    }), [G]), n.useEffect(() => {
      H(G.getDecorators());
    }, [G]), n.useMemo(() => {
      const j = [], re = Object.keys(P);
      for (let te = 0; te < re.length; te++) {
        const ce = re[te], V = /* @__PURE__ */ n.createElement(k, {
          onError: (q) => G._onError(q)
        }, /* @__PURE__ */ n.createElement(n.Suspense, {
          fallback: null
        }, P[ce])), z = G.getElementByKey(ce);
        z !== null && j.push(/* @__PURE__ */ d.createPortal(V, z, ce));
      }
      return j;
    }, [k, P, G]);
  }
  function m(G) {
    T(() => l.mergeRegister(p.registerRichText(G), f.registerDragonSupport(G)), [G]);
  }
  function v({
    contentEditable: G,
    placeholder: k,
    ErrorBoundary: P
  }) {
    const [H] = e.useLexicalComposerContext(), j = O(H, P);
    return m(H), /* @__PURE__ */ n.createElement(n.Fragment, null, G, /* @__PURE__ */ n.createElement(I, {
      content: k
    }), j);
  }
  function I({
    content: G
  }) {
    const [k] = e.useLexicalComposerContext(), P = w(k), H = t();
    return P ? typeof G == "function" ? G(H) : G : null;
  }
  return nu.RichTextPlugin = v, nu;
}
var pu = {}, oh;
function tC() {
  if (oh) return pu;
  oh = 1;
  var e = qn(), t = Cp(), n = xn, r = Ep(), l = gn(), d = sp, f = Tp(), p = md(), _ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? n.useLayoutEffect : n.useEffect;
  function E(m) {
    return m.getEditorState().read(r.$canShowPlaceholderCurry(m.isComposing()));
  }
  function T(m) {
    let [v, I] = n.useState(() => E(m));
    return _(() => {
      function G() {
        let k = E(m);
        I(k);
      }
      return G(), l.mergeRegister(m.registerUpdateListener(() => {
        G();
      }), m.registerEditableListener(() => {
        G();
      }));
    }, [m]), v;
  }
  function S(m, v) {
    let [I, G] = n.useState(() => m.getDecorators());
    return _(() => m.registerDecoratorListener((k) => {
      d.flushSync(() => {
        G(k);
      });
    }), [m]), n.useEffect(() => {
      G(m.getDecorators());
    }, [m]), n.useMemo(() => {
      let k = [], P = Object.keys(I);
      for (let H = 0; H < P.length; H++) {
        let j = P[H], re = n.createElement(v, { onError: (ce) => m._onError(ce) }, n.createElement(n.Suspense, { fallback: null }, I[j])), te = m.getElementByKey(j);
        te !== null && k.push(d.createPortal(re, te, j));
      }
      return k;
    }, [v, I, m]);
  }
  function w(m) {
    _(() => l.mergeRegister(p.registerRichText(m), f.registerDragonSupport(m)), [m]);
  }
  function O({ content: m }) {
    var [v] = e.useLexicalComposerContext();
    v = T(v);
    let I = t();
    return v ? typeof m == "function" ? m(I) : m : null;
  }
  return pu.RichTextPlugin = function({ contentEditable: m, placeholder: v, ErrorBoundary: I }) {
    let [G] = e.useLexicalComposerContext();
    return I = S(G, I), w(G), n.createElement(n.Fragment, null, m, n.createElement(O, { content: v }), I);
  }, pu;
}
const nC = process.env.NODE_ENV === "development" ? eC() : tC();
var rC = nC, mu = {}, lh;
function iC() {
  if (lh) return mu;
  lh = 1;
  var e = qn(), t = xn;
  function n() {
    return n = Object.assign ? Object.assign.bind() : function(p) {
      for (var _ = 1; _ < arguments.length; _++) {
        var E = arguments[_];
        for (var T in E)
          Object.prototype.hasOwnProperty.call(E, T) && (p[T] = E[T]);
      }
      return p;
    }, n.apply(this, arguments);
  }
  var d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function f({
    ariaActiveDescendant: p,
    ariaAutoComplete: _,
    ariaControls: E,
    ariaDescribedBy: T,
    ariaExpanded: S,
    ariaLabel: w,
    ariaLabelledBy: O,
    ariaMultiline: m,
    ariaOwns: v,
    ariaRequired: I,
    autoCapitalize: G,
    className: k,
    id: P,
    role: H = "textbox",
    spellCheck: j = !0,
    style: re,
    tabIndex: te,
    "data-testid": ce,
    ...V
  }) {
    const [z] = e.useLexicalComposerContext(), [q, Te] = t.useState(!1), Se = t.useCallback((Ee) => {
      z.setRootElement(Ee);
    }, [z]);
    return d(() => (Te(z.isEditable()), z.registerEditableListener((Ee) => {
      Te(Ee);
    })), [z]), /* @__PURE__ */ t.createElement("div", n({}, V, {
      "aria-activedescendant": q ? p : void 0,
      "aria-autocomplete": q ? _ : "none",
      "aria-controls": q ? E : void 0,
      "aria-describedby": T,
      "aria-expanded": q && H === "combobox" ? !!S : void 0,
      "aria-label": w,
      "aria-labelledby": O,
      "aria-multiline": m,
      "aria-owns": q ? v : void 0,
      "aria-readonly": q ? void 0 : !0,
      "aria-required": I,
      autoCapitalize: G,
      className: k,
      contentEditable: q,
      "data-testid": ce,
      id: P,
      ref: Se,
      role: H,
      spellCheck: j,
      style: re,
      tabIndex: te
    }));
  }
  return mu.ContentEditable = f, mu;
}
var _u = {}, ah;
function sC() {
  if (ah) return _u;
  ah = 1;
  var e = qn(), t = xn;
  function n() {
    return n = Object.assign ? Object.assign.bind() : function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d], p;
        for (p in f) Object.prototype.hasOwnProperty.call(f, p) && (l[p] = f[p]);
      }
      return l;
    }, n.apply(this, arguments);
  }
  var r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  return _u.ContentEditable = function({ ariaActiveDescendant: l, ariaAutoComplete: d, ariaControls: f, ariaDescribedBy: p, ariaExpanded: _, ariaLabel: E, ariaLabelledBy: T, ariaMultiline: S, ariaOwns: w, ariaRequired: O, autoCapitalize: m, className: v, id: I, role: G = "textbox", spellCheck: k = !0, style: P, tabIndex: H, "data-testid": j, ...re }) {
    let [te] = e.useLexicalComposerContext(), [ce, V] = t.useState(!1), z = t.useCallback((q) => {
      te.setRootElement(q);
    }, [te]);
    return r(() => (V(te.isEditable()), te.registerEditableListener((q) => {
      V(q);
    })), [te]), t.createElement(
      "div",
      n({}, re, { "aria-activedescendant": ce ? l : void 0, "aria-autocomplete": ce ? d : "none", "aria-controls": ce ? f : void 0, "aria-describedby": p, "aria-expanded": ce && G === "combobox" ? !!_ : void 0, "aria-label": E, "aria-labelledby": T, "aria-multiline": S, "aria-owns": ce ? w : void 0, "aria-readonly": ce ? void 0 : !0, "aria-required": O, autoCapitalize: m, className: v, contentEditable: ce, "data-testid": j, id: I, ref: z, role: G, spellCheck: k, style: P, tabIndex: H })
    );
  }, _u;
}
const oC = process.env.NODE_ENV === "development" ? iC() : sC();
var lC = oC, yu, ch;
function aC() {
  if (ch) return yu;
  ch = 1;
  var e = xn;
  function t(p, _) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(T, S) {
      return T.__proto__ = S, T;
    }, t(p, _);
  }
  function n(p, _) {
    p.prototype = Object.create(_.prototype), p.prototype.constructor = p, t(p, _);
  }
  var r = function(_, E) {
    return _ === void 0 && (_ = []), E === void 0 && (E = []), _.length !== E.length || _.some(function(T, S) {
      return !Object.is(T, E[S]);
    });
  }, l = {
    error: null
  }, d = /* @__PURE__ */ function(p) {
    n(_, p);
    function _() {
      for (var T, S = arguments.length, w = new Array(S), O = 0; O < S; O++)
        w[O] = arguments[O];
      return T = p.call.apply(p, [this].concat(w)) || this, T.state = l, T.resetErrorBoundary = function() {
        for (var m, v = arguments.length, I = new Array(v), G = 0; G < v; G++)
          I[G] = arguments[G];
        T.props.onReset == null || (m = T.props).onReset.apply(m, I), T.reset();
      }, T;
    }
    _.getDerivedStateFromError = function(S) {
      return {
        error: S
      };
    };
    var E = _.prototype;
    return E.reset = function() {
      this.setState(l);
    }, E.componentDidCatch = function(S, w) {
      var O, m;
      (O = (m = this.props).onError) == null || O.call(m, S, w);
    }, E.componentDidUpdate = function(S, w) {
      var O = this.state.error, m = this.props.resetKeys;
      if (O !== null && w.error !== null && r(S.resetKeys, m)) {
        var v, I;
        (v = (I = this.props).onResetKeysChange) == null || v.call(I, S.resetKeys, m), this.reset();
      }
    }, E.render = function() {
      var S = this.state.error, w = this.props, O = w.fallbackRender, m = w.FallbackComponent, v = w.fallback;
      if (S !== null) {
        var I = {
          error: S,
          resetErrorBoundary: this.resetErrorBoundary
        };
        if (/* @__PURE__ */ e.isValidElement(v))
          return v;
        if (typeof O == "function")
          return O(I);
        if (m)
          return /* @__PURE__ */ e.createElement(m, I);
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
      return this.props.children;
    }, _;
  }(e.Component);
  function f({
    children: p,
    onError: _
  }) {
    return /* @__PURE__ */ e.createElement(d, {
      fallback: /* @__PURE__ */ e.createElement("div", {
        style: {
          border: "1px solid #f00",
          color: "#f00",
          padding: "8px"
        }
      }, "An error was thrown."),
      onError: _
    }, p);
  }
  return yu = f, yu;
}
var Nu, uh;
function cC() {
  if (uh) return Nu;
  uh = 1;
  var e = xn;
  function t(f, p) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, E) {
      return _.__proto__ = E, _;
    }, t(f, p);
  }
  function n(f, p) {
    f.prototype = Object.create(p.prototype), f.prototype.constructor = f, t(f, p);
  }
  function r(f, p) {
    return f === void 0 && (f = []), p === void 0 && (p = []), f.length !== p.length || f.some(function(_, E) {
      return !Object.is(_, p[E]);
    });
  }
  var l = { error: null }, d = function(f) {
    function p() {
      for (var E, T = arguments.length, S = Array(T), w = 0; w < T; w++) S[w] = arguments[w];
      return E = f.call.apply(f, [this].concat(S)) || this, E.state = l, E.resetErrorBoundary = function() {
        for (var O, m = arguments.length, v = Array(m), I = 0; I < m; I++) v[I] = arguments[I];
        E.props.onReset == null || (O = E.props).onReset.apply(O, v), E.reset();
      }, E;
    }
    n(p, f), p.getDerivedStateFromError = function(E) {
      return { error: E };
    };
    var _ = p.prototype;
    return _.reset = function() {
      this.setState(l);
    }, _.componentDidCatch = function(E, T) {
      var S, w;
      (S = (w = this.props).onError) == null || S.call(w, E, T);
    }, _.componentDidUpdate = function(E, T) {
      var S = this.props.resetKeys;
      if (this.state.error !== null && T.error !== null && r(E.resetKeys, S)) {
        var w, O;
        (w = (O = this.props).onResetKeysChange) == null || w.call(O, E.resetKeys, S), this.reset();
      }
    }, _.render = function() {
      var E = this.state.error, T = this.props, S = T.fallbackRender, w = T.FallbackComponent;
      if (T = T.fallback, E !== null) {
        if (E = { error: E, resetErrorBoundary: this.resetErrorBoundary }, e.isValidElement(T)) return T;
        if (typeof S == "function") return S(E);
        if (w) return e.createElement(w, E);
        throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
      return this.props.children;
    }, p;
  }(e.Component);
  return Nu = function({ children: f, onError: p }) {
    return e.createElement(d, { fallback: e.createElement("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" } }, "An error was thrown."), onError: p }, f);
  }, Nu;
}
const uC = process.env.NODE_ENV === "development" ? aC() : cC();
var dC = uC;
const fC = /* @__PURE__ */ op(dC);
var Cu = {}, pr = {}, dh;
function hC() {
  if (dh) return pr;
  dh = 1;
  var e = Yt(), t = gn();
  function n(Y) {
    let W = 1, J = Y.getParent();
    for (; J != null; ) {
      if (ce(J)) {
        const R = J.getParent();
        if (de(R)) {
          W++, J = R.getParent();
          continue;
        }
        throw Error("A ListItemNode must have a ListNode for a parent.");
      }
      return W;
    }
    return W;
  }
  function r(Y) {
    let W = Y.getParent();
    if (!de(W))
      throw Error("A ListItemNode must have a ListNode for a parent.");
    let J = W;
    for (; J !== null; )
      J = J.getParent(), de(J) && (W = J);
    return W;
  }
  function l(Y) {
    let W = [];
    const J = Y.getChildren().filter(ce);
    for (let R = 0; R < J.length; R++) {
      const U = J[R], X = U.getFirstChild();
      de(X) ? W = W.concat(l(X)) : W.push(U);
    }
    return W;
  }
  function d(Y) {
    return ce(Y) && de(Y.getFirstChild());
  }
  function f(Y) {
    let W = Y;
    for (; W.getNextSibling() == null && W.getPreviousSibling() == null; ) {
      const J = W.getParent();
      if (J == null || !(ce(W) || de(W)))
        break;
      W = J;
    }
    W.remove();
  }
  function p(Y) {
    return te().append(Y);
  }
  function _(Y, W) {
    return ce(Y) && (W.length === 0 || W.length === 1 && Y.is(W[0]) && Y.getChildrenSize() === 0);
  }
  function E(Y) {
    const W = Y.getParent();
    let J = 1;
    if (W != null)
      if (de(W))
        J = W.getStart();
      else
        throw Error("$getListItemValue: list node is not parent of list item node");
    const R = Y.getPreviousSiblings();
    for (let U = 0; U < R.length; U++) {
      const X = R[U];
      ce(X) && !de(X.getFirstChild()) && J++;
    }
    return J;
  }
  function T(Y, W) {
    Y.update(() => {
      const J = e.$getSelection();
      if (e.$INTERNAL_isPointSelection(J)) {
        const R = J.getNodes(), X = J.anchor.getNode(), fe = X.getParent();
        if (_(X, R)) {
          const _e = Ee(W);
          if (e.$isRootOrShadowRoot(fe)) {
            X.replace(_e);
            const B = te();
            e.$isElementNode(X) && (B.setFormat(X.getFormatType()), B.setIndent(X.getIndent())), _e.append(B);
          } else if (ce(X)) {
            const B = X.getParentOrThrow();
            S(_e, B.getChildren()), B.replace(_e);
          }
          return;
        } else {
          const _e = /* @__PURE__ */ new Set();
          for (let B = 0; B < R.length; B++) {
            const M = R[B];
            if (e.$isElementNode(M) && M.isEmpty() && !ce(M) && !_e.has(M.getKey())) {
              w(M, W);
              continue;
            }
            if (e.$isLeafNode(M)) {
              let F = M.getParent();
              for (; F != null; ) {
                const se = F.getKey();
                if (de(F)) {
                  if (!_e.has(se)) {
                    const ye = Ee(W);
                    S(ye, F.getChildren()), F.replace(ye), v(ye), _e.add(se);
                  }
                  break;
                } else {
                  const ye = F.getParent();
                  if (e.$isRootOrShadowRoot(ye) && !_e.has(se)) {
                    _e.add(se), w(F, W);
                    break;
                  }
                  F = ye;
                }
              }
            }
          }
        }
      }
    });
  }
  function S(Y, W) {
    Y.splice(Y.getChildrenSize(), 0, W);
  }
  function w(Y, W) {
    if (de(Y))
      return Y;
    const J = Y.getPreviousSibling(), R = Y.getNextSibling(), U = te();
    if (U.setFormat(Y.getFormatType()), U.setIndent(Y.getIndent()), S(U, Y.getChildren()), de(J) && W === J.getListType())
      return J.append(U), Y.remove(), de(R) && W === R.getListType() && (S(J, R.getChildren()), R.remove()), J;
    if (de(R) && W === R.getListType())
      return R.getFirstChildOrThrow().insertBefore(U), Y.remove(), R;
    {
      const X = Ee(W);
      return X.append(U), Y.replace(X), v(X), X;
    }
  }
  function O(Y, W) {
    const J = Y.getLastChild(), R = W.getFirstChild();
    J && R && d(J) && d(R) && (O(J.getFirstChild(), R.getFirstChild()), R.remove());
    const U = W.getChildren();
    U.length > 0 && (Y.append(...U), v(Y)), W.remove();
  }
  function m(Y) {
    Y.update(() => {
      const W = e.$getSelection();
      if (e.$isRangeSelection(W)) {
        const J = /* @__PURE__ */ new Set(), R = W.getNodes(), U = W.anchor.getNode();
        if (_(U, R))
          J.add(r(U));
        else
          for (let X = 0; X < R.length; X++) {
            const fe = R[X];
            if (e.$isLeafNode(fe)) {
              const _e = t.$getNearestNodeOfType(fe, P);
              _e != null && J.add(r(_e));
            }
          }
        for (const X of J) {
          let fe = X;
          const _e = l(X);
          for (const B of _e) {
            const M = e.$createParagraphNode();
            S(M, B.getChildren()), fe.insertAfter(M), fe = M, B.__key === W.anchor.key && W.anchor.set(M.getKey(), 0, "element"), B.__key === W.focus.key && W.focus.set(M.getKey(), 0, "element"), B.remove();
          }
          X.remove();
        }
      }
    });
  }
  function v(Y, W) {
    const J = W || Y.getChildren();
    if (J !== void 0)
      for (let R = 0; R < J.length; R++) {
        const U = J[R];
        if (ce(U)) {
          const X = U.getValue(), fe = E(U);
          X !== fe && U.setValue(fe);
        }
      }
  }
  function I(Y) {
    const W = /* @__PURE__ */ new Set();
    if (d(Y) || W.has(Y.getKey()))
      return;
    const J = Y.getParent(), R = Y.getNextSibling(), U = Y.getPreviousSibling();
    if (d(R) && d(U)) {
      const X = U.getFirstChild();
      if (de(X)) {
        X.append(Y);
        const fe = R.getFirstChild();
        if (de(fe)) {
          const _e = fe.getChildren();
          S(X, _e), R.remove(), W.add(R.getKey());
        }
        v(X);
      }
    } else if (d(R)) {
      const X = R.getFirstChild();
      if (de(X)) {
        const fe = X.getFirstChild();
        fe !== null && fe.insertBefore(Y), v(X);
      }
    } else if (d(U)) {
      const X = U.getFirstChild();
      de(X) && (X.append(Y), v(X));
    } else if (de(J)) {
      const X = te(), fe = Ee(J.getListType());
      X.append(fe), fe.append(Y), U ? U.insertAfter(X) : R ? R.insertBefore(X) : J.append(X), v(fe);
    }
    de(J) && v(J);
  }
  function G(Y) {
    if (d(Y))
      return;
    const W = Y.getParent(), J = W ? W.getParent() : void 0, R = J ? J.getParent() : void 0;
    if (de(R) && ce(J) && de(W)) {
      const U = W ? W.getFirstChild() : void 0, X = W ? W.getLastChild() : void 0;
      if (Y.is(U))
        J.insertBefore(Y), W.isEmpty() && J.remove();
      else if (Y.is(X))
        J.insertAfter(Y), W.isEmpty() && J.remove();
      else {
        const fe = W.getListType(), _e = te(), B = Ee(fe);
        _e.append(B), Y.getPreviousSiblings().forEach((se) => B.append(se));
        const M = te(), F = Ee(fe);
        M.append(F), S(F, Y.getNextSiblings()), J.insertBefore(_e), J.insertAfter(M), J.replace(Y);
      }
      v(W), v(R);
    }
  }
  function k() {
    const Y = e.$getSelection();
    if (!e.$isRangeSelection(Y) || !Y.isCollapsed())
      return !1;
    const W = Y.anchor.getNode();
    if (!ce(W) || W.getChildrenSize() !== 0)
      return !1;
    const J = r(W), R = W.getParent();
    if (!de(R))
      throw Error("A ListItemNode must have a ListNode for a parent.");
    const U = R.getParent();
    let X;
    if (e.$isRootOrShadowRoot(U))
      X = e.$createParagraphNode(), J.insertAfter(X);
    else if (ce(U))
      X = te(), U.insertAfter(X);
    else
      return !1;
    X.select();
    const fe = W.getNextSiblings();
    if (fe.length > 0) {
      const _e = Ee(R.getListType());
      if (e.$isParagraphNode(X))
        X.insertAfter(_e);
      else {
        const B = te();
        B.append(_e), X.insertAfter(B);
      }
      fe.forEach((B) => {
        B.remove(), _e.append(B);
      });
    }
    return f(W), !0;
  }
  class P extends e.ElementNode {
    /** @internal */
    /** @internal */
    static getType() {
      return "listitem";
    }
    static clone(W) {
      return new P(W.__value, W.__checked, W.__key);
    }
    constructor(W, J, R) {
      super(R), this.__value = W === void 0 ? 1 : W, this.__checked = J;
    }
    createDOM(W) {
      const J = document.createElement("li"), R = this.getParent();
      return de(R) && R.getListType() === "check" && j(J, this, null), J.value = this.__value, H(J, W.theme, this), J;
    }
    updateDOM(W, J, R) {
      const U = this.getParent();
      return de(U) && U.getListType() === "check" && j(J, this, W), J.value = this.__value, H(J, R.theme, this), !1;
    }
    static transform() {
      return (W) => {
        const J = W.getParent();
        if (de(J)) {
          if (v(J), !ce(W))
            throw Error("node is not a ListItemNode");
          J.getListType() !== "check" && W.getChecked() != null && W.setChecked(void 0);
        }
      };
    }
    static importDOM() {
      return {
        li: (W) => ({
          conversion: re,
          priority: 0
        })
      };
    }
    static importJSON(W) {
      const J = te();
      return J.setChecked(W.checked), J.setValue(W.value), J.setFormat(W.format), J.setDirection(W.direction), J;
    }
    exportDOM(W) {
      const J = this.createDOM(W._config);
      return J.style.textAlign = this.getFormatType(), {
        element: J
      };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        checked: this.getChecked(),
        type: "listitem",
        value: this.getValue(),
        version: 1
      };
    }
    append(...W) {
      for (let J = 0; J < W.length; J++) {
        const R = W[J];
        if (e.$isElementNode(R) && this.canMergeWith(R)) {
          const U = R.getChildren();
          this.append(...U), R.remove();
        } else
          super.append(R);
      }
      return this;
    }
    replace(W, J) {
      if (ce(W))
        return super.replace(W);
      this.setIndent(0);
      const R = this.getParentOrThrow();
      if (!de(R)) return W;
      if (R.__first === this.getKey())
        R.insertBefore(W);
      else if (R.__last === this.getKey())
        R.insertAfter(W);
      else {
        const U = Ee(R.getListType());
        let X = this.getNextSibling();
        for (; X; ) {
          const fe = X;
          X = X.getNextSibling(), U.append(fe);
        }
        R.insertAfter(W), W.insertAfter(U);
      }
      if (J) {
        if (!e.$isElementNode(W))
          throw Error("includeChildren should only be true for ElementNodes");
        this.getChildren().forEach((U) => {
          W.append(U);
        });
      }
      return this.remove(), R.getChildrenSize() === 0 && R.remove(), W;
    }
    insertAfter(W, J = !0) {
      const R = this.getParentOrThrow();
      if (!de(R))
        throw Error("insertAfter: list node is not parent of list item node");
      const U = this.getNextSiblings();
      if (ce(W)) {
        const X = super.insertAfter(W, J), fe = W.getParentOrThrow();
        return de(fe) && v(fe), X;
      }
      if (de(W)) {
        let X = W;
        const fe = W.getChildren();
        for (let _e = fe.length - 1; _e >= 0; _e--)
          X = fe[_e], this.insertAfter(X, J);
        return X;
      }
      if (R.insertAfter(W, J), U.length !== 0) {
        const X = Ee(R.getListType());
        U.forEach((fe) => X.append(fe)), W.insertAfter(X, J);
      }
      return W;
    }
    remove(W) {
      const J = this.getPreviousSibling(), R = this.getNextSibling();
      if (super.remove(W), J && R && d(J) && d(R))
        O(J.getFirstChild(), R.getFirstChild()), R.remove();
      else if (R) {
        const U = R.getParent();
        de(U) && v(U);
      }
    }
    insertNewAfter(W, J = !0) {
      const R = te(this.__checked == null ? void 0 : !1);
      return this.insertAfter(R, J), R;
    }
    collapseAtStart(W) {
      const J = e.$createParagraphNode();
      this.getChildren().forEach((_e) => J.append(_e));
      const U = this.getParentOrThrow(), X = U.getParentOrThrow(), fe = ce(X);
      if (U.getChildrenSize() === 1)
        if (fe)
          U.remove(), X.select();
        else {
          U.insertBefore(J), U.remove();
          const _e = W.anchor, B = W.focus, M = J.getKey();
          _e.type === "element" && _e.getNode().is(this) && _e.set(M, _e.offset, "element"), B.type === "element" && B.getNode().is(this) && B.set(M, B.offset, "element");
        }
      else
        U.insertBefore(J), this.remove();
      return !0;
    }
    getValue() {
      return this.getLatest().__value;
    }
    setValue(W) {
      const J = this.getWritable();
      J.__value = W;
    }
    getChecked() {
      return this.getLatest().__checked;
    }
    setChecked(W) {
      const J = this.getWritable();
      J.__checked = W;
    }
    toggleChecked() {
      this.setChecked(!this.__checked);
    }
    getIndent() {
      const W = this.getParent();
      if (W === null)
        return this.getLatest().__indent;
      let J = W.getParentOrThrow(), R = 0;
      for (; ce(J); )
        J = J.getParentOrThrow().getParentOrThrow(), R++;
      return R;
    }
    setIndent(W) {
      if (!(typeof W == "number" && W > -1))
        throw Error("Invalid indent value.");
      let J = this.getIndent();
      for (; J !== W; )
        J < W ? (I(this), J++) : (G(this), J--);
      return this;
    }
    insertBefore(W) {
      if (ce(W)) {
        const J = this.getParentOrThrow();
        if (de(J)) {
          const R = this.getNextSiblings();
          v(J, R);
        }
      }
      return super.insertBefore(W);
    }
    canInsertAfter(W) {
      return ce(W);
    }
    canReplaceWith(W) {
      return ce(W);
    }
    canMergeWith(W) {
      return e.$isParagraphNode(W) || ce(W);
    }
    extractWithChild(W, J) {
      if (!e.$isRangeSelection(J))
        return !1;
      const R = J.anchor.getNode(), U = J.focus.getNode();
      return this.isParentOf(R) && this.isParentOf(U) && this.getTextContent().length === J.getTextContent().length;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return Ee("bullet");
    }
  }
  function H(Y, W, J) {
    const R = [], U = [], X = W.list, fe = X ? X.listitem : void 0;
    let _e;
    if (X && X.nested && (_e = X.nested.listitem), fe !== void 0) {
      const B = fe.split(" ");
      R.push(...B);
    }
    if (X) {
      const B = J.getParent(), M = de(B) && B.getListType() === "check", F = J.getChecked();
      (!M || F) && U.push(X.listitemUnchecked), (!M || !F) && U.push(X.listitemChecked), M && R.push(F ? X.listitemChecked : X.listitemUnchecked);
    }
    if (_e !== void 0) {
      const B = _e.split(" ");
      J.getChildren().some((M) => de(M)) ? R.push(...B) : U.push(...B);
    }
    U.length > 0 && t.removeClassNamesFromElement(Y, ...U), R.length > 0 && t.addClassNamesToElement(Y, ...R);
  }
  function j(Y, W, J, R) {
    de(W.getFirstChild()) ? (Y.removeAttribute("role"), Y.removeAttribute("tabIndex"), Y.removeAttribute("aria-checked")) : (Y.setAttribute("role", "checkbox"), Y.setAttribute("tabIndex", "-1"), (!J || W.__checked !== J.__checked) && Y.setAttribute("aria-checked", W.getChecked() ? "true" : "false"));
  }
  function re(Y) {
    const W = t.isHTMLElement(Y) && Y.getAttribute("aria-checked") === "true";
    return {
      node: te(W)
    };
  }
  function te(Y) {
    return e.$applyNodeReplacement(new P(void 0, Y));
  }
  function ce(Y) {
    return Y instanceof P;
  }
  class V extends e.ElementNode {
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "list";
    }
    static clone(W) {
      const J = W.__listType || Se[W.__tag];
      return new V(J, W.__start, W.__key);
    }
    constructor(W, J, R) {
      super(R);
      const U = Se[W] || W;
      this.__listType = U, this.__tag = U === "number" ? "ol" : "ul", this.__start = J;
    }
    getTag() {
      return this.__tag;
    }
    setListType(W) {
      const J = this.getWritable();
      J.__listType = W, J.__tag = W === "number" ? "ol" : "ul";
    }
    getListType() {
      return this.__listType;
    }
    getStart() {
      return this.__start;
    }
    // View
    createDOM(W, J) {
      const R = this.__tag, U = document.createElement(R);
      return this.__start !== 1 && U.setAttribute("start", String(this.__start)), U.__lexicalListType = this.__listType, z(U, W.theme, this), U;
    }
    updateDOM(W, J, R) {
      return W.__tag !== this.__tag ? !0 : (z(J, R.theme, this), !1);
    }
    static importDOM() {
      return {
        ol: (W) => ({
          conversion: Te,
          priority: 0
        }),
        ul: (W) => ({
          conversion: Te,
          priority: 0
        })
      };
    }
    static importJSON(W) {
      const J = Ee(W.listType, W.start);
      return J.setFormat(W.format), J.setIndent(W.indent), J.setDirection(W.direction), J;
    }
    exportDOM(W) {
      const {
        element: J
      } = super.exportDOM(W);
      return J && t.isHTMLElement(J) && (this.__start !== 1 && J.setAttribute("start", String(this.__start)), this.__listType === "check" && J.setAttribute("__lexicalListType", "check")), {
        element: J
      };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        listType: this.getListType(),
        start: this.getStart(),
        tag: this.getTag(),
        type: "list",
        version: 1
      };
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
    append(...W) {
      for (let J = 0; J < W.length; J++) {
        const R = W[J];
        if (ce(R))
          super.append(R);
        else {
          const U = te();
          if (de(R))
            U.append(R);
          else if (e.$isElementNode(R)) {
            const X = e.$createTextNode(R.getTextContent());
            U.append(X);
          } else
            U.append(R);
          super.append(U);
        }
      }
      return v(this), this;
    }
    extractWithChild(W) {
      return ce(W);
    }
  }
  function z(Y, W, J) {
    const R = [], U = [], X = W.list;
    if (X !== void 0) {
      const fe = X[`${J.__tag}Depth`] || [], _e = n(J) - 1, B = _e % fe.length, M = fe[B], F = X[J.__tag];
      let se;
      const ye = X.nested;
      if (ye !== void 0 && ye.list && (se = ye.list), F !== void 0 && R.push(F), M !== void 0) {
        const De = M.split(" ");
        R.push(...De);
        for (let ee = 0; ee < fe.length; ee++)
          ee !== B && U.push(J.__tag + ee);
      }
      if (se !== void 0) {
        const De = se.split(" ");
        _e > 1 ? R.push(...De) : U.push(...De);
      }
    }
    U.length > 0 && t.removeClassNamesFromElement(Y, ...U), R.length > 0 && t.addClassNamesToElement(Y, ...R);
  }
  function q(Y) {
    const W = [];
    for (let J = 0; J < Y.length; J++) {
      const R = Y[J];
      if (ce(R)) {
        W.push(R);
        const U = R.getChildren();
        U.length > 1 && U.forEach((X) => {
          de(X) && W.push(p(X));
        });
      } else
        W.push(p(R));
    }
    return W;
  }
  function Te(Y) {
    const W = Y.nodeName.toLowerCase();
    let J = null;
    if (W === "ol") {
      const R = Y.start;
      J = Ee("number", R);
    } else W === "ul" && (t.isHTMLElement(Y) && Y.getAttribute("__lexicallisttype") === "check" ? J = Ee("check") : J = Ee("bullet"));
    return {
      after: q,
      node: J
    };
  }
  const Se = {
    ol: "number",
    ul: "bullet"
  };
  function Ee(Y, W = 1) {
    return e.$applyNodeReplacement(new V(Y, W));
  }
  function de(Y) {
    return Y instanceof V;
  }
  const K = e.createCommand("INSERT_UNORDERED_LIST_COMMAND"), D = e.createCommand("INSERT_ORDERED_LIST_COMMAND"), Z = e.createCommand("INSERT_CHECK_LIST_COMMAND"), oe = e.createCommand("REMOVE_LIST_COMMAND");
  return pr.$createListItemNode = te, pr.$createListNode = Ee, pr.$getListDepth = n, pr.$handleListInsertParagraph = k, pr.$isListItemNode = ce, pr.$isListNode = de, pr.INSERT_CHECK_LIST_COMMAND = Z, pr.INSERT_ORDERED_LIST_COMMAND = D, pr.INSERT_UNORDERED_LIST_COMMAND = K, pr.ListItemNode = P, pr.ListNode = V, pr.REMOVE_LIST_COMMAND = oe, pr.insertList = T, pr.removeList = m, pr;
}
var mr = {}, fh;
function gC() {
  if (fh) return mr;
  fh = 1;
  var e = Yt(), t = gn();
  function n(K) {
    let D = new URLSearchParams();
    D.append("code", K);
    for (let Z = 1; Z < arguments.length; Z++) D.append("v", arguments[Z]);
    throw Error(`Minified Lexical error #${K}; visit https://lexical.dev/docs/error?${D} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  function r(K) {
    let D = 1;
    for (K = K.getParent(); K != null; ) {
      if (H(K)) {
        if (K = K.getParent(), q(K)) {
          D++, K = K.getParent();
          continue;
        }
        n(40);
      }
      break;
    }
    return D;
  }
  function l(K) {
    K = K.getParent(), q(K) || n(40);
    let D = K;
    for (; D !== null; ) D = D.getParent(), q(D) && (K = D);
    return K;
  }
  function d(K) {
    let D = [];
    K = K.getChildren().filter(H);
    for (let Z = 0; Z < K.length; Z++) {
      let oe = K[Z], Y = oe.getFirstChild();
      q(Y) ? D = D.concat(d(Y)) : D.push(oe);
    }
    return D;
  }
  function f(K) {
    return H(K) && q(K.getFirstChild());
  }
  function p(K) {
    for (; K.getNextSibling() == null && K.getPreviousSibling() == null; ) {
      let D = K.getParent();
      if (D == null || !H(K) && !q(K)) break;
      K = D;
    }
    K.remove();
  }
  function _(K) {
    return P().append(K);
  }
  function E(K, D) {
    return H(K) && (D.length === 0 || D.length === 1 && K.is(D[0]) && K.getChildrenSize() === 0);
  }
  function T(K, D) {
    K.splice(K.getChildrenSize(), 0, D);
  }
  function S(K, D) {
    if (q(K)) return K;
    let Z = K.getPreviousSibling(), oe = K.getNextSibling(), Y = P();
    return Y.setFormat(K.getFormatType()), Y.setIndent(K.getIndent()), T(Y, K.getChildren()), q(Z) && D === Z.getListType() ? (Z.append(Y), K.remove(), q(oe) && D === oe.getListType() && (T(Z, oe.getChildren()), oe.remove()), Z) : q(oe) && D === oe.getListType() ? (oe.getFirstChildOrThrow().insertBefore(Y), K.remove(), oe) : (D = z(D), D.append(Y), K.replace(D), O(D), D);
  }
  function w(K, D) {
    var Z = K.getLastChild();
    let oe = D.getFirstChild();
    Z && oe && f(Z) && f(oe) && (w(Z.getFirstChild(), oe.getFirstChild()), oe.remove()), Z = D.getChildren(), 0 < Z.length && (K.append(...Z), O(K)), D.remove();
  }
  function O(K, D) {
    if (K = D || K.getChildren(), K !== void 0) for (D = 0; D < K.length; D++) {
      let W = K[D];
      if (H(W)) {
        let J = W.getValue();
        var Z = W, oe = Z.getParent(), Y = 1;
        for (oe != null && (q(oe) ? Y = oe.getStart() : n(44)), Z = Z.getPreviousSiblings(), oe = 0; oe < Z.length; oe++) {
          let R = Z[oe];
          H(R) && !q(R.getFirstChild()) && Y++;
        }
        J !== Y && W.setValue(Y);
      }
    }
  }
  function m(K) {
    if (!f(K)) {
      var D = K.getParent(), Z = D ? D.getParent() : void 0, oe = Z ? Z.getParent() : void 0;
      if (q(oe) && H(Z) && q(D)) {
        var Y = D ? D.getFirstChild() : void 0, W = D ? D.getLastChild() : void 0;
        if (K.is(Y)) Z.insertBefore(K), D.isEmpty() && Z.remove();
        else if (K.is(W)) Z.insertAfter(K), D.isEmpty() && Z.remove();
        else {
          var J = D.getListType();
          Y = P();
          let R = z(J);
          Y.append(R), K.getPreviousSiblings().forEach((U) => R.append(U)), W = P(), J = z(J), W.append(J), T(J, K.getNextSiblings()), Z.insertBefore(Y), Z.insertAfter(W), Z.replace(K);
        }
        O(D), O(oe);
      }
    }
  }
  class v extends e.ElementNode {
    static getType() {
      return "listitem";
    }
    static clone(D) {
      return new v(D.__value, D.__checked, D.__key);
    }
    constructor(D, Z, oe) {
      super(oe), this.__value = D === void 0 ? 1 : D, this.__checked = Z;
    }
    createDOM(D) {
      let Z = document.createElement("li"), oe = this.getParent();
      return q(oe) && oe.getListType() === "check" && G(Z, this, null), Z.value = this.__value, I(Z, D.theme, this), Z;
    }
    updateDOM(D, Z, oe) {
      let Y = this.getParent();
      return q(Y) && Y.getListType() === "check" && G(Z, this, D), Z.value = this.__value, I(Z, oe.theme, this), !1;
    }
    static transform() {
      return (D) => {
        let Z = D.getParent();
        if (q(Z)) {
          if (O(Z), !H(D)) throw Error("node is not a ListItemNode");
          Z.getListType() !== "check" && D.getChecked() != null && D.setChecked(void 0);
        }
      };
    }
    static importDOM() {
      return { li: () => ({ conversion: k, priority: 0 }) };
    }
    static importJSON(D) {
      let Z = P();
      return Z.setChecked(D.checked), Z.setValue(D.value), Z.setFormat(D.format), Z.setDirection(D.direction), Z;
    }
    exportDOM(D) {
      return D = this.createDOM(D._config), D.style.textAlign = this.getFormatType(), { element: D };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        checked: this.getChecked(),
        type: "listitem",
        value: this.getValue(),
        version: 1
      };
    }
    append(...D) {
      for (let Z = 0; Z < D.length; Z++) {
        let oe = D[Z];
        if (e.$isElementNode(oe) && this.canMergeWith(oe)) {
          let Y = oe.getChildren();
          this.append(...Y), oe.remove();
        } else super.append(oe);
      }
      return this;
    }
    replace(D, Z) {
      if (H(D)) return super.replace(D);
      this.setIndent(0);
      let oe = this.getParentOrThrow();
      if (!q(oe)) return D;
      if (oe.__first === this.getKey()) oe.insertBefore(D);
      else if (oe.__last === this.getKey()) oe.insertAfter(D);
      else {
        let Y = z(oe.getListType()), W = this.getNextSibling();
        for (; W; ) {
          let J = W;
          W = W.getNextSibling(), Y.append(J);
        }
        oe.insertAfter(D), D.insertAfter(Y);
      }
      if (Z) {
        if (!e.$isElementNode(D)) throw Error("includeChildren should only be true for ElementNodes");
        this.getChildren().forEach((Y) => {
          D.append(Y);
        });
      }
      return this.remove(), oe.getChildrenSize() === 0 && oe.remove(), D;
    }
    insertAfter(D, Z = !0) {
      var oe = this.getParentOrThrow();
      q(oe) || n(39);
      var Y = this.getNextSiblings();
      if (H(D)) return Z = super.insertAfter(D, Z), D = D.getParentOrThrow(), q(D) && O(D), Z;
      if (q(D)) {
        for (oe = D, D = D.getChildren(), Y = D.length - 1; 0 <= Y; Y--) oe = D[Y], this.insertAfter(oe, Z);
        return oe;
      }
      if (oe.insertAfter(D, Z), Y.length !== 0) {
        let W = z(oe.getListType());
        Y.forEach((J) => W.append(J)), D.insertAfter(W, Z);
      }
      return D;
    }
    remove(D) {
      let Z = this.getPreviousSibling(), oe = this.getNextSibling();
      super.remove(D), Z && oe && f(Z) && f(oe) ? (w(Z.getFirstChild(), oe.getFirstChild()), oe.remove()) : oe && (D = oe.getParent(), q(D) && O(D));
    }
    insertNewAfter(D, Z = !0) {
      return D = P(this.__checked == null ? void 0 : !1), this.insertAfter(D, Z), D;
    }
    collapseAtStart(D) {
      let Z = e.$createParagraphNode();
      this.getChildren().forEach((J) => Z.append(J));
      var oe = this.getParentOrThrow(), Y = oe.getParentOrThrow();
      let W = H(Y);
      return oe.getChildrenSize() === 1 ? W ? (oe.remove(), Y.select()) : (oe.insertBefore(Z), oe.remove(), oe = D.anchor, D = D.focus, Y = Z.getKey(), oe.type === "element" && oe.getNode().is(this) && oe.set(Y, oe.offset, "element"), D.type === "element" && D.getNode().is(this) && D.set(Y, D.offset, "element")) : (oe.insertBefore(Z), this.remove()), !0;
    }
    getValue() {
      return this.getLatest().__value;
    }
    setValue(D) {
      this.getWritable().__value = D;
    }
    getChecked() {
      return this.getLatest().__checked;
    }
    setChecked(D) {
      this.getWritable().__checked = D;
    }
    toggleChecked() {
      this.setChecked(!this.__checked);
    }
    getIndent() {
      var D = this.getParent();
      if (D === null) return this.getLatest().__indent;
      D = D.getParentOrThrow();
      let Z = 0;
      for (; H(D); ) D = D.getParentOrThrow().getParentOrThrow(), Z++;
      return Z;
    }
    setIndent(D) {
      typeof D == "number" && -1 < D || n(117);
      let Z = this.getIndent();
      for (; Z !== D; ) if (Z < D) {
        e: {
          var oe = /* @__PURE__ */ new Set();
          if (f(this) || oe.has(this.getKey())) break e;
          let R = this.getParent();
          var Y = this.getNextSibling(), W = this.getPreviousSibling();
          if (f(Y) && f(W)) {
            if (W = W.getFirstChild(), q(W)) {
              W.append(this);
              var J = Y.getFirstChild();
              q(J) && (J = J.getChildren(), T(W, J), Y.remove(), oe.add(Y.getKey())), O(W);
            }
          } else f(Y) ? (Y = Y.getFirstChild(), q(Y) && (oe = Y.getFirstChild(), oe !== null && oe.insertBefore(this), O(Y))) : f(W) ? (Y = W.getFirstChild(), q(Y) && (Y.append(this), O(Y))) : q(R) && (oe = P(), J = z(R.getListType()), oe.append(J), J.append(this), W ? W.insertAfter(oe) : Y ? Y.insertBefore(oe) : R.append(oe), O(J));
          q(R) && O(R);
        }
        Z++;
      } else m(this), Z--;
      return this;
    }
    insertBefore(D) {
      if (H(D)) {
        let Z = this.getParentOrThrow();
        if (q(Z)) {
          let oe = this.getNextSiblings();
          O(
            Z,
            oe
          );
        }
      }
      return super.insertBefore(D);
    }
    canInsertAfter(D) {
      return H(D);
    }
    canReplaceWith(D) {
      return H(D);
    }
    canMergeWith(D) {
      return e.$isParagraphNode(D) || H(D);
    }
    extractWithChild(D, Z) {
      if (!e.$isRangeSelection(Z)) return !1;
      D = Z.anchor.getNode();
      let oe = Z.focus.getNode();
      return this.isParentOf(D) && this.isParentOf(oe) && this.getTextContent().length === Z.getTextContent().length;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return z("bullet");
    }
  }
  function I(K, D, Z) {
    let oe = [], Y = [];
    var W = (D = D.list) ? D.listitem : void 0;
    if (D && D.nested) var J = D.nested.listitem;
    if (W !== void 0 && (W = W.split(" "), oe.push(...W)), D) {
      W = Z.getParent(), W = q(W) && W.getListType() === "check";
      let R = Z.getChecked();
      W && !R || Y.push(D.listitemUnchecked), W && R || Y.push(D.listitemChecked), W && oe.push(R ? D.listitemChecked : D.listitemUnchecked);
    }
    J !== void 0 && (J = J.split(" "), Z.getChildren().some((R) => q(R)) ? oe.push(...J) : Y.push(...J)), 0 < Y.length && t.removeClassNamesFromElement(K, ...Y), 0 < oe.length && t.addClassNamesToElement(
      K,
      ...oe
    );
  }
  function G(K, D, Z) {
    q(D.getFirstChild()) ? (K.removeAttribute("role"), K.removeAttribute("tabIndex"), K.removeAttribute("aria-checked")) : (K.setAttribute("role", "checkbox"), K.setAttribute("tabIndex", "-1"), Z && D.__checked === Z.__checked || K.setAttribute("aria-checked", D.getChecked() ? "true" : "false"));
  }
  function k(K) {
    return K = t.isHTMLElement(K) && K.getAttribute("aria-checked") === "true", { node: P(K) };
  }
  function P(K) {
    return e.$applyNodeReplacement(new v(void 0, K));
  }
  function H(K) {
    return K instanceof v;
  }
  class j extends e.ElementNode {
    static getType() {
      return "list";
    }
    static clone(D) {
      return new j(D.__listType || V[D.__tag], D.__start, D.__key);
    }
    constructor(D, Z, oe) {
      super(oe), this.__listType = D = V[D] || D, this.__tag = D === "number" ? "ol" : "ul", this.__start = Z;
    }
    getTag() {
      return this.__tag;
    }
    setListType(D) {
      let Z = this.getWritable();
      Z.__listType = D, Z.__tag = D === "number" ? "ol" : "ul";
    }
    getListType() {
      return this.__listType;
    }
    getStart() {
      return this.__start;
    }
    createDOM(D) {
      let Z = document.createElement(this.__tag);
      return this.__start !== 1 && Z.setAttribute(
        "start",
        String(this.__start)
      ), Z.__lexicalListType = this.__listType, re(Z, D.theme, this), Z;
    }
    updateDOM(D, Z, oe) {
      return D.__tag !== this.__tag ? !0 : (re(Z, oe.theme, this), !1);
    }
    static importDOM() {
      return { ol: () => ({ conversion: ce, priority: 0 }), ul: () => ({ conversion: ce, priority: 0 }) };
    }
    static importJSON(D) {
      let Z = z(D.listType, D.start);
      return Z.setFormat(D.format), Z.setIndent(D.indent), Z.setDirection(D.direction), Z;
    }
    exportDOM(D) {
      return { element: D } = super.exportDOM(D), D && t.isHTMLElement(D) && (this.__start !== 1 && D.setAttribute("start", String(this.__start)), this.__listType === "check" && D.setAttribute("__lexicalListType", "check")), { element: D };
    }
    exportJSON() {
      return { ...super.exportJSON(), listType: this.getListType(), start: this.getStart(), tag: this.getTag(), type: "list", version: 1 };
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
    append(...D) {
      for (let oe = 0; oe < D.length; oe++) {
        var Z = D[oe];
        if (H(Z)) super.append(Z);
        else {
          let Y = P();
          q(Z) || e.$isElementNode(Z) && (Z = e.$createTextNode(Z.getTextContent())), Y.append(Z), super.append(Y);
        }
      }
      return O(this), this;
    }
    extractWithChild(D) {
      return H(D);
    }
  }
  function re(K, D, Z) {
    let oe = [], Y = [];
    var W = D.list;
    if (W !== void 0) {
      let R = W[`${Z.__tag}Depth`] || [];
      D = r(Z) - 1;
      let U = D % R.length;
      var J = R[U];
      let X = W[Z.__tag], fe;
      if (W = W.nested, W !== void 0 && W.list && (fe = W.list), X !== void 0 && oe.push(X), J !== void 0) for (J = J.split(" "), oe.push(...J), J = 0; J < R.length; J++) J !== U && Y.push(Z.__tag + J);
      fe !== void 0 && (Z = fe.split(" "), 1 < D ? oe.push(...Z) : Y.push(...Z));
    }
    0 < Y.length && t.removeClassNamesFromElement(K, ...Y), 0 < oe.length && t.addClassNamesToElement(K, ...oe);
  }
  function te(K) {
    let D = [];
    for (let oe = 0; oe < K.length; oe++) {
      var Z = K[oe];
      H(Z) ? (D.push(Z), Z = Z.getChildren(), 1 < Z.length && Z.forEach((Y) => {
        q(Y) && D.push(_(Y));
      })) : D.push(_(Z));
    }
    return D;
  }
  function ce(K) {
    let D = K.nodeName.toLowerCase(), Z = null;
    return D === "ol" ? Z = z("number", K.start) : D === "ul" && (Z = t.isHTMLElement(K) && K.getAttribute("__lexicallisttype") === "check" ? z("check") : z("bullet")), { after: te, node: Z };
  }
  let V = { ol: "number", ul: "bullet" };
  function z(K, D = 1) {
    return e.$applyNodeReplacement(new j(K, D));
  }
  function q(K) {
    return K instanceof j;
  }
  let Te = e.createCommand("INSERT_UNORDERED_LIST_COMMAND"), Se = e.createCommand("INSERT_ORDERED_LIST_COMMAND"), Ee = e.createCommand("INSERT_CHECK_LIST_COMMAND"), de = e.createCommand("REMOVE_LIST_COMMAND");
  return mr.$createListItemNode = P, mr.$createListNode = z, mr.$getListDepth = r, mr.$handleListInsertParagraph = function() {
    var K = e.$getSelection();
    if (!e.$isRangeSelection(K) || !K.isCollapsed() || (K = K.anchor.getNode(), !H(K) || K.getChildrenSize() !== 0)) return !1;
    var D = l(K), Z = K.getParent();
    q(Z) || n(40);
    let oe = Z.getParent(), Y;
    if (e.$isRootOrShadowRoot(oe)) Y = e.$createParagraphNode(), D.insertAfter(Y);
    else if (H(oe)) Y = P(), oe.insertAfter(Y);
    else return !1;
    if (Y.select(), D = K.getNextSiblings(), 0 < D.length) {
      let W = z(Z.getListType());
      e.$isParagraphNode(Y) ? Y.insertAfter(W) : (Z = P(), Z.append(W), Y.insertAfter(Z)), D.forEach((J) => {
        J.remove(), W.append(J);
      });
    }
    return p(K), !0;
  }, mr.$isListItemNode = H, mr.$isListNode = q, mr.INSERT_CHECK_LIST_COMMAND = Ee, mr.INSERT_ORDERED_LIST_COMMAND = Se, mr.INSERT_UNORDERED_LIST_COMMAND = Te, mr.ListItemNode = v, mr.ListNode = j, mr.REMOVE_LIST_COMMAND = de, mr.insertList = function(K, D) {
    K.update(() => {
      var Z = e.$getSelection();
      if (e.$INTERNAL_isPointSelection(Z)) {
        var oe = Z.getNodes();
        Z = Z.anchor.getNode();
        var Y = Z.getParent();
        if (E(Z, oe)) oe = z(D), e.$isRootOrShadowRoot(Y) ? (Z.replace(oe), Y = P(), e.$isElementNode(Z) && (Y.setFormat(Z.getFormatType()), Y.setIndent(Z.getIndent())), oe.append(Y)) : H(Z) && (Z = Z.getParentOrThrow(), T(oe, Z.getChildren()), Z.replace(oe));
        else for (Z = /* @__PURE__ */ new Set(), Y = 0; Y < oe.length; Y++) {
          var W = oe[Y];
          if (e.$isElementNode(W) && W.isEmpty() && !H(W) && !Z.has(W.getKey())) S(
            W,
            D
          );
          else if (e.$isLeafNode(W)) for (W = W.getParent(); W != null; ) {
            let R = W.getKey();
            if (q(W)) {
              if (!Z.has(R)) {
                var J = z(D);
                T(J, W.getChildren()), W.replace(J), O(J), Z.add(R);
              }
              break;
            } else {
              if (J = W.getParent(), e.$isRootOrShadowRoot(J) && !Z.has(R)) {
                Z.add(R), S(W, D);
                break;
              }
              W = J;
            }
          }
        }
      }
    });
  }, mr.removeList = function(K) {
    K.update(() => {
      let D = e.$getSelection();
      if (e.$isRangeSelection(D)) {
        var Z = /* @__PURE__ */ new Set(), oe = D.getNodes(), Y = D.anchor.getNode();
        if (E(Y, oe)) Z.add(l(Y));
        else for (Y = 0; Y < oe.length; Y++) {
          var W = oe[Y];
          e.$isLeafNode(W) && (W = t.$getNearestNodeOfType(W, v), W != null && Z.add(l(W)));
        }
        for (let J of Z) {
          Z = J, oe = d(J);
          for (let R of oe) oe = e.$createParagraphNode(), T(oe, R.getChildren()), Z.insertAfter(oe), Z = oe, R.__key === D.anchor.key && D.anchor.set(oe.getKey(), 0, "element"), R.__key === D.focus.key && D.focus.set(oe.getKey(), 0, "element"), R.remove();
          J.remove();
        }
      }
    });
  }, mr;
}
var Eu, hh;
function _d() {
  return hh || (hh = 1, Eu = process.env.NODE_ENV === "development" ? hC() : gC()), Eu;
}
var gh;
function pC() {
  if (gh) return Cu;
  gh = 1;
  var e = _d(), t = qn(), n = xn, r = gn(), l = Yt();
  function d(p) {
    n.useEffect(() => r.mergeRegister(p.registerCommand(e.INSERT_ORDERED_LIST_COMMAND, () => (e.insertList(p, "number"), !0), l.COMMAND_PRIORITY_LOW), p.registerCommand(e.INSERT_UNORDERED_LIST_COMMAND, () => (e.insertList(p, "bullet"), !0), l.COMMAND_PRIORITY_LOW), p.registerCommand(e.REMOVE_LIST_COMMAND, () => (e.removeList(p), !0), l.COMMAND_PRIORITY_LOW), p.registerCommand(l.INSERT_PARAGRAPH_COMMAND, () => !!e.$handleListInsertParagraph(), l.COMMAND_PRIORITY_LOW)), [p]);
  }
  function f() {
    const [p] = t.useLexicalComposerContext();
    return n.useEffect(() => {
      if (!p.hasNodes([e.ListNode, e.ListItemNode]))
        throw new Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [p]), d(p), null;
  }
  return Cu.ListPlugin = f, Cu;
}
var Tu = {}, ph;
function mC() {
  if (ph) return Tu;
  ph = 1;
  var e = _d(), t = qn(), n = xn, r = gn(), l = Yt();
  function d(f) {
    n.useEffect(() => r.mergeRegister(f.registerCommand(e.INSERT_ORDERED_LIST_COMMAND, () => (e.insertList(f, "number"), !0), l.COMMAND_PRIORITY_LOW), f.registerCommand(e.INSERT_UNORDERED_LIST_COMMAND, () => (e.insertList(f, "bullet"), !0), l.COMMAND_PRIORITY_LOW), f.registerCommand(e.REMOVE_LIST_COMMAND, () => (e.removeList(f), !0), l.COMMAND_PRIORITY_LOW), f.registerCommand(l.INSERT_PARAGRAPH_COMMAND, () => !!e.$handleListInsertParagraph(), l.COMMAND_PRIORITY_LOW)), [f]);
  }
  return Tu.ListPlugin = function() {
    let [f] = t.useLexicalComposerContext();
    return n.useEffect(() => {
      if (!f.hasNodes([e.ListNode, e.ListItemNode])) throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [f]), d(f), null;
  }, Tu;
}
const _C = process.env.NODE_ENV === "development" ? pC() : mC();
var yC = _C, xu = {}, Di = {}, mh;
function NC() {
  if (mh) return Di;
  mh = 1;
  var e = gn(), t = Yt();
  const n = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);
  class r extends t.ElementNode {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "link";
    }
    static clone(m) {
      return new r(m.__url, {
        rel: m.__rel,
        target: m.__target,
        title: m.__title
      }, m.__key);
    }
    constructor(m, v = {}, I) {
      super(I);
      const {
        target: G = null,
        rel: k = null,
        title: P = null
      } = v;
      this.__url = m, this.__target = G, this.__rel = k, this.__title = P;
    }
    createDOM(m) {
      const v = document.createElement("a");
      return v.href = this.sanitizeUrl(this.__url), this.__target !== null && (v.target = this.__target), this.__rel !== null && (v.rel = this.__rel), this.__title !== null && (v.title = this.__title), e.addClassNamesToElement(v, m.theme.link), v;
    }
    updateDOM(m, v, I) {
      const G = this.__url, k = this.__target, P = this.__rel, H = this.__title;
      return G !== m.__url && (v.href = G), k !== m.__target && (k ? v.target = k : v.removeAttribute("target")), P !== m.__rel && (P ? v.rel = P : v.removeAttribute("rel")), H !== m.__title && (H ? v.title = H : v.removeAttribute("title")), !1;
    }
    static importDOM() {
      return {
        a: (m) => ({
          conversion: l,
          priority: 1
        })
      };
    }
    static importJSON(m) {
      const v = d(m.url, {
        rel: m.rel,
        target: m.target,
        title: m.title
      });
      return v.setFormat(m.format), v.setIndent(m.indent), v.setDirection(m.direction), v;
    }
    sanitizeUrl(m) {
      try {
        const v = new URL(m);
        if (!n.has(v.protocol))
          return "about:blank";
      } catch {
        return m;
      }
      return m;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        rel: this.getRel(),
        target: this.getTarget(),
        title: this.getTitle(),
        type: "link",
        url: this.getURL(),
        version: 1
      };
    }
    getURL() {
      return this.getLatest().__url;
    }
    setURL(m) {
      const v = this.getWritable();
      v.__url = m;
    }
    getTarget() {
      return this.getLatest().__target;
    }
    setTarget(m) {
      const v = this.getWritable();
      v.__target = m;
    }
    getRel() {
      return this.getLatest().__rel;
    }
    setRel(m) {
      const v = this.getWritable();
      v.__rel = m;
    }
    getTitle() {
      return this.getLatest().__title;
    }
    setTitle(m) {
      const v = this.getWritable();
      v.__title = m;
    }
    insertNewAfter(m, v = !0) {
      const I = d(this.__url, {
        rel: this.__rel,
        target: this.__target,
        title: this.__title
      });
      return this.insertAfter(I, v), I;
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isInline() {
      return !0;
    }
    extractWithChild(m, v, I) {
      if (!t.$isRangeSelection(v))
        return !1;
      const G = v.anchor.getNode(), k = v.focus.getNode();
      return this.isParentOf(G) && this.isParentOf(k) && v.getTextContent().length > 0;
    }
  }
  function l(O) {
    let m = null;
    if (e.isHTMLAnchorElement(O)) {
      const v = O.textContent;
      (v !== null && v !== "" || O.children.length > 0) && (m = d(O.getAttribute("href") || "", {
        rel: O.getAttribute("rel"),
        target: O.getAttribute("target"),
        title: O.getAttribute("title")
      }));
    }
    return {
      node: m
    };
  }
  function d(O, m) {
    return t.$applyNodeReplacement(new r(O, m));
  }
  function f(O) {
    return O instanceof r;
  }
  class p extends r {
    static getType() {
      return "autolink";
    }
    static clone(m) {
      return new p(m.__url, {
        rel: m.__rel,
        target: m.__target,
        title: m.__title
      }, m.__key);
    }
    static importJSON(m) {
      const v = _(m.url, {
        rel: m.rel,
        target: m.target,
        title: m.title
      });
      return v.setFormat(m.format), v.setIndent(m.indent), v.setDirection(m.direction), v;
    }
    static importDOM() {
      return null;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "autolink",
        version: 1
      };
    }
    insertNewAfter(m, v = !0) {
      const I = this.getParentOrThrow().insertNewAfter(m, v);
      if (t.$isElementNode(I)) {
        const G = _(this.__url, {
          rel: this.__rel,
          target: this.__target,
          title: this.__title
        });
        return I.append(G), G;
      }
      return null;
    }
  }
  function _(O, m) {
    return t.$applyNodeReplacement(new p(O, m));
  }
  function E(O) {
    return O instanceof p;
  }
  const T = t.createCommand("TOGGLE_LINK_COMMAND");
  function S(O, m = {}) {
    const {
      target: v,
      title: I
    } = m, G = m.rel === void 0 ? "noreferrer" : m.rel, k = t.$getSelection();
    if (!t.$isRangeSelection(k))
      return;
    const P = k.extract();
    if (O === null)
      P.forEach((H) => {
        const j = H.getParent();
        if (f(j)) {
          const re = j.getChildren();
          for (let te = 0; te < re.length; te++)
            j.insertBefore(re[te]);
          j.remove();
        }
      });
    else {
      if (P.length === 1) {
        const re = P[0], te = w(re, f);
        if (te !== null) {
          te.setURL(O), v !== void 0 && te.setTarget(v), G !== null && te.setRel(G), I !== void 0 && te.setTitle(I);
          return;
        }
      }
      let H = null, j = null;
      P.forEach((re) => {
        const te = re.getParent();
        if (!(te === j || te === null || t.$isElementNode(re) && !re.isInline())) {
          if (f(te)) {
            j = te, te.setURL(O), v !== void 0 && te.setTarget(v), G !== null && j.setRel(G), I !== void 0 && j.setTitle(I);
            return;
          }
          if (te.is(H) || (H = te, j = d(O, {
            rel: G,
            target: v,
            title: I
          }), f(te) ? re.getPreviousSibling() === null ? te.insertBefore(j) : te.insertAfter(j) : re.insertBefore(j)), f(re)) {
            if (re.is(j))
              return;
            if (j !== null) {
              const ce = re.getChildren();
              for (let V = 0; V < ce.length; V++)
                j.append(ce[V]);
            }
            re.remove();
            return;
          }
          j !== null && j.append(re);
        }
      });
    }
  }
  function w(O, m) {
    let v = O;
    for (; v !== null && v.getParent() !== null && !m(v); )
      v = v.getParentOrThrow();
    return m(v) ? v : null;
  }
  return Di.$createAutoLinkNode = _, Di.$createLinkNode = d, Di.$isAutoLinkNode = E, Di.$isLinkNode = f, Di.AutoLinkNode = p, Di.LinkNode = r, Di.TOGGLE_LINK_COMMAND = T, Di.toggleLink = S, Di;
}
var Ai = {}, _h;
function CC() {
  if (_h) return Ai;
  _h = 1;
  var e = gn(), t = Yt();
  let n = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);
  class r extends t.ElementNode {
    static getType() {
      return "link";
    }
    static clone(w) {
      return new r(w.__url, { rel: w.__rel, target: w.__target, title: w.__title }, w.__key);
    }
    constructor(w, O = {}, m) {
      super(m);
      let { target: v = null, rel: I = null, title: G = null } = O;
      this.__url = w, this.__target = v, this.__rel = I, this.__title = G;
    }
    createDOM(w) {
      let O = document.createElement("a");
      return O.href = this.sanitizeUrl(this.__url), this.__target !== null && (O.target = this.__target), this.__rel !== null && (O.rel = this.__rel), this.__title !== null && (O.title = this.__title), e.addClassNamesToElement(
        O,
        w.theme.link
      ), O;
    }
    updateDOM(w, O) {
      let m = this.__url, v = this.__target, I = this.__rel, G = this.__title;
      return m !== w.__url && (O.href = m), v !== w.__target && (v ? O.target = v : O.removeAttribute("target")), I !== w.__rel && (I ? O.rel = I : O.removeAttribute("rel")), G !== w.__title && (G ? O.title = G : O.removeAttribute("title")), !1;
    }
    static importDOM() {
      return { a: () => ({ conversion: l, priority: 1 }) };
    }
    static importJSON(w) {
      let O = d(w.url, { rel: w.rel, target: w.target, title: w.title });
      return O.setFormat(w.format), O.setIndent(w.indent), O.setDirection(w.direction), O;
    }
    sanitizeUrl(w) {
      try {
        let O = new URL(w);
        if (!n.has(O.protocol)) return "about:blank";
      } catch {
      }
      return w;
    }
    exportJSON() {
      return { ...super.exportJSON(), rel: this.getRel(), target: this.getTarget(), title: this.getTitle(), type: "link", url: this.getURL(), version: 1 };
    }
    getURL() {
      return this.getLatest().__url;
    }
    setURL(w) {
      this.getWritable().__url = w;
    }
    getTarget() {
      return this.getLatest().__target;
    }
    setTarget(w) {
      this.getWritable().__target = w;
    }
    getRel() {
      return this.getLatest().__rel;
    }
    setRel(w) {
      this.getWritable().__rel = w;
    }
    getTitle() {
      return this.getLatest().__title;
    }
    setTitle(w) {
      this.getWritable().__title = w;
    }
    insertNewAfter(w, O = !0) {
      return w = d(this.__url, { rel: this.__rel, target: this.__target, title: this.__title }), this.insertAfter(w, O), w;
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isInline() {
      return !0;
    }
    extractWithChild(w, O) {
      if (!t.$isRangeSelection(O)) return !1;
      w = O.anchor.getNode();
      let m = O.focus.getNode();
      return this.isParentOf(w) && this.isParentOf(m) && 0 < O.getTextContent().length;
    }
  }
  function l(S) {
    let w = null;
    if (e.isHTMLAnchorElement(S)) {
      let O = S.textContent;
      (O !== null && O !== "" || 0 < S.children.length) && (w = d(S.getAttribute("href") || "", { rel: S.getAttribute("rel"), target: S.getAttribute("target"), title: S.getAttribute("title") }));
    }
    return { node: w };
  }
  function d(S, w) {
    return t.$applyNodeReplacement(new r(S, w));
  }
  function f(S) {
    return S instanceof r;
  }
  class p extends r {
    static getType() {
      return "autolink";
    }
    static clone(w) {
      return new p(w.__url, { rel: w.__rel, target: w.__target, title: w.__title }, w.__key);
    }
    static importJSON(w) {
      let O = _(w.url, { rel: w.rel, target: w.target, title: w.title });
      return O.setFormat(w.format), O.setIndent(w.indent), O.setDirection(w.direction), O;
    }
    static importDOM() {
      return null;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "autolink", version: 1 };
    }
    insertNewAfter(w, O = !0) {
      return w = this.getParentOrThrow().insertNewAfter(w, O), t.$isElementNode(w) ? (O = _(this.__url, { rel: this.__rel, target: this.__target, title: this.__title }), w.append(O), O) : null;
    }
  }
  function _(S, w) {
    return t.$applyNodeReplacement(new p(S, w));
  }
  let E = t.createCommand("TOGGLE_LINK_COMMAND");
  function T(S, w) {
    for (; S !== null && S.getParent() !== null && !w(S); ) S = S.getParentOrThrow();
    return w(S) ? S : null;
  }
  return Ai.$createAutoLinkNode = _, Ai.$createLinkNode = d, Ai.$isAutoLinkNode = function(S) {
    return S instanceof p;
  }, Ai.$isLinkNode = f, Ai.AutoLinkNode = p, Ai.LinkNode = r, Ai.TOGGLE_LINK_COMMAND = E, Ai.toggleLink = function(S, w = {}) {
    let { target: O, title: m } = w, v = w.rel === void 0 ? "noreferrer" : w.rel;
    if (w = t.$getSelection(), t.$isRangeSelection(w)) if (w = w.extract(), S === null) w.forEach((I) => {
      if (I = I.getParent(), f(I)) {
        let G = I.getChildren();
        for (let k = 0; k < G.length; k++) I.insertBefore(G[k]);
        I.remove();
      }
    });
    else {
      if (w.length === 1) {
        let k = T(w[0], f);
        if (k !== null) {
          k.setURL(S), O !== void 0 && k.setTarget(O), v !== null && k.setRel(v), m !== void 0 && k.setTitle(m);
          return;
        }
      }
      let I = null, G = null;
      w.forEach((k) => {
        var P = k.getParent();
        if (P !== G && P !== null && (!t.$isElementNode(k) || k.isInline())) if (f(P)) G = P, P.setURL(S), O !== void 0 && P.setTarget(O), v !== null && G.setRel(v), m !== void 0 && G.setTitle(m);
        else if (P.is(I) || (I = P, G = d(S, { rel: v, target: O, title: m }), f(P) ? k.getPreviousSibling() === null ? P.insertBefore(G) : P.insertAfter(G) : k.insertBefore(G)), f(k)) {
          if (!k.is(G)) {
            if (G !== null) {
              P = k.getChildren();
              for (let H = 0; H < P.length; H++) G.append(P[H]);
            }
            k.remove();
          }
        } else G !== null && G.append(k);
      });
    }
  }, Ai;
}
var vu, yh;
function yd() {
  return yh || (yh = 1, vu = process.env.NODE_ENV === "development" ? NC() : CC()), vu;
}
var Nh;
function EC() {
  if (Nh) return xu;
  Nh = 1;
  var e = yd(), t = qn(), n = gn(), r = Yt(), l = xn;
  function d({
    validateUrl: f
  }) {
    const [p] = t.useLexicalComposerContext();
    return l.useEffect(() => {
      if (!p.hasNodes([e.LinkNode]))
        throw new Error("LinkPlugin: LinkNode not registered on editor");
      return n.mergeRegister(p.registerCommand(e.TOGGLE_LINK_COMMAND, (_) => {
        if (_ === null)
          return e.toggleLink(_), !0;
        if (typeof _ == "string")
          return f === void 0 || f(_) ? (e.toggleLink(_), !0) : !1;
        {
          const {
            url: E,
            target: T,
            rel: S,
            title: w
          } = _;
          return e.toggleLink(E, {
            rel: S,
            target: T,
            title: w
          }), !0;
        }
      }, r.COMMAND_PRIORITY_LOW), f !== void 0 ? p.registerCommand(r.PASTE_COMMAND, (_) => {
        const E = r.$getSelection();
        if (!r.$isRangeSelection(E) || E.isCollapsed() || !(_ instanceof ClipboardEvent) || _.clipboardData == null)
          return !1;
        const T = _.clipboardData.getData("text");
        return f(T) ? E.getNodes().some((S) => r.$isElementNode(S)) ? !1 : (p.dispatchCommand(e.TOGGLE_LINK_COMMAND, T), _.preventDefault(), !0) : !1;
      }, r.COMMAND_PRIORITY_LOW) : () => {
      });
    }, [p, f]), null;
  }
  return xu.LinkPlugin = d, xu;
}
var Su = {}, Ch;
function TC() {
  if (Ch) return Su;
  Ch = 1;
  var e = yd(), t = qn(), n = gn(), r = Yt(), l = xn;
  return Su.LinkPlugin = function({ validateUrl: d }) {
    let [f] = t.useLexicalComposerContext();
    return l.useEffect(() => {
      if (!f.hasNodes([e.LinkNode])) throw Error("LinkPlugin: LinkNode not registered on editor");
      return n.mergeRegister(f.registerCommand(e.TOGGLE_LINK_COMMAND, (p) => {
        if (p === null) return e.toggleLink(p), !0;
        if (typeof p == "string") return d === void 0 || d(p) ? (e.toggleLink(p), !0) : !1;
        let { url: _, target: E, rel: T, title: S } = p;
        return e.toggleLink(_, { rel: T, target: E, title: S }), !0;
      }, r.COMMAND_PRIORITY_LOW), d !== void 0 ? f.registerCommand(
        r.PASTE_COMMAND,
        (p) => {
          let _ = r.$getSelection();
          if (!r.$isRangeSelection(_) || _.isCollapsed() || !(p instanceof ClipboardEvent) || p.clipboardData == null) return !1;
          let E = p.clipboardData.getData("text");
          return d(E) ? _.getNodes().some((T) => r.$isElementNode(T)) ? !1 : (f.dispatchCommand(e.TOGGLE_LINK_COMMAND, E), p.preventDefault(), !0) : !1;
        },
        r.COMMAND_PRIORITY_LOW
      ) : () => {
      });
    }, [f, d]), null;
  }, Su;
}
const xC = process.env.NODE_ENV === "development" ? EC() : TC();
var vC = xC, wu = {}, Zt = {}, Eh;
function SC() {
  if (Eh) return Zt;
  Eh = 1;
  var e = Yt(), t = gn();
  class n extends e.INTERNAL_PointSelection {
    constructor(ie, le, ve) {
      super(le, ve), this.gridKey = ie;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(ie) {
      this._cachedNodes = ie;
    }
    is(ie) {
      return r(ie) ? this.gridKey === ie.gridKey && this.anchor.is(ie.anchor) && this.focus.is(ie.focus) : !1;
    }
    set(ie, le, ve) {
      this.dirty = !0, this.gridKey = ie, this.anchor.key = le, this.focus.key = ve, this._cachedNodes = null;
    }
    clone() {
      return new n(this.gridKey, this.anchor, this.focus);
    }
    isCollapsed() {
      return !1;
    }
    extract() {
      return this.getNodes();
    }
    insertRawText(ie) {
    }
    insertText() {
    }
    insertNodes(ie) {
      const le = this.focus.getNode();
      if (!e.$isElementNode(le))
        throw Error("Expected GridSelection focus to be an ElementNode");
      e.$normalizeSelection__EXPERIMENTAL(le.select(0, le.getChildrenSize())).insertNodes(ie);
    }
    // TODO Deprecate this method. It's confusing when used with colspan|rowspan
    getShape() {
      const ie = e.$getNodeByKey(this.anchor.key);
      if (!e.DEPRECATED_$isGridCellNode(ie))
        throw Error("Expected GridSelection anchor to be (or a child of) GridCellNode");
      const le = e.DEPRECATED_$getGridCellNodeRect(ie);
      if (le === null)
        throw Error("getCellRect: expected to find AnchorNode");
      const ve = e.$getNodeByKey(this.focus.key);
      if (!e.DEPRECATED_$isGridCellNode(ve))
        throw Error("Expected GridSelection focus to be (or a child of) GridCellNode");
      const Le = e.DEPRECATED_$getGridCellNodeRect(ve);
      if (Le === null)
        throw Error("getCellRect: expected to find focusCellNode");
      const Me = Math.min(le.columnIndex, Le.columnIndex), je = Math.max(le.columnIndex, Le.columnIndex), rt = Math.min(le.rowIndex, Le.rowIndex), it = Math.max(le.rowIndex, Le.rowIndex);
      return {
        fromX: Math.min(Me, je),
        fromY: Math.min(rt, it),
        toX: Math.max(Me, je),
        toY: Math.max(rt, it)
      };
    }
    getNodes() {
      const ie = this._cachedNodes;
      if (ie !== null)
        return ie;
      const le = this.anchor.getNode(), ve = this.focus.getNode(), Le = t.$findMatchingParent(le, e.DEPRECATED_$isGridCellNode), Me = t.$findMatchingParent(ve, e.DEPRECATED_$isGridCellNode);
      if (!e.DEPRECATED_$isGridCellNode(Le))
        throw Error("Expected GridSelection anchor to be (or a child of) GridCellNode");
      if (!e.DEPRECATED_$isGridCellNode(Me))
        throw Error("Expected GridSelection focus to be (or a child of) GridCellNode");
      const je = Le.getParent();
      if (!e.DEPRECATED_$isGridRowNode(je))
        throw Error("Expected anchorCell to have a parent GridRowNode");
      const rt = je.getParent();
      if (!e.DEPRECATED_$isGridNode(rt))
        throw Error("Expected tableNode to have a parent GridNode");
      const it = Me.getParents()[1];
      if (it !== rt) {
        if (rt.isParentOf(Me)) {
          const Lt = it.getParent();
          if (Lt == null)
            throw Error("Expected focusCellParent to have a parent");
          this.set(this.gridKey, Me.getKey(), Lt.getKey());
        } else {
          const Lt = rt.getParent();
          if (Lt == null)
            throw Error("Expected gridParent to have a parent");
          this.set(this.gridKey, Lt.getKey(), Me.getKey());
        }
        return this.getNodes();
      }
      const [st, vt, Ge] = e.DEPRECATED_$computeGridMap(rt, Le, Me);
      let ze = Math.min(vt.startColumn, Ge.startColumn), tt = Math.min(vt.startRow, Ge.startRow), _t = Math.max(vt.startColumn + vt.cell.__colSpan - 1, Ge.startColumn + Ge.cell.__colSpan - 1), yt = Math.max(vt.startRow + vt.cell.__rowSpan - 1, Ge.startRow + Ge.cell.__rowSpan - 1), Ct = ze, ht = tt, Tt = ze, pt = tt;
      function Pt(Lt) {
        const {
          cell: jt,
          startColumn: Rt,
          startRow: nn
        } = Lt;
        ze = Math.min(ze, Rt), tt = Math.min(tt, nn), _t = Math.max(_t, Rt + jt.__colSpan - 1), yt = Math.max(yt, nn + jt.__rowSpan - 1);
      }
      for (; ze < Ct || tt < ht || _t > Tt || yt > pt; ) {
        if (ze < Ct) {
          const Lt = pt - ht, jt = Ct - 1;
          for (let Rt = 0; Rt <= Lt; Rt++)
            Pt(st[ht + Rt][jt]);
          Ct = jt;
        }
        if (tt < ht) {
          const Lt = Tt - Ct, jt = ht - 1;
          for (let Rt = 0; Rt <= Lt; Rt++)
            Pt(st[jt][Ct + Rt]);
          ht = jt;
        }
        if (_t > Tt) {
          const Lt = pt - ht, jt = Tt + 1;
          for (let Rt = 0; Rt <= Lt; Rt++)
            Pt(st[ht + Rt][jt]);
          Tt = jt;
        }
        if (yt > pt) {
          const Lt = Tt - Ct, jt = pt + 1;
          for (let Rt = 0; Rt <= Lt; Rt++)
            Pt(st[jt][Ct + Rt]);
          pt = jt;
        }
      }
      const Wt = [rt];
      let tn = null;
      for (let Lt = tt; Lt <= yt; Lt++)
        for (let jt = ze; jt <= _t; jt++) {
          const {
            cell: Rt
          } = st[Lt][jt], nn = Rt.getParent();
          if (!e.DEPRECATED_$isGridRowNode(nn))
            throw Error("Expected GridCellNode parent to be a GridRowNode");
          nn !== tn && Wt.push(nn), Wt.push(Rt, ...d(Rt)), tn = nn;
        }
      return e.isCurrentlyReadOnlyMode() || (this._cachedNodes = Wt), Wt;
    }
    getTextContent() {
      const ie = this.getNodes();
      let le = "";
      for (let ve = 0; ve < ie.length; ve++)
        le += ie[ve].getTextContent();
      return le;
    }
  }
  function r(Oe) {
    return Oe instanceof n;
  }
  function l() {
    const Oe = e.$createPoint("root", 0, "element"), ie = e.$createPoint("root", 0, "element");
    return new n("root", Oe, ie);
  }
  function d(Oe) {
    const ie = [], le = [Oe];
    for (; le.length > 0; ) {
      const ve = le.pop();
      if (ve === void 0)
        throw Error("Stack.length > 0; can't be undefined");
      e.$isElementNode(ve) && le.unshift(...ve.getChildren()), ve !== Oe && ie.push(ve);
    }
    return ie;
  }
  const f = /^(\d+(?:\.\d+)?)px$/, p = {
    BOTH: 3,
    COLUMN: 2,
    NO_STATUS: 0,
    ROW: 1
  };
  class _ extends e.DEPRECATED_GridCellNode {
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "tablecell";
    }
    static clone(ie) {
      const le = new _(ie.__headerState, ie.__colSpan, ie.__width, ie.__key);
      return le.__rowSpan = ie.__rowSpan, le.__backgroundColor = ie.__backgroundColor, le;
    }
    static importDOM() {
      return {
        td: (ie) => ({
          conversion: E,
          priority: 0
        }),
        th: (ie) => ({
          conversion: E,
          priority: 0
        })
      };
    }
    static importJSON(ie) {
      const le = ie.colSpan || 1, ve = ie.rowSpan || 1, Le = T(ie.headerState, le, ie.width || void 0);
      return Le.__rowSpan = ve, Le.__backgroundColor = ie.backgroundColor || null, Le;
    }
    constructor(ie = p.NO_STATUS, le = 1, ve, Le) {
      super(le, Le), this.__headerState = ie, this.__width = ve, this.__backgroundColor = null;
    }
    createDOM(ie) {
      const le = document.createElement(this.getTag());
      return this.__width && (le.style.width = `${this.__width}px`), this.__colSpan > 1 && (le.colSpan = this.__colSpan), this.__rowSpan > 1 && (le.rowSpan = this.__rowSpan), this.__backgroundColor !== null && (le.style.backgroundColor = this.__backgroundColor), t.addClassNamesToElement(le, ie.theme.tableCell, this.hasHeader() && ie.theme.tableCellHeader), le;
    }
    exportDOM(ie) {
      const {
        element: le
      } = super.exportDOM(ie);
      if (le) {
        const ve = le, Le = 700, Me = this.getParentOrThrow().getChildrenSize();
        ve.style.border = "1px solid black", this.__colSpan > 1 && (ve.colSpan = this.__colSpan), this.__rowSpan > 1 && (ve.rowSpan = this.__rowSpan), ve.style.width = `${this.getWidth() || Math.max(90, Le / Me)}px`, ve.style.verticalAlign = "top", ve.style.textAlign = "start";
        const je = this.getBackgroundColor();
        je !== null ? ve.style.backgroundColor = je : this.hasHeader() && (ve.style.backgroundColor = "#f2f3f5");
      }
      return {
        element: le
      };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        backgroundColor: this.getBackgroundColor(),
        headerState: this.__headerState,
        type: "tablecell",
        width: this.getWidth()
      };
    }
    getTag() {
      return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(ie) {
      const le = this.getWritable();
      return le.__headerState = ie, this.__headerState;
    }
    getHeaderStyles() {
      return this.getLatest().__headerState;
    }
    setWidth(ie) {
      const le = this.getWritable();
      return le.__width = ie, this.__width;
    }
    getWidth() {
      return this.getLatest().__width;
    }
    getBackgroundColor() {
      return this.getLatest().__backgroundColor;
    }
    setBackgroundColor(ie) {
      this.getWritable().__backgroundColor = ie;
    }
    toggleHeaderStyle(ie) {
      const le = this.getWritable();
      return (le.__headerState & ie) === ie ? le.__headerState -= ie : le.__headerState += ie, le;
    }
    hasHeaderState(ie) {
      return (this.getHeaderStyles() & ie) === ie;
    }
    hasHeader() {
      return this.getLatest().__headerState !== p.NO_STATUS;
    }
    updateDOM(ie) {
      return ie.__headerState !== this.__headerState || ie.__width !== this.__width || ie.__colSpan !== this.__colSpan || ie.__rowSpan !== this.__rowSpan || ie.__backgroundColor !== this.__backgroundColor;
    }
    isShadowRoot() {
      return !0;
    }
    collapseAtStart() {
      return !0;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function E(Oe) {
    const ie = Oe, le = Oe.nodeName.toLowerCase();
    let ve;
    f.test(ie.style.width) && (ve = parseFloat(ie.style.width));
    const Le = T(le === "th" ? p.ROW : p.NO_STATUS, ie.colSpan, ve);
    Le.__rowSpan = ie.rowSpan;
    const Me = ie.style.backgroundColor;
    return Me !== "" && (Le.__backgroundColor = Me), {
      forChild: (je, rt) => {
        if (S(rt) && !e.$isElementNode(je)) {
          const it = e.$createParagraphNode();
          return e.$isLineBreakNode(je) && je.getTextContent() === `
` ? null : (it.append(je), it);
        }
        return je;
      },
      node: Le
    };
  }
  function T(Oe, ie = 1, le) {
    return e.$applyNodeReplacement(new _(Oe, ie, le));
  }
  function S(Oe) {
    return Oe instanceof _;
  }
  class w extends e.DEPRECATED_GridRowNode {
    /** @internal */
    static getType() {
      return "tablerow";
    }
    static clone(ie) {
      return new w(ie.__height, ie.__key);
    }
    static importDOM() {
      return {
        tr: (ie) => ({
          conversion: O,
          priority: 0
        })
      };
    }
    static importJSON(ie) {
      return m(ie.height);
    }
    constructor(ie, le) {
      super(le), this.__height = ie;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "tablerow",
        version: 1
      };
    }
    createDOM(ie) {
      const le = document.createElement("tr");
      return this.__height && (le.style.height = `${this.__height}px`), t.addClassNamesToElement(le, ie.theme.tableRow), le;
    }
    isShadowRoot() {
      return !0;
    }
    setHeight(ie) {
      const le = this.getWritable();
      return le.__height = ie, this.__height;
    }
    getHeight() {
      return this.getLatest().__height;
    }
    updateDOM(ie) {
      return ie.__height !== this.__height;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function O(Oe) {
    const ie = Oe;
    let le;
    return f.test(ie.style.height) && (le = parseFloat(ie.style.height)), {
      node: m(le)
    };
  }
  function m(Oe) {
    return e.$applyNodeReplacement(new w(Oe));
  }
  function v(Oe) {
    return Oe instanceof w;
  }
  const I = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", G = (Oe) => I ? (Oe || window).getSelection() : null;
  class k {
    constructor(ie, le) {
      this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = le, this.editor = ie, this.grid = {
        cells: [],
        columns: 0,
        rows: 0
      }, this.gridSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
    }
    getGrid() {
      return this.grid;
    }
    removeListeners() {
      Array.from(this.listenersToRemove).forEach((ie) => ie());
    }
    trackTableGrid() {
      const ie = new MutationObserver((le) => {
        this.editor.update(() => {
          let ve = !1;
          for (let Me = 0; Me < le.length; Me++) {
            const it = le[Me].target.nodeName;
            if (it === "TABLE" || it === "TR") {
              ve = !0;
              break;
            }
          }
          if (!ve)
            return;
          const Le = this.editor.getElementByKey(this.tableNodeKey);
          if (!Le)
            throw new Error("Expected to find TableElement in DOM");
          this.grid = ce(Le);
        });
      });
      this.editor.update(() => {
        const le = this.editor.getElementByKey(this.tableNodeKey);
        if (!le)
          throw new Error("Expected to find TableElement in DOM");
        this.grid = ce(le), ie.observe(le, {
          childList: !0,
          subtree: !0
        });
      });
    }
    clearHighlight() {
      const ie = this.editor;
      this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.gridSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), ie.update(() => {
        const le = e.$getNodeByKey(this.tableNodeKey);
        if (!B(le))
          throw new Error("Expected TableNode.");
        const ve = ie.getElementByKey(this.tableNodeKey);
        if (!ve)
          throw new Error("Expected to find TableElement in DOM");
        const Le = ce(ve);
        V(ie, Le, null), e.$setSelection(null), ie.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    enableHighlightStyle() {
      const ie = this.editor;
      ie.update(() => {
        const le = ie.getElementByKey(this.tableNodeKey);
        if (!le)
          throw new Error("Expected to find TableElement in DOM");
        t.removeClassNamesFromElement(le, ie._config.theme.tableSelection), le.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
      });
    }
    disableHighlightStyle() {
      const ie = this.editor;
      ie.update(() => {
        const le = ie.getElementByKey(this.tableNodeKey);
        if (!le)
          throw new Error("Expected to find TableElement in DOM");
        t.addClassNamesToElement(le, ie._config.theme.tableSelection), this.hasHijackedSelectionStyles = !0;
      });
    }
    updateTableGridSelection(ie) {
      if (ie != null && ie.gridKey === this.tableNodeKey) {
        const le = this.editor;
        this.gridSelection = ie, this.isHighlightingCells = !0, this.disableHighlightStyle(), V(le, this.grid, this.gridSelection);
      } else ie == null ? this.clearHighlight() : (this.tableNodeKey = ie.gridKey, this.updateTableGridSelection(ie));
    }
    setFocusCellForSelection(ie, le = !1) {
      const ve = this.editor;
      ve.update(() => {
        const Le = e.$getNodeByKey(this.tableNodeKey);
        if (!B(Le))
          throw new Error("Expected TableNode.");
        if (!ve.getElementByKey(this.tableNodeKey))
          throw new Error("Expected to find TableElement in DOM");
        const je = ie.x, rt = ie.y;
        if (this.focusCell = ie, this.anchorCell !== null) {
          const it = G(ve._window);
          it && it.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
        }
        if (!this.isHighlightingCells && (this.anchorX !== je || this.anchorY !== rt || le))
          this.isHighlightingCells = !0, this.disableHighlightStyle();
        else if (je === this.focusX && rt === this.focusY)
          return;
        if (this.focusX = je, this.focusY = rt, this.isHighlightingCells) {
          const it = e.$getNearestNodeFromDOMNode(ie.elem);
          if (this.gridSelection != null && this.anchorCellNodeKey != null && S(it)) {
            const st = it.getKey();
            this.gridSelection = this.gridSelection.clone() || l(), this.focusCellNodeKey = st, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), e.$setSelection(this.gridSelection), ve.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0), V(ve, this.grid, this.gridSelection);
          }
        }
      });
    }
    setAnchorCellForSelection(ie) {
      this.isHighlightingCells = !1, this.anchorCell = ie, this.anchorX = ie.x, this.anchorY = ie.y, this.editor.update(() => {
        const le = e.$getNearestNodeFromDOMNode(ie.elem);
        if (S(le)) {
          const ve = le.getKey();
          this.gridSelection = this.gridSelection != null ? this.gridSelection.clone() : l(), this.anchorCellNodeKey = ve;
        }
      });
    }
    formatCells(ie) {
      this.editor.update(() => {
        const le = e.$getSelection();
        if (!r(le))
          throw Error("Expected grid selection");
        const ve = e.$createRangeSelection(), Le = ve.anchor, Me = ve.focus;
        le.getNodes().forEach((je) => {
          S(je) && je.getTextContentSize() !== 0 && (Le.set(je.getKey(), 0, "element"), Me.set(je.getKey(), je.getChildrenSize(), "element"), ve.formatText(ie));
        }), e.$setSelection(le), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    clearText() {
      const ie = this.editor;
      ie.update(() => {
        const le = e.$getNodeByKey(this.tableNodeKey);
        if (!B(le))
          throw new Error("Expected TableNode.");
        const ve = e.$getSelection();
        if (!r(ve))
          throw Error("Expected grid selection");
        const Le = ve.getNodes().filter(S);
        if (Le.length === this.grid.columns * this.grid.rows) {
          le.selectPrevious(), le.remove(), e.$getRoot().selectStart();
          return;
        }
        Le.forEach((Me) => {
          if (e.$isElementNode(Me)) {
            const je = e.$createParagraphNode(), rt = e.$createTextNode();
            je.append(rt), Me.append(je), Me.getChildren().forEach((it) => {
              it !== je && it.remove();
            });
          }
        }), V(ie, this.grid, null), e.$setSelection(null), ie.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
  }
  const P = "__lexicalTableSelection";
  function H(Oe, ie, le, ve) {
    const Le = le.getRootElement();
    if (Le === null)
      throw new Error("No root element.");
    const Me = new k(le, Oe.getKey()), je = le._window || window;
    j(ie, Me), ie.addEventListener("mousedown", (Ge) => {
      setTimeout(() => {
        if (Ge.button !== 0 || !je)
          return;
        const ze = te(Ge.target);
        ze !== null && (R(Ge), Me.setAnchorCellForSelection(ze));
        const tt = () => {
          je.removeEventListener("mouseup", tt), je.removeEventListener("mousemove", _t);
        }, _t = (yt) => {
          const Ct = te(yt.target);
          Ct !== null && (Me.anchorX !== Ct.x || Me.anchorY !== Ct.y) && (yt.preventDefault(), Me.setFocusCellForSelection(Ct));
        };
        je.addEventListener("mouseup", tt), je.addEventListener("mousemove", _t);
      }, 0);
    });
    const rt = (Ge) => {
      Ge.button === 0 && le.update(() => {
        const ze = e.$getSelection(), tt = Ge.target;
        r(ze) && ze.gridKey === Me.tableNodeKey && Le.contains(tt) && Me.clearHighlight();
      });
    };
    je.addEventListener("mousedown", rt), Me.listenersToRemove.add(() => je.removeEventListener("mousedown", rt)), Me.listenersToRemove.add(le.registerCommand(e.KEY_ARROW_DOWN_COMMAND, (Ge) => J(le, Ge, "down", Oe, Me), e.COMMAND_PRIORITY_HIGH)), Me.listenersToRemove.add(le.registerCommand(e.KEY_ARROW_UP_COMMAND, (Ge) => J(le, Ge, "up", Oe, Me), e.COMMAND_PRIORITY_HIGH)), Me.listenersToRemove.add(le.registerCommand(e.KEY_ARROW_LEFT_COMMAND, (Ge) => J(le, Ge, "backward", Oe, Me), e.COMMAND_PRIORITY_HIGH)), Me.listenersToRemove.add(le.registerCommand(e.KEY_ARROW_RIGHT_COMMAND, (Ge) => J(le, Ge, "forward", Oe, Me), e.COMMAND_PRIORITY_HIGH)), Me.listenersToRemove.add(le.registerCommand(e.KEY_ESCAPE_COMMAND, (Ge) => {
      const ze = e.$getSelection();
      if (r(ze)) {
        const tt = t.$findMatchingParent(ze.focus.getNode(), S);
        if (S(tt))
          return R(Ge), tt.selectEnd(), !0;
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH));
    const it = (Ge) => () => {
      const ze = e.$getSelection();
      if (!de(ze, Oe))
        return !1;
      if (r(ze))
        return Me.clearText(), !0;
      if (e.$isRangeSelection(ze)) {
        const tt = t.$findMatchingParent(ze.anchor.getNode(), (Wt) => S(Wt));
        if (!S(tt))
          return !1;
        const _t = ze.anchor.getNode(), yt = ze.focus.getNode(), Ct = Oe.isParentOf(_t), ht = Oe.isParentOf(yt);
        if (Ct && !ht || ht && !Ct)
          return Me.clearText(), !0;
        const pt = t.$findMatchingParent(ze.anchor.getNode(), (Wt) => e.$isElementNode(Wt)), Pt = pt && t.$findMatchingParent(pt, (Wt) => e.$isElementNode(Wt) && S(Wt.getParent()));
        if (!e.$isElementNode(Pt) || !e.$isElementNode(pt))
          return !1;
        if (Ge === e.DELETE_LINE_COMMAND && Pt.getPreviousSibling() === null)
          return !0;
        if ((Ge === e.DELETE_CHARACTER_COMMAND || Ge === e.DELETE_WORD_COMMAND) && ze.isCollapsed() && ze.anchor.offset === 0 && pt !== Pt) {
          const Wt = pt.getChildren(), tn = e.$createParagraphNode();
          return Wt.forEach((Lt) => tn.append(Lt)), pt.replace(tn), pt.getWritable().__parent = tt.getKey(), !0;
        }
      }
      return !1;
    };
    [e.DELETE_WORD_COMMAND, e.DELETE_LINE_COMMAND, e.DELETE_CHARACTER_COMMAND].forEach((Ge) => {
      Me.listenersToRemove.add(le.registerCommand(Ge, it(Ge), e.COMMAND_PRIORITY_CRITICAL));
    });
    const st = (Ge) => {
      const ze = e.$getSelection();
      if (!de(ze, Oe))
        return !1;
      if (r(ze))
        return Ge.preventDefault(), Ge.stopPropagation(), Me.clearText(), !0;
      if (e.$isRangeSelection(ze)) {
        const tt = t.$findMatchingParent(ze.anchor.getNode(), (_t) => S(_t));
        if (!S(tt))
          return !1;
      }
      return !1;
    };
    Me.listenersToRemove.add(le.registerCommand(e.KEY_BACKSPACE_COMMAND, st, e.COMMAND_PRIORITY_CRITICAL)), Me.listenersToRemove.add(le.registerCommand(e.KEY_DELETE_COMMAND, st, e.COMMAND_PRIORITY_CRITICAL)), Me.listenersToRemove.add(le.registerCommand(e.FORMAT_TEXT_COMMAND, (Ge) => {
      const ze = e.$getSelection();
      if (!de(ze, Oe))
        return !1;
      if (r(ze))
        return Me.formatCells(Ge), !0;
      if (e.$isRangeSelection(ze)) {
        const tt = t.$findMatchingParent(ze.anchor.getNode(), (_t) => S(_t));
        if (!S(tt))
          return !1;
      }
      return !1;
    }, e.COMMAND_PRIORITY_CRITICAL)), Me.listenersToRemove.add(le.registerCommand(e.CONTROLLED_TEXT_INSERTION_COMMAND, (Ge) => {
      const ze = e.$getSelection();
      if (!de(ze, Oe))
        return !1;
      if (r(ze))
        return Me.clearHighlight(), !1;
      if (e.$isRangeSelection(ze)) {
        const tt = t.$findMatchingParent(ze.anchor.getNode(), (_t) => S(_t));
        if (!S(tt))
          return !1;
      }
      return !1;
    }, e.COMMAND_PRIORITY_CRITICAL)), ve && Me.listenersToRemove.add(le.registerCommand(e.KEY_TAB_COMMAND, (Ge) => {
      const ze = e.$getSelection();
      if (!e.$isRangeSelection(ze) || !ze.isCollapsed() || !de(ze, Oe))
        return !1;
      const tt = Y(ze.anchor.getNode());
      if (tt === null)
        return !1;
      R(Ge);
      const _t = Oe.getCordsFromCellNode(tt, Me.grid);
      return Se(Me, Oe, _t.x, _t.y, Ge.shiftKey ? "backward" : "forward"), !0;
    }, e.COMMAND_PRIORITY_CRITICAL)), Me.listenersToRemove.add(le.registerCommand(e.FOCUS_COMMAND, (Ge) => Oe.isSelected(), e.COMMAND_PRIORITY_HIGH));
    function vt(Ge) {
      const ze = Oe.getCordsFromCellNode(Ge, Me.grid);
      return Oe.getCellFromCordsOrThrow(ze.x, ze.y, Me.grid);
    }
    return Me.listenersToRemove.add(le.registerCommand(e.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, (Ge) => {
      const {
        nodes: ze,
        selection: tt
      } = Ge, _t = e.$INTERNAL_isPointSelection(tt), yt = e.$isRangeSelection(tt), Ct = yt && t.$findMatchingParent(tt.anchor.getNode(), (Bt) => e.DEPRECATED_$isGridCellNode(Bt)) !== null && t.$findMatchingParent(tt.focus.getNode(), (Bt) => e.DEPRECATED_$isGridCellNode(Bt)) !== null || _t && !yt;
      if (ze.length !== 1 || !e.DEPRECATED_$isGridNode(ze[0]) || !Ct)
        return !1;
      const {
        anchor: ht
      } = tt, Tt = ze[0], pt = Tt.getChildren(), Pt = Tt.getFirstChildOrThrow().getChildrenSize(), Wt = Tt.getChildrenSize(), tn = t.$findMatchingParent(ht.getNode(), (Bt) => e.DEPRECATED_$isGridCellNode(Bt)), Lt = tn && t.$findMatchingParent(tn, (Bt) => e.DEPRECATED_$isGridRowNode(Bt)), jt = Lt && t.$findMatchingParent(Lt, (Bt) => e.DEPRECATED_$isGridNode(Bt));
      if (!e.DEPRECATED_$isGridCellNode(tn) || !e.DEPRECATED_$isGridRowNode(Lt) || !e.DEPRECATED_$isGridNode(jt))
        return !1;
      const Rt = Lt.getIndexWithinParent(), nn = Math.min(jt.getChildrenSize() - 1, Rt + Wt - 1), Ar = tn.getIndexWithinParent(), Ni = Math.min(Lt.getChildrenSize() - 1, Ar + Pt - 1), pe = Math.min(Ar, Ni), Ze = Math.min(Rt, nn), ot = Math.max(Ar, Ni), St = Math.max(Rt, nn), Ut = jt.getChildren();
      let Ft = 0, kt, It;
      for (let Bt = Ze; Bt <= St; Bt++) {
        const sn = Ut[Bt];
        if (!e.DEPRECATED_$isGridRowNode(sn))
          return !1;
        const ln = pt[Ft];
        if (!e.DEPRECATED_$isGridRowNode(ln))
          return !1;
        const bn = sn.getChildren(), Cr = ln.getChildren();
        let Zn = 0;
        for (let un = pe; un <= ot; un++) {
          const or = bn[un];
          if (!e.DEPRECATED_$isGridCellNode(or))
            return !1;
          const lr = Cr[Zn];
          if (!e.DEPRECATED_$isGridCellNode(lr))
            return !1;
          Bt === Ze && un === pe ? kt = or.getKey() : Bt === St && un === ot && (It = or.getKey());
          const Ri = or.getChildren();
          lr.getChildren().forEach((Er) => {
            e.$isTextNode(Er) && e.$createParagraphNode().append(Er), or.append(Er);
          }), Ri.forEach((Er) => Er.remove()), Zn++;
        }
        Ft++;
      }
      if (kt && It) {
        const Bt = l();
        Bt.set(ze[0].getKey(), kt, It), e.$setSelection(Bt);
      }
      return !0;
    }, e.COMMAND_PRIORITY_CRITICAL)), Me.listenersToRemove.add(le.registerCommand(e.SELECTION_CHANGE_COMMAND, () => {
      const Ge = e.$getSelection(), ze = e.$getPreviousSelection();
      if (e.$isRangeSelection(Ge)) {
        const {
          anchor: tt,
          focus: _t
        } = Ge, yt = tt.getNode(), Ct = _t.getNode(), ht = Y(yt), Tt = Y(Ct), pt = ht && Oe.is(W(ht)), Pt = Tt && Oe.is(W(Tt)), Wt = pt !== Pt, tn = pt && Pt, Lt = Ge.isBackward();
        if (Wt) {
          const jt = Ge.clone();
          jt.focus.set(Oe.getKey(), Lt ? 0 : Oe.getChildrenSize(), "element"), e.$setSelection(jt), q(le, Me);
        } else tn && (ht.is(Tt) || (Me.setAnchorCellForSelection(vt(ht)), Me.setFocusCellForSelection(vt(Tt), !0)));
      }
      return Ge && !Ge.is(ze) && (r(Ge) || r(ze)) && Me.gridSelection && !Me.gridSelection.is(ze) ? (r(Ge) && Ge.gridKey === Me.tableNodeKey ? Me.updateTableGridSelection(Ge) : !r(Ge) && r(ze) && ze.gridKey === Me.tableNodeKey && Me.updateTableGridSelection(null), !1) : (Me.hasHijackedSelectionStyles && !Oe.isSelected() ? Te(le, Me) : !Me.hasHijackedSelectionStyles && Oe.isSelected() && q(le, Me), !1);
    }, e.COMMAND_PRIORITY_CRITICAL)), Me;
  }
  function j(Oe, ie) {
    Oe[P] = ie;
  }
  function re(Oe) {
    return Oe[P];
  }
  function te(Oe) {
    let ie = Oe;
    for (; ie != null; ) {
      const le = ie.nodeName;
      if (le === "TD" || le === "TH") {
        const ve = ie._cell;
        return ve === void 0 ? null : ve;
      }
      ie = ie.parentNode;
    }
    return null;
  }
  function ce(Oe) {
    const ie = [], le = {
      cells: ie,
      columns: 0,
      rows: 0
    };
    let ve = Oe.firstChild, Le = 0, Me = 0;
    for (ie.length = 0; ve != null; ) {
      const je = ve.nodeName;
      if (je === "TD" || je === "TH") {
        const st = ve, vt = {
          elem: st,
          hasBackgroundColor: st.style.backgroundColor !== "",
          highlighted: !1,
          x: Le,
          y: Me
        };
        ve._cell = vt;
        let Ge = ie[Me];
        Ge === void 0 && (Ge = ie[Me] = []), Ge[Le] = vt;
      } else {
        const st = ve.firstChild;
        if (st != null) {
          ve = st;
          continue;
        }
      }
      const rt = ve.nextSibling;
      if (rt != null) {
        Le++, ve = rt;
        continue;
      }
      const it = ve.parentNode;
      if (it != null) {
        const st = it.nextSibling;
        if (st == null)
          break;
        Me++, Le = 0, ve = st;
      }
    }
    return le.columns = Le + 1, le.rows = Me + 1, le;
  }
  function V(Oe, ie, le) {
    const ve = new Set(le ? le.getNodes() : []);
    z(ie, (Le, Me) => {
      const je = Le.elem;
      ve.has(Me) ? (Le.highlighted = !0, Z(Oe, Le)) : (Le.highlighted = !1, oe(Oe, Le), je.getAttribute("style") || je.removeAttribute("style"));
    });
  }
  function z(Oe, ie) {
    const {
      cells: le
    } = Oe;
    for (let ve = 0; ve < le.length; ve++) {
      const Le = le[ve];
      if (Le)
        for (let Me = 0; Me < Le.length; Me++) {
          const je = Le[Me];
          if (!je)
            continue;
          const rt = e.$getNearestNodeFromDOMNode(je.elem);
          rt !== null && ie(je, rt, {
            x: Me,
            y: ve
          });
        }
    }
  }
  function q(Oe, ie) {
    ie.disableHighlightStyle(), z(ie.grid, (le) => {
      le.highlighted = !0, Z(Oe, le);
    });
  }
  function Te(Oe, ie) {
    ie.enableHighlightStyle(), z(ie.grid, (le) => {
      const ve = le.elem;
      le.highlighted = !1, oe(Oe, le), ve.getAttribute("style") || ve.removeAttribute("style");
    });
  }
  const Se = (Oe, ie, le, ve, Le) => {
    const Me = Le === "forward";
    switch (Le) {
      case "backward":
      case "forward":
        return le !== (Me ? Oe.grid.columns - 1 : 0) ? K(ie.getCellNodeFromCordsOrThrow(le + (Me ? 1 : -1), ve, Oe.grid), Me) : ve !== (Me ? Oe.grid.rows - 1 : 0) ? K(ie.getCellNodeFromCordsOrThrow(Me ? 0 : Oe.grid.columns - 1, ve + (Me ? 1 : -1), Oe.grid), Me) : Me ? ie.selectNext() : ie.selectPrevious(), !0;
      case "up":
        return ve !== 0 ? K(ie.getCellNodeFromCordsOrThrow(le, ve - 1, Oe.grid), !1) : ie.selectPrevious(), !0;
      case "down":
        return ve !== Oe.grid.rows - 1 ? K(ie.getCellNodeFromCordsOrThrow(le, ve + 1, Oe.grid), !0) : ie.selectNext(), !0;
      default:
        return !1;
    }
  }, Ee = (Oe, ie, le, ve, Le) => {
    const Me = Le === "forward";
    switch (Le) {
      case "backward":
      case "forward":
        return le !== (Me ? Oe.grid.columns - 1 : 0) && Oe.setFocusCellForSelection(ie.getCellFromCordsOrThrow(le + (Me ? 1 : -1), ve, Oe.grid)), !0;
      case "up":
        return ve !== 0 ? (Oe.setFocusCellForSelection(ie.getCellFromCordsOrThrow(le, ve - 1, Oe.grid)), !0) : !1;
      case "down":
        return ve !== Oe.grid.rows - 1 ? (Oe.setFocusCellForSelection(ie.getCellFromCordsOrThrow(le, ve + 1, Oe.grid)), !0) : !1;
      default:
        return !1;
    }
  };
  function de(Oe, ie) {
    if (e.$isRangeSelection(Oe) || r(Oe)) {
      const le = ie.isParentOf(Oe.anchor.getNode()), ve = ie.isParentOf(Oe.focus.getNode());
      return le && ve;
    }
    return !1;
  }
  function K(Oe, ie) {
    ie ? Oe.selectStart() : Oe.selectEnd();
  }
  const D = "172,206,247";
  function Z(Oe, ie) {
    const le = ie.elem, ve = e.$getNearestNodeFromDOMNode(le);
    if (!S(ve))
      throw Error("Expected to find LexicalNode from Table Cell DOMNode");
    ve.getBackgroundColor() === null ? le.style.setProperty("background-color", `rgb(${D})`) : le.style.setProperty("background-image", `linear-gradient(to right, rgba(${D},0.85), rgba(${D},0.85))`), le.style.setProperty("caret-color", "transparent");
  }
  function oe(Oe, ie) {
    const le = ie.elem, ve = e.$getNearestNodeFromDOMNode(le);
    if (!S(ve))
      throw Error("Expected to find LexicalNode from Table Cell DOMNode");
    ve.getBackgroundColor() === null && le.style.removeProperty("background-color"), le.style.removeProperty("background-image"), le.style.removeProperty("caret-color");
  }
  function Y(Oe) {
    const ie = t.$findMatchingParent(Oe, S);
    return S(ie) ? ie : null;
  }
  function W(Oe) {
    const ie = t.$findMatchingParent(Oe, B);
    return B(ie) ? ie : null;
  }
  function J(Oe, ie, le, ve, Le) {
    const Me = e.$getSelection();
    if (!de(Me, ve))
      return !1;
    if (e.$isRangeSelection(Me) && Me.isCollapsed()) {
      if (le === "backward" || le === "forward")
        return !1;
      const {
        anchor: je,
        focus: rt
      } = Me, it = t.$findMatchingParent(je.getNode(), S), st = t.$findMatchingParent(rt.getNode(), S);
      if (!S(it) || !it.is(st))
        return !1;
      const vt = W(it);
      if (vt !== ve && vt != null) {
        const Tt = Oe.getElementByKey(vt.getKey());
        if (Tt != null)
          return Le.grid = ce(Tt), J(Oe, ie, le, vt, Le);
      }
      const Ge = Oe.getElementByKey(it.__key), ze = Oe.getElementByKey(je.key);
      if (ze == null || Ge == null)
        return !1;
      let tt;
      if (je.type === "element")
        tt = ze.getBoundingClientRect();
      else {
        const Tt = window.getSelection();
        if (Tt === null || Tt.rangeCount === 0)
          return !1;
        tt = Tt.getRangeAt(0).getBoundingClientRect();
      }
      const _t = le === "up" ? it.getFirstChild() : it.getLastChild();
      if (_t == null)
        return !1;
      const yt = Oe.getElementByKey(_t.__key);
      if (yt == null)
        return !1;
      const Ct = yt.getBoundingClientRect();
      if (le === "up" ? Ct.top > tt.top - tt.height : tt.bottom + tt.height > Ct.bottom) {
        R(ie);
        const Tt = ve.getCordsFromCellNode(it, Le.grid);
        if (ie.shiftKey) {
          const pt = ve.getCellFromCordsOrThrow(Tt.x, Tt.y, Le.grid);
          Le.setAnchorCellForSelection(pt), Le.setFocusCellForSelection(pt, !0);
        } else
          return Se(Le, ve, Tt.x, Tt.y, le);
        return !0;
      }
    } else if (r(Me)) {
      const {
        anchor: je,
        focus: rt
      } = Me, it = t.$findMatchingParent(je.getNode(), S), st = t.$findMatchingParent(rt.getNode(), S), [vt] = Me.getNodes(), Ge = Oe.getElementByKey(vt.getKey());
      if (!S(it) || !S(st) || !B(vt) || Ge == null)
        return !1;
      Le.updateTableGridSelection(Me);
      const ze = ce(Ge), tt = ve.getCordsFromCellNode(it, ze), _t = ve.getCellFromCordsOrThrow(tt.x, tt.y, ze);
      if (Le.setAnchorCellForSelection(_t), R(ie), ie.shiftKey) {
        const yt = ve.getCordsFromCellNode(st, ze);
        return Ee(Le, vt, yt.x, yt.y, le);
      } else
        st.selectEnd();
      return !0;
    }
    return !1;
  }
  function R(Oe) {
    Oe.preventDefault(), Oe.stopImmediatePropagation(), Oe.stopPropagation();
  }
  class U extends e.DEPRECATED_GridNode {
    /** @internal */
    static getType() {
      return "table";
    }
    static clone(ie) {
      return new U(ie.__key);
    }
    static importDOM() {
      return {
        table: (ie) => ({
          conversion: fe,
          priority: 1
        })
      };
    }
    static importJSON(ie) {
      return _e();
    }
    constructor(ie) {
      super(ie);
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "table",
        version: 1
      };
    }
    createDOM(ie, le) {
      const ve = document.createElement("table");
      return t.addClassNamesToElement(ve, ie.theme.table), ve;
    }
    updateDOM() {
      return !1;
    }
    exportDOM(ie) {
      return {
        ...super.exportDOM(ie),
        after: (le) => {
          if (le) {
            const ve = le.cloneNode(), Le = document.createElement("colgroup"), Me = document.createElement("tbody");
            t.isHTMLElement(le) && Me.append(...le.children);
            const je = this.getFirstChildOrThrow();
            if (!v(je))
              throw new Error("Expected to find row node.");
            const rt = je.getChildrenSize();
            for (let it = 0; it < rt; it++) {
              const st = document.createElement("col");
              Le.append(st);
            }
            return ve.replaceChildren(Le, Me), ve;
          }
        }
      };
    }
    // TODO 0.10 deprecate
    canExtractContents() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isShadowRoot() {
      return !0;
    }
    getCordsFromCellNode(ie, le) {
      const {
        rows: ve,
        cells: Le
      } = le;
      for (let Me = 0; Me < ve; Me++) {
        const je = Le[Me];
        if (je == null)
          continue;
        const rt = je.findIndex((it) => {
          if (!it) return;
          const {
            elem: st
          } = it;
          return e.$getNearestNodeFromDOMNode(st) === ie;
        });
        if (rt !== -1)
          return {
            x: rt,
            y: Me
          };
      }
      throw new Error("Cell not found in table.");
    }
    getCellFromCords(ie, le, ve) {
      const {
        cells: Le
      } = ve, Me = Le[le];
      if (Me == null)
        return null;
      const je = Me[ie];
      return je ?? null;
    }
    getCellFromCordsOrThrow(ie, le, ve) {
      const Le = this.getCellFromCords(ie, le, ve);
      if (!Le)
        throw new Error("Cell not found at cords.");
      return Le;
    }
    getCellNodeFromCords(ie, le, ve) {
      const Le = this.getCellFromCords(ie, le, ve);
      if (Le == null)
        return null;
      const Me = e.$getNearestNodeFromDOMNode(Le.elem);
      return S(Me) ? Me : null;
    }
    getCellNodeFromCordsOrThrow(ie, le, ve) {
      const Le = this.getCellNodeFromCords(ie, le, ve);
      if (!Le)
        throw new Error("Node at cords not TableCellNode.");
      return Le;
    }
    canSelectBefore() {
      return !0;
    }
    canIndent() {
      return !1;
    }
  }
  function X(Oe, ie) {
    const le = Oe.getElementByKey(ie.getKey());
    if (le == null)
      throw new Error("Table Element Not Found");
    return ce(le);
  }
  function fe(Oe) {
    return {
      node: _e()
    };
  }
  function _e() {
    return e.$applyNodeReplacement(new U());
  }
  function B(Oe) {
    return Oe instanceof U;
  }
  function M(Oe, ie, le = !0) {
    const ve = _e();
    for (let Le = 0; Le < Oe; Le++) {
      const Me = m();
      for (let je = 0; je < ie; je++) {
        let rt = p.NO_STATUS;
        typeof le == "object" ? (Le === 0 && le.rows && (rt |= p.ROW), je === 0 && le.columns && (rt |= p.COLUMN)) : le && (Le === 0 && (rt |= p.ROW), je === 0 && (rt |= p.COLUMN));
        const it = T(rt), st = e.$createParagraphNode();
        st.append(e.$createTextNode()), it.append(st), Me.append(it);
      }
      ve.append(Me);
    }
    return ve;
  }
  function F(Oe) {
    const ie = t.$findMatchingParent(Oe, (le) => S(le));
    return S(ie) ? ie : null;
  }
  function se(Oe) {
    const ie = t.$findMatchingParent(Oe, (le) => v(le));
    if (v(ie))
      return ie;
    throw new Error("Expected table cell to be inside of table row.");
  }
  function ye(Oe) {
    const ie = t.$findMatchingParent(Oe, (le) => B(le));
    if (B(ie))
      return ie;
    throw new Error("Expected table cell to be inside of table.");
  }
  function De(Oe) {
    const ie = se(Oe);
    return ye(ie).getChildren().findIndex((ve) => ve.is(ie));
  }
  function ee(Oe) {
    return se(Oe).getChildren().findIndex((le) => le.is(Oe));
  }
  function ne(Oe, ie) {
    const le = ye(Oe), {
      x: ve,
      y: Le
    } = le.getCordsFromCellNode(Oe, ie);
    return {
      above: le.getCellNodeFromCords(ve, Le - 1, ie),
      below: le.getCellNodeFromCords(ve, Le + 1, ie),
      left: le.getCellNodeFromCords(ve - 1, Le, ie),
      right: le.getCellNodeFromCords(ve + 1, Le, ie)
    };
  }
  function ue(Oe, ie) {
    const le = Oe.getChildren();
    if (ie >= le.length || ie < 0)
      throw new Error("Expected table cell to be inside of table row.");
    return le[ie].remove(), Oe;
  }
  function be(Oe, ie, le = !0, ve, Le) {
    const Me = Oe.getChildren();
    if (ie >= Me.length || ie < 0)
      throw new Error("Table row target index out of range");
    const je = Me[ie];
    if (v(je))
      for (let rt = 0; rt < ve; rt++) {
        const it = je.getChildren(), st = it.length, vt = m();
        for (let Ge = 0; Ge < st; Ge++) {
          const ze = it[Ge];
          if (!S(ze))
            throw Error("Expected table cell");
          const {
            above: tt,
            below: _t
          } = ne(ze, Le);
          let yt = p.NO_STATUS;
          const Ct = tt && tt.getWidth() || _t && _t.getWidth() || void 0;
          (tt && tt.hasHeaderState(p.COLUMN) || _t && _t.hasHeaderState(p.COLUMN)) && (yt |= p.COLUMN);
          const ht = T(yt, 1, Ct);
          ht.append(e.$createParagraphNode()), vt.append(ht);
        }
        le ? je.insertAfter(vt) : je.insertBefore(vt);
      }
    else
      throw new Error("Row before insertion index does not exist.");
    return Oe;
  }
  function Ne(Oe = !0) {
    const ie = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(ie))
      throw Error("Expected a INTERNAL_PointSelection");
    const le = ie.focus.getNode(), [ve, , Le] = e.DEPRECATED_$getNodeTriplet(le), [Me, je] = e.DEPRECATED_$computeGridMap(Le, ve, ve), rt = Me[0].length, {
      startRow: it
    } = je;
    if (Oe) {
      const st = it + ve.__rowSpan - 1, vt = Me[st], Ge = m();
      for (let tt = 0; tt < rt; tt++) {
        const {
          cell: _t,
          startRow: yt
        } = vt[tt];
        yt + _t.__rowSpan - 1 <= st ? Ge.append(T(p.NO_STATUS).append(e.$createParagraphNode())) : _t.setRowSpan(_t.__rowSpan + 1);
      }
      const ze = Le.getChildAtIndex(st);
      if (!e.DEPRECATED_$isGridRowNode(ze))
        throw Error("focusEndRow is not a GridRowNode");
      ze.insertAfter(Ge);
    } else {
      const st = Me[it], vt = m();
      for (let ze = 0; ze < rt; ze++) {
        const {
          cell: tt,
          startRow: _t
        } = st[ze];
        _t === it ? vt.append(T(p.NO_STATUS).append(e.$createParagraphNode())) : tt.setRowSpan(tt.__rowSpan + 1);
      }
      const Ge = Le.getChildAtIndex(it);
      if (!e.DEPRECATED_$isGridRowNode(Ge))
        throw Error("focusEndRow is not a GridRowNode");
      Ge.insertBefore(vt);
    }
  }
  function Re(Oe, ie, le = !0, ve, Le) {
    const Me = Oe.getChildren(), je = [];
    for (let rt = 0; rt < Me.length; rt++) {
      const it = Me[rt];
      if (v(it))
        for (let st = 0; st < ve; st++) {
          const vt = it.getChildren();
          if (ie >= vt.length || ie < 0)
            throw new Error("Table column target index out of range");
          const Ge = vt[ie];
          if (!S(Ge))
            throw Error("Expected table cell");
          const {
            left: ze,
            right: tt
          } = ne(Ge, Le);
          let _t = p.NO_STATUS;
          (ze && ze.hasHeaderState(p.ROW) || tt && tt.hasHeaderState(p.ROW)) && (_t |= p.ROW);
          const yt = T(_t);
          yt.append(e.$createParagraphNode()), je.push({
            newTableCell: yt,
            targetCell: Ge
          });
        }
    }
    return je.forEach(({
      newTableCell: rt,
      targetCell: it
    }) => {
      le ? it.insertAfter(rt) : it.insertBefore(rt);
    }), Oe;
  }
  function ke(Oe = !0) {
    const ie = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(ie))
      throw Error("Expected a PointSeleciton");
    const le = ie.anchor.getNode(), ve = ie.focus.getNode(), [Le] = e.DEPRECATED_$getNodeTriplet(le), [Me, , je] = e.DEPRECATED_$getNodeTriplet(ve), [rt, it, st] = e.DEPRECATED_$computeGridMap(je, Me, Le), vt = rt.length, Ge = Oe ? Math.max(it.startColumn, st.startColumn) : Math.min(it.startColumn, st.startColumn), ze = Oe ? Ge + Me.__colSpan - 1 : Ge - 1, tt = je.getFirstChild();
    if (!e.DEPRECATED_$isGridRowNode(tt))
      throw Error("Expected firstTable child to be a row");
    let _t = null;
    function yt() {
      const ht = T(p.NO_STATUS).append(e.$createParagraphNode());
      return _t === null && (_t = ht), ht;
    }
    let Ct = tt;
    e: for (let ht = 0; ht < vt; ht++) {
      if (ht !== 0) {
        const tn = Ct.getNextSibling();
        if (!e.DEPRECATED_$isGridRowNode(tn))
          throw Error("Expected row nextSibling to be a row");
        Ct = tn;
      }
      const Tt = rt[ht];
      if (ze < 0) {
        Dt(Ct, yt());
        continue;
      }
      const {
        cell: pt,
        startColumn: Pt,
        startRow: Wt
      } = Tt[ze];
      if (Pt + pt.__colSpan - 1 <= ze) {
        let tn = pt, Lt = Wt, jt = ze;
        for (; Lt !== ht && tn.__rowSpan > 1; )
          if (jt -= pt.__colSpan, jt >= 0) {
            const {
              cell: Rt,
              startRow: nn
            } = Tt[jt];
            tn = Rt, Lt = nn;
          } else {
            Ct.append(yt());
            continue e;
          }
        tn.insertAfter(yt());
      } else
        pt.setColSpan(pt.__colSpan + 1);
    }
    _t !== null && ct(_t);
  }
  function Fe(Oe, ie) {
    const le = Oe.getChildren();
    for (let ve = 0; ve < le.length; ve++) {
      const Le = le[ve];
      if (v(Le)) {
        const Me = Le.getChildren();
        if (ie >= Me.length || ie < 0)
          throw new Error("Table column target index out of range");
        Me[ie].remove();
      }
    }
    return Oe;
  }
  function qe() {
    const Oe = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(Oe))
      throw Error("Expected a INTERNAL_PointSelection");
    const ie = Oe.anchor.getNode(), le = Oe.focus.getNode(), [ve, , Le] = e.DEPRECATED_$getNodeTriplet(ie), [Me] = e.DEPRECATED_$getNodeTriplet(le), [je, rt, it] = e.DEPRECATED_$computeGridMap(Le, ve, Me), {
      startRow: st
    } = rt, {
      startRow: vt
    } = it, Ge = vt + Me.__rowSpan - 1;
    if (je.length === Ge - st + 1) {
      Le.remove();
      return;
    }
    const ze = je[0].length, tt = je[Ge + 1], _t = Le.getChildAtIndex(Ge + 1);
    for (let yt = Ge; yt >= st; yt--) {
      for (let ht = ze - 1; ht >= 0; ht--) {
        const {
          cell: Tt,
          startRow: pt,
          startColumn: Pt
        } = je[yt][ht];
        if (Pt === ht && (yt === st && pt < st && Tt.setRowSpan(Tt.__rowSpan - (pt - st)), pt >= st && pt + Tt.__rowSpan - 1 > Ge)) {
          if (Tt.setRowSpan(Tt.__rowSpan - (Ge - pt + 1)), _t === null)
            throw Error("Expected nextRowNode not to be null");
          if (ht === 0)
            Dt(_t, Tt);
          else {
            const {
              cell: Wt
            } = tt[ht - 1];
            Wt.insertAfter(Tt);
          }
        }
      }
      const Ct = Le.getChildAtIndex(yt);
      if (!e.DEPRECATED_$isGridRowNode(Ct))
        throw Error(`Expected GridNode childAtIndex(${String(yt)}) to be RowNode`);
      Ct.remove();
    }
    if (tt !== void 0) {
      const {
        cell: yt
      } = tt[0];
      ct(yt);
    } else {
      const yt = je[st - 1], {
        cell: Ct
      } = yt[0];
      ct(Ct);
    }
  }
  function Be() {
    const Oe = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(Oe))
      throw Error("Expected a INTERNAL_PointSelection");
    const ie = Oe.anchor.getNode(), le = Oe.focus.getNode(), [ve, , Le] = e.DEPRECATED_$getNodeTriplet(ie), [Me] = e.DEPRECATED_$getNodeTriplet(le), [je, rt, it] = e.DEPRECATED_$computeGridMap(Le, ve, Me), {
      startColumn: st
    } = rt, {
      startRow: vt,
      startColumn: Ge
    } = it, ze = Math.min(st, Ge), tt = Math.max(st + ve.__colSpan - 1, Ge + Me.__colSpan - 1), _t = tt - ze + 1;
    if (je[0].length === tt - ze + 1) {
      Le.selectPrevious(), Le.remove();
      return;
    }
    const Ct = je.length;
    for (let pt = 0; pt < Ct; pt++)
      for (let Pt = ze; Pt <= tt; Pt++) {
        const {
          cell: Wt,
          startColumn: tn
        } = je[pt][Pt];
        if (tn < ze) {
          if (Pt === ze) {
            const Lt = ze - tn;
            Wt.setColSpan(Wt.__colSpan - // Possible overflow right too
            Math.min(_t, Wt.__colSpan - Lt));
          }
        } else if (tn + Wt.__colSpan - 1 > tt) {
          if (Pt === tt) {
            const Lt = tt - tn + 1;
            Wt.setColSpan(Wt.__colSpan - Lt);
          }
        } else
          Wt.remove();
      }
    const ht = je[vt], Tt = ht[Ge + Me.__colSpan];
    if (Tt !== void 0) {
      const {
        cell: pt
      } = Tt;
      ct(pt);
    } else {
      const pt = ht[Ge - 1], {
        cell: Pt
      } = pt;
      ct(Pt);
    }
  }
  function ct(Oe) {
    const ie = Oe.getFirstDescendant();
    ie == null ? Oe.selectStart() : ie.getParentOrThrow().selectStart();
  }
  function Dt(Oe, ie) {
    const le = Oe.getFirstChild();
    le !== null ? le.insertBefore(ie) : Oe.append(ie);
  }
  function zt() {
    const Oe = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(Oe))
      throw Error("Expected a INTERNAL_PointSelection");
    const ie = Oe.anchor.getNode(), [le, ve, Le] = e.DEPRECATED_$getNodeTriplet(ie), Me = le.__colSpan, je = le.__rowSpan;
    if (Me > 1) {
      for (let rt = 1; rt < Me; rt++)
        le.insertAfter(T(p.NO_STATUS));
      le.setColSpan(1);
    }
    if (je > 1) {
      const [rt, it] = e.DEPRECATED_$computeGridMap(Le, le, le), {
        startColumn: st,
        startRow: vt
      } = it;
      let Ge;
      for (let ze = 1; ze < je; ze++) {
        const tt = vt + ze, _t = rt[tt];
        if (Ge = (Ge || ve).getNextSibling(), !e.DEPRECATED_$isGridRowNode(Ge))
          throw Error("Expected row next sibling to be a row");
        let yt = null;
        for (let Ct = 0; Ct < st; Ct++) {
          const ht = _t[Ct], Tt = ht.cell;
          ht.startRow === tt && (yt = Tt), Tt.__colSpan > 1 && (Ct += Tt.__colSpan - 1);
        }
        if (yt === null)
          for (let Ct = 0; Ct < Me; Ct++)
            Dt(Ge, T(p.NO_STATUS));
        else
          for (let Ct = 0; Ct < Me; Ct++)
            yt.insertAfter(T(p.NO_STATUS));
      }
      le.setRowSpan(1);
    }
  }
  const en = e.createCommand("INSERT_TABLE_COMMAND");
  return Zt.$createGridSelection = l, Zt.$createTableCellNode = T, Zt.$createTableNode = _e, Zt.$createTableNodeWithDimensions = M, Zt.$createTableRowNode = m, Zt.$deleteTableColumn = Fe, Zt.$deleteTableColumn__EXPERIMENTAL = Be, Zt.$deleteTableRow__EXPERIMENTAL = qe, Zt.$getElementGridForTableNode = X, Zt.$getTableCellNodeFromLexicalNode = F, Zt.$getTableColumnIndexFromTableCellNode = ee, Zt.$getTableNodeFromLexicalNodeOrThrow = ye, Zt.$getTableRowIndexFromTableCellNode = De, Zt.$getTableRowNodeFromTableCellNodeOrThrow = se, Zt.$insertTableColumn = Re, Zt.$insertTableColumn__EXPERIMENTAL = ke, Zt.$insertTableRow = be, Zt.$insertTableRow__EXPERIMENTAL = Ne, Zt.$isGridSelection = r, Zt.$isTableCellNode = S, Zt.$isTableNode = B, Zt.$isTableRowNode = v, Zt.$removeTableRowAtIndex = ue, Zt.$unmergeCell = zt, Zt.INSERT_TABLE_COMMAND = en, Zt.TableCellHeaderStates = p, Zt.TableCellNode = _, Zt.TableNode = U, Zt.TableRowNode = w, Zt.TableSelection = k, Zt.applyTableHandlers = H, Zt.getCellFromTarget = te, Zt.getTableSelectionFromTableElement = re, Zt;
}
var Jt = {}, Th;
function wC() {
  if (Th) return Jt;
  Th = 1;
  var e = Yt(), t = gn();
  function n(B) {
    let M = new URLSearchParams();
    M.append("code", B);
    for (let F = 1; F < arguments.length; F++) M.append("v", arguments[F]);
    throw Error(`Minified Lexical error #${B}; visit https://lexical.dev/docs/error?${M} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  class r extends e.INTERNAL_PointSelection {
    constructor(M, F, se) {
      super(F, se), this.gridKey = M;
    }
    getCachedNodes() {
      return this._cachedNodes;
    }
    setCachedNodes(M) {
      this._cachedNodes = M;
    }
    is(M) {
      return l(M) ? this.gridKey === M.gridKey && this.anchor.is(M.anchor) && this.focus.is(M.focus) : !1;
    }
    set(M, F, se) {
      this.dirty = !0, this.gridKey = M, this.anchor.key = F, this.focus.key = se, this._cachedNodes = null;
    }
    clone() {
      return new r(this.gridKey, this.anchor, this.focus);
    }
    isCollapsed() {
      return !1;
    }
    extract() {
      return this.getNodes();
    }
    insertRawText() {
    }
    insertText() {
    }
    insertNodes(M) {
      let F = this.focus.getNode();
      if (!e.$isElementNode(F)) throw Error("Expected GridSelection focus to be an ElementNode");
      e.$normalizeSelection__EXPERIMENTAL(F.select(0, F.getChildrenSize())).insertNodes(M);
    }
    getShape() {
      var M = e.$getNodeByKey(this.anchor.key);
      if (e.DEPRECATED_$isGridCellNode(M) || n(103), M = e.DEPRECATED_$getGridCellNodeRect(M), M === null) throw Error("getCellRect: expected to find AnchorNode");
      var F = e.$getNodeByKey(this.focus.key);
      e.DEPRECATED_$isGridCellNode(F) || n(104);
      let se = e.DEPRECATED_$getGridCellNodeRect(F);
      if (se === null) throw Error("getCellRect: expected to find focusCellNode");
      F = Math.min(M.columnIndex, se.columnIndex);
      let ye = Math.max(M.columnIndex, se.columnIndex), De = Math.min(M.rowIndex, se.rowIndex);
      return M = Math.max(M.rowIndex, se.rowIndex), { fromX: Math.min(F, ye), fromY: Math.min(De, M), toX: Math.max(F, ye), toY: Math.max(De, M) };
    }
    getNodes() {
      function M(ct) {
        let { cell: Dt, startColumn: zt, startRow: en } = ct;
        be = Math.min(be, zt), Ne = Math.min(Ne, en), Re = Math.max(Re, zt + Dt.__colSpan - 1), ke = Math.max(ke, en + Dt.__rowSpan - 1);
      }
      var F = this._cachedNodes;
      if (F !== null) return F;
      var se = this.anchor.getNode();
      F = this.focus.getNode();
      var ye = t.$findMatchingParent(se, e.DEPRECATED_$isGridCellNode);
      se = t.$findMatchingParent(F, e.DEPRECATED_$isGridCellNode), e.DEPRECATED_$isGridCellNode(ye) || n(103), e.DEPRECATED_$isGridCellNode(se) || n(104), F = ye.getParent(), e.DEPRECATED_$isGridRowNode(F) || n(105), F = F.getParent(), e.DEPRECATED_$isGridNode(F) || n(106);
      var De = se.getParents()[1];
      if (De !== F) {
        if (F.isParentOf(se)) {
          if (F = De.getParent(), F == null) throw Error("Expected focusCellParent to have a parent");
          this.set(
            this.gridKey,
            se.getKey(),
            F.getKey()
          );
        } else {
          if (F = F.getParent(), F == null) throw Error("Expected gridParent to have a parent");
          this.set(this.gridKey, F.getKey(), se.getKey());
        }
        return this.getNodes();
      }
      let [ee, ne, ue] = e.DEPRECATED_$computeGridMap(F, ye, se), be = Math.min(ne.startColumn, ue.startColumn), Ne = Math.min(ne.startRow, ue.startRow), Re = Math.max(ne.startColumn + ne.cell.__colSpan - 1, ue.startColumn + ue.cell.__colSpan - 1), ke = Math.max(ne.startRow + ne.cell.__rowSpan - 1, ue.startRow + ue.cell.__rowSpan - 1);
      se = be, ye = Ne, De = be;
      for (var Fe = Ne; be < se || Ne < ye || Re > De || ke > Fe; ) {
        if (be < se) {
          var qe = Fe - ye;
          --se;
          for (var Be = 0; Be <= qe; Be++) M(ee[ye + Be][se]);
        }
        if (Ne < ye) for (qe = De - se, --ye, Be = 0; Be <= qe; Be++) M(ee[ye][se + Be]);
        if (Re > De) for (qe = Fe - ye, De += 1, Be = 0; Be <= qe; Be++) M(ee[ye + Be][De]);
        if (ke > Fe) for (qe = De - se, Fe += 1, Be = 0; Be <= qe; Be++) M(ee[Fe][se + Be]);
      }
      for (F = [F], se = null, ye = Ne; ye <= ke; ye++) for (De = be; De <= Re; De++) ({ cell: Fe } = ee[ye][De]), qe = Fe.getParent(), e.DEPRECATED_$isGridRowNode(qe) || n(107), qe !== se && F.push(qe), F.push(Fe, ...f(Fe)), se = qe;
      return e.isCurrentlyReadOnlyMode() || (this._cachedNodes = F), F;
    }
    getTextContent() {
      let M = this.getNodes(), F = "";
      for (let se = 0; se < M.length; se++) F += M[se].getTextContent();
      return F;
    }
  }
  function l(B) {
    return B instanceof r;
  }
  function d() {
    let B = e.$createPoint("root", 0, "element"), M = e.$createPoint("root", 0, "element");
    return new r("root", B, M);
  }
  function f(B) {
    let M = [], F = [B];
    for (; 0 < F.length; ) {
      let se = F.pop();
      se === void 0 && n(112), e.$isElementNode(se) && F.unshift(...se.getChildren()), se !== B && M.push(se);
    }
    return M;
  }
  let p = /^(\d+(?:\.\d+)?)px$/, _ = { BOTH: 3, COLUMN: 2, NO_STATUS: 0, ROW: 1 };
  class E extends e.DEPRECATED_GridCellNode {
    static getType() {
      return "tablecell";
    }
    static clone(M) {
      let F = new E(M.__headerState, M.__colSpan, M.__width, M.__key);
      return F.__rowSpan = M.__rowSpan, F.__backgroundColor = M.__backgroundColor, F;
    }
    static importDOM() {
      return { td: () => ({ conversion: T, priority: 0 }), th: () => ({ conversion: T, priority: 0 }) };
    }
    static importJSON(M) {
      let F = M.rowSpan || 1, se = S(M.headerState, M.colSpan || 1, M.width || void 0);
      return se.__rowSpan = F, se.__backgroundColor = M.backgroundColor || null, se;
    }
    constructor(M = _.NO_STATUS, F = 1, se, ye) {
      super(F, ye), this.__headerState = M, this.__width = se, this.__backgroundColor = null;
    }
    createDOM(M) {
      let F = document.createElement(this.getTag());
      return this.__width && (F.style.width = `${this.__width}px`), 1 < this.__colSpan && (F.colSpan = this.__colSpan), 1 < this.__rowSpan && (F.rowSpan = this.__rowSpan), this.__backgroundColor !== null && (F.style.backgroundColor = this.__backgroundColor), t.addClassNamesToElement(F, M.theme.tableCell, this.hasHeader() && M.theme.tableCellHeader), F;
    }
    exportDOM(M) {
      if ({ element: M } = super.exportDOM(M), M) {
        var F = this.getParentOrThrow().getChildrenSize();
        M.style.border = "1px solid black", 1 < this.__colSpan && (M.colSpan = this.__colSpan), 1 < this.__rowSpan && (M.rowSpan = this.__rowSpan), M.style.width = `${this.getWidth() || Math.max(90, 700 / F)}px`, M.style.verticalAlign = "top", M.style.textAlign = "start", F = this.getBackgroundColor(), F !== null ? M.style.backgroundColor = F : this.hasHeader() && (M.style.backgroundColor = "#f2f3f5");
      }
      return { element: M };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        backgroundColor: this.getBackgroundColor(),
        headerState: this.__headerState,
        type: "tablecell",
        width: this.getWidth()
      };
    }
    getTag() {
      return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(M) {
      return this.getWritable().__headerState = M, this.__headerState;
    }
    getHeaderStyles() {
      return this.getLatest().__headerState;
    }
    setWidth(M) {
      return this.getWritable().__width = M, this.__width;
    }
    getWidth() {
      return this.getLatest().__width;
    }
    getBackgroundColor() {
      return this.getLatest().__backgroundColor;
    }
    setBackgroundColor(M) {
      this.getWritable().__backgroundColor = M;
    }
    toggleHeaderStyle(M) {
      let F = this.getWritable();
      return F.__headerState = (F.__headerState & M) === M ? F.__headerState - M : F.__headerState + M, F;
    }
    hasHeaderState(M) {
      return (this.getHeaderStyles() & M) === M;
    }
    hasHeader() {
      return this.getLatest().__headerState !== _.NO_STATUS;
    }
    updateDOM(M) {
      return M.__headerState !== this.__headerState || M.__width !== this.__width || M.__colSpan !== this.__colSpan || M.__rowSpan !== this.__rowSpan || M.__backgroundColor !== this.__backgroundColor;
    }
    isShadowRoot() {
      return !0;
    }
    collapseAtStart() {
      return !0;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function T(B) {
    var M = B.nodeName.toLowerCase();
    let F;
    return p.test(B.style.width) && (F = parseFloat(B.style.width)), M = S(M === "th" ? _.ROW : _.NO_STATUS, B.colSpan, F), M.__rowSpan = B.rowSpan, B = B.style.backgroundColor, B !== "" && (M.__backgroundColor = B), { forChild: (se, ye) => w(ye) && !e.$isElementNode(se) ? (ye = e.$createParagraphNode(), e.$isLineBreakNode(se) && se.getTextContent() === `
` ? null : (ye.append(se), ye)) : se, node: M };
  }
  function S(B, M = 1, F) {
    return e.$applyNodeReplacement(new E(B, M, F));
  }
  function w(B) {
    return B instanceof E;
  }
  class O extends e.DEPRECATED_GridRowNode {
    static getType() {
      return "tablerow";
    }
    static clone(M) {
      return new O(M.__height, M.__key);
    }
    static importDOM() {
      return { tr: () => ({ conversion: m, priority: 0 }) };
    }
    static importJSON(M) {
      return v(M.height);
    }
    constructor(M, F) {
      super(F), this.__height = M;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "tablerow", version: 1 };
    }
    createDOM(M) {
      let F = document.createElement("tr");
      return this.__height && (F.style.height = `${this.__height}px`), t.addClassNamesToElement(F, M.theme.tableRow), F;
    }
    isShadowRoot() {
      return !0;
    }
    setHeight(M) {
      return this.getWritable().__height = M, this.__height;
    }
    getHeight() {
      return this.getLatest().__height;
    }
    updateDOM(M) {
      return M.__height !== this.__height;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function m(B) {
    let M;
    return p.test(B.style.height) && (M = parseFloat(B.style.height)), { node: v(M) };
  }
  function v(B) {
    return e.$applyNodeReplacement(new O(B));
  }
  function I(B) {
    return B instanceof O;
  }
  let G = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  class k {
    constructor(M, F) {
      this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = F, this.editor = M, this.grid = { cells: [], columns: 0, rows: 0 }, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
    }
    getGrid() {
      return this.grid;
    }
    removeListeners() {
      Array.from(this.listenersToRemove).forEach((M) => M());
    }
    trackTableGrid() {
      let M = new MutationObserver((F) => {
        this.editor.update(() => {
          var se = !1;
          for (let ye = 0; ye < F.length; ye++) {
            const De = F[ye].target.nodeName;
            if (De === "TABLE" || De === "TR") {
              se = !0;
              break;
            }
          }
          if (se) {
            if (se = this.editor.getElementByKey(this.tableNodeKey), !se) throw Error("Expected to find TableElement in DOM");
            this.grid = H(se);
          }
        });
      });
      this.editor.update(() => {
        let F = this.editor.getElementByKey(this.tableNodeKey);
        if (!F) throw Error("Expected to find TableElement in DOM");
        this.grid = H(F), M.observe(F, { childList: !0, subtree: !0 });
      });
    }
    clearHighlight() {
      let M = this.editor;
      this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), M.update(() => {
        var F = e.$getNodeByKey(this.tableNodeKey);
        if (!W(F)) throw Error("Expected TableNode.");
        if (F = M.getElementByKey(this.tableNodeKey), !F) throw Error("Expected to find TableElement in DOM");
        F = H(F), j(M, F, null), e.$setSelection(null), M.dispatchCommand(
          e.SELECTION_CHANGE_COMMAND,
          void 0
        );
      });
    }
    enableHighlightStyle() {
      let M = this.editor;
      M.update(() => {
        let F = M.getElementByKey(this.tableNodeKey);
        if (!F) throw Error("Expected to find TableElement in DOM");
        t.removeClassNamesFromElement(F, M._config.theme.tableSelection), F.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
      });
    }
    disableHighlightStyle() {
      let M = this.editor;
      M.update(() => {
        let F = M.getElementByKey(this.tableNodeKey);
        if (!F) throw Error("Expected to find TableElement in DOM");
        t.addClassNamesToElement(F, M._config.theme.tableSelection), this.hasHijackedSelectionStyles = !0;
      });
    }
    updateTableGridSelection(M) {
      if (M != null && M.gridKey === this.tableNodeKey) {
        let F = this.editor;
        this.gridSelection = M, this.isHighlightingCells = !0, this.disableHighlightStyle(), j(F, this.grid, this.gridSelection);
      } else M == null ? this.clearHighlight() : (this.tableNodeKey = M.gridKey, this.updateTableGridSelection(M));
    }
    setFocusCellForSelection(M, F = !1) {
      let se = this.editor;
      se.update(() => {
        var ye = e.$getNodeByKey(this.tableNodeKey);
        if (!W(ye)) throw Error("Expected TableNode.");
        if (!se.getElementByKey(this.tableNodeKey)) throw Error("Expected to find TableElement in DOM");
        ye = M.x;
        let De = M.y;
        if (this.focusCell = M, this.anchorCell !== null) {
          let ee = G ? (se._window || window).getSelection() : null;
          ee && ee.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
        }
        if (!this.isHighlightingCells && (this.anchorX !== ye || this.anchorY !== De || F)) this.isHighlightingCells = !0, this.disableHighlightStyle();
        else if (ye === this.focusX && De === this.focusY) return;
        this.focusX = ye, this.focusY = De, this.isHighlightingCells && (ye = e.$getNearestNodeFromDOMNode(M.elem), this.gridSelection != null && this.anchorCellNodeKey != null && w(ye) && (ye = ye.getKey(), this.gridSelection = this.gridSelection.clone() || d(), this.focusCellNodeKey = ye, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), e.$setSelection(this.gridSelection), se.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0), j(se, this.grid, this.gridSelection)));
      });
    }
    setAnchorCellForSelection(M) {
      this.isHighlightingCells = !1, this.anchorCell = M, this.anchorX = M.x, this.anchorY = M.y, this.editor.update(() => {
        var F = e.$getNearestNodeFromDOMNode(M.elem);
        w(F) && (F = F.getKey(), this.gridSelection = this.gridSelection != null ? this.gridSelection.clone() : d(), this.anchorCellNodeKey = F);
      });
    }
    formatCells(M) {
      this.editor.update(() => {
        let F = e.$getSelection();
        l(F) || n(11);
        let se = e.$createRangeSelection(), ye = se.anchor, De = se.focus;
        F.getNodes().forEach((ee) => {
          w(ee) && ee.getTextContentSize() !== 0 && (ye.set(ee.getKey(), 0, "element"), De.set(ee.getKey(), ee.getChildrenSize(), "element"), se.formatText(M));
        }), e.$setSelection(F), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    clearText() {
      let M = this.editor;
      M.update(() => {
        let F = e.$getNodeByKey(this.tableNodeKey);
        if (!W(F)) throw Error("Expected TableNode.");
        var se = e.$getSelection();
        l(se) || n(11), se = se.getNodes().filter(w), se.length === this.grid.columns * this.grid.rows ? (F.selectPrevious(), F.remove(), e.$getRoot().selectStart()) : (se.forEach((ye) => {
          if (e.$isElementNode(ye)) {
            let De = e.$createParagraphNode(), ee = e.$createTextNode();
            De.append(ee), ye.append(De), ye.getChildren().forEach((ne) => {
              ne !== De && ne.remove();
            });
          }
        }), j(M, this.grid, null), e.$setSelection(null), M.dispatchCommand(
          e.SELECTION_CHANGE_COMMAND,
          void 0
        ));
      });
    }
  }
  function P(B) {
    for (; B != null; ) {
      let M = B.nodeName;
      if (M === "TD" || M === "TH") {
        if (B = B._cell, B === void 0) break;
        return B;
      }
      B = B.parentNode;
    }
    return null;
  }
  function H(B) {
    let M = [], F = { cells: M, columns: 0, rows: 0 };
    var se = B.firstChild;
    let ye = B = 0;
    for (M.length = 0; se != null; ) {
      var De = se.nodeName;
      if (De === "TD" || De === "TH") {
        De = se, De = { elem: De, hasBackgroundColor: De.style.backgroundColor !== "", highlighted: !1, x: B, y: ye }, se._cell = De;
        let ee = M[ye];
        ee === void 0 && (ee = M[ye] = []), ee[B] = De;
      } else if (De = se.firstChild, De != null) {
        se = De;
        continue;
      }
      if (De = se.nextSibling, De != null) B++, se = De;
      else if (De = se.parentNode, De != null) {
        if (se = De.nextSibling, se == null) break;
        ye++, B = 0;
      }
    }
    return F.columns = B + 1, F.rows = ye + 1, F;
  }
  function j(B, M, F) {
    let se = new Set(F ? F.getNodes() : []);
    re(M, (ye, De) => {
      let ee = ye.elem;
      se.has(De) ? (ye.highlighted = !0, Te(B, ye)) : (ye.highlighted = !1, Se(B, ye), ee.getAttribute("style") || ee.removeAttribute("style"));
    });
  }
  function re(B, M) {
    ({ cells: B } = B);
    for (let F = 0; F < B.length; F++) {
      let se = B[F];
      if (se) for (let ye = 0; ye < se.length; ye++) {
        let De = se[ye];
        if (!De) continue;
        let ee = e.$getNearestNodeFromDOMNode(De.elem);
        ee !== null && M(De, ee, { x: ye, y: F });
      }
    }
  }
  function te(B, M) {
    M.disableHighlightStyle(), re(M.grid, (F) => {
      F.highlighted = !0, Te(B, F);
    });
  }
  function ce(B, M) {
    M.enableHighlightStyle(), re(M.grid, (F) => {
      let se = F.elem;
      F.highlighted = !1, Se(B, F), se.getAttribute("style") || se.removeAttribute("style");
    });
  }
  let V = (B, M, F, se, ye) => {
    const De = ye === "forward";
    switch (ye) {
      case "backward":
      case "forward":
        return F !== (De ? B.grid.columns - 1 : 0) ? (B = M.getCellNodeFromCordsOrThrow(F + (De ? 1 : -1), se, B.grid), De ? B.selectStart() : B.selectEnd()) : se !== (De ? B.grid.rows - 1 : 0) ? (B = M.getCellNodeFromCordsOrThrow(De ? 0 : B.grid.columns - 1, se + (De ? 1 : -1), B.grid), De ? B.selectStart() : B.selectEnd()) : De ? M.selectNext() : M.selectPrevious(), !0;
      case "up":
        return se !== 0 ? M.getCellNodeFromCordsOrThrow(F, se - 1, B.grid).selectEnd() : M.selectPrevious(), !0;
      case "down":
        return se !== B.grid.rows - 1 ? M.getCellNodeFromCordsOrThrow(F, se + 1, B.grid).selectStart() : M.selectNext(), !0;
      default:
        return !1;
    }
  }, z = (B, M, F, se, ye) => {
    const De = ye === "forward";
    switch (ye) {
      case "backward":
      case "forward":
        return F !== (De ? B.grid.columns - 1 : 0) && B.setFocusCellForSelection(M.getCellFromCordsOrThrow(F + (De ? 1 : -1), se, B.grid)), !0;
      case "up":
        return se !== 0 ? (B.setFocusCellForSelection(M.getCellFromCordsOrThrow(F, se - 1, B.grid)), !0) : !1;
      case "down":
        return se !== B.grid.rows - 1 ? (B.setFocusCellForSelection(M.getCellFromCordsOrThrow(F, se + 1, B.grid)), !0) : !1;
      default:
        return !1;
    }
  };
  function q(B, M) {
    if (e.$isRangeSelection(B) || l(B)) {
      let F = M.isParentOf(B.anchor.getNode());
      return B = M.isParentOf(B.focus.getNode()), F && B;
    }
    return !1;
  }
  function Te(B, M) {
    B = M.elem, M = e.$getNearestNodeFromDOMNode(B), w(M) || n(131), M.getBackgroundColor() === null ? B.style.setProperty("background-color", "rgb(172,206,247)") : B.style.setProperty("background-image", "linear-gradient(to right, rgba(172,206,247,0.85), rgba(172,206,247,0.85))"), B.style.setProperty("caret-color", "transparent");
  }
  function Se(B, M) {
    B = M.elem, M = e.$getNearestNodeFromDOMNode(B), w(M) || n(131), M.getBackgroundColor() === null && B.style.removeProperty("background-color"), B.style.removeProperty("background-image"), B.style.removeProperty("caret-color");
  }
  function Ee(B) {
    return B = t.$findMatchingParent(B, w), w(B) ? B : null;
  }
  function de(B) {
    return B = t.$findMatchingParent(B, W), W(B) ? B : null;
  }
  function K(B, M, F, se, ye) {
    let De = e.$getSelection();
    if (!q(De, se)) return !1;
    if (e.$isRangeSelection(De) && De.isCollapsed()) {
      if (F === "backward" || F === "forward") return !1;
      let { anchor: be, focus: Ne } = De;
      var ee = t.$findMatchingParent(be.getNode(), w), ne = t.$findMatchingParent(Ne.getNode(), w);
      if (!w(ee) || !ee.is(ne)) return !1;
      if (ne = de(ee), ne !== se && ne != null) {
        var ue = B.getElementByKey(ne.getKey());
        if (ue != null) return ye.grid = H(ue), K(B, M, F, ne, ye);
      }
      if (ne = B.getElementByKey(ee.__key), ue = B.getElementByKey(be.key), ue == null || ne == null) return !1;
      if (be.type === "element") ne = ue.getBoundingClientRect();
      else {
        if (ne = window.getSelection(), ne === null || ne.rangeCount === 0) return !1;
        ne = ne.getRangeAt(0).getBoundingClientRect();
      }
      if (ue = F === "up" ? ee.getFirstChild() : ee.getLastChild(), ue == null || (B = B.getElementByKey(ue.__key), B == null)) return !1;
      if (B = B.getBoundingClientRect(), F === "up" ? B.top > ne.top - ne.height : ne.bottom + ne.height > B.bottom) {
        if (D(M), B = se.getCordsFromCellNode(ee, ye.grid), M.shiftKey) F = se.getCellFromCordsOrThrow(B.x, B.y, ye.grid), ye.setAnchorCellForSelection(F), ye.setFocusCellForSelection(F, !0);
        else return V(ye, se, B.x, B.y, F);
        return !0;
      }
    } else if (l(De)) {
      let { anchor: be, focus: Ne } = De;
      return ue = t.$findMatchingParent(be.getNode(), w), ne = t.$findMatchingParent(Ne.getNode(), w), [ee] = De.getNodes(), B = B.getElementByKey(ee.getKey()), !w(ue) || !w(ne) || !W(ee) || B == null ? !1 : (ye.updateTableGridSelection(De), B = H(B), ue = se.getCordsFromCellNode(ue, B), ue = se.getCellFromCordsOrThrow(ue.x, ue.y, B), ye.setAnchorCellForSelection(ue), D(M), M.shiftKey ? (M = se.getCordsFromCellNode(ne, B), z(ye, ee, M.x, M.y, F)) : (ne.selectEnd(), !0));
    }
    return !1;
  }
  function D(B) {
    B.preventDefault(), B.stopImmediatePropagation(), B.stopPropagation();
  }
  class Z extends e.DEPRECATED_GridNode {
    static getType() {
      return "table";
    }
    static clone(M) {
      return new Z(M.__key);
    }
    static importDOM() {
      return { table: () => ({ conversion: oe, priority: 1 }) };
    }
    static importJSON() {
      return Y();
    }
    constructor(M) {
      super(M);
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "table", version: 1 };
    }
    createDOM(M) {
      let F = document.createElement("table");
      return t.addClassNamesToElement(F, M.theme.table), F;
    }
    updateDOM() {
      return !1;
    }
    exportDOM(M) {
      return { ...super.exportDOM(M), after: (F) => {
        if (F) {
          let se = F.cloneNode(), ye = document.createElement("colgroup"), De = document.createElement("tbody");
          if (t.isHTMLElement(F) && De.append(...F.children), F = this.getFirstChildOrThrow(), !I(F)) throw Error("Expected to find row node.");
          F = F.getChildrenSize();
          for (let ee = 0; ee < F; ee++) {
            let ne = document.createElement("col");
            ye.append(ne);
          }
          return se.replaceChildren(ye, De), se;
        }
      } };
    }
    canExtractContents() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isShadowRoot() {
      return !0;
    }
    getCordsFromCellNode(M, F) {
      let { rows: se, cells: ye } = F;
      for (F = 0; F < se; F++) {
        var De = ye[F];
        if (De != null && (De = De.findIndex((ee) => {
          if (ee) return { elem: ee } = ee, e.$getNearestNodeFromDOMNode(ee) === M;
        }), De !== -1)) return { x: De, y: F };
      }
      throw Error("Cell not found in table.");
    }
    getCellFromCords(M, F, se) {
      return { cells: se } = se, F = se[F], F == null ? null : (M = F[M], M ?? null);
    }
    getCellFromCordsOrThrow(M, F, se) {
      if (M = this.getCellFromCords(M, F, se), !M) throw Error("Cell not found at cords.");
      return M;
    }
    getCellNodeFromCords(M, F, se) {
      return M = this.getCellFromCords(M, F, se), M == null ? null : (M = e.$getNearestNodeFromDOMNode(M.elem), w(M) ? M : null);
    }
    getCellNodeFromCordsOrThrow(M, F, se) {
      if (M = this.getCellNodeFromCords(M, F, se), !M) throw Error("Node at cords not TableCellNode.");
      return M;
    }
    canSelectBefore() {
      return !0;
    }
    canIndent() {
      return !1;
    }
  }
  function oe() {
    return { node: Y() };
  }
  function Y() {
    return e.$applyNodeReplacement(new Z());
  }
  function W(B) {
    return B instanceof Z;
  }
  function J(B) {
    if (B = t.$findMatchingParent(B, (M) => I(M)), I(B)) return B;
    throw Error("Expected table cell to be inside of table row.");
  }
  function R(B) {
    if (B = t.$findMatchingParent(B, (M) => W(M)), W(B)) return B;
    throw Error("Expected table cell to be inside of table.");
  }
  function U(B, M) {
    let F = R(B), { x: se, y: ye } = F.getCordsFromCellNode(B, M);
    return { above: F.getCellNodeFromCords(se, ye - 1, M), below: F.getCellNodeFromCords(se, ye + 1, M), left: F.getCellNodeFromCords(se - 1, ye, M), right: F.getCellNodeFromCords(se + 1, ye, M) };
  }
  function X(B) {
    let M = B.getFirstDescendant();
    M == null ? B.selectStart() : M.getParentOrThrow().selectStart();
  }
  function fe(B, M) {
    let F = B.getFirstChild();
    F !== null ? F.insertBefore(M) : B.append(M);
  }
  let _e = e.createCommand("INSERT_TABLE_COMMAND");
  return Jt.$createGridSelection = d, Jt.$createTableCellNode = S, Jt.$createTableNode = Y, Jt.$createTableNodeWithDimensions = function(B, M, F = !0) {
    let se = Y();
    for (let De = 0; De < B; De++) {
      let ee = v();
      for (let ne = 0; ne < M; ne++) {
        var ye = _.NO_STATUS;
        typeof F == "object" ? (De === 0 && F.rows && (ye |= _.ROW), ne === 0 && F.columns && (ye |= _.COLUMN)) : F && (De === 0 && (ye |= _.ROW), ne === 0 && (ye |= _.COLUMN)), ye = S(ye);
        let ue = e.$createParagraphNode();
        ue.append(e.$createTextNode()), ye.append(ue), ee.append(ye);
      }
      se.append(ee);
    }
    return se;
  }, Jt.$createTableRowNode = v, Jt.$deleteTableColumn = function(B, M) {
    let F = B.getChildren();
    for (let ye = 0; ye < F.length; ye++) {
      var se = F[ye];
      if (I(se)) {
        if (se = se.getChildren(), M >= se.length || 0 > M) throw Error("Table column target index out of range");
        se[M].remove();
      }
    }
    return B;
  }, Jt.$deleteTableColumn__EXPERIMENTAL = function() {
    var B = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(B)) throw Error("Expected a INTERNAL_PointSelection");
    var M = B.anchor.getNode();
    B = B.focus.getNode();
    let [F, , se] = e.DEPRECATED_$getNodeTriplet(M);
    [M] = e.DEPRECATED_$getNodeTriplet(B);
    let [ye, De, ee] = e.DEPRECATED_$computeGridMap(se, F, M);
    var { startColumn: ne } = De;
    let { startRow: ue, startColumn: be } = ee;
    B = Math.min(ne, be), ne = Math.max(ne + F.__colSpan - 1, be + M.__colSpan - 1);
    let Ne = ne - B + 1;
    if (ye[0].length === ne - B + 1) se.selectPrevious(), se.remove();
    else {
      var Re = ye.length;
      for (let ke = 0; ke < Re; ke++) for (let Fe = B; Fe <= ne; Fe++) {
        let { cell: qe, startColumn: Be } = ye[ke][Fe];
        Be < B ? Fe === B && qe.setColSpan(qe.__colSpan - Math.min(Ne, qe.__colSpan - (B - Be))) : Be + qe.__colSpan - 1 > ne ? Fe === ne && qe.setColSpan(qe.__colSpan - (ne - Be + 1)) : qe.remove();
      }
      B = ye[ue], M = B[be + M.__colSpan], M !== void 0 ? ({ cell: M } = M, X(M)) : ({ cell: M } = B[be - 1], X(M));
    }
  }, Jt.$deleteTableRow__EXPERIMENTAL = function() {
    var B = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(B)) throw Error("Expected a INTERNAL_PointSelection");
    var M = B.anchor.getNode();
    B = B.focus.getNode();
    let [F, , se] = e.DEPRECATED_$getNodeTriplet(M);
    [B] = e.DEPRECATED_$getNodeTriplet(B);
    let [ye, De, ee] = e.DEPRECATED_$computeGridMap(se, F, B);
    ({ startRow: M } = De);
    var { startRow: ne } = ee;
    if (B = ne + B.__rowSpan - 1, ye.length === B - M + 1) se.remove();
    else {
      ne = ye[0].length;
      var ue = ye[B + 1], be = se.getChildAtIndex(B + 1);
      for (let Re = B; Re >= M; Re--) {
        for (var Ne = ne - 1; 0 <= Ne; Ne--) {
          let { cell: ke, startRow: Fe, startColumn: qe } = ye[Re][Ne];
          if (qe === Ne && (Re === M && Fe < M && ke.setRowSpan(ke.__rowSpan - (Fe - M)), Fe >= M && Fe + ke.__rowSpan - 1 > B)) if (ke.setRowSpan(ke.__rowSpan - (B - Fe + 1)), be === null && n(122), Ne === 0) fe(be, ke);
          else {
            let { cell: Be } = ue[Ne - 1];
            Be.insertAfter(ke);
          }
        }
        Ne = se.getChildAtIndex(Re), e.DEPRECATED_$isGridRowNode(Ne) || n(123, String(Re)), Ne.remove();
      }
      ue !== void 0 ? ({ cell: M } = ue[0], X(M)) : ({ cell: M } = ye[M - 1][0], X(M));
    }
  }, Jt.$getElementGridForTableNode = function(B, M) {
    if (B = B.getElementByKey(M.getKey()), B == null) throw Error("Table Element Not Found");
    return H(B);
  }, Jt.$getTableCellNodeFromLexicalNode = function(B) {
    return B = t.$findMatchingParent(B, (M) => w(M)), w(B) ? B : null;
  }, Jt.$getTableColumnIndexFromTableCellNode = function(B) {
    return J(B).getChildren().findIndex((M) => M.is(B));
  }, Jt.$getTableNodeFromLexicalNodeOrThrow = R, Jt.$getTableRowIndexFromTableCellNode = function(B) {
    let M = J(B);
    return R(M).getChildren().findIndex((F) => F.is(M));
  }, Jt.$getTableRowNodeFromTableCellNodeOrThrow = J, Jt.$insertTableColumn = function(B, M, F = !0, se, ye) {
    let De = B.getChildren(), ee = [];
    for (let be = 0; be < De.length; be++) {
      let Ne = De[be];
      if (I(Ne)) for (let Re = 0; Re < se; Re++) {
        var ne = Ne.getChildren();
        if (M >= ne.length || 0 > M) throw Error("Table column target index out of range");
        ne = ne[M], w(ne) || n(12);
        let { left: ke, right: Fe } = U(ne, ye);
        var ue = _.NO_STATUS;
        (ke && ke.hasHeaderState(_.ROW) || Fe && Fe.hasHeaderState(_.ROW)) && (ue |= _.ROW), ue = S(ue), ue.append(e.$createParagraphNode()), ee.push({ newTableCell: ue, targetCell: ne });
      }
    }
    return ee.forEach(({ newTableCell: be, targetCell: Ne }) => {
      F ? Ne.insertAfter(be) : Ne.insertBefore(be);
    }), B;
  }, Jt.$insertTableColumn__EXPERIMENTAL = function(B = !0) {
    function M() {
      let Re = S(_.NO_STATUS).append(e.$createParagraphNode());
      return be === null && (be = Re), Re;
    }
    var F = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(F)) throw Error("Expected a PointSeleciton");
    var se = F.anchor.getNode();
    F = F.focus.getNode(), [se] = e.DEPRECATED_$getNodeTriplet(se);
    let [ye, , De] = e.DEPRECATED_$getNodeTriplet(F), [ee, ne, ue] = e.DEPRECATED_$computeGridMap(De, ye, se);
    se = ee.length, F = B ? Math.max(ne.startColumn, ue.startColumn) : Math.min(ne.startColumn, ue.startColumn), B = B ? F + ye.__colSpan - 1 : F - 1, F = De.getFirstChild(), e.DEPRECATED_$isGridRowNode(F) || n(120);
    let be = null;
    var Ne = F;
    e: for (F = 0; F < se; F++) {
      F !== 0 && (Ne = Ne.getNextSibling(), e.DEPRECATED_$isGridRowNode(Ne) || n(121));
      let Re = ee[F];
      if (0 > B) {
        fe(Ne, M());
        continue;
      }
      let { cell: ke, startColumn: Fe, startRow: qe } = Re[B];
      if (Fe + ke.__colSpan - 1 <= B) {
        let Be = ke, ct = qe, Dt = B;
        for (; ct !== F && 1 < Be.__rowSpan; ) if (Dt -= ke.__colSpan, 0 <= Dt) {
          let { cell: zt, startRow: en } = Re[Dt];
          Be = zt, ct = en;
        } else {
          Ne.append(M());
          continue e;
        }
        Be.insertAfter(M());
      } else ke.setColSpan(ke.__colSpan + 1);
    }
    be !== null && X(be);
  }, Jt.$insertTableRow = function(B, M, F = !0, se, ye) {
    var De = B.getChildren();
    if (M >= De.length || 0 > M) throw Error("Table row target index out of range");
    if (M = De[M], I(M)) for (De = 0; De < se; De++) {
      let ne = M.getChildren(), ue = ne.length, be = v();
      for (let Ne = 0; Ne < ue; Ne++) {
        var ee = ne[Ne];
        w(ee) || n(12);
        let { above: Re, below: ke } = U(ee, ye);
        ee = _.NO_STATUS;
        let Fe = Re && Re.getWidth() || ke && ke.getWidth() || void 0;
        (Re && Re.hasHeaderState(_.COLUMN) || ke && ke.hasHeaderState(_.COLUMN)) && (ee |= _.COLUMN), ee = S(ee, 1, Fe), ee.append(e.$createParagraphNode()), be.append(ee);
      }
      F ? M.insertAfter(be) : M.insertBefore(be);
    }
    else throw Error("Row before insertion index does not exist.");
    return B;
  }, Jt.$insertTableRow__EXPERIMENTAL = function(B = !0) {
    var M = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(M)) throw Error("Expected a INTERNAL_PointSelection");
    M = M.focus.getNode();
    let [F, , se] = e.DEPRECATED_$getNodeTriplet(M), [ye, De] = e.DEPRECATED_$computeGridMap(se, F, F);
    M = ye[0].length;
    var { startRow: ee } = De;
    if (B) {
      B = ee + F.__rowSpan - 1;
      var ne = ye[B];
      ee = v();
      for (var ue = 0; ue < M; ue++) {
        let { cell: be, startRow: Ne } = ne[ue];
        Ne + be.__rowSpan - 1 <= B ? ee.append(S(_.NO_STATUS).append(e.$createParagraphNode())) : be.setRowSpan(be.__rowSpan + 1);
      }
      M = se.getChildAtIndex(B), e.DEPRECATED_$isGridRowNode(M) || n(119), M.insertAfter(ee);
    } else {
      for (ne = ye[ee], B = v(), ue = 0; ue < M; ue++) {
        let { cell: be, startRow: Ne } = ne[ue];
        Ne === ee ? B.append(S(_.NO_STATUS).append(e.$createParagraphNode())) : be.setRowSpan(be.__rowSpan + 1);
      }
      M = se.getChildAtIndex(ee), e.DEPRECATED_$isGridRowNode(M) || n(119), M.insertBefore(B);
    }
  }, Jt.$isGridSelection = l, Jt.$isTableCellNode = w, Jt.$isTableNode = W, Jt.$isTableRowNode = I, Jt.$removeTableRowAtIndex = function(B, M) {
    let F = B.getChildren();
    if (M >= F.length || 0 > M) throw Error("Expected table cell to be inside of table row.");
    return F[M].remove(), B;
  }, Jt.$unmergeCell = function() {
    var B = e.$getSelection();
    if (!e.$INTERNAL_isPointSelection(B)) throw Error("Expected a INTERNAL_PointSelection");
    B = B.anchor.getNode();
    let [M, F, se] = e.DEPRECATED_$getNodeTriplet(B);
    B = M.__colSpan;
    let ye = M.__rowSpan;
    if (1 < B) {
      for (var De = 1; De < B; De++) M.insertAfter(S(_.NO_STATUS));
      M.setColSpan(1);
    }
    if (1 < ye) {
      let [ue, be] = e.DEPRECATED_$computeGridMap(se, M, M), { startColumn: Ne, startRow: Re } = be, ke;
      for (De = 1; De < ye; De++) {
        var ee = Re + De;
        let Fe = ue[ee];
        ke = (ke || F).getNextSibling(), e.DEPRECATED_$isGridRowNode(ke) || n(125);
        var ne = null;
        for (let qe = 0; qe < Ne; qe++) {
          let Be = Fe[qe], ct = Be.cell;
          Be.startRow === ee && (ne = ct), 1 < ct.__colSpan && (qe += ct.__colSpan - 1);
        }
        if (ne === null) for (ne = 0; ne < B; ne++) fe(ke, S(_.NO_STATUS));
        else for (ee = 0; ee < B; ee++) ne.insertAfter(S(_.NO_STATUS));
      }
      M.setRowSpan(1);
    }
  }, Jt.INSERT_TABLE_COMMAND = _e, Jt.TableCellHeaderStates = _, Jt.TableCellNode = E, Jt.TableNode = Z, Jt.TableRowNode = O, Jt.TableSelection = k, Jt.applyTableHandlers = function(B, M, F, se) {
    function ye(Ne) {
      return Ne = B.getCordsFromCellNode(Ne, ee.grid), B.getCellFromCordsOrThrow(Ne.x, Ne.y, ee.grid);
    }
    let De = F.getRootElement();
    if (De === null) throw Error("No root element.");
    let ee = new k(F, B.getKey()), ne = F._window || window;
    M.__lexicalTableSelection = ee, M.addEventListener("mousedown", (Ne) => {
      setTimeout(() => {
        if (Ne.button === 0 && ne) {
          var Re = P(Ne.target);
          Re !== null && (D(Ne), ee.setAnchorCellForSelection(Re));
          var ke = () => {
            ne.removeEventListener("mouseup", ke), ne.removeEventListener(
              "mousemove",
              Fe
            );
          }, Fe = (qe) => {
            const Be = P(qe.target);
            Be === null || ee.anchorX === Be.x && ee.anchorY === Be.y || (qe.preventDefault(), ee.setFocusCellForSelection(Be));
          };
          ne.addEventListener("mouseup", ke), ne.addEventListener("mousemove", Fe);
        }
      }, 0);
    });
    let ue = (Ne) => {
      Ne.button === 0 && F.update(() => {
        const Re = e.$getSelection(), ke = Ne.target;
        l(Re) && Re.gridKey === ee.tableNodeKey && De.contains(ke) && ee.clearHighlight();
      });
    };
    ne.addEventListener("mousedown", ue), ee.listenersToRemove.add(() => ne.removeEventListener("mousedown", ue)), ee.listenersToRemove.add(F.registerCommand(
      e.KEY_ARROW_DOWN_COMMAND,
      (Ne) => K(F, Ne, "down", B, ee),
      e.COMMAND_PRIORITY_HIGH
    )), ee.listenersToRemove.add(F.registerCommand(e.KEY_ARROW_UP_COMMAND, (Ne) => K(F, Ne, "up", B, ee), e.COMMAND_PRIORITY_HIGH)), ee.listenersToRemove.add(F.registerCommand(e.KEY_ARROW_LEFT_COMMAND, (Ne) => K(F, Ne, "backward", B, ee), e.COMMAND_PRIORITY_HIGH)), ee.listenersToRemove.add(F.registerCommand(e.KEY_ARROW_RIGHT_COMMAND, (Ne) => K(F, Ne, "forward", B, ee), e.COMMAND_PRIORITY_HIGH)), ee.listenersToRemove.add(F.registerCommand(e.KEY_ESCAPE_COMMAND, (Ne) => {
      var Re = e.$getSelection();
      return l(Re) && (Re = t.$findMatchingParent(
        Re.focus.getNode(),
        w
      ), w(Re)) ? (D(Ne), Re.selectEnd(), !0) : !1;
    }, e.COMMAND_PRIORITY_HIGH));
    let be = (Ne) => () => {
      var Re = e.$getSelection();
      if (!q(Re, B)) return !1;
      if (l(Re)) return ee.clearText(), !0;
      if (e.$isRangeSelection(Re)) {
        const qe = t.$findMatchingParent(Re.anchor.getNode(), (Be) => w(Be));
        if (!w(qe)) return !1;
        var ke = Re.anchor.getNode(), Fe = Re.focus.getNode();
        if (ke = B.isParentOf(ke), Fe = B.isParentOf(Fe), ke && !Fe || Fe && !ke) return ee.clearText(), !0;
        if (ke = (Fe = t.$findMatchingParent(Re.anchor.getNode(), (Be) => e.$isElementNode(Be))) && t.$findMatchingParent(Fe, (Be) => e.$isElementNode(Be) && w(Be.getParent())), !e.$isElementNode(ke) || !e.$isElementNode(Fe)) return !1;
        if (Ne === e.DELETE_LINE_COMMAND && ke.getPreviousSibling() === null) return !0;
        if ((Ne === e.DELETE_CHARACTER_COMMAND || Ne === e.DELETE_WORD_COMMAND) && Re.isCollapsed() && Re.anchor.offset === 0 && Fe !== ke) {
          Re = Fe.getChildren();
          const Be = e.$createParagraphNode();
          return Re.forEach((ct) => Be.append(ct)), Fe.replace(Be), Fe.getWritable().__parent = qe.getKey(), !0;
        }
      }
      return !1;
    };
    return [e.DELETE_WORD_COMMAND, e.DELETE_LINE_COMMAND, e.DELETE_CHARACTER_COMMAND].forEach((Ne) => {
      ee.listenersToRemove.add(F.registerCommand(
        Ne,
        be(Ne),
        e.COMMAND_PRIORITY_CRITICAL
      ));
    }), M = (Ne) => {
      const Re = e.$getSelection();
      return q(Re, B) ? l(Re) ? (Ne.preventDefault(), Ne.stopPropagation(), ee.clearText(), !0) : (e.$isRangeSelection(Re) && (Ne = t.$findMatchingParent(Re.anchor.getNode(), (ke) => w(ke)), w(Ne)), !1) : !1;
    }, ee.listenersToRemove.add(F.registerCommand(e.KEY_BACKSPACE_COMMAND, M, e.COMMAND_PRIORITY_CRITICAL)), ee.listenersToRemove.add(F.registerCommand(e.KEY_DELETE_COMMAND, M, e.COMMAND_PRIORITY_CRITICAL)), ee.listenersToRemove.add(F.registerCommand(
      e.FORMAT_TEXT_COMMAND,
      (Ne) => {
        let Re = e.$getSelection();
        return q(Re, B) ? l(Re) ? (ee.formatCells(Ne), !0) : (e.$isRangeSelection(Re) && (Ne = t.$findMatchingParent(Re.anchor.getNode(), (ke) => w(ke)), w(Ne)), !1) : !1;
      },
      e.COMMAND_PRIORITY_CRITICAL
    )), ee.listenersToRemove.add(F.registerCommand(e.CONTROLLED_TEXT_INSERTION_COMMAND, () => {
      var Ne = e.$getSelection();
      return q(Ne, B) && (l(Ne) ? ee.clearHighlight() : e.$isRangeSelection(Ne) && (Ne = t.$findMatchingParent(Ne.anchor.getNode(), (Re) => w(Re)), w(Ne))), !1;
    }, e.COMMAND_PRIORITY_CRITICAL)), se && ee.listenersToRemove.add(F.registerCommand(
      e.KEY_TAB_COMMAND,
      (Ne) => {
        var Re = e.$getSelection();
        return !e.$isRangeSelection(Re) || !Re.isCollapsed() || !q(Re, B) || (Re = Ee(Re.anchor.getNode()), Re === null) ? !1 : (D(Ne), Re = B.getCordsFromCellNode(Re, ee.grid), V(ee, B, Re.x, Re.y, Ne.shiftKey ? "backward" : "forward"), !0);
      },
      e.COMMAND_PRIORITY_CRITICAL
    )), ee.listenersToRemove.add(F.registerCommand(e.FOCUS_COMMAND, () => B.isSelected(), e.COMMAND_PRIORITY_HIGH)), ee.listenersToRemove.add(F.registerCommand(e.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, (Ne) => {
      let { nodes: Re, selection: ke } = Ne;
      Ne = e.$INTERNAL_isPointSelection(ke);
      var Fe = e.$isRangeSelection(ke);
      if (Ne = Fe && t.$findMatchingParent(ke.anchor.getNode(), (Le) => e.DEPRECATED_$isGridCellNode(Le)) !== null && t.$findMatchingParent(ke.focus.getNode(), (Le) => e.DEPRECATED_$isGridCellNode(Le)) !== null || Ne && !Fe, Re.length !== 1 || !e.DEPRECATED_$isGridNode(Re[0]) || !Ne) return !1;
      var { anchor: qe } = ke, Be = Re[0];
      Ne = Be.getChildren(), Fe = Be.getFirstChildOrThrow().getChildrenSize(), Be = Be.getChildrenSize();
      var ct = t.$findMatchingParent(qe.getNode(), (Le) => e.DEPRECATED_$isGridCellNode(Le)), Dt = (qe = ct && t.$findMatchingParent(ct, (Le) => e.DEPRECATED_$isGridRowNode(Le))) && t.$findMatchingParent(qe, (Le) => e.DEPRECATED_$isGridNode(Le));
      if (!e.DEPRECATED_$isGridCellNode(ct) || !e.DEPRECATED_$isGridRowNode(qe) || !e.DEPRECATED_$isGridNode(Dt)) return !1;
      var zt = qe.getIndexWithinParent(), en = Math.min(Dt.getChildrenSize() - 1, zt + Be - 1);
      Be = ct.getIndexWithinParent(), ct = Math.min(qe.getChildrenSize() - 1, Be + Fe - 1), Fe = Math.min(Be, ct), qe = Math.min(zt, en), Be = Math.max(Be, ct), zt = Math.max(zt, en), Dt = Dt.getChildren(), en = 0;
      let Oe, ie;
      for (ct = qe; ct <= zt; ct++) {
        var le = Dt[ct];
        if (!e.DEPRECATED_$isGridRowNode(le)) return !1;
        var ve = Ne[en];
        if (!e.DEPRECATED_$isGridRowNode(ve)) return !1;
        le = le.getChildren(), ve = ve.getChildren();
        let Le = 0;
        for (let Me = Fe; Me <= Be; Me++) {
          let je = le[Me];
          if (!e.DEPRECATED_$isGridCellNode(je)) return !1;
          let rt = ve[Le];
          if (!e.DEPRECATED_$isGridCellNode(rt)) return !1;
          ct === qe && Me === Fe ? Oe = je.getKey() : ct === zt && Me === Be && (ie = je.getKey());
          let it = je.getChildren();
          rt.getChildren().forEach((st) => {
            e.$isTextNode(st) && e.$createParagraphNode().append(st), je.append(st);
          }), it.forEach((st) => st.remove()), Le++;
        }
        en++;
      }
      return Oe && ie && (Ne = d(), Ne.set(Re[0].getKey(), Oe, ie), e.$setSelection(Ne)), !0;
    }, e.COMMAND_PRIORITY_CRITICAL)), ee.listenersToRemove.add(F.registerCommand(
      e.SELECTION_CHANGE_COMMAND,
      () => {
        let Ne = e.$getSelection(), Re = e.$getPreviousSelection();
        if (e.$isRangeSelection(Ne)) {
          let { anchor: ct, focus: Dt } = Ne;
          var ke = ct.getNode(), Fe = Dt.getNode();
          ke = Ee(ke), Fe = Ee(Fe);
          var qe = ke && B.is(de(ke)), Be = Fe && B.is(de(Fe));
          let zt = qe !== Be;
          Be = qe && Be, qe = Ne.isBackward(), zt ? (ke = Ne.clone(), ke.focus.set(B.getKey(), qe ? 0 : B.getChildrenSize(), "element"), e.$setSelection(ke), te(F, ee)) : Be && !ke.is(Fe) && (ee.setAnchorCellForSelection(ye(ke)), ee.setFocusCellForSelection(ye(Fe), !0));
        }
        return Ne && !Ne.is(Re) && (l(Ne) || l(Re)) && ee.gridSelection && !ee.gridSelection.is(Re) ? (l(Ne) && Ne.gridKey === ee.tableNodeKey ? ee.updateTableGridSelection(Ne) : !l(Ne) && l(Re) && Re.gridKey === ee.tableNodeKey && ee.updateTableGridSelection(null), !1) : (ee.hasHijackedSelectionStyles && !B.isSelected() ? ce(F, ee) : !ee.hasHijackedSelectionStyles && B.isSelected() && te(F, ee), !1);
      },
      e.COMMAND_PRIORITY_CRITICAL
    )), ee;
  }, Jt.getCellFromTarget = P, Jt.getTableSelectionFromTableElement = function(B) {
    return B.__lexicalTableSelection;
  }, Jt;
}
var Ou, xh;
function Nd() {
  return xh || (xh = 1, Ou = process.env.NODE_ENV === "development" ? SC() : wC()), Ou;
}
var vh;
function OC() {
  if (vh) return wu;
  vh = 1;
  var e = qn(), t = Nd(), n = gn(), r = Yt(), l = xn;
  function d({
    hasCellMerge: f = !0,
    hasCellBackgroundColor: p = !0,
    hasTabHandler: _ = !0
  }) {
    const [E] = e.useLexicalComposerContext();
    return l.useEffect(() => {
      if (!E.hasNodes([t.TableNode, t.TableCellNode, t.TableRowNode]))
        throw Error("TablePlugin: TableNode, TableCellNode or TableRowNode not registered on editor");
      return E.registerCommand(t.INSERT_TABLE_COMMAND, ({
        columns: T,
        rows: S,
        includeHeaders: w
      }) => {
        const O = t.$createTableNodeWithDimensions(Number(S), Number(T), w);
        n.$insertNodeToNearestRoot(O);
        const m = O.getFirstDescendant();
        return r.$isTextNode(m) && m.select(), !0;
      }, r.COMMAND_PRIORITY_EDITOR);
    }, [E]), l.useEffect(() => {
      const T = /* @__PURE__ */ new Map(), S = (O) => {
        const m = O.getKey(), v = E.getElementByKey(m);
        if (v && !T.has(m)) {
          const I = t.applyTableHandlers(O, v, E, _);
          T.set(m, I);
        }
      };
      E.getEditorState().read(() => {
        const O = r.$nodesOfType(t.TableNode);
        for (const m of O)
          t.$isTableNode(m) && S(m);
      });
      const w = E.registerMutationListener(t.TableNode, (O) => {
        for (const [m, v] of O)
          if (v === "created")
            E.getEditorState().read(() => {
              const I = r.$getNodeByKey(m);
              t.$isTableNode(I) && S(I);
            });
          else if (v === "destroyed") {
            const I = T.get(m);
            I !== void 0 && (I.removeListeners(), T.delete(m));
          }
      });
      return () => {
        w();
        for (const [, O] of T)
          O.removeListeners();
      };
    }, [E, _]), l.useEffect(() => {
      if (!f)
        return E.registerNodeTransform(t.TableCellNode, (T) => {
          if (T.getColSpan() > 1 || T.getRowSpan() > 1) {
            const [, , S] = r.DEPRECATED_$getNodeTriplet(T), [w] = r.DEPRECATED_$computeGridMap(S, T, T), O = w.length, m = w[0].length;
            let v = S.getFirstChild();
            if (!r.DEPRECATED_$isGridRowNode(v))
              throw Error("Expected TableNode first child to be a RowNode");
            const I = [];
            for (let G = 0; G < O; G++) {
              if (G !== 0 && (v = v.getNextSibling(), !r.DEPRECATED_$isGridRowNode(v)))
                throw Error("Expected TableNode first child to be a RowNode");
              let k = null;
              for (let P = 0; P < m; P++) {
                const H = w[G][P], j = H.cell;
                if (H.startRow === G && H.startColumn === P)
                  k = j, I.push(j);
                else if (j.getColSpan() > 1 || j.getRowSpan() > 1) {
                  if (!t.$isTableCellNode(j))
                    throw Error("Expected TableNode cell to be a TableCellNode");
                  const re = t.$createTableCellNode(j.__headerState);
                  k !== null ? k.insertAfter(re) : n.$insertFirst(v, re);
                }
              }
            }
            for (const G of I)
              G.setColSpan(1), G.setRowSpan(1);
          }
        });
    }, [E, f]), l.useEffect(() => {
      if (!p)
        return E.registerNodeTransform(t.TableCellNode, (T) => {
          T.getBackgroundColor() !== null && T.setBackgroundColor(null);
        });
    }, [E, p, f]), null;
  }
  return wu.TablePlugin = d, wu;
}
var Du = {}, Sh;
function DC() {
  if (Sh) return Du;
  Sh = 1;
  var e = qn(), t = Nd(), n = gn(), r = Yt(), l = xn;
  function d(f) {
    let p = new URLSearchParams();
    p.append("code", f);
    for (let _ = 1; _ < arguments.length; _++) p.append("v", arguments[_]);
    throw Error(`Minified Lexical error #${f}; visit https://lexical.dev/docs/error?${p} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  return Du.TablePlugin = function({ hasCellMerge: f = !0, hasCellBackgroundColor: p = !0, hasTabHandler: _ = !0 }) {
    let [E] = e.useLexicalComposerContext();
    return l.useEffect(() => (E.hasNodes([t.TableNode, t.TableCellNode, t.TableRowNode]) || d(10), E.registerCommand(t.INSERT_TABLE_COMMAND, ({ columns: T, rows: S, includeHeaders: w }) => (T = t.$createTableNodeWithDimensions(Number(S), Number(T), w), n.$insertNodeToNearestRoot(T), T = T.getFirstDescendant(), r.$isTextNode(T) && T.select(), !0), r.COMMAND_PRIORITY_EDITOR)), [E]), l.useEffect(
      () => {
        let T = /* @__PURE__ */ new Map(), S = (O) => {
          const m = O.getKey(), v = E.getElementByKey(m);
          v && !T.has(m) && (O = t.applyTableHandlers(O, v, E, _), T.set(m, O));
        };
        E.getEditorState().read(() => {
          let O = r.$nodesOfType(t.TableNode);
          for (let m of O) t.$isTableNode(m) && S(m);
        });
        let w = E.registerMutationListener(t.TableNode, (O) => {
          for (const [m, v] of O) v === "created" ? E.getEditorState().read(() => {
            const I = r.$getNodeByKey(m);
            t.$isTableNode(I) && S(I);
          }) : v === "destroyed" && (O = T.get(m), O !== void 0 && (O.removeListeners(), T.delete(m)));
        });
        return () => {
          w();
          for (let [, O] of T) O.removeListeners();
        };
      },
      [E, _]
    ), l.useEffect(() => {
      if (!f) return E.registerNodeTransform(t.TableCellNode, (T) => {
        if (1 < T.getColSpan() || 1 < T.getRowSpan()) {
          var [, , S] = r.DEPRECATED_$getNodeTriplet(T);
          [T] = r.DEPRECATED_$computeGridMap(S, T, T);
          let O = T.length, m = T[0].length;
          if (S = S.getFirstChild(), !r.DEPRECATED_$isGridRowNode(S)) throw Error("Expected TableNode first child to be a RowNode");
          let v = [];
          for (let I = 0; I < O; I++) {
            if (I !== 0 && (S = S.getNextSibling(), !r.DEPRECATED_$isGridRowNode(S))) throw Error("Expected TableNode first child to be a RowNode");
            let G = null;
            for (let k = 0; k < m; k++) {
              var w = T[I][k];
              let P = w.cell;
              if (w.startRow === I && w.startColumn === k) G = P, v.push(P);
              else if (1 < P.getColSpan() || 1 < P.getRowSpan()) {
                if (!t.$isTableCellNode(P)) throw Error("Expected TableNode cell to be a TableCellNode");
                w = t.$createTableCellNode(P.__headerState), G !== null ? G.insertAfter(w) : n.$insertFirst(S, w);
              }
            }
          }
          for (let I of v) I.setColSpan(1), I.setRowSpan(1);
        }
      });
    }, [E, f]), l.useEffect(
      () => {
        if (!p) return E.registerNodeTransform(t.TableCellNode, (T) => {
          T.getBackgroundColor() !== null && T.setBackgroundColor(null);
        });
      },
      [E, p, f]
    ), null;
  }, Du;
}
const AC = process.env.NODE_ENV === "development" ? OC() : DC();
var MC = AC, Pn = {}, Au = { exports: {} }, wh;
function Sp() {
  return wh || (wh = 1, function(e) {
    var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
    /**
     * Prism: Lightweight, robust, elegant syntax highlighting
     *
     * @license MIT <https://opensource.org/licenses/MIT>
     * @author Lea Verou <https://lea.verou.me>
     * @namespace
     * @public
     */
    var n = function(r) {
      var l = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, d = 0, f = {}, p = {
        /**
         * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
         * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
         * additional languages or plugins yourself.
         *
         * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
         *
         * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.manual = true;
         * // add a new <script> to load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        manual: r.Prism && r.Prism.manual,
        /**
         * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
         * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
         * own worker, you don't want it to do this.
         *
         * By setting this value to `true`, Prism will not add its own listeners to the worker.
         *
         * You obviously have to change this value before Prism executes. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.disableWorkerMessageHandler = true;
         * // Load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        disableWorkerMessageHandler: r.Prism && r.Prism.disableWorkerMessageHandler,
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function k(P) {
            return P instanceof _ ? new _(P.type, k(P.content), P.alias) : Array.isArray(P) ? P.map(k) : P.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(k) {
            return Object.prototype.toString.call(k).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(k) {
            return k.__id || Object.defineProperty(k, "__id", { value: ++d }), k.__id;
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function k(P, H) {
            H = H || {};
            var j, re;
            switch (p.util.type(P)) {
              case "Object":
                if (re = p.util.objId(P), H[re])
                  return H[re];
                j = /** @type {Record<string, any>} */
                {}, H[re] = j;
                for (var te in P)
                  P.hasOwnProperty(te) && (j[te] = k(P[te], H));
                return (
                  /** @type {any} */
                  j
                );
              case "Array":
                return re = p.util.objId(P), H[re] ? H[re] : (j = [], H[re] = j, /** @type {Array} */
                /** @type {any} */
                P.forEach(function(ce, V) {
                  j[V] = k(ce, H);
                }), /** @type {any} */
                j);
              default:
                return P;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(k) {
            for (; k; ) {
              var P = l.exec(k.className);
              if (P)
                return P[1].toLowerCase();
              k = k.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(k, P) {
            k.className = k.className.replace(RegExp(l, "gi"), ""), k.classList.add("language-" + P);
          },
          /**
           * Returns the script element that is currently executing.
           *
           * This does __not__ work for line script element.
           *
           * @returns {HTMLScriptElement | null}
           */
          currentScript: function() {
            if (typeof document > "u")
              return null;
            if ("currentScript" in document)
              return (
                /** @type {any} */
                document.currentScript
              );
            try {
              throw new Error();
            } catch (j) {
              var k = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(j.stack) || [])[1];
              if (k) {
                var P = document.getElementsByTagName("script");
                for (var H in P)
                  if (P[H].src == k)
                    return P[H];
              }
              return null;
            }
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(k, P, H) {
            for (var j = "no-" + P; k; ) {
              var re = k.classList;
              if (re.contains(P))
                return !0;
              if (re.contains(j))
                return !1;
              k = k.parentElement;
            }
            return !!H;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: f,
          plaintext: f,
          text: f,
          txt: f,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(k, P) {
            var H = p.util.clone(p.languages[k]);
            for (var j in P)
              H[j] = P[j];
            return H;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(k, P, H, j) {
            j = j || /** @type {any} */
            p.languages;
            var re = j[k], te = {};
            for (var ce in re)
              if (re.hasOwnProperty(ce)) {
                if (ce == P)
                  for (var V in H)
                    H.hasOwnProperty(V) && (te[V] = H[V]);
                H.hasOwnProperty(ce) || (te[ce] = re[ce]);
              }
            var z = j[k];
            return j[k] = te, p.languages.DFS(p.languages, function(q, Te) {
              Te === z && q != k && (this[q] = te);
            }), te;
          },
          // Traverse a language definition with Depth First Search
          DFS: function k(P, H, j, re) {
            re = re || {};
            var te = p.util.objId;
            for (var ce in P)
              if (P.hasOwnProperty(ce)) {
                H.call(P, ce, P[ce], j || ce);
                var V = P[ce], z = p.util.type(V);
                z === "Object" && !re[te(V)] ? (re[te(V)] = !0, k(V, H, null, re)) : z === "Array" && !re[te(V)] && (re[te(V)] = !0, k(V, H, ce, re));
              }
          }
        },
        plugins: {},
        /**
         * This is the most high-level function in Prism’s API.
         * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
         * each one of them.
         *
         * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
         *
         * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
         * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
         * @memberof Prism
         * @public
         */
        highlightAll: function(k, P) {
          p.highlightAllUnder(document, k, P);
        },
        /**
         * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
         * {@link Prism.highlightElement} on each one of them.
         *
         * The following hooks will be run:
         * 1. `before-highlightall`
         * 2. `before-all-elements-highlight`
         * 3. All hooks of {@link Prism.highlightElement} for each element.
         *
         * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
         * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
         * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
         * @memberof Prism
         * @public
         */
        highlightAllUnder: function(k, P, H) {
          var j = {
            callback: H,
            container: k,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          p.hooks.run("before-highlightall", j), j.elements = Array.prototype.slice.apply(j.container.querySelectorAll(j.selector)), p.hooks.run("before-all-elements-highlight", j);
          for (var re = 0, te; te = j.elements[re++]; )
            p.highlightElement(te, P === !0, j.callback);
        },
        /**
         * Highlights the code inside a single element.
         *
         * The following hooks will be run:
         * 1. `before-sanity-check`
         * 2. `before-highlight`
         * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
         * 4. `before-insert`
         * 5. `after-highlight`
         * 6. `complete`
         *
         * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
         * the element's language.
         *
         * @param {Element} element The element containing the code.
         * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
         * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
         * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
         * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
         *
         * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
         * asynchronous highlighting to work. You can build your own bundle on the
         * [Download page](https://prismjs.com/download.html).
         * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
         * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
         * @memberof Prism
         * @public
         */
        highlightElement: function(k, P, H) {
          var j = p.util.getLanguage(k), re = p.languages[j];
          p.util.setLanguage(k, j);
          var te = k.parentElement;
          te && te.nodeName.toLowerCase() === "pre" && p.util.setLanguage(te, j);
          var ce = k.textContent, V = {
            element: k,
            language: j,
            grammar: re,
            code: ce
          };
          function z(Te) {
            V.highlightedCode = Te, p.hooks.run("before-insert", V), V.element.innerHTML = V.highlightedCode, p.hooks.run("after-highlight", V), p.hooks.run("complete", V), H && H.call(V.element);
          }
          if (p.hooks.run("before-sanity-check", V), te = V.element.parentElement, te && te.nodeName.toLowerCase() === "pre" && !te.hasAttribute("tabindex") && te.setAttribute("tabindex", "0"), !V.code) {
            p.hooks.run("complete", V), H && H.call(V.element);
            return;
          }
          if (p.hooks.run("before-highlight", V), !V.grammar) {
            z(p.util.encode(V.code));
            return;
          }
          if (P && r.Worker) {
            var q = new Worker(p.filename);
            q.onmessage = function(Te) {
              z(Te.data);
            }, q.postMessage(JSON.stringify({
              language: V.language,
              code: V.code,
              immediateClose: !0
            }));
          } else
            z(p.highlight(V.code, V.grammar, V.language));
        },
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(k, P, H) {
          var j = {
            code: k,
            grammar: P,
            language: H
          };
          if (p.hooks.run("before-tokenize", j), !j.grammar)
            throw new Error('The language "' + j.language + '" has no grammar.');
          return j.tokens = p.tokenize(j.code, j.grammar), p.hooks.run("after-tokenize", j), _.stringify(p.util.encode(j.tokens), j.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(k, P) {
          var H = P.rest;
          if (H) {
            for (var j in H)
              P[j] = H[j];
            delete P.rest;
          }
          var re = new S();
          return w(re, re.head, k), T(k, re, P, re.head, 0), m(re);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(k, P) {
            var H = p.hooks.all;
            H[k] = H[k] || [], H[k].push(P);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(k, P) {
            var H = p.hooks.all[k];
            if (!(!H || !H.length))
              for (var j = 0, re; re = H[j++]; )
                re(P);
          }
        },
        Token: _
      };
      r.Prism = p;
      function _(k, P, H, j) {
        this.type = k, this.content = P, this.alias = H, this.length = (j || "").length | 0;
      }
      _.stringify = function k(P, H) {
        if (typeof P == "string")
          return P;
        if (Array.isArray(P)) {
          var j = "";
          return P.forEach(function(z) {
            j += k(z, H);
          }), j;
        }
        var re = {
          type: P.type,
          content: k(P.content, H),
          tag: "span",
          classes: ["token", P.type],
          attributes: {},
          language: H
        }, te = P.alias;
        te && (Array.isArray(te) ? Array.prototype.push.apply(re.classes, te) : re.classes.push(te)), p.hooks.run("wrap", re);
        var ce = "";
        for (var V in re.attributes)
          ce += " " + V + '="' + (re.attributes[V] || "").replace(/"/g, "&quot;") + '"';
        return "<" + re.tag + ' class="' + re.classes.join(" ") + '"' + ce + ">" + re.content + "</" + re.tag + ">";
      };
      function E(k, P, H, j) {
        k.lastIndex = P;
        var re = k.exec(H);
        if (re && j && re[1]) {
          var te = re[1].length;
          re.index += te, re[0] = re[0].slice(te);
        }
        return re;
      }
      function T(k, P, H, j, re, te) {
        for (var ce in H)
          if (!(!H.hasOwnProperty(ce) || !H[ce])) {
            var V = H[ce];
            V = Array.isArray(V) ? V : [V];
            for (var z = 0; z < V.length; ++z) {
              if (te && te.cause == ce + "," + z)
                return;
              var q = V[z], Te = q.inside, Se = !!q.lookbehind, Ee = !!q.greedy, de = q.alias;
              if (Ee && !q.pattern.global) {
                var K = q.pattern.toString().match(/[imsuy]*$/)[0];
                q.pattern = RegExp(q.pattern.source, K + "g");
              }
              for (var D = q.pattern || q, Z = j.next, oe = re; Z !== P.tail && !(te && oe >= te.reach); oe += Z.value.length, Z = Z.next) {
                var Y = Z.value;
                if (P.length > k.length)
                  return;
                if (!(Y instanceof _)) {
                  var W = 1, J;
                  if (Ee) {
                    if (J = E(D, oe, k, Se), !J || J.index >= k.length)
                      break;
                    var fe = J.index, R = J.index + J[0].length, U = oe;
                    for (U += Z.value.length; fe >= U; )
                      Z = Z.next, U += Z.value.length;
                    if (U -= Z.value.length, oe = U, Z.value instanceof _)
                      continue;
                    for (var X = Z; X !== P.tail && (U < R || typeof X.value == "string"); X = X.next)
                      W++, U += X.value.length;
                    W--, Y = k.slice(oe, U), J.index -= oe;
                  } else if (J = E(D, 0, Y, Se), !J)
                    continue;
                  var fe = J.index, _e = J[0], B = Y.slice(0, fe), M = Y.slice(fe + _e.length), F = oe + Y.length;
                  te && F > te.reach && (te.reach = F);
                  var se = Z.prev;
                  B && (se = w(P, se, B), oe += B.length), O(P, se, W);
                  var ye = new _(ce, Te ? p.tokenize(_e, Te) : _e, de, _e);
                  if (Z = w(P, se, ye), M && w(P, Z, M), W > 1) {
                    var De = {
                      cause: ce + "," + z,
                      reach: F
                    };
                    T(k, P, H, Z.prev, oe, De), te && De.reach > te.reach && (te.reach = De.reach);
                  }
                }
              }
            }
          }
      }
      function S() {
        var k = { value: null, prev: null, next: null }, P = { value: null, prev: k, next: null };
        k.next = P, this.head = k, this.tail = P, this.length = 0;
      }
      function w(k, P, H) {
        var j = P.next, re = { value: H, prev: P, next: j };
        return P.next = re, j.prev = re, k.length++, re;
      }
      function O(k, P, H) {
        for (var j = P.next, re = 0; re < H && j !== k.tail; re++)
          j = j.next;
        P.next = j, j.prev = P, k.length -= re;
      }
      function m(k) {
        for (var P = [], H = k.head.next; H !== k.tail; )
          P.push(H.value), H = H.next;
        return P;
      }
      if (!r.document)
        return r.addEventListener && (p.disableWorkerMessageHandler || r.addEventListener("message", function(k) {
          var P = JSON.parse(k.data), H = P.language, j = P.code, re = P.immediateClose;
          r.postMessage(p.highlight(j, p.languages[H], H)), re && r.close();
        }, !1)), p;
      var v = p.util.currentScript();
      v && (p.filename = v.src, v.hasAttribute("data-manual") && (p.manual = !0));
      function I() {
        p.manual || p.highlightAll();
      }
      if (!p.manual) {
        var G = document.readyState;
        G === "loading" || G === "interactive" && v && v.defer ? document.addEventListener("DOMContentLoaded", I) : window.requestAnimationFrame ? window.requestAnimationFrame(I) : window.setTimeout(I, 16);
      }
      return p;
    }(t);
    e.exports && (e.exports = n), typeof uf < "u" && (uf.Prism = n), n.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                {
                  pattern: /^(\s*)["']|["']$/,
                  lookbehind: !0
                }
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(r) {
      r.type === "entity" && (r.attributes.title = r.content.replace(/&amp;/, "&"));
    }), Object.defineProperty(n.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: function(l, d) {
        var f = {};
        f["language-" + d] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: n.languages[d]
        }, f.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var p = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: f
          }
        };
        p["language-" + d] = {
          pattern: /[\s\S]+/,
          inside: n.languages[d]
        };
        var _ = {};
        _[l] = {
          pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
            return l;
          }), "i"),
          lookbehind: !0,
          greedy: !0,
          inside: p
        }, n.languages.insertBefore("markup", "cdata", _);
      }
    }), Object.defineProperty(n.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: function(r, l) {
        n.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + r + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [l, "language-" + l],
                  inside: n.languages[l]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }
    }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml, function(r) {
      var l = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      r.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + l.source + ")*?" + /(?:;|(?=\s*\{))/.source),
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp("\\burl\\((?:" + l.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + l.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + l.source + ")*(?=\\s*\\{)"),
          lookbehind: !0
        },
        string: {
          pattern: l,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, r.languages.css.atrule.inside.rest = r.languages.css;
      var d = r.languages.markup;
      d && (d.tag.addInlined("style", "css"), d.tag.addAttribute("style", "css"));
    }(n), n.languages.clike = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b\w+(?=\()/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
      punctuation: /[{}[\];(),.:]/
    }, n.languages.javascript = n.languages.extend("clike", {
      "class-name": [
        n.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", {
      regex: {
        pattern: RegExp(
          // lookbehind
          // eslint-disable-next-line regexp/no-dupe-characters-character-class
          /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
          // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
          // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
          // with the only syntax, so we have to define 2 different regex patterns.
          /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
          /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
          /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: n.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: n.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), n.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: n.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), n.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    )), n.languages.js = n.languages.javascript, function() {
      if (typeof n > "u" || typeof document > "u")
        return;
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
      var r = "Loading…", l = function(v, I) {
        return "✖ Error " + v + " while fetching file: " + I;
      }, d = "✖ Error: File does not exist or is empty", f = {
        js: "javascript",
        py: "python",
        rb: "ruby",
        ps1: "powershell",
        psm1: "powershell",
        sh: "bash",
        bat: "batch",
        h: "c",
        tex: "latex"
      }, p = "data-src-status", _ = "loading", E = "loaded", T = "failed", S = "pre[data-src]:not([" + p + '="' + E + '"]):not([' + p + '="' + _ + '"])';
      function w(v, I, G) {
        var k = new XMLHttpRequest();
        k.open("GET", v, !0), k.onreadystatechange = function() {
          k.readyState == 4 && (k.status < 400 && k.responseText ? I(k.responseText) : k.status >= 400 ? G(l(k.status, k.statusText)) : G(d));
        }, k.send(null);
      }
      function O(v) {
        var I = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(v || "");
        if (I) {
          var G = Number(I[1]), k = I[2], P = I[3];
          return k ? P ? [G, Number(P)] : [G, void 0] : [G, G];
        }
      }
      n.hooks.add("before-highlightall", function(v) {
        v.selector += ", " + S;
      }), n.hooks.add("before-sanity-check", function(v) {
        var I = (
          /** @type {HTMLPreElement} */
          v.element
        );
        if (I.matches(S)) {
          v.code = "", I.setAttribute(p, _);
          var G = I.appendChild(document.createElement("CODE"));
          G.textContent = r;
          var k = I.getAttribute("data-src"), P = v.language;
          if (P === "none") {
            var H = (/\.(\w+)$/.exec(k) || [, "none"])[1];
            P = f[H] || H;
          }
          n.util.setLanguage(G, P), n.util.setLanguage(I, P);
          var j = n.plugins.autoloader;
          j && j.loadLanguages(P), w(
            k,
            function(re) {
              I.setAttribute(p, E);
              var te = O(I.getAttribute("data-range"));
              if (te) {
                var ce = re.split(/\r\n?|\n/g), V = te[0], z = te[1] == null ? ce.length : te[1];
                V < 0 && (V += ce.length), V = Math.max(0, Math.min(V - 1, ce.length)), z < 0 && (z += ce.length), z = Math.max(0, Math.min(z, ce.length)), re = ce.slice(V, z).join(`
`), I.hasAttribute("data-start") || I.setAttribute("data-start", String(V + 1));
              }
              G.textContent = re, n.highlightElement(G);
            },
            function(re) {
              I.setAttribute(p, T), G.textContent = re;
            }
          );
        }
      }), n.plugins.fileHighlight = {
        /**
         * Executes the File Highlight plugin for all matching `pre` elements under the given container.
         *
         * Note: Elements which are already loaded or currently loading will not be touched by this method.
         *
         * @param {ParentNode} [container=document]
         */
        highlight: function(I) {
          for (var G = (I || document).querySelectorAll(S), k = 0, P; P = G[k++]; )
            n.highlightElement(P);
        }
      };
      var m = !1;
      n.fileHighlight = function() {
        m || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), m = !0), n.plugins.fileHighlight.highlight.apply(this, arguments);
      };
    }();
  }(Au)), Au.exports;
}
var Oh = {}, Dh;
function wp() {
  return Dh || (Dh = 1, Prism.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }), Oh;
}
var Ah = {}, Mh;
function Op() {
  return Mh || (Mh = 1, Prism.languages.javascript = Prism.languages.extend("clike", {
    "class-name": [
      Prism.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(
        // lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: Prism.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), Prism.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: Prism.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), Prism.languages.js = Prism.languages.javascript), Ah;
}
var Rh = {}, bh;
function Dp() {
  return bh || (bh = 1, Prism.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: !0
              }
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(e) {
    e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(t, n) {
      var r = {};
      r["language-" + n] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: Prism.languages[n]
      }, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var l = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: r
        }
      };
      l["language-" + n] = {
        pattern: /[\s\S]+/,
        inside: Prism.languages[n]
      };
      var d = {};
      d[t] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return t;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: l
      }, Prism.languages.insertBefore("markup", "cdata", d);
    }
  }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(e, t) {
      Prism.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [t, "language-" + t],
                inside: Prism.languages[t]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml), Rh;
}
var Lh = {}, Ih;
function Ap() {
  return Ih || (Ih = 1, function(e) {
    var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function n(T) {
      return T = T.replace(/<inner>/g, function() {
        return t;
      }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + T + ")");
    }
    var r = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, l = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
      return r;
    }), d = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
      "front-matter-block": {
        pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^---|---$/,
          "front-matter": {
            pattern: /\S+(?:\s+\S+)*/,
            alias: ["yaml", "language-yaml"],
            inside: e.languages.yaml
          }
        }
      },
      blockquote: {
        // > ...
        pattern: /^>(?:[\t ]*>)*/m,
        alias: "punctuation"
      },
      table: {
        pattern: RegExp("^" + l + d + "(?:" + l + ")*", "m"),
        inside: {
          "table-data-rows": {
            pattern: RegExp("^(" + l + d + ")(?:" + l + ")*$"),
            lookbehind: !0,
            inside: {
              "table-data": {
                pattern: RegExp(r),
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          },
          "table-line": {
            pattern: RegExp("^(" + l + ")" + d + "$"),
            lookbehind: !0,
            inside: {
              punctuation: /\||:?-{3,}:?/
            }
          },
          "table-header-row": {
            pattern: RegExp("^" + l + "$"),
            inside: {
              "table-header": {
                pattern: RegExp(r),
                alias: "important",
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          }
        }
      },
      code: [
        {
          // Prefixed by 4 spaces or 1 tab and preceded by an empty line
          pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
          lookbehind: !0,
          alias: "keyword"
        },
        {
          // ```optional language
          // code block
          // ```
          pattern: /^```[\s\S]*?^```$/m,
          greedy: !0,
          inside: {
            "code-block": {
              pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
              lookbehind: !0
            },
            "code-language": {
              pattern: /^(```).+/,
              lookbehind: !0
            },
            punctuation: /```/
          }
        }
      ],
      title: [
        {
          // title 1
          // =======
          // title 2
          // -------
          pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
          alias: "important",
          inside: {
            punctuation: /==+$|--+$/
          }
        },
        {
          // # title 1
          // ###### title 6
          pattern: /(^\s*)#.+/m,
          lookbehind: !0,
          alias: "important",
          inside: {
            punctuation: /^#+|#+$/
          }
        }
      ],
      hr: {
        // ***
        // ---
        // * * *
        // -----------
        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      list: {
        // * item
        // + item
        // - item
        // 1. item
        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      "url-reference": {
        // [id]: http://example.com "Optional title"
        // [id]: http://example.com 'Optional title'
        // [id]: http://example.com (Optional title)
        // [id]: <http://example.com> "Optional title"
        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
        inside: {
          variable: {
            pattern: /^(!?\[)[^\]]+/,
            lookbehind: !0
          },
          string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
          punctuation: /^[\[\]!:]|[<>]/
        },
        alias: "url"
      },
      bold: {
        // **strong**
        // __strong__
        // allow one nested instance of italic text using the same delimiter
        pattern: n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^..)[\s\S]+(?=..$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /\*\*|__/
        }
      },
      italic: {
        // *em*
        // _em_
        // allow one nested instance of bold text using the same delimiter
        pattern: n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^.)[\s\S]+(?=.$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /[*_]/
        }
      },
      strike: {
        // ~~strike through~~
        // ~strike~
        // eslint-disable-next-line regexp/strict
        pattern: n(/(~~?)(?:(?!~)<inner>)+\2/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^~~?)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /~~?/
        }
      },
      "code-snippet": {
        // `code`
        // ``code``
        pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
        lookbehind: !0,
        greedy: !0,
        alias: ["code", "keyword"]
      },
      url: {
        // [example](http://example.com "Optional title")
        // [example][id]
        // [example] [id]
        pattern: n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          operator: /^!/,
          content: {
            pattern: /(^\[)[^\]]+(?=\])/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          variable: {
            pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
            lookbehind: !0
          },
          url: {
            pattern: /(^\]\()[^\s)]+/,
            lookbehind: !0
          },
          string: {
            pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
            lookbehind: !0
          }
        }
      }
    }), ["url", "bold", "italic", "strike"].forEach(function(T) {
      ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(S) {
        T !== S && (e.languages.markdown[T].inside.content.inside[S] = e.languages.markdown[S]);
      });
    }), e.hooks.add("after-tokenize", function(T) {
      if (T.language !== "markdown" && T.language !== "md")
        return;
      function S(w) {
        if (!(!w || typeof w == "string"))
          for (var O = 0, m = w.length; O < m; O++) {
            var v = w[O];
            if (v.type !== "code") {
              S(v.content);
              continue;
            }
            var I = v.content[1], G = v.content[3];
            if (I && G && I.type === "code-language" && G.type === "code-block" && typeof I.content == "string") {
              var k = I.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
              k = (/[a-z][\w-]*/i.exec(k) || [""])[0].toLowerCase();
              var P = "language-" + k;
              G.alias ? typeof G.alias == "string" ? G.alias = [G.alias, P] : G.alias.push(P) : G.alias = [P];
            }
          }
      }
      S(T.tokens);
    }), e.hooks.add("wrap", function(T) {
      if (T.type === "code-block") {
        for (var S = "", w = 0, O = T.classes.length; w < O; w++) {
          var m = T.classes[w], v = /language-(.+)/.exec(m);
          if (v) {
            S = v[1];
            break;
          }
        }
        var I = e.languages[S];
        if (I)
          T.content = e.highlight(E(T.content), I, S);
        else if (S && S !== "none" && e.plugins.autoloader) {
          var G = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
          T.attributes.id = G, e.plugins.autoloader.loadLanguages(S, function() {
            var k = document.getElementById(G);
            k && (k.innerHTML = e.highlight(k.textContent, e.languages[S], S));
          });
        }
      }
    });
    var f = RegExp(e.languages.markup.tag.pattern.source, "gi"), p = {
      amp: "&",
      lt: "<",
      gt: ">",
      quot: '"'
    }, _ = String.fromCodePoint || String.fromCharCode;
    function E(T) {
      var S = T.replace(f, "");
      return S = S.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(w, O) {
        if (O = O.toLowerCase(), O[0] === "#") {
          var m;
          return O[1] === "x" ? m = parseInt(O.slice(2), 16) : m = Number(O.slice(1)), _(m);
        } else {
          var v = p[O];
          return v || w;
        }
      }), S;
    }
    e.languages.md = e.languages.markdown;
  }(Prism)), Lh;
}
var kh = {}, Ph;
function Mp() {
  return Ph || (Ph = 1, Prism.languages.c = Prism.languages.extend("clike", {
    comment: {
      pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    string: {
      // https://en.cppreference.com/w/c/language/string_literal
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
      lookbehind: !0
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
  }), Prism.languages.insertBefore("c", "string", {
    char: {
      // https://en.cppreference.com/w/c/language/character_constant
      pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
      greedy: !0
    }
  }), Prism.languages.insertBefore("c", "string", {
    macro: {
      // allow for multiline macro definitions
      // spaces after the # character compile fine with gcc
      pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        string: [
          {
            // highlight the path of the include statement as a string
            pattern: /^(#\s*include\s*)<[^>]+>/,
            lookbehind: !0
          },
          Prism.languages.c.string
        ],
        char: Prism.languages.c.char,
        comment: Prism.languages.c.comment,
        "macro-name": [
          {
            pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
            lookbehind: !0
          },
          {
            pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
            lookbehind: !0,
            alias: "function"
          }
        ],
        // highlight macro directives as keywords
        directive: {
          pattern: /^(#\s*)[a-z]+/,
          lookbehind: !0,
          alias: "keyword"
        },
        "directive-hash": /^#/,
        punctuation: /##|\\(?=[\r\n])/,
        expression: {
          pattern: /\S[\s\S]*/,
          inside: Prism.languages.c
        }
      }
    }
  }), Prism.languages.insertBefore("c", "function", {
    // highlight predefined macros as constants
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
  }), delete Prism.languages.c.boolean), kh;
}
var $h = {}, Fh;
function Rp() {
  return Fh || (Fh = 1, function(e) {
    var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t.source + ")*?" + /(?:;|(?=\s*\{))/.source),
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + t.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: t,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css;
    var n = e.languages.markup;
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
  }(Prism)), $h;
}
var Bh = {}, Hh;
function bp() {
  return Hh || (Hh = 1, Prism.languages.objectivec = Prism.languages.extend("c", {
    string: {
      pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
  }), delete Prism.languages.objectivec["class-name"], Prism.languages.objc = Prism.languages.objectivec), Bh;
}
var Wh = {}, Kh;
function Lp() {
  return Kh || (Kh = 1, Prism.languages.sql = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
      lookbehind: !0
    },
    variable: [
      {
        pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
        greedy: !0
      },
      /@[\w.$]+/
    ],
    string: {
      pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
      greedy: !0,
      lookbehind: !0
    },
    identifier: {
      pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
      greedy: !0,
      lookbehind: !0,
      inside: {
        punctuation: /^`|`$/
      }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    // Should we highlight user defined functions too?
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
  }), Wh;
}
var zh = {}, Uh;
function Ip() {
  return Uh || (Uh = 1, Prism.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0,
      greedy: !0
    },
    "string-interpolation": {
      pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
      greedy: !0,
      inside: {
        interpolation: {
          // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
          pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
          lookbehind: !0,
          inside: {
            "format-spec": {
              pattern: /(:)[^:(){}]+(?=\}$)/,
              lookbehind: !0
            },
            "conversion-option": {
              pattern: /![sra](?=[:}]$)/,
              alias: "punctuation"
            },
            rest: null
          }
        },
        string: /[\s\S]+/
      }
    },
    "triple-quoted-string": {
      pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
      greedy: !0
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: !0
    },
    "class-name": {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: !0
    },
    decorator: {
      pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
      lookbehind: !0,
      alias: ["annotation", "punctuation"],
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python, Prism.languages.py = Prism.languages.python), zh;
}
var Gh = {}, Yh;
function kp() {
  return Yh || (Yh = 1, function(e) {
    for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++)
      t = t.replace(/<self>/g, function() {
        return t;
      });
    t = t.replace(/<self>/g, function() {
      return /[^\s\S]/.source;
    }), e.languages.rust = {
      comment: [
        {
          pattern: RegExp(/(^|[^\\])/.source + t),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
        greedy: !0
      },
      char: {
        pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
        greedy: !0
      },
      attribute: {
        pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
        greedy: !0,
        alias: "attr-name",
        inside: {
          string: null
          // see below
        }
      },
      // Closure params should not be confused with bitwise OR |
      "closure-params": {
        pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "closure-punctuation": {
            pattern: /^\||\|$/,
            alias: "punctuation"
          },
          rest: null
          // see below
        }
      },
      "lifetime-annotation": {
        pattern: /'\w+/,
        alias: "symbol"
      },
      "fragment-specifier": {
        pattern: /(\$\w+:)[a-z]+/,
        lookbehind: !0,
        alias: "punctuation"
      },
      variable: /\$\w+/,
      "function-definition": {
        pattern: /(\bfn\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      "type-definition": {
        pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
        lookbehind: !0,
        alias: "class-name"
      },
      "module-declaration": [
        {
          pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
          lookbehind: !0,
          alias: "namespace"
        },
        {
          pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /::/
          }
        }
      ],
      keyword: [
        // https://github.com/rust-lang/reference/blob/master/src/keywords.md
        /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
        // primitives and str
        // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
        /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
      ],
      // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
      // and Rust's naming conventions recommend snake_case anyway.
      // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
      macro: {
        pattern: /\b\w+!/,
        alias: "property"
      },
      constant: /\b[A-Z_][A-Z_\d]+\b/,
      "class-name": /\b[A-Z]\w*\b/,
      namespace: {
        pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
        inside: {
          punctuation: /::/
        }
      },
      // Hex, oct, bin, dec numbers with visual separators and type suffix
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
      operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
  }(Prism)), Gh;
}
var jh = {}, Vh;
function Pp() {
  return Vh || (Vh = 1, Prism.languages.swift = {
    comment: {
      // Nested comments are supported up to 2 levels
      pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
      lookbehind: !0,
      greedy: !0
    },
    "string-literal": [
      // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
      {
        pattern: RegExp(
          /(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\\($/,
            alias: "punctuation"
          },
          punctuation: /\\(?=[\r\n])/,
          string: /[\s\S]+/
        }
      },
      {
        pattern: RegExp(
          /(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\#+\($/,
            alias: "punctuation"
          },
          string: /[\s\S]+/
        }
      }
    ],
    directive: {
      // directives with conditions
      pattern: RegExp(
        /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
      ),
      alias: "property",
      inside: {
        "directive-name": /^#\w+/,
        boolean: /\b(?:false|true)\b/,
        number: /\b\d+(?:\.\d+)*\b/,
        operator: /!|&&|\|\||[<>]=?/,
        punctuation: /[(),]/
      }
    },
    literal: {
      pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
      alias: "constant"
    },
    "other-directive": {
      pattern: /#\w+\b/,
      alias: "property"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "atrule"
    },
    "function-definition": {
      pattern: /(\bfunc\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    label: {
      // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
      pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
      lookbehind: !0,
      alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
      pattern: /\bnil\b/,
      alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
      pattern: /\b_\b/,
      alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
  }, Prism.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = Prism.languages.swift;
  })), jh;
}
var qh = {}, Zh;
function $p() {
  return Zh || (Zh = 1, function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(
      /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
      // keywords that have to be followed by an identifier
      /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
      // This is for `import type *, {}`
      /\btype\b(?=\s*(?:[\{*]|$))/
    ), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var t = e.languages.extend("typescript", {});
    delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
      decorator: {
        pattern: /@[$\w\xA0-\uFFFF]+/,
        inside: {
          at: {
            pattern: /^@/,
            alias: "operator"
          },
          function: /^[\s\S]+/
        }
      },
      "generic-function": {
        // e.g. foo<T extends "bar" | "baz">( ...
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
        greedy: !0,
        inside: {
          function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
          generic: {
            pattern: /<[\s\S]+/,
            // everything after the first <
            alias: "class-name",
            inside: t
          }
        }
      }
    }), e.languages.ts = e.languages.typescript;
  }(Prism)), qh;
}
var Jh = {}, Xh;
function Fp() {
  return Xh || (Xh = 1, function(e) {
    var t = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, n = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, r = {
      pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /\./
      }
    };
    e.languages.java = e.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        r,
        {
          // variables, parameters, and constructor references
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
          lookbehind: !0,
          inside: r.inside
        },
        {
          // class names based on keyword
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + n + /[A-Z]\w*\b/.source),
          lookbehind: !0,
          inside: r.inside
        }
      ],
      keyword: t,
      function: [
        e.languages.clike.function,
        {
          pattern: /(::\s*)[a-z_]\w*/,
          lookbehind: !0
        }
      ],
      number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
      operator: {
        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
        lookbehind: !0
      },
      constant: /\b[A-Z][A-Z_\d]+\b/
    }), e.languages.insertBefore("java", "string", {
      "triple-quoted-string": {
        // http://openjdk.java.net/jeps/355#Description
        pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
        greedy: !0,
        alias: "string"
      },
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
        greedy: !0
      }
    }), e.languages.insertBefore("java", "class-name", {
      annotation: {
        pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
        lookbehind: !0,
        alias: "punctuation"
      },
      generics: {
        pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
        inside: {
          "class-name": r,
          keyword: t,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      },
      import: [
        {
          pattern: RegExp(/(\bimport\s+)/.source + n + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
          lookbehind: !0,
          inside: {
            namespace: r.inside.namespace,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        },
        {
          pattern: RegExp(/(\bimport\s+static\s+)/.source + n + /(?:\w+|\*)(?=\s*;)/.source),
          lookbehind: !0,
          alias: "static",
          inside: {
            namespace: r.inside.namespace,
            static: /\b\w+$/,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        }
      ],
      namespace: {
        pattern: RegExp(
          /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
            return t.source;
          })
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    });
  }(Prism)), Jh;
}
var Qh = {}, eg;
function Bp() {
  return eg || (eg = 1, function(e) {
    var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, n = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
      return t.source;
    });
    e.languages.cpp = e.languages.extend("c", {
      "class-name": [
        {
          pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
            return t.source;
          })),
          lookbehind: !0
        },
        // This is intended to capture the class name of method implementations like:
        //   void foo::bar() const {}
        // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
        // it starts with an uppercase letter. This approximation should give decent results.
        /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
        // This will capture the class name before destructors like:
        //   Foo::~Foo() {}
        /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
        // This also intends to capture the class name of method implementations but here the class has template
        // parameters, so it can't be a namespace (until C++ adds generic namespaces).
        /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
      ],
      keyword: t,
      number: {
        pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
        greedy: !0
      },
      operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
      boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
      module: {
        // https://en.cppreference.com/w/cpp/language/modules
        pattern: RegExp(
          /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
          /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
          /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
            return n;
          }) + ")"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: /^[<"][\s\S]+/,
          operator: /:/,
          punctuation: /\./
        }
      },
      "raw-string": {
        pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
        alias: "string",
        greedy: !0
      }
    }), e.languages.insertBefore("cpp", "keyword", {
      "generic-function": {
        pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<[\s\S]+/,
            alias: "class-name",
            inside: e.languages.cpp
          }
        }
      }
    }), e.languages.insertBefore("cpp", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("cpp", "class-name", {
      // the base clause is an optional list of parent classes
      // https://en.cppreference.com/w/cpp/language/class
      "base-clause": {
        pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: e.languages.extend("cpp", {})
      }
    }), e.languages.insertBefore("inside", "double-colon", {
      // All untokenized words that are not namespaces should be class names
      "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
  }(Prism)), Qh;
}
var tg;
function RC() {
  if (tg) return Pn;
  tg = 1;
  var e = Sp();
  wp(), Op(), Dp(), Ap(), Mp(), Rp(), bp(), Lp(), Ip(), kp(), Pp(), $p(), Fp(), Bp();
  var t = gn(), n = Yt();
  const r = (ee) => ee != null && e.languages.hasOwnProperty(ee) ? ee : void 0;
  function l(ee, ne) {
    for (const ue of ee.childNodes) {
      if (t.isHTMLElement(ue) && ue.tagName === ne)
        return !0;
      l(ue, ne);
    }
    return !1;
  }
  const d = "data-highlight-language";
  class f extends n.ElementNode {
    /** @internal */
    static getType() {
      return "code";
    }
    static clone(ne) {
      return new f(ne.__language, ne.__key);
    }
    constructor(ne, ue) {
      super(ue), this.__language = r(ne);
    }
    // View
    createDOM(ne) {
      const ue = document.createElement("code");
      t.addClassNamesToElement(ue, ne.theme.code), ue.setAttribute("spellcheck", "false");
      const be = this.getLanguage();
      return be && ue.setAttribute(d, be), ue;
    }
    updateDOM(ne, ue, be) {
      const Ne = this.__language, Re = ne.__language;
      return Ne ? Ne !== Re && ue.setAttribute(d, Ne) : Re && ue.removeAttribute(d), !1;
    }
    exportDOM() {
      const ne = document.createElement("pre");
      ne.setAttribute("spellcheck", "false");
      const ue = this.getLanguage();
      return ue && ne.setAttribute(d, ue), {
        element: ne
      };
    }
    static importDOM() {
      return {
        // Typically <pre> is used for code blocks, and <code> for inline code styles
        // but if it's a multi line <code> we'll create a block. Pass through to
        // inline format handled by TextNode otherwise.
        code: (ne) => ne.textContent != null && (/\r?\n/.test(ne.textContent) || l(ne, "BR")) ? {
          conversion: E,
          priority: 1
        } : null,
        div: (ne) => ({
          conversion: T,
          priority: 1
        }),
        pre: (ne) => ({
          conversion: E,
          priority: 0
        }),
        table: (ne) => G(ne) ? {
          conversion: S,
          priority: 3
        } : null,
        td: (ne) => {
          const ue = ne, be = ue.closest("table");
          return I(ue) ? {
            conversion: O,
            priority: 3
          } : be && G(be) ? {
            conversion: w,
            priority: 3
          } : null;
        },
        tr: (ne) => {
          const be = ne.closest("table");
          return be && G(be) ? {
            conversion: w,
            priority: 3
          } : null;
        }
      };
    }
    static importJSON(ne) {
      const ue = p(ne.language);
      return ue.setFormat(ne.format), ue.setIndent(ne.indent), ue.setDirection(ne.direction), ue;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        language: this.getLanguage(),
        type: "code",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(ne, ue = !0) {
      const be = this.getChildren(), Ne = be.length;
      if (Ne >= 2 && be[Ne - 1].getTextContent() === `
` && be[Ne - 2].getTextContent() === `
` && ne.isCollapsed() && ne.anchor.key === this.__key && ne.anchor.offset === Ne) {
        be[Ne - 1].remove(), be[Ne - 2].remove();
        const Be = n.$createParagraphNode();
        return this.insertAfter(Be, ue), Be;
      }
      const {
        anchor: Re,
        focus: ke
      } = ne, qe = (Re.isBefore(ke) ? Re : ke).getNode();
      if (n.$isTextNode(qe)) {
        let Be = Se(qe);
        const ct = [];
        for (; ; )
          if (n.$isTabNode(Be))
            ct.push(n.$createTabNode()), Be = Be.getNextSibling();
          else if (Te(Be)) {
            let ve = 0;
            const Le = Be.getTextContent(), Me = Be.getTextContentSize();
            for (; ve < Me && Le[ve] === " "; ve++) ;
            if (ve !== 0 && ct.push(q(" ".repeat(ve))), ve !== Me)
              break;
            Be = Be.getNextSibling();
          } else
            break;
        const Dt = qe.splitText(Re.offset)[0], zt = Re.offset === 0 ? 0 : 1, en = Dt.getIndexWithinParent() + zt, Oe = qe.getParentOrThrow(), ie = [n.$createLineBreakNode(), ...ct];
        Oe.splice(en, 0, ie);
        const le = ct[ct.length - 1];
        le ? le.select() : Re.offset === 0 ? Dt.selectPrevious() : Dt.getNextSibling().selectNext(0, 0);
      }
      if (_(qe)) {
        const {
          offset: Be
        } = ne.anchor;
        qe.splice(Be, 0, [n.$createLineBreakNode()]), qe.select(Be + 1, Be + 1);
      }
      return null;
    }
    canIndent() {
      return !1;
    }
    collapseAtStart() {
      const ne = n.$createParagraphNode();
      return this.getChildren().forEach((be) => ne.append(be)), this.replace(ne), !0;
    }
    setLanguage(ne) {
      const ue = this.getWritable();
      ue.__language = r(ne);
    }
    getLanguage() {
      return this.getLatest().__language;
    }
  }
  function p(ee) {
    return n.$applyNodeReplacement(new f(ee));
  }
  function _(ee) {
    return ee instanceof f;
  }
  function E(ee) {
    let ne;
    return t.isHTMLElement(ee) && (ne = ee.getAttribute(d)), {
      node: p(ne)
    };
  }
  function T(ee) {
    const ne = ee, ue = m(ne);
    return !ue && !v(ne) ? {
      node: null
    } : {
      after: (be) => {
        const Ne = ee.parentNode;
        return Ne != null && ee !== Ne.lastChild && be.push(n.$createLineBreakNode()), be;
      },
      node: ue ? p() : null
    };
  }
  function S() {
    return {
      node: p()
    };
  }
  function w() {
    return {
      node: null
    };
  }
  function O(ee) {
    const ne = ee;
    return {
      after: (ue) => (ne.parentNode && ne.parentNode.nextSibling && ue.push(n.$createLineBreakNode()), ue),
      node: null
    };
  }
  function m(ee) {
    return ee.style.fontFamily.match("monospace") !== null;
  }
  function v(ee) {
    let ne = ee.parentElement;
    for (; ne !== null; ) {
      if (m(ne))
        return !0;
      ne = ne.parentElement;
    }
    return !1;
  }
  function I(ee) {
    return ee.classList.contains("js-file-line");
  }
  function G(ee) {
    return ee.classList.contains("js-file-line-container");
  }
  const k = "javascript", P = {
    c: "C",
    clike: "C-like",
    cpp: "C++",
    css: "CSS",
    html: "HTML",
    java: "Java",
    js: "JavaScript",
    markdown: "Markdown",
    objc: "Objective-C",
    plain: "Plain Text",
    py: "Python",
    rust: "Rust",
    sql: "SQL",
    swift: "Swift",
    typescript: "TypeScript",
    xml: "XML"
  }, H = {
    cpp: "cpp",
    java: "java",
    javascript: "js",
    md: "markdown",
    plaintext: "plain",
    python: "py",
    text: "plain",
    ts: "typescript"
  };
  function j(ee) {
    return H[ee] || ee;
  }
  function re(ee) {
    const ne = j(ee);
    return P[ne] || ne;
  }
  const te = () => k, ce = () => Object.keys(e.languages).filter(
    // Prism has several language helpers mixed into languages object
    // so filtering them out here to get langs list
    (ee) => typeof e.languages[ee] != "function"
  ).sort();
  class V extends n.TextNode {
    /** @internal */
    constructor(ne, ue, be) {
      super(ne, be), this.__highlightType = ue;
    }
    static getType() {
      return "code-highlight";
    }
    static clone(ne) {
      return new V(ne.__text, ne.__highlightType || void 0, ne.__key);
    }
    getHighlightType() {
      return this.getLatest().__highlightType;
    }
    createDOM(ne) {
      const ue = super.createDOM(ne), be = z(ne.theme, this.__highlightType);
      return t.addClassNamesToElement(ue, be), ue;
    }
    updateDOM(ne, ue, be) {
      const Ne = super.updateDOM(ne, ue, be), Re = z(be.theme, ne.__highlightType), ke = z(be.theme, this.__highlightType);
      return Re !== ke && (Re && t.removeClassNamesFromElement(ue, Re), ke && t.addClassNamesToElement(ue, ke)), Ne;
    }
    static importJSON(ne) {
      const ue = q(ne.text, ne.highlightType);
      return ue.setFormat(ne.format), ue.setDetail(ne.detail), ue.setMode(ne.mode), ue.setStyle(ne.style), ue;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        highlightType: this.getHighlightType(),
        type: "code-highlight",
        version: 1
      };
    }
    // Prevent formatting (bold, underline, etc)
    setFormat(ne) {
      return this;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return p();
    }
  }
  function z(ee, ne) {
    return ne && ee && ee.codeHighlight && ee.codeHighlight[ne];
  }
  function q(ee, ne) {
    return n.$applyNodeReplacement(new V(ee, ne));
  }
  function Te(ee) {
    return ee instanceof V;
  }
  function Se(ee) {
    let ne = ee, ue = ee;
    for (; Te(ue) || n.$isTabNode(ue); )
      ne = ue, ue = ue.getPreviousSibling();
    return ne;
  }
  function Ee(ee) {
    let ne = ee, ue = ee;
    for (; Te(ue) || n.$isTabNode(ue); )
      ne = ue, ue = ue.getNextSibling();
    return ne;
  }
  const de = {
    defaultLanguage: k,
    tokenize(ee, ne) {
      return e.tokenize(ee, e.languages[ne || ""] || e.languages[this.defaultLanguage]);
    }
  };
  function K(ee, ne) {
    let ue = null, be = null, Ne = ee, Re = ne, ke = ee.getTextContent();
    for (; ; ) {
      if (Re === 0) {
        if (Ne = Ne.getPreviousSibling(), Ne === null)
          break;
        if (!(Te(Ne) || n.$isTabNode(Ne) || n.$isLineBreakNode(Ne)))
          throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");
        if (n.$isLineBreakNode(Ne)) {
          ue = {
            node: Ne,
            offset: 1
          };
          break;
        }
        Re = Math.max(0, Ne.getTextContentSize() - 1), ke = Ne.getTextContent();
      } else
        Re--;
      const qe = ke[Re];
      Te(Ne) && qe !== " " && (be = {
        node: Ne,
        offset: Re
      });
    }
    if (be !== null)
      return be;
    let Fe = null;
    if (ne < ee.getTextContentSize())
      Te(ee) && (Fe = ee.getTextContent()[ne]);
    else {
      const qe = ee.getNextSibling();
      Te(qe) && (Fe = qe.getTextContent()[0]);
    }
    if (Fe !== null && Fe !== " ")
      return ue;
    {
      const qe = D(ee, ne);
      return qe !== null ? qe : ue;
    }
  }
  function D(ee, ne) {
    let ue = ee, be = ne, Ne = ee.getTextContent(), Re = ee.getTextContentSize();
    for (; ; ) {
      if (!Te(ue) || be === Re) {
        if (ue = ue.getNextSibling(), ue === null || n.$isLineBreakNode(ue))
          return null;
        Te(ue) && (be = 0, Ne = ue.getTextContent(), Re = ue.getTextContentSize());
      }
      if (Te(ue)) {
        if (Ne[be] !== " ")
          return {
            node: ue,
            offset: be
          };
        be++;
      }
    }
  }
  function Z(ee) {
    const ne = Ee(ee);
    if (n.$isLineBreakNode(ne))
      throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");
    return ne;
  }
  function oe(ee, ne, ue) {
    const be = ee.getParent();
    _(be) ? J(be, ne, ue) : Te(ee) && ee.replace(n.$createTextNode(ee.__text));
  }
  function Y(ee, ne) {
    const ue = ne.getElementByKey(ee.getKey());
    if (ue === null)
      return;
    const be = ee.getChildren(), Ne = be.length;
    if (Ne === ue.__cachedChildrenLength)
      return;
    ue.__cachedChildrenLength = Ne;
    let Re = "1", ke = 1;
    for (let Fe = 0; Fe < Ne; Fe++)
      n.$isLineBreakNode(be[Fe]) && (Re += `
` + ++ke);
    ue.setAttribute("data-gutter", Re);
  }
  const W = /* @__PURE__ */ new Set();
  function J(ee, ne, ue) {
    const be = ee.getKey();
    W.has(be) || (W.add(be), ee.getLanguage() === void 0 && ee.setLanguage(ue.defaultLanguage), ne.update(() => {
      U(be, () => {
        const Ne = n.$getNodeByKey(be);
        if (!_(Ne) || !Ne.isAttached())
          return !1;
        const Re = Ne.getTextContent(), ke = ue.tokenize(Re, Ne.getLanguage() || ue.defaultLanguage), Fe = R(ke), qe = X(Ne.getChildren(), Fe), {
          from: Be,
          to: ct,
          nodesForReplacement: Dt
        } = qe;
        return Be !== ct || Dt.length ? (ee.splice(Be, ct - Be, Dt), !0) : !1;
      });
    }, {
      onUpdate: () => {
        W.delete(be);
      },
      skipTransforms: !0
    }));
  }
  function R(ee, ne) {
    const ue = [];
    for (const be of ee)
      if (typeof be == "string") {
        const Ne = be.split(/(\n|\t)/), Re = Ne.length;
        for (let ke = 0; ke < Re; ke++) {
          const Fe = Ne[ke];
          Fe === `
` || Fe === `\r
` ? ue.push(n.$createLineBreakNode()) : Fe === "	" ? ue.push(n.$createTabNode()) : Fe.length > 0 && ue.push(q(Fe, ne));
        }
      } else {
        const {
          content: Ne
        } = be;
        typeof Ne == "string" ? ue.push(...R([Ne], be.type)) : Array.isArray(Ne) && ue.push(...R(Ne, be.type));
      }
    return ue;
  }
  function U(ee, ne) {
    const ue = n.$getNodeByKey(ee);
    if (!_(ue) || !ue.isAttached())
      return;
    const be = n.$getSelection();
    if (!n.$isRangeSelection(be)) {
      ne();
      return;
    }
    const Ne = be.anchor, Re = Ne.offset, ke = Ne.type === "element" && n.$isLineBreakNode(ue.getChildAtIndex(Ne.offset - 1));
    let Fe = 0;
    if (!ke) {
      const Be = Ne.getNode();
      Fe = Re + Be.getPreviousSiblings().reduce((ct, Dt) => ct + Dt.getTextContentSize(), 0);
    }
    if (ne()) {
      if (ke) {
        Ne.getNode().select(Re, Re);
        return;
      }
      ue.getChildren().some((Be) => {
        const ct = n.$isTextNode(Be);
        if (ct || n.$isLineBreakNode(Be)) {
          const Dt = Be.getTextContentSize();
          if (ct && Dt >= Fe)
            return Be.select(Fe, Fe), !0;
          Fe -= Dt;
        }
        return !1;
      });
    }
  }
  function X(ee, ne) {
    let ue = 0;
    for (; ue < ee.length && fe(ee[ue], ne[ue]); )
      ue++;
    const be = ee.length, Ne = ne.length, Re = Math.min(be, Ne) - ue;
    let ke = 0;
    for (; ke < Re; )
      if (ke++, !fe(ee[be - ke], ne[Ne - ke])) {
        ke--;
        break;
      }
    const Fe = ue, qe = be - ke, Be = ne.slice(ue, Ne - ke);
    return {
      from: Fe,
      nodesForReplacement: Be,
      to: qe
    };
  }
  function fe(ee, ne) {
    return Te(ee) && Te(ne) && ee.__text === ne.__text && ee.__highlightType === ne.__highlightType || n.$isTabNode(ee) && n.$isTabNode(ne) || n.$isLineBreakNode(ee) && n.$isLineBreakNode(ne);
  }
  function _e(ee) {
    if (!n.$isRangeSelection(ee))
      return !1;
    const ne = ee.anchor.getNode(), ue = ee.focus.getNode();
    if (ne.is(ue) && _(ne))
      return !0;
    const be = ne.getParent();
    return _(be) && be.is(ue.getParent());
  }
  function B(ee) {
    const ne = ee.getNodes(), ue = [[]];
    if (ne.length === 1 && _(ne[0]))
      return ue;
    let be = ue[0];
    for (let Ne = 0; Ne < ne.length; Ne++) {
      const Re = ne[Ne];
      if (!(Te(Re) || n.$isTabNode(Re) || n.$isLineBreakNode(Re)))
        throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");
      n.$isLineBreakNode(Re) ? Ne !== 0 && be.length > 0 && (be = [], ue.push(be)) : be.push(Re);
    }
    return ue;
  }
  function M(ee) {
    const ne = n.$getSelection();
    if (!n.$isRangeSelection(ne) || !_e(ne))
      return null;
    const ue = ee ? n.OUTDENT_CONTENT_COMMAND : n.INDENT_CONTENT_COMMAND, be = ee ? n.OUTDENT_CONTENT_COMMAND : n.INSERT_TAB_COMMAND;
    if (B(ne).length > 1)
      return ue;
    const ke = ne.getNodes()[0];
    if (!(_(ke) || Te(ke) || n.$isTabNode(ke) || n.$isLineBreakNode(ke)))
      throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");
    if (_(ke))
      return ue;
    const Fe = Se(ke), qe = Ee(ke), Be = ne.anchor, ct = ne.focus;
    let Dt, zt;
    return ct.isBefore(Be) ? (Dt = ct, zt = Be) : (Dt = Be, zt = ct), Fe !== null && qe !== null && Dt.key === Fe.getKey() && Dt.offset === 0 && zt.key === qe.getKey() && zt.offset === qe.getTextContentSize() ? ue : be;
  }
  function F(ee) {
    const ne = n.$getSelection();
    if (!n.$isRangeSelection(ne) || !_e(ne))
      return !1;
    const ue = B(ne), be = ue.length;
    if (ue.length > 1) {
      for (let Fe = 0; Fe < be; Fe++) {
        const qe = ue[Fe];
        if (qe.length > 0) {
          let Be = qe[0];
          Fe === 0 && (Be = Se(Be)), Be !== null && (ee === n.INDENT_CONTENT_COMMAND ? Be.insertBefore(n.$createTabNode()) : n.$isTabNode(Be) && Be.remove());
        }
      }
      return !0;
    }
    const Re = ne.getNodes()[0];
    if (!(_(Re) || Te(Re) || n.$isTabNode(Re) || n.$isLineBreakNode(Re)))
      throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");
    if (_(Re))
      return ee === n.INDENT_CONTENT_COMMAND && ne.insertNodes([n.$createTabNode()]), !0;
    const ke = Se(Re);
    if (ke === null)
      throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");
    return ee === n.INDENT_CONTENT_COMMAND ? n.$isLineBreakNode(ke) ? ke.insertAfter(n.$createTabNode()) : ke.insertBefore(n.$createTabNode()) : n.$isTabNode(ke) && ke.remove(), !0;
  }
  function se(ee, ne) {
    const ue = n.$getSelection();
    if (!n.$isRangeSelection(ue))
      return !1;
    const {
      anchor: be,
      focus: Ne
    } = ue, Re = be.offset, ke = Ne.offset, Fe = be.getNode(), qe = Ne.getNode(), Be = ee === n.KEY_ARROW_UP_COMMAND;
    if (!_e(ue) || !(Te(Fe) || n.$isTabNode(Fe)) || !(Te(qe) || n.$isTabNode(qe)))
      return !1;
    if (!ne.altKey) {
      if (ue.isCollapsed()) {
        const ve = Fe.getParentOrThrow();
        if (Be && Re === 0 && Fe.getPreviousSibling() === null) {
          if (ve.getPreviousSibling() === null)
            return ve.selectPrevious(), ne.preventDefault(), !0;
        } else if (!Be && Re === Fe.getTextContentSize() && Fe.getNextSibling() === null && ve.getNextSibling() === null)
          return ve.selectNext(), ne.preventDefault(), !0;
      }
      return !1;
    }
    let ct, Dt;
    if (Fe.isBefore(qe) ? (ct = Se(Fe), Dt = Ee(qe)) : (ct = Se(qe), Dt = Ee(Fe)), ct == null || Dt == null)
      return !1;
    const zt = ct.getNodesBetween(Dt);
    for (let ve = 0; ve < zt.length; ve++) {
      const Le = zt[ve];
      if (!Te(Le) && !n.$isTabNode(Le) && !n.$isLineBreakNode(Le))
        return !1;
    }
    ne.preventDefault(), ne.stopPropagation();
    const en = Be ? ct.getPreviousSibling() : Dt.getNextSibling();
    if (!n.$isLineBreakNode(en))
      return !0;
    const Oe = Be ? en.getPreviousSibling() : en.getNextSibling();
    if (Oe == null)
      return !0;
    const ie = Te(Oe) || n.$isTabNode(Oe) || n.$isLineBreakNode(Oe) ? Be ? Se(Oe) : Ee(Oe) : null;
    let le = ie ?? Oe;
    return en.remove(), zt.forEach((ve) => ve.remove()), ee === n.KEY_ARROW_UP_COMMAND ? (zt.forEach((ve) => le.insertBefore(ve)), le.insertBefore(en)) : (le.insertAfter(en), le = en, zt.forEach((ve) => {
      le.insertAfter(ve), le = ve;
    })), ue.setTextNodeRange(Fe, Re, qe, ke), !0;
  }
  function ye(ee, ne) {
    const ue = n.$getSelection();
    if (!n.$isRangeSelection(ue))
      return !1;
    const {
      anchor: be,
      focus: Ne
    } = ue, Re = be.getNode(), ke = Ne.getNode(), Fe = ee === n.MOVE_TO_START;
    if (!(Te(Re) || n.$isTabNode(Re)) || !(Te(ke) || n.$isTabNode(ke)))
      return !1;
    if (Fe) {
      const qe = K(ke, Ne.offset);
      if (qe !== null) {
        const {
          node: Be,
          offset: ct
        } = qe;
        n.$isLineBreakNode(Be) ? Be.selectNext(0, 0) : ue.setTextNodeRange(Be, ct, Be, ct);
      } else
        ke.getParentOrThrow().selectStart();
    } else
      Z(ke).select();
    return ne.preventDefault(), ne.stopPropagation(), !0;
  }
  function De(ee, ne) {
    if (!ee.hasNodes([f, V]))
      throw new Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
    return ne == null && (ne = de), t.mergeRegister(ee.registerMutationListener(f, (ue) => {
      ee.update(() => {
        for (const [be, Ne] of ue)
          if (Ne !== "destroyed") {
            const Re = n.$getNodeByKey(be);
            Re !== null && Y(Re, ee);
          }
      });
    }), ee.registerNodeTransform(f, (ue) => J(ue, ee, ne)), ee.registerNodeTransform(n.TextNode, (ue) => oe(ue, ee, ne)), ee.registerNodeTransform(V, (ue) => oe(ue, ee, ne)), ee.registerCommand(n.KEY_TAB_COMMAND, (ue) => {
      const be = M(ue.shiftKey);
      return be === null ? !1 : (ue.preventDefault(), ee.dispatchCommand(be, void 0), !0);
    }, n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.INSERT_TAB_COMMAND, () => {
      const ue = n.$getSelection();
      return _e(ue) ? (n.$insertNodes([n.$createTabNode()]), !0) : !1;
    }, n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.INDENT_CONTENT_COMMAND, (ue) => F(n.INDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.OUTDENT_CONTENT_COMMAND, (ue) => F(n.OUTDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.KEY_ARROW_UP_COMMAND, (ue) => se(n.KEY_ARROW_UP_COMMAND, ue), n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (ue) => se(n.KEY_ARROW_DOWN_COMMAND, ue), n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.MOVE_TO_END, (ue) => ye(n.MOVE_TO_END, ue), n.COMMAND_PRIORITY_LOW), ee.registerCommand(n.MOVE_TO_START, (ue) => ye(n.MOVE_TO_START, ue), n.COMMAND_PRIORITY_LOW));
  }
  return Pn.$createCodeHighlightNode = q, Pn.$createCodeNode = p, Pn.$isCodeHighlightNode = Te, Pn.$isCodeNode = _, Pn.CODE_LANGUAGE_FRIENDLY_NAME_MAP = P, Pn.CODE_LANGUAGE_MAP = H, Pn.CodeHighlightNode = V, Pn.CodeNode = f, Pn.DEFAULT_CODE_LANGUAGE = k, Pn.PrismTokenizer = de, Pn.getCodeLanguages = ce, Pn.getDefaultCodeLanguage = te, Pn.getEndOfCodeInLine = Z, Pn.getFirstCodeNodeOfLine = Se, Pn.getLanguageFriendlyName = re, Pn.getLastCodeNodeOfLine = Ee, Pn.getStartOfCodeInLine = K, Pn.normalizeCodeLang = j, Pn.registerCodeHighlighting = De, Pn;
}
var $n = {}, ng;
function bC() {
  if (ng) return $n;
  ng = 1;
  var e = Sp();
  wp(), Op(), Dp(), Ap(), Mp(), Rp(), bp(), Lp(), Ip(), kp(), Pp(), $p(), Fp(), Bp();
  var t = gn(), n = Yt();
  let r = (R) => R != null && e.languages.hasOwnProperty(R) ? R : void 0;
  function l(R, U) {
    for (let X of R.childNodes) {
      if (t.isHTMLElement(X) && X.tagName === U) return !0;
      l(X, U);
    }
    return !1;
  }
  class d extends n.ElementNode {
    static getType() {
      return "code";
    }
    static clone(U) {
      return new d(U.__language, U.__key);
    }
    constructor(U, X) {
      super(X), this.__language = r(U);
    }
    createDOM(U) {
      let X = document.createElement("code");
      return t.addClassNamesToElement(X, U.theme.code), X.setAttribute("spellcheck", "false"), (U = this.getLanguage()) && X.setAttribute("data-highlight-language", U), X;
    }
    updateDOM(U, X) {
      let fe = this.__language;
      return U = U.__language, fe ? fe !== U && X.setAttribute("data-highlight-language", fe) : U && X.removeAttribute("data-highlight-language"), !1;
    }
    exportDOM() {
      let U = document.createElement("pre");
      U.setAttribute("spellcheck", "false");
      let X = this.getLanguage();
      return X && U.setAttribute("data-highlight-language", X), { element: U };
    }
    static importDOM() {
      return { code: (U) => U.textContent != null && (/\r?\n/.test(U.textContent) || l(U, "BR")) ? { conversion: _, priority: 1 } : null, div: () => ({ conversion: E, priority: 1 }), pre: () => ({ conversion: _, priority: 0 }), table: (U) => m(U) ? { conversion: T, priority: 3 } : null, td: (U) => {
        let X = U.closest("table");
        return U.classList.contains("js-file-line") ? { conversion: w, priority: 3 } : X && m(X) ? { conversion: S, priority: 3 } : null;
      }, tr: (U) => (U = U.closest("table")) && m(U) ? { conversion: S, priority: 3 } : null };
    }
    static importJSON(U) {
      let X = f(U.language);
      return X.setFormat(U.format), X.setIndent(U.indent), X.setDirection(U.direction), X;
    }
    exportJSON() {
      return { ...super.exportJSON(), language: this.getLanguage(), type: "code", version: 1 };
    }
    insertNewAfter(U, X = !0) {
      var fe = this.getChildren(), _e = fe.length;
      if (2 <= _e && fe[_e - 1].getTextContent() === `
` && fe[_e - 2].getTextContent() === `
` && U.isCollapsed() && U.anchor.key === this.__key && U.anchor.offset === _e) return fe[_e - 1].remove(), fe[_e - 2].remove(), U = n.$createParagraphNode(), this.insertAfter(U, X), U;
      let { anchor: B, focus: M } = U;
      if (X = (B.isBefore(M) ? B : M).getNode(), n.$isTextNode(X)) {
        for (_e = re(X), fe = []; ; ) if (n.$isTabNode(_e)) fe.push(n.$createTabNode()), _e = _e.getNextSibling();
        else if (j(_e)) {
          for (var F = 0, se = _e.getTextContent(), ye = _e.getTextContentSize(); F < ye && se[F] === " "; F++) ;
          if (F !== 0 && fe.push(H(" ".repeat(F))), F !== ye) break;
          _e = _e.getNextSibling();
        } else break;
        _e = X.splitText(B.offset)[0], F = B.offset === 0 ? 0 : 1, F = _e.getIndexWithinParent() + F, se = X.getParentOrThrow(), ye = [n.$createLineBreakNode(), ...fe], se.splice(F, 0, ye), (fe = fe[fe.length - 1]) ? fe.select() : B.offset === 0 ? _e.selectPrevious() : _e.getNextSibling().selectNext(0, 0);
      }
      return p(X) && ({ offset: U } = U.anchor, X.splice(U, 0, [n.$createLineBreakNode()]), X.select(U + 1, U + 1)), null;
    }
    canIndent() {
      return !1;
    }
    collapseAtStart() {
      let U = n.$createParagraphNode();
      return this.getChildren().forEach((X) => U.append(X)), this.replace(U), !0;
    }
    setLanguage(U) {
      this.getWritable().__language = r(U);
    }
    getLanguage() {
      return this.getLatest().__language;
    }
  }
  function f(R) {
    return n.$applyNodeReplacement(new d(R));
  }
  function p(R) {
    return R instanceof d;
  }
  function _(R) {
    let U;
    return t.isHTMLElement(R) && (U = R.getAttribute("data-highlight-language")), { node: f(U) };
  }
  function E(R) {
    let U = R.style.fontFamily.match("monospace") !== null;
    return U || O(R) ? { after: (X) => {
      let fe = R.parentNode;
      return fe != null && R !== fe.lastChild && X.push(n.$createLineBreakNode()), X;
    }, node: U ? f() : null } : { node: null };
  }
  function T() {
    return { node: f() };
  }
  function S() {
    return { node: null };
  }
  function w(R) {
    return { after: (U) => (R.parentNode && R.parentNode.nextSibling && U.push(n.$createLineBreakNode()), U), node: null };
  }
  function O(R) {
    for (R = R.parentElement; R !== null; ) {
      if (R.style.fontFamily.match("monospace") !== null) return !0;
      R = R.parentElement;
    }
    return !1;
  }
  function m(R) {
    return R.classList.contains("js-file-line-container");
  }
  let v = { c: "C", clike: "C-like", cpp: "C++", css: "CSS", html: "HTML", java: "Java", js: "JavaScript", markdown: "Markdown", objc: "Objective-C", plain: "Plain Text", py: "Python", rust: "Rust", sql: "SQL", swift: "Swift", typescript: "TypeScript", xml: "XML" }, I = { cpp: "cpp", java: "java", javascript: "js", md: "markdown", plaintext: "plain", python: "py", text: "plain", ts: "typescript" };
  function G(R) {
    return I[R] || R;
  }
  class k extends n.TextNode {
    constructor(U, X, fe) {
      super(U, fe), this.__highlightType = X;
    }
    static getType() {
      return "code-highlight";
    }
    static clone(U) {
      return new k(U.__text, U.__highlightType || void 0, U.__key);
    }
    getHighlightType() {
      return this.getLatest().__highlightType;
    }
    createDOM(U) {
      let X = super.createDOM(U);
      return U = P(U.theme, this.__highlightType), t.addClassNamesToElement(X, U), X;
    }
    updateDOM(U, X, fe) {
      let _e = super.updateDOM(U, X, fe);
      return U = P(fe.theme, U.__highlightType), fe = P(fe.theme, this.__highlightType), U !== fe && (U && t.removeClassNamesFromElement(
        X,
        U
      ), fe && t.addClassNamesToElement(X, fe)), _e;
    }
    static importJSON(U) {
      let X = H(U.text, U.highlightType);
      return X.setFormat(U.format), X.setDetail(U.detail), X.setMode(U.mode), X.setStyle(U.style), X;
    }
    exportJSON() {
      return { ...super.exportJSON(), highlightType: this.getHighlightType(), type: "code-highlight", version: 1 };
    }
    setFormat() {
      return this;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return f();
    }
  }
  function P(R, U) {
    return U && R && R.codeHighlight && R.codeHighlight[U];
  }
  function H(R, U) {
    return n.$applyNodeReplacement(new k(R, U));
  }
  function j(R) {
    return R instanceof k;
  }
  function re(R) {
    let U = R;
    for (; j(R) || n.$isTabNode(R); ) U = R, R = R.getPreviousSibling();
    return U;
  }
  function te(R) {
    let U = R;
    for (; j(R) || n.$isTabNode(R); ) U = R, R = R.getNextSibling();
    return U;
  }
  let ce = { defaultLanguage: "javascript", tokenize(R, U) {
    return e.tokenize(R, e.languages[U || ""] || e.languages[this.defaultLanguage]);
  } };
  function V(R, U) {
    let X = null;
    var fe = null, _e = R;
    let B = U, M = R.getTextContent();
    for (; ; ) {
      if (B === 0) {
        if (_e = _e.getPreviousSibling(), _e === null) break;
        if (!(j(_e) || n.$isTabNode(_e) || n.$isLineBreakNode(_e))) throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");
        if (n.$isLineBreakNode(_e)) {
          X = { node: _e, offset: 1 };
          break;
        }
        B = Math.max(0, _e.getTextContentSize() - 1), M = _e.getTextContent();
      } else B--;
      let F = M[B];
      j(_e) && F !== " " && (fe = { node: _e, offset: B });
    }
    if (fe !== null) return fe;
    if (fe = null, U < R.getTextContentSize() ? j(R) && (fe = R.getTextContent()[U]) : (_e = R.getNextSibling(), j(_e) && (fe = _e.getTextContent()[0])), fe !== null && fe !== " ") return X;
    e: for (fe = R, _e = R.getTextContent(), R = R.getTextContentSize(); ; ) {
      if (!j(fe) || U === R) {
        if (fe = fe.getNextSibling(), fe === null || n.$isLineBreakNode(fe)) {
          R = null;
          break e;
        }
        j(fe) && (U = 0, _e = fe.getTextContent(), R = fe.getTextContentSize());
      }
      if (j(fe)) {
        if (_e[U] !== " ") {
          R = { node: fe, offset: U };
          break e;
        }
        U++;
      }
    }
    return R !== null ? R : X;
  }
  function z(R) {
    if (R = te(R), n.$isLineBreakNode(R)) throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");
    return R;
  }
  function q(R, U, X) {
    let fe = R.getParent();
    p(fe) ? Se(fe, U, X) : j(R) && R.replace(n.$createTextNode(R.__text));
  }
  let Te = /* @__PURE__ */ new Set();
  function Se(R, U, X) {
    let fe = R.getKey();
    Te.has(fe) || (Te.add(fe), R.getLanguage() === void 0 && R.setLanguage(X.defaultLanguage), U.update(() => {
      de(fe, () => {
        var _e = n.$getNodeByKey(fe);
        if (!p(_e) || !_e.isAttached()) return !1;
        var B = _e.getTextContent();
        B = X.tokenize(B, _e.getLanguage() || X.defaultLanguage), B = Ee(B);
        var M = _e.getChildren();
        for (_e = 0; _e < M.length && K(M[_e], B[_e]); ) _e++;
        var F = M.length;
        let se = B.length, ye = Math.min(F, se) - _e, De = 0;
        for (; De < ye; ) if (De++, !K(M[F - De], B[se - De])) {
          De--;
          break;
        }
        M = _e, F -= De, B = B.slice(_e, se - De);
        let { from: ee, to: ne, nodesForReplacement: ue } = { from: M, nodesForReplacement: B, to: F };
        return ee !== ne || ue.length ? (R.splice(ee, ne - ee, ue), !0) : !1;
      });
    }, { onUpdate: () => {
      Te.delete(fe);
    }, skipTransforms: !0 }));
  }
  function Ee(R, U) {
    let X = [];
    for (let fe of R) if (typeof fe == "string") {
      R = fe.split(/(\n|\t)/);
      let _e = R.length;
      for (let B = 0; B < _e; B++) {
        let M = R[B];
        M === `
` || M === `\r
` ? X.push(n.$createLineBreakNode()) : M === "	" ? X.push(n.$createTabNode()) : 0 < M.length && X.push(H(M, U));
      }
    } else ({ content: R } = fe), typeof R == "string" ? X.push(...Ee([R], fe.type)) : Array.isArray(R) && X.push(...Ee(R, fe.type));
    return X;
  }
  function de(R, U) {
    if (R = n.$getNodeByKey(R), p(R) && R.isAttached()) {
      var X = n.$getSelection();
      if (n.$isRangeSelection(X)) {
        X = X.anchor;
        var fe = X.offset, _e = X.type === "element" && n.$isLineBreakNode(R.getChildAtIndex(X.offset - 1)), B = 0;
        if (!_e) {
          let M = X.getNode();
          B = fe + M.getPreviousSiblings().reduce((F, se) => F + se.getTextContentSize(), 0);
        }
        U() && (_e ? X.getNode().select(fe, fe) : R.getChildren().some((M) => {
          let F = n.$isTextNode(M);
          if (F || n.$isLineBreakNode(M)) {
            let se = M.getTextContentSize();
            if (F && se >= B) return M.select(B, B), !0;
            B -= se;
          }
          return !1;
        }));
      } else U();
    }
  }
  function K(R, U) {
    return j(R) && j(U) && R.__text === U.__text && R.__highlightType === U.__highlightType || n.$isTabNode(R) && n.$isTabNode(U) || n.$isLineBreakNode(R) && n.$isLineBreakNode(U);
  }
  function D(R) {
    if (!n.$isRangeSelection(R)) return !1;
    var U = R.anchor.getNode();
    return R = R.focus.getNode(), U.is(R) && p(U) ? !0 : (U = U.getParent(), p(U) && U.is(R.getParent()));
  }
  function Z(R) {
    R = R.getNodes();
    let U = [[]];
    if (R.length === 1 && p(R[0])) return U;
    let X = U[0];
    for (let fe = 0; fe < R.length; fe++) {
      let _e = R[fe];
      if (!(j(_e) || n.$isTabNode(_e) || n.$isLineBreakNode(_e))) throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");
      n.$isLineBreakNode(_e) ? fe !== 0 && 0 < X.length && (X = [], U.push(X)) : X.push(_e);
    }
    return U;
  }
  function oe(R) {
    var U = n.$getSelection();
    if (!n.$isRangeSelection(U) || !D(U)) return null;
    let X = R ? n.OUTDENT_CONTENT_COMMAND : n.INDENT_CONTENT_COMMAND;
    if (R = R ? n.OUTDENT_CONTENT_COMMAND : n.INSERT_TAB_COMMAND, 1 < Z(U).length) return X;
    var fe = U.getNodes()[0];
    if (!(p(fe) || j(fe) || n.$isTabNode(fe) || n.$isLineBreakNode(fe))) throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");
    if (p(fe)) return X;
    let _e = re(fe);
    fe = te(fe);
    var B = U.anchor;
    let M = U.focus;
    return M.isBefore(B) ? U = M : (U = B, B = M), _e !== null && fe !== null && U.key === _e.getKey() && U.offset === 0 && B.key === fe.getKey() && B.offset === fe.getTextContentSize() ? X : R;
  }
  function Y(R) {
    var U = n.$getSelection();
    if (!n.$isRangeSelection(U) || !D(U)) return !1;
    var X = Z(U);
    let fe = X.length;
    if (1 < X.length) {
      for (U = 0; U < fe; U++) {
        var _e = X[U];
        0 < _e.length && (_e = _e[0], U === 0 && (_e = re(_e)), _e !== null && (R === n.INDENT_CONTENT_COMMAND ? _e.insertBefore(n.$createTabNode()) : n.$isTabNode(_e) && _e.remove()));
      }
      return !0;
    }
    if (X = U.getNodes()[0], !(p(X) || j(X) || n.$isTabNode(X) || n.$isLineBreakNode(X))) throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");
    if (p(X)) return R === n.INDENT_CONTENT_COMMAND && U.insertNodes([n.$createTabNode()]), !0;
    if (X = re(X), X === null) throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");
    return R === n.INDENT_CONTENT_COMMAND ? n.$isLineBreakNode(X) ? X.insertAfter(n.$createTabNode()) : X.insertBefore(n.$createTabNode()) : n.$isTabNode(X) && X.remove(), !0;
  }
  function W(R, U) {
    let X = n.$getSelection();
    if (!n.$isRangeSelection(X)) return !1;
    let { anchor: fe, focus: _e } = X, B = fe.offset, M = _e.offset, F = fe.getNode(), se = _e.getNode();
    var ye = R === n.KEY_ARROW_UP_COMMAND;
    if (!D(X) || !j(F) && !n.$isTabNode(F) || !j(se) && !n.$isTabNode(se)) return !1;
    if (!U.altKey) {
      if (X.isCollapsed()) {
        if (R = F.getParentOrThrow(), ye && B === 0 && F.getPreviousSibling() === null) {
          if (R.getPreviousSibling() === null) return R.selectPrevious(), U.preventDefault(), !0;
        } else if (!ye && B === F.getTextContentSize() && F.getNextSibling() === null && R.getNextSibling() === null) return R.selectNext(), U.preventDefault(), !0;
      }
      return !1;
    }
    let De;
    if (F.isBefore(se)) {
      var ee = re(F);
      De = te(se);
    } else ee = re(se), De = te(F);
    if (ee == null || De == null) return !1;
    let ne = ee.getNodesBetween(De);
    for (let be = 0; be < ne.length; be++) {
      let Ne = ne[be];
      if (!j(Ne) && !n.$isTabNode(Ne) && !n.$isLineBreakNode(Ne)) return !1;
    }
    if (U.preventDefault(), U.stopPropagation(), U = ye ? ee.getPreviousSibling() : De.getNextSibling(), !n.$isLineBreakNode(U) || (ee = ye ? U.getPreviousSibling() : U.getNextSibling(), ee == null)) return !0;
    ye = j(ee) || n.$isTabNode(ee) || n.$isLineBreakNode(ee) ? ye ? re(ee) : te(ee) : null;
    let ue = ye ?? ee;
    return U.remove(), ne.forEach((be) => be.remove()), R === n.KEY_ARROW_UP_COMMAND ? (ne.forEach((be) => ue.insertBefore(be)), ue.insertBefore(U)) : (ue.insertAfter(U), ue = U, ne.forEach((be) => {
      ue.insertAfter(be), ue = be;
    })), X.setTextNodeRange(F, B, se, M), !0;
  }
  function J(R, U) {
    let X = n.$getSelection();
    if (!n.$isRangeSelection(X)) return !1;
    let { anchor: fe, focus: _e } = X;
    var B = fe.getNode();
    let M = _e.getNode();
    if (R = R === n.MOVE_TO_START, !j(B) && !n.$isTabNode(B) || !j(M) && !n.$isTabNode(M)) return !1;
    if (R) if (B = V(M, _e.offset), B !== null) {
      let { node: F, offset: se } = B;
      n.$isLineBreakNode(F) ? F.selectNext(0, 0) : X.setTextNodeRange(F, se, F, se);
    } else M.getParentOrThrow().selectStart();
    else z(M).select();
    return U.preventDefault(), U.stopPropagation(), !0;
  }
  return $n.$createCodeHighlightNode = H, $n.$createCodeNode = f, $n.$isCodeHighlightNode = j, $n.$isCodeNode = p, $n.CODE_LANGUAGE_FRIENDLY_NAME_MAP = v, $n.CODE_LANGUAGE_MAP = I, $n.CodeHighlightNode = k, $n.CodeNode = d, $n.DEFAULT_CODE_LANGUAGE = "javascript", $n.PrismTokenizer = ce, $n.getCodeLanguages = () => Object.keys(e.languages).filter((R) => typeof e.languages[R] != "function").sort(), $n.getDefaultCodeLanguage = () => "javascript", $n.getEndOfCodeInLine = z, $n.getFirstCodeNodeOfLine = re, $n.getLanguageFriendlyName = function(R) {
    return R = G(R), v[R] || R;
  }, $n.getLastCodeNodeOfLine = te, $n.getStartOfCodeInLine = V, $n.normalizeCodeLang = G, $n.registerCodeHighlighting = function(R, U) {
    if (!R.hasNodes([d, k])) throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
    return U == null && (U = ce), t.mergeRegister(
      R.registerMutationListener(d, (X) => {
        R.update(() => {
          for (let [B, M] of X) if (M !== "destroyed") {
            var fe = n.$getNodeByKey(B);
            if (fe !== null) e: {
              var _e = fe;
              if (fe = R.getElementByKey(_e.getKey()), fe === null) break e;
              _e = _e.getChildren();
              let F = _e.length;
              if (F === fe.__cachedChildrenLength) break e;
              fe.__cachedChildrenLength = F;
              let se = "1", ye = 1;
              for (let De = 0; De < F; De++) n.$isLineBreakNode(_e[De]) && (se += `
` + ++ye);
              fe.setAttribute("data-gutter", se);
            }
          }
        });
      }),
      R.registerNodeTransform(d, (X) => Se(X, R, U)),
      R.registerNodeTransform(n.TextNode, (X) => q(X, R, U)),
      R.registerNodeTransform(k, (X) => q(X, R, U)),
      R.registerCommand(n.KEY_TAB_COMMAND, (X) => {
        let fe = oe(X.shiftKey);
        return fe === null ? !1 : (X.preventDefault(), R.dispatchCommand(fe, void 0), !0);
      }, n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.INSERT_TAB_COMMAND, () => {
        let X = n.$getSelection();
        return D(X) ? (n.$insertNodes([n.$createTabNode()]), !0) : !1;
      }, n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.INDENT_CONTENT_COMMAND, () => Y(n.INDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.OUTDENT_CONTENT_COMMAND, () => Y(n.OUTDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.KEY_ARROW_UP_COMMAND, (X) => W(n.KEY_ARROW_UP_COMMAND, X), n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (X) => W(n.KEY_ARROW_DOWN_COMMAND, X), n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.MOVE_TO_END, (X) => J(n.MOVE_TO_END, X), n.COMMAND_PRIORITY_LOW),
      R.registerCommand(n.MOVE_TO_START, (X) => J(n.MOVE_TO_START, X), n.COMMAND_PRIORITY_LOW)
    );
  }, $n;
}
const LC = process.env.NODE_ENV === "development" ? RC() : bC();
var Zu = LC, Cd = qn();
function IC() {
  const [e] = Cd.useLexicalComposerContext();
  return tr(() => Zu.registerCodeHighlighting(e), [e]), null;
}
var rg = gn(), Fn = Yt();
function kC({
  src: e,
  altText: t,
  width: n,
  height: r,
  maxWidth: l
}) {
  const d = ip(() => ({ height: r, width: n, maxWidth: l }), [r, n, l]);
  return /* @__PURE__ */ nt.jsx("img", { src: e, alt: t, style: d });
}
function Hp({
  altText: e,
  height: t,
  maxWidth: n = 500,
  src: r,
  width: l,
  key: d
}) {
  return Fn.$applyNodeReplacement(
    new sl(r, e, n, l, t, d)
  );
}
function PC(e) {
  return e instanceof sl;
}
class sl extends Fn.DecoratorNode {
  constructor(n, r, l, d, f, p) {
    super(p);
    Ie(this, "__src");
    Ie(this, "__altText");
    Ie(this, "__width");
    Ie(this, "__height");
    Ie(this, "__maxWidth");
    this.__src = n, this.__altText = r, this.__maxWidth = l, this.__width = d || "inherit", this.__height = f || "inherit";
  }
  static getType() {
    return "image";
  }
  static clone(n) {
    return new sl(
      n.__src,
      n.__altText,
      n.__maxWidth,
      n.__width,
      n.__height,
      n.__key
    );
  }
  getSrc() {
    return this.getLatest().__src;
  }
  getAltText() {
    return this.getLatest().__altText;
  }
  /**
   * Defines the JSON Serialization strategy for an {@link ImageNode}.
   */
  exportJSON() {
    return {
      altText: this.getAltText(),
      height: this.__height === "inherit" ? 0 : this.__height,
      maxWidth: this.__maxWidth,
      src: this.getSrc(),
      type: "image",
      version: 1,
      width: this.__width === "inherit" ? 0 : this.__width
    };
  }
  /**
   * Static constructor for creating an {@link ImageNode} from a JSON serialized Node.
   */
  static importJSON(n) {
    return Hp(n);
  }
  /**
   * Inserts the {@link ImageNode}'s placeholder {@link HTMLElement} into the Lexical Dev's DOM.
   */
  createDOM(n) {
    const r = document.createElement("span"), l = n.theme.image;
    return l && (r.className = l), r;
  }
  /**
   * Since this Node will only be used in a read-only context, we don't need to worry about
   * updating the DOM when its attributes change.
   */
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ nt.jsx(
      kC,
      {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth
      }
    );
  }
}
const $C = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", FC = (e) => $C ? (e || window).getSelection() : null, Wp = Fn.createCommand(
  "INSERT_IMAGE_COMMAND"
);
function BC() {
  const [e] = Cd.useLexicalComposerContext();
  return tr(() => {
    if (!e.hasNodes([sl]))
      throw new Error("ImagePlugin: ImageNode not registered on editor");
    return rg.mergeRegister(
      e.registerCommand(
        Wp,
        (t) => {
          const n = Hp(t);
          return Fn.$insertNodes([n]), Fn.$isRootOrShadowRoot(n.getParentOrThrow()) && rg.$wrapNodeInElement(n, Fn.$createParagraphNode).selectEnd(), !0;
        },
        Fn.COMMAND_PRIORITY_EDITOR
      ),
      e.registerCommand(
        Fn.DRAGSTART_COMMAND,
        (t) => HC(t),
        Fn.COMMAND_PRIORITY_HIGH
      ),
      e.registerCommand(
        Fn.DRAGOVER_COMMAND,
        (t) => WC(t),
        Fn.COMMAND_PRIORITY_LOW
      ),
      e.registerCommand(
        Fn.DROP_COMMAND,
        (t) => KC(t, e),
        Fn.COMMAND_PRIORITY_HIGH
      )
    );
  }, [e]), null;
}
function HC(e) {
  const t = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", n = document.createElement("img");
  n.src = t;
  const r = Ed();
  if (!r)
    return !1;
  const l = e.dataTransfer;
  return l ? (l.setData("text/plain", "_"), l.setDragImage(n, 0, 0), l.setData(
    "application/x-lexical-drag",
    JSON.stringify({
      data: {
        altText: r.__altText,
        height: r.__height,
        key: r.getKey(),
        maxWidth: r.__maxWidth,
        src: r.__src,
        width: r.__width
      },
      type: "image"
    })
  ), !0) : !1;
}
function WC(e) {
  return Ed() ? (Kp(e) || e.preventDefault(), !0) : !1;
}
function KC(e, t) {
  const n = Ed();
  if (!n)
    return !1;
  const r = zC(e);
  if (!r)
    return !1;
  if (e.preventDefault(), Kp(e)) {
    const l = UC(e);
    n.remove();
    const d = Fn.$createRangeSelection();
    l != null && d.applyDOMRange(l), Fn.$setSelection(d), t.dispatchCommand(Wp, r);
  }
  return !0;
}
function Ed() {
  const e = Fn.$getSelection();
  if (!Fn.$isNodeSelection(e))
    return null;
  const n = e.getNodes()[0];
  return PC(n) ? n : null;
}
function zC(e) {
  var l;
  const t = (l = e.dataTransfer) == null ? void 0 : l.getData("application/x-lexical-drag");
  if (!t)
    return null;
  const { type: n, data: r } = JSON.parse(t);
  return n !== "image" ? null : r;
}
function Kp(e) {
  const t = e.target;
  return !!(t && t instanceof HTMLElement && !t.closest("code, span.yext-default-richtextv2-theme__image") && t.parentElement);
}
function UC(e) {
  let t;
  const n = e.target, r = n === null || !(n instanceof Node) ? null : n.nodeType === 9 ? n.defaultView : n.ownerDocument.defaultView, l = FC(r);
  if (document.caretRangeFromPoint)
    t = document.caretRangeFromPoint(e.clientX, e.clientY);
  else if (e.rangeParent && l !== null)
    l.collapse(e.rangeParent, e.rangeOffset || 0), t = l.getRangeAt(0);
  else
    throw Error("Cannot get the selection when dragging");
  return t;
}
var ro = _d();
function GC(e) {
  const t = e.getNodes();
  return t.length === 0 ? /* @__PURE__ */ new Set([
    e.anchor.getNode().getParentOrThrow(),
    e.focus.getNode().getParentOrThrow()
  ]) : new Set(
    t.map((n) => Fn.$isElementNode(n) ? n : n.getParentOrThrow())
  );
}
const YC = 3;
function jC(e) {
  const t = Fn.$getSelection();
  if (!Fn.$isRangeSelection(t))
    return !1;
  const n = GC(t);
  let r = 0;
  for (const l of n)
    if (ro.$isListNode(l))
      r = Math.max(ro.$getListDepth(l) + 1, r);
    else if (ro.$isListItemNode(l)) {
      const d = l.getParent();
      if (!ro.$isListNode(d))
        throw new Error(
          "ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent."
        );
      r = Math.max(ro.$getListDepth(d) + 1, r);
    }
  return r <= e;
}
function VC({ maxDepth: e }) {
  const [t] = Cd.useLexicalComposerContext();
  return tr(() => t.registerCommand(
    Fn.INDENT_CONTENT_COMMAND,
    () => !jC(e || 7),
    YC
  ), [t, e]), null;
}
var Mu = Nd(), ig = yd(), sg = md(), ql = {}, og;
function qC() {
  if (og) return ql;
  og = 1;
  var e = gn(), t = Yt();
  class n extends t.TextNode {
    static getType() {
      return "hashtag";
    }
    static clone(f) {
      return new n(f.__text, f.__key);
    }
    constructor(f, p) {
      super(f, p);
    }
    createDOM(f) {
      const p = super.createDOM(f);
      return e.addClassNamesToElement(p, f.theme.hashtag), p;
    }
    static importJSON(f) {
      const p = r(f.text);
      return p.setFormat(f.format), p.setDetail(f.detail), p.setMode(f.mode), p.setStyle(f.style), p;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "hashtag"
      };
    }
    canInsertTextBefore() {
      return !1;
    }
    isTextEntity() {
      return !0;
    }
  }
  function r(d = "") {
    return t.$applyNodeReplacement(new n(d));
  }
  function l(d) {
    return d instanceof n;
  }
  return ql.$createHashtagNode = r, ql.$isHashtagNode = l, ql.HashtagNode = n, ql;
}
var Zl = {}, lg;
function ZC() {
  if (lg) return Zl;
  lg = 1;
  var e = gn(), t = Yt();
  class n extends t.TextNode {
    static getType() {
      return "hashtag";
    }
    static clone(d) {
      return new n(d.__text, d.__key);
    }
    constructor(d, f) {
      super(d, f);
    }
    createDOM(d) {
      let f = super.createDOM(d);
      return e.addClassNamesToElement(f, d.theme.hashtag), f;
    }
    static importJSON(d) {
      let f = r(d.text);
      return f.setFormat(d.format), f.setDetail(d.detail), f.setMode(d.mode), f.setStyle(d.style), f;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "hashtag" };
    }
    canInsertTextBefore() {
      return !1;
    }
    isTextEntity() {
      return !0;
    }
  }
  function r(l = "") {
    return t.$applyNodeReplacement(new n(l));
  }
  return Zl.$createHashtagNode = r, Zl.$isHashtagNode = function(l) {
    return l instanceof n;
  }, Zl.HashtagNode = n, Zl;
}
const JC = process.env.NODE_ENV === "development" ? qC() : ZC();
var XC = JC;
const dt = {
  "yext-default-richtextv2-theme__ul1": "_yext-default-richtextv2-theme__ul1_13v3w_17",
  "yext-default-richtextv2-theme__ul2": "_yext-default-richtextv2-theme__ul2_13v3w_25",
  "yext-default-richtextv2-theme__ul3": "_yext-default-richtextv2-theme__ul3_13v3w_33",
  "yext-default-richtextv2-theme__ltr": "_yext-default-richtextv2-theme__ltr_13v3w_55",
  "yext-default-richtextv2-theme__rtl": "_yext-default-richtextv2-theme__rtl_13v3w_58",
  "yext-default-richtextv2-theme__paragraph": "_yext-default-richtextv2-theme__paragraph_13v3w_61",
  "yext-default-richtextv2-theme__quote": "_yext-default-richtextv2-theme__quote_13v3w_70",
  "yext-default-richtextv2-theme__h1": "_yext-default-richtextv2-theme__h1_13v3w_81",
  "yext-default-richtextv2-theme__h2": "_yext-default-richtextv2-theme__h2_13v3w_89",
  "yext-default-richtextv2-theme__h3": "_yext-default-richtextv2-theme__h3_13v3w_97",
  "yext-default-richtextv2-theme__h4": "_yext-default-richtextv2-theme__h4_13v3w_105",
  "yext-default-richtextv2-theme__h5": "_yext-default-richtextv2-theme__h5_13v3w_113",
  "yext-default-richtextv2-theme__h6": "_yext-default-richtextv2-theme__h6_13v3w_121",
  "yext-default-richtextv2-theme__textBold": "_yext-default-richtextv2-theme__textBold_13v3w_130",
  "yext-default-richtextv2-theme__textItalic": "_yext-default-richtextv2-theme__textItalic_13v3w_133",
  "yext-default-richtextv2-theme__textUnderline": "_yext-default-richtextv2-theme__textUnderline_13v3w_136",
  "yext-default-richtextv2-theme__textStrikethrough": "_yext-default-richtextv2-theme__textStrikethrough_13v3w_139",
  "yext-default-richtextv2-theme__textUnderlineStrikethrough": "_yext-default-richtextv2-theme__textUnderlineStrikethrough_13v3w_142",
  "yext-default-richtextv2-theme__textSubscript": "_yext-default-richtextv2-theme__textSubscript_13v3w_145",
  "yext-default-richtextv2-theme__textSuperscript": "_yext-default-richtextv2-theme__textSuperscript_13v3w_149",
  "yext-default-richtextv2-theme__textCode": "_yext-default-richtextv2-theme__textCode_13v3w_153",
  "yext-default-richtextv2-theme__hashtag": "_yext-default-richtextv2-theme__hashtag_13v3w_159",
  "yext-default-richtextv2-theme__link": "_yext-default-richtextv2-theme__link_13v3w_163",
  "yext-default-richtextv2-theme__code": "_yext-default-richtextv2-theme__code_13v3w_171",
  "yext-default-richtextv2-theme__table": "_yext-default-richtextv2-theme__table_13v3w_199",
  "yext-default-richtextv2-theme__tableCell": "_yext-default-richtextv2-theme__tableCell_13v3w_208",
  "yext-default-richtextv2-theme__tableCellHeader": "_yext-default-richtextv2-theme__tableCellHeader_13v3w_218",
  "yext-default-richtextv2-theme__characterLimit": "_yext-default-richtextv2-theme__characterLimit_13v3w_222",
  "yext-default-richtextv2-theme__ol1": "_yext-default-richtextv2-theme__ol1_13v3w_226",
  "yext-default-richtextv2-theme__ol2": "_yext-default-richtextv2-theme__ol2_13v3w_233",
  "yext-default-richtextv2-theme__ol3": "_yext-default-richtextv2-theme__ol3_13v3w_240",
  "yext-default-richtextv2-theme__ol4": "_yext-default-richtextv2-theme__ol4_13v3w_247",
  "yext-default-richtextv2-theme__ol5": "_yext-default-richtextv2-theme__ol5_13v3w_254",
  "yext-default-richtextv2-theme__listItem": "_yext-default-richtextv2-theme__listItem_13v3w_267",
  "yext-default-richtextv2-theme__listItemChecked": "_yext-default-richtextv2-theme__listItemChecked_13v3w_270",
  "yext-default-richtextv2-theme__listItemUnchecked": "_yext-default-richtextv2-theme__listItemUnchecked_13v3w_271",
  "yext-default-richtextv2-theme__nestedListItem": "_yext-default-richtextv2-theme__nestedListItem_13v3w_330",
  "yext-default-richtextv2-theme__tokenComment": "_yext-default-richtextv2-theme__tokenComment_13v3w_337",
  "yext-default-richtextv2-theme__tokenPunctuation": "_yext-default-richtextv2-theme__tokenPunctuation_13v3w_340",
  "yext-default-richtextv2-theme__tokenProperty": "_yext-default-richtextv2-theme__tokenProperty_13v3w_343",
  "yext-default-richtextv2-theme__tokenSelector": "_yext-default-richtextv2-theme__tokenSelector_13v3w_346",
  "yext-default-richtextv2-theme__tokenOperator": "_yext-default-richtextv2-theme__tokenOperator_13v3w_349",
  "yext-default-richtextv2-theme__tokenAttr": "_yext-default-richtextv2-theme__tokenAttr_13v3w_352",
  "yext-default-richtextv2-theme__tokenVariable": "_yext-default-richtextv2-theme__tokenVariable_13v3w_355",
  "yext-default-richtextv2-theme__tokenFunction": "_yext-default-richtextv2-theme__tokenFunction_13v3w_358",
  "yext-default-richtextv2-theme__mark": "_yext-default-richtextv2-theme__mark_13v3w_361",
  "yext-default-richtextv2-theme__markOverlap": "_yext-default-richtextv2-theme__markOverlap_13v3w_366",
  "yext-default-richtextv2-theme__embedBlock": "_yext-default-richtextv2-theme__embedBlock_13v3w_378",
  "yext-default-richtextv2-theme__embedBlockFocus": "_yext-default-richtextv2-theme__embedBlockFocus_13v3w_381",
  "yext-default-richtextv2-theme__image": "_yext-default-richtextv2-theme__image_13v3w_385"
}, QC = {
  characterLimit: dt["yext-default-richtextv2-theme__characterLimit"],
  code: dt["yext-default-richtextv2-theme__code"],
  codeHighlight: {
    atrule: dt["yext-default-richtextv2-theme__tokenAttr"],
    attr: dt["yext-default-richtextv2-theme__tokenAttr"],
    boolean: dt["yext-default-richtextv2-theme__tokenProperty"],
    builtin: dt["yext-default-richtextv2-theme__tokenSelector"],
    cdata: dt["yext-default-richtextv2-theme__tokenComment"],
    char: dt["yext-default-richtextv2-theme__tokenSelector"],
    class: dt["yext-default-richtextv2-theme__tokenFunction"],
    "class-name": dt["yext-default-richtextv2-theme__tokenFunction"],
    comment: dt["yext-default-richtextv2-theme__tokenComment"],
    constant: dt["yext-default-richtextv2-theme__tokenProperty"],
    deleted: dt["yext-default-richtextv2-theme__tokenProperty"],
    doctype: dt["yext-default-richtextv2-theme__tokenComment"],
    entity: dt["yext-default-richtextv2-theme__tokenOperator"],
    function: dt["yext-default-richtextv2-theme__tokenFunction"],
    important: dt["yext-default-richtextv2-theme__tokenVariable"],
    inserted: dt["yext-default-richtextv2-theme__tokenSelector"],
    keyword: dt["yext-default-richtextv2-theme__tokenAttr"],
    namespace: dt["yext-default-richtextv2-theme__tokenVariable"],
    number: dt["yext-default-richtextv2-theme__tokenProperty"],
    operator: dt["yext-default-richtextv2-theme__tokenOperator"],
    prolog: dt["yext-default-richtextv2-theme__tokenComment"],
    property: dt["yext-default-richtextv2-theme__tokenProperty"],
    punctuation: dt["yext-default-richtextv2-theme__tokenPunctuation"],
    regex: dt["yext-default-richtextv2-theme__tokenVariable"],
    selector: dt["yext-default-richtextv2-theme__tokenSelector"],
    string: dt["yext-default-richtextv2-theme__tokenSelector"],
    symbol: dt["yext-default-richtextv2-theme__tokenProperty"],
    tag: dt["yext-default-richtextv2-theme__tokenProperty"],
    url: dt["yext-default-richtextv2-theme__tokenOperator"],
    variable: dt["yext-default-richtextv2-theme__tokenVariable"]
  },
  embedBlock: {
    base: dt["yext-default-richtextv2-theme__embedBlock"],
    focus: dt["yext-default-richtextv2-theme__embedBlockFocus"]
  },
  hashtag: dt["yext-default-richtextv2-theme__hashtag"],
  heading: {
    h1: dt["yext-default-richtextv2-theme__h1"],
    h2: dt["yext-default-richtextv2-theme__h2"],
    h3: dt["yext-default-richtextv2-theme__h3"],
    h4: dt["yext-default-richtextv2-theme__h4"],
    h5: dt["yext-default-richtextv2-theme__h5"],
    h6: dt["yext-default-richtextv2-theme__h6"]
  },
  image: dt["yext-default-richtextv2-theme__image"],
  link: dt["yext-default-richtextv2-theme__link"],
  list: {
    listitem: dt["yext-default-richtextv2-theme__listItem"],
    listitemChecked: dt["yext-default-richtextv2-theme__listItemChecked"],
    listitemUnchecked: dt["yext-default-richtextv2-theme__listItemUnchecked"],
    nested: {
      listitem: dt["yext-default-richtextv2-theme__nestedListItem"]
    },
    olDepth: [
      dt["yext-default-richtextv2-theme__ol1"],
      dt["yext-default-richtextv2-theme__ol2"],
      dt["yext-default-richtextv2-theme__ol3"],
      dt["yext-default-richtextv2-theme__ol4"],
      dt["yext-default-richtextv2-theme__ol5"]
    ],
    ulDepth: [
      dt["yext-default-richtextv2-theme__ul1"],
      dt["yext-default-richtextv2-theme__ul2"],
      dt["yext-default-richtextv2-theme__ul3"]
    ]
  },
  ltr: dt["yext-default-richtextv2-theme__ltr"],
  mark: dt["yext-default-richtextv2-theme__mark"],
  markOverlap: dt["yext-default-richtextv2-theme__markOverlap"],
  paragraph: dt["yext-default-richtextv2-theme__paragraph"],
  quote: dt["yext-default-richtextv2-theme__quote"],
  rtl: dt["yext-default-richtextv2-theme__rtl"],
  table: dt["yext-default-richtextv2-theme__table"],
  tableCell: dt["yext-default-richtextv2-theme__tableCell"],
  tableCellHeader: dt["yext-default-richtextv2-theme__tableCellHeader"],
  text: {
    bold: dt["yext-default-richtextv2-theme__textBold"],
    code: dt["yext-default-richtextv2-theme__textCode"],
    italic: dt["yext-default-richtextv2-theme__textItalic"],
    strikethrough: dt["yext-default-richtextv2-theme__textStrikethrough"],
    subscript: dt["yext-default-richtextv2-theme__textSubscript"],
    superscript: dt["yext-default-richtextv2-theme__textSuperscript"],
    underline: dt["yext-default-richtextv2-theme__textUnderline"],
    underlineStrikethrough: dt["yext-default-richtextv2-theme__textUnderlineStrikethrough"]
  }
};
var Go = {}, Ru = {}, ag;
function eE() {
  if (ag) return Ru;
  ag = 1;
  var e = qn(), t = Yt(), n = xn;
  function r(d, f) {
    return d.getEditorState().read(() => {
      const p = t.$getNodeByKey(f);
      return p === null ? !1 : p.isSelected();
    });
  }
  function l(d) {
    const [f] = e.useLexicalComposerContext(), [p, _] = n.useState(() => r(f, d));
    n.useEffect(() => {
      let S = !0;
      const w = f.registerUpdateListener(() => {
        S && _(r(f, d));
      });
      return () => {
        S = !1, w();
      };
    }, [f, d]);
    const E = n.useCallback((S) => {
      f.update(() => {
        let w = t.$getSelection();
        t.$isNodeSelection(w) || (w = t.$createNodeSelection(), t.$setSelection(w)), t.$isNodeSelection(w) && (S ? w.add(d) : w.delete(d));
      });
    }, [f, d]), T = n.useCallback(() => {
      f.update(() => {
        const S = t.$getSelection();
        t.$isNodeSelection(S) && S.clear();
      });
    }, [f]);
    return [p, E, T];
  }
  return Ru.useLexicalNodeSelection = l, Ru;
}
var bu = {}, cg;
function tE() {
  if (cg) return bu;
  cg = 1;
  var e = qn(), t = Yt(), n = xn;
  function r(l, d) {
    return l.getEditorState().read(() => {
      let f = t.$getNodeByKey(d);
      return f === null ? !1 : f.isSelected();
    });
  }
  return bu.useLexicalNodeSelection = function(l) {
    let [d] = e.useLexicalComposerContext(), [f, p] = n.useState(() => r(d, l));
    n.useEffect(() => {
      let T = !0, S = d.registerUpdateListener(() => {
        T && p(r(d, l));
      });
      return () => {
        T = !1, S();
      };
    }, [d, l]);
    let _ = n.useCallback((T) => {
      d.update(() => {
        let S = t.$getSelection();
        t.$isNodeSelection(S) || (S = t.$createNodeSelection(), t.$setSelection(S)), t.$isNodeSelection(S) && (T ? S.add(l) : S.delete(l));
      });
    }, [d, l]), E = n.useCallback(
      () => {
        d.update(() => {
          const T = t.$getSelection();
          t.$isNodeSelection(T) && T.clear();
        });
      },
      [d]
    );
    return [f, _, E];
  }, bu;
}
var Lu, ug;
function zp() {
  return ug || (ug = 1, Lu = process.env.NODE_ENV === "development" ? eE() : tE()), Lu;
}
var dg;
function nE() {
  if (dg) return Go;
  dg = 1;
  var e = qn(), t = zp(), n = gn(), r = Yt(), l = xn;
  const d = r.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
  function f({
    nodeKey: S
  }) {
    const [w] = e.useLexicalComposerContext(), [O, m, v] = t.useLexicalNodeSelection(S), I = l.useCallback((G) => {
      if (O && r.$isNodeSelection(r.$getSelection())) {
        G.preventDefault();
        const k = r.$getNodeByKey(S);
        T(k) && k.remove();
      }
      return !1;
    }, [O, S]);
    return l.useEffect(() => n.mergeRegister(w.registerCommand(r.CLICK_COMMAND, (G) => {
      const k = w.getElementByKey(S);
      return G.target === k ? (G.shiftKey || v(), m(!O), !0) : !1;
    }, r.COMMAND_PRIORITY_LOW), w.registerCommand(r.KEY_DELETE_COMMAND, I, r.COMMAND_PRIORITY_LOW), w.registerCommand(r.KEY_BACKSPACE_COMMAND, I, r.COMMAND_PRIORITY_LOW)), [v, w, O, S, I, m]), l.useEffect(() => {
      const G = w.getElementByKey(S);
      G !== null && (G.className = O ? "selected" : "");
    }, [w, O, S]), null;
  }
  class p extends r.DecoratorNode {
    static getType() {
      return "horizontalrule";
    }
    static clone(w) {
      return new p(w.__key);
    }
    static importJSON(w) {
      return E();
    }
    static importDOM() {
      return {
        hr: () => ({
          conversion: _,
          priority: 0
        })
      };
    }
    exportJSON() {
      return {
        type: "horizontalrule",
        version: 1
      };
    }
    exportDOM() {
      return {
        element: document.createElement("hr")
      };
    }
    createDOM() {
      return document.createElement("hr");
    }
    getTextContent() {
      return `
`;
    }
    isInline() {
      return !1;
    }
    updateDOM() {
      return !1;
    }
    decorate() {
      return /* @__PURE__ */ l.createElement(f, {
        nodeKey: this.__key
      });
    }
  }
  function _() {
    return {
      node: E()
    };
  }
  function E() {
    return r.$applyNodeReplacement(new p());
  }
  function T(S) {
    return S instanceof p;
  }
  return Go.$createHorizontalRuleNode = E, Go.$isHorizontalRuleNode = T, Go.HorizontalRuleNode = p, Go.INSERT_HORIZONTAL_RULE_COMMAND = d, Go;
}
var Yo = {}, fg;
function rE() {
  if (fg) return Yo;
  fg = 1;
  var e = qn(), t = zp(), n = gn(), r = Yt(), l = xn;
  let d = r.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
  function f({ nodeKey: S }) {
    let [w] = e.useLexicalComposerContext(), [O, m, v] = t.useLexicalNodeSelection(S), I = l.useCallback((G) => (O && r.$isNodeSelection(r.$getSelection()) && (G.preventDefault(), G = r.$getNodeByKey(S), T(G) && G.remove()), !1), [O, S]);
    return l.useEffect(() => n.mergeRegister(w.registerCommand(r.CLICK_COMMAND, (G) => {
      let k = w.getElementByKey(S);
      return G.target === k ? (G.shiftKey || v(), m(!O), !0) : !1;
    }, r.COMMAND_PRIORITY_LOW), w.registerCommand(r.KEY_DELETE_COMMAND, I, r.COMMAND_PRIORITY_LOW), w.registerCommand(
      r.KEY_BACKSPACE_COMMAND,
      I,
      r.COMMAND_PRIORITY_LOW
    )), [v, w, O, S, I, m]), l.useEffect(() => {
      let G = w.getElementByKey(S);
      G !== null && (G.className = O ? "selected" : "");
    }, [w, O, S]), null;
  }
  class p extends r.DecoratorNode {
    static getType() {
      return "horizontalrule";
    }
    static clone(w) {
      return new p(w.__key);
    }
    static importJSON() {
      return E();
    }
    static importDOM() {
      return { hr: () => ({ conversion: _, priority: 0 }) };
    }
    exportJSON() {
      return { type: "horizontalrule", version: 1 };
    }
    exportDOM() {
      return { element: document.createElement("hr") };
    }
    createDOM() {
      return document.createElement("hr");
    }
    getTextContent() {
      return `
`;
    }
    isInline() {
      return !1;
    }
    updateDOM() {
      return !1;
    }
    decorate() {
      return l.createElement(f, { nodeKey: this.__key });
    }
  }
  function _() {
    return { node: E() };
  }
  function E() {
    return r.$applyNodeReplacement(new p());
  }
  function T(S) {
    return S instanceof p;
  }
  return Yo.$createHorizontalRuleNode = E, Yo.$isHorizontalRuleNode = T, Yo.HorizontalRuleNode = p, Yo.INSERT_HORIZONTAL_RULE_COMMAND = d, Yo;
}
const iE = process.env.NODE_ENV === "development" ? nE() : rE();
var sE = iE;
function oE(e, t) {
  return {
    namespace: "",
    editable: !1,
    onError: (n) => {
      throw n;
    },
    editorState: e,
    theme: t ?? QC,
    nodes: [
      sg.HeadingNode,
      XC.HashtagNode,
      sl,
      ro.ListNode,
      ro.ListItemNode,
      sg.QuoteNode,
      Zu.CodeNode,
      Zu.CodeHighlightNode,
      Mu.TableNode,
      Mu.TableCellNode,
      Mu.TableRowNode,
      ig.AutoLinkNode,
      ig.LinkNode,
      sE.HorizontalRuleNode
    ]
  };
}
const Iu = {
  "editor-inner": "_editor-inner_1mmqo_6",
  "no-border": "_no-border_1mmqo_10"
};
function cw({
  serializedAST: e,
  nodeClassNames: t
}) {
  return /* @__PURE__ */ nt.jsx(
    $N.LexicalComposer,
    {
      initialConfig: oE(e, t),
      children: /* @__PURE__ */ nt.jsx("div", { className: `${Iu["editor-inner"]} ${Iu["no-border"]}`, children: /* @__PURE__ */ nt.jsxs("div", { className: Iu["editor-inner"], children: [
        /* @__PURE__ */ nt.jsx(
          rC.RichTextPlugin,
          {
            contentEditable: /* @__PURE__ */ nt.jsx(
              lC.ContentEditable,
              {
                className: "editor-input",
                ariaLabel: "Lexical Rich Text"
              }
            ),
            ErrorBoundary: fC,
            placeholder: /* @__PURE__ */ nt.jsx("div", {})
          }
        ),
        /* @__PURE__ */ nt.jsx(IC, {}),
        /* @__PURE__ */ nt.jsx(yC.ListPlugin, {}),
        /* @__PURE__ */ nt.jsx(vC.LinkPlugin, {}),
        /* @__PURE__ */ nt.jsx(MC.TablePlugin, {}),
        /* @__PURE__ */ nt.jsx(BC, {}),
        /* @__PURE__ */ nt.jsx(VC, { maxDepth: 7 })
      ] }) })
    }
  );
}
function Td(e, t, n, r) {
  const l = e.length;
  let d = 0, f;
  if (t < 0 ? t = -t > l ? 0 : l + t : t = t > l ? l : t, n = n > 0 ? n : 0, r.length < 1e4)
    f = Array.from(r), f.unshift(t, n), [].splice.apply(e, f);
  else
    for (n && [].splice.apply(e, [t, n]); d < r.length; )
      f = r.slice(d, d + 1e4), f.unshift(t, 0), [].splice.apply(e, f), d += 1e4, t += 1e4;
}
function Jl(e, t) {
  return e.length > 0 ? (Td(e, e.length, 0, t), e) : t;
}
const hg = {}.hasOwnProperty;
function lE(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    aE(t, e[n]);
  return t;
}
function aE(e, t) {
  let n;
  for (n in t) {
    const l = (hg.call(e, n) ? e[n] : void 0) || (e[n] = {}), d = t[n];
    let f;
    for (f in d) {
      hg.call(l, f) || (l[f] = []);
      const p = d[f];
      cE(
        // @ts-expect-error Looks like a list.
        l[f],
        Array.isArray(p) ? p : p ? [p] : []
      );
    }
  }
}
function cE(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Td(e, 0, 0, r);
}
const ts = {
  plusSign: 43,
  // `+`
  caret: 94,
  // `^`
  tilde: 126
};
var gg = Object.prototype.hasOwnProperty;
function pg(e, t, n) {
  for (n of e.keys())
    if (sa(n, t)) return n;
}
function sa(e, t) {
  var n, r, l;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((r = e.length) === t.length)
        for (; r-- && sa(e[r], t[r]); ) ;
      return r === -1;
    }
    if (n === Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if (l = r, l && typeof l == "object" && (l = pg(t, l), !l) || !t.has(l)) return !1;
      return !0;
    }
    if (n === Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if (l = r[0], l && typeof l == "object" && (l = pg(t, l), !l) || !sa(r[1], t.get(l)))
          return !1;
      return !0;
    }
    if (n === ArrayBuffer)
      e = new Uint8Array(e), t = new Uint8Array(t);
    else if (n === DataView) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e.getInt8(r) === t.getInt8(r); ) ;
      return r === -1;
    }
    if (ArrayBuffer.isView(e)) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e[r] === t[r]; ) ;
      return r === -1;
    }
    if (!n || typeof e == "object") {
      r = 0;
      for (n in e)
        if (gg.call(e, n) && ++r && !gg.call(t, n) || !(n in t) || !sa(e[n], t[n])) return !1;
      return Object.keys(t).length === r;
    }
  }
  return e !== e && t !== t;
}
let Ju, Up, Gp, Yp, jp = !0;
typeof process < "u" && ({ FORCE_COLOR: Ju, NODE_DISABLE_COLORS: Up, NO_COLOR: Gp, TERM: Yp } = process.env || {}, jp = process.stdout && process.stdout.isTTY);
const Xt = {
  enabled: !Up && Gp == null && Yp !== "dumb" && (Ju != null && Ju !== "0" || jp),
  // modifiers
  reset: _n(0, 0),
  bold: _n(1, 22),
  dim: _n(2, 22),
  italic: _n(3, 23),
  underline: _n(4, 24),
  inverse: _n(7, 27),
  hidden: _n(8, 28),
  strikethrough: _n(9, 29),
  // colors
  black: _n(30, 39),
  red: _n(31, 39),
  green: _n(32, 39),
  yellow: _n(33, 39),
  blue: _n(34, 39),
  magenta: _n(35, 39),
  cyan: _n(36, 39),
  white: _n(37, 39),
  gray: _n(90, 39),
  grey: _n(90, 39),
  // background colors
  bgBlack: _n(40, 49),
  bgRed: _n(41, 49),
  bgGreen: _n(42, 49),
  bgYellow: _n(43, 49),
  bgBlue: _n(44, 49),
  bgMagenta: _n(45, 49),
  bgCyan: _n(46, 49),
  bgWhite: _n(47, 49)
};
function mg(e, t) {
  let n = 0, r, l = "", d = "";
  for (; n < e.length; n++)
    r = e[n], l += r.open, d += r.close, ~t.indexOf(r.close) && (t = t.replace(r.rgx, r.close + r.open));
  return l + t + d;
}
function uE(e, t) {
  let n = { has: e, keys: t };
  return n.reset = Xt.reset.bind(n), n.bold = Xt.bold.bind(n), n.dim = Xt.dim.bind(n), n.italic = Xt.italic.bind(n), n.underline = Xt.underline.bind(n), n.inverse = Xt.inverse.bind(n), n.hidden = Xt.hidden.bind(n), n.strikethrough = Xt.strikethrough.bind(n), n.black = Xt.black.bind(n), n.red = Xt.red.bind(n), n.green = Xt.green.bind(n), n.yellow = Xt.yellow.bind(n), n.blue = Xt.blue.bind(n), n.magenta = Xt.magenta.bind(n), n.cyan = Xt.cyan.bind(n), n.white = Xt.white.bind(n), n.gray = Xt.gray.bind(n), n.grey = Xt.grey.bind(n), n.bgBlack = Xt.bgBlack.bind(n), n.bgRed = Xt.bgRed.bind(n), n.bgGreen = Xt.bgGreen.bind(n), n.bgYellow = Xt.bgYellow.bind(n), n.bgBlue = Xt.bgBlue.bind(n), n.bgMagenta = Xt.bgMagenta.bind(n), n.bgCyan = Xt.bgCyan.bind(n), n.bgWhite = Xt.bgWhite.bind(n), n;
}
function _n(e, t) {
  let n = {
    open: `\x1B[${e}m`,
    close: `\x1B[${t}m`,
    rgx: new RegExp(`\\x1b\\[${t}m`, "g")
  };
  return function(r) {
    return this !== void 0 && this.has !== void 0 ? (~this.has.indexOf(e) || (this.has.push(e), this.keys.push(n)), r === void 0 ? this : Xt.enabled ? mg(this.keys, r + "") : r + "") : r === void 0 ? uE([e], [n]) : Xt.enabled ? mg([n], r + "") : r + "";
  };
}
function Ss() {
}
Ss.prototype = {
  diff: function(t, n) {
    var r, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, d = l.callback;
    typeof l == "function" && (d = l, l = {}), this.options = l;
    var f = this;
    function p(H) {
      return d ? (setTimeout(function() {
        d(void 0, H);
      }, 0), !0) : H;
    }
    t = this.castInput(t), n = this.castInput(n), t = this.removeEmpty(this.tokenize(t)), n = this.removeEmpty(this.tokenize(n));
    var _ = n.length, E = t.length, T = 1, S = _ + E;
    l.maxEditLength && (S = Math.min(S, l.maxEditLength));
    var w = (r = l.timeout) !== null && r !== void 0 ? r : 1 / 0, O = Date.now() + w, m = [{
      oldPos: -1,
      lastComponent: void 0
    }], v = this.extractCommon(m[0], n, t, 0);
    if (m[0].oldPos + 1 >= E && v + 1 >= _)
      return p([{
        value: this.join(n),
        count: n.length
      }]);
    var I = -1 / 0, G = 1 / 0;
    function k() {
      for (var H = Math.max(I, -T); H <= Math.min(G, T); H += 2) {
        var j = void 0, re = m[H - 1], te = m[H + 1];
        re && (m[H - 1] = void 0);
        var ce = !1;
        if (te) {
          var V = te.oldPos - H;
          ce = te && 0 <= V && V < _;
        }
        var z = re && re.oldPos + 1 < E;
        if (!ce && !z) {
          m[H] = void 0;
          continue;
        }
        if (!z || ce && re.oldPos + 1 < te.oldPos ? j = f.addToPath(te, !0, void 0, 0) : j = f.addToPath(re, void 0, !0, 1), v = f.extractCommon(j, n, t, H), j.oldPos + 1 >= E && v + 1 >= _)
          return p(dE(f, j.lastComponent, n, t, f.useLongestToken));
        m[H] = j, j.oldPos + 1 >= E && (G = Math.min(G, H - 1)), v + 1 >= _ && (I = Math.max(I, H + 1));
      }
      T++;
    }
    if (d)
      (function H() {
        setTimeout(function() {
          if (T > S || Date.now() > O)
            return d();
          k() || H();
        }, 0);
      })();
    else
      for (; T <= S && Date.now() <= O; ) {
        var P = k();
        if (P)
          return P;
      }
  },
  addToPath: function(t, n, r, l) {
    var d = t.lastComponent;
    return d && d.added === n && d.removed === r ? {
      oldPos: t.oldPos + l,
      lastComponent: {
        count: d.count + 1,
        added: n,
        removed: r,
        previousComponent: d.previousComponent
      }
    } : {
      oldPos: t.oldPos + l,
      lastComponent: {
        count: 1,
        added: n,
        removed: r,
        previousComponent: d
      }
    };
  },
  extractCommon: function(t, n, r, l) {
    for (var d = n.length, f = r.length, p = t.oldPos, _ = p - l, E = 0; _ + 1 < d && p + 1 < f && this.equals(n[_ + 1], r[p + 1]); )
      _++, p++, E++;
    return E && (t.lastComponent = {
      count: E,
      previousComponent: t.lastComponent
    }), t.oldPos = p, _;
  },
  equals: function(t, n) {
    return this.options.comparator ? this.options.comparator(t, n) : t === n || this.options.ignoreCase && t.toLowerCase() === n.toLowerCase();
  },
  removeEmpty: function(t) {
    for (var n = [], r = 0; r < t.length; r++)
      t[r] && n.push(t[r]);
    return n;
  },
  castInput: function(t) {
    return t;
  },
  tokenize: function(t) {
    return t.split("");
  },
  join: function(t) {
    return t.join("");
  }
};
function dE(e, t, n, r, l) {
  for (var d = [], f; t; )
    d.push(t), f = t.previousComponent, delete t.previousComponent, t = f;
  d.reverse();
  for (var p = 0, _ = d.length, E = 0, T = 0; p < _; p++) {
    var S = d[p];
    if (S.removed) {
      if (S.value = e.join(r.slice(T, T + S.count)), T += S.count, p && d[p - 1].added) {
        var O = d[p - 1];
        d[p - 1] = d[p], d[p] = O;
      }
    } else {
      if (!S.added && l) {
        var w = n.slice(E, E + S.count);
        w = w.map(function(v, I) {
          var G = r[T + I];
          return G.length > v.length ? G : v;
        }), S.value = e.join(w);
      } else
        S.value = e.join(n.slice(E, E + S.count));
      E += S.count, S.added || (T += S.count);
    }
  }
  var m = d[_ - 1];
  return _ > 1 && typeof m.value == "string" && (m.added || m.removed) && e.equals("", m.value) && (d[_ - 2].value += m.value, d.pop()), d;
}
var _g = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, yg = /\S/, Vp = new Ss();
Vp.equals = function(e, t) {
  return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !yg.test(e) && !yg.test(t);
};
Vp.tokenize = function(e) {
  for (var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0; n < t.length - 1; n++)
    !t[n + 1] && t[n + 2] && _g.test(t[n]) && _g.test(t[n + 2]) && (t[n] += t[n + 2], t.splice(n + 1, 2), n--);
  return t;
};
var qp = new Ss();
qp.tokenize = function(e) {
  this.options.stripTrailingCr && (e = e.replace(/\r\n/g, `
`));
  var t = [], n = e.split(/(\n|\r\n)/);
  n[n.length - 1] || n.pop();
  for (var r = 0; r < n.length; r++) {
    var l = n[r];
    r % 2 && !this.options.newlineIsToken ? t[t.length - 1] += l : (this.options.ignoreWhitespace && (l = l.trim()), t.push(l));
  }
  return t;
};
var fE = new Ss();
fE.tokenize = function(e) {
  return e.split(/(\S.+?[.!?])(?=\s+|$)/);
};
var hE = new Ss();
hE.tokenize = function(e) {
  return e.split(/([{}:;,]|\s+)/);
};
function lc(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lc = function(t) {
    return typeof t;
  } : lc = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lc(e);
}
var gE = Object.prototype.toString, aa = new Ss();
aa.useLongestToken = !0;
aa.tokenize = qp.tokenize;
aa.castInput = function(e) {
  var t = this.options, n = t.undefinedReplacement, r = t.stringifyReplacer, l = r === void 0 ? function(d, f) {
    return typeof f > "u" ? n : f;
  } : r;
  return typeof e == "string" ? e : JSON.stringify(Xu(e, null, null, l), l, "  ");
};
aa.equals = function(e, t) {
  return Ss.prototype.equals.call(aa, e.replace(/,([\r\n])/g, "$1"), t.replace(/,([\r\n])/g, "$1"));
};
function Xu(e, t, n, r, l) {
  t = t || [], n = n || [], r && (e = r(l, e));
  var d;
  for (d = 0; d < t.length; d += 1)
    if (t[d] === e)
      return n[d];
  var f;
  if (gE.call(e) === "[object Array]") {
    for (t.push(e), f = new Array(e.length), n.push(f), d = 0; d < e.length; d += 1)
      f[d] = Xu(e[d], t, n, r, l);
    return t.pop(), n.pop(), f;
  }
  if (e && e.toJSON && (e = e.toJSON()), lc(e) === "object" && e !== null) {
    t.push(e), f = {}, n.push(f);
    var p = [], _;
    for (_ in e)
      e.hasOwnProperty(_) && p.push(_);
    for (p.sort(), d = 0; d < p.length; d += 1)
      _ = p[d], f[_] = Xu(e[_], t, n, r, _);
    t.pop(), n.pop();
  } else
    f = e;
  return f;
}
var Qu = new Ss();
Qu.tokenize = function(e) {
  return e.slice();
};
Qu.join = Qu.removeEmpty = function(e) {
  return e;
};
Xt.red, Xt.grey, Xt.green;
Xt.dim().italic;
Xt.dim("→");
Xt.dim("·");
Xt.dim("↵");
function fc(e) {
  e = e.replace(/\r?\n/g, `
`);
  let t = e.match(/^[ \t]*(?=\S)/gm), n = 0, r = 1 / 0, l = (t || []).length;
  for (; n < l; n++) r = Math.min(r, t[n].length);
  return l && r ? e.replace(new RegExp(`^[ \\t]{${r}}`, "gm"), "") : e;
}
class pE extends Error {
  constructor(t = {}) {
    super(t.message), this.name = "Assertion", this.code = "ERR_ASSERTION", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.details = t.details || !1, this.generated = !!t.generated, this.operator = t.operator, this.expects = t.expects, this.actual = t.actual;
  }
}
function ii(e, t, n, r, l, d, f) {
  if (e) return;
  let p = f || d;
  if (f instanceof Error) throw f;
  let _ = l;
  throw new pE({ actual: t, expects: n, operator: r, message: p, details: _, generated: !f });
}
function xc(e, t) {
  ii(!!e, !1, !0, "ok", !1, "Expected value to be truthy", t);
}
function ns(e, t) {
  ii(!e, !0, !1, "not", !1, "Expected value to be falsey", t);
}
ns.ok = ns;
ns.equal = function(e, t, n) {
  ii(!sa(e, t), e, t, "not.equal", !1, "Expected values not to be deeply equal", n);
};
ns.type = function(e, t, n) {
  let r = typeof e;
  ii(r !== t, r, t, "not.type", !1, `Expected "${r}" not to be "${t}"`, n);
};
ns.instance = function(e, t, n) {
  let r = "`" + (t.name || t.constructor.name) + "`";
  ii(!(e instanceof t), e, t, "not.instance", !1, `Expected value not to be an instance of ${r}`, n);
};
ns.snapshot = function(e, t, n) {
  e = fc(e), t = fc(t), ii(e !== t, e, t, "not.snapshot", !1, "Expected value not to match snapshot", n);
};
ns.fixture = function(e, t, n) {
  e = fc(e), t = fc(t), ii(e !== t, e, t, "not.fixture", !1, "Expected value not to match fixture", n);
};
ns.match = function(e, t, n) {
  typeof t == "string" ? ii(!e.includes(t), e, t, "not.match", !1, `Expected value not to include "${t}" substring`, n) : ii(!t.test(e), e, t, "not.match", !1, `Expected value not to match \`${String(t)}\` pattern`, n);
};
ns.throws = function(e, t, n) {
  !n && typeof t == "string" && (n = t, t = null);
  try {
    e();
  } catch (r) {
    typeof t == "function" ? ii(!t(r), !0, !1, "not.throws", !1, "Expected function not to throw matching exception", n) : t instanceof RegExp ? ii(!t.test(r.message), !0, !1, "not.throws", !1, `Expected function not to throw exception matching \`${String(t)}\` pattern`, n) : t || ii(!1, !0, !1, "not.throws", !1, "Expected function not to throw", n);
  }
};
const mE = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, uw = ws(/[A-Za-z]/), Ng = ws(/[\dA-Za-z]/), dw = ws(/[#-'*+\--9=?A-Z^-~]/);
function fw(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const hw = ws(/\d/), gw = ws(/[\dA-Fa-f]/), pw = ws(/[!-/:-@[-`{-~]/);
function mw(e) {
  return e !== null && e < -2;
}
function _E(e) {
  return e !== null && (e < 0 || e === 32);
}
function _w(e) {
  return e === -2 || e === -1 || e === 32;
}
const yE = ws(mE), NE = ws(/\s/);
function ws(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function hc(e) {
  if (e === null || _E(e) || NE(e))
    return 1;
  if (yE(e))
    return 2;
}
const gc = {
  characterGroupPunctuation: 2
};
function CE(e, t) {
  const n = this.previous, r = hc(n);
  return l;
  function l(f) {
    return xc(f === ts.tilde, "expected `~`"), e.enter("tildeSequenceTemporary"), d(f);
  }
  function d(f) {
    if (f === ts.tilde)
      return e.consume(f), d;
    const p = e.exit("tildeSequenceTemporary"), _ = hc(f);
    return p._open = !_ || _ === gc.characterGroupPunctuation && !!r, p._close = !r || r === gc.characterGroupPunctuation && !!_, t(f);
  }
}
function EE(e, t, n) {
  const r = [];
  let l = -1;
  for (; ++l < e.length; ) {
    const d = e[l].resolveAll;
    d && !r.includes(d) && (t = d(t, n), r.push(d));
  }
  return t;
}
const TE = {
  // Generic type for data, such as in a title, a destination, etc.
  data: "data"
};
function xd(e, t) {
  return !!(e[0] === "enter" && e[1].type === `${t}SequenceTemporary` && e[1]._close);
}
function vd(e, t) {
  return !!(e[0] === "exit" && e[1].type === `${t}SequenceTemporary` && e[1]._open);
}
function Sd(e, t, n, r, l, d) {
  const [f, p, _, E] = xE(
    e[t],
    e[n],
    l,
    d
  );
  e[t][1].end = Object.assign({}, f.start), e[n][1].start = Object.assign({}, p.end);
  let T = [];
  e[t][1].end.offset - e[t][1].start.offset && (T = Jl(T, [
    ["enter", e[t][1], r],
    ["exit", e[t][1], r]
  ])), T = Jl(T, [
    ["enter", E, r],
    ["enter", f, r],
    ["exit", f, r],
    ["enter", _, r]
  ]), T = Jl(
    T,
    EE(
      r.parser.constructs.insideSpan.null,
      e.slice(t + 1, n),
      r
    )
  ), T = Jl(T, [
    ["exit", _, r],
    ["enter", p, r],
    ["exit", p, r],
    ["exit", E, r]
  ]);
  let S = 0;
  return e[n][1].end.offset - e[n][1].start.offset && (S = 2, T = Jl(T, [
    ["enter", e[n][1], r],
    ["exit", e[n][1], r]
  ])), Td(e, t - 1, n - t + 3, T), t + T.length - S - 2;
}
function xE(e, t, n, r) {
  const l = Object.assign({}, e[1].end), d = Object.assign({}, t[1].start);
  Cg(l, -r), Cg(d, r);
  const f = {
    type: `${n}Sequence`,
    start: l,
    end: Object.assign({}, e[1].end)
  }, p = {
    type: `${n}Sequence`,
    start: Object.assign({}, t[1].start),
    end: d
  }, _ = {
    type: `${n}Text`,
    start: Object.assign({}, e[1].end),
    end: Object.assign({}, t[1].start)
  }, E = {
    type: `${n}`,
    start: Object.assign({}, f.start),
    end: Object.assign({}, p.end)
  };
  return [f, p, _, E];
}
function Cg(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
function wd(e, t) {
  e.forEach((n) => {
    n[1].type === `${t}SequenceTemporary` && (n[1].type = TE.data);
  });
}
function vE(e, t) {
  let n = -1;
  for (; ++n < e.length; )
    if (xd(e[n], "tilde")) {
      let r = n;
      for (; r--; )
        if (vd(e[r], "tilde")) {
          const l = SE(e[r], e[n]);
          n = Sd(
            e,
            r,
            n,
            t,
            l === 1 ? "subscript" : "strikethrough",
            l
          );
          break;
        }
    }
  return wd(e, "tilde"), e;
}
function SE(e, t) {
  const n = e[1].end.offset - e[1].start.offset, r = t[1].end.offset - t[1].start.offset;
  return n < 3 || r < 3 ? r < n ? r : n : r % 2 === 0 ? 2 : 1;
}
function wE() {
  const e = {
    tokenize: CE,
    resolveAll: vE
  };
  return {
    text: { [ts.tilde]: e },
    insideSpan: { null: [e] }
  };
}
function OE(e, t) {
  let n = -1;
  for (; ++n < e.length; )
    if (xd(e[n], "superscript")) {
      let r = n;
      for (; r--; )
        if (vd(e[r], "superscript")) {
          n = Sd(
            e,
            r,
            n,
            t,
            "superscript",
            1
          );
          break;
        }
    }
  return wd(e, "superscript"), e;
}
function DE(e, t) {
  return n;
  function n(l) {
    return xc(l === ts.caret, "expected `^`"), e.enter("superscriptSequenceTemporary"), r(l);
  }
  function r(l) {
    if (l === ts.caret)
      return e.consume(l), r;
    const d = e.exit("superscriptSequenceTemporary");
    return d._open = !0, d._close = !0, t(l);
  }
}
function AE() {
  const e = {
    tokenize: DE,
    resolveAll: OE
  };
  return {
    text: { [ts.caret]: e },
    insideSpan: { null: [e] }
  };
}
function ME(e, t, n) {
  const r = this.previous, l = hc(r);
  let d = 0;
  return f;
  function f(_) {
    return xc(_ === ts.plusSign, "expected `+`"), e.enter("underlineSequenceTemporary"), p(_);
  }
  function p(_) {
    if (_ === ts.plusSign)
      return e.consume(_), d++, p;
    if (d < 2)
      return n(_);
    const E = e.exit("underlineSequenceTemporary"), T = hc(_);
    return E._open = !T || T === gc.characterGroupPunctuation && !!l, E._close = !l || l === gc.characterGroupPunctuation && !!T, t(_);
  }
}
function RE(e, t) {
  let n = -1;
  for (; ++n < e.length; )
    if (xd(e[n], "underline") && e[n][1].end.offset - e[n][1].start.offset > 1) {
      let r = n;
      for (; r--; )
        if (vd(e[r], "underline") && e[r][1].end.offset - e[r][1].start.offset > 1) {
          n = Sd(
            e,
            r,
            n,
            t,
            "underline",
            2
          );
          break;
        }
    }
  return wd(e, "underline"), e;
}
function bE() {
  const e = {
    tokenize: ME,
    resolveAll: RE
  };
  return {
    text: { [ts.plusSign]: e },
    insideSpan: { null: [e] }
  };
}
function LE() {
  return lE([
    bE(),
    AE(),
    wE()
  ]);
}
const IE = {
  canContainEols: ["strikethrough"],
  enter: { strikethrough: kE },
  exit: { strikethrough: PE }
};
function kE(e) {
  this.enter({ type: "strikethrough", children: [] }, e);
}
function PE(e) {
  this.exit(e);
}
const $E = {
  canContainEols: ["subscript"],
  enter: { subscript: FE },
  exit: { subscript: BE }
};
function FE(e) {
  this.enter({ type: "subscript", children: [] }, e);
}
function BE(e) {
  this.exit(e);
}
const HE = {
  canContainEols: ["superscript"],
  enter: { superscript: WE },
  exit: { superscript: KE }
};
function WE(e) {
  this.enter({ type: "superscript", children: [] }, e);
}
function KE(e) {
  this.exit(e);
}
const zE = {
  canContainEols: ["underline"],
  enter: { underline: UE },
  exit: { underline: GE }
};
function UE(e) {
  this.enter({ type: "underline", children: [] }, e);
}
function GE(e) {
  this.exit(e);
}
function YE() {
  return [
    zE,
    IE,
    $E,
    HE
  ];
}
function jE() {
  const e = this.data();
  t("micromarkExtensions", LE()), t("fromMarkdownExtensions", YE());
  function t(n, r) {
    const l = e[n];
    l ? (xc(Array.isArray(l)), l.push(r)) : e[n] = [r];
  }
}
function VE(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function qE(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function ZE(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, l = {};
  r && (l.className = ["language-" + r]);
  let d = {
    type: "element",
    tagName: "code",
    properties: l,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (d.data = { meta: t.meta }), e.patch(t, d), d = e.applyData(t, d), d = { type: "element", tagName: "pre", properties: {}, children: [d] }, e.patch(t, d), d;
}
function JE(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function XE(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function da(e) {
  const t = [];
  let n = -1, r = 0, l = 0;
  for (; ++n < e.length; ) {
    const d = e.charCodeAt(n);
    let f = "";
    if (d === 37 && Ng(e.charCodeAt(n + 1)) && Ng(e.charCodeAt(n + 2)))
      l = 2;
    else if (d < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(d)) || (f = String.fromCharCode(d));
    else if (d > 55295 && d < 57344) {
      const p = e.charCodeAt(n + 1);
      d < 56320 && p > 56319 && p < 57344 ? (f = String.fromCharCode(d, p), l = 1) : f = "�";
    } else
      f = String.fromCharCode(d);
    f && (t.push(e.slice(r, n), encodeURIComponent(f)), r = n + l + 1, f = ""), l && (n += l, l = 0);
  }
  return t.join("") + e.slice(r);
}
function Zp(e, t) {
  const n = String(t.identifier).toUpperCase(), r = da(n.toLowerCase()), l = e.footnoteOrder.indexOf(n);
  let d;
  l === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, d = e.footnoteOrder.length) : (e.footnoteCounts[n]++, d = l + 1);
  const f = e.footnoteCounts[n], p = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (f > 1 ? "-" + f : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(d) }]
  };
  e.patch(t, p);
  const _ = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [p]
  };
  return e.patch(t, _), e.applyData(t, _);
}
function QE(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; ) r++;
  const l = String(r);
  return n[l] = {
    type: "footnoteDefinition",
    identifier: l,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, Zp(e, {
    type: "footnoteReference",
    identifier: l,
    position: t.position
  });
}
function eT(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function tT(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function Jp(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const l = e.all(t), d = l[0];
  d && d.type === "text" ? d.value = "[" + d.value : l.unshift({ type: "text", value: "[" });
  const f = l[l.length - 1];
  return f && f.type === "text" ? f.value += r : l.push({ type: "text", value: r }), l;
}
function nT(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Jp(e, t);
  const r = { src: da(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const l = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, l), e.applyData(t, l);
}
function rT(e, t) {
  const n = { src: da(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function iT(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function sT(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Jp(e, t);
  const r = { href: da(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function oT(e, t) {
  const n = { href: da(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function lT(e, t, n) {
  const r = e.all(t), l = n ? aT(n) : Xp(t), d = {}, f = [];
  if (typeof t.checked == "boolean") {
    const T = r[0];
    let S;
    T && T.type === "element" && T.tagName === "p" ? S = T : (S = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(S)), S.children.length > 0 && S.children.unshift({ type: "text", value: " " }), S.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), d.className = ["task-list-item"];
  }
  let p = -1;
  for (; ++p < r.length; ) {
    const T = r[p];
    (l || p !== 0 || T.type !== "element" || T.tagName !== "p") && f.push({ type: "text", value: `
` }), T.type === "element" && T.tagName === "p" && !l ? f.push(...T.children) : f.push(T);
  }
  const _ = r[r.length - 1];
  _ && (l || _.type !== "element" || _.tagName !== "p") && f.push({ type: "text", value: `
` });
  const E = { type: "element", tagName: "li", properties: d, children: f };
  return e.patch(t, E), e.applyData(t, E);
}
function aT(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Xp(n[r]);
  }
  return t;
}
function Xp(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function cT(e, t) {
  const n = {}, r = e.all(t);
  let l = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++l < r.length; ) {
    const f = r[l];
    if (f.type === "element" && f.tagName === "li" && f.properties && Array.isArray(f.properties.className) && f.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const d = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function uT(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function dT(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function fT(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Od = Qp("start"), Dd = Qp("end");
function hT(e) {
  return { start: Od(e), end: Dd(e) };
}
function Qp(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function gT(e, t) {
  const n = e.all(t), r = n.shift(), l = [];
  if (r) {
    const f = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], f), l.push(f);
  }
  if (n.length > 0) {
    const f = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, p = Od(t.children[1]), _ = Dd(t.children[t.children.length - 1]);
    p.line && _.line && (f.position = { start: p, end: _ }), l.push(f);
  }
  const d = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function pT(e, t, n) {
  const r = n ? n.children : void 0, d = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", f = n && n.type === "table" ? n.align : void 0, p = f ? f.length : t.children.length;
  let _ = -1;
  const E = [];
  for (; ++_ < p; ) {
    const S = t.children[_], w = {}, O = f ? f[_] : void 0;
    O && (w.align = O);
    let m = { type: "element", tagName: d, properties: w, children: [] };
    S && (m.children = e.all(S), e.patch(S, m), m = e.applyData(t, m)), E.push(m);
  }
  const T = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(E, !0)
  };
  return e.patch(t, T), e.applyData(t, T);
}
function mT(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Eg = 9, Tg = 32;
function _T(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), l = 0;
  const d = [];
  for (; r; )
    d.push(
      xg(t.slice(l, r.index), l > 0, !0),
      r[0]
    ), l = r.index + r[0].length, r = n.exec(t);
  return d.push(xg(t.slice(l), l > 0, !1)), d.join("");
}
function xg(e, t, n) {
  let r = 0, l = e.length;
  if (t) {
    let d = e.codePointAt(r);
    for (; d === Eg || d === Tg; )
      r++, d = e.codePointAt(r);
  }
  if (n) {
    let d = e.codePointAt(l - 1);
    for (; d === Eg || d === Tg; )
      l--, d = e.codePointAt(l - 1);
  }
  return l > r ? e.slice(r, l) : "";
}
function yT(e, t) {
  const n = { type: "text", value: _T(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function NT(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const CT = {
  blockquote: VE,
  break: qE,
  code: ZE,
  delete: JE,
  emphasis: XE,
  footnoteReference: Zp,
  footnote: QE,
  heading: eT,
  html: tT,
  imageReference: nT,
  image: rT,
  inlineCode: iT,
  linkReference: sT,
  link: oT,
  listItem: lT,
  list: cT,
  paragraph: uT,
  root: dT,
  strong: fT,
  table: gT,
  tableCell: mT,
  tableRow: pT,
  text: yT,
  thematicBreak: NT,
  toml: ec,
  yaml: ec,
  definition: ec,
  footnoteDefinition: ec
};
function ec() {
  return null;
}
const em = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return vT;
    if (typeof e == "string")
      return xT(e);
    if (typeof e == "object")
      return Array.isArray(e) ? ET(e) : TT(e);
    if (typeof e == "function")
      return vc(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function ET(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = em(e[n]);
  return vc(r);
  function r(...l) {
    let d = -1;
    for (; ++d < t.length; )
      if (t[d].call(this, ...l)) return !0;
    return !1;
  }
}
function TT(e) {
  return vc(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r]) return !1;
    return !0;
  }
}
function xT(e) {
  return vc(t);
  function t(n) {
    return n && n.type === e;
  }
}
function vc(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function vT() {
  return !0;
}
const ST = !0, vg = !1, wT = "skip", OT = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const l = em(t), d = r ? -1 : 1;
    f(e, void 0, [])();
    function f(p, _, E) {
      const T = p && typeof p == "object" ? p : {};
      if (typeof T.type == "string") {
        const w = (
          // `hast`
          typeof T.tagName == "string" ? T.tagName : (
            // `xast`
            typeof T.name == "string" ? T.name : void 0
          )
        );
        Object.defineProperty(S, "name", {
          value: "node (" + (p.type + (w ? "<" + w + ">" : "")) + ")"
        });
      }
      return S;
      function S() {
        let w = [], O, m, v;
        if ((!t || l(p, _, E[E.length - 1] || null)) && (w = DT(n(p, E)), w[0] === vg))
          return w;
        if (p.children && w[0] !== wT)
          for (m = (r ? p.children.length : -1) + d, v = E.concat(p); m > -1 && m < p.children.length; ) {
            if (O = f(p.children[m], m, v)(), O[0] === vg)
              return O;
            m = typeof O[1] == "number" ? O[1] : m + d;
          }
        return w;
      }
    }
  }
);
function DT(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [ST, e] : [e];
}
const tm = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), OT(e, t, l, r);
    function l(d, f) {
      const p = f[f.length - 1];
      return n(
        d,
        p ? p.children.indexOf(d) : null,
        p
      );
    }
  }
);
function AT(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const Sg = {}.hasOwnProperty;
function MT(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return tm(e, "definition", (r) => {
    const l = wg(r.identifier);
    l && !Sg.call(t, l) && (t[l] = r);
  }), n;
  function n(r) {
    const l = wg(r);
    return l && Sg.call(t, l) ? t[l] : null;
  }
}
function wg(e) {
  return String(e || "").toUpperCase();
}
const pc = {}.hasOwnProperty;
function yw(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, l = {};
  return f.dangerous = r, f.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, f.footnoteLabel = n.footnoteLabel || "Footnotes", f.footnoteLabelTagName = n.footnoteLabelTagName || "h2", f.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, f.footnoteBackLabel = n.footnoteBackLabel || "Back to content", f.unknownHandler = n.unknownHandler, f.passThrough = n.passThrough, f.handlers = { ...CT, ...n.handlers }, f.definition = MT(e), f.footnoteById = l, f.footnoteOrder = [], f.footnoteCounts = {}, f.patch = RT, f.applyData = bT, f.one = p, f.all = _, f.wrap = IT, f.augment = d, tm(e, "footnoteDefinition", (E) => {
    const T = String(E.identifier).toUpperCase();
    pc.call(l, T) || (l[T] = E);
  }), f;
  function d(E, T) {
    if (E && "data" in E && E.data) {
      const S = E.data;
      S.hName && (T.type !== "element" && (T = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), T.tagName = S.hName), T.type === "element" && S.hProperties && (T.properties = { ...T.properties, ...S.hProperties }), "children" in T && T.children && S.hChildren && (T.children = S.hChildren);
    }
    if (E) {
      const S = "type" in E ? E : { position: E };
      AT(S) || (T.position = { start: Od(S), end: Dd(S) });
    }
    return T;
  }
  function f(E, T, S, w) {
    return Array.isArray(S) && (w = S, S = {}), d(E, {
      type: "element",
      tagName: T,
      properties: S || {},
      children: w || []
    });
  }
  function p(E, T) {
    return nm(f, E, T);
  }
  function _(E) {
    return is(f, E);
  }
}
function RT(e, t) {
  e.position && (t.position = hT(e));
}
function bT(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, l = e.data.hChildren, d = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && d && (n.properties = { ...n.properties, ...d }), "children" in n && n.children && l !== null && l !== void 0 && (n.children = l);
  }
  return n;
}
function nm(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return pc.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: is(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : LT(e, t);
}
function is(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let l = -1;
    for (; ++l < r.length; ) {
      const d = nm(e, r[l], t);
      if (d) {
        if (l && r[l - 1].type === "break" && (!Array.isArray(d) && d.type === "text" && (d.value = d.value.replace(/^\s+/, "")), !Array.isArray(d) && d.type === "element")) {
          const f = d.children[0];
          f && f.type === "text" && (f.value = f.value.replace(/^\s+/, ""));
        }
        Array.isArray(d) ? n.push(...d) : n.push(d);
      }
    }
  }
  return n;
}
function LT(e, t) {
  const n = t.data || {}, r = "value" in t && !(pc.call(n, "hProperties") || pc.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: is(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function IT(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
const kT = (e, t) => e(t, "i", is(e, t)), PT = (e, t) => e(t, "b", is(e, t)), $T = (e, t) => e(t, "u", is(e, t)), FT = (e, t) => e(t, "s", is(e, t)), BT = (e, t) => e(t, "sub", is(e, t)), HT = (e, t) => e(t, "sup", is(e, t)), WT = {
  emphasis: kT,
  strong: PT,
  underline: $T,
  strikethrough: FT,
  subscript: BT,
  superscript: HT
}, Nw = (e) => {
  const [t, n] = Nr();
  let r;
  return tr(() => {
    (async () => {
      if (!r)
        try {
          r = (await import("./index-B_gmZeUL.js")).default;
        } catch {
          throw new Error(
            "Failed to import React Markdown, cannot properly render LegacyRichText."
          );
        }
      const d = r({
        children: e.markdown,
        remarkPlugins: [jE],
        remarkRehypeOptions: {
          handlers: WT
        }
      });
      n(d);
    })();
  }, [e.markdown]), t || null;
};
class ho extends Error {
}
class KT extends ho {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class zT extends ho {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class UT extends ho {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Jo extends ho {
}
class rm extends ho {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class _r extends ho {
}
class Ns extends ho {
  constructor() {
    super("Zone is an abstract class");
  }
}
const lt = "numeric", yi = "short", Vr = "long", mc = {
  year: lt,
  month: lt,
  day: lt
}, im = {
  year: lt,
  month: yi,
  day: lt
}, GT = {
  year: lt,
  month: yi,
  day: lt,
  weekday: yi
}, sm = {
  year: lt,
  month: Vr,
  day: lt
}, om = {
  year: lt,
  month: Vr,
  day: lt,
  weekday: Vr
}, lm = {
  hour: lt,
  minute: lt
}, am = {
  hour: lt,
  minute: lt,
  second: lt
}, cm = {
  hour: lt,
  minute: lt,
  second: lt,
  timeZoneName: yi
}, um = {
  hour: lt,
  minute: lt,
  second: lt,
  timeZoneName: Vr
}, dm = {
  hour: lt,
  minute: lt,
  hourCycle: "h23"
}, fm = {
  hour: lt,
  minute: lt,
  second: lt,
  hourCycle: "h23"
}, hm = {
  hour: lt,
  minute: lt,
  second: lt,
  hourCycle: "h23",
  timeZoneName: yi
}, gm = {
  hour: lt,
  minute: lt,
  second: lt,
  hourCycle: "h23",
  timeZoneName: Vr
}, pm = {
  year: lt,
  month: lt,
  day: lt,
  hour: lt,
  minute: lt
}, mm = {
  year: lt,
  month: lt,
  day: lt,
  hour: lt,
  minute: lt,
  second: lt
}, _m = {
  year: lt,
  month: yi,
  day: lt,
  hour: lt,
  minute: lt
}, ym = {
  year: lt,
  month: yi,
  day: lt,
  hour: lt,
  minute: lt,
  second: lt
}, YT = {
  year: lt,
  month: yi,
  day: lt,
  weekday: yi,
  hour: lt,
  minute: lt
}, Nm = {
  year: lt,
  month: Vr,
  day: lt,
  hour: lt,
  minute: lt,
  timeZoneName: yi
}, Cm = {
  year: lt,
  month: Vr,
  day: lt,
  hour: lt,
  minute: lt,
  second: lt,
  timeZoneName: yi
}, Em = {
  year: lt,
  month: Vr,
  day: lt,
  weekday: Vr,
  hour: lt,
  minute: lt,
  timeZoneName: Vr
}, Tm = {
  year: lt,
  month: Vr,
  day: lt,
  weekday: Vr,
  hour: lt,
  minute: lt,
  second: lt,
  timeZoneName: Vr
};
class fa {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Ns();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Ns();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Ns();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new Ns();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new Ns();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new Ns();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new Ns();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Ns();
  }
}
let ku = null;
class Sc extends fa {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return ku === null && (ku = new Sc()), ku;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: r }) {
    return Rm(t, n, r);
  }
  /** @override **/
  formatOffset(t, n) {
    return oa(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let ac = {};
function jT(e) {
  return ac[e] || (ac[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), ac[e];
}
const VT = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function qT(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, l, d, f, p, _, E, T] = r;
  return [f, l, d, p, _, E, T];
}
function ZT(e, t) {
  const n = e.formatToParts(t), r = [];
  for (let l = 0; l < n.length; l++) {
    const { type: d, value: f } = n[l], p = VT[d];
    d === "era" ? r[p] = f : bt(p) || (r[p] = parseInt(f, 10));
  }
  return r;
}
let tc = {};
class rs extends fa {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return tc[t] || (tc[t] = new rs(t)), tc[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    tc = {}, ac = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = rs.isValidZone(t);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, { format: n, locale: r }) {
    return Rm(t, n, r, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return oa(this.offset(t), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    const n = new Date(t);
    if (isNaN(n)) return NaN;
    const r = jT(this.name);
    let [l, d, f, p, _, E, T] = r.formatToParts ? ZT(r, n) : qT(r, n);
    p === "BC" && (l = -Math.abs(l) + 1);
    const w = Oc({
      year: l,
      month: d,
      day: f,
      hour: _ === 24 ? 0 : _,
      minute: E,
      second: T,
      millisecond: 0
    });
    let O = +n;
    const m = O % 1e3;
    return O -= m >= 0 ? m : 1e3 + m, (w - O) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let Og = {};
function JT(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = Og[n];
  return r || (r = new Intl.ListFormat(e, t), Og[n] = r), r;
}
let ed = {};
function td(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = ed[n];
  return r || (r = new Intl.DateTimeFormat(e, t), ed[n] = r), r;
}
let nd = {};
function XT(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = nd[n];
  return r || (r = new Intl.NumberFormat(e, t), nd[n] = r), r;
}
let rd = {};
function QT(e, t = {}) {
  const { base: n, ...r } = t, l = JSON.stringify([e, r]);
  let d = rd[l];
  return d || (d = new Intl.RelativeTimeFormat(e, t), rd[l] = d), d;
}
let ta = null;
function ex() {
  return ta || (ta = new Intl.DateTimeFormat().resolvedOptions().locale, ta);
}
let Dg = {};
function tx(e) {
  let t = Dg[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, Dg[e] = t;
  }
  return t;
}
function nx(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let r, l;
    try {
      r = td(e).resolvedOptions(), l = e;
    } catch {
      const _ = e.substring(0, n);
      r = td(_).resolvedOptions(), l = _;
    }
    const { numberingSystem: d, calendar: f } = r;
    return [l, d, f];
  }
}
function rx(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function ix(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const r = xt.utc(2009, n, 1);
    t.push(e(r));
  }
  return t;
}
function sx(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const r = xt.utc(2016, 11, 13 + n);
    t.push(e(r));
  }
  return t;
}
function nc(e, t, n, r) {
  const l = e.listingMode();
  return l === "error" ? null : l === "en" ? n(t) : r(t);
}
function ox(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class lx {
  constructor(t, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: l, floor: d, ...f } = r;
    if (!n || Object.keys(f).length > 0) {
      const p = { useGrouping: !1, ...r };
      r.padTo > 0 && (p.minimumIntegerDigits = r.padTo), this.inf = XT(t, p);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : Ld(t, 3);
      return Kn(n, this.padTo);
    }
  }
}
class ax {
  constructor(t, n, r) {
    this.opts = r, this.originalZone = void 0;
    let l;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const f = -1 * (t.offset / 60), p = f >= 0 ? `Etc/GMT+${f}` : `Etc/GMT${f}`;
      t.offset !== 0 && rs.create(p).valid ? (l = p, this.dt = t) : (l = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, l = t.zone.name) : (l = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const d = { ...this.opts };
    d.timeZone = d.timeZone || l, this.dtf = td(n, d);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const r = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: r
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class cx {
  constructor(t, n, r) {
    this.opts = { style: "long", ...r }, !n && Am() && (this.rtf = QT(t, r));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : bx(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const ux = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class cn {
  static fromOpts(t) {
    return cn.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, r, l, d = !1) {
    const f = t || Rn.defaultLocale, p = f || (d ? "en-US" : ex()), _ = n || Rn.defaultNumberingSystem, E = r || Rn.defaultOutputCalendar, T = id(l) || Rn.defaultWeekSettings;
    return new cn(p, _, E, T, f);
  }
  static resetCache() {
    ta = null, ed = {}, nd = {}, rd = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: r, weekSettings: l } = {}) {
    return cn.create(t, n, r, l);
  }
  constructor(t, n, r, l, d) {
    const [f, p, _] = nx(t);
    this.locale = f, this.numberingSystem = n || p || null, this.outputCalendar = r || _ || null, this.weekSettings = l, this.intl = rx(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = d, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = ox(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : cn.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      id(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return nc(this, t, Im, () => {
      const r = n ? { month: t, day: "numeric" } : { month: t }, l = n ? "format" : "standalone";
      return this.monthsCache[l][t] || (this.monthsCache[l][t] = ix((d) => this.extract(d, r, "month"))), this.monthsCache[l][t];
    });
  }
  weekdays(t, n = !1) {
    return nc(this, t, $m, () => {
      const r = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, l = n ? "format" : "standalone";
      return this.weekdaysCache[l][t] || (this.weekdaysCache[l][t] = sx(
        (d) => this.extract(d, r, "weekday")
      )), this.weekdaysCache[l][t];
    });
  }
  meridiems() {
    return nc(
      this,
      void 0,
      () => Fm,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [xt.utc(2016, 11, 13, 9), xt.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return nc(this, t, Bm, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [xt.utc(-40, 1, 1), xt.utc(2017, 1, 1)].map(
        (r) => this.extract(r, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, r) {
    const l = this.dtFormatter(t, n), d = l.formatToParts(), f = d.find((p) => p.type.toLowerCase() === r);
    return f ? f.value : null;
  }
  numberFormatter(t = {}) {
    return new lx(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new ax(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new cx(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return JT(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Mm() ? tx(this.locale) : ux;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Pu = null;
class wr extends fa {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Pu === null && (Pu = new wr(0)), Pu;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? wr.utcInstance : new wr(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new wr(Dc(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${oa(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${oa(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return oa(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class dx extends fa {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Ts(e, t) {
  if (bt(e) || e === null)
    return t;
  if (e instanceof fa)
    return e;
  if (_x(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? Sc.instance : n === "utc" || n === "gmt" ? wr.utcInstance : wr.parseSpecifier(n) || rs.create(e);
  } else return xs(e) ? wr.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new dx(e);
}
const Ad = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Ag = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, fx = Ad.hanidec.replace(/[\[|\]]/g, "").split("");
function hx(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const r = e.charCodeAt(n);
      if (e[n].search(Ad.hanidec) !== -1)
        t += fx.indexOf(e[n]);
      else
        for (const l in Ag) {
          const [d, f] = Ag[l];
          r >= d && r <= f && (t += r - d);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
let Zo = {};
function gx() {
  Zo = {};
}
function pi({ numberingSystem: e }, t = "") {
  const n = e || "latn";
  return Zo[n] || (Zo[n] = {}), Zo[n][t] || (Zo[n][t] = new RegExp(`${Ad[n]}${t}`)), Zo[n][t];
}
let Mg = () => Date.now(), Rg = "system", bg = null, Lg = null, Ig = null, kg = 60, Pg, $g = null;
class Rn {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Mg;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    Mg = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    Rg = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Ts(Rg, Sc.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return bg;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    bg = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Lg;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    Lg = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Ig;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    Ig = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return $g;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    $g = id(t);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return kg;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    kg = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Pg;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    Pg = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    cn.resetCache(), rs.resetCache(), xt.resetCache(), gx();
  }
}
class _i {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const xm = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], vm = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function ni(e, t) {
  return new _i(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function Md(e, t, n) {
  const r = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const l = r.getUTCDay();
  return l === 0 ? 7 : l;
}
function Sm(e, t, n) {
  return n + (ha(e) ? vm : xm)[t - 1];
}
function wm(e, t) {
  const n = ha(e) ? vm : xm, r = n.findIndex((d) => d < t), l = t - n[r];
  return { month: r + 1, day: l };
}
function Rd(e, t) {
  return (e - t + 7) % 7 + 1;
}
function _c(e, t = 4, n = 1) {
  const { year: r, month: l, day: d } = e, f = Sm(r, l, d), p = Rd(Md(r, l, d), n);
  let _ = Math.floor((f - p + 14 - t) / 7), E;
  return _ < 1 ? (E = r - 1, _ = ca(E, t, n)) : _ > ca(r, t, n) ? (E = r + 1, _ = 1) : E = r, { weekYear: E, weekNumber: _, weekday: p, ...Ac(e) };
}
function Fg(e, t = 4, n = 1) {
  const { weekYear: r, weekNumber: l, weekday: d } = e, f = Rd(Md(r, 1, t), n), p = Xo(r);
  let _ = l * 7 + d - f - 7 + t, E;
  _ < 1 ? (E = r - 1, _ += Xo(E)) : _ > p ? (E = r + 1, _ -= Xo(r)) : E = r;
  const { month: T, day: S } = wm(E, _);
  return { year: E, month: T, day: S, ...Ac(e) };
}
function $u(e) {
  const { year: t, month: n, day: r } = e, l = Sm(t, n, r);
  return { year: t, ordinal: l, ...Ac(e) };
}
function Bg(e) {
  const { year: t, ordinal: n } = e, { month: r, day: l } = wm(t, n);
  return { year: t, month: r, day: l, ...Ac(e) };
}
function Hg(e, t) {
  if (!bt(e.localWeekday) || !bt(e.localWeekNumber) || !bt(e.localWeekYear)) {
    if (!bt(e.weekday) || !bt(e.weekNumber) || !bt(e.weekYear))
      throw new Jo(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return bt(e.localWeekday) || (e.weekday = e.localWeekday), bt(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), bt(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function px(e, t = 4, n = 1) {
  const r = wc(e.weekYear), l = ri(
    e.weekNumber,
    1,
    ca(e.weekYear, t, n)
  ), d = ri(e.weekday, 1, 7);
  return r ? l ? d ? !1 : ni("weekday", e.weekday) : ni("week", e.weekNumber) : ni("weekYear", e.weekYear);
}
function mx(e) {
  const t = wc(e.year), n = ri(e.ordinal, 1, Xo(e.year));
  return t ? n ? !1 : ni("ordinal", e.ordinal) : ni("year", e.year);
}
function Om(e) {
  const t = wc(e.year), n = ri(e.month, 1, 12), r = ri(e.day, 1, yc(e.year, e.month));
  return t ? n ? r ? !1 : ni("day", e.day) : ni("month", e.month) : ni("year", e.year);
}
function Dm(e) {
  const { hour: t, minute: n, second: r, millisecond: l } = e, d = ri(t, 0, 23) || t === 24 && n === 0 && r === 0 && l === 0, f = ri(n, 0, 59), p = ri(r, 0, 59), _ = ri(l, 0, 999);
  return d ? f ? p ? _ ? !1 : ni("millisecond", l) : ni("second", r) : ni("minute", n) : ni("hour", t);
}
function bt(e) {
  return typeof e > "u";
}
function xs(e) {
  return typeof e == "number";
}
function wc(e) {
  return typeof e == "number" && e % 1 === 0;
}
function _x(e) {
  return typeof e == "string";
}
function yx(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Am() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Mm() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Nx(e) {
  return Array.isArray(e) ? e : [e];
}
function Wg(e, t, n) {
  if (e.length !== 0)
    return e.reduce((r, l) => {
      const d = [t(l), l];
      return r && n(r[0], d[0]) === r[0] ? r : d;
    }, null)[1];
}
function Cx(e, t) {
  return t.reduce((n, r) => (n[r] = e[r], n), {});
}
function tl(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function id(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new _r("Week settings must be an object");
  if (!ri(e.firstDay, 1, 7) || !ri(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !ri(t, 1, 7)))
    throw new _r("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function ri(e, t, n) {
  return wc(e) && e >= t && e <= n;
}
function Ex(e, t) {
  return e - t * Math.floor(e / t);
}
function Kn(e, t = 2) {
  const n = e < 0;
  let r;
  return n ? r = "-" + ("" + -e).padStart(t, "0") : r = ("" + e).padStart(t, "0"), r;
}
function Es(e) {
  if (!(bt(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function Qs(e) {
  if (!(bt(e) || e === null || e === ""))
    return parseFloat(e);
}
function bd(e) {
  if (!(bt(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function Ld(e, t, n = !1) {
  const r = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * r) / r;
}
function ha(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Xo(e) {
  return ha(e) ? 366 : 365;
}
function yc(e, t) {
  const n = Ex(t - 1, 12) + 1, r = e + (t - n) / 12;
  return n === 2 ? ha(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Oc(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function Kg(e, t, n) {
  return -Rd(Md(e, 1, t), n) + t - 1;
}
function ca(e, t = 4, n = 1) {
  const r = Kg(e, t, n), l = Kg(e + 1, t, n);
  return (Xo(e) - r + l) / 7;
}
function sd(e) {
  return e > 99 ? e : e > Rn.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Rm(e, t, n, r = null) {
  const l = new Date(e), d = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (d.timeZone = r);
  const f = { timeZoneName: t, ...d }, p = new Intl.DateTimeFormat(n, f).formatToParts(l).find((_) => _.type.toLowerCase() === "timezonename");
  return p ? p.value : null;
}
function Dc(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(t, 10) || 0, l = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + l;
}
function bm(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new _r(`Invalid unit value ${e}`);
  return t;
}
function Nc(e, t) {
  const n = {};
  for (const r in e)
    if (tl(e, r)) {
      const l = e[r];
      if (l == null) continue;
      n[t(r)] = bm(l);
    }
  return n;
}
function oa(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), r = Math.trunc(Math.abs(e % 60)), l = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${l}${Kn(n, 2)}:${Kn(r, 2)}`;
    case "narrow":
      return `${l}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${l}${Kn(n, 2)}${Kn(r, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function Ac(e) {
  return Cx(e, ["hour", "minute", "second", "millisecond"]);
}
const Tx = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Lm = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], xx = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Im(e) {
  switch (e) {
    case "narrow":
      return [...xx];
    case "short":
      return [...Lm];
    case "long":
      return [...Tx];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const km = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Pm = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], vx = ["M", "T", "W", "T", "F", "S", "S"];
function $m(e) {
  switch (e) {
    case "narrow":
      return [...vx];
    case "short":
      return [...Pm];
    case "long":
      return [...km];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Fm = ["AM", "PM"], Sx = ["Before Christ", "Anno Domini"], wx = ["BC", "AD"], Ox = ["B", "A"];
function Bm(e) {
  switch (e) {
    case "narrow":
      return [...Ox];
    case "short":
      return [...wx];
    case "long":
      return [...Sx];
    default:
      return null;
  }
}
function Dx(e) {
  return Fm[e.hour < 12 ? 0 : 1];
}
function Ax(e, t) {
  return $m(t)[e.weekday - 1];
}
function Mx(e, t) {
  return Im(t)[e.month - 1];
}
function Rx(e, t) {
  return Bm(t)[e.year < 0 ? 0 : 1];
}
function bx(e, t, n = "always", r = !1) {
  const l = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, d = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && d) {
    const S = e === "days";
    switch (t) {
      case 1:
        return S ? "tomorrow" : `next ${l[e][0]}`;
      case -1:
        return S ? "yesterday" : `last ${l[e][0]}`;
      case 0:
        return S ? "today" : `this ${l[e][0]}`;
    }
  }
  const f = Object.is(t, -0) || t < 0, p = Math.abs(t), _ = p === 1, E = l[e], T = r ? _ ? E[1] : E[2] || E[1] : _ ? l[e][0] : e;
  return f ? `${p} ${T} ago` : `in ${p} ${T}`;
}
function zg(e, t) {
  let n = "";
  for (const r of e)
    r.literal ? n += r.val : n += t(r.val);
  return n;
}
const Lx = {
  D: mc,
  DD: im,
  DDD: sm,
  DDDD: om,
  t: lm,
  tt: am,
  ttt: cm,
  tttt: um,
  T: dm,
  TT: fm,
  TTT: hm,
  TTTT: gm,
  f: pm,
  ff: _m,
  fff: Nm,
  ffff: Em,
  F: mm,
  FF: ym,
  FFF: Cm,
  FFFF: Tm
};
class yr {
  static create(t, n = {}) {
    return new yr(t, n);
  }
  static parseFormat(t) {
    let n = null, r = "", l = !1;
    const d = [];
    for (let f = 0; f < t.length; f++) {
      const p = t.charAt(f);
      p === "'" ? (r.length > 0 && d.push({ literal: l || /^\s+$/.test(r), val: r }), n = null, r = "", l = !l) : l || p === n ? r += p : (r.length > 0 && d.push({ literal: /^\s+$/.test(r), val: r }), r = p, n = p);
    }
    return r.length > 0 && d.push({ literal: l || /^\s+$/.test(r), val: r }), d;
  }
  static macroTokenToFormatOpts(t) {
    return Lx[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return Kn(t, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(t);
  }
  formatDateTimeFromString(t, n) {
    const r = this.loc.listingMode() === "en", l = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", d = (O, m) => this.loc.extract(t, O, m), f = (O) => t.isOffsetFixed && t.offset === 0 && O.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, O.format) : "", p = () => r ? Dx(t) : d({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), _ = (O, m) => r ? Mx(t, O) : d(m ? { month: O } : { month: O, day: "numeric" }, "month"), E = (O, m) => r ? Ax(t, O) : d(
      m ? { weekday: O } : { weekday: O, month: "long", day: "numeric" },
      "weekday"
    ), T = (O) => {
      const m = yr.macroTokenToFormatOpts(O);
      return m ? this.formatWithSystemDefault(t, m) : O;
    }, S = (O) => r ? Rx(t, O) : d({ era: O }, "era"), w = (O) => {
      switch (O) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return f({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return f({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return f({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return p();
        case "d":
          return l ? d({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return l ? d({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return E("short", !0);
        case "cccc":
          return E("long", !0);
        case "ccccc":
          return E("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return E("short", !1);
        case "EEEE":
          return E("long", !1);
        case "EEEEE":
          return E("narrow", !1);
        case "L":
          return l ? d({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return l ? d({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return _("short", !0);
        case "LLLL":
          return _("long", !0);
        case "LLLLL":
          return _("narrow", !0);
        case "M":
          return l ? d({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return l ? d({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return _("short", !1);
        case "MMMM":
          return _("long", !1);
        case "MMMMM":
          return _("narrow", !1);
        case "y":
          return l ? d({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return l ? d({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return l ? d({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return l ? d({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return S("short");
        case "GG":
          return S("long");
        case "GGGGG":
          return S("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return T(O);
      }
    };
    return zg(yr.parseFormat(n), w);
  }
  formatDurationFromString(t, n) {
    const r = (_) => {
      switch (_[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, l = (_) => (E) => {
      const T = r(E);
      return T ? this.num(_.get(T), E.length) : E;
    }, d = yr.parseFormat(n), f = d.reduce(
      (_, { literal: E, val: T }) => E ? _ : _.concat(T),
      []
    ), p = t.shiftTo(...f.map(r).filter((_) => _));
    return zg(d, l(p));
  }
}
const Hm = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ol(...e) {
  const t = e.reduce((n, r) => n + r.source, "");
  return RegExp(`^${t}$`);
}
function ll(...e) {
  return (t) => e.reduce(
    ([n, r, l], d) => {
      const [f, p, _] = d(t, l);
      return [{ ...n, ...f }, p || r, _];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function al(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, r] of t) {
    const l = n.exec(e);
    if (l)
      return r(l);
  }
  return [null, null];
}
function Wm(...e) {
  return (t, n) => {
    const r = {};
    let l;
    for (l = 0; l < e.length; l++)
      r[e[l]] = Es(t[n + l]);
    return [r, null, n + l];
  };
}
const Km = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Ix = `(?:${Km.source}?(?:\\[(${Hm.source})\\])?)?`, Id = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, zm = RegExp(`${Id.source}${Ix}`), kd = RegExp(`(?:T${zm.source})?`), kx = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, Px = /(\d{4})-?W(\d\d)(?:-?(\d))?/, $x = /(\d{4})-?(\d{3})/, Fx = Wm("weekYear", "weekNumber", "weekDay"), Bx = Wm("year", "ordinal"), Hx = /(\d{4})-(\d\d)-(\d\d)/, Um = RegExp(
  `${Id.source} ?(?:${Km.source}|(${Hm.source}))?`
), Wx = RegExp(`(?: ${Um.source})?`);
function Qo(e, t, n) {
  const r = e[t];
  return bt(r) ? n : Es(r);
}
function Kx(e, t) {
  return [{
    year: Qo(e, t),
    month: Qo(e, t + 1, 1),
    day: Qo(e, t + 2, 1)
  }, null, t + 3];
}
function cl(e, t) {
  return [{
    hours: Qo(e, t, 0),
    minutes: Qo(e, t + 1, 0),
    seconds: Qo(e, t + 2, 0),
    milliseconds: bd(e[t + 3])
  }, null, t + 4];
}
function ga(e, t) {
  const n = !e[t] && !e[t + 1], r = Dc(e[t + 1], e[t + 2]), l = n ? null : wr.instance(r);
  return [{}, l, t + 3];
}
function pa(e, t) {
  const n = e[t] ? rs.create(e[t]) : null;
  return [{}, n, t + 1];
}
const zx = RegExp(`^T?${Id.source}$`), Ux = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Gx(e) {
  const [t, n, r, l, d, f, p, _, E] = e, T = t[0] === "-", S = _ && _[0] === "-", w = (O, m = !1) => O !== void 0 && (m || O && T) ? -O : O;
  return [
    {
      years: w(Qs(n)),
      months: w(Qs(r)),
      weeks: w(Qs(l)),
      days: w(Qs(d)),
      hours: w(Qs(f)),
      minutes: w(Qs(p)),
      seconds: w(Qs(_), _ === "-0"),
      milliseconds: w(bd(E), S)
    }
  ];
}
const Yx = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Pd(e, t, n, r, l, d, f) {
  const p = {
    year: t.length === 2 ? sd(Es(t)) : Es(t),
    month: Lm.indexOf(n) + 1,
    day: Es(r),
    hour: Es(l),
    minute: Es(d)
  };
  return f && (p.second = Es(f)), e && (p.weekday = e.length > 3 ? km.indexOf(e) + 1 : Pm.indexOf(e) + 1), p;
}
const jx = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Vx(e) {
  const [
    ,
    t,
    n,
    r,
    l,
    d,
    f,
    p,
    _,
    E,
    T,
    S
  ] = e, w = Pd(t, l, r, n, d, f, p);
  let O;
  return _ ? O = Yx[_] : E ? O = 0 : O = Dc(T, S), [w, new wr(O)];
}
function qx(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Zx = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Jx = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Xx = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Ug(e) {
  const [, t, n, r, l, d, f, p] = e;
  return [Pd(t, l, r, n, d, f, p), wr.utcInstance];
}
function Qx(e) {
  const [, t, n, r, l, d, f, p] = e;
  return [Pd(t, p, n, r, l, d, f), wr.utcInstance];
}
const ev = ol(kx, kd), tv = ol(Px, kd), nv = ol($x, kd), rv = ol(zm), Gm = ll(
  Kx,
  cl,
  ga,
  pa
), iv = ll(
  Fx,
  cl,
  ga,
  pa
), sv = ll(
  Bx,
  cl,
  ga,
  pa
), ov = ll(
  cl,
  ga,
  pa
);
function lv(e) {
  return al(
    e,
    [ev, Gm],
    [tv, iv],
    [nv, sv],
    [rv, ov]
  );
}
function av(e) {
  return al(qx(e), [jx, Vx]);
}
function cv(e) {
  return al(
    e,
    [Zx, Ug],
    [Jx, Ug],
    [Xx, Qx]
  );
}
function uv(e) {
  return al(e, [Ux, Gx]);
}
const dv = ll(cl);
function fv(e) {
  return al(e, [zx, dv]);
}
const hv = ol(Hx, Wx), gv = ol(Um), pv = ll(
  cl,
  ga,
  pa
);
function mv(e) {
  return al(
    e,
    [hv, Gm],
    [gv, pv]
  );
}
const Gg = "Invalid Duration", Ym = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, _v = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Ym
}, ti = 146097 / 400, jo = 146097 / 4800, yv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: ti / 7,
    days: ti,
    hours: ti * 24,
    minutes: ti * 24 * 60,
    seconds: ti * 24 * 60 * 60,
    milliseconds: ti * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: ti / 28,
    days: ti / 4,
    hours: ti * 24 / 4,
    minutes: ti * 24 * 60 / 4,
    seconds: ti * 24 * 60 * 60 / 4,
    milliseconds: ti * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: jo / 7,
    days: jo,
    hours: jo * 24,
    minutes: jo * 24 * 60,
    seconds: jo * 24 * 60 * 60,
    milliseconds: jo * 24 * 60 * 60 * 1e3
  },
  ...Ym
}, oo = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Nv = oo.slice(0).reverse();
function Cs(e, t, n = !1) {
  const r = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new Qt(r);
}
function jm(e, t) {
  let n = t.milliseconds ?? 0;
  for (const r of Nv.slice(1))
    t[r] && (n += t[r] * e[r].milliseconds);
  return n;
}
function Yg(e, t) {
  const n = jm(e, t) < 0 ? -1 : 1;
  oo.reduceRight((r, l) => {
    if (bt(t[l]))
      return r;
    if (r) {
      const d = t[r] * n, f = e[l][r], p = Math.floor(d / f);
      t[l] += p * n, t[r] -= p * f * n;
    }
    return l;
  }, null), oo.reduce((r, l) => {
    if (bt(t[l]))
      return r;
    if (r) {
      const d = t[r] % 1;
      t[r] -= d, t[l] += d * e[r][l];
    }
    return l;
  }, null);
}
function Cv(e) {
  const t = {};
  for (const [n, r] of Object.entries(e))
    r !== 0 && (t[n] = r);
  return t;
}
class Qt {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let r = n ? yv : _v;
    t.matrix && (r = t.matrix), this.values = t.values, this.loc = t.loc || cn.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = r, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return Qt.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new _r(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new Qt({
      values: Nc(t, Qt.normalizeUnit),
      loc: cn.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (xs(t))
      return Qt.fromMillis(t);
    if (Qt.isDuration(t))
      return t;
    if (typeof t == "object")
      return Qt.fromObject(t);
    throw new _r(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [r] = uv(t);
    return r ? Qt.fromObject(r, n) : Qt.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [r] = fv(t);
    return r ? Qt.fromObject(r, n) : Qt.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new _r("need to specify a reason the Duration is invalid");
    const r = t instanceof _i ? t : new _i(t, n);
    if (Rn.throwOnInvalid)
      throw new UT(r);
    return new Qt({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n) throw new rm(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? yr.create(this.loc, r).formatDurationFromString(this, t) : Gg;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return Gg;
    const n = oo.map((r) => {
      const l = this.values[r];
      return bt(l) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: r.slice(0, -1) }).format(l);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += Ld(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, xt.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? jm(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = Qt.fromDurationLike(t), r = {};
    for (const l of oo)
      (tl(n.values, l) || tl(this.values, l)) && (r[l] = n.get(l) + this.get(l));
    return Cs(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = Qt.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = bm(t(this.values[r], r));
    return Cs(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[Qt.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...Nc(t, Qt.normalizeUnit) };
    return Cs(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: r, matrix: l } = {}) {
    const f = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: l, conversionAccuracy: r };
    return Cs(this, f);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return Yg(this.matrix, t), Cs(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = Cv(this.normalize().shiftToAll().toObject());
    return Cs(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((f) => Qt.normalizeUnit(f));
    const n = {}, r = {}, l = this.toObject();
    let d;
    for (const f of oo)
      if (t.indexOf(f) >= 0) {
        d = f;
        let p = 0;
        for (const E in r)
          p += this.matrix[E][f] * r[E], r[E] = 0;
        xs(l[f]) && (p += l[f]);
        const _ = Math.trunc(p);
        n[f] = _, r[f] = (p * 1e3 - _ * 1e3) / 1e3;
      } else xs(l[f]) && (r[f] = l[f]);
    for (const f in r)
      r[f] !== 0 && (n[d] += f === d ? r[f] : r[f] / this.matrix[d][f]);
    return Yg(this.matrix, n), Cs(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return Cs(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(r, l) {
      return r === void 0 || r === 0 ? l === void 0 || l === 0 : r === l;
    }
    for (const r of oo)
      if (!n(this.values[r], t.values[r]))
        return !1;
    return !0;
  }
}
const Vo = "Invalid Interval";
function Ev(e, t) {
  return !e || !e.isValid ? Mn.invalid("missing or invalid start") : !t || !t.isValid ? Mn.invalid("missing or invalid end") : t < e ? Mn.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class Mn {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new _r("need to specify a reason the Interval is invalid");
    const r = t instanceof _i ? t : new _i(t, n);
    if (Rn.throwOnInvalid)
      throw new zT(r);
    return new Mn({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const r = Xl(t), l = Xl(n), d = Ev(r, l);
    return d ?? new Mn({
      start: r,
      end: l
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const r = Qt.fromDurationLike(n), l = Xl(t);
    return Mn.fromDateTimes(l, l.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const r = Qt.fromDurationLike(n), l = Xl(t);
    return Mn.fromDateTimes(l.minus(r), l);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [r, l] = (t || "").split("/", 2);
    if (r && l) {
      let d, f;
      try {
        d = xt.fromISO(r, n), f = d.isValid;
      } catch {
        f = !1;
      }
      let p, _;
      try {
        p = xt.fromISO(l, n), _ = p.isValid;
      } catch {
        _ = !1;
      }
      if (f && _)
        return Mn.fromDateTimes(d, p);
      if (f) {
        const E = Qt.fromISO(l, n);
        if (E.isValid)
          return Mn.after(d, E);
      } else if (_) {
        const E = Qt.fromISO(r, n);
        if (E.isValid)
          return Mn.before(p, E);
      }
    }
    return Mn.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const r = this.start.startOf(t, n);
    let l;
    return n != null && n.useLocaleWeeks ? l = this.end.reconfigure({ locale: r.locale }) : l = this.end, l = l.startOf(t, n), Math.floor(l.diff(r, t).get(t)) + (l.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? Mn.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const n = t.map(Xl).filter((f) => this.contains(f)).sort((f, p) => f.toMillis() - p.toMillis()), r = [];
    let { s: l } = this, d = 0;
    for (; l < this.e; ) {
      const f = n[d] || this.e, p = +f > +this.e ? this.e : f;
      r.push(Mn.fromDateTimes(l, p)), l = p, d += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = Qt.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, l = 1, d;
    const f = [];
    for (; r < this.e; ) {
      const p = this.start.plus(n.mapUnits((_) => _ * l));
      d = +p > +this.e ? this.e : p, f.push(Mn.fromDateTimes(r, d)), r = d, l += 1;
    }
    return f;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const n = this.s > t.s ? this.s : t.s, r = this.e < t.e ? this.e : t.e;
    return n >= r ? null : Mn.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const n = this.s < t.s ? this.s : t.s, r = this.e > t.e ? this.e : t.e;
    return Mn.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, r] = t.sort((l, d) => l.s - d.s).reduce(
      ([l, d], f) => d ? d.overlaps(f) || d.abutsStart(f) ? [l, d.union(f)] : [l.concat([d]), f] : [l, f],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, r = 0;
    const l = [], d = t.map((_) => [
      { time: _.s, type: "s" },
      { time: _.e, type: "e" }
    ]), f = Array.prototype.concat(...d), p = f.sort((_, E) => _.time - E.time);
    for (const _ of p)
      r += _.type === "s" ? 1 : -1, r === 1 ? n = _.time : (n && +n != +_.time && l.push(Mn.fromDateTimes(n, _.time)), n = null);
    return Mn.merge(l);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return Mn.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Vo;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = mc, n = {}) {
    return this.isValid ? yr.create(this.s.loc.clone(n), t).formatInterval(this) : Vo;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : Vo;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Vo;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : Vo;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : Vo;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : Qt.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return Mn.fromDateTimes(t(this.s), t(this.e));
  }
}
class rc {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = Rn.defaultZone) {
    const n = xt.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return rs.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return Ts(t, Rn.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || cn.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || cn.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || cn.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: r = null, locObj: l = null, outputCalendar: d = "gregory" } = {}) {
    return (l || cn.create(n, r, d)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: r = null, locObj: l = null, outputCalendar: d = "gregory" } = {}) {
    return (l || cn.create(n, r, d)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: r = null, locObj: l = null } = {}) {
    return (l || cn.create(n, r, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: r = null, locObj: l = null } = {}) {
    return (l || cn.create(n, r, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return cn.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return cn.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Am(), localeWeek: Mm() };
  }
}
function jg(e, t) {
  const n = (l) => l.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(t) - n(e);
  return Math.floor(Qt.fromMillis(r).as("days"));
}
function Tv(e, t, n) {
  const r = [
    ["years", (_, E) => E.year - _.year],
    ["quarters", (_, E) => E.quarter - _.quarter + (E.year - _.year) * 4],
    ["months", (_, E) => E.month - _.month + (E.year - _.year) * 12],
    [
      "weeks",
      (_, E) => {
        const T = jg(_, E);
        return (T - T % 7) / 7;
      }
    ],
    ["days", jg]
  ], l = {}, d = e;
  let f, p;
  for (const [_, E] of r)
    n.indexOf(_) >= 0 && (f = _, l[_] = E(e, t), p = d.plus(l), p > t ? (l[_]--, e = d.plus(l), e > t && (p = e, l[_]--, e = d.plus(l))) : e = p);
  return [e, l, p, f];
}
function xv(e, t, n, r) {
  let [l, d, f, p] = Tv(e, t, n);
  const _ = t - l, E = n.filter(
    (S) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(S) >= 0
  );
  E.length === 0 && (f < t && (f = l.plus({ [p]: 1 })), f !== l && (d[p] = (d[p] || 0) + _ / (f - l)));
  const T = Qt.fromObject(d, r);
  return E.length > 0 ? Qt.fromMillis(_, r).shiftTo(...E).plus(T) : T;
}
const vv = "missing Intl.DateTimeFormat.formatToParts support";
function on(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(hx(n)) };
}
const Sv = " ", Vm = `[ ${Sv}]`, qm = new RegExp(Vm, "g");
function wv(e) {
  return e.replace(/\./g, "\\.?").replace(qm, Vm);
}
function Vg(e) {
  return e.replace(/\./g, "").replace(qm, " ").toLowerCase();
}
function mi(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(wv).join("|")),
    deser: ([n]) => e.findIndex((r) => Vg(n) === Vg(r)) + t
  };
}
function qg(e, t) {
  return { regex: e, deser: ([, n, r]) => Dc(n, r), groups: t };
}
function ic(e) {
  return { regex: e, deser: ([t]) => t };
}
function Ov(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Dv(e, t) {
  const n = pi(t), r = pi(t, "{2}"), l = pi(t, "{3}"), d = pi(t, "{4}"), f = pi(t, "{6}"), p = pi(t, "{1,2}"), _ = pi(t, "{1,3}"), E = pi(t, "{1,6}"), T = pi(t, "{1,9}"), S = pi(t, "{2,4}"), w = pi(t, "{4,6}"), O = (I) => ({ regex: RegExp(Ov(I.val)), deser: ([G]) => G, literal: !0 }), v = ((I) => {
    if (e.literal)
      return O(I);
    switch (I.val) {
      case "G":
        return mi(t.eras("short"), 0);
      case "GG":
        return mi(t.eras("long"), 0);
      case "y":
        return on(E);
      case "yy":
        return on(S, sd);
      case "yyyy":
        return on(d);
      case "yyyyy":
        return on(w);
      case "yyyyyy":
        return on(f);
      case "M":
        return on(p);
      case "MM":
        return on(r);
      case "MMM":
        return mi(t.months("short", !0), 1);
      case "MMMM":
        return mi(t.months("long", !0), 1);
      case "L":
        return on(p);
      case "LL":
        return on(r);
      case "LLL":
        return mi(t.months("short", !1), 1);
      case "LLLL":
        return mi(t.months("long", !1), 1);
      case "d":
        return on(p);
      case "dd":
        return on(r);
      case "o":
        return on(_);
      case "ooo":
        return on(l);
      case "HH":
        return on(r);
      case "H":
        return on(p);
      case "hh":
        return on(r);
      case "h":
        return on(p);
      case "mm":
        return on(r);
      case "m":
        return on(p);
      case "q":
        return on(p);
      case "qq":
        return on(r);
      case "s":
        return on(p);
      case "ss":
        return on(r);
      case "S":
        return on(_);
      case "SSS":
        return on(l);
      case "u":
        return ic(T);
      case "uu":
        return ic(p);
      case "uuu":
        return on(n);
      case "a":
        return mi(t.meridiems(), 0);
      case "kkkk":
        return on(d);
      case "kk":
        return on(S, sd);
      case "W":
        return on(p);
      case "WW":
        return on(r);
      case "E":
      case "c":
        return on(n);
      case "EEE":
        return mi(t.weekdays("short", !1), 1);
      case "EEEE":
        return mi(t.weekdays("long", !1), 1);
      case "ccc":
        return mi(t.weekdays("short", !0), 1);
      case "cccc":
        return mi(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return qg(new RegExp(`([+-]${p.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return qg(new RegExp(`([+-]${p.source})(${r.source})?`), 2);
      case "z":
        return ic(/[a-z_+-/]{1,256}?/i);
      case " ":
        return ic(/[^\S\n\r]/);
      default:
        return O(I);
    }
  })(e) || {
    invalidReason: vv
  };
  return v.token = e, v;
}
const Av = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Mv(e, t, n) {
  const { type: r, value: l } = e;
  if (r === "literal") {
    const _ = /^\s+$/.test(l);
    return {
      literal: !_,
      val: _ ? " " : l
    };
  }
  const d = t[r];
  let f = r;
  r === "hour" && (t.hour12 != null ? f = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? f = "hour12" : f = "hour24" : f = n.hour12 ? "hour12" : "hour24");
  let p = Av[f];
  if (typeof p == "object" && (p = p[d]), p)
    return {
      literal: !1,
      val: p
    };
}
function Rv(e) {
  return [`^${e.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, e];
}
function bv(e, t, n) {
  const r = e.match(t);
  if (r) {
    const l = {};
    let d = 1;
    for (const f in n)
      if (tl(n, f)) {
        const p = n[f], _ = p.groups ? p.groups + 1 : 1;
        !p.literal && p.token && (l[p.token.val[0]] = p.deser(r.slice(d, d + _))), d += _;
      }
    return [r, l];
  } else
    return [r, {}];
}
function Lv(e) {
  const t = (d) => {
    switch (d) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return bt(e.z) || (n = rs.create(e.z)), bt(e.Z) || (n || (n = new wr(e.Z)), r = e.Z), bt(e.q) || (e.M = (e.q - 1) * 3 + 1), bt(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), bt(e.u) || (e.S = bd(e.u)), [Object.keys(e).reduce((d, f) => {
    const p = t(f);
    return p && (d[p] = e[f]), d;
  }, {}), n, r];
}
let Fu = null;
function Iv() {
  return Fu || (Fu = xt.fromMillis(1555555555555)), Fu;
}
function kv(e, t) {
  if (e.literal)
    return e;
  const n = yr.macroTokenToFormatOpts(e.val), r = Qm(n, t);
  return r == null || r.includes(void 0) ? e : r;
}
function Zm(e, t) {
  return Array.prototype.concat(...e.map((n) => kv(n, t)));
}
class Jm {
  constructor(t, n) {
    if (this.locale = t, this.format = n, this.tokens = Zm(yr.parseFormat(n), t), this.units = this.tokens.map((r) => Dv(r, t)), this.disqualifyingUnit = this.units.find((r) => r.invalidReason), !this.disqualifyingUnit) {
      const [r, l] = Rv(this.units);
      this.regex = RegExp(r, "i"), this.handlers = l;
    }
  }
  explainFromTokens(t) {
    if (this.isValid) {
      const [n, r] = bv(t, this.regex, this.handlers), [l, d, f] = r ? Lv(r) : [null, null, void 0];
      if (tl(r, "a") && tl(r, "H"))
        throw new Jo(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: t,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: r,
        result: l,
        zone: d,
        specificOffset: f
      };
    } else
      return { input: t, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Xm(e, t, n) {
  return new Jm(e, n).explainFromTokens(t);
}
function Pv(e, t, n) {
  const { result: r, zone: l, specificOffset: d, invalidReason: f } = Xm(e, t, n);
  return [r, l, d, f];
}
function Qm(e, t) {
  if (!e)
    return null;
  const r = yr.create(t, e).dtFormatter(Iv()), l = r.formatToParts(), d = r.resolvedOptions();
  return l.map((f) => Mv(f, e, d));
}
const Bu = "Invalid DateTime", $v = 864e13;
function na(e) {
  return new _i("unsupported zone", `the zone "${e.name}" is not supported`);
}
function Hu(e) {
  return e.weekData === null && (e.weekData = _c(e.c)), e.weekData;
}
function Wu(e) {
  return e.localWeekData === null && (e.localWeekData = _c(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function eo(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new xt({ ...n, ...t, old: n });
}
function e_(e, t, n) {
  let r = e - t * 60 * 1e3;
  const l = n.offset(r);
  if (t === l)
    return [r, t];
  r -= (l - t) * 60 * 1e3;
  const d = n.offset(r);
  return l === d ? [r, l] : [e - Math.min(l, d) * 60 * 1e3, Math.max(l, d)];
}
function sc(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function cc(e, t, n) {
  return e_(Oc(e), t, n);
}
function Zg(e, t) {
  const n = e.o, r = e.c.year + Math.trunc(t.years), l = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, d = {
    ...e.c,
    year: r,
    month: l,
    day: Math.min(e.c.day, yc(r, l)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, f = Qt.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), p = Oc(d);
  let [_, E] = e_(p, n, e.zone);
  return f !== 0 && (_ += f, E = e.zone.offset(_)), { ts: _, o: E };
}
function qo(e, t, n, r, l, d) {
  const { setZone: f, zone: p } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const _ = t || p, E = xt.fromObject(e, {
      ...n,
      zone: _,
      specificOffset: d
    });
    return f ? E : E.setZone(p);
  } else
    return xt.invalid(
      new _i("unparsable", `the input "${l}" can't be parsed as ${r}`)
    );
}
function oc(e, t, n = !0) {
  return e.isValid ? yr.create(cn.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Ku(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let r = "";
  return n && e.c.year >= 0 && (r += "+"), r += Kn(e.c.year, n ? 6 : 4), t ? (r += "-", r += Kn(e.c.month), r += "-", r += Kn(e.c.day)) : (r += Kn(e.c.month), r += Kn(e.c.day)), r;
}
function Jg(e, t, n, r, l, d) {
  let f = Kn(e.c.hour);
  return t ? (f += ":", f += Kn(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (f += ":")) : f += Kn(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (f += Kn(e.c.second), (e.c.millisecond !== 0 || !r) && (f += ".", f += Kn(e.c.millisecond, 3))), l && (e.isOffsetFixed && e.offset === 0 && !d ? f += "Z" : e.o < 0 ? (f += "-", f += Kn(Math.trunc(-e.o / 60)), f += ":", f += Kn(Math.trunc(-e.o % 60))) : (f += "+", f += Kn(Math.trunc(e.o / 60)), f += ":", f += Kn(Math.trunc(e.o % 60)))), d && (f += "[" + e.zone.ianaName + "]"), f;
}
const t_ = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Fv = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Bv = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, n_ = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Hv = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Wv = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Kv(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new rm(e);
  return t;
}
function Xg(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return Kv(e);
  }
}
function zv(e) {
  return dc[e] || (uc === void 0 && (uc = Rn.now()), dc[e] = e.offset(uc)), dc[e];
}
function Qg(e, t) {
  const n = Ts(t.zone, Rn.defaultZone);
  if (!n.isValid)
    return xt.invalid(na(n));
  const r = cn.fromObject(t);
  let l, d;
  if (bt(e.year))
    l = Rn.now();
  else {
    for (const _ of n_)
      bt(e[_]) && (e[_] = t_[_]);
    const f = Om(e) || Dm(e);
    if (f)
      return xt.invalid(f);
    const p = zv(n);
    [l, d] = cc(e, p, n);
  }
  return new xt({ ts: l, zone: n, loc: r, o: d });
}
function ep(e, t, n) {
  const r = bt(n.round) ? !0 : n.round, l = (f, p) => (f = Ld(f, r || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(f, p)), d = (f) => n.calendary ? t.hasSame(e, f) ? 0 : t.startOf(f).diff(e.startOf(f), f).get(f) : t.diff(e, f).get(f);
  if (n.unit)
    return l(d(n.unit), n.unit);
  for (const f of n.units) {
    const p = d(f);
    if (Math.abs(p) >= 1)
      return l(p, f);
  }
  return l(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function tp(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
let uc, dc = {};
class xt {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || Rn.defaultZone;
    let r = t.invalid || (Number.isNaN(t.ts) ? new _i("invalid input") : null) || (n.isValid ? null : na(n));
    this.ts = bt(t.ts) ? Rn.now() : t.ts;
    let l = null, d = null;
    if (!r)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [l, d] = [t.old.c, t.old.o];
      else {
        const p = xs(t.o) && !t.old ? t.o : n.offset(this.ts);
        l = sc(this.ts, p), r = Number.isNaN(l.year) ? new _i("invalid input") : null, l = r ? null : l, d = r ? null : p;
      }
    this._zone = n, this.loc = t.loc || cn.create(), this.invalid = r, this.weekData = null, this.localWeekData = null, this.c = l, this.o = d, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new xt({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = tp(arguments), [r, l, d, f, p, _, E] = n;
    return Qg({ year: r, month: l, day: d, hour: f, minute: p, second: _, millisecond: E }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = tp(arguments), [r, l, d, f, p, _, E] = n;
    return t.zone = wr.utcInstance, Qg({ year: r, month: l, day: d, hour: f, minute: p, second: _, millisecond: E }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const r = yx(t) ? t.valueOf() : NaN;
    if (Number.isNaN(r))
      return xt.invalid("invalid input");
    const l = Ts(n.zone, Rn.defaultZone);
    return l.isValid ? new xt({
      ts: r,
      zone: l,
      loc: cn.fromObject(n)
    }) : xt.invalid(na(l));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (xs(t))
      return t < -864e13 || t > $v ? xt.invalid("Timestamp out of range") : new xt({
        ts: t,
        zone: Ts(n.zone, Rn.defaultZone),
        loc: cn.fromObject(n)
      });
    throw new _r(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (xs(t))
      return new xt({
        ts: t * 1e3,
        zone: Ts(n.zone, Rn.defaultZone),
        loc: cn.fromObject(n)
      });
    throw new _r("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const r = Ts(n.zone, Rn.defaultZone);
    if (!r.isValid)
      return xt.invalid(na(r));
    const l = cn.fromObject(n), d = Nc(t, Xg), { minDaysInFirstWeek: f, startOfWeek: p } = Hg(d, l), _ = Rn.now(), E = bt(n.specificOffset) ? r.offset(_) : n.specificOffset, T = !bt(d.ordinal), S = !bt(d.year), w = !bt(d.month) || !bt(d.day), O = S || w, m = d.weekYear || d.weekNumber;
    if ((O || T) && m)
      throw new Jo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (w && T)
      throw new Jo("Can't mix ordinal dates with month/day");
    const v = m || d.weekday && !O;
    let I, G, k = sc(_, E);
    v ? (I = Hv, G = Fv, k = _c(k, f, p)) : T ? (I = Wv, G = Bv, k = $u(k)) : (I = n_, G = t_);
    let P = !1;
    for (const z of I) {
      const q = d[z];
      bt(q) ? P ? d[z] = G[z] : d[z] = k[z] : P = !0;
    }
    const H = v ? px(d, f, p) : T ? mx(d) : Om(d), j = H || Dm(d);
    if (j)
      return xt.invalid(j);
    const re = v ? Fg(d, f, p) : T ? Bg(d) : d, [te, ce] = cc(re, E, r), V = new xt({
      ts: te,
      zone: r,
      o: ce,
      loc: l
    });
    return d.weekday && O && t.weekday !== V.weekday ? xt.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${d.weekday} and a date of ${V.toISO()}`
    ) : V.isValid ? V : xt.invalid(V.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [r, l] = lv(t);
    return qo(r, l, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [r, l] = av(t);
    return qo(r, l, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [r, l] = cv(t);
    return qo(r, l, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, r = {}) {
    if (bt(t) || bt(n))
      throw new _r("fromFormat requires an input string and a format");
    const { locale: l = null, numberingSystem: d = null } = r, f = cn.fromOpts({
      locale: l,
      numberingSystem: d,
      defaultToEN: !0
    }), [p, _, E, T] = Pv(f, t, n);
    return T ? xt.invalid(T) : qo(p, _, r, `format ${n}`, t, E);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, r = {}) {
    return xt.fromFormat(t, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [r, l] = mv(t);
    return qo(r, l, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new _r("need to specify a reason the DateTime is invalid");
    const r = t instanceof _i ? t : new _i(t, n);
    if (Rn.throwOnInvalid)
      throw new KT(r);
    return new xt({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const r = Qm(t, cn.fromObject(n));
    return r ? r.map((l) => l ? l.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return Zm(yr.parseFormat(t), cn.fromObject(n)).map((l) => l.val).join("");
  }
  static resetCache() {
    uc = void 0, dc = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Hu(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Hu(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Hu(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Wu(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Wu(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Wu(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? $u(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? rc.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? rc.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? rc.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? rc.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, r = Oc(this.c), l = this.zone.offset(r - t), d = this.zone.offset(r + t), f = this.zone.offset(r - l * n), p = this.zone.offset(r - d * n);
    if (f === p)
      return [this];
    const _ = r - f * n, E = r - p * n, T = sc(_, f), S = sc(E, p);
    return T.hour === S.hour && T.minute === S.minute && T.second === S.second && T.millisecond === S.millisecond ? [eo(this, { ts: _ }), eo(this, { ts: E })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return ha(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return yc(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Xo(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? ca(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? ca(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: r, calendar: l } = yr.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: l };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(wr.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Rn.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (t = Ts(t, Rn.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let l = this.ts;
      if (n || r) {
        const d = t.offset(this.ts), f = this.toObject();
        [l] = cc(f, d, t);
      }
      return eo(this, { ts: l, zone: t });
    } else
      return xt.invalid(na(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: r } = {}) {
    const l = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: r });
    return eo(this, { loc: l });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = Nc(t, Xg), { minDaysInFirstWeek: r, startOfWeek: l } = Hg(n, this.loc), d = !bt(n.weekYear) || !bt(n.weekNumber) || !bt(n.weekday), f = !bt(n.ordinal), p = !bt(n.year), _ = !bt(n.month) || !bt(n.day), E = p || _, T = n.weekYear || n.weekNumber;
    if ((E || f) && T)
      throw new Jo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (_ && f)
      throw new Jo("Can't mix ordinal dates with month/day");
    let S;
    d ? S = Fg(
      { ..._c(this.c, r, l), ...n },
      r,
      l
    ) : bt(n.ordinal) ? (S = { ...this.toObject(), ...n }, bt(n.day) && (S.day = Math.min(yc(S.year, S.month), S.day))) : S = Bg({ ...$u(this.c), ...n });
    const [w, O] = cc(S, this.o, this.zone);
    return eo(this, { ts: w, o: O });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = Qt.fromDurationLike(t);
    return eo(this, Zg(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = Qt.fromDurationLike(t).negate();
    return eo(this, Zg(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const r = {}, l = Qt.normalizeUnit(t);
    switch (l) {
      case "years":
        r.month = 1;
      case "quarters":
      case "months":
        r.day = 1;
      case "weeks":
      case "days":
        r.hour = 0;
      case "hours":
        r.minute = 0;
      case "minutes":
        r.second = 0;
      case "seconds":
        r.millisecond = 0;
        break;
    }
    if (l === "weeks")
      if (n) {
        const d = this.loc.getStartOfWeek(), { weekday: f } = this;
        f < d && (r.weekNumber = this.weekNumber - 1), r.weekday = d;
      } else
        r.weekday = 1;
    if (l === "quarters") {
      const d = Math.ceil(this.month / 3);
      r.month = (d - 1) * 3 + 1;
    }
    return this.set(r);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? yr.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : Bu;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = mc, n = {}) {
    return this.isValid ? yr.create(this.loc.clone(n), t).formatDateTime(this) : Bu;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? yr.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: l = !0,
    extendedZone: d = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const f = t === "extended";
    let p = Ku(this, f);
    return p += "T", p += Jg(this, f, n, r, l, d), p;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? Ku(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return oc(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: l = !1,
    extendedZone: d = !1,
    format: f = "extended"
  } = {}) {
    return this.isValid ? (l ? "T" : "") + Jg(
      this,
      f === "extended",
      n,
      t,
      r,
      d
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return oc(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return oc(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Ku(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let l = "HH:mm:ss.SSS";
    return (n || t) && (r && (l += " "), n ? l += "z" : t && (l += "ZZ")), oc(this, l, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Bu;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", r = {}) {
    if (!this.isValid || !t.isValid)
      return Qt.invalid("created by diffing an invalid DateTime");
    const l = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, d = Nx(n).map(Qt.normalizeUnit), f = t.valueOf() > this.valueOf(), p = f ? this : t, _ = f ? t : this, E = xv(p, _, d, l);
    return f ? E.negate() : E;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(xt.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? Mn.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, r) {
    if (!this.isValid) return !1;
    const l = t.valueOf(), d = this.setZone(t.zone, { keepLocalTime: !0 });
    return d.startOf(n, r) <= l && l <= d.endOf(n, r);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const n = t.base || xt.fromObject({}, { zone: this.zone }), r = t.padding ? this < n ? -t.padding : t.padding : 0;
    let l = ["years", "months", "days", "hours", "minutes", "seconds"], d = t.unit;
    return Array.isArray(t.unit) && (l = t.unit, d = void 0), ep(n, this.plus(r), {
      ...t,
      numeric: "always",
      units: l,
      unit: d
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? ep(t.base || xt.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(xt.isDateTime))
      throw new _r("min requires all arguments be DateTimes");
    return Wg(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(xt.isDateTime))
      throw new _r("max requires all arguments be DateTimes");
    return Wg(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, r = {}) {
    const { locale: l = null, numberingSystem: d = null } = r, f = cn.fromOpts({
      locale: l,
      numberingSystem: d,
      defaultToEN: !0
    });
    return Xm(f, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, r = {}) {
    return xt.fromFormatExplain(t, n, r);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(t, n = {}) {
    const { locale: r = null, numberingSystem: l = null } = n, d = cn.fromOpts({
      locale: r,
      numberingSystem: l,
      defaultToEN: !0
    });
    return new Jm(d, t);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(t, n, r = {}) {
    if (bt(t) || bt(n))
      throw new _r(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: l = null, numberingSystem: d = null } = r, f = cn.fromOpts({
      locale: l,
      numberingSystem: d,
      defaultToEN: !0
    });
    if (!f.equals(n.locale))
      throw new _r(
        `fromFormatParser called with a locale of ${f}, but the format parser was created for ${n.locale}`
      );
    const { result: p, zone: _, specificOffset: E, invalidReason: T } = n.explainFromTokens(t);
    return T ? xt.invalid(T) : qo(
      p,
      _,
      r,
      `format ${n.format}`,
      t,
      E
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return mc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return im;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return GT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return sm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return om;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return lm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return am;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return cm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return um;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return dm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return fm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return hm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return gm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return pm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return mm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return _m;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return ym;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return YT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Nm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Cm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Em;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Tm;
  }
}
function Xl(e) {
  if (xt.isDateTime(e))
    return e;
  if (e && e.valueOf && xs(e.valueOf()))
    return xt.fromJSDate(e);
  if (e && typeof e == "object")
    return xt.fromObject(e);
  throw new _r(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
var Gt = /* @__PURE__ */ ((e) => (e.Monday = "MONDAY", e.Tuesday = "TUESDAY", e.Wednesday = "WEDNESDAY", e.Thursday = "THURSDAY", e.Friday = "FRIDAY", e.Saturday = "SATURDAY", e.Sunday = "SUNDAY", e))(Gt || {});
function Mc(e) {
  const t = {
    1: Gt.Monday,
    2: Gt.Tuesday,
    3: Gt.Wednesday,
    4: Gt.Thursday,
    5: Gt.Friday,
    6: Gt.Saturday,
    7: Gt.Sunday
  };
  if (e.weekday in t)
    return t[e.weekday];
  throw new Error(`Invalid DateTime.weekday property: ${e}, ${e.weekday}`);
}
function ao(e) {
  return {
    [Gt.Monday]: "Monday",
    [Gt.Tuesday]: "Tuesday",
    [Gt.Wednesday]: "Wednesday",
    [Gt.Thursday]: "Thursday",
    [Gt.Friday]: "Friday",
    [Gt.Saturday]: "Saturday",
    [Gt.Sunday]: "Sunday"
  }[e];
}
const od = [
  Gt.Monday,
  Gt.Tuesday,
  Gt.Wednesday,
  Gt.Thursday,
  Gt.Friday,
  Gt.Saturday,
  Gt.Sunday
], ra = {
  [Gt.Monday]: "monday",
  [Gt.Tuesday]: "tuesday",
  [Gt.Wednesday]: "wednesday",
  [Gt.Thursday]: "thursday",
  [Gt.Friday]: "friday",
  [Gt.Saturday]: "saturday",
  [Gt.Sunday]: "sunday"
};
class Cc {
  /**
   * @param date - DateTime the DateTime for the day on which the interval starts
   * @param interval - the Yext Streams interval data
   */
  constructor(t, n, r) {
    Ie(this, "end");
    Ie(this, "start");
    this.end = t.setZone(r), this.start = t.setZone(r), [n.start, n.end].forEach((E) => {
      if (E.split(":").length !== 2)
        throw new Error(
          'expected interval start and end data to be in the format "HH:MM"'
        );
    });
    const [l, d] = n.start.split(":").map(Number), [f, p] = n.end.split(":").map(Number);
    let _ = 0;
    f < l && (_ = 1), this.end = this.end.set({
      hour: f,
      minute: p,
      day: this.end.day + _
    }), this.start = this.start.set({
      hour: l,
      minute: d
    }), this.end.minute === 59 && (this.end = this.end.set({ minute: 60 }));
  }
  /**
   * @param date - A moment in time
   * @returns boolean - True if the given moment is within the interval
   */
  contains(t) {
    return this.start <= t && t < this.end;
  }
  /**
   * @param opts - intl.DateTimeFormatOptions
   * @param locale - defaults to 'en-US'
   * @returns string - representation of this interval's start time
   */
  getStartTime(t, n) {
    const r = {
      hour: "numeric",
      minute: "numeric",
      ...n
    };
    return this.start.setLocale(t || "en-US").toLocaleString(r).replace(" ", " ");
  }
  /**
   * @param opts - intl.DateTimeFormatOptions
   * @param locale - defaults to 'en-US'
   * @returns string representation of this interval's end time
   */
  getEndTime(t, n) {
    const r = {
      hour: "numeric",
      minute: "numeric",
      ...n
    };
    return this.end.setLocale(t || "en-US").toLocaleString(r).replace(" ", " ");
  }
  /**
   * @returns boolean if this interval and 'other' have the same start/end
   */
  timeIsEqualTo(t) {
    const n = this.getStartTime() === t.getStartTime(), r = this.getEndTime() === t.getEndTime();
    return n && r;
  }
  /**
   * @returns boolean if this interval is 24 hours
   */
  is24h() {
    const t = this.start.minute === 0 && this.start.hour === 0, n = this.end.minute === 0 && this.end.hour === 0, r = this.end.day - this.start.day === 1 || this.end.day === 1;
    return t && n && r;
  }
}
class r_ {
  /**
   * @param hours - Hours object in the format returned by Yext Streams
   */
  constructor(t, n) {
    Ie(this, "holidayHoursByDate");
    Ie(this, "hours");
    Ie(this, "timezone");
    this.holidayHoursByDate = Object.fromEntries(
      (t.holidayHours || []).map((r) => [r.date, r])
    ), this.hours = t, this.timezone = n;
  }
  /**
   * @param date - A moment in time
   * @returns HoursInterval? The first interval that contains the given moment, null if none
   */
  getInterval(t) {
    if (this.isTemporarilyClosedAt(t))
      return null;
    const n = t.minus({ days: 1 });
    for (const r of [n, t]) {
      const l = this.getHours(r);
      if (l && !l.isClosed)
        for (const d of l.openIntervals || []) {
          const f = new Cc(
            r,
            d,
            this.timezone
          );
          if (f.contains(t))
            return f;
        }
    }
    return null;
  }
  /**
   * @returns HoursInterval? The first interval that contains the current time, null if none
   */
  getCurrentInterval() {
    return this.getInterval(xt.now());
  }
  /**
   * @param date - A moment in time
   * @returns HoursInterval? The next interval that hasn't started as of the given moment
   */
  getIntervalAfter(t) {
    const n = this.getIntervalsForNDays(8, t), r = (d, f) => d.start === f.start ? 0 : d.start > f.start ? 1 : -1, l = n.sort(r);
    for (const [d, f] of l.entries())
      if (f.contains(t) && l.length > d + 1)
        return l[d + 1];
    for (const d of l)
      if (d.start > t)
        return d;
    return null;
  }
  /*
   * @param {number} n number of days to check
   * @param {DateTime} startDate first day to check
   * @returns {HoursInterval[]} list of intervals in range [startDate, startDate+7]
   */
  getIntervalsForNDays(t, n) {
    const r = [];
    for (let l = 0; l < t; l++) {
      let d = n;
      d = d.plus({ days: l });
      const f = this.getHours(d);
      f != null && f.openIntervals && !f.isClosed && r.push(
        ...f.openIntervals.map(
          (p) => new Cc(d, p, this.timezone)
        )
      );
    }
    return r;
  }
  /**
   * @param date - The day to get the hours for
   * @returns Object? The daily holiday hours object from the original Streams response for the
   *   given date, null if none
   */
  getHolidayHours(t) {
    return this.isTemporarilyClosedAt(t) ? null : this.holidayHoursByDate[(t.toISO() || "").replace(/T.*/, "")] || null;
  }
  /**
   * @param date - The day to get the hours for
   * @returns Object? The daily normal hours object from the original Streams response for the
   *   given date, null if none
   */
  getNormalHours(t) {
    if (this.isTemporarilyClosedAt(t))
      return null;
    const n = ao(Mc(t)).toLowerCase();
    return this.hours[n];
  }
  /**
   * @param date - The day to get the hours for
   * @returns Object? The daily hours object from the original Streams response for the given
   *   date, null if none
   */
  getHours(t) {
    const n = this.getHolidayHours(t);
    return !n || n.isRegularHours ? this.getNormalHours(t) : n;
  }
  /**
   * @returns HoursInterval? The next interval that hasn't started as of the current time
   */
  getNextInterval() {
    return this.getIntervalAfter(xt.now());
  }
  /**
   * @param date - A day
   * @returns Boolean True if the given day has holiday hours
   */
  isHoliday(t) {
    return !!this.getHolidayHours(t);
  }
  /**
   * Yext platform uses the field `hours.reopenDate` to indicate an entity is
   *  temporarily closed for more than one day.
   * @returns Boolean True if the given date is before 'reopenDate'
   */
  isTemporarilyClosedAt(t) {
    if (!this.hours.reopenDate)
      return !1;
    const n = this.hours.reopenDate.split("-");
    if (n.length === 3) {
      const [r, l, d] = n, f = xt.fromObject(
        { year: Number(r), month: Number(l), day: Number(d) },
        { zone: this.timezone }
      );
      if (t < f)
        return !0;
    }
    return !1;
  }
  /**
   * @param date - A moment in time
   * @returns Boolean True if the given moment falls within any interval
   */
  isOpenAt(t) {
    return this.isTemporarilyClosedAt(t) ? !1 : !!this.getInterval(t);
  }
  /**
   * @returns Boolean True if the current time falls within any interval
   */
  isOpenNow() {
    return this.isOpenAt(xt.now());
  }
}
function Uv(e, t) {
  const n = [...e];
  return t = t % n.length, n.concat(n.splice(0, n.length - t));
}
function Gv(e, t) {
  if (e.length !== t.length)
    return !1;
  for (const [n, r] of e.entries())
    if (!r.timeIsEqualTo(t[n]))
      return !1;
  return !0;
}
function ma(e) {
  var t, n;
  return ((n = (t = e == null ? void 0 : e.currentInterval) == null ? void 0 : t.is24h) == null ? void 0 : n.call(t)) || !1;
}
function _a(e) {
  return !e.futureInterval;
}
function Yv(e) {
  return ma(e) ? /* @__PURE__ */ nt.jsx("span", { className: "HoursStatus-current", children: "Open 24 Hours" }) : _a(e) ? /* @__PURE__ */ nt.jsx("span", { className: "HoursStatus-current", children: "Temporarily Closed" }) : /* @__PURE__ */ nt.jsx("span", { className: "HoursStatus-current", children: e.isOpen ? "Open Now" : "Closed" });
}
function jv(e) {
  return ma(e) || _a(e) ? null : /* @__PURE__ */ nt.jsx("span", { className: "HoursStatus-separator", children: " • " });
}
function Vv(e) {
  return ma(e) || _a(e) ? null : /* @__PURE__ */ nt.jsx("span", { className: "HoursStatus-future", children: e.isOpen ? "Closes at" : "Opens at" });
}
function qv(e) {
  if (ma(e) || _a(e))
    return null;
  let t = "";
  if (e.isOpen) {
    const n = e.currentInterval;
    t += n ? n.getEndTime("en-US", e.timeOptions) : "";
  } else {
    const n = e.futureInterval;
    t += n ? n.getStartTime("en-US", e.timeOptions) : "";
  }
  return /* @__PURE__ */ nt.jsxs("span", { className: "HoursStatus-time", children: [
    " ",
    t
  ] });
}
function Zv(e) {
  var r, l;
  if (ma(e) || _a(e))
    return null;
  const t = {
    weekday: "long",
    ...e.dayOptions ?? {}
  };
  let n = "";
  if (e.isOpen) {
    const d = e.currentInterval;
    n += ((r = d == null ? void 0 : d.end) == null ? void 0 : r.setLocale("en-US").toLocaleString(t)) || "";
  } else {
    const d = e.futureInterval;
    n += ((l = d == null ? void 0 : d.start) == null ? void 0 : l.setLocale("en-US").toLocaleString(t)) || "";
  }
  return /* @__PURE__ */ nt.jsxs("span", { className: "HoursStatus-dayOfWeek", children: [
    " ",
    n
  ] });
}
function Jv(e, t) {
  const n = e.currentTemplate || Yv, r = e.separatorTemplate || jv, l = e.futureTemplate || Vv, d = e.timeTemplate || qv, f = e.dayOfWeekTemplate || Zv;
  return /* @__PURE__ */ nt.jsxs("div", { className: el("HoursStatus", (t == null ? void 0 : t.className) || ""), children: [
    n(e),
    r(e),
    l(e),
    d(e),
    f(e)
  ] });
}
const Xv = { minHeight: `${1.5}em` }, Cw = (e) => {
  const [t, n] = Nr(!1), [r, l] = Nr(!1);
  if (tr(() => {
    l(!0);
  }, []), !e.hours)
    return /* @__PURE__ */ nt.jsx(nt.Fragment, {});
  const d = e.statusTemplate || Jv, f = new r_(e.hours, e.timezone), p = f.isOpenNow(), _ = f.getCurrentInterval(), E = f.getNextInterval(), T = (_ == null ? void 0 : _.end) || (E == null ? void 0 : E.start);
  if (T && !t) {
    n(!0);
    const w = T.toMillis() - xt.now().toMillis();
    setTimeout(() => n(!1), w);
  }
  const S = {
    isOpen: p,
    currentInterval: _,
    futureInterval: E,
    ...e
  };
  return /* @__PURE__ */ nt.jsx(nt.Fragment, { children: r ? d(S, e) : /* @__PURE__ */ nt.jsx(
    "div",
    {
      style: Xv,
      className: el("HoursStatus", (e == null ? void 0 : e.className) || "")
    }
  ) });
};
function Qv(e, t) {
  const n = [];
  return e.forEach((r) => {
    const l = n[n.length - 1];
    l ? Gv(l.intervals, r.intervals) ? (l.endDay = r.endDay, l.isToday = l.isToday || r.isToday) : n.push({
      ...r
    }) : n.push({
      ...r
    });
  }), n.map((r) => {
    const l = t && ra[r.startDay] in t ? t[ra[r.startDay]] || "" : ao(r.startDay), d = t && ra[r.endDay] in t ? t[ra[r.endDay]] || "" : ao(r.endDay);
    return {
      ...r,
      dayOfWeek: "Collapsed",
      dayName: r.startDay === r.endDay ? `${l}` : `${l} - ${d}`
    };
  });
}
function eS(e, t, n) {
  const r = [], l = e.intervals.length > 0 && e.intervals[0].is24h();
  return e.intervals.length === 0 ? r.push((n == null ? void 0 : n.isClosed) || "Closed") : l ? r.push((n == null ? void 0 : n.open24Hours) || "Open 24 hours") : e.intervals.forEach((d) => {
    const f = d.getStartTime(
      (n == null ? void 0 : n.timeFormatLocale) || "en-US",
      t
    ), p = d.getEndTime(
      (n == null ? void 0 : n.timeFormatLocale) || "en-US",
      t
    );
    r.push(`${f} - ${p}`);
  }), r;
}
function tS(e, t, n) {
  const r = [];
  for (let l = 1; l <= 7; l++) {
    const d = xt.fromObject({ weekday: l }), f = Mc(d);
    r.push({
      startDay: f,
      endDay: f,
      dayName: n && ao(f).toLowerCase() in n ? n[ao(f).toLowerCase()] || "" : ao(f),
      intervals: e.filter((p) => p.start.weekday === l),
      isToday: (t == null ? void 0 : t.weekday) === l
    });
  }
  return r;
}
const Ew = (e) => {
  const [t, n] = Nr(!1);
  return tr(() => {
    n(!0);
  }, []), e.hours ? /* @__PURE__ */ nt.jsx(nt.Fragment, { children: t ? /* @__PURE__ */ nt.jsx(nS, { ...e }) : /* @__PURE__ */ nt.jsx(rS, { ...e }) }) : /* @__PURE__ */ nt.jsx(nt.Fragment, {});
}, nS = (e) => {
  const t = new r_(
    e.hours,
    Intl.DateTimeFormat().resolvedOptions().timeZone
  ), n = xt.now(), r = t.getIntervalsForNDays(7, n), l = tS(
    r,
    n,
    e.dayOfWeekNames
  );
  return /* @__PURE__ */ nt.jsx(ld, { ...e, hoursData: l, isClient: !0 });
}, rS = (e) => {
  var f;
  const { hours: t, dayOfWeekNames: n, intervalTranslations: r } = e, l = od.map((p) => {
    var E, T;
    const _ = ra[p];
    return {
      dayName: (n == null ? void 0 : n[_]) || ao(p),
      startDay: p,
      endDay: p,
      isToday: !1,
      intervals: ((T = (E = t[_]) == null ? void 0 : E.openIntervals) == null ? void 0 : T.map(
        (S) => new Cc(xt.now(), S, "UTC")
      )) ?? []
    };
  }), d = (f = t.holidayHours) == null ? void 0 : f.map((p) => {
    var T, S;
    const _ = xt.fromFormat(p.date, "yyyy-MM-dd"), E = Mc(_);
    return {
      dayName: _.setLocale((r == null ? void 0 : r.timeFormatLocale) || "en-US").toLocaleString(),
      isToday: !1,
      startDay: E,
      endDay: E,
      intervals: (p.isRegularHours ? (T = p.openIntervals) == null ? void 0 : T.map(
        (w) => new Cc(_, w, "UTC")
      ) : (S = l.find((w) => w.startDay === E)) == null ? void 0 : S.intervals) ?? []
    };
  });
  return /* @__PURE__ */ nt.jsxs(nt.Fragment, { children: [
    /* @__PURE__ */ nt.jsx(
      ld,
      {
        ...e,
        hoursData: l,
        isClient: !1
      }
    ),
    d && d.length > 0 && /* @__PURE__ */ nt.jsx(
      ld,
      {
        ...e,
        hoursData: d,
        isClient: !1,
        isHolidayHours: !0
      }
    ),
    t.reopenDate && /* @__PURE__ */ nt.jsxs("div", { className: "HoursTable-row", children: [
      /* @__PURE__ */ nt.jsx("span", { className: "HoursTable-day", children: (r == null ? void 0 : r.reopenDate) || "Reopen Date" }),
      /* @__PURE__ */ nt.jsx("span", { className: "HoursTable-intervals", children: xt.fromFormat(t.reopenDate, "yyyy-MM-dd").setLocale((r == null ? void 0 : r.timeFormatLocale) || "en-US").toLocaleString() })
    ] })
  ] });
}, ld = (e) => {
  const {
    intervalStringsBuilderFn: t,
    className: n,
    timeOptions: r,
    intervalTranslations: l,
    dayOfWeekNames: d,
    startOfWeek: f,
    isClient: p,
    isHolidayHours: _
  } = e;
  let E = e.hoursData;
  function T(O) {
    return O ? {
      today: Mc(xt.now()),
      monday: Gt.Monday,
      tuesday: Gt.Tuesday,
      wednesday: Gt.Wednesday,
      thursday: Gt.Thursday,
      friday: Gt.Friday,
      saturday: Gt.Saturday,
      sunday: Gt.Sunday
    }[O] : Gt.Sunday;
  }
  const S = od.indexOf(
    T(
      p || f !== "today" ? f : "sunday"
    )
  ), w = Uv(od, 7 - S);
  return _ || (E.sort(
    (O, m) => w.indexOf(O.startDay) - w.indexOf(m.startDay)
  ), e.collapseDays && (E = Qv(E, d))), /* @__PURE__ */ nt.jsx("div", { className: el("HoursTable", n), children: E.map((O) => {
    const v = (t || eS)(
      O,
      r,
      l
    );
    return /* @__PURE__ */ nt.jsxs(
      "div",
      {
        className: el("HoursTable-row", { "is-today": O.isToday }),
        children: [
          /* @__PURE__ */ nt.jsx("span", { className: "HoursTable-day", children: O.dayName }),
          /* @__PURE__ */ nt.jsx("span", { className: "HoursTable-intervals", children: v.map((I, G) => /* @__PURE__ */ nt.jsx("span", { className: "HoursTable-interval", children: I }, G)) })
        ]
      },
      O.dayName
    );
  }) });
}, Tw = (e) => `<script type="application/ld+json">
  ${JSON.stringify(e)}
  <\/script>`, $d = (e, t) => {
  if (!(!e.name || typeof e.name != "string"))
    return {
      "@context": "https://schema.org",
      "@type": t,
      name: e.name
    };
}, iS = (e) => typeof e != "object" ? !1 : !!e.name || !!e.address, sS = (e) => typeof e != "object" ? !1 : !!e.line1 || !!e.city || !!e.region || !!e.postalCode || !!e.countryCode, i_ = (e) => sS(e) && {
  address: {
    "@type": "PostalAddress",
    streetAddress: e.line1,
    addressLocality: e.city,
    addressRegion: e.region,
    postalCode: e.postalCode,
    addressCountry: e.countryCode
  }
}, oS = (e) => iS(e) && {
  "@type": "Place",
  name: e.name,
  ...i_(e.address)
}, s_ = (e) => typeof e != "object" || !("image" in e) ? !1 : "url" in e.image && typeof e.image.url == "string", Fd = (e) => {
  if (!e)
    return {};
  const t = new Array();
  for (const n of e)
    s_(n) && t.push(n.image.url);
  return {
    image: t
  };
}, xw = (e) => s_(e) && {
  image: e.image.url
}, lS = (e) => typeof e != "object" ? !1 : !!e.name, aS = (e) => Array.isArray(e) && e.length > 0, cS = (e) => aS(e) && {
  performer: {
    "@type": "PerformingGroup",
    name: e.join(" and ")
  }
}, uS = (e) => lS(e) && {
  organizer: {
    "@type": "Organization",
    name: e.name,
    ...e.url && { url: e.url }
  }
}, dS = [
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "MadeToOrder",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "Reserved",
  "SoldOut"
], fS = (e) => typeof e != "object" ? !1 : "priceCurrency" in e && "price" in e && "availability" in e && dS.includes(e.availability), o_ = (e) => fS(e) && {
  offers: {
    "@type": "Offer",
    url: e.url,
    priceCurrency: e.priceCurrency,
    price: e.price,
    priceValidUntil: e.priceValidUntil,
    itemCondition: e.itemCondition,
    availability: e.availability
  }
}, vw = (e, t) => {
  const n = oS({
    name: e.geomodifier,
    address: e.address
  });
  return {
    ...$d(e, t ?? "Event"),
    ...Fd(e.photoGallery),
    ...n && { location: n },
    ...cS(e.performers),
    ...uS({
      name: e.organizerName
    }),
    ...o_({
      url: "",
      priceCurrency: e.c_currency,
      price: e.price,
      priceValidUntil: e.expirationDate,
      itemCondition: e.condition,
      availability: e.stockStatus
    }),
    ...e.c_startDate && { startDate: e.c_startDate },
    ...e.c_endDate && { endDate: e.c_endDate },
    ...e.description && { description: e.description },
    ...e.attendance && { eventAttendanceMode: e.attendance },
    ...e.eventStatus && { eventStatus: e.eventStatus }
  };
}, hS = (e) => typeof e != "object" ? !1 : "monday" in e || "tuesday" in e || "wednesday" in e || "thursday" in e || "friday" in e || "saturday" in e || "sunday" in e, gS = (e) => typeof e != "object" ? !1 : e.isClosed ? !0 : "openIntervals" in e && Array.isArray(e.openIntervals) && e.openIntervals.length ? e.openIntervals.every((t) => typeof t == "object" && "start" in t && "end" in t) : !1, pS = (e) => {
  if (!hS(e))
    return {};
  let t = /* @__PURE__ */ new Map();
  t = to(e.monday, t, "Mo"), t = to(e.tuesday, t, "Tu"), t = to(e.wednesday, t, "We"), t = to(e.thursday, t, "Th"), t = to(e.friday, t, "Fr"), t = to(e.saturday, t, "Sa"), t = to(e.sunday, t, "Su");
  const n = new Array();
  for (const [r, l] of t) {
    const d = l.join(",");
    n.push(d + " " + r);
  }
  return {
    openingHours: n
  };
}, to = (e, t, n) => {
  if (!gS(e))
    return t;
  if (e.isClosed || !e.openIntervals) {
    const r = "00:00-00:00", l = t.get(r) ?? [];
    return l.push(n), t.set(r, l), t;
  }
  for (let r = 0; r < e.openIntervals.length; r++) {
    const l = e.openIntervals[r].start + "-" + e.openIntervals[r].end, d = t.get(l) ?? [];
    d.push(n), t.set(l, d);
  }
  return t;
}, Sw = (e, t) => ({
  ...$d(e, t ?? "LocalBusiness"),
  // default, if schemaType is nil, set to LocalBusiness
  ...i_(e.address),
  ...pS(e.hours),
  ...Fd(e.photoGallery),
  description: e.description,
  telephone: e.mainPhone,
  email: e.email
}), mS = (e) => typeof e != "object" ? !1 : "ratingValue" in e, _S = (e) => typeof e != "object" ? !1 : "ratingValue" in e && "reviewCount" in e, yS = (e) => mS(e) && {
  review: {
    "@type": "Review",
    reviewRating: {
      "@type": "Rating",
      ratingValue: e.ratingValue,
      bestRating: e.bestRating
    },
    ...e.author && {
      author: {
        "@type": "Person",
        name: e.author
      }
    }
  }
}, NS = (e) => _S(e) ? {
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: e.ratingValue,
    reviewCount: e.reviewCount
  }
} : void 0, ww = (e, t) => ({
  ...$d(e, t ?? "Product"),
  ...Fd(e.photoGallery),
  ...yS(e.c_reviews),
  ...NS(e.c_aggregateRating),
  ...o_({
    url: "",
    priceCurrency: e.c_currency,
    price: e.price,
    priceValidUntil: e.expirationDate,
    itemCondition: e.condition,
    availability: e.stockStatus
  }),
  description: e.description,
  sku: e.sku,
  mpn: e.mpn,
  ...e.brand && {
    brand: {
      "@type": "Brand",
      name: e.brand
    }
  }
}), CS = (e) => !e || typeof e != "object" ? !1 : "question" in e && "answer" in e, ES = (e) => !e || typeof e != "object" ? !1 : "question" in e && "answerV2" in e ? "json" in e.answerV2 && typeof e.answerV2.json == "object" : !1;
function ad(e, t) {
  for (const n in e)
    if (typeof e[n] == "object")
      if (Array.isArray(e[n]))
        for (let r = 0; r < e[n].length; r++)
          ad(e[n][r], t);
      else
        ad(e[n], t);
    else
      n === "text" && t.push(e[n]);
}
function TS(e) {
  if (e.json) {
    const t = [];
    return ad(e.json, t), t.join("");
  }
  return "";
}
const Ow = (e) => {
  const t = e.map((n) => {
    if (CS(n) || ES(n))
      return {
        "@type": "Question",
        name: n.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: "answer" in n ? n.answer : TS(n.answerV2)
        }
      };
  }).filter(Boolean);
  if (t.length)
    return {
      "@context": "http://www.schema.org",
      "@type": "FAQPage",
      mainEntity: t
    };
}, cd = Math.log2(1.6745627884839434), xS = 4, vS = 19, ud = "js-baidu-neg-lng-fix";
let l_;
const SS = new Promise((e) => l_ = e), wS = "https://api.map.baidu.com/geoconv/v1/";
let Ql = [];
const OS = "gcj02ToBD09Callback_b872c21c";
let DS = 0, np;
async function a_(e) {
  return await new Promise((t, n) => {
    Ql.push({ coordinates: e, resolve: t, reject: n }), Ql.length === 1 && (np = setTimeout(r, 100)), Ql.length > 40 && (clearTimeout(np), r());
    function r() {
      const l = Ql;
      Ql = [];
      const d = [].concat(
        ...l.map((_) => _.coordinates)
      ), f = OS + "_" + DS++, p = document.createElement("script");
      window[f] = (_) => {
        var S;
        if (_.status) {
          const w = new Error(
            `Unable to convert coordinates to BD-09: Received status code ${_.status}${_.message ? ": " + _.message : ""}`
          );
          l.forEach((O) => O.reject(w));
        }
        const E = _.result.map(
          (w) => new fn(w.y, w.x)
        );
        let T = 0;
        l.forEach((w) => {
          w.resolve(
            E.slice(
              T,
              T += w.coordinates.length
            )
          );
        }), delete window[f], (S = p.parentNode) == null || S.removeChild(p);
      }, SS.then((_) => {
        const E = {
          ak: _,
          callback: f,
          coords: d.map(
            (T) => `${T.longitude},${T.latitude}`
          ).join(";"),
          from: 3,
          to: 5
        };
        p.src = wS + "?" + Object.entries(E).map(([T, S]) => T + "=" + S).join("&"), document.head.appendChild(p);
      });
    }
  });
}
class AS extends rl {
  constructor(n) {
    super(n);
    Ie(this, "_wrapper");
    Ie(this, "map");
    Ie(this, "_panStartHandler");
    Ie(this, "_panHandler");
    Ie(this, "_centerReady");
    const r = !!(window.MSInputMethodContext && document.DOCUMENT_NODE);
    this._wrapper = n.wrapper, this.map = new BMap.Map(this._wrapper, {
      enableMapClick: n.controlEnabled,
      // A side effect of the negative pin longitude glitch is that pins don't render at higher zoom levels.
      // For IE, 15 and above is broken. For other browsers, 19 and above.
      maxZoom: r ? 14 : 18,
      ...n.providerOptions
    }), n.controlEnabled ? (this.map.enableScrollWheelZoom(), this.map.addControl(
      new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_ZOOM
      })
    )) : (this.map.disableDragging(), this.map.disableDoubleClickZoom(), this.map.disablePinchToZoom()), this._panStartHandler = () => null, this._panHandler = () => null, this.map.addEventListener("movestart", () => this._panStartHandler()), this.map.addEventListener("moveend", () => this._panHandler()), this.map.addEventListener("zoomstart", () => this._panStartHandler()), this.map.addEventListener("zoomend", () => {
      this._wrapper && (this._wrapper.dataset.baiduZoom = this.map.getZoom()), this._panHandler();
    }), this._centerReady = Promise.resolve();
  }
  /**
   * {@inheritDoc ProviderMap.getCenter}
   */
  getCenter() {
    return new fn(this.map.getCenter());
  }
  /**
   * {@inheritDoc ProviderMap.getZoom}
   */
  getZoom() {
    return this.map.getZoom() - cd;
  }
  /**
   * {@inheritDoc ProviderMap.setCenter}
   */
  setCenter(n, r) {
    this._centerReady = a_([n]).then(([l]) => {
      const d = new BMap.Point(
        l.longitude,
        l.latitude
      );
      this.map.panTo(d, { noAnimation: !r });
    });
  }
  /**
   * {@inheritDoc ProviderMap.setZoom}
   */
  setZoom(n, r) {
    this._centerReady.then(() => {
      this.map.setViewport(
        {
          center: this.map.getCenter(),
          zoom: Math.floor(n + cd)
          // Baidu only allows integer zoom
        },
        { enableAnimation: r }
      );
    });
  }
}
class MS extends il {
  constructor(n) {
    super(n);
    Ie(this, "_wrapper");
    Ie(this, "_zIndex");
    Ie(this, "_wrapperClass");
    Ie(this, "_originalWrapperClass");
    Ie(this, "_element");
    Ie(this, "_coordinateReady");
    Ie(this, "_negativeLngFix");
    Ie(this, "pin");
    this._wrapper = null, this._zIndex = 0, this._wrapperClass = "", this._originalWrapperClass = "", this._element = this._pinEl, this._coordinateReady = Promise.resolve(), this._negativeLngFix = !1;
    class r extends BMap.Marker {
      constructor(p, _) {
        super(p);
        Ie(this, "pin");
        this.pin = _;
      }
      initialize(p) {
        return this.pin._wrapper = super.initialize(p), this.pin._wrapper && (this.pin._wrapper.style.zIndex = this.pin._zIndex.toString(), this.pin._originalWrapperClass = this.pin._wrapper.getAttribute("class") ?? "", this.pin._wrapper.setAttribute("class", this.pin._getClass()), this.pin._wrapper.appendChild(this.pin._element), this.pin.addListeners()), this.pin._wrapper;
      }
      draw() {
        if (this.pin._wrapper) {
          const p = this.pin._wrapper.style.zIndex;
          super.draw(), this.pin._wrapper.style.height = "", this.pin._wrapper.style.width = "", this.pin._wrapper.style.pointerEvents = "none", this.pin._wrapper.style.zIndex = p;
        } else
          super.draw();
      }
    }
    this.pin = new r(new BMap.Point(0, 0), this);
    const l = new BMap.Icon(
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      { height: 0, width: 0 }
    );
    this.pin.setIcon(l), this.pin.setShadow(l);
  }
  /**
   * {@inheritDoc HTMLProviderPin.addListeners}
   */
  addListeners() {
    super.addListeners(), this._wrapper && this._wrapper.addEventListener("touchend", () => this._clickHandler());
  }
  /**
   * {@inheritDoc HTMLProviderPin.setCoordinate}
   */
  setCoordinate(n) {
    this._coordinateReady = a_([n]).then(
      ([r]) => {
        this._negativeLngFix = r.longitude < 0, this.pin.setPosition(
          new BMap.Point(
            r.longitude + (this._negativeLngFix ? 180 : 0),
            r.latitude
          )
        ), this._wrapper && this._wrapper.classList[this._negativeLngFix ? "add" : "remove"](
          ud
        );
      }
    );
  }
  /**
   * {@inheritDoc HTMLProviderPin.setMap}
   */
  setMap(n, r) {
    this._coordinateReady.then(() => {
      r && r.getProviderMap().map.removeOverlay(this.pin), n && n.getProviderMap().map.addOverlay(this.pin);
    });
  }
  /**
   * {@inheritDoc HTMLProviderPin.setProperties}
   */
  setProperties(n) {
    super.setProperties(n), this._wrapperClass = n.getClass(), this._element = n.getElement() || this._pinEl, this._zIndex = n.getZIndex(), this._wrapper && this._wrapper.setAttribute("class", this._getClass());
  }
  /**
   * Get the class attribute value for the pin element
   */
  _getClass() {
    return `${this._originalWrapperClass} ${this._negativeLngFix ? ud : ""} ${this._wrapperClass}`;
  }
}
const RS = "https://api.map.baidu.com/getscript";
function bS(e, t, n, { params: r = {}, version: l = "3.0" } = {}) {
  window.BMAP_PROTOCOL = "https", window.BMap_loadScriptTime = (/* @__PURE__ */ new Date()).getTime();
  const d = n, f = {
    ak: d,
    v: l,
    ...r
  };
  l_(d);
  const p = document.createElement("script");
  p.src = RS + "?" + Object.entries(f).map(([T, S]) => T + "=" + S).join("&"), p.onload = () => e(), document.head.appendChild(p);
  let _ = "";
  for (let T = xS; T <= vS; T++) {
    const S = 2 ** (T - cd + 7);
    _ += `[data-baidu-zoom="${T}"] .${ud}{transform:translateX(-${S}px);}`;
  }
  const E = document.createElement("style");
  E.appendChild(document.createTextNode(_)), document.head.appendChild(E);
}
const Dw = new uo().withLoadFunction(bS).withMapClass(AS).withPinClass(MS).withProviderName("Baidu").build();
let c_;
function LS() {
  class e extends Microsoft.Maps.CustomOverlay {
    constructor() {
      super({ beneathLabels: !1 });
      Ie(this, "_container");
      Ie(this, "_pins");
      Ie(this, "_viewChangeEventHandler");
      // @ts-expect-error Property '_map' in type 'PinOverlayClass' is not assignable to the same property in base type 'CustomOverlay'.
      Ie(this, "_map");
      this._container = document.createElement("div"), this._pins = /* @__PURE__ */ new Set(), this._viewChangeEventHandler = null, this._container.style.position = "absolute", this._container.style.left = "0", this._container.style.top = "0";
    }
    addPin(r) {
      this._pins.add(r), r._wrapper && (r._wrapper.style.position = "absolute", this._container.appendChild(r._wrapper)), this._map && this.updatePinPosition(r);
    }
    onAdd() {
      this._map = this.getMap(), this.setHtmlElement(this._container);
    }
    onLoad() {
      this._viewChangeEventHandler = Microsoft.Maps.Events.addHandler(
        this._map,
        "viewchange",
        () => this.updatePinPositions()
      ), this.updatePinPositions();
    }
    onRemove() {
      this._viewChangeEventHandler && Microsoft.Maps.Events.removeHandler(this._viewChangeEventHandler), this._map = null;
    }
    removePin(r) {
      this._pins.delete(r), r._wrapper && this._container.removeChild(r._wrapper);
    }
    updatePinPosition(r) {
      if (!this._map)
        return;
      const l = this._map.tryLocationToPixel(
        r._location,
        Microsoft.Maps.PixelReference.control
      );
      r._wrapper && l instanceof Microsoft.Maps.Point && (r._wrapper.style.left = l.x + "px", r._wrapper.style.top = l.y + "px");
    }
    updatePinPositions() {
      this._pins.forEach((r) => this.updatePinPosition(r));
    }
  }
  c_ = e;
}
class IS extends rl {
  constructor(n) {
    super(n);
    Ie(this, "wrapper");
    Ie(this, "map");
    Ie(this, "pinOverlay");
    this.wrapper = n.wrapper, this.wrapper && (this.map = new Microsoft.Maps.Map(this.wrapper, {
      disablePanning: !n.controlEnabled,
      disableZooming: !n.controlEnabled,
      showLocateMeButton: !1,
      showMapTypeSelector: !1,
      showScalebar: !1,
      showTrafficButton: !1,
      ...n.providerOptions
    }), this.pinOverlay = new c_(this.map), this.map.layers.insert(this.pinOverlay), Microsoft.Maps.Events.addHandler(
      this.map,
      "viewchangestart",
      () => this._panStartHandler()
    ), Microsoft.Maps.Events.addHandler(
      this.map,
      "viewchangeend",
      () => this._panHandler()
    ));
  }
  /**
   * {@inheritDoc ProviderMap.getCenter}
   */
  getCenter() {
    var n;
    return new fn(((n = this.map) == null ? void 0 : n.getCenter()) ?? { lat: 0, lng: 0 });
  }
  /**
   * {@inheritDoc ProviderMap.getZoom}
   */
  getZoom() {
    var n;
    return ((n = this.map) == null ? void 0 : n.getZoom()) ?? 0;
  }
  /**
   * {@inheritDoc ProviderMap.setCenter}
   */
  setCenter(n, r) {
    var d;
    const l = new Microsoft.Maps.Location(
      n.latitude,
      n.longitude
    );
    (d = this.map) == null || d.setView({ center: l }), this.pinOverlay.updatePinPositions();
  }
  /**
   * {@inheritDoc ProviderMap.setZoom}
   */
  setZoom(n, r) {
    var l;
    (l = this.map) == null || l.setView({ zoom: Math.floor(n) }), this.pinOverlay.updatePinPositions();
  }
}
class u_ extends il {
  constructor(n) {
    super(n);
    Ie(this, "_location");
    Ie(this, "_map");
    this._map = null, this._location = new Microsoft.Maps.Location(0, 0);
  }
  /**
   * Bing pins need global callbacks to complete initialization.
   * This function provides a unique ID to include in the name of the callback.
   * @returns An ID for the pin unique across all instances of {@link BingPin}
   */
  static getId() {
    return this._pinId = (this._pinId || 0) + 1, this._pinId;
  }
  /**
   * {@inheritDoc HTMLProviderPin.setCoordinate}
   */
  setCoordinate(n) {
    this._location = new Microsoft.Maps.Location(
      n.latitude,
      n.longitude
    ), this._map && this._map.getProviderMap().pinOverlay.updatePinPosition(
      this
    );
  }
  /**
   * {@inheritDoc HTMLProviderPin.setMap}
   */
  setMap(n, r) {
    r && r.getProviderMap().pinOverlay.removePin(this), n && n.getProviderMap().pinOverlay.addPin(this), this._map = n;
  }
}
Ie(u_, "_pinId");
const rp = "BingMapsCallback_593d7d33", kS = "https://www.bing.com/api/maps/mapcontrol";
function PS(e, t, n, { params: r = {} } = {}) {
  window[rp] = () => {
    LS(), e();
  };
  const l = {
    callback: rp,
    key: n,
    ...r
  };
  gp(
    kS + "?" + Object.entries(l).map(([d, f]) => d + "=" + f).join("&")
  );
}
const Aw = new uo().withLoadFunction(PS).withMapClass(IS).withPinClass(u_).withProviderName("Bing").build();
class $S extends rl {
  constructor(n) {
    var r, l, d;
    super(n);
    Ie(this, "map");
    if (n.wrapper && (this.map = new mapboxgl.Map({
      container: n.wrapper,
      interactive: n.controlEnabled,
      style: "mapbox://styles/mapbox/streets-v9",
      ...n.providerOptions
    })), n.controlEnabled) {
      const f = new mapboxgl.NavigationControl({
        showCompass: !1
      });
      (r = this.map) == null || r.addControl(f);
    }
    (l = this.map) == null || l.on("movestart", () => this._panStartHandler()), (d = this.map) == null || d.on("moveend", () => this._panHandler());
  }
  /**
   * {@inheritDoc ProviderMap.getCenter}
   */
  getCenter() {
    var n;
    return new fn(((n = this.map) == null ? void 0 : n.getCenter()) ?? { lat: 0, lng: 0 });
  }
  /**
   * {@inheritDoc ProviderMap.getZoom}
   */
  getZoom() {
    var n;
    return (((n = this.map) == null ? void 0 : n.getZoom()) ?? 0) + 1;
  }
  /**
   * {@inheritDoc ProviderMap.setCenter}
   */
  setCenter(n, r) {
    const l = new mapboxgl.LngLat(
      n.longitude,
      n.latitude
    );
    this.map && this.map[r ? "panTo" : "setCenter"](l);
  }
  /**
   * {@inheritDoc ProviderMap.setZoom}
   */
  setZoom(n, r) {
    this.map && this.map[r ? "zoomTo" : "setZoom"](n - 1);
  }
  /**
   * {@inheritDoc ProviderMap.zetZoomCenter}
   */
  setZoomCenter(n, r, l) {
    const d = new mapboxgl.LngLat(
      r.longitude,
      r.latitude
    );
    this.map && this.map[l ? "easeTo" : "jumpTo"]({ center: d, zoom: n - 1 });
  }
}
class FS extends il {
  constructor(n) {
    super(n);
    Ie(this, "pin");
    this._wrapper && (this._wrapper.style.position = "relative", this.pin = new mapboxgl.Marker({
      anchor: "top-left",
      element: this._wrapper
    }));
  }
  /**
   * {@inheritDoc HTMLProviderPin.setCoordinate}
   */
  setCoordinate(n) {
    var r;
    (r = this.pin) == null || r.setLngLat(
      new mapboxgl.LngLat(n.longitude, n.latitude)
    );
  }
  /**
   * {@inheritDoc HTMLProviderPin.setMap}
   */
  setMap(n, r) {
    var l, d;
    if (n) {
      const f = n.getProviderMap().map;
      f && ((l = this.pin) == null || l.addTo(f));
    } else
      (d = this.pin) == null || d.remove();
  }
}
function BS(e, t, n, { version: r = "v1.13.0" } = {}) {
  const l = `https://api.mapbox.com/mapbox-gl-js/${r}/mapbox-gl`, d = document.createElement("link");
  d.rel = "stylesheet", d.href = l + ".css";
  const f = document.createElement("script");
  f.src = l + ".js", f.onload = () => {
    mapboxgl.accessToken = n, e();
  }, document.head.appendChild(d), document.head.appendChild(f);
}
const Mw = new uo().withLoadFunction(BS).withMapClass($S).withPinClass(FS).withProviderName("Mapbox").build();
var lo;
let d_ = (lo = class extends rl {
  constructor(n) {
    var r, l, d;
    super(n);
    Ie(this, "map");
    this._initMap(n), n.controlEnabled && ((r = this.map) == null || r.zoomControl.setPosition("topright")), (l = this.map) == null || l.on("movestart", () => this._panStartHandler()), (d = this.map) == null || d.on("moveend", () => this._panHandler());
  }
  /**
   * {@inheritDoc ProviderMap.getCenter}
   */
  getCenter() {
    var n;
    return new fn(((n = this.map) == null ? void 0 : n.getCenter()) ?? { lat: 0, lng: 0 });
  }
  /**
   * {@inheritDoc ProviderMap.getZoom}
   */
  getZoom() {
    var n;
    return ((n = this.map) == null ? void 0 : n.getZoom()) ?? 0;
  }
  /**
   * {@inheritDoc ProviderMap.setCenter}
   */
  setCenter(n, r) {
    var d;
    const l = new L.LatLng(n.latitude, n.longitude);
    (d = this.map) == null || d.panTo(l, { animate: r });
  }
  /**
   * {@inheritDoc ProviderMap.setZoom}
   */
  setZoom(n, r) {
    var l;
    (l = this.map) == null || l.setZoom(n, { animate: r });
  }
  /**
   * {@inheritDoc ProviderMap.setZoomCenter}
   */
  setZoomCenter(n, r, l) {
    var f;
    const d = new L.LatLng(r.latitude, r.longitude);
    (f = this.map) == null || f.setView(d, n, { animate: l });
  }
  _initMap(n) {
    n.wrapper && (this.map = new L.Map(n.wrapper, {
      boxZoom: n.controlEnabled,
      doubleClickZoom: n.controlEnabled,
      dragging: n.controlEnabled,
      zoom: 0,
      zoomControl: n.controlEnabled,
      zoomSnap: 0,
      ...n.providerOptions
    }));
    const r = n.providerOptions, l = r.tileLayerSrc || "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}", d = r.tileLayerOptions || {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: "mapbox/streets-v11"
    };
    d.accessToken = lo.apiKey, this.map && L.tileLayer(l, d).addTo(this.map);
  }
}, Ie(lo, "apiKey"), lo), HS = class extends hd {
  constructor(n) {
    super(n);
    Ie(this, "pin");
    this.pin = new L.Marker(new L.LatLng(0, 0)), this.pin.on("click", () => this._clickHandler()), this.pin.on("mouseover", () => this._hoverHandler(!0)), this.pin.on("mouseout", () => this._hoverHandler(!1));
  }
  /**
   * {@inheritDoc ProviderPin.setCoordinate}
   */
  setCoordinate(n) {
    const r = new L.LatLng(n.latitude, n.longitude);
    this.pin.setLatLng(r);
  }
  /**
   * {@inheritDoc ProviderPin.setMap}
   */
  setMap(n, r) {
    if (n) {
      const l = n.getProviderMap().map;
      l && this.pin.addTo(l);
    } else
      this.pin.remove();
  }
  /**
   * {@inheritDoc ProviderPin.setProperties}
   */
  setProperties(n) {
    const r = n.getWidth(), l = n.getHeight(), d = n.getAnchorX(), f = n.getAnchorY();
    this.pin.setIcon(
      new L.Icon({
        iconUrl: this._icons[n.getIcon()],
        iconSize: [r, l],
        iconAnchor: [d * r, f * l],
        className: n.getClass()
      })
    ), this.pin.setZIndexOffset(n.getZIndex());
  }
};
function WS(e, t, n, { version: r = "1.7.1" } = {}) {
  const l = `https://unpkg.com/leaflet@${r}/dist/leaflet`;
  d_.apiKey = n;
  const d = document.createElement("link");
  d.rel = "stylesheet", d.href = l + ".css";
  const f = document.createElement("script");
  f.src = l + ".js", f.onload = () => e(), document.head.appendChild(d), document.head.appendChild(f);
}
const f_ = new uo().withLoadFunction(WS).withMapClass(d_).withPinClass(HS).withProviderName("Leaflet").build(), KS = f_.getMapClass(), zS = f_.getPinClass();
class US extends KS {
  constructor() {
    super(...arguments);
    Ie(this, "map");
  }
  /**
   * {@inheritDoc LeafletMap._initMap}
   */
  _initMap(n) {
    this.map = L.mapquest.map(n.wrapper, {
      boxZoom: n.controlEnabled,
      center: new L.LatLng(0, 0),
      doubleClickZoom: n.controlEnabled,
      dragging: n.controlEnabled,
      layers: L.mapquest.tileLayer("map"),
      zoom: 0,
      zoomControl: n.controlEnabled,
      zoomSnap: 0,
      ...n.providerOptions
    });
  }
}
class GS extends zS {
}
function YS(e, t, n, { version: r = "v1.3.2" } = {}) {
  const l = `https://api.mqcdn.com/sdk/mapquest-js/${r}/mapquest-maps`, d = document.createElement("link");
  d.rel = "stylesheet", d.href = l + ".css";
  const f = document.createElement("script");
  f.src = l + ".js", f.onload = () => {
    L.mapquest.key = n, e();
  }, document.head.appendChild(d), document.head.appendChild(f);
}
const bw = new uo().withLoadFunction(YS).withMapClass(US).withPinClass(GS).withProviderName("MapQuest").build();
export {
  Sw as $,
  JS as A,
  ew as B,
  tw as C,
  nw as D,
  XS as E,
  ju as F,
  dp as G,
  QS as H,
  rw as I,
  io as J,
  fN as K,
  sy as L,
  hf as M,
  wN as N,
  sw as O,
  Np as P,
  lw as Q,
  ow as R,
  aw as S,
  cw as T,
  Nw as U,
  Cw as V,
  Ew as W,
  Gt as X,
  Tw as Y,
  $d as Z,
  vw as _,
  yw as a,
  ww as a0,
  Ow as a1,
  TS as a2,
  i_ as a3,
  oS as a4,
  pS as a5,
  o_ as a6,
  cS as a7,
  uS as a8,
  Fd as a9,
  xw as aa,
  NS as ab,
  yS as ac,
  Dw as ad,
  Aw as ae,
  xN as af,
  Mw as ag,
  f_ as ah,
  bw as ai,
  fn as aj,
  op as b,
  el as c,
  mw as d,
  hc as e,
  uw as f,
  la as g,
  Ng as h,
  fw as i,
  nt as j,
  dw as k,
  pw as l,
  _w as m,
  da as n,
  gw as o,
  Jl as p,
  hw as q,
  EE as r,
  Td as s,
  _E as t,
  lE as u,
  tm as v,
  ZS as w,
  Yy as x,
  up as y,
  ua as z
};
